
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("59TQn", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                (function(global1) {
                    (function() {
                        /*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $jscomp = $jscomp || {};
                        $jscomp.scope = {};
                        $jscomp.createTemplateTagFirstArg = function(a) {
                            return a.raw = a;
                        };
                        $jscomp.createTemplateTagFirstArgWithRaw = function(a, b) {
                            a.raw = b;
                            return a;
                        };
                        $jscomp.arrayIteratorImpl = function(a) {
                            var b = 0;
                            return function() {
                                return b < a.length ? {
                                    done: !1,
                                    value: a[b++]
                                } : {
                                    done: !0
                                };
                            };
                        };
                        $jscomp.arrayIterator = function(a) {
                            return {
                                next: $jscomp.arrayIteratorImpl(a)
                            };
                        };
                        $jscomp.makeIterator = function(a) {
                            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
                            return b ? b.call(a) : $jscomp.arrayIterator(a);
                        };
                        $jscomp.arrayFromIterator = function(a) {
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            return c;
                        };
                        $jscomp.arrayFromIterable = function(a) {
                            return a instanceof Array ? a : $jscomp.arrayFromIterator($jscomp.makeIterator(a));
                        };
                        $jscomp.checkStringArgs = function(a, b, c) {
                            if (null == a) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
                            return a + "";
                        };
                        $jscomp.ASSUME_ES5 = !1;
                        $jscomp.ASSUME_NO_NATIVE_MAP = !1;
                        $jscomp.ASSUME_NO_NATIVE_SET = !1;
                        $jscomp.SIMPLE_FROUND_POLYFILL = !1;
                        $jscomp.ISOLATE_POLYFILLS = !1;
                        $jscomp.FORCE_POLYFILL_PROMISE = !1;
                        $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
                        $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
                            if (a == Array.prototype || a == Object.prototype) return a;
                            a[b] = c.value;
                            return a;
                        };
                        $jscomp.getGlobal = function(a) {
                            a = [
                                "object" == typeof globalThis && globalThis,
                                a,
                                "object" == typeof window && window,
                                "object" == typeof self && self,
                                "object" == typeof global1 && global1
                            ];
                            for(var b = 0; b < a.length; ++b){
                                var c = a[b];
                                if (c && c.Math == Math) return c;
                            }
                            throw Error("Cannot find global object");
                        };
                        $jscomp.global = $jscomp.getGlobal(this);
                        $jscomp.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
                        $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
                        $jscomp.polyfills = {};
                        $jscomp.propertyToPolyfillSymbol = {};
                        $jscomp.POLYFILL_PREFIX = "$jscp$";
                        var $jscomp$lookupPolyfilledValue = function(a, b) {
                            var c = $jscomp.propertyToPolyfillSymbol[b];
                            if (null == c) return a[b];
                            c = a[c];
                            return void 0 !== c ? c : a[b];
                        };
                        $jscomp.polyfill = function(a, b, c, d) {
                            b && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(a, b, c, d) : $jscomp.polyfillUnisolated(a, b, c, d));
                        };
                        $jscomp.polyfillUnisolated = function(a, b, c, d) {
                            c = $jscomp.global;
                            a = a.split(".");
                            for(d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) return;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && null != b && $jscomp.defineProperty(c, a, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            });
                        };
                        $jscomp.polyfillIsolated = function(a, b, c, d) {
                            var e = a.split(".");
                            a = 1 === e.length;
                            d = e[0];
                            d = !a && d in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
                            for(var f = 0; f < e.length - 1; f++){
                                var g = e[f];
                                if (!(g in d)) return;
                                d = d[g];
                            }
                            e = e[e.length - 1];
                            c = $jscomp.IS_SYMBOL_NATIVE && "es6" === c ? d[e] : null;
                            b = b(c);
                            null != b && (a ? $jscomp.defineProperty($jscomp.polyfills, e, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            }) : b !== c && ($jscomp.propertyToPolyfillSymbol[e] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(e) : $jscomp.POLYFILL_PREFIX + e, e = $jscomp.propertyToPolyfillSymbol[e], $jscomp.defineProperty(d, e, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            })));
                        };
                        $jscomp.polyfill("String.prototype.endsWith", function(a) {
                            return a ? a : function(b, c) {
                                var d = $jscomp.checkStringArgs(this, b, "endsWith");
                                b += "";
                                void 0 === c && (c = d.length);
                                c = Math.max(0, Math.min(c | 0, d.length));
                                for(var e = b.length; 0 < e && 0 < c;)if (d[--c] != b[--e]) return !1;
                                return 0 >= e;
                            };
                        }, "es6", "es3");
                        $jscomp.findInternal = function(a, b, c) {
                            a instanceof String && (a = String(a));
                            for(var d = a.length, e = 0; e < d; e++){
                                var f = a[e];
                                if (b.call(c, f, e, a)) return {
                                    i: e,
                                    v: f
                                };
                            }
                            return {
                                i: -1,
                                v: void 0
                            };
                        };
                        $jscomp.polyfill("Array.prototype.find", function(a) {
                            return a ? a : function(b, c) {
                                return $jscomp.findInternal(this, b, c).v;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("String.prototype.startsWith", function(a) {
                            return a ? a : function(b, c) {
                                var d = $jscomp.checkStringArgs(this, b, "startsWith");
                                b += "";
                                var e = d.length, f = b.length;
                                c = Math.max(0, Math.min(c | 0, d.length));
                                for(var g = 0; g < f && c < e;)if (d[c++] != b[g++]) return !1;
                                return g >= f;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("String.prototype.repeat", function(a) {
                            return a ? a : function(b) {
                                var c = $jscomp.checkStringArgs(this, null, "repeat");
                                if (0 > b || 1342177279 < b) throw new RangeError("Invalid count value");
                                b |= 0;
                                for(var d = ""; b;)if (b & 1 && (d += c), b >>>= 1) c += c;
                                return d;
                            };
                        }, "es6", "es3");
                        $jscomp.initSymbol = function() {};
                        $jscomp.polyfill("Symbol", function(a) {
                            if (a) return a;
                            var b = function(e, f) {
                                this.$jscomp$symbol$id_ = e;
                                $jscomp.defineProperty(this, "description", {
                                    configurable: !0,
                                    writable: !0,
                                    value: f
                                });
                            };
                            b.prototype.toString = function() {
                                return this.$jscomp$symbol$id_;
                            };
                            var c = 0, d = function(e) {
                                if (this instanceof d) throw new TypeError("Symbol is not a constructor");
                                return new b("jscomp_symbol_" + (e || "") + "_" + c++, e);
                            };
                            return d;
                        }, "es6", "es3");
                        $jscomp.polyfill("Symbol.iterator", function(a) {
                            if (a) return a;
                            a = Symbol("Symbol.iterator");
                            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                                var d = $jscomp.global[b[c]];
                                "function" === typeof d && "function" != typeof d.prototype[a] && $jscomp.defineProperty(d.prototype, a, {
                                    configurable: !0,
                                    writable: !0,
                                    value: function() {
                                        return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
                                    }
                                });
                            }
                            return a;
                        }, "es6", "es3");
                        $jscomp.iteratorPrototype = function(a) {
                            a = {
                                next: a
                            };
                            a[Symbol.iterator] = function() {
                                return this;
                            };
                            return a;
                        };
                        $jscomp.iteratorFromArray = function(a, b) {
                            a instanceof String && (a += "");
                            var c = 0, d = !1, e = {
                                next: function() {
                                    if (!d && c < a.length) {
                                        var f = c++;
                                        return {
                                            value: b(f, a[f]),
                                            done: !1
                                        };
                                    }
                                    d = !0;
                                    return {
                                        done: !0,
                                        value: void 0
                                    };
                                }
                            };
                            e[Symbol.iterator] = function() {
                                return e;
                            };
                            return e;
                        };
                        $jscomp.polyfill("Array.prototype.keys", function(a) {
                            return a ? a : function() {
                                return $jscomp.iteratorFromArray(this, function(b) {
                                    return b;
                                });
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("Object.is", function(a) {
                            return a ? a : function(b, c) {
                                return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("Array.prototype.includes", function(a) {
                            return a ? a : function(b, c) {
                                var d = this;
                                d instanceof String && (d = String(d));
                                var e = d.length;
                                c = c || 0;
                                for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                    var f = d[c];
                                    if (f === b || Object.is(f, b)) return !0;
                                }
                                return !1;
                            };
                        }, "es7", "es3");
                        $jscomp.polyfill("String.prototype.includes", function(a) {
                            return a ? a : function(b, c) {
                                return -1 !== $jscomp.checkStringArgs(this, b, "includes").indexOf(b, c || 0);
                            };
                        }, "es6", "es3");
                        var COMPILED = !0, goog = goog || {};
                        goog.global = this || self;
                        goog.exportPath_ = function(a, b, c, d) {
                            a = a.split(".");
                            d = d || goog.global;
                            a[0] in d || "undefined" == typeof d.execScript || d.execScript("var " + a[0]);
                            for(var e; a.length && (e = a.shift());)if (a.length || void 0 === b) d = d[e] && d[e] !== Object.prototype[e] ? d[e] : d[e] = {};
                            else if (!c && goog.isObject(b) && goog.isObject(d[e])) for(var f in b)b.hasOwnProperty(f) && (d[e][f] = b[f]);
                            else d[e] = b;
                        };
                        goog.define = function(a, b) {
                            if (!COMPILED) {
                                var c = goog.global.CLOSURE_UNCOMPILED_DEFINES, d = goog.global.CLOSURE_DEFINES;
                                c && void 0 === c.nodeType && Object.prototype.hasOwnProperty.call(c, a) ? b = c[a] : d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a) && (b = d[a]);
                            }
                            return b;
                        };
                        goog.FEATURESET_YEAR = 2012;
                        goog.DEBUG = !0;
                        goog.LOCALE = "en";
                        goog.TRUSTED_SITE = !0;
                        goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
                        goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
                        goog.provide = function(a) {
                            if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
                            if (!COMPILED && goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
                            goog.constructNamespace_(a);
                        };
                        goog.constructNamespace_ = function(a, b, c) {
                            if (!COMPILED) {
                                delete goog.implicitNamespaces_[a];
                                for(var d = a; (d = d.substring(0, d.lastIndexOf("."))) && !goog.getObjectByName(d);)goog.implicitNamespaces_[d] = !0;
                            }
                            goog.exportPath_(a, b, c);
                        };
                        goog.getScriptNonce = function(a) {
                            if (a && a != goog.global) return goog.getScriptNonce_(a.document);
                            null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
                            return goog.cspNonce_;
                        };
                        goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
                        goog.cspNonce_ = null;
                        goog.getScriptNonce_ = function(a) {
                            return (a = a.querySelector && a.querySelector("script[nonce]")) && (a = a.nonce || a.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a) ? a : "";
                        };
                        goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
                        goog.module = function(a) {
                            if ("string" !== typeof a || !a || -1 == a.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
                            if (!goog.isInGoogModuleLoader_()) throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
                            if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
                            goog.moduleLoaderState_.moduleName = a;
                            if (!COMPILED) {
                                if (goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
                                delete goog.implicitNamespaces_[a];
                            }
                        };
                        goog.module.get = function(a) {
                            return goog.module.getInternal_(a);
                        };
                        goog.module.getInternal_ = function(a) {
                            if (!COMPILED) {
                                if (a in goog.loadedModules_) return goog.loadedModules_[a].exports;
                                if (!goog.implicitNamespaces_[a]) return a = goog.getObjectByName(a), null != a ? a : null;
                            }
                            return null;
                        };
                        goog.ModuleType = {
                            ES6: "es6",
                            GOOG: "goog"
                        };
                        goog.moduleLoaderState_ = null;
                        goog.isInModuleLoader_ = function() {
                            return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
                        };
                        goog.isInGoogModuleLoader_ = function() {
                            return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
                        };
                        goog.isInEs6ModuleLoader_ = function() {
                            if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
                            var a = goog.global.$jscomp;
                            return a ? "function" != typeof a.getCurrentModulePath ? !1 : !!a.getCurrentModulePath() : !1;
                        };
                        goog.module.declareLegacyNamespace = function() {
                            if (!COMPILED && !goog.isInGoogModuleLoader_()) throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
                            if (!COMPILED && !goog.moduleLoaderState_.moduleName) throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
                            goog.moduleLoaderState_.declareLegacyNamespace = !0;
                        };
                        goog.declareModuleId = function(a) {
                            if (!COMPILED) {
                                if (!goog.isInEs6ModuleLoader_()) throw Error("goog.declareModuleId may only be called from within an ES6 module");
                                if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) throw Error("goog.declareModuleId may only be called once per module.");
                                if (a in goog.loadedModules_) throw Error('Module with namespace "' + a + '" already exists.');
                            }
                            if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = a;
                            else {
                                var b = goog.global.$jscomp;
                                if (!b || "function" != typeof b.getCurrentModulePath) throw Error('Module with namespace "' + a + '" has been loaded incorrectly.');
                                b = b.require(b.getCurrentModulePath());
                                goog.loadedModules_[a] = {
                                    exports: b,
                                    type: goog.ModuleType.ES6,
                                    moduleId: a
                                };
                            }
                        };
                        goog.setTestOnly = function(a) {
                            if (goog.DISALLOW_TEST_ONLY_CODE) throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
                        };
                        goog.forwardDeclare = function(a) {};
                        COMPILED || (goog.isProvided_ = function(a) {
                            return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && null != goog.getObjectByName(a);
                        }, goog.implicitNamespaces_ = {
                            "goog.module": !0
                        });
                        goog.getObjectByName = function(a, b) {
                            a = a.split(".");
                            b = b || goog.global;
                            for(var c = 0; c < a.length; c++)if (b = b[a[c]], null == b) return null;
                            return b;
                        };
                        goog.addDependency = function(a, b, c, d) {
                            !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a, b, c, d);
                        };
                        goog.ENABLE_DEBUG_LOADER = !0;
                        goog.logToConsole_ = function(a) {
                            goog.global.console && goog.global.console.error(a);
                        };
                        goog.require = function(a) {
                            if (!COMPILED) {
                                goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a);
                                if (goog.isProvided_(a)) {
                                    if (goog.isInModuleLoader_()) return goog.module.getInternal_(a);
                                } else if (goog.ENABLE_DEBUG_LOADER) {
                                    var b = goog.moduleLoaderState_;
                                    goog.moduleLoaderState_ = null;
                                    try {
                                        goog.debugLoader_.load_(a);
                                    } finally{
                                        goog.moduleLoaderState_ = b;
                                    }
                                }
                                return null;
                            }
                        };
                        goog.requireType = function(a) {
                            return {};
                        };
                        goog.basePath = "";
                        goog.nullFunction = function() {};
                        goog.abstractMethod = function() {
                            throw Error("unimplemented abstract method");
                        };
                        goog.addSingletonGetter = function(a) {
                            a.instance_ = void 0;
                            a.getInstance = function() {
                                if (a.instance_) return a.instance_;
                                goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
                                return a.instance_ = new a;
                            };
                        };
                        goog.instantiatedSingletons_ = [];
                        goog.LOAD_MODULE_USING_EVAL = !0;
                        goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
                        goog.loadedModules_ = {};
                        goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
                        goog.TRANSPILE = "detect";
                        goog.ASSUME_ES_MODULES_TRANSPILED = !1;
                        goog.TRANSPILE_TO_LANGUAGE = "";
                        goog.TRANSPILER = "transpile.js";
                        goog.hasBadLetScoping = null;
                        goog.useSafari10Workaround = function() {
                            if (null == goog.hasBadLetScoping) {
                                try {
                                    var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
                                } catch (b) {
                                    a = !1;
                                }
                                goog.hasBadLetScoping = a;
                            }
                            return goog.hasBadLetScoping;
                        };
                        goog.workaroundSafari10EvalBug = function(a) {
                            return "(function(){" + a + "\n;})();\n";
                        };
                        goog.loadModule = function(a) {
                            var b = goog.moduleLoaderState_;
                            try {
                                goog.moduleLoaderState_ = {
                                    moduleName: "",
                                    declareLegacyNamespace: !1,
                                    type: goog.ModuleType.GOOG
                                };
                                var c = {}, d = c;
                                if ("function" === typeof a) d = a.call(void 0, d);
                                else if ("string" === typeof a) goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), d = goog.loadModuleFromSource_.call(void 0, d, a);
                                else throw Error("Invalid module definition");
                                var e = goog.moduleLoaderState_.moduleName;
                                if ("string" === typeof e && e) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(e, d, c !== d) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof d && null != d && Object.seal(d), goog.loadedModules_[e] = {
                                    exports: d,
                                    type: goog.ModuleType.GOOG,
                                    moduleId: goog.moduleLoaderState_.moduleName
                                };
                                else throw Error('Invalid module name "' + e + '"');
                            } finally{
                                goog.moduleLoaderState_ = b;
                            }
                        };
                        goog.loadModuleFromSource_ = function(a, b) {
                            eval(b);
                            return a;
                        };
                        goog.normalizePath_ = function(a) {
                            a = a.split("/");
                            for(var b = 0; b < a.length;)"." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
                            return a.join("/");
                        };
                        goog.loadFileSync_ = function(a) {
                            if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
                            try {
                                var b = new goog.global.XMLHttpRequest;
                                b.open("get", a, !1);
                                b.send();
                                return 0 == b.status || 200 == b.status ? b.responseText : null;
                            } catch (c) {
                                return null;
                            }
                        };
                        goog.transpile_ = function(a, b, c) {
                            var d = goog.global.$jscomp;
                            d || (goog.global.$jscomp = d = {});
                            var e = d.transpile;
                            if (!e) {
                                var f = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(f);
                                if (g) {
                                    (function() {
                                        (0, eval)(g + "\n//# sourceURL=" + f);
                                    }).call(goog.global);
                                    if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
                                    goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
                                    d = goog.global.$jscomp;
                                    e = d.transpile;
                                }
                            }
                            e || (e = d.transpile = function(h, k) {
                                goog.logToConsole_(k + " requires transpilation but no transpiler was found.");
                                return h;
                            });
                            return e(a, b, c);
                        };
                        goog.typeOf = function(a) {
                            var b = typeof a;
                            return "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
                        };
                        goog.isArrayLike = function(a) {
                            var b = goog.typeOf(a);
                            return "array" == b || "object" == b && "number" == typeof a.length;
                        };
                        goog.isDateLike = function(a) {
                            return goog.isObject(a) && "function" == typeof a.getFullYear;
                        };
                        goog.isObject = function(a) {
                            var b = typeof a;
                            return "object" == b && null != a || "function" == b;
                        };
                        goog.getUid = function(a) {
                            return Object.prototype.hasOwnProperty.call(a, goog.UID_PROPERTY_) && a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
                        };
                        goog.hasUid = function(a) {
                            return !!a[goog.UID_PROPERTY_];
                        };
                        goog.removeUid = function(a) {
                            null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
                            try {
                                delete a[goog.UID_PROPERTY_];
                            } catch (b) {}
                        };
                        goog.UID_PROPERTY_ = "closure_uid_" + (1E9 * Math.random() >>> 0);
                        goog.uidCounter_ = 0;
                        goog.cloneObject = function(a) {
                            var b = goog.typeOf(a);
                            if ("object" == b || "array" == b) {
                                if ("function" === typeof a.clone) return a.clone();
                                b = "array" == b ? [] : {};
                                for(var c in a)b[c] = goog.cloneObject(a[c]);
                                return b;
                            }
                            return a;
                        };
                        goog.bindNative_ = function(a, b, c) {
                            return a.call.apply(a.bind, arguments);
                        };
                        goog.bindJs_ = function(a, b, c) {
                            if (!a) throw Error();
                            if (2 < arguments.length) {
                                var d = Array.prototype.slice.call(arguments, 2);
                                return function() {
                                    var e = Array.prototype.slice.call(arguments);
                                    Array.prototype.unshift.apply(e, d);
                                    return a.apply(b, e);
                                };
                            }
                            return function() {
                                return a.apply(b, arguments);
                            };
                        };
                        goog.bind = function(a, b, c) {
                            Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
                            return goog.bind.apply(null, arguments);
                        };
                        goog.partial = function(a, b) {
                            var c = Array.prototype.slice.call(arguments, 1);
                            return function() {
                                var d = c.slice();
                                d.push.apply(d, arguments);
                                return a.apply(this, d);
                            };
                        };
                        goog.mixin = function(a, b) {
                            for(var c in b)a[c] = b[c];
                        };
                        goog.now = function() {
                            return Date.now();
                        };
                        goog.globalEval = function(a) {
                            (0, eval)(a);
                        };
                        goog.getCssName = function(a, b) {
                            if ("." == String(a).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
                            var c = function(e) {
                                return goog.cssNameMapping_[e] || e;
                            }, d = function(e) {
                                e = e.split("-");
                                for(var f = [], g = 0; g < e.length; g++)f.push(c(e[g]));
                                return f.join("-");
                            };
                            d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(e) {
                                return e;
                            };
                            a = b ? a + "-" + d(b) : d(a);
                            return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a) : a;
                        };
                        goog.setCssNameMapping = function(a, b) {
                            goog.cssNameMapping_ = a;
                            goog.cssNameMappingStyle_ = b;
                        };
                        !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
                        goog.getMsg = function(a, b, c) {
                            c && c.html && (a = a.replace(/</g, "&lt;"));
                            c && c.unescapeHtmlEntities && (a = a.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&"));
                            b && (a = a.replace(/\{\$([^}]+)}/g, function(d, e) {
                                return null != b && e in b ? b[e] : d;
                            }));
                            return a;
                        };
                        goog.getMsgWithFallback = function(a, b) {
                            return a;
                        };
                        goog.exportSymbol = function(a, b, c) {
                            goog.exportPath_(a, b, !0, c);
                        };
                        goog.exportProperty = function(a, b, c) {
                            a[b] = c;
                        };
                        goog.inherits = function(a, b) {
                            function c() {}
                            c.prototype = b.prototype;
                            a.superClass_ = b.prototype;
                            a.prototype = new c;
                            a.prototype.constructor = a;
                            a.base = function(d, e, f) {
                                for(var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++)g[h - 2] = arguments[h];
                                return b.prototype[e].apply(d, g);
                            };
                        };
                        goog.scope = function(a) {
                            if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
                            a.call(goog.global);
                        };
                        COMPILED || (goog.global.COMPILED = COMPILED);
                        goog.defineClass = function(a, b) {
                            var c = b.constructor, d = b.statics;
                            c && c != Object.prototype.constructor || (c = function() {
                                throw Error("cannot instantiate an interface (no constructor defined).");
                            });
                            c = goog.defineClass.createSealingConstructor_(c, a);
                            a && goog.inherits(c, a);
                            delete b.constructor;
                            delete b.statics;
                            goog.defineClass.applyProperties_(c.prototype, b);
                            null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
                            return c;
                        };
                        goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
                        goog.defineClass.createSealingConstructor_ = function(a, b) {
                            return goog.defineClass.SEAL_CLASS_INSTANCES ? function() {
                                var c = a.apply(this, arguments) || this;
                                c[goog.UID_PROPERTY_] = c[goog.UID_PROPERTY_];
                                return c;
                            } : a;
                        };
                        goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
                        goog.defineClass.applyProperties_ = function(a, b) {
                            for(var c in b)Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
                            for(var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++)c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
                        };
                        !COMPILED && goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
                            var a = goog.global.document;
                            return null != a && "write" in a;
                        }, goog.isDocumentLoading_ = function() {
                            var a = goog.global.document;
                            return a.attachEvent ? "complete" != a.readyState : "loading" == a.readyState;
                        }, goog.findBasePath_ = function() {
                            if (void 0 != goog.global.CLOSURE_BASE_PATH && "string" === typeof goog.global.CLOSURE_BASE_PATH) goog.basePath = goog.global.CLOSURE_BASE_PATH;
                            else if (goog.inHtmlDocument_()) {
                                var a = goog.global.document, b = a.currentScript;
                                a = b ? [
                                    b
                                ] : a.getElementsByTagName("SCRIPT");
                                for(b = a.length - 1; 0 <= b; --b){
                                    var c = a[b].src, d = c.lastIndexOf("?");
                                    d = -1 == d ? c.length : d;
                                    if ("base.js" == c.substr(d - 7, 7)) {
                                        goog.basePath = c.substr(0, d - 7);
                                        break;
                                    }
                                }
                            }
                        }, goog.findBasePath_(), goog.Transpiler = function() {
                            this.requiresTranspilation_ = null;
                            this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
                        }, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
                            function a(g, h) {
                                e ? d[g] = !0 : h() ? (c = g, d[g] = !1) : e = d[g] = !0;
                            }
                            function b(g) {
                                try {
                                    return !!eval(g);
                                } catch (h) {
                                    return !1;
                                }
                            }
                            var c = "es3", d = {
                                es3: !1
                            }, e = !1, f = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
                            a("es5", function() {
                                return b("[1,].length==1");
                            });
                            a("es6", function() {
                                return f.match(/Edge\/(\d+)(\.\d)*/i) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
                            });
                            a("es7", function() {
                                return b("2 ** 2 == 4");
                            });
                            a("es8", function() {
                                return b("async () => 1, true");
                            });
                            a("es9", function() {
                                return b("({...rest} = {}), true");
                            });
                            a("es_next", function() {
                                return !1;
                            });
                            return {
                                target: c,
                                map: d
                            };
                        }, goog.Transpiler.prototype.needsTranspile = function(a, b) {
                            if ("always" == goog.TRANSPILE) return !0;
                            if ("never" == goog.TRANSPILE) return !1;
                            if (!this.requiresTranspilation_) {
                                var c = this.createRequiresTranspilation_();
                                this.requiresTranspilation_ = c.map;
                                this.transpilationTarget_ = this.transpilationTarget_ || c.target;
                            }
                            if (a in this.requiresTranspilation_) return this.requiresTranspilation_[a] ? !0 : !goog.inHtmlDocument_() || "es6" != b || "noModule" in goog.global.document.createElement("script") ? !1 : !0;
                            throw Error("Unknown language mode: " + a);
                        }, goog.Transpiler.prototype.transpile = function(a, b) {
                            return goog.transpile_(a, b, this.transpilationTarget_);
                        }, goog.transpiler_ = new goog.Transpiler, goog.protectScriptTag_ = function(a) {
                            return a.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
                        }, goog.DebugLoader_ = function() {
                            this.dependencies_ = {};
                            this.idToPath_ = {};
                            this.written_ = {};
                            this.loadingDeps_ = [];
                            this.depsToLoad_ = [];
                            this.paused_ = !1;
                            this.factory_ = new goog.DependencyFactory(goog.transpiler_);
                            this.deferredCallbacks_ = {};
                            this.deferredQueue_ = [];
                        }, goog.DebugLoader_.prototype.bootstrap = function(a, b) {
                            function c() {
                                d && (goog.global.setTimeout(d, 0), d = null);
                            }
                            var d = b;
                            if (a.length) {
                                b = [];
                                for(var e = 0; e < a.length; e++){
                                    var f = this.getPathFromDeps_(a[e]);
                                    if (!f) throw Error("Unregonized namespace: " + a[e]);
                                    b.push(this.dependencies_[f]);
                                }
                                f = goog.require;
                                var g = 0;
                                for(e = 0; e < a.length; e++)f(a[e]), b[e].onLoad(function() {
                                    ++g == a.length && c();
                                });
                            } else c();
                        }, goog.DebugLoader_.prototype.loadClosureDeps = function() {
                            this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + "deps.js"), "deps.js", [], [], {}, !1));
                            this.loadDeps_();
                        }, goog.DebugLoader_.prototype.requested = function(a, b) {
                            (a = this.getPathFromDeps_(a)) && (b || this.areDepsLoaded_(this.dependencies_[a].requires)) && (b = this.deferredCallbacks_[a]) && (delete this.deferredCallbacks_[a], b());
                        }, goog.DebugLoader_.prototype.setDependencyFactory = function(a) {
                            this.factory_ = a;
                        }, goog.DebugLoader_.prototype.load_ = function(a) {
                            if (this.getPathFromDeps_(a)) {
                                var b = this, c = [], d = function(e) {
                                    var f = b.getPathFromDeps_(e);
                                    if (!f) throw Error("Bad dependency path or symbol: " + e);
                                    if (!b.written_[f]) {
                                        b.written_[f] = !0;
                                        e = b.dependencies_[f];
                                        for(f = 0; f < e.requires.length; f++)goog.isProvided_(e.requires[f]) || d(e.requires[f]);
                                        c.push(e);
                                    }
                                };
                                d(a);
                                a = !!this.depsToLoad_.length;
                                this.depsToLoad_ = this.depsToLoad_.concat(c);
                                this.paused_ || a || this.loadDeps_();
                            } else throw a = "goog.require could not find: " + a, goog.logToConsole_(a), Error(a);
                        }, goog.DebugLoader_.prototype.loadDeps_ = function() {
                            for(var a = this, b = this.paused_; this.depsToLoad_.length && !b;)(function() {
                                var c = !1, d = a.depsToLoad_.shift(), e = !1;
                                a.loading_(d);
                                var f = {
                                    pause: function() {
                                        if (c) throw Error("Cannot call pause after the call to load.");
                                        b = !0;
                                    },
                                    resume: function() {
                                        c ? a.resume_() : b = !1;
                                    },
                                    loaded: function() {
                                        if (e) throw Error("Double call to loaded.");
                                        e = !0;
                                        a.loaded_(d);
                                    },
                                    pending: function() {
                                        for(var g = [], h = 0; h < a.loadingDeps_.length; h++)g.push(a.loadingDeps_[h]);
                                        return g;
                                    },
                                    setModuleState: function(g) {
                                        goog.moduleLoaderState_ = {
                                            type: g,
                                            moduleName: "",
                                            declareLegacyNamespace: !1
                                        };
                                    },
                                    registerEs6ModuleExports: function(g, h, k) {
                                        k && (goog.loadedModules_[k] = {
                                            exports: h,
                                            type: goog.ModuleType.ES6,
                                            moduleId: k || ""
                                        });
                                    },
                                    registerGoogModuleExports: function(g, h) {
                                        goog.loadedModules_[g] = {
                                            exports: h,
                                            type: goog.ModuleType.GOOG,
                                            moduleId: g
                                        };
                                    },
                                    clearModuleState: function() {
                                        goog.moduleLoaderState_ = null;
                                    },
                                    defer: function(g) {
                                        if (c) throw Error("Cannot register with defer after the call to load.");
                                        a.defer_(d, g);
                                    },
                                    areDepsLoaded: function() {
                                        return a.areDepsLoaded_(d.requires);
                                    }
                                };
                                try {
                                    d.load(f);
                                } finally{
                                    c = !0;
                                }
                            })();
                            b && this.pause_();
                        }, goog.DebugLoader_.prototype.pause_ = function() {
                            this.paused_ = !0;
                        }, goog.DebugLoader_.prototype.resume_ = function() {
                            this.paused_ && (this.paused_ = !1, this.loadDeps_());
                        }, goog.DebugLoader_.prototype.loading_ = function(a) {
                            this.loadingDeps_.push(a);
                        }, goog.DebugLoader_.prototype.loaded_ = function(a) {
                            for(var b = 0; b < this.loadingDeps_.length; b++)if (this.loadingDeps_[b] == a) {
                                this.loadingDeps_.splice(b, 1);
                                break;
                            }
                            for(b = 0; b < this.deferredQueue_.length; b++)if (this.deferredQueue_[b] == a.path) {
                                this.deferredQueue_.splice(b, 1);
                                break;
                            }
                            if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length) for(; this.deferredQueue_.length;)this.requested(this.deferredQueue_.shift(), !0);
                            a.loaded();
                        }, goog.DebugLoader_.prototype.areDepsLoaded_ = function(a) {
                            for(var b = 0; b < a.length; b++){
                                var c = this.getPathFromDeps_(a[b]);
                                if (!c || !(c in this.deferredCallbacks_ || goog.isProvided_(a[b]))) return !1;
                            }
                            return !0;
                        }, goog.DebugLoader_.prototype.getPathFromDeps_ = function(a) {
                            return a in this.idToPath_ ? this.idToPath_[a] : a in this.dependencies_ ? a : null;
                        }, goog.DebugLoader_.prototype.defer_ = function(a, b) {
                            this.deferredCallbacks_[a.path] = b;
                            this.deferredQueue_.push(a.path);
                        }, goog.LoadController = function() {}, goog.LoadController.prototype.pause = function() {}, goog.LoadController.prototype.resume = function() {}, goog.LoadController.prototype.loaded = function() {}, goog.LoadController.prototype.pending = function() {}, goog.LoadController.prototype.registerEs6ModuleExports = function(a, b, c) {}, goog.LoadController.prototype.setModuleState = function(a) {}, goog.LoadController.prototype.clearModuleState = function() {}, goog.LoadController.prototype.defer = function(a) {}, goog.LoadController.prototype.areDepsLoaded = function() {}, goog.Dependency = function(a, b, c, d, e) {
                            this.path = a;
                            this.relativePath = b;
                            this.provides = c;
                            this.requires = d;
                            this.loadFlags = e;
                            this.loaded_ = !1;
                            this.loadCallbacks_ = [];
                        }, goog.Dependency.prototype.getPathName = function() {
                            var a = this.path, b = a.indexOf("://");
                            0 <= b && (a = a.substring(b + 3), b = a.indexOf("/"), 0 <= b && (a = a.substring(b + 1)));
                            return a;
                        }, goog.Dependency.prototype.onLoad = function(a) {
                            this.loaded_ ? a() : this.loadCallbacks_.push(a);
                        }, goog.Dependency.prototype.loaded = function() {
                            this.loaded_ = !0;
                            var a = this.loadCallbacks_;
                            this.loadCallbacks_ = [];
                            for(var b = 0; b < a.length; b++)a[b]();
                        }, goog.Dependency.defer_ = !1, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function(a) {
                            var b = Math.random().toString(32);
                            goog.Dependency.callbackMap_[b] = a;
                            return b;
                        }, goog.Dependency.unregisterCallback_ = function(a) {
                            delete goog.Dependency.callbackMap_[a];
                        }, goog.Dependency.callback_ = function(a, b) {
                            if (a in goog.Dependency.callbackMap_) {
                                for(var c = goog.Dependency.callbackMap_[a], d = [], e = 1; e < arguments.length; e++)d.push(arguments[e]);
                                c.apply(void 0, d);
                            } else throw Error("Callback key " + a + " does not exist (was base.js loaded more than once?).");
                        }, goog.Dependency.prototype.load = function(a) {
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
                            else if (goog.inHtmlDocument_()) {
                                var b = goog.global.document;
                                if ("complete" == b.readyState && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
                                    if (/\bdeps.js$/.test(this.path)) {
                                        a.loaded();
                                        return;
                                    }
                                    throw Error('Cannot write "' + this.path + '" after document load');
                                }
                                var c = goog.getScriptNonce();
                                if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
                                    var d = function(h) {
                                        h.readyState && "complete" != h.readyState ? h.onload = d : (goog.Dependency.unregisterCallback_(e), a.loaded());
                                    };
                                    var e = goog.Dependency.registerCallback_(d);
                                    c = c ? ' nonce="' + c + '"' : "";
                                    var f = '<script src="' + this.path + '"' + c + (goog.Dependency.defer_ ? " defer" : "") + ' id="script-' + e + '">\x3c/script>';
                                    f += "<script" + c + ">";
                                    f = goog.Dependency.defer_ ? f + ("document.getElementById('script-" + e + "').onload = function() {\n  goog.Dependency.callback_('" + e + "', this);\n};\n") : f + ("goog.Dependency.callback_('" + e + "', document.getElementById('script-" + e + "'));");
                                    f += "\x3c/script>";
                                    b.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(f) : f);
                                } else {
                                    var g = b.createElement("script");
                                    g.defer = goog.Dependency.defer_;
                                    g.async = !1;
                                    c && (g.nonce = c);
                                    goog.DebugLoader_.IS_OLD_IE_ ? (a.pause(), g.onreadystatechange = function() {
                                        if ("loaded" == g.readyState || "complete" == g.readyState) a.loaded(), a.resume();
                                    }) : g.onload = function() {
                                        g.onload = null;
                                        a.loaded();
                                    };
                                    g.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path;
                                    b.head.appendChild(g);
                                }
                            } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), "deps.js" == this.relativePath ? (goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."), a.loaded()) : a.pause();
                        }, goog.Es6ModuleDependency = function(a, b, c, d, e) {
                            goog.Dependency.call(this, a, b, c, d, e);
                        }, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function(a) {
                            function b(l, p) {
                                var m = "", n = goog.getScriptNonce();
                                n && (m = ' nonce="' + n + '"');
                                l = p ? '<script type="module" crossorigin' + m + ">" + p + "\x3c/script>" : '<script type="module" crossorigin src="' + l + '"' + m + ">\x3c/script>";
                                d.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(l) : l);
                            }
                            function c(l, p) {
                                var m = d.createElement("script");
                                m.defer = !0;
                                m.async = !1;
                                m.type = "module";
                                m.setAttribute("crossorigin", !0);
                                var n = goog.getScriptNonce();
                                n && (m.nonce = n);
                                p ? m.text = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(p) : p : m.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(l) : l;
                                d.head.appendChild(m);
                            }
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
                            else if (goog.inHtmlDocument_()) {
                                var d = goog.global.document, e = this;
                                if (goog.isDocumentLoading_()) {
                                    var f = b;
                                    goog.Dependency.defer_ = !0;
                                } else f = c;
                                var g = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(g);
                                    a.setModuleState(goog.ModuleType.ES6);
                                });
                                f(void 0, 'goog.Dependency.callback_("' + g + '")');
                                f(this.path, void 0);
                                var h = goog.Dependency.registerCallback_(function(l) {
                                    goog.Dependency.unregisterCallback_(h);
                                    a.registerEs6ModuleExports(e.path, l, goog.moduleLoaderState_.moduleName);
                                });
                                f(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
                                var k = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(k);
                                    a.clearModuleState();
                                    a.loaded();
                                });
                                f(void 0, 'goog.Dependency.callback_("' + k + '")');
                            } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), a.pause();
                        }, goog.TransformedDependency = function(a, b, c, d, e) {
                            goog.Dependency.call(this, a, b, c, d, e);
                            this.contents_ = null;
                            this.lazyFetch_ = !goog.inHtmlDocument_() || !("noModule" in goog.global.document.createElement("script"));
                        }, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function(a) {
                            function b() {
                                e.contents_ = goog.loadFileSync_(e.path);
                                e.contents_ && (e.contents_ = e.transform(e.contents_), e.contents_ && (e.contents_ += "\n//# sourceURL=" + e.path));
                            }
                            function c() {
                                e.lazyFetch_ && b();
                                if (e.contents_) {
                                    f && a.setModuleState(goog.ModuleType.ES6);
                                    try {
                                        var p = e.contents_;
                                        e.contents_ = null;
                                        goog.globalEval(p);
                                        if (f) var m = goog.moduleLoaderState_.moduleName;
                                    } finally{
                                        f && a.clearModuleState();
                                    }
                                    f && goog.global.$jscomp.require.ensure([
                                        e.getPathName()
                                    ], function() {
                                        a.registerEs6ModuleExports(e.path, goog.global.$jscomp.require(e.getPathName()), m);
                                    });
                                    a.loaded();
                                }
                            }
                            function d() {
                                var p = goog.global.document, m = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(m);
                                    c();
                                }), n = goog.getScriptNonce();
                                n = "<script" + (n ? ' nonce="' + n + '"' : "") + ">" + goog.protectScriptTag_('goog.Dependency.callback_("' + m + '");') + "\x3c/script>";
                                p.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(n) : n);
                            }
                            var e = this;
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) b(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT("", this.contents_) ? (this.contents_ = null, a.loaded()) : a.pause();
                            else {
                                var f = this.loadFlags.module == goog.ModuleType.ES6;
                                this.lazyFetch_ || b();
                                var g = 1 < a.pending().length, h = g && goog.DebugLoader_.IS_OLD_IE_;
                                g = goog.Dependency.defer_ && (g || goog.isDocumentLoading_());
                                if (h || g) a.defer(function() {
                                    c();
                                });
                                else {
                                    var k = goog.global.document;
                                    h = goog.inHtmlDocument_() && "ActiveXObject" in goog.global;
                                    if (f && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !h) {
                                        goog.Dependency.defer_ = !0;
                                        a.pause();
                                        var l = k.onreadystatechange;
                                        k.onreadystatechange = function() {
                                            "interactive" == k.readyState && (k.onreadystatechange = l, c(), a.resume());
                                            "function" === typeof l && l.apply(void 0, arguments);
                                        };
                                    } else !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d() : c();
                                }
                            }
                        }, goog.TransformedDependency.prototype.transform = function(a) {}, goog.TranspiledDependency = function(a, b, c, d, e, f) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                            this.transpiler = f;
                        }, goog.inherits(goog.TranspiledDependency, goog.TransformedDependency), goog.TranspiledDependency.prototype.transform = function(a) {
                            return this.transpiler.transpile(a, this.getPathName());
                        }, goog.PreTranspiledEs6ModuleDependency = function(a, b, c, d, e) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                        }, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function(a) {
                            return a;
                        }, goog.GoogModuleDependency = function(a, b, c, d, e, f, g) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                            this.needsTranspile_ = f;
                            this.transpiler_ = g;
                        }, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function(a) {
                            this.needsTranspile_ && (a = this.transpiler_.transpile(a, this.getPathName()));
                            return goog.LOAD_MODULE_USING_EVAL && void 0 !== goog.global.JSON ? "goog.loadModule(" + goog.global.JSON.stringify(a + "\n//# sourceURL=" + this.path + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + a + "\n;return exports});\n//# sourceURL=" + this.path + "\n";
                        }, goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader_.prototype.addDependency = function(a, b, c, d) {
                            b = b || [];
                            a = a.replace(/\\/g, "/");
                            var e = goog.normalizePath_(goog.basePath + a);
                            d && "boolean" !== typeof d || (d = d ? {
                                module: goog.ModuleType.GOOG
                            } : {});
                            c = this.factory_.createDependency(e, a, b, c, d, goog.transpiler_.needsTranspile(d.lang || "es3", d.module));
                            this.dependencies_[e] = c;
                            for(c = 0; c < b.length; c++)this.idToPath_[b[c]] = e;
                            this.idToPath_[a] = e;
                        }, goog.DependencyFactory = function(a) {
                            this.transpiler = a;
                        }, goog.DependencyFactory.prototype.createDependency = function(a, b, c, d, e, f) {
                            return e.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(a, b, c, d, e, f, this.transpiler) : f ? new goog.TranspiledDependency(a, b, c, d, e, this.transpiler) : e.module == goog.ModuleType.ES6 ? "never" == goog.TRANSPILE && goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(a, b, c, d, e) : new goog.Es6ModuleDependency(a, b, c, d, e) : new goog.Dependency(a, b, c, d, e);
                        }, goog.debugLoader_ = new goog.DebugLoader_, goog.loadClosureDeps = function() {
                            goog.debugLoader_.loadClosureDeps();
                        }, goog.setDependencyFactory = function(a) {
                            goog.debugLoader_.setDependencyFactory(a);
                        }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function(a, b) {
                            goog.debugLoader_.bootstrap(a, b);
                        });
                        goog.TRUSTED_TYPES_POLICY_NAME = "goog";
                        goog.identity_ = function(a) {
                            return a;
                        };
                        goog.createTrustedTypesPolicy = function(a) {
                            var b = null, c = goog.global.trustedTypes;
                            if (!c || !c.createPolicy) return b;
                            try {
                                b = c.createPolicy(a, {
                                    createHTML: goog.identity_,
                                    createScript: goog.identity_,
                                    createScriptURL: goog.identity_
                                });
                            } catch (d) {
                                goog.logToConsole_(d.message);
                            }
                            return b;
                        };
                        goog.debug = {};
                        function module$contents$goog$debug$Error_DebugError(a) {
                            if (Error.captureStackTrace) Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
                            else {
                                var b = Error().stack;
                                b && (this.stack = b);
                            }
                            a && (this.message = String(a));
                            this.reportErrorToServer = !0;
                        }
                        goog.inherits(module$contents$goog$debug$Error_DebugError, Error);
                        module$contents$goog$debug$Error_DebugError.prototype.name = "CustomError";
                        goog.debug.Error = module$contents$goog$debug$Error_DebugError;
                        goog.dom = {};
                        goog.dom.NodeType = {
                            ELEMENT: 1,
                            ATTRIBUTE: 2,
                            TEXT: 3,
                            CDATA_SECTION: 4,
                            ENTITY_REFERENCE: 5,
                            ENTITY: 6,
                            PROCESSING_INSTRUCTION: 7,
                            COMMENT: 8,
                            DOCUMENT: 9,
                            DOCUMENT_TYPE: 10,
                            DOCUMENT_FRAGMENT: 11,
                            NOTATION: 12
                        };
                        goog.asserts = {};
                        goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
                        goog.asserts.AssertionError = function(a, b) {
                            module$contents$goog$debug$Error_DebugError.call(this, goog.asserts.subs_(a, b));
                            this.messagePattern = a;
                        };
                        goog.inherits(goog.asserts.AssertionError, module$contents$goog$debug$Error_DebugError);
                        goog.asserts.AssertionError.prototype.name = "AssertionError";
                        goog.asserts.DEFAULT_ERROR_HANDLER = function(a) {
                            throw a;
                        };
                        goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
                        goog.asserts.subs_ = function(a, b) {
                            a = a.split("%s");
                            for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
                            return c + a[d];
                        };
                        goog.asserts.doAssertFailure_ = function(a, b, c, d) {
                            var e = "Assertion failed";
                            if (c) {
                                e += ": " + c;
                                var f = d;
                            } else a && (e += ": " + a, f = b);
                            a = new goog.asserts.AssertionError("" + e, f || []);
                            goog.asserts.errorHandler_(a);
                        };
                        goog.asserts.setErrorHandler = function(a) {
                            goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
                        };
                        goog.asserts.assert = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertExists = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && null == a && goog.asserts.doAssertFailure_("Expected to exist: %s.", [
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.fail = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
                        };
                        goog.asserts.assertNumber = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "number" !== typeof a && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertString = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "string" !== typeof a && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertFunction = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "function" !== typeof a && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertObject = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertArray = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !Array.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertBoolean = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "boolean" !== typeof a && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertElement = function(a, b, c) {
                            !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertInstanceof = function(a, b, c, d) {
                            !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [
                                goog.asserts.getType_(b),
                                goog.asserts.getType_(a)
                            ], c, Array.prototype.slice.call(arguments, 3));
                            return a;
                        };
                        goog.asserts.assertFinite = function(a, b, c) {
                            !goog.asserts.ENABLE_ASSERTS || "number" == typeof a && isFinite(a) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertObjectPrototypeIsIntact = function() {
                            for(var a in Object.prototype)goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
                        };
                        goog.asserts.getType_ = function(a) {
                            return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
                        };
                        goog.array = {};
                        goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
                        var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
                        goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
                        function module$contents$goog$array_peek(a) {
                            return a[a.length - 1];
                        }
                        goog.array.peek = module$contents$goog$array_peek;
                        goog.array.last = module$contents$goog$array_peek;
                        var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.indexOf.call(a, b, c);
                        } : function(a, b, c) {
                            c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
                            if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, c);
                            for(; c < a.length; c++)if (c in a && a[c] === b) return c;
                            return -1;
                        };
                        goog.array.indexOf = module$contents$goog$array_indexOf;
                        var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
                        } : function(a, b, c) {
                            c = null == c ? a.length - 1 : c;
                            0 > c && (c = Math.max(0, a.length + c));
                            if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.lastIndexOf(b, c);
                            for(; 0 <= c; c--)if (c in a && a[c] === b) return c;
                            return -1;
                        };
                        goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
                        var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            Array.prototype.forEach.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
                        };
                        goog.array.forEach = module$contents$goog$array_forEach;
                        function module$contents$goog$array_forEachRight(a, b, c) {
                            var d = a.length, e = "string" === typeof a ? a.split("") : a;
                            for(--d; 0 <= d; --d)d in e && b.call(c, e[d], d, a);
                        }
                        goog.array.forEachRight = module$contents$goog$array_forEachRight;
                        var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.filter.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = [], f = 0, g = "string" === typeof a ? a.split("") : a, h = 0; h < d; h++)if (h in g) {
                                var k = g[h];
                                b.call(c, k, h, a) && (e[f++] = k);
                            }
                            return e;
                        };
                        goog.array.filter = module$contents$goog$array_filter;
                        var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.map.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = Array(d), f = "string" === typeof a ? a.split("") : a, g = 0; g < d; g++)g in f && (e[g] = b.call(c, f[g], g, a));
                            return e;
                        };
                        goog.array.map = module$contents$goog$array_map;
                        var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            d && (b = goog.bind(b, d));
                            return Array.prototype.reduce.call(a, b, c);
                        } : function(a, b, c, d) {
                            var e = c;
                            module$contents$goog$array_forEach(a, function(f, g) {
                                e = b.call(d, e, f, g, a);
                            });
                            return e;
                        };
                        goog.array.reduce = module$contents$goog$array_reduce;
                        var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            goog.asserts.assert(null != b);
                            d && (b = goog.bind(b, d));
                            return Array.prototype.reduceRight.call(a, b, c);
                        } : function(a, b, c, d) {
                            var e = c;
                            module$contents$goog$array_forEachRight(a, function(f, g) {
                                e = b.call(d, e, f, g, a);
                            });
                            return e;
                        };
                        goog.array.reduceRight = module$contents$goog$array_reduceRight;
                        var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.some.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && b.call(c, e[f], f, a)) return !0;
                            return !1;
                        };
                        goog.array.some = module$contents$goog$array_some;
                        var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.every.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && !b.call(c, e[f], f, a)) return !1;
                            return !0;
                        };
                        goog.array.every = module$contents$goog$array_every;
                        function module$contents$goog$array_count(a, b, c) {
                            var d = 0;
                            module$contents$goog$array_forEach(a, function(e, f, g) {
                                b.call(c, e, f, g) && ++d;
                            }, c);
                            return d;
                        }
                        goog.array.count = module$contents$goog$array_count;
                        function module$contents$goog$array_find(a, b, c) {
                            b = module$contents$goog$array_findIndex(a, b, c);
                            return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
                        }
                        goog.array.find = module$contents$goog$array_find;
                        function module$contents$goog$array_findIndex(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && b.call(c, e[f], f, a)) return f;
                            return -1;
                        }
                        goog.array.findIndex = module$contents$goog$array_findIndex;
                        function module$contents$goog$array_findRight(a, b, c) {
                            b = module$contents$goog$array_findIndexRight(a, b, c);
                            return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
                        }
                        goog.array.findRight = module$contents$goog$array_findRight;
                        function module$contents$goog$array_findIndexRight(a, b, c) {
                            var d = a.length, e = "string" === typeof a ? a.split("") : a;
                            for(--d; 0 <= d; d--)if (d in e && b.call(c, e[d], d, a)) return d;
                            return -1;
                        }
                        goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
                        function module$contents$goog$array_contains(a, b) {
                            return 0 <= module$contents$goog$array_indexOf(a, b);
                        }
                        goog.array.contains = module$contents$goog$array_contains;
                        function module$contents$goog$array_isEmpty(a) {
                            return 0 == a.length;
                        }
                        goog.array.isEmpty = module$contents$goog$array_isEmpty;
                        function module$contents$goog$array_clear(a) {
                            if (!Array.isArray(a)) for(var b = a.length - 1; 0 <= b; b--)delete a[b];
                            a.length = 0;
                        }
                        goog.array.clear = module$contents$goog$array_clear;
                        function module$contents$goog$array_insert(a, b) {
                            module$contents$goog$array_contains(a, b) || a.push(b);
                        }
                        goog.array.insert = module$contents$goog$array_insert;
                        function module$contents$goog$array_insertAt(a, b, c) {
                            module$contents$goog$array_splice(a, c, 0, b);
                        }
                        goog.array.insertAt = module$contents$goog$array_insertAt;
                        function module$contents$goog$array_insertArrayAt(a, b, c) {
                            goog.partial(module$contents$goog$array_splice, a, c, 0).apply(null, b);
                        }
                        goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
                        function module$contents$goog$array_insertBefore(a, b, c) {
                            var d;
                            2 == arguments.length || 0 > (d = module$contents$goog$array_indexOf(a, c)) ? a.push(b) : module$contents$goog$array_insertAt(a, b, d);
                        }
                        goog.array.insertBefore = module$contents$goog$array_insertBefore;
                        function module$contents$goog$array_remove(a, b) {
                            b = module$contents$goog$array_indexOf(a, b);
                            var c;
                            (c = 0 <= b) && module$contents$goog$array_removeAt(a, b);
                            return c;
                        }
                        goog.array.remove = module$contents$goog$array_remove;
                        function module$contents$goog$array_removeLast(a, b) {
                            b = module$contents$goog$array_lastIndexOf(a, b);
                            return 0 <= b ? (module$contents$goog$array_removeAt(a, b), !0) : !1;
                        }
                        goog.array.removeLast = module$contents$goog$array_removeLast;
                        function module$contents$goog$array_removeAt(a, b) {
                            goog.asserts.assert(null != a.length);
                            return 1 == Array.prototype.splice.call(a, b, 1).length;
                        }
                        goog.array.removeAt = module$contents$goog$array_removeAt;
                        function module$contents$goog$array_removeIf(a, b, c) {
                            b = module$contents$goog$array_findIndex(a, b, c);
                            return 0 <= b ? (module$contents$goog$array_removeAt(a, b), !0) : !1;
                        }
                        goog.array.removeIf = module$contents$goog$array_removeIf;
                        function module$contents$goog$array_removeAllIf(a, b, c) {
                            var d = 0;
                            module$contents$goog$array_forEachRight(a, function(e, f) {
                                b.call(c, e, f, a) && module$contents$goog$array_removeAt(a, f) && d++;
                            });
                            return d;
                        }
                        goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
                        function module$contents$goog$array_concat(a) {
                            return Array.prototype.concat.apply([], arguments);
                        }
                        goog.array.concat = module$contents$goog$array_concat;
                        function module$contents$goog$array_join(a) {
                            return Array.prototype.concat.apply([], arguments);
                        }
                        goog.array.join = module$contents$goog$array_join;
                        function module$contents$goog$array_toArray(a) {
                            var b = a.length;
                            if (0 < b) {
                                for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
                                return c;
                            }
                            return [];
                        }
                        var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
                        goog.array.clone = module$contents$goog$array_clone;
                        function module$contents$goog$array_extend(a, b) {
                            for(var c = 1; c < arguments.length; c++){
                                var d = arguments[c];
                                if (goog.isArrayLike(d)) {
                                    var e = a.length || 0, f = d.length || 0;
                                    a.length = e + f;
                                    for(var g = 0; g < f; g++)a[e + g] = d[g];
                                } else a.push(d);
                            }
                        }
                        goog.array.extend = module$contents$goog$array_extend;
                        function module$contents$goog$array_splice(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.splice.apply(a, module$contents$goog$array_slice(arguments, 1));
                        }
                        goog.array.splice = module$contents$goog$array_splice;
                        function module$contents$goog$array_slice(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
                        }
                        goog.array.slice = module$contents$goog$array_slice;
                        function module$contents$goog$array_removeDuplicates(a, b, c) {
                            b = b || a;
                            var d = function(k) {
                                return goog.isObject(k) ? "o" + goog.getUid(k) : (typeof k).charAt(0) + k;
                            };
                            c = c || d;
                            d = {};
                            for(var e = 0, f = 0; f < a.length;){
                                var g = a[f++], h = c(g);
                                Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
                            }
                            b.length = e;
                        }
                        goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
                        function module$contents$goog$array_binarySearch(a, b, c) {
                            return module$contents$goog$array_binarySearch_(a, c || module$contents$goog$array_defaultCompare, !1, b);
                        }
                        goog.array.binarySearch = module$contents$goog$array_binarySearch;
                        function module$contents$goog$array_binarySelect(a, b, c) {
                            return module$contents$goog$array_binarySearch_(a, b, !0, void 0, c);
                        }
                        goog.array.binarySelect = module$contents$goog$array_binarySelect;
                        function module$contents$goog$array_binarySearch_(a, b, c, d, e) {
                            for(var f = 0, g = a.length, h; f < g;){
                                var k = f + (g - f >>> 1);
                                var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
                                0 < l ? f = k + 1 : (g = k, h = !l);
                            }
                            return h ? f : -f - 1;
                        }
                        function module$contents$goog$array_sort(a, b) {
                            a.sort(b || module$contents$goog$array_defaultCompare);
                        }
                        goog.array.sort = module$contents$goog$array_sort;
                        function module$contents$goog$array_stableSort(a, b) {
                            for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = {
                                index: d,
                                value: a[d]
                            };
                            var e = b || module$contents$goog$array_defaultCompare;
                            module$contents$goog$array_sort(c, function(f, g) {
                                return e(f.value, g.value) || f.index - g.index;
                            });
                            for(d = 0; d < a.length; d++)a[d] = c[d].value;
                        }
                        goog.array.stableSort = module$contents$goog$array_stableSort;
                        function module$contents$goog$array_sortByKey(a, b, c) {
                            var d = c || module$contents$goog$array_defaultCompare;
                            module$contents$goog$array_sort(a, function(e, f) {
                                return d(b(e), b(f));
                            });
                        }
                        goog.array.sortByKey = module$contents$goog$array_sortByKey;
                        function module$contents$goog$array_sortObjectsByKey(a, b, c) {
                            module$contents$goog$array_sortByKey(a, function(d) {
                                return d[b];
                            }, c);
                        }
                        goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
                        function module$contents$goog$array_isSorted(a, b, c) {
                            b = b || module$contents$goog$array_defaultCompare;
                            for(var d = 1; d < a.length; d++){
                                var e = b(a[d - 1], a[d]);
                                if (0 < e || 0 == e && c) return !1;
                            }
                            return !0;
                        }
                        goog.array.isSorted = module$contents$goog$array_isSorted;
                        function module$contents$goog$array_equals(a, b, c) {
                            if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) return !1;
                            var d = a.length;
                            c = c || module$contents$goog$array_defaultCompareEquality;
                            for(var e = 0; e < d; e++)if (!c(a[e], b[e])) return !1;
                            return !0;
                        }
                        goog.array.equals = module$contents$goog$array_equals;
                        function module$contents$goog$array_compare3(a, b, c) {
                            c = c || module$contents$goog$array_defaultCompare;
                            for(var d = Math.min(a.length, b.length), e = 0; e < d; e++){
                                var f = c(a[e], b[e]);
                                if (0 != f) return f;
                            }
                            return module$contents$goog$array_defaultCompare(a.length, b.length);
                        }
                        goog.array.compare3 = module$contents$goog$array_compare3;
                        function module$contents$goog$array_defaultCompare(a, b) {
                            return a > b ? 1 : a < b ? -1 : 0;
                        }
                        goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
                        function module$contents$goog$array_inverseDefaultCompare(a, b) {
                            return -module$contents$goog$array_defaultCompare(a, b);
                        }
                        goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
                        function module$contents$goog$array_defaultCompareEquality(a, b) {
                            return a === b;
                        }
                        goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
                        function module$contents$goog$array_binaryInsert(a, b, c) {
                            c = module$contents$goog$array_binarySearch(a, b, c);
                            return 0 > c ? (module$contents$goog$array_insertAt(a, b, -(c + 1)), !0) : !1;
                        }
                        goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
                        function module$contents$goog$array_binaryRemove(a, b, c) {
                            b = module$contents$goog$array_binarySearch(a, b, c);
                            return 0 <= b ? module$contents$goog$array_removeAt(a, b) : !1;
                        }
                        goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
                        function module$contents$goog$array_bucket(a, b, c) {
                            for(var d = {}, e = 0; e < a.length; e++){
                                var f = a[e], g = b.call(c, f, e, a);
                                void 0 !== g && (d[g] || (d[g] = [])).push(f);
                            }
                            return d;
                        }
                        goog.array.bucket = module$contents$goog$array_bucket;
                        function module$contents$goog$array_toObject(a, b, c) {
                            var d = {};
                            module$contents$goog$array_forEach(a, function(e, f) {
                                d[b.call(c, e, f, a)] = e;
                            });
                            return d;
                        }
                        goog.array.toObject = module$contents$goog$array_toObject;
                        function module$contents$goog$array_range(a, b, c) {
                            var d = [], e = 0, f = a;
                            c = c || 1;
                            void 0 !== b && (e = a, f = b);
                            if (0 > c * (f - e)) return [];
                            if (0 < c) for(a = e; a < f; a += c)d.push(a);
                            else for(a = e; a > f; a += c)d.push(a);
                            return d;
                        }
                        goog.array.range = module$contents$goog$array_range;
                        function module$contents$goog$array_repeat(a, b) {
                            for(var c = [], d = 0; d < b; d++)c[d] = a;
                            return c;
                        }
                        goog.array.repeat = module$contents$goog$array_repeat;
                        function module$contents$goog$array_flatten(a) {
                            for(var b = [], c = 0; c < arguments.length; c++){
                                var d = arguments[c];
                                if (Array.isArray(d)) for(var e = 0; e < d.length; e += 8192){
                                    var f = module$contents$goog$array_slice(d, e, e + 8192);
                                    f = module$contents$goog$array_flatten.apply(null, f);
                                    for(var g = 0; g < f.length; g++)b.push(f[g]);
                                }
                                else b.push(d);
                            }
                            return b;
                        }
                        goog.array.flatten = module$contents$goog$array_flatten;
                        function module$contents$goog$array_rotate(a, b) {
                            goog.asserts.assert(null != a.length);
                            a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
                            return a;
                        }
                        goog.array.rotate = module$contents$goog$array_rotate;
                        function module$contents$goog$array_moveItem(a, b, c) {
                            goog.asserts.assert(0 <= b && b < a.length);
                            goog.asserts.assert(0 <= c && c < a.length);
                            b = Array.prototype.splice.call(a, b, 1);
                            Array.prototype.splice.call(a, c, 0, b[0]);
                        }
                        goog.array.moveItem = module$contents$goog$array_moveItem;
                        function module$contents$goog$array_zip(a) {
                            if (!arguments.length) return [];
                            for(var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++)arguments[d].length < c && (c = arguments[d].length);
                            for(d = 0; d < c; d++){
                                for(var e = [], f = 0; f < arguments.length; f++)e.push(arguments[f][d]);
                                b.push(e);
                            }
                            return b;
                        }
                        goog.array.zip = module$contents$goog$array_zip;
                        function module$contents$goog$array_shuffle(a, b) {
                            b = b || Math.random;
                            for(var c = a.length - 1; 0 < c; c--){
                                var d = Math.floor(b() * (c + 1)), e = a[c];
                                a[c] = a[d];
                                a[d] = e;
                            }
                        }
                        goog.array.shuffle = module$contents$goog$array_shuffle;
                        function module$contents$goog$array_copyByIndex(a, b) {
                            var c = [];
                            module$contents$goog$array_forEach(b, function(d) {
                                c.push(a[d]);
                            });
                            return c;
                        }
                        goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
                        function module$contents$goog$array_concatMap(a, b, c) {
                            return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(a, b, c));
                        }
                        goog.array.concatMap = module$contents$goog$array_concatMap;
                        goog.dom.asserts = {};
                        goog.dom.asserts.assertIsLocation = function(a) {
                            if (goog.asserts.ENABLE_ASSERTS) {
                                var b = goog.dom.asserts.getWindow_(a);
                                b && (!a || !(a instanceof b.Location) && a instanceof b.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a));
                            }
                            return a;
                        };
                        goog.dom.asserts.assertIsElementType_ = function(a, b) {
                            if (goog.asserts.ENABLE_ASSERTS) {
                                var c = goog.dom.asserts.getWindow_(a);
                                c && "undefined" != typeof c[b] && (a && (a instanceof c[b] || !(a instanceof c.Location || a instanceof c.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, goog.dom.asserts.debugStringForType_(a)));
                            }
                            return a;
                        };
                        goog.dom.asserts.assertIsHTMLAnchorElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLAnchorElement");
                        };
                        goog.dom.asserts.assertIsHTMLButtonElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLButtonElement");
                        };
                        goog.dom.asserts.assertIsHTMLLinkElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLLinkElement");
                        };
                        goog.dom.asserts.assertIsHTMLImageElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLImageElement");
                        };
                        goog.dom.asserts.assertIsHTMLAudioElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLAudioElement");
                        };
                        goog.dom.asserts.assertIsHTMLVideoElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLVideoElement");
                        };
                        goog.dom.asserts.assertIsHTMLInputElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLInputElement");
                        };
                        goog.dom.asserts.assertIsHTMLTextAreaElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLTextAreaElement");
                        };
                        goog.dom.asserts.assertIsHTMLCanvasElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLCanvasElement");
                        };
                        goog.dom.asserts.assertIsHTMLEmbedElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLEmbedElement");
                        };
                        goog.dom.asserts.assertIsHTMLFormElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLFormElement");
                        };
                        goog.dom.asserts.assertIsHTMLFrameElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLFrameElement");
                        };
                        goog.dom.asserts.assertIsHTMLIFrameElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLIFrameElement");
                        };
                        goog.dom.asserts.assertIsHTMLObjectElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLObjectElement");
                        };
                        goog.dom.asserts.assertIsHTMLScriptElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLScriptElement");
                        };
                        goog.dom.asserts.debugStringForType_ = function(a) {
                            if (goog.isObject(a)) try {
                                return a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
                            } catch (b) {
                                return "<object could not be stringified>";
                            }
                            else return void 0 === a ? "undefined" : null === a ? "null" : typeof a;
                        };
                        goog.dom.asserts.getWindow_ = function(a) {
                            try {
                                var b = a && a.ownerDocument, c = b && (b.defaultView || b.parentWindow);
                                c = c || goog.global;
                                if (c.Element && c.Location) return c;
                            } catch (d) {}
                            return null;
                        };
                        goog.dom.HtmlElement = function() {};
                        goog.functions = {};
                        goog.functions.constant = function(a) {
                            return function() {
                                return a;
                            };
                        };
                        goog.functions.FALSE = function() {
                            return !1;
                        };
                        goog.functions.TRUE = function() {
                            return !0;
                        };
                        goog.functions.NULL = function() {
                            return null;
                        };
                        goog.functions.identity = function(a, b) {
                            return a;
                        };
                        goog.functions.error = function(a) {
                            return function() {
                                throw Error(a);
                            };
                        };
                        goog.functions.fail = function(a) {
                            return function() {
                                throw a;
                            };
                        };
                        goog.functions.lock = function(a, b) {
                            b = b || 0;
                            return function() {
                                return a.apply(this, Array.prototype.slice.call(arguments, 0, b));
                            };
                        };
                        goog.functions.nth = function(a) {
                            return function() {
                                return arguments[a];
                            };
                        };
                        goog.functions.partialRight = function(a, b) {
                            var c = Array.prototype.slice.call(arguments, 1);
                            return function() {
                                var d = this;
                                d === goog.global && (d = void 0);
                                var e = Array.prototype.slice.call(arguments);
                                e.push.apply(e, c);
                                return a.apply(d, e);
                            };
                        };
                        goog.functions.withReturnValue = function(a, b) {
                            return goog.functions.sequence(a, goog.functions.constant(b));
                        };
                        goog.functions.equalTo = function(a, b) {
                            return function(c) {
                                return b ? a == c : a === c;
                            };
                        };
                        goog.functions.compose = function(a, b) {
                            var c = arguments, d = c.length;
                            return function() {
                                var e;
                                d && (e = c[d - 1].apply(this, arguments));
                                for(var f = d - 2; 0 <= f; f--)e = c[f].call(this, e);
                                return e;
                            };
                        };
                        goog.functions.sequence = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d, e = 0; e < c; e++)d = b[e].apply(this, arguments);
                                return d;
                            };
                        };
                        goog.functions.and = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d = 0; d < c; d++)if (!b[d].apply(this, arguments)) return !1;
                                return !0;
                            };
                        };
                        goog.functions.or = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d = 0; d < c; d++)if (b[d].apply(this, arguments)) return !0;
                                return !1;
                            };
                        };
                        goog.functions.not = function(a) {
                            return function() {
                                return !a.apply(this, arguments);
                            };
                        };
                        goog.functions.create = function(a, b) {
                            var c = function() {};
                            c.prototype = a.prototype;
                            c = new c;
                            a.apply(c, Array.prototype.slice.call(arguments, 1));
                            return c;
                        };
                        goog.functions.CACHE_RETURN_VALUE = !0;
                        goog.functions.cacheReturnValue = function(a) {
                            var b = !1, c;
                            return function() {
                                if (!goog.functions.CACHE_RETURN_VALUE) return a();
                                b || (c = a(), b = !0);
                                return c;
                            };
                        };
                        goog.functions.once = function(a) {
                            var b = a;
                            return function() {
                                if (b) {
                                    var c = b;
                                    b = null;
                                    c();
                                }
                            };
                        };
                        goog.functions.debounce = function(a, b, c) {
                            var d = 0;
                            return function(e) {
                                goog.global.clearTimeout(d);
                                var f = arguments;
                                d = goog.global.setTimeout(function() {
                                    a.apply(c, f);
                                }, b);
                            };
                        };
                        goog.functions.throttle = function(a, b, c) {
                            var d = 0, e = !1, f = [], g = function() {
                                d = 0;
                                e && (e = !1, h());
                            }, h = function() {
                                d = goog.global.setTimeout(g, b);
                                a.apply(c, f);
                            };
                            return function(k) {
                                f = arguments;
                                d ? e = !0 : h();
                            };
                        };
                        goog.functions.rateLimit = function(a, b, c) {
                            var d = 0, e = function() {
                                d = 0;
                            };
                            return function(f) {
                                d || (d = goog.global.setTimeout(e, b), a.apply(c, arguments));
                            };
                        };
                        goog.functions.isFunction = function(a) {
                            return "function" === typeof a;
                        };
                        goog.dom.TagName = function() {};
                        goog.dom.TagName.cast = function(a, b) {
                            return a;
                        };
                        goog.dom.TagName.prototype.toString = function() {};
                        goog.dom.TagName.A = "A";
                        goog.dom.TagName.ABBR = "ABBR";
                        goog.dom.TagName.ACRONYM = "ACRONYM";
                        goog.dom.TagName.ADDRESS = "ADDRESS";
                        goog.dom.TagName.APPLET = "APPLET";
                        goog.dom.TagName.AREA = "AREA";
                        goog.dom.TagName.ARTICLE = "ARTICLE";
                        goog.dom.TagName.ASIDE = "ASIDE";
                        goog.dom.TagName.AUDIO = "AUDIO";
                        goog.dom.TagName.B = "B";
                        goog.dom.TagName.BASE = "BASE";
                        goog.dom.TagName.BASEFONT = "BASEFONT";
                        goog.dom.TagName.BDI = "BDI";
                        goog.dom.TagName.BDO = "BDO";
                        goog.dom.TagName.BIG = "BIG";
                        goog.dom.TagName.BLOCKQUOTE = "BLOCKQUOTE";
                        goog.dom.TagName.BODY = "BODY";
                        goog.dom.TagName.BR = "BR";
                        goog.dom.TagName.BUTTON = "BUTTON";
                        goog.dom.TagName.CANVAS = "CANVAS";
                        goog.dom.TagName.CAPTION = "CAPTION";
                        goog.dom.TagName.CENTER = "CENTER";
                        goog.dom.TagName.CITE = "CITE";
                        goog.dom.TagName.CODE = "CODE";
                        goog.dom.TagName.COL = "COL";
                        goog.dom.TagName.COLGROUP = "COLGROUP";
                        goog.dom.TagName.COMMAND = "COMMAND";
                        goog.dom.TagName.DATA = "DATA";
                        goog.dom.TagName.DATALIST = "DATALIST";
                        goog.dom.TagName.DD = "DD";
                        goog.dom.TagName.DEL = "DEL";
                        goog.dom.TagName.DETAILS = "DETAILS";
                        goog.dom.TagName.DFN = "DFN";
                        goog.dom.TagName.DIALOG = "DIALOG";
                        goog.dom.TagName.DIR = "DIR";
                        goog.dom.TagName.DIV = "DIV";
                        goog.dom.TagName.DL = "DL";
                        goog.dom.TagName.DT = "DT";
                        goog.dom.TagName.EM = "EM";
                        goog.dom.TagName.EMBED = "EMBED";
                        goog.dom.TagName.FIELDSET = "FIELDSET";
                        goog.dom.TagName.FIGCAPTION = "FIGCAPTION";
                        goog.dom.TagName.FIGURE = "FIGURE";
                        goog.dom.TagName.FONT = "FONT";
                        goog.dom.TagName.FOOTER = "FOOTER";
                        goog.dom.TagName.FORM = "FORM";
                        goog.dom.TagName.FRAME = "FRAME";
                        goog.dom.TagName.FRAMESET = "FRAMESET";
                        goog.dom.TagName.H1 = "H1";
                        goog.dom.TagName.H2 = "H2";
                        goog.dom.TagName.H3 = "H3";
                        goog.dom.TagName.H4 = "H4";
                        goog.dom.TagName.H5 = "H5";
                        goog.dom.TagName.H6 = "H6";
                        goog.dom.TagName.HEAD = "HEAD";
                        goog.dom.TagName.HEADER = "HEADER";
                        goog.dom.TagName.HGROUP = "HGROUP";
                        goog.dom.TagName.HR = "HR";
                        goog.dom.TagName.HTML = "HTML";
                        goog.dom.TagName.I = "I";
                        goog.dom.TagName.IFRAME = "IFRAME";
                        goog.dom.TagName.IMG = "IMG";
                        goog.dom.TagName.INPUT = "INPUT";
                        goog.dom.TagName.INS = "INS";
                        goog.dom.TagName.ISINDEX = "ISINDEX";
                        goog.dom.TagName.KBD = "KBD";
                        goog.dom.TagName.KEYGEN = "KEYGEN";
                        goog.dom.TagName.LABEL = "LABEL";
                        goog.dom.TagName.LEGEND = "LEGEND";
                        goog.dom.TagName.LI = "LI";
                        goog.dom.TagName.LINK = "LINK";
                        goog.dom.TagName.MAIN = "MAIN";
                        goog.dom.TagName.MAP = "MAP";
                        goog.dom.TagName.MARK = "MARK";
                        goog.dom.TagName.MATH = "MATH";
                        goog.dom.TagName.MENU = "MENU";
                        goog.dom.TagName.MENUITEM = "MENUITEM";
                        goog.dom.TagName.META = "META";
                        goog.dom.TagName.METER = "METER";
                        goog.dom.TagName.NAV = "NAV";
                        goog.dom.TagName.NOFRAMES = "NOFRAMES";
                        goog.dom.TagName.NOSCRIPT = "NOSCRIPT";
                        goog.dom.TagName.OBJECT = "OBJECT";
                        goog.dom.TagName.OL = "OL";
                        goog.dom.TagName.OPTGROUP = "OPTGROUP";
                        goog.dom.TagName.OPTION = "OPTION";
                        goog.dom.TagName.OUTPUT = "OUTPUT";
                        goog.dom.TagName.P = "P";
                        goog.dom.TagName.PARAM = "PARAM";
                        goog.dom.TagName.PICTURE = "PICTURE";
                        goog.dom.TagName.PRE = "PRE";
                        goog.dom.TagName.PROGRESS = "PROGRESS";
                        goog.dom.TagName.Q = "Q";
                        goog.dom.TagName.RP = "RP";
                        goog.dom.TagName.RT = "RT";
                        goog.dom.TagName.RTC = "RTC";
                        goog.dom.TagName.RUBY = "RUBY";
                        goog.dom.TagName.S = "S";
                        goog.dom.TagName.SAMP = "SAMP";
                        goog.dom.TagName.SCRIPT = "SCRIPT";
                        goog.dom.TagName.SECTION = "SECTION";
                        goog.dom.TagName.SELECT = "SELECT";
                        goog.dom.TagName.SMALL = "SMALL";
                        goog.dom.TagName.SOURCE = "SOURCE";
                        goog.dom.TagName.SPAN = "SPAN";
                        goog.dom.TagName.STRIKE = "STRIKE";
                        goog.dom.TagName.STRONG = "STRONG";
                        goog.dom.TagName.STYLE = "STYLE";
                        goog.dom.TagName.SUB = "SUB";
                        goog.dom.TagName.SUMMARY = "SUMMARY";
                        goog.dom.TagName.SUP = "SUP";
                        goog.dom.TagName.SVG = "SVG";
                        goog.dom.TagName.TABLE = "TABLE";
                        goog.dom.TagName.TBODY = "TBODY";
                        goog.dom.TagName.TD = "TD";
                        goog.dom.TagName.TEMPLATE = "TEMPLATE";
                        goog.dom.TagName.TEXTAREA = "TEXTAREA";
                        goog.dom.TagName.TFOOT = "TFOOT";
                        goog.dom.TagName.TH = "TH";
                        goog.dom.TagName.THEAD = "THEAD";
                        goog.dom.TagName.TIME = "TIME";
                        goog.dom.TagName.TITLE = "TITLE";
                        goog.dom.TagName.TR = "TR";
                        goog.dom.TagName.TRACK = "TRACK";
                        goog.dom.TagName.TT = "TT";
                        goog.dom.TagName.U = "U";
                        goog.dom.TagName.UL = "UL";
                        goog.dom.TagName.VAR = "VAR";
                        goog.dom.TagName.VIDEO = "VIDEO";
                        goog.dom.TagName.WBR = "WBR";
                        goog.object = {};
                        goog.object.forEach = function(a, b, c) {
                            for(var d in a)b.call(c, a[d], d, a);
                        };
                        goog.object.filter = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)b.call(c, a[e], e, a) && (d[e] = a[e]);
                            return d;
                        };
                        goog.object.map = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)d[e] = b.call(c, a[e], e, a);
                            return d;
                        };
                        goog.object.some = function(a, b, c) {
                            for(var d in a)if (b.call(c, a[d], d, a)) return !0;
                            return !1;
                        };
                        goog.object.every = function(a, b, c) {
                            for(var d in a)if (!b.call(c, a[d], d, a)) return !1;
                            return !0;
                        };
                        goog.object.getCount = function(a) {
                            var b = 0, c;
                            for(c in a)b++;
                            return b;
                        };
                        goog.object.getAnyKey = function(a) {
                            for(var b in a)return b;
                        };
                        goog.object.getAnyValue = function(a) {
                            for(var b in a)return a[b];
                        };
                        goog.object.contains = function(a, b) {
                            return goog.object.containsValue(a, b);
                        };
                        goog.object.getValues = function(a) {
                            var b = [], c = 0, d;
                            for(d in a)b[c++] = a[d];
                            return b;
                        };
                        goog.object.getKeys = function(a) {
                            var b = [], c = 0, d;
                            for(d in a)b[c++] = d;
                            return b;
                        };
                        goog.object.getValueByKeys = function(a, b) {
                            var c = goog.isArrayLike(b), d = c ? b : arguments;
                            for(c = c ? 0 : 1; c < d.length; c++){
                                if (null == a) return;
                                a = a[d[c]];
                            }
                            return a;
                        };
                        goog.object.containsKey = function(a, b) {
                            return null !== a && b in a;
                        };
                        goog.object.containsValue = function(a, b) {
                            for(var c in a)if (a[c] == b) return !0;
                            return !1;
                        };
                        goog.object.findKey = function(a, b, c) {
                            for(var d in a)if (b.call(c, a[d], d, a)) return d;
                        };
                        goog.object.findValue = function(a, b, c) {
                            return (b = goog.object.findKey(a, b, c)) && a[b];
                        };
                        goog.object.isEmpty = function(a) {
                            for(var b in a)return !1;
                            return !0;
                        };
                        goog.object.clear = function(a) {
                            for(var b in a)delete a[b];
                        };
                        goog.object.remove = function(a, b) {
                            var c;
                            (c = b in a) && delete a[b];
                            return c;
                        };
                        goog.object.add = function(a, b, c) {
                            if (null !== a && b in a) throw Error('The object already contains the key "' + b + '"');
                            goog.object.set(a, b, c);
                        };
                        goog.object.get = function(a, b, c) {
                            return null !== a && b in a ? a[b] : c;
                        };
                        goog.object.set = function(a, b, c) {
                            a[b] = c;
                        };
                        goog.object.setIfUndefined = function(a, b, c) {
                            return b in a ? a[b] : a[b] = c;
                        };
                        goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
                            if (b in a) return a[b];
                            c = c();
                            return a[b] = c;
                        };
                        goog.object.equals = function(a, b) {
                            for(var c in a)if (!(c in b) || a[c] !== b[c]) return !1;
                            for(var d in b)if (!(d in a)) return !1;
                            return !0;
                        };
                        goog.object.clone = function(a) {
                            var b = {}, c;
                            for(c in a)b[c] = a[c];
                            return b;
                        };
                        goog.object.unsafeClone = function(a) {
                            if (!a || "object" !== typeof a) return a;
                            if ("function" === typeof a.clone) return a.clone();
                            var b = Array.isArray(a) ? [] : "function" !== typeof ArrayBuffer || "function" !== typeof ArrayBuffer.isView || !ArrayBuffer.isView(a) || a instanceof DataView ? {} : new a.constructor(a.length), c;
                            for(c in a)b[c] = goog.object.unsafeClone(a[c]);
                            return b;
                        };
                        goog.object.transpose = function(a) {
                            var b = {}, c;
                            for(c in a)b[a[c]] = c;
                            return b;
                        };
                        goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
                        goog.object.extend = function(a, b) {
                            for(var c, d, e = 1; e < arguments.length; e++){
                                d = arguments[e];
                                for(c in d)a[c] = d[c];
                                for(var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++)c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
                            }
                        };
                        goog.object.create = function(a) {
                            var b = arguments.length;
                            if (1 == b && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
                            if (b % 2) throw Error("Uneven number of arguments");
                            for(var c = {}, d = 0; d < b; d += 2)c[arguments[d]] = arguments[d + 1];
                            return c;
                        };
                        goog.object.createSet = function(a) {
                            var b = arguments.length;
                            if (1 == b && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
                            for(var c = {}, d = 0; d < b; d++)c[arguments[d]] = !0;
                            return c;
                        };
                        goog.object.createImmutableView = function(a) {
                            var b = a;
                            Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
                            return b;
                        };
                        goog.object.isImmutableView = function(a) {
                            return !!Object.isFrozen && Object.isFrozen(a);
                        };
                        goog.object.getAllPropertyNames = function(a, b, c) {
                            if (!a) return [];
                            if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(a);
                            for(var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);){
                                for(var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++)d[e[f]] = !0;
                                a = Object.getPrototypeOf(a);
                            }
                            return goog.object.getKeys(d);
                        };
                        goog.object.getSuperClass = function(a) {
                            return (a = Object.getPrototypeOf(a.prototype)) && a.constructor;
                        };
                        goog.dom.tags = {};
                        goog.dom.tags.VOID_TAGS_ = {
                            area: !0,
                            base: !0,
                            br: !0,
                            col: !0,
                            command: !0,
                            embed: !0,
                            hr: !0,
                            img: !0,
                            input: !0,
                            keygen: !0,
                            link: !0,
                            meta: !0,
                            param: !0,
                            source: !0,
                            track: !0,
                            wbr: !0
                        };
                        goog.dom.tags.isVoidTag = function(a) {
                            return !0 === goog.dom.tags.VOID_TAGS_[a];
                        };
                        goog.string = {};
                        goog.string.TypedString = function() {};
                        goog.string.Const = function(a, b) {
                            this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
                            this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
                        };
                        goog.string.Const.prototype.implementsGoogStringTypedString = !0;
                        goog.string.Const.prototype.getTypedStringValue = function() {
                            return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
                        };
                        goog.DEBUG && (goog.string.Const.prototype.toString = function() {
                            return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
                        });
                        goog.string.Const.unwrap = function(a) {
                            if (a instanceof goog.string.Const && a.constructor === goog.string.Const && a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_) return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
                            goog.asserts.fail("expected object of type Const, got '" + a + "'");
                            return "type_error:Const";
                        };
                        goog.string.Const.from = function(a) {
                            return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a);
                        };
                        goog.string.Const.TYPE_MARKER_ = {};
                        goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.string.Const.EMPTY = goog.string.Const.from("");
                        goog.html = {};
                        goog.html.trustedtypes = {};
                        goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse = function() {
                            if (!goog.TRUSTED_TYPES_POLICY_NAME) return null;
                            void 0 === goog.html.trustedtypes.cachedPolicy_ && (goog.html.trustedtypes.cachedPolicy_ = goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html"));
                            return goog.html.trustedtypes.cachedPolicy_;
                        };
                        var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeScript_SafeScript = function(a, b) {
                            this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = b === module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE ? a : "";
                            this.implementsGoogStringTypedString = !0;
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            return 0 === a.length ? module$contents$goog$html$SafeScript_SafeScript.EMPTY : module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs = function(a, b) {
                            for(var c = [], d = 1; d < arguments.length; d++)c.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[d]));
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a) + ")(" + c.join(", ") + ");");
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromJson = function(a) {
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(a));
                        };
                        module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
                        };
                        module$contents$goog$html$SafeScript_SafeScript.unwrap = function(a) {
                            return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(a).toString();
                        };
                        module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript = function(a) {
                            if (a instanceof module$contents$goog$html$SafeScript_SafeScript && a.constructor === module$contents$goog$html$SafeScript_SafeScript) return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;
                            (0, goog.asserts.fail)("expected object of type SafeScript, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeScript";
                        };
                        module$contents$goog$html$SafeScript_SafeScript.stringify_ = function(a) {
                            return JSON.stringify(a).replace(/</g, "\\x3c");
                        };
                        module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(a) {
                            var b = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = b ? b.createScript(a) : a;
                            return new module$contents$goog$html$SafeScript_SafeScript(a, module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE);
                        };
                        goog.DEBUG && (module$contents$goog$html$SafeScript_SafeScript.prototype.toString = function() {
                            return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
                        });
                        module$contents$goog$html$SafeScript_SafeScript.EMPTY = function() {
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
                        }();
                        goog.html.SafeScript = module$contents$goog$html$SafeScript_SafeScript;
                        goog.fs = {};
                        goog.fs.url = {};
                        goog.fs.url.createObjectUrl = function(a) {
                            return goog.fs.url.getUrlObject_().createObjectURL(a);
                        };
                        goog.fs.url.revokeObjectUrl = function(a) {
                            goog.fs.url.getUrlObject_().revokeObjectURL(a);
                        };
                        goog.fs.url.UrlObject_ = function() {};
                        goog.fs.url.UrlObject_.prototype.createObjectURL = function(a) {};
                        goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(a) {};
                        goog.fs.url.getUrlObject_ = function() {
                            var a = goog.fs.url.findUrlObject_();
                            if (null != a) return a;
                            throw Error("This browser doesn't seem to support blob URLs");
                        };
                        goog.fs.url.findUrlObject_ = function() {
                            return void 0 !== goog.global.URL && void 0 !== goog.global.URL.createObjectURL ? goog.global.URL : void 0 !== goog.global.webkitURL && void 0 !== goog.global.webkitURL.createObjectURL ? goog.global.webkitURL : void 0 !== goog.global.createObjectURL ? goog.global : null;
                        };
                        goog.fs.url.browserSupportsObjectUrls = function() {
                            return null != goog.fs.url.findUrlObject_();
                        };
                        goog.fs.blob = {};
                        goog.fs.blob.getBlob = function(a) {
                            var b = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
                            if (void 0 !== b) {
                                b = new b;
                                for(var c = 0; c < arguments.length; c++)b.append(arguments[c]);
                                return b.getBlob();
                            }
                            return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments));
                        };
                        goog.fs.blob.getBlobWithProperties = function(a, b, c) {
                            var d = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
                            if (void 0 !== d) {
                                d = new d;
                                for(var e = 0; e < a.length; e++)d.append(a[e], c);
                                return d.getBlob(b);
                            }
                            if (void 0 !== goog.global.Blob) return d = {}, b && (d.type = b), c && (d.endings = c), new Blob(a, d);
                            throw Error("This browser doesn't seem to support creating Blobs");
                        };
                        goog.i18n = {};
                        goog.i18n.bidi = {};
                        goog.i18n.bidi.FORCE_RTL = !1;
                        goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase());
                        goog.i18n.bidi.Format = {
                            LRE: "\u202a",
                            RLE: "\u202b",
                            PDF: "\u202c",
                            LRM: "\u200e",
                            RLM: "\u200f"
                        };
                        goog.i18n.bidi.Dir = {
                            LTR: 1,
                            RTL: -1,
                            NEUTRAL: 0
                        };
                        goog.i18n.bidi.RIGHT = "right";
                        goog.i18n.bidi.LEFT = "left";
                        goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
                        goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;
                        goog.i18n.bidi.toDir = function(a, b) {
                            return "number" == typeof a ? 0 < a ? goog.i18n.bidi.Dir.LTR : 0 > a ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : null == a ? null : a ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
                        };
                        goog.i18n.bidi.ltrChars_ = "A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0900-\u1fff\u200e\u2c00-\ud801\ud804-\ud839\ud83c-\udbff\uf900-\ufb1c\ufe00-\ufe6f\ufefd-\uffff";
                        goog.i18n.bidi.rtlChars_ = "\u0591-\u06ef\u06fa-\u08ff\u200f\ud802-\ud803\ud83a-\ud83b\ufb1d-\ufdff\ufe70-\ufefc";
                        goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;
                        goog.i18n.bidi.stripHtmlIfNeeded_ = function(a, b) {
                            return b ? a.replace(goog.i18n.bidi.htmlSkipReg_, "") : a;
                        };
                        goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.hasAnyRtl = function(a, b) {
                            return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;
                        goog.i18n.bidi.hasAnyLtr = function(a, b) {
                            return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.isRtlChar = function(a) {
                            return goog.i18n.bidi.rtlRe_.test(a);
                        };
                        goog.i18n.bidi.isLtrChar = function(a) {
                            return goog.i18n.bidi.ltrRe_.test(a);
                        };
                        goog.i18n.bidi.isNeutralChar = function(a) {
                            return !goog.i18n.bidi.isLtrChar(a) && !goog.i18n.bidi.isRtlChar(a);
                        };
                        goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.startsWithRtl = function(a, b) {
                            return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;
                        goog.i18n.bidi.startsWithLtr = function(a, b) {
                            return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
                        goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;
                        goog.i18n.bidi.isNeutralText = function(a, b) {
                            a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b);
                            return goog.i18n.bidi.isRequiredLtrRe_.test(a) || !goog.i18n.bidi.hasAnyLtr(a) && !goog.i18n.bidi.hasAnyRtl(a);
                        };
                        goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$");
                        goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$");
                        goog.i18n.bidi.endsWithLtr = function(a, b) {
                            return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;
                        goog.i18n.bidi.endsWithRtl = function(a, b) {
                            return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
                        goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
                        goog.i18n.bidi.isRtlLanguage = function(a) {
                            return goog.i18n.bidi.rtlLocalesRe_.test(a);
                        };
                        goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
                        goog.i18n.bidi.guardBracketInText = function(a, b) {
                            b = (void 0 === b ? goog.i18n.bidi.hasAnyRtl(a) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
                            return a.replace(goog.i18n.bidi.bracketGuardTextRe_, b + "$&" + b);
                        };
                        goog.i18n.bidi.enforceRtlInHtml = function(a) {
                            return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a + "</span>";
                        };
                        goog.i18n.bidi.enforceRtlInText = function(a) {
                            return goog.i18n.bidi.Format.RLE + a + goog.i18n.bidi.Format.PDF;
                        };
                        goog.i18n.bidi.enforceLtrInHtml = function(a) {
                            return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a + "</span>";
                        };
                        goog.i18n.bidi.enforceLtrInText = function(a) {
                            return goog.i18n.bidi.Format.LRE + a + goog.i18n.bidi.Format.PDF;
                        };
                        goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
                        goog.i18n.bidi.leftRe_ = /left/gi;
                        goog.i18n.bidi.rightRe_ = /right/gi;
                        goog.i18n.bidi.tempRe_ = /%%%%/g;
                        goog.i18n.bidi.mirrorCSS = function(a) {
                            return a.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
                        };
                        goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
                        goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;
                        goog.i18n.bidi.normalizeHebrewQuote = function(a) {
                            return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05f4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05f3");
                        };
                        goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
                        goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
                        goog.i18n.bidi.rtlDetectionThreshold_ = .4;
                        goog.i18n.bidi.estimateDirection = function(a, b) {
                            var c = 0, d = 0, e = !1;
                            a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b).split(goog.i18n.bidi.wordSeparatorRe_);
                            for(b = 0; b < a.length; b++){
                                var f = a[b];
                                goog.i18n.bidi.startsWithRtl(f) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(f) ? e = !0 : goog.i18n.bidi.hasAnyLtr(f) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(f) && (e = !0);
                            }
                            return 0 == d ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
                        };
                        goog.i18n.bidi.detectRtlDirectionality = function(a, b) {
                            return goog.i18n.bidi.estimateDirection(a, b) == goog.i18n.bidi.Dir.RTL;
                        };
                        goog.i18n.bidi.setElementDirAndAlign = function(a, b) {
                            a && (b = goog.i18n.bidi.toDir(b)) && (a.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a.dir = b == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
                        };
                        goog.i18n.bidi.setElementDirByTextDirectionality = function(a, b) {
                            switch(goog.i18n.bidi.estimateDirection(b)){
                                case goog.i18n.bidi.Dir.LTR:
                                    "ltr" !== a.dir && (a.dir = "ltr");
                                    break;
                                case goog.i18n.bidi.Dir.RTL:
                                    "rtl" !== a.dir && (a.dir = "rtl");
                                    break;
                                default:
                                    a.removeAttribute("dir");
                            }
                        };
                        goog.i18n.bidi.DirectionalString = function() {};
                        goog.html.TrustedResourceUrl = function(a, b) {
                            this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = b === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0;
                        goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
                        };
                        goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.TrustedResourceUrl.prototype.getDirection = function() {
                            return goog.i18n.bidi.Dir.LTR;
                        };
                        goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(a, b) {
                            var c = goog.html.TrustedResourceUrl.unwrap(this);
                            c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
                            var d = c[3] || "";
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c[2] || "", a) + goog.html.TrustedResourceUrl.stringifyParams_("#", d, b));
                        };
                        goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
                            return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
                        });
                        goog.html.TrustedResourceUrl.unwrap = function(a) {
                            return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString();
                        };
                        goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(a) {
                            if (a instanceof goog.html.TrustedResourceUrl && a.constructor === goog.html.TrustedResourceUrl) return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
                            goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:TrustedResourceUrl";
                        };
                        goog.html.TrustedResourceUrl.format = function(a, b) {
                            var c = goog.string.Const.unwrap(a);
                            if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
                            a = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(d, e) {
                                if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
                                d = b[e];
                                return d instanceof goog.string.Const ? goog.string.Const.unwrap(d) : encodeURIComponent(String(d));
                            });
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
                        goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;
                        goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
                        goog.html.TrustedResourceUrl.formatWithParams = function(a, b, c, d) {
                            return goog.html.TrustedResourceUrl.format(a, b).cloneWithParams(c, d);
                        };
                        goog.html.TrustedResourceUrl.fromConstant = function(a) {
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
                        };
                        goog.html.TrustedResourceUrl.fromConstants = function(a) {
                            for(var b = "", c = 0; c < a.length; c++)b += goog.string.Const.unwrap(a[c]);
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.TrustedResourceUrl.fromSafeScript = function(a) {
                            a = goog.fs.blob.getBlobWithProperties([
                                module$contents$goog$html$SafeScript_SafeScript.unwrap(a)
                            ], "text/javascript");
                            a = goog.fs.url.createObjectUrl(a);
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(a) {
                            var b = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = b ? b.createScriptURL(a) : a;
                            return new goog.html.TrustedResourceUrl(a, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.TrustedResourceUrl.stringifyParams_ = function(a, b, c) {
                            if (null == c) return b;
                            if ("string" === typeof c) return c ? a + encodeURIComponent(c) : "";
                            for(var d in c)if (Object.prototype.hasOwnProperty.call(c, d)) {
                                var e = c[d];
                                e = Array.isArray(e) ? e : [
                                    e
                                ];
                                for(var f = 0; f < e.length; f++){
                                    var g = e[f];
                                    null != g && (b || (b = a), b += (b.length > a.length ? "&" : "") + encodeURIComponent(d) + "=" + encodeURIComponent(String(g)));
                                }
                            }
                            return b;
                        };
                        goog.string.internal = {};
                        goog.string.internal.startsWith = function(a, b) {
                            return 0 == a.lastIndexOf(b, 0);
                        };
                        goog.string.internal.endsWith = function(a, b) {
                            var c = a.length - b.length;
                            return 0 <= c && a.indexOf(b, c) == c;
                        };
                        goog.string.internal.caseInsensitiveStartsWith = function(a, b) {
                            return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(0, b.length));
                        };
                        goog.string.internal.caseInsensitiveEndsWith = function(a, b) {
                            return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
                        };
                        goog.string.internal.caseInsensitiveEquals = function(a, b) {
                            return a.toLowerCase() == b.toLowerCase();
                        };
                        goog.string.internal.isEmptyOrWhitespace = function(a) {
                            return /^[\s\xa0]*$/.test(a);
                        };
                        goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a) {
                            return a.trim();
                        } : function(a) {
                            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
                        };
                        goog.string.internal.caseInsensitiveCompare = function(a, b) {
                            a = String(a).toLowerCase();
                            b = String(b).toLowerCase();
                            return a < b ? -1 : a == b ? 0 : 1;
                        };
                        goog.string.internal.newLineToBr = function(a, b) {
                            return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
                        };
                        goog.string.internal.htmlEscape = function(a, b) {
                            if (b) a = a.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
                            else {
                                if (!goog.string.internal.ALL_RE_.test(a)) return a;
                                -1 != a.indexOf("&") && (a = a.replace(goog.string.internal.AMP_RE_, "&amp;"));
                                -1 != a.indexOf("<") && (a = a.replace(goog.string.internal.LT_RE_, "&lt;"));
                                -1 != a.indexOf(">") && (a = a.replace(goog.string.internal.GT_RE_, "&gt;"));
                                -1 != a.indexOf('"') && (a = a.replace(goog.string.internal.QUOT_RE_, "&quot;"));
                                -1 != a.indexOf("'") && (a = a.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
                                -1 != a.indexOf("\x00") && (a = a.replace(goog.string.internal.NULL_RE_, "&#0;"));
                            }
                            return a;
                        };
                        goog.string.internal.AMP_RE_ = /&/g;
                        goog.string.internal.LT_RE_ = /</g;
                        goog.string.internal.GT_RE_ = />/g;
                        goog.string.internal.QUOT_RE_ = /"/g;
                        goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
                        goog.string.internal.NULL_RE_ = /\x00/g;
                        goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
                        goog.string.internal.whitespaceEscape = function(a, b) {
                            return goog.string.internal.newLineToBr(a.replace(/  /g, " &#160;"), b);
                        };
                        goog.string.internal.contains = function(a, b) {
                            return -1 != a.indexOf(b);
                        };
                        goog.string.internal.caseInsensitiveContains = function(a, b) {
                            return goog.string.internal.contains(a.toLowerCase(), b.toLowerCase());
                        };
                        goog.string.internal.compareVersions = function(a, b) {
                            var c = 0;
                            a = goog.string.internal.trim(String(a)).split(".");
                            b = goog.string.internal.trim(String(b)).split(".");
                            for(var d = Math.max(a.length, b.length), e = 0; 0 == c && e < d; e++){
                                var f = a[e] || "", g = b[e] || "";
                                do {
                                    f = /(\d*)(\D*)(.*)/.exec(f) || [
                                        "",
                                        "",
                                        "",
                                        ""
                                    ];
                                    g = /(\d*)(\D*)(.*)/.exec(g) || [
                                        "",
                                        "",
                                        "",
                                        ""
                                    ];
                                    if (0 == f[0].length && 0 == g[0].length) break;
                                    c = 0 == f[1].length ? 0 : parseInt(f[1], 10);
                                    var h = 0 == g[1].length ? 0 : parseInt(g[1], 10);
                                    c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(0 == f[2].length, 0 == g[2].length) || goog.string.internal.compareElements_(f[2], g[2]);
                                    f = f[3];
                                    g = g[3];
                                }while (0 == c);
                            }
                            return c;
                        };
                        goog.string.internal.compareElements_ = function(a, b) {
                            return a < b ? -1 : a > b ? 1 : 0;
                        };
                        goog.html.SafeUrl = function(a, b) {
                            this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = b === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez";
                        goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeUrl.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
                        };
                        goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.SafeUrl.prototype.getDirection = function() {
                            return goog.i18n.bidi.Dir.LTR;
                        };
                        goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
                            return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
                        });
                        goog.html.SafeUrl.unwrap = function(a) {
                            if (a instanceof goog.html.SafeUrl && a.constructor === goog.html.SafeUrl) return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;
                            goog.asserts.fail("expected object of type SafeUrl, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeUrl";
                        };
                        goog.html.SafeUrl.fromConstant = function(a) {
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
                        };
                        goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i;
                        goog.html.SafeUrl.isSafeMimeType = function(a) {
                            return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a);
                        };
                        goog.html.SafeUrl.fromBlob = function(a) {
                            a = goog.html.SafeUrl.isSafeMimeType(a.type) ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.revokeObjectUrl = function(a) {
                            a = a.getTypedStringValue();
                            a !== goog.html.SafeUrl.INNOCUOUS_STRING && goog.fs.url.revokeObjectUrl(a);
                        };
                        goog.html.SafeUrl.fromMediaSource = function(a) {
                            goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource");
                            a = a instanceof MediaSource ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i;
                        goog.html.SafeUrl.tryFromDataUrl = function(a) {
                            a = String(a);
                            a = a.replace(/(%0A|%0D)/g, "");
                            var b = a.match(goog.html.DATA_URL_PATTERN_);
                            return b && goog.html.SafeUrl.isSafeMimeType(b[1]) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a) : null;
                        };
                        goog.html.SafeUrl.fromDataUrl = function(a) {
                            return goog.html.SafeUrl.tryFromDataUrl(a) || goog.html.SafeUrl.INNOCUOUS_URL;
                        };
                        goog.html.SafeUrl.fromTelUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "tel:") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;
                        goog.html.SafeUrl.fromSipUrl = function(a) {
                            goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a)) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromFacebookMessengerUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "fb-messenger://share") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromWhatsAppUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "whatsapp://send") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromSmsUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.isSmsUrlBodyValid_ = function(a) {
                            var b = a.indexOf("#");
                            0 < b && (a = a.substring(0, b));
                            b = a.match(/[?&]body=/gi);
                            if (!b) return !0;
                            if (1 < b.length) return !1;
                            a = a.match(/[?&]body=([^&]*)/)[1];
                            if (!a) return !0;
                            try {
                                decodeURIComponent(a);
                            } catch (c) {
                                return !1;
                            }
                            return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a);
                        };
                        goog.html.SafeUrl.fromSshUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "ssh://") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeExtensionUrl_ = function(a, b, c) {
                            (a = a.exec(b)) ? (a = a[1], -1 == (c instanceof goog.string.Const ? [
                                goog.string.Const.unwrap(c)
                            ] : c.map(function(d) {
                                return goog.string.Const.unwrap(d);
                            })).indexOf(a) && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.SafeUrl.fromTrustedResourceUrl = function(a) {
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a));
                        };
                        goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
                        goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;
                        goog.html.SafeUrl.trySanitize = function(a) {
                            if (a instanceof goog.html.SafeUrl) return a;
                            a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            return goog.html.SAFE_URL_PATTERN_.test(a) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a) : goog.html.SafeUrl.tryFromDataUrl(a);
                        };
                        goog.html.SafeUrl.sanitize = function(a) {
                            return goog.html.SafeUrl.trySanitize(a) || goog.html.SafeUrl.INNOCUOUS_URL;
                        };
                        goog.html.SafeUrl.sanitizeAssertUnchanged = function(a, b) {
                            if (a instanceof goog.html.SafeUrl) return a;
                            a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            if (b && /^data:/i.test(a) && (b = goog.html.SafeUrl.fromDataUrl(a), b.getTypedStringValue() == a)) return b;
                            goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a), "%s does not match the safe URL pattern", a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new goog.html.SafeUrl(a, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeUrl.INNOCUOUS_URL = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING);
                        goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");
                        goog.html.SafeStyle = function(a, b) {
                            this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = b === goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeStyle.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            if (0 === a.length) return goog.html.SafeStyle.EMPTY;
                            goog.asserts.assert(goog.string.internal.endsWith(a, ";"), "Last character of style string is not ';': " + a);
                            goog.asserts.assert(goog.string.internal.contains(a, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + a);
                            return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeStyle.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
                        };
                        goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
                            return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
                        });
                        goog.html.SafeStyle.unwrap = function(a) {
                            if (a instanceof goog.html.SafeStyle && a.constructor === goog.html.SafeStyle) return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;
                            goog.asserts.fail("expected object of type SafeStyle, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeStyle";
                        };
                        goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new goog.html.SafeStyle(a, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");
                        goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez";
                        goog.html.SafeStyle.create = function(a) {
                            var b = "", c;
                            for(c in a)if (Object.prototype.hasOwnProperty.call(a, c)) {
                                if (!/^[-_a-zA-Z0-9]+$/.test(c)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + c);
                                var d = a[c];
                                null != d && (d = Array.isArray(d) ? module$contents$goog$array_map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ":" + d + ";");
                            }
                            return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
                        };
                        goog.html.SafeStyle.sanitizePropertyValue_ = function(a) {
                            if (a instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(a).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
                            a = a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a));
                            if (/[{;}]/.test(a)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [
                                a
                            ]);
                            return a;
                        };
                        goog.html.SafeStyle.sanitizePropertyValueString_ = function(a) {
                            var b = a.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
                            if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
                                if (goog.html.SafeStyle.COMMENT_RE_.test(a)) return goog.asserts.fail("String value disallows comments, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                                if (!goog.html.SafeStyle.hasBalancedQuotes_(a)) return goog.asserts.fail("String value requires balanced quotes, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                                if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                            } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                            return goog.html.SafeStyle.sanitizeUrl_(a);
                        };
                        goog.html.SafeStyle.hasBalancedQuotes_ = function(a) {
                            for(var b = !0, c = !0, d = 0; d < a.length; d++){
                                var e = a.charAt(d);
                                "'" == e && c ? b = !b : '"' == e && b && (c = !c);
                            }
                            return b && c;
                        };
                        goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(a) {
                            for(var b = !0, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a.length; d++){
                                var e = a.charAt(d);
                                if ("]" == e) {
                                    if (b) return !1;
                                    b = !0;
                                } else if ("[" == e) {
                                    if (!b) return !1;
                                    b = !1;
                                } else if (!b && !c.test(e)) return !1;
                            }
                            return b;
                        };
                        goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
                        goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$");
                        goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;
                        goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" ");
                        goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g");
                        goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;
                        goog.html.SafeStyle.sanitizeUrl_ = function(a) {
                            return a.replace(goog.html.SafeStyle.URL_RE_, function(b, c, d, e) {
                                var f = "";
                                d = d.replace(/^(['"])(.*)\1$/, function(g, h, k) {
                                    f = h;
                                    return k;
                                });
                                b = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
                                return c + f + b + f + e;
                            });
                        };
                        goog.html.SafeStyle.concat = function(a) {
                            var b = "", c = function(d) {
                                Array.isArray(d) ? module$contents$goog$array_forEach(d, c) : b += goog.html.SafeStyle.unwrap(d);
                            };
                            module$contents$goog$array_forEach(arguments, c);
                            return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
                        };
                        var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet = function(a, b) {
                            this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = b === module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE ? a : "";
                            this.implementsGoogStringTypedString = !0;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule = function(a, b) {
                            if ((0, goog.string.internal.contains)(a, "<")) throw Error("Selector does not allow '<', got: " + a);
                            var c = a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
                            if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a);
                            if (!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(c)) throw Error("() and [] in selector must be balanced, got: " + a);
                            b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
                            a = a + "{" + goog.html.SafeStyle.unwrap(b).replace(/</g, "\\3C ") + "}";
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_ = function(a) {
                            for(var b = {
                                "(": ")",
                                "[": "]"
                            }, c = [], d = 0; d < a.length; d++){
                                var e = a[d];
                                if (b[e]) c.push(b[e]);
                                else if (goog.object.contains(b, e) && c.pop() != e) return !1;
                            }
                            return 0 == c.length;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat = function(a) {
                            var b = "", c = function(d) {
                                Array.isArray(d) ? module$contents$goog$array_forEach(d, c) : b += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(d);
                            };
                            module$contents$goog$array_forEach(arguments, c);
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            if (0 === a.length) return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY;
                            (0, goog.asserts.assert)(!(0, goog.string.internal.contains)(a, "<"), "Forbidden '<' character in style sheet string: " + a);
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap = function(a) {
                            if (a instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet && a.constructor === module$contents$goog$html$SafeStyleSheet_SafeStyleSheet) return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
                            (0, goog.asserts.fail)("expected object of type SafeStyleSheet, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeStyleSheet";
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(a, module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE);
                        };
                        goog.DEBUG && (module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString = function() {
                            return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
                        });
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");
                        goog.html.SafeStyleSheet = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet;
                        goog.labs = {};
                        goog.labs.userAgent = {};
                        goog.labs.userAgent.util = {};
                        goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
                            var a = goog.labs.userAgent.util.getNavigator_();
                            return a && (a = a.userAgent) ? a : "";
                        };
                        goog.labs.userAgent.util.getNavigator_ = function() {
                            return goog.global.navigator;
                        };
                        goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();
                        goog.labs.userAgent.util.setUserAgent = function(a) {
                            goog.labs.userAgent.util.userAgent_ = a || goog.labs.userAgent.util.getNativeUserAgentString_();
                        };
                        goog.labs.userAgent.util.getUserAgent = function() {
                            return goog.labs.userAgent.util.userAgent_;
                        };
                        goog.labs.userAgent.util.matchUserAgent = function(a) {
                            var b = goog.labs.userAgent.util.getUserAgent();
                            return goog.string.internal.contains(b, a);
                        };
                        goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(a) {
                            var b = goog.labs.userAgent.util.getUserAgent();
                            return goog.string.internal.caseInsensitiveContains(b, a);
                        };
                        goog.labs.userAgent.util.extractVersionTuples = function(a) {
                            for(var b = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c = [], d; d = b.exec(a);)c.push([
                                d[1],
                                d[2],
                                d[3] || void 0
                            ]);
                            return c;
                        };
                        goog.labs.userAgent.browser = {};
                        goog.labs.userAgent.browser.matchOpera_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Opera");
                        };
                        goog.labs.userAgent.browser.matchIE_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
                        };
                        goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Edge");
                        };
                        goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Edg/");
                        };
                        goog.labs.userAgent.browser.matchOperaChromium_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("OPR");
                        };
                        goog.labs.userAgent.browser.matchFirefox_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
                        };
                        goog.labs.userAgent.browser.matchSafari_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
                        };
                        goog.labs.userAgent.browser.matchCoast_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Coast");
                        };
                        goog.labs.userAgent.browser.matchIosWebview_ = function() {
                            return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
                        };
                        goog.labs.userAgent.browser.matchChrome_ = function() {
                            return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
                        };
                        goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
                        };
                        goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
                        goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
                        goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
                        goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
                        goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
                        goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
                        goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
                        goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
                        goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
                        goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
                        goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;
                        goog.labs.userAgent.browser.isSilk = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Silk");
                        };
                        goog.labs.userAgent.browser.getVersion = function() {
                            function a(e) {
                                e = module$contents$goog$array_find(e, d);
                                return c[e] || "";
                            }
                            var b = goog.labs.userAgent.util.getUserAgent();
                            if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(b);
                            b = goog.labs.userAgent.util.extractVersionTuples(b);
                            var c = {};
                            module$contents$goog$array_forEach(b, function(e) {
                                c[e[0]] = e[1];
                            });
                            var d = goog.partial(goog.object.containsKey, c);
                            return goog.labs.userAgent.browser.isOpera() ? a([
                                "Version",
                                "Opera"
                            ]) : goog.labs.userAgent.browser.isEdge() ? a([
                                "Edge"
                            ]) : goog.labs.userAgent.browser.isEdgeChromium() ? a([
                                "Edg"
                            ]) : goog.labs.userAgent.browser.isChrome() ? a([
                                "Chrome",
                                "CriOS",
                                "HeadlessChrome"
                            ]) : (b = b[2]) && b[1] || "";
                        };
                        goog.labs.userAgent.browser.isVersionOrHigher = function(a) {
                            return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a);
                        };
                        goog.labs.userAgent.browser.getIEVersion_ = function(a) {
                            var b = /rv: *([\d\.]*)/.exec(a);
                            if (b && b[1]) return b[1];
                            b = "";
                            var c = /MSIE +([\d\.]+)/.exec(a);
                            if (c && c[1]) {
                                if (a = /Trident\/(\d.\d)/.exec(a), "7.0" == c[1]) {
                                    if (a && a[1]) switch(a[1]){
                                        case "4.0":
                                            b = "8.0";
                                            break;
                                        case "5.0":
                                            b = "9.0";
                                            break;
                                        case "6.0":
                                            b = "10.0";
                                            break;
                                        case "7.0":
                                            b = "11.0";
                                    }
                                    else b = "7.0";
                                } else b = c[1];
                            }
                            return b;
                        };
                        goog.html.SafeHtml = function(a, b, c) {
                            this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = c === goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                            this.dir_ = b;
                        };
                        goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG;
                        goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0;
                        goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.SafeHtml.prototype.getDirection = function() {
                            return this.dir_;
                        };
                        goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeHtml.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
                        };
                        goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
                            return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
                        });
                        goog.html.SafeHtml.unwrap = function(a) {
                            return goog.html.SafeHtml.unwrapTrustedHTML(a).toString();
                        };
                        goog.html.SafeHtml.unwrapTrustedHTML = function(a) {
                            if (a instanceof goog.html.SafeHtml && a.constructor === goog.html.SafeHtml) return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
                            goog.asserts.fail("expected object of type SafeHtml, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeHtml";
                        };
                        goog.html.SafeHtml.htmlEscape = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            var b = "object" == typeof a, c = null;
                            b && a.implementsGoogI18nBidiDirectionalString && (c = a.getDirection());
                            a = b && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a), c);
                        };
                        goog.html.SafeHtml.htmlEscapePreservingNewlines = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            a = goog.html.SafeHtml.htmlEscape(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)), a.getDirection());
                        };
                        goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            a = goog.html.SafeHtml.htmlEscape(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)), a.getDirection());
                        };
                        goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
                        goog.html.SafeHtml.comment = function(a) {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("\x3c!--" + goog.string.internal.htmlEscape(a) + "--\x3e", null);
                        };
                        goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
                        goog.html.SafeHtml.URL_ATTRIBUTES_ = {
                            action: !0,
                            cite: !0,
                            data: !0,
                            formaction: !0,
                            href: !0,
                            manifest: !0,
                            poster: !0,
                            src: !0
                        };
                        goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = goog.object.createSet(goog.dom.TagName.APPLET, goog.dom.TagName.BASE, goog.dom.TagName.EMBED, goog.dom.TagName.IFRAME, goog.dom.TagName.LINK, goog.dom.TagName.MATH, goog.dom.TagName.META, goog.dom.TagName.OBJECT, goog.dom.TagName.SCRIPT, goog.dom.TagName.STYLE, goog.dom.TagName.SVG, goog.dom.TagName.TEMPLATE);
                        goog.html.SafeHtml.create = function(a, b, c) {
                            goog.html.SafeHtml.verifyTagName(String(a));
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a), b, c);
                        };
                        goog.html.SafeHtml.verifyTagName = function(a) {
                            if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + a + ">." : "");
                            if (a.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + a + "> is not allowed for SafeHtml." : "");
                        };
                        goog.html.SafeHtml.createIframe = function(a, b, c, d) {
                            a && goog.html.TrustedResourceUrl.unwrap(a);
                            var e = {};
                            e.src = a || null;
                            e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
                            a = goog.html.SafeHtml.combineAttributes(e, {
                                sandbox: ""
                            }, c);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
                        };
                        goog.html.SafeHtml.createSandboxIframe = function(a, b, c, d) {
                            if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
                            var e = {};
                            e.src = a ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)) : null;
                            e.srcdoc = b || null;
                            e.sandbox = "";
                            a = goog.html.SafeHtml.combineAttributes(e, {}, c);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
                        };
                        goog.html.SafeHtml.canUseSandboxIframe = function() {
                            return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
                        };
                        goog.html.SafeHtml.createScriptSrc = function(a, b) {
                            goog.html.TrustedResourceUrl.unwrap(a);
                            a = goog.html.SafeHtml.combineAttributes({
                                src: a
                            }, {}, b);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", a);
                        };
                        goog.html.SafeHtml.createScript = function(a, b) {
                            for(var c in b)if (Object.prototype.hasOwnProperty.call(b, c)) {
                                var d = c.toLowerCase();
                                if ("language" == d || "src" == d || "text" == d || "type" == d) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + d + '" attribute' : "");
                            }
                            c = "";
                            a = module$contents$goog$array_concat(a);
                            for(d = 0; d < a.length; d++)c += module$contents$goog$html$SafeScript_SafeScript.unwrap(a[d]);
                            a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b, a);
                        };
                        goog.html.SafeHtml.createStyle = function(a, b) {
                            b = goog.html.SafeHtml.combineAttributes({
                                type: "text/css"
                            }, {}, b);
                            var c = "";
                            a = module$contents$goog$array_concat(a);
                            for(var d = 0; d < a.length; d++)c += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(a[d]);
                            a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", b, a);
                        };
                        goog.html.SafeHtml.createMetaRefresh = function(a, b) {
                            a = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));
                            (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'");
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
                                "http-equiv": "refresh",
                                content: (b || 0) + "; url=" + a
                            });
                        };
                        goog.html.SafeHtml.getAttrNameAndValue_ = function(a, b, c) {
                            if (c instanceof goog.string.Const) c = goog.string.Const.unwrap(c);
                            else if ("style" == b.toLowerCase()) {
                                if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) c = goog.html.SafeHtml.getStyleValue_(c);
                                else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
                            } else {
                                if (/^on/i.test(b)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.' : "");
                                if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) {
                                    if (c instanceof goog.html.TrustedResourceUrl) c = goog.html.TrustedResourceUrl.unwrap(c);
                                    else if (c instanceof goog.html.SafeUrl) c = goog.html.SafeUrl.unwrap(c);
                                    else if ("string" === typeof c) c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();
                                    else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" on tag "' + a + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.' : "");
                                }
                            }
                            c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
                            goog.asserts.assert("string" === typeof c || "number" === typeof c, "String or number value expected, got " + typeof c + " with value: " + c);
                            return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
                        };
                        goog.html.SafeHtml.getStyleValue_ = function(a) {
                            if (!goog.isObject(a)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a + " given: " + a : "");
                            a instanceof goog.html.SafeStyle || (a = goog.html.SafeStyle.create(a));
                            return goog.html.SafeStyle.unwrap(a);
                        };
                        goog.html.SafeHtml.createWithDir = function(a, b, c, d) {
                            b = goog.html.SafeHtml.create(b, c, d);
                            b.dir_ = a;
                            return b;
                        };
                        goog.html.SafeHtml.join = function(a, b) {
                            a = goog.html.SafeHtml.htmlEscape(a);
                            var c = a.getDirection(), d = [], e = function(f) {
                                Array.isArray(f) ? module$contents$goog$array_forEach(f, e) : (f = goog.html.SafeHtml.htmlEscape(f), d.push(goog.html.SafeHtml.unwrap(f)), f = f.getDirection(), c == goog.i18n.bidi.Dir.NEUTRAL ? c = f : f != goog.i18n.bidi.Dir.NEUTRAL && c != f && (c = null));
                            };
                            module$contents$goog$array_forEach(b, e);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)), c);
                        };
                        goog.html.SafeHtml.concat = function(a) {
                            return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
                        };
                        goog.html.SafeHtml.concatWithDir = function(a, b) {
                            var c = goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments, 1));
                            c.dir_ = a;
                            return c;
                        };
                        goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(a, b) {
                            var c = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = c ? c.createHTML(a) : a;
                            return new goog.html.SafeHtml(a, b, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(a, b, c) {
                            var d = null;
                            var e = "<" + a + goog.html.SafeHtml.stringifyAttributes(a, b);
                            null == c ? c = [] : Array.isArray(c) || (c = [
                                c
                            ]);
                            goog.dom.tags.isVoidTag(a.toLowerCase()) ? (goog.asserts.assert(!c.length, "Void tag <" + a + "> does not allow content."), e += ">") : (d = goog.html.SafeHtml.concat(c), e += ">" + goog.html.SafeHtml.unwrap(d) + "</" + a + ">", d = d.getDirection());
                            (a = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a) ? goog.i18n.bidi.Dir.NEUTRAL : null);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
                        };
                        goog.html.SafeHtml.stringifyAttributes = function(a, b) {
                            var c = "";
                            if (b) {
                                for(var d in b)if (Object.prototype.hasOwnProperty.call(b, d)) {
                                    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + d + '".' : "");
                                    var e = b[d];
                                    null != e && (c += " " + goog.html.SafeHtml.getAttrNameAndValue_(a, d, e));
                                }
                            }
                            return c;
                        };
                        goog.html.SafeHtml.combineAttributes = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)Object.prototype.hasOwnProperty.call(a, e) && (goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = a[e]);
                            for(e in b)Object.prototype.hasOwnProperty.call(b, e) && (goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = b[e]);
                            if (c) {
                                for(e in c)if (Object.prototype.hasOwnProperty.call(c, e)) {
                                    var f = e.toLowerCase();
                                    if (f in a) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"' : "");
                                    f in b && delete d[f];
                                    d[e] = c[e];
                                }
                            }
                            return d;
                        };
                        goog.html.SafeHtml.DOCTYPE_HTML = function() {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
                        }();
                        goog.html.SafeHtml.EMPTY = new goog.html.SafeHtml(goog.global.trustedTypes && goog.global.trustedTypes.emptyHTML || "", goog.i18n.bidi.Dir.NEUTRAL, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
                        goog.html.SafeHtml.BR = function() {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
                        }();
                        goog.html.uncheckedconversions = {};
                        goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(a, b, c) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
                        };
                        goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.dom.safe = {};
                        goog.dom.safe.InsertAdjacentHtmlPosition = {
                            AFTERBEGIN: "afterbegin",
                            AFTEREND: "afterend",
                            BEFOREBEGIN: "beforebegin",
                            BEFOREEND: "beforeend"
                        };
                        goog.dom.safe.insertAdjacentHtml = function(a, b, c) {
                            a.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
                        };
                        goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
                            MATH: !0,
                            SCRIPT: !0,
                            STYLE: !0,
                            SVG: !0,
                            TEMPLATE: !0
                        };
                        goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
                            if (goog.DEBUG && "undefined" === typeof document) return !1;
                            var a = document.createElement("div"), b = document.createElement("div");
                            b.appendChild(document.createElement("div"));
                            a.appendChild(b);
                            if (goog.DEBUG && !a.firstChild) return !1;
                            b = a.firstChild.firstChild;
                            a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
                            return !b.parentElement;
                        });
                        goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(a, b) {
                            if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for(; a.lastChild;)a.removeChild(a.lastChild);
                            a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setInnerHtml = function(a, b) {
                            if (goog.asserts.ENABLE_ASSERTS && a.tagName) {
                                var c = a.tagName.toUpperCase();
                                if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a.tagName + ".");
                            }
                            goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a, b);
                        };
                        goog.dom.safe.setInnerHtmlFromConstant = function(a, b) {
                            goog.dom.safe.setInnerHtml(a, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."), goog.string.Const.unwrap(b)));
                        };
                        goog.dom.safe.setOuterHtml = function(a, b) {
                            a.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setFormElementAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLFormElement(a).action = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setButtonFormAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLButtonElement(a).formAction = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setInputFormAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLInputElement(a).formAction = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setStyle = function(a, b) {
                            a.style.cssText = goog.html.SafeStyle.unwrap(b);
                        };
                        goog.dom.safe.documentWrite = function(a, b) {
                            a.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
                        };
                        goog.dom.safe.setAnchorHref = function(a, b) {
                            goog.dom.asserts.assertIsHTMLAnchorElement(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.href = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setImageSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLImageElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:image\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setAudioSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLAudioElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:audio\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setVideoSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLVideoElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:video\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setEmbedSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLEmbedElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                        };
                        goog.dom.safe.setFrameSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLFrameElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrap(b);
                        };
                        goog.dom.safe.setIframeSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLIFrameElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrap(b);
                        };
                        goog.dom.safe.setIframeSrcdoc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLIFrameElement(a);
                            a.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setLinkHrefAndRel = function(a, b, c) {
                            goog.dom.asserts.assertIsHTMLLinkElement(a);
                            a.rel = c;
                            goog.string.internal.caseInsensitiveContains(c, "stylesheet") ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a.href = goog.html.TrustedResourceUrl.unwrap(b)) : a.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(b) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
                        };
                        goog.dom.safe.setObjectData = function(a, b) {
                            goog.dom.asserts.assertIsHTMLObjectElement(a);
                            a.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                        };
                        goog.dom.safe.setScriptSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLScriptElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                            goog.dom.safe.setNonceForScriptElement_(a);
                        };
                        goog.dom.safe.setScriptContent = function(a, b) {
                            goog.dom.asserts.assertIsHTMLScriptElement(a);
                            a.textContent = module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(b);
                            goog.dom.safe.setNonceForScriptElement_(a);
                        };
                        goog.dom.safe.setNonceForScriptElement_ = function(a) {
                            var b = goog.getScriptNonce(a.ownerDocument && a.ownerDocument.defaultView);
                            b && a.setAttribute("nonce", b);
                        };
                        goog.dom.safe.setLocationHref = function(a, b) {
                            goog.dom.asserts.assertIsLocation(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.href = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.assignLocation = function(a, b) {
                            goog.dom.asserts.assertIsLocation(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.assign(goog.html.SafeUrl.unwrap(b));
                        };
                        goog.dom.safe.replaceLocation = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.replace(goog.html.SafeUrl.unwrap(b));
                        };
                        goog.dom.safe.openInWindow = function(a, b, c, d, e) {
                            a = a instanceof goog.html.SafeUrl ? a : goog.html.SafeUrl.sanitizeAssertUnchanged(a);
                            b = b || goog.global;
                            c = c instanceof goog.string.Const ? goog.string.Const.unwrap(c) : c || "";
                            return b.open(goog.html.SafeUrl.unwrap(a), c, d, e);
                        };
                        goog.dom.safe.parseFromStringHtml = function(a, b) {
                            return goog.dom.safe.parseFromString(a, b, "text/html");
                        };
                        goog.dom.safe.parseFromString = function(a, b, c) {
                            return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
                        };
                        goog.dom.safe.createImageFromBlob = function(a) {
                            if (!/^image\/.*/g.test(a.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
                            var b = goog.global.URL.createObjectURL(a);
                            a = new goog.global.Image;
                            a.onload = function() {
                                goog.global.URL.revokeObjectURL(b);
                            };
                            goog.dom.safe.setImageSrc(a, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b));
                            return a;
                        };
                        goog.string.DETECT_DOUBLE_ESCAPING = !1;
                        goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
                        goog.string.Unicode = {
                            NBSP: "\u00a0"
                        };
                        goog.string.startsWith = goog.string.internal.startsWith;
                        goog.string.endsWith = goog.string.internal.endsWith;
                        goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
                        goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
                        goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;
                        goog.string.subs = function(a, b) {
                            for(var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)d += c.shift() + e.shift();
                            return d + c.join("%s");
                        };
                        goog.string.collapseWhitespace = function(a) {
                            return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
                        };
                        goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;
                        goog.string.isEmptyString = function(a) {
                            return 0 == a.length;
                        };
                        goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
                        goog.string.isEmptyOrWhitespaceSafe = function(a) {
                            return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
                        };
                        goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
                        goog.string.isBreakingWhitespace = function(a) {
                            return !/[^\t\n\r ]/.test(a);
                        };
                        goog.string.isAlpha = function(a) {
                            return !/[^a-zA-Z]/.test(a);
                        };
                        goog.string.isNumeric = function(a) {
                            return !/[^0-9]/.test(a);
                        };
                        goog.string.isAlphaNumeric = function(a) {
                            return !/[^a-zA-Z0-9]/.test(a);
                        };
                        goog.string.isSpace = function(a) {
                            return " " == a;
                        };
                        goog.string.isUnicodeChar = function(a) {
                            return 1 == a.length && " " <= a && "~" >= a || "\u0080" <= a && "\ufffd" >= a;
                        };
                        goog.string.stripNewlines = function(a) {
                            return a.replace(/(\r\n|\r|\n)+/g, " ");
                        };
                        goog.string.canonicalizeNewlines = function(a) {
                            return a.replace(/(\r\n|\r|\n)/g, "\n");
                        };
                        goog.string.normalizeWhitespace = function(a) {
                            return a.replace(/\xa0|\s/g, " ");
                        };
                        goog.string.normalizeSpaces = function(a) {
                            return a.replace(/\xa0|[ \t]+/g, " ");
                        };
                        goog.string.collapseBreakingSpaces = function(a) {
                            return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
                        };
                        goog.string.trim = goog.string.internal.trim;
                        goog.string.trimLeft = function(a) {
                            return a.replace(/^[\s\xa0]+/, "");
                        };
                        goog.string.trimRight = function(a) {
                            return a.replace(/[\s\xa0]+$/, "");
                        };
                        goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;
                        goog.string.numberAwareCompare_ = function(a, b, c) {
                            if (a == b) return 0;
                            if (!a) return -1;
                            if (!b) return 1;
                            for(var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++){
                                c = d[g];
                                var h = e[g];
                                if (c != h) return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
                            }
                            return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
                        };
                        goog.string.intAwareCompare = function(a, b) {
                            return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
                        };
                        goog.string.floatAwareCompare = function(a, b) {
                            return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
                        };
                        goog.string.numerateCompare = goog.string.floatAwareCompare;
                        goog.string.urlEncode = function(a) {
                            return encodeURIComponent(String(a));
                        };
                        goog.string.urlDecode = function(a) {
                            return decodeURIComponent(a.replace(/\+/g, " "));
                        };
                        goog.string.newLineToBr = goog.string.internal.newLineToBr;
                        goog.string.htmlEscape = function(a, b) {
                            a = goog.string.internal.htmlEscape(a, b);
                            goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
                            return a;
                        };
                        goog.string.E_RE_ = /e/g;
                        goog.string.unescapeEntities = function(a) {
                            return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
                        };
                        goog.string.unescapeEntitiesWithDocument = function(a, b) {
                            return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
                        };
                        goog.string.unescapeEntitiesUsingDom_ = function(a, b) {
                            var c = {
                                "&amp;": "&",
                                "&lt;": "<",
                                "&gt;": ">",
                                "&quot;": '"'
                            };
                            var d = b ? b.createElement("div") : goog.global.document.createElement("div");
                            return a.replace(goog.string.HTML_ENTITY_PATTERN_, function(e, f) {
                                var g = c[e];
                                if (g) return g;
                                "#" == f.charAt(0) && (f = Number("0" + f.substr(1)), isNaN(f) || (g = String.fromCharCode(f)));
                                g || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), e + " ")), g = d.firstChild.nodeValue.slice(0, -1));
                                return c[e] = g;
                            });
                        };
                        goog.string.unescapePureXmlEntities_ = function(a) {
                            return a.replace(/&([^;]+);/g, function(b, c) {
                                switch(c){
                                    case "amp":
                                        return "&";
                                    case "lt":
                                        return "<";
                                    case "gt":
                                        return ">";
                                    case "quot":
                                        return '"';
                                    default:
                                        return "#" != c.charAt(0) || (c = Number("0" + c.substr(1)), isNaN(c)) ? b : String.fromCharCode(c);
                                }
                            });
                        };
                        goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
                        goog.string.whitespaceEscape = function(a, b) {
                            return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
                        };
                        goog.string.preserveSpaces = function(a) {
                            return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
                        };
                        goog.string.stripQuotes = function(a, b) {
                            for(var c = b.length, d = 0; d < c; d++){
                                var e = 1 == c ? b : b.charAt(d);
                                if (a.charAt(0) == e && a.charAt(a.length - 1) == e) return a.substring(1, a.length - 1);
                            }
                            return a;
                        };
                        goog.string.truncate = function(a, b, c) {
                            c && (a = goog.string.unescapeEntities(a));
                            a.length > b && (a = a.substring(0, b - 3) + "...");
                            c && (a = goog.string.htmlEscape(a));
                            return a;
                        };
                        goog.string.truncateMiddle = function(a, b, c, d) {
                            c && (a = goog.string.unescapeEntities(a));
                            if (d && a.length > b) {
                                d > b && (d = b);
                                var e = a.length - d;
                                a = a.substring(0, b - d) + "..." + a.substring(e);
                            } else a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));
                            c && (a = goog.string.htmlEscape(a));
                            return a;
                        };
                        goog.string.specialEscapeChars_ = {
                            "\x00": "\\0",
                            "\b": "\\b",
                            "\f": "\\f",
                            "\n": "\\n",
                            "\r": "\\r",
                            "\t": "\\t",
                            "\x0B": "\\x0B",
                            '"': '\\"',
                            "\\": "\\\\",
                            "<": "\\u003C"
                        };
                        goog.string.jsEscapeCache_ = {
                            "'": "\\'"
                        };
                        goog.string.quote = function(a) {
                            a = String(a);
                            for(var b = [
                                '"'
                            ], c = 0; c < a.length; c++){
                                var d = a.charAt(c), e = d.charCodeAt(0);
                                b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
                            }
                            b.push('"');
                            return b.join("");
                        };
                        goog.string.escapeString = function(a) {
                            for(var b = [], c = 0; c < a.length; c++)b[c] = goog.string.escapeChar(a.charAt(c));
                            return b.join("");
                        };
                        goog.string.escapeChar = function(a) {
                            if (a in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[a];
                            if (a in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
                            var b = a.charCodeAt(0);
                            if (31 < b && 127 > b) var c = a;
                            else {
                                if (256 > b) {
                                    if (c = "\\x", 16 > b || 256 < b) c += "0";
                                } else c = "\\u", 4096 > b && (c += "0");
                                c += b.toString(16).toUpperCase();
                            }
                            return goog.string.jsEscapeCache_[a] = c;
                        };
                        goog.string.contains = goog.string.internal.contains;
                        goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;
                        goog.string.countOf = function(a, b) {
                            return a && b ? a.split(b).length - 1 : 0;
                        };
                        goog.string.removeAt = function(a, b, c) {
                            var d = a;
                            0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
                            return d;
                        };
                        goog.string.remove = function(a, b) {
                            return a.replace(b, "");
                        };
                        goog.string.removeAll = function(a, b) {
                            b = new RegExp(goog.string.regExpEscape(b), "g");
                            return a.replace(b, "");
                        };
                        goog.string.replaceAll = function(a, b, c) {
                            b = new RegExp(goog.string.regExpEscape(b), "g");
                            return a.replace(b, c.replace(/\$/g, "$$$$"));
                        };
                        goog.string.regExpEscape = function(a) {
                            return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
                        };
                        goog.string.repeat = String.prototype.repeat ? function(a, b) {
                            return a.repeat(b);
                        } : function(a, b) {
                            return Array(b + 1).join(a);
                        };
                        goog.string.padNumber = function(a, b, c) {
                            a = void 0 !== c ? a.toFixed(c) : String(a);
                            c = a.indexOf(".");
                            -1 == c && (c = a.length);
                            return goog.string.repeat("0", Math.max(0, b - c)) + a;
                        };
                        goog.string.makeSafe = function(a) {
                            return null == a ? "" : String(a);
                        };
                        goog.string.buildString = function(a) {
                            return Array.prototype.join.call(arguments, "");
                        };
                        goog.string.getRandomString = function() {
                            return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
                        };
                        goog.string.compareVersions = goog.string.internal.compareVersions;
                        goog.string.hashCode = function(a) {
                            for(var b = 0, c = 0; c < a.length; ++c)b = 31 * b + a.charCodeAt(c) >>> 0;
                            return b;
                        };
                        goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
                        goog.string.createUniqueString = function() {
                            return "goog_" + goog.string.uniqueStringCounter_++;
                        };
                        goog.string.toNumber = function(a) {
                            var b = Number(a);
                            return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
                        };
                        goog.string.isLowerCamelCase = function(a) {
                            return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
                        };
                        goog.string.isUpperCamelCase = function(a) {
                            return /^([A-Z][a-z]*)+$/.test(a);
                        };
                        goog.string.toCamelCase = function(a) {
                            return String(a).replace(/\-([a-z])/g, function(b, c) {
                                return c.toUpperCase();
                            });
                        };
                        goog.string.toSelectorCase = function(a) {
                            return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
                        };
                        goog.string.toTitleCase = function(a, b) {
                            b = "string" === typeof b ? goog.string.regExpEscape(b) : "\\s";
                            return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function(c, d, e) {
                                return d + e.toUpperCase();
                            });
                        };
                        goog.string.capitalize = function(a) {
                            return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
                        };
                        goog.string.parseInt = function(a) {
                            isFinite(a) && (a = String(a));
                            return "string" === typeof a ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
                        };
                        goog.string.splitLimit = function(a, b, c) {
                            a = a.split(b);
                            for(var d = []; 0 < c && a.length;)d.push(a.shift()), c--;
                            a.length && d.push(a.join(b));
                            return d;
                        };
                        goog.string.lastComponent = function(a, b) {
                            if (b) "string" == typeof b && (b = [
                                b
                            ]);
                            else return a;
                            for(var c = -1, d = 0; d < b.length; d++)if ("" != b[d]) {
                                var e = a.lastIndexOf(b[d]);
                                e > c && (c = e);
                            }
                            return -1 == c ? a : a.slice(c + 1);
                        };
                        goog.string.editDistance = function(a, b) {
                            var c = [], d = [];
                            if (a == b) return 0;
                            if (!a.length || !b.length) return Math.max(a.length, b.length);
                            for(var e = 0; e < b.length + 1; e++)c[e] = e;
                            for(e = 0; e < a.length; e++){
                                d[0] = e + 1;
                                for(var f = 0; f < b.length; f++)d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
                                for(f = 0; f < c.length; f++)c[f] = d[f];
                            }
                            return d[b.length];
                        };
                        goog.proto2 = {};
                        goog.proto2.Descriptor = function(a, b, c) {
                            this.messageType_ = a;
                            this.name_ = b.name || null;
                            this.fullName_ = b.fullName || null;
                            this.containingType_ = b.containingType;
                            this.fields_ = {};
                            for(a = 0; a < c.length; a++)b = c[a], this.fields_[b.getTag()] = b;
                        };
                        goog.proto2.Descriptor.prototype.getName = function() {
                            return this.name_;
                        };
                        goog.proto2.Descriptor.prototype.getFullName = function() {
                            return this.fullName_;
                        };
                        goog.proto2.Descriptor.prototype.getContainingType = function() {
                            return this.containingType_ ? this.containingType_.getDescriptor() : null;
                        };
                        goog.proto2.Descriptor.prototype.getFields = function() {
                            var a = goog.object.getValues(this.fields_);
                            module$contents$goog$array_sort(a, function(b, c) {
                                return b.getTag() - c.getTag();
                            });
                            return a;
                        };
                        goog.proto2.Descriptor.prototype.getFieldsMap = function() {
                            return this.fields_;
                        };
                        goog.proto2.Descriptor.prototype.findFieldByName = function(a) {
                            return goog.object.findValue(this.fields_, function(b, c, d) {
                                return b.getName() == a;
                            }) || null;
                        };
                        goog.proto2.Descriptor.prototype.findFieldByTag = function(a) {
                            goog.asserts.assert(goog.string.isNumeric(a));
                            return this.fields_[parseInt(a, 10)] || null;
                        };
                        goog.proto2.Descriptor.prototype.createMessageInstance = function() {
                            return new this.messageType_;
                        };
                        goog.proto2.FieldDescriptor = function(a, b, c) {
                            this.parent_ = a;
                            goog.asserts.assert(goog.string.isNumeric(b));
                            this.tag_ = b;
                            this.name_ = c.name;
                            this.isPacked_ = !!c.packed;
                            this.isRepeated_ = !!c.repeated;
                            this.isRequired_ = !!c.required;
                            this.fieldType_ = c.fieldType;
                            this.nativeType_ = c.type;
                            this.deserializationConversionPermitted_ = !1;
                            switch(this.fieldType_){
                                case goog.proto2.FieldDescriptor.FieldType.INT64:
                                case goog.proto2.FieldDescriptor.FieldType.UINT64:
                                case goog.proto2.FieldDescriptor.FieldType.FIXED64:
                                case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
                                case goog.proto2.FieldDescriptor.FieldType.SINT64:
                                case goog.proto2.FieldDescriptor.FieldType.FLOAT:
                                case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
                                    this.deserializationConversionPermitted_ = !0;
                            }
                            this.defaultValue_ = c.defaultValue;
                        };
                        goog.proto2.FieldDescriptor.FieldType = {
                            DOUBLE: 1,
                            FLOAT: 2,
                            INT64: 3,
                            UINT64: 4,
                            INT32: 5,
                            FIXED64: 6,
                            FIXED32: 7,
                            BOOL: 8,
                            STRING: 9,
                            GROUP: 10,
                            MESSAGE: 11,
                            BYTES: 12,
                            UINT32: 13,
                            ENUM: 14,
                            SFIXED32: 15,
                            SFIXED64: 16,
                            SINT32: 17,
                            SINT64: 18
                        };
                        goog.proto2.FieldDescriptor.prototype.getTag = function() {
                            return this.tag_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
                            return this.parent_.prototype.getDescriptor();
                        };
                        goog.proto2.FieldDescriptor.prototype.getName = function() {
                            return this.name_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
                            if (void 0 === this.defaultValue_) {
                                var a = this.nativeType_;
                                if (a === Boolean) this.defaultValue_ = !1;
                                else if (a === Number) this.defaultValue_ = 0;
                                else if (a === String) this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
                                else return new a;
                            }
                            return this.defaultValue_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
                            return this.fieldType_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
                            return this.nativeType_;
                        };
                        goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
                            return this.deserializationConversionPermitted_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
                            return this.nativeType_.prototype.getDescriptor();
                        };
                        goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
                            return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
                        };
                        goog.proto2.FieldDescriptor.prototype.isPacked = function() {
                            return this.isPacked_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
                            return this.isRepeated_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isRequired = function() {
                            return this.isRequired_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isOptional = function() {
                            return !this.isRepeated_ && !this.isRequired_;
                        };
                        goog.proto2.Message = function() {
                            this.values_ = {};
                            this.fields_ = this.getDescriptor().getFieldsMap();
                            this.deserializedFields_ = this.lazyDeserializer_ = null;
                        };
                        goog.proto2.Message.FieldType = {
                            DOUBLE: 1,
                            FLOAT: 2,
                            INT64: 3,
                            UINT64: 4,
                            INT32: 5,
                            FIXED64: 6,
                            FIXED32: 7,
                            BOOL: 8,
                            STRING: 9,
                            GROUP: 10,
                            MESSAGE: 11,
                            BYTES: 12,
                            UINT32: 13,
                            ENUM: 14,
                            SFIXED32: 15,
                            SFIXED64: 16,
                            SINT32: 17,
                            SINT64: 18
                        };
                        goog.proto2.Message.prototype.initializeForLazyDeserializer = function(a, b) {
                            this.lazyDeserializer_ = a;
                            this.values_ = b;
                            this.deserializedFields_ = {};
                        };
                        goog.proto2.Message.prototype.setUnknown = function(a, b) {
                            goog.asserts.assert(!this.fields_[a], "Field is not unknown in this message");
                            goog.asserts.assert(1 <= a, "Tag " + a + ' has value "' + b + '" in descriptor ' + this.getDescriptor().getName());
                            goog.asserts.assert(null !== b, "Value cannot be null");
                            this.values_[a] = b;
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.prototype.forEachUnknown = function(a, b) {
                            b = b || this;
                            for(var c in this.values_){
                                var d = Number(c);
                                this.fields_[d] || a.call(b, d, this.values_[c]);
                            }
                        };
                        goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod;
                        goog.proto2.Message.prototype.has = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.has$Value(a.getTag());
                        };
                        goog.proto2.Message.prototype.arrayOf = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.array$Values(a.getTag());
                        };
                        goog.proto2.Message.prototype.countOf = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.count$Values(a.getTag());
                        };
                        goog.proto2.Message.prototype.get = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.get$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.getOrDefault = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.get$ValueOrDefault(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.set = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.set$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.add = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.add$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.clear = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.clear$Field(a.getTag());
                        };
                        goog.proto2.Message.prototype.equals = function(a) {
                            if (!a || this.constructor != a.constructor) return !1;
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag();
                                if (this.has$Value(e) != a.has$Value(e)) return !1;
                                if (this.has$Value(e)) {
                                    var f = d.isCompositeType(), g = this.getValueForTag_(e);
                                    e = a.getValueForTag_(e);
                                    if (d.isRepeated()) {
                                        if (g.length != e.length) return !1;
                                        for(d = 0; d < g.length; d++){
                                            var h = g[d], k = e[d];
                                            if (f ? !h.equals(k) : h != k) return !1;
                                        }
                                    } else if (f ? !g.equals(e) : g != e) return !1;
                                }
                            }
                            return !0;
                        };
                        goog.proto2.Message.prototype.copyFrom = function(a) {
                            goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
                            this != a && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(a));
                        };
                        goog.proto2.Message.prototype.mergeFrom = function(a) {
                            goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag();
                                if (a.has$Value(e)) {
                                    this.deserializedFields_ && delete this.deserializedFields_[d.getTag()];
                                    var f = d.isCompositeType();
                                    if (d.isRepeated()) {
                                        d = a.array$Values(e);
                                        for(var g = 0; g < d.length; g++)this.add$Value(e, f ? d[g].clone() : d[g]);
                                    } else d = a.getValueForTag_(e), f ? (f = this.getValueForTag_(e)) ? f.mergeFrom(d) : this.set$Value(e, d.clone()) : this.set$Value(e, d);
                                }
                            }
                        };
                        goog.proto2.Message.prototype.clone = function() {
                            var a = new this.constructor;
                            a.copyFrom(this);
                            return a;
                        };
                        goog.proto2.Message.prototype.initDefaults = function(a) {
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag(), f = d.isCompositeType();
                                this.has$Value(e) || d.isRepeated() || (f ? this.values_[e] = new (d.getNativeType()) : a && (this.values_[e] = d.getDefaultValue()));
                                if (f) {
                                    if (d.isRepeated()) for(d = this.array$Values(e), e = 0; e < d.length; e++)d[e].initDefaults(a);
                                    else this.get$Value(e).initDefaults(a);
                                }
                            }
                        };
                        goog.proto2.Message.prototype.has$Value = function(a) {
                            return null != this.values_[a];
                        };
                        goog.proto2.Message.prototype.getValueForTag_ = function(a) {
                            var b = this.values_[a];
                            return null == b ? null : this.lazyDeserializer_ ? a in this.deserializedFields_ ? this.deserializedFields_[a] : (b = this.lazyDeserializer_.deserializeField(this, this.fields_[a], b), this.deserializedFields_[a] = b) : b;
                        };
                        goog.proto2.Message.prototype.get$Value = function(a, b) {
                            var c = this.getValueForTag_(a);
                            return this.fields_[a].isRepeated() ? (a = b || 0, goog.asserts.assert(0 <= a && a < c.length, "Given index %s is out of bounds.  Repeated field length: %s", a, c.length), c[a]) : c;
                        };
                        goog.proto2.Message.prototype.get$ValueOrDefault = function(a, b) {
                            return this.has$Value(a) ? this.get$Value(a, b) : this.fields_[a].getDefaultValue();
                        };
                        goog.proto2.Message.prototype.array$Values = function(a) {
                            return this.getValueForTag_(a) || [];
                        };
                        goog.proto2.Message.prototype.count$Values = function(a) {
                            return this.fields_[a].isRepeated() ? this.has$Value(a) ? this.values_[a].length : 0 : this.has$Value(a) ? 1 : 0;
                        };
                        goog.proto2.Message.prototype.set$Value = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
                            this.values_[a] = b;
                            this.deserializedFields_ && (this.deserializedFields_[a] = b);
                        };
                        goog.proto2.Message.prototype.add$Value = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
                            this.values_[a] || (this.values_[a] = []);
                            this.values_[a].push(b);
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.prototype.checkFieldType_ = function(a, b) {
                            a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b) : goog.asserts.assert(Object(b).constructor == a.getNativeType());
                        };
                        goog.proto2.Message.prototype.clear$Field = function(a) {
                            delete this.values_[a];
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.createDescriptor = function(a, b) {
                            var c = [], d = b[0], e;
                            for(e in b)0 != e && c.push(new goog.proto2.FieldDescriptor(a, e, b[e]));
                            return new goog.proto2.Descriptor(a, d, c);
                        };
                        goog.proto2.Serializer = function() {};
                        goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1;
                        goog.proto2.Serializer.prototype.serialize = goog.abstractMethod;
                        goog.proto2.Serializer.prototype.getSerializedValue = function(a, b) {
                            return a.isCompositeType() ? this.serialize(b) : "number" !== typeof b || isFinite(b) ? b : b.toString();
                        };
                        goog.proto2.Serializer.prototype.deserialize = function(a, b) {
                            a = a.createMessageInstance();
                            this.deserializeTo(a, b);
                            goog.asserts.assert(a instanceof goog.proto2.Message);
                            return a;
                        };
                        goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod;
                        goog.proto2.Serializer.prototype.getDeserializedValue = function(a, b) {
                            if (a.isCompositeType()) return b instanceof goog.proto2.Message ? b : this.deserialize(a.getFieldMessageType(), b);
                            if (a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && "string" === typeof b && (a = a.getNativeType(), a.hasOwnProperty(b)) ? a[b] : "string" === typeof b && goog.proto2.Serializer.INTEGER_REGEX.test(b) && (a = Number(b), 0 < a) ? a : b;
                            if (!a.deserializationConversionPermitted()) return b;
                            a = a.getNativeType();
                            if (a === String) {
                                if ("number" === typeof b) return String(b);
                            } else if (a === Number && "string" === typeof b && ("Infinity" === b || "-Infinity" === b || "NaN" === b || goog.proto2.Serializer.INTEGER_REGEX.test(b))) return Number(b);
                            return b;
                        };
                        goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/;
                        goog.proto2.LazyDeserializer = function() {};
                        goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer);
                        goog.proto2.LazyDeserializer.prototype.deserialize = function(a, b) {
                            a = a.createMessageInstance();
                            a.initializeForLazyDeserializer(this, b);
                            goog.asserts.assert(a instanceof goog.proto2.Message);
                            return a;
                        };
                        goog.proto2.LazyDeserializer.prototype.deserializeTo = function(a, b) {
                            throw Error("Unimplemented");
                        };
                        goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod;
                        goog.proto2.PbLiteSerializer = function() {};
                        goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer);
                        goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1;
                        goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(a) {
                            this.zeroIndexing_ = a;
                        };
                        goog.proto2.PbLiteSerializer.prototype.serialize = function(a) {
                            for(var b = a.getDescriptor().getFields(), c = [], d = this.zeroIndexing_, e = 0; e < b.length; e++){
                                var f = b[e];
                                if (a.has(f)) {
                                    var g = f.getTag();
                                    g = d ? g - 1 : g;
                                    if (f.isRepeated()) {
                                        c[g] = [];
                                        for(var h = 0; h < a.countOf(f); h++)c[g][h] = this.getSerializedValue(f, a.get(f, h));
                                    } else c[g] = this.getSerializedValue(f, a.get(f));
                                }
                            }
                            a.forEachUnknown(function(k, l) {
                                c[d ? k - 1 : k] = l;
                            });
                            return c;
                        };
                        goog.proto2.PbLiteSerializer.prototype.deserializeField = function(a, b, c) {
                            if (null == c) return c;
                            if (b.isRepeated()) {
                                a = [];
                                goog.asserts.assert(Array.isArray(c), "Value must be array: %s", c);
                                for(var d = 0; d < c.length; d++)a[d] = this.getDeserializedValue(b, c[d]);
                                return a;
                            }
                            return this.getDeserializedValue(b, c);
                        };
                        goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(a, b) {
                            return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
                        };
                        goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(a, b) {
                            return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert("number" === typeof b || "boolean" === typeof b, "Value is expected to be a number or boolean"), !!b) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
                        };
                        goog.proto2.PbLiteSerializer.prototype.deserialize = function(a, b) {
                            var c = b;
                            if (this.zeroIndexing_) {
                                c = [];
                                for(var d in b)c[parseInt(d, 10) + 1] = b[d];
                            }
                            return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a, c);
                        };
                        goog.string.StringBuffer = function(a, b) {
                            null != a && this.append.apply(this, arguments);
                        };
                        goog.string.StringBuffer.prototype.buffer_ = "";
                        goog.string.StringBuffer.prototype.set = function(a) {
                            this.buffer_ = "" + a;
                        };
                        goog.string.StringBuffer.prototype.append = function(a, b, c) {
                            this.buffer_ += String(a);
                            if (null != b) for(var d = 1; d < arguments.length; d++)this.buffer_ += arguments[d];
                            return this;
                        };
                        goog.string.StringBuffer.prototype.clear = function() {
                            this.buffer_ = "";
                        };
                        goog.string.StringBuffer.prototype.getLength = function() {
                            return this.buffer_.length;
                        };
                        goog.string.StringBuffer.prototype.toString = function() {
                            return this.buffer_;
                        }; /*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        var i18n = {
                            phonenumbers: {}
                        };
                        i18n.phonenumbers.NumberFormat = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message);
                        i18n.phonenumbers.NumberFormat.descriptor_ = null;
                        i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setPattern = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setFormat = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(a) {
                            return this.get$Value(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(a) {
                            return this.get$ValueOrDefault(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(a) {
                            this.add$Value(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
                            return this.array$Values(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneNumberDesc = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message);
                        i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null;
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(a) {
                            return this.get$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(a) {
                            return this.get$ValueOrDefault(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(a) {
                            this.add$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
                            return this.array$Values(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
                            return this.has$Value(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
                            return this.count$Values(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
                            this.clear$Field(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(a) {
                            return this.get$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(a) {
                            return this.get$ValueOrDefault(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(a) {
                            this.add$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
                            return this.array$Values(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
                            return this.has$Value(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
                            return this.count$Values(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
                            this.clear$Field(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneMetadata = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message);
                        i18n.phonenumbers.PhoneMetadata.descriptor_ = null;
                        i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
                            return this.get$Value(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
                            return this.get$ValueOrDefault(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(a) {
                            this.set$Value(3, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
                            return this.get$Value(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
                            return this.get$ValueOrDefault(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(a) {
                            this.set$Value(7, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
                            return this.has$Value(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
                            return this.count$Values(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
                            this.clear$Field(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
                            return this.get$Value(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
                            return this.get$ValueOrDefault(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(a) {
                            this.set$Value(8, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
                            return this.has$Value(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
                            return this.count$Values(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
                            this.clear$Field(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
                            return this.get$Value(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
                            return this.get$ValueOrDefault(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(a) {
                            this.set$Value(21, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
                            return this.has$Value(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
                            return this.count$Values(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
                            this.clear$Field(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
                            return this.get$Value(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
                            return this.get$ValueOrDefault(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(a) {
                            this.set$Value(25, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
                            return this.has$Value(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
                            return this.count$Values(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
                            this.clear$Field(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
                            return this.get$Value(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
                            return this.get$ValueOrDefault(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(a) {
                            this.set$Value(27, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
                            return this.has$Value(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
                            return this.count$Values(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
                            this.clear$Field(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
                            return this.get$Value(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
                            return this.get$ValueOrDefault(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(a) {
                            this.set$Value(28, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
                            return this.has$Value(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
                            return this.count$Values(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
                            this.clear$Field(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
                            return this.get$Value(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
                            return this.get$ValueOrDefault(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function(a) {
                            this.set$Value(29, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
                            return this.has$Value(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
                            return this.count$Values(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
                            this.clear$Field(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
                            return this.get$Value(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
                            return this.get$ValueOrDefault(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(a) {
                            this.set$Value(30, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
                            return this.has$Value(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
                            return this.count$Values(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
                            this.clear$Field(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
                            return this.get$Value(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
                            return this.get$ValueOrDefault(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(a) {
                            this.set$Value(31, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
                            return this.has$Value(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
                            return this.count$Values(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
                            this.clear$Field(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
                            return this.get$Value(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
                            return this.get$ValueOrDefault(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(a) {
                            this.set$Value(33, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
                            return this.has$Value(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
                            return this.count$Values(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
                            this.clear$Field(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
                            return this.get$Value(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
                            return this.get$ValueOrDefault(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(a) {
                            this.set$Value(24, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
                            return this.has$Value(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
                            return this.count$Values(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
                            this.clear$Field(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
                            return this.get$Value(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
                            return this.get$ValueOrDefault(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setId = function(a) {
                            this.set$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
                            return this.has$Value(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
                            return this.count$Values(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
                            this.clear$Field(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
                            return this.get$Value(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
                            return this.get$ValueOrDefault(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(a) {
                            this.set$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
                            return this.has$Value(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
                            return this.count$Values(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
                            this.clear$Field(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
                            return this.get$Value(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(a) {
                            this.set$Value(11, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
                            return this.has$Value(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
                            return this.count$Values(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
                            this.clear$Field(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
                            return this.get$Value(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(a) {
                            this.set$Value(17, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
                            return this.has$Value(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
                            return this.count$Values(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
                            this.clear$Field(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
                            return this.get$Value(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(a) {
                            this.set$Value(12, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
                            return this.has$Value(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
                            return this.count$Values(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
                            this.clear$Field(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
                            return this.get$Value(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(a) {
                            this.set$Value(13, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
                            return this.has$Value(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
                            return this.count$Values(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
                            this.clear$Field(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
                            return this.get$Value(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
                            return this.get$ValueOrDefault(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(a) {
                            this.set$Value(15, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
                            return this.has$Value(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
                            return this.count$Values(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
                            this.clear$Field(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
                            return this.get$Value(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
                            return this.get$ValueOrDefault(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(a) {
                            this.set$Value(16, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
                            return this.has$Value(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
                            return this.count$Values(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
                            this.clear$Field(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
                            return this.get$Value(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
                            return this.get$ValueOrDefault(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(a) {
                            this.set$Value(18, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
                            return this.has$Value(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
                            return this.count$Values(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
                            this.clear$Field(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(a) {
                            return this.get$Value(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(a) {
                            return this.get$ValueOrDefault(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(a) {
                            this.add$Value(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
                            return this.array$Values(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
                            return this.has$Value(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
                            return this.count$Values(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
                            this.clear$Field(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(a) {
                            return this.get$Value(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(a) {
                            return this.get$ValueOrDefault(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(a) {
                            this.add$Value(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
                            return this.array$Values(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
                            return this.has$Value(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
                            return this.count$Values(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
                            this.clear$Field(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
                            return this.get$Value(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
                            return this.get$ValueOrDefault(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(a) {
                            this.set$Value(22, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
                            return this.has$Value(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
                            return this.count$Values(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
                            this.clear$Field(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
                            return this.get$Value(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
                            return this.get$ValueOrDefault(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(a) {
                            this.set$Value(23, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
                            return this.has$Value(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
                            return this.count$Values(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
                            this.clear$Field(23);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message);
                        i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null;
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(a) {
                            return this.get$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(a) {
                            return this.get$ValueOrDefault(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(a) {
                            this.add$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
                            return this.array$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.NumberFormat.descriptor_;
                            a || (i18n.phonenumbers.NumberFormat.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {
                                0: {
                                    name: "NumberFormat",
                                    fullName: "i18n.phonenumbers.NumberFormat"
                                },
                                1: {
                                    name: "pattern",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                2: {
                                    name: "format",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                3: {
                                    name: "leading_digits_pattern",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                4: {
                                    name: "national_prefix_formatting_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                6: {
                                    name: "national_prefix_optional_when_formatting",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                5: {
                                    name: "domestic_carrier_code_formatting_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
                            a || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {
                                0: {
                                    name: "PhoneNumberDesc",
                                    fullName: "i18n.phonenumbers.PhoneNumberDesc"
                                },
                                2: {
                                    name: "national_number_pattern",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                9: {
                                    name: "possible_length",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                10: {
                                    name: "possible_length_local_only",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                6: {
                                    name: "example_number",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneMetadata.descriptor_;
                            a || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {
                                0: {
                                    name: "PhoneMetadata",
                                    fullName: "i18n.phonenumbers.PhoneMetadata"
                                },
                                1: {
                                    name: "general_desc",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                2: {
                                    name: "fixed_line",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                3: {
                                    name: "mobile",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                4: {
                                    name: "toll_free",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                5: {
                                    name: "premium_rate",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                6: {
                                    name: "shared_cost",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                7: {
                                    name: "personal_number",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                8: {
                                    name: "voip",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                21: {
                                    name: "pager",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                25: {
                                    name: "uan",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                27: {
                                    name: "emergency",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                28: {
                                    name: "voicemail",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                29: {
                                    name: "short_code",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                30: {
                                    name: "standard_rate",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                31: {
                                    name: "carrier_specific",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                33: {
                                    name: "sms_services",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                24: {
                                    name: "no_international_dialling",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                9: {
                                    name: "id",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                10: {
                                    name: "country_code",
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                11: {
                                    name: "international_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                17: {
                                    name: "preferred_international_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                12: {
                                    name: "national_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                13: {
                                    name: "preferred_extn_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                15: {
                                    name: "national_prefix_for_parsing",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                16: {
                                    name: "national_prefix_transform_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                18: {
                                    name: "same_mobile_and_fixed_line_pattern",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                19: {
                                    name: "number_format",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.NumberFormat
                                },
                                20: {
                                    name: "intl_number_format",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.NumberFormat
                                },
                                22: {
                                    name: "main_country_for_code",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                23: {
                                    name: "leading_digits",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
                            a || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {
                                0: {
                                    name: "PhoneMetadataCollection",
                                    fullName: "i18n.phonenumbers.PhoneMetadataCollection"
                                },
                                1: {
                                    name: "metadata",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneMetadata
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneNumber = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message);
                        i18n.phonenumbers.PhoneNumber.descriptor_ = null;
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
                            return this.get$Value(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
                            return this.get$ValueOrDefault(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(a) {
                            this.set$Value(3, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
                            return this.get$Value(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
                            return this.get$ValueOrDefault(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(a) {
                            this.set$Value(8, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
                            return this.has$Value(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
                            return this.count$Values(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
                            this.clear$Field(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
                            return this.get$Value(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
                            return this.get$ValueOrDefault(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(a) {
                            this.set$Value(7, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
                            return this.has$Value(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
                            return this.count$Values(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
                            this.clear$Field(7);
                        };
                        i18n.phonenumbers.PhoneNumber.CountryCodeSource = {
                            UNSPECIFIED: 0,
                            FROM_NUMBER_WITH_PLUS_SIGN: 1,
                            FROM_NUMBER_WITH_IDD: 5,
                            FROM_NUMBER_WITHOUT_PLUS_SIGN: 10,
                            FROM_DEFAULT_COUNTRY: 20
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneNumber.descriptor_;
                            a || (i18n.phonenumbers.PhoneNumber.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {
                                0: {
                                    name: "PhoneNumber",
                                    fullName: "i18n.phonenumbers.PhoneNumber"
                                },
                                1: {
                                    name: "country_code",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                2: {
                                    name: "national_number",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.UINT64,
                                    type: Number
                                },
                                3: {
                                    name: "extension",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                4: {
                                    name: "italian_leading_zero",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    type: Boolean
                                },
                                8: {
                                    name: "number_of_leading_zeros",
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    defaultValue: 1,
                                    type: Number
                                },
                                5: {
                                    name: "raw_input",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                6: {
                                    name: "country_code_source",
                                    fieldType: goog.proto2.Message.FieldType.ENUM,
                                    defaultValue: i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED,
                                    type: i18n.phonenumbers.PhoneNumber.CountryCodeSource
                                },
                                7: {
                                    name: "preferred_domestic_carrier_code",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber;
                        i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor; /*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.metadata = {};
                        i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {
                            1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
                            7: [
                                "RU",
                                "KZ"
                            ],
                            20: [
                                "EG"
                            ],
                            27: [
                                "ZA"
                            ],
                            30: [
                                "GR"
                            ],
                            31: [
                                "NL"
                            ],
                            32: [
                                "BE"
                            ],
                            33: [
                                "FR"
                            ],
                            34: [
                                "ES"
                            ],
                            36: [
                                "HU"
                            ],
                            39: [
                                "IT",
                                "VA"
                            ],
                            40: [
                                "RO"
                            ],
                            41: [
                                "CH"
                            ],
                            43: [
                                "AT"
                            ],
                            44: [
                                "GB",
                                "GG",
                                "IM",
                                "JE"
                            ],
                            45: [
                                "DK"
                            ],
                            46: [
                                "SE"
                            ],
                            47: [
                                "NO",
                                "SJ"
                            ],
                            48: [
                                "PL"
                            ],
                            49: [
                                "DE"
                            ],
                            51: [
                                "PE"
                            ],
                            52: [
                                "MX"
                            ],
                            53: [
                                "CU"
                            ],
                            54: [
                                "AR"
                            ],
                            55: [
                                "BR"
                            ],
                            56: [
                                "CL"
                            ],
                            57: [
                                "CO"
                            ],
                            58: [
                                "VE"
                            ],
                            60: [
                                "MY"
                            ],
                            61: [
                                "AU",
                                "CC",
                                "CX"
                            ],
                            62: [
                                "ID"
                            ],
                            63: [
                                "PH"
                            ],
                            64: [
                                "NZ"
                            ],
                            65: [
                                "SG"
                            ],
                            66: [
                                "TH"
                            ],
                            81: [
                                "JP"
                            ],
                            82: [
                                "KR"
                            ],
                            84: [
                                "VN"
                            ],
                            86: [
                                "CN"
                            ],
                            90: [
                                "TR"
                            ],
                            91: [
                                "IN"
                            ],
                            92: [
                                "PK"
                            ],
                            93: [
                                "AF"
                            ],
                            94: [
                                "LK"
                            ],
                            95: [
                                "MM"
                            ],
                            98: [
                                "IR"
                            ],
                            211: [
                                "SS"
                            ],
                            212: [
                                "MA",
                                "EH"
                            ],
                            213: [
                                "DZ"
                            ],
                            216: [
                                "TN"
                            ],
                            218: [
                                "LY"
                            ],
                            220: [
                                "GM"
                            ],
                            221: [
                                "SN"
                            ],
                            222: [
                                "MR"
                            ],
                            223: [
                                "ML"
                            ],
                            224: [
                                "GN"
                            ],
                            225: [
                                "CI"
                            ],
                            226: [
                                "BF"
                            ],
                            227: [
                                "NE"
                            ],
                            228: [
                                "TG"
                            ],
                            229: [
                                "BJ"
                            ],
                            230: [
                                "MU"
                            ],
                            231: [
                                "LR"
                            ],
                            232: [
                                "SL"
                            ],
                            233: [
                                "GH"
                            ],
                            234: [
                                "NG"
                            ],
                            235: [
                                "TD"
                            ],
                            236: [
                                "CF"
                            ],
                            237: [
                                "CM"
                            ],
                            238: [
                                "CV"
                            ],
                            239: [
                                "ST"
                            ],
                            240: [
                                "GQ"
                            ],
                            241: [
                                "GA"
                            ],
                            242: [
                                "CG"
                            ],
                            243: [
                                "CD"
                            ],
                            244: [
                                "AO"
                            ],
                            245: [
                                "GW"
                            ],
                            246: [
                                "IO"
                            ],
                            247: [
                                "AC"
                            ],
                            248: [
                                "SC"
                            ],
                            249: [
                                "SD"
                            ],
                            250: [
                                "RW"
                            ],
                            251: [
                                "ET"
                            ],
                            252: [
                                "SO"
                            ],
                            253: [
                                "DJ"
                            ],
                            254: [
                                "KE"
                            ],
                            255: [
                                "TZ"
                            ],
                            256: [
                                "UG"
                            ],
                            257: [
                                "BI"
                            ],
                            258: [
                                "MZ"
                            ],
                            260: [
                                "ZM"
                            ],
                            261: [
                                "MG"
                            ],
                            262: [
                                "RE",
                                "YT"
                            ],
                            263: [
                                "ZW"
                            ],
                            264: [
                                "NA"
                            ],
                            265: [
                                "MW"
                            ],
                            266: [
                                "LS"
                            ],
                            267: [
                                "BW"
                            ],
                            268: [
                                "SZ"
                            ],
                            269: [
                                "KM"
                            ],
                            290: [
                                "SH",
                                "TA"
                            ],
                            291: [
                                "ER"
                            ],
                            297: [
                                "AW"
                            ],
                            298: [
                                "FO"
                            ],
                            299: [
                                "GL"
                            ],
                            350: [
                                "GI"
                            ],
                            351: [
                                "PT"
                            ],
                            352: [
                                "LU"
                            ],
                            353: [
                                "IE"
                            ],
                            354: [
                                "IS"
                            ],
                            355: [
                                "AL"
                            ],
                            356: [
                                "MT"
                            ],
                            357: [
                                "CY"
                            ],
                            358: [
                                "FI",
                                "AX"
                            ],
                            359: [
                                "BG"
                            ],
                            370: [
                                "LT"
                            ],
                            371: [
                                "LV"
                            ],
                            372: [
                                "EE"
                            ],
                            373: [
                                "MD"
                            ],
                            374: [
                                "AM"
                            ],
                            375: [
                                "BY"
                            ],
                            376: [
                                "AD"
                            ],
                            377: [
                                "MC"
                            ],
                            378: [
                                "SM"
                            ],
                            380: [
                                "UA"
                            ],
                            381: [
                                "RS"
                            ],
                            382: [
                                "ME"
                            ],
                            383: [
                                "XK"
                            ],
                            385: [
                                "HR"
                            ],
                            386: [
                                "SI"
                            ],
                            387: [
                                "BA"
                            ],
                            389: [
                                "MK"
                            ],
                            420: [
                                "CZ"
                            ],
                            421: [
                                "SK"
                            ],
                            423: [
                                "LI"
                            ],
                            500: [
                                "FK"
                            ],
                            501: [
                                "BZ"
                            ],
                            502: [
                                "GT"
                            ],
                            503: [
                                "SV"
                            ],
                            504: [
                                "HN"
                            ],
                            505: [
                                "NI"
                            ],
                            506: [
                                "CR"
                            ],
                            507: [
                                "PA"
                            ],
                            508: [
                                "PM"
                            ],
                            509: [
                                "HT"
                            ],
                            590: [
                                "GP",
                                "BL",
                                "MF"
                            ],
                            591: [
                                "BO"
                            ],
                            592: [
                                "GY"
                            ],
                            593: [
                                "EC"
                            ],
                            594: [
                                "GF"
                            ],
                            595: [
                                "PY"
                            ],
                            596: [
                                "MQ"
                            ],
                            597: [
                                "SR"
                            ],
                            598: [
                                "UY"
                            ],
                            599: [
                                "CW",
                                "BQ"
                            ],
                            670: [
                                "TL"
                            ],
                            672: [
                                "NF"
                            ],
                            673: [
                                "BN"
                            ],
                            674: [
                                "NR"
                            ],
                            675: [
                                "PG"
                            ],
                            676: [
                                "TO"
                            ],
                            677: [
                                "SB"
                            ],
                            678: [
                                "VU"
                            ],
                            679: [
                                "FJ"
                            ],
                            680: [
                                "PW"
                            ],
                            681: [
                                "WF"
                            ],
                            682: [
                                "CK"
                            ],
                            683: [
                                "NU"
                            ],
                            685: [
                                "WS"
                            ],
                            686: [
                                "KI"
                            ],
                            687: [
                                "NC"
                            ],
                            688: [
                                "TV"
                            ],
                            689: [
                                "PF"
                            ],
                            690: [
                                "TK"
                            ],
                            691: [
                                "FM"
                            ],
                            692: [
                                "MH"
                            ],
                            800: [
                                "001"
                            ],
                            808: [
                                "001"
                            ],
                            850: [
                                "KP"
                            ],
                            852: [
                                "HK"
                            ],
                            853: [
                                "MO"
                            ],
                            855: [
                                "KH"
                            ],
                            856: [
                                "LA"
                            ],
                            870: [
                                "001"
                            ],
                            878: [
                                "001"
                            ],
                            880: [
                                "BD"
                            ],
                            881: [
                                "001"
                            ],
                            882: [
                                "001"
                            ],
                            883: [
                                "001"
                            ],
                            886: [
                                "TW"
                            ],
                            888: [
                                "001"
                            ],
                            960: [
                                "MV"
                            ],
                            961: [
                                "LB"
                            ],
                            962: [
                                "JO"
                            ],
                            963: [
                                "SY"
                            ],
                            964: [
                                "IQ"
                            ],
                            965: [
                                "KW"
                            ],
                            966: [
                                "SA"
                            ],
                            967: [
                                "YE"
                            ],
                            968: [
                                "OM"
                            ],
                            970: [
                                "PS"
                            ],
                            971: [
                                "AE"
                            ],
                            972: [
                                "IL"
                            ],
                            973: [
                                "BH"
                            ],
                            974: [
                                "QA"
                            ],
                            975: [
                                "BT"
                            ],
                            976: [
                                "MN"
                            ],
                            977: [
                                "NP"
                            ],
                            979: [
                                "001"
                            ],
                            992: [
                                "TJ"
                            ],
                            993: [
                                "TM"
                            ],
                            994: [
                                "AZ"
                            ],
                            995: [
                                "GE"
                            ],
                            996: [
                                "KG"
                            ],
                            998: [
                                "UZ"
                            ]
                        };
                        i18n.phonenumbers.metadata.countryToMetadata = {
                            AC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[01589]\\d|[46])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[2-467]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "62889",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "40123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AC",
                                247,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[1-9]|[1589]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "542011",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[78]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "712345",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "690\\d{6}|[356]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312345",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180[02]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[19]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "912345",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AD",
                                376,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[135-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-4679][2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[024-68]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "501234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "400\\d{6}|800\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[02]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[05]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "700012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AE",
                                971,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,9})",
                                        "$1 $2",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[236]|[479][2-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[479]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600[25]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "600212345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-7]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "234567890",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AF",
                                93,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:268|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684601234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684641234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "26848[01]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684801234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "AG",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([457]\\d{6})$|1",
                                "268$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "26840[69]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684061234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                "268",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:264|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "264(?:292|4(?:6[12]|9[78]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2644612345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2642351234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AI",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2457]\\d{6})$|1",
                                "264$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "264724\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2647241234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                "264",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[78][2-9]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "672123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[1-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "900123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808[1-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "808123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[2-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AL",
                                355,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "80|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "4[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2358][2-5]|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[23578]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-489]\\d|55|60|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "10123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "90[016]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80[1-4]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "60271234"
                                ],
                                "AM",
                                374,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]0"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2|3[12]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "1|47"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[3-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[29]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-79]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "923123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AO",
                                244,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[29]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "91123456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "60[04579]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "6001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AR",
                                54,
                                "00",
                                "0",
                                ,
                                ,
                                "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
                                "9$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})",
                                        "$1",
                                        [
                                            "0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                                            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[23]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "9(?:2[2-469]|3[3-578])",
                                            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                                            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                                            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[23]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "9(?:2[2-469]|3[3-578])",
                                            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                                            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "91"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "810\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8101234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|684|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6846(?:22|33|44|55|77|88|9[19])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6846221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6847331234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([267]\\d{6})$|1",
                                "684$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "684",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",
                                    ,
                                    ,
                                    ,
                                    "1234567890",
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}",
                                    ,
                                    ,
                                    ,
                                    "664123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:10|2[018])\\d{6,10}|828\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "810123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "780123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                "AT",
                                43,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "1(?:11|[2-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})",
                                        "$1 $2",
                                        [
                                            "517"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "5[079]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[18]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,10})",
                                        "$1 $2",
                                        [
                                            "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                                            "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "[2-467]|5[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,7})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "1(?:11|[2-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})",
                                        "$1 $2",
                                        [
                                            "517"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "5[079]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,10})",
                                        "$1 $2",
                                        [
                                            "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                                            "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "[2-467]|5[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,7})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "AU",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "(183[12])|0",
                                ,
                                "0011",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "13"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1802"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "14|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2378]"
                                        ],
                                        "(0$1)",
                                        "$CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:30|[89])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "130"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "14|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2378]"
                                        ],
                                        "(0$1)",
                                        "$CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:30|[89])"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "163\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    "1631234",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25-79]\\d\\d|800)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:2\\d|8[1-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5212345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5601234"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:28\\d|501)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5011234"
                                ],
                                "AW",
                                297,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[25-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AX: [
                                ,
                                [
                                    ,
                                    ,
                                    "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[1-8]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    "181234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]00\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "600123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AX",
                                358,
                                "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "18",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "10112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "123123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "401234567"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "881234567"
                                ],
                                [
                                    ,
                                    ,
                                    "900200\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "900200123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AZ",
                                994,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[28]|2|365|46",
                                            "1[28]|2|365[45]|46",
                                            "1[28]|2|365(?:4|5[02])|46"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[28]|2|365|46",
                                            "1[28]|2|365[45]|46",
                                            "1[28]|2|365(?:4|5[02])|46"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BA: [
                                ,
                                [
                                    ,
                                    ,
                                    "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "30212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "61123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0246]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[12]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "82123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BA",
                                387,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[1-3]|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "[3-5]|6[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[1-3]|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "[3-5]|6[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70341234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BB: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:246|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2464123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "2462501234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:246976|900[2-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9002123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "24631\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2463101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "BB",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "246$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "246",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2464301234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "27111234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1812345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[03]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9604123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "BD",
                                880,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1-$2",
                                        [
                                            "31[5-8]|[459]1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1-$2",
                                        [
                                            "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,6})",
                                        "$1-$2",
                                        [
                                            "[13-9]|2[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7,8})",
                                        "$1-$2",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BE: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{8}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "470123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7879\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "78791234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BE",
                                32,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:80|9)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[239]|4[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[15-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "78102345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[025-7]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20491234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BF",
                                226,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[025-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BG: [
                                ,
                                [
                                    ,
                                    ,
                                    "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        12
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "2123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "43012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:00800\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BG",
                                359,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "43[1-6]|70[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:70|8)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "43[1-7]|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[48]|9[08]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "43[1-6]|70[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:70|8)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "43[1-7]|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[48]|9[08]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[136-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "17001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "36001234"
                                ],
                                [
                                    ,
                                    ,
                                    "8[02369]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:87|9[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    "84\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "84123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BH",
                                973,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[13679]|8[02-4679]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[267]\\d|31)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22|31)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:29|6[124-9]|7[125-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "79561234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BI",
                                257,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2367]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01\\d|[24-689])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "0120211234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "0195123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "857[58]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "85751234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "BJ",
                                229,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-689]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "81123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590271234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "BL",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:441|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4414123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4413701234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "441$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "441",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22[89]|[78]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[34]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "5345678"
                                ],
                                "BN",
                                673,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-578]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BO: [
                                ,
                                [
                                    ,
                                    ,
                                    "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "71234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8001[07]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "800171234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "50123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                "BO",
                                591,
                                "00(?:1\\d)?",
                                "0",
                                ,
                                ,
                                "0(1\\d)?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[235]|4[46]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "[67]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8001[07]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[34]1|7\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "7151234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3181234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BQ",
                                599,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "[347]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "11961234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[59]00\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "500123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370|864))\\d{4}|300\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "40041234",
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BR",
                                55,
                                "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
                                "0",
                                ,
                                ,
                                "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
                                "$2",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3,6})",
                                        "$1",
                                        [
                                            "1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "300|4(?:0[02]|37|86)",
                                            "300|4(?:0(?:0|20)|370|864)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-57]",
                                            "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:[358]|90)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[16][1-9]|[2-57-9]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "300|4(?:0[02]|37|86)",
                                            "300|4(?:0(?:0|20)|370|864)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:[358]|90)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[16][1-9]|[2-57-9]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|864))\\d{4}|800\\d{6,7}|300\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:242|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2423456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2423591234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([3-8]\\d{6})$|1",
                                "242$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "242",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242225\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2422250123"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d{7}|[2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2345678",
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[67]|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "17123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BT",
                                975,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-68]|7[246]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[67]|7"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-68]|7[246]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[67]|7"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2401234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:321|7[1-8]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0800|800\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "0800012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "79(?:1(?:[0-2]\\d|3[0-8])|2[0-7]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "79101234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "BW",
                                267,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "90"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[24-6]|3[15-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[37]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "152450911",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "294911911",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8011234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:810|902)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9021234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "249\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "249123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "BY",
                                375,
                                "810",
                                "8",
                                ,
                                ,
                                "0|80?",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "8 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "800"
                                        ],
                                        "8 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                                            "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "1(?:[56]|7[467])|2[1-3]"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[1-4]"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "8 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800\\d|[2-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2221234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[0-35-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6221234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "08001234123",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BZ",
                                501,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                                        "$1-$2-$3-$4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{9}|3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5062345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5062345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5219023456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "6002012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "CA",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "310\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3101234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "891621234",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CC",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "([59]\\d{7})$|0",
                                "8$1",
                                "0011",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1234567"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "991234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CD",
                                243,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[1-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CF: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[27]\\d{3}|8776)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[12]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21612345"
                                ],
                                [
                                    ,
                                    ,
                                    "7[024-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8776\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "87761234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CF",
                                236,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[278]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CG: [
                                ,
                                [
                                    ,
                                    ,
                                    "222\\d{6}|(?:0\\d|80)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "222[1-589]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "061234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-2]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CG",
                                242,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[02]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CH: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{11}|[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[89]|7[235-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "781234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[016]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84[0248]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "840123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "878\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "878123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CH",
                                41,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8[047]|90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-79]|81"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "74[0248]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "740123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[18]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "581234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "860\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "860123456789",
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ]
                            ],
                            CI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[02]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2123456789"
                                ],
                                [
                                    ,
                                    ,
                                    "0[157]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "0123456789"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CI",
                                225,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[13-7]|4[1-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "21234"
                                ],
                                [
                                    ,
                                    ,
                                    "[578]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CK",
                                682,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[2-578]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CL: [
                                ,
                                [
                                    ,
                                    ,
                                    "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "221234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "221234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:123|8)00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "6001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "44\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "441234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CL",
                                56,
                                "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "1(?:[03-589]|21)|[29]0|78"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219",
                                            "2196"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[1-36]"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "60"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219",
                                            "2196"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[1-36]"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "60"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "600\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[26]\\d{8}|88\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:22|33)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "222123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "671234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "88012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CM",
                                237,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "88"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[26]|88"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                                    ,
                                    ,
                                    ,
                                    "1012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "13123456789",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:10|21)8|8)00\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "16[08]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "16812345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    "4001234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CN",
                                86,
                                "00|1(?:[12]\\d|79)\\d\\d00",
                                "0",
                                ,
                                ,
                                "(1(?:[12]\\d|79)\\d\\d)|0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5,6})",
                                        "$1",
                                        [
                                            "1(?:00|2[13])|9[56]",
                                            "1(?:00|2(?:1|39))|9[56]",
                                            "1(?:00|2(?:1|395))|9[56]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5,6})",
                                        "$1",
                                        [
                                            "1(?:0|23)|781|[1-9]12",
                                            "1(?:0|23)|7812|[1-9]123",
                                            "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                                            "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]",
                                            "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
                                            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
                                            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
                                            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "16[08]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                                            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                                            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                                            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]",
                                            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
                                            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
                                            "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:4|80)0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-578]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[12]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                                            "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                                            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                                            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                                            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:4|80)0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-578]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[12]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ],
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[18][1-9]|[24-7][2-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "6012345678",
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "3211234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:19(?:0[01]|4[78])|901)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "19001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CO",
                                57,
                                "00(?:4(?:[14]4|56)|[579])",
                                "0",
                                ,
                                ,
                                "0([3579]|4(?:[14]4|56))?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "46"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "6|90"
                                        ],
                                        "($1)",
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3[0-357]|9[14]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{7})",
                                        "$1-$2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "46"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "6|90"
                                        ],
                                        "($1)",
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3[0-357]|9[14]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{7})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "83123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[059]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "40001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "CR",
                                506,
                                "00",
                                ,
                                ,
                                ,
                                "(19(?:0[0-2468]|1[09]|20|66|77|99))",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-7]|8[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[89]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        10
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "71234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5\\d|6[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "807\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8071234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CU",
                                53,
                                "119",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "2[1-4]|[34]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-59]\\d\\d|800)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2211234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:36|5[1-389]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9911234"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[3-5]|4[356])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3401234"
                                ],
                                "CV",
                                238,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[2-589]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "94351234"
                                ],
                                [
                                    ,
                                    ,
                                    "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "95181234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CW",
                                599,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[3467]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9[4-8]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "955\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "95581234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                1,
                                "[69]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CX: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "891641234",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CX",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "([59]\\d{7})$|0",
                                "8$1",
                                "0011",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[279]\\d|[58]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[2-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22345678"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:10|[4-79]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "96123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80001234"
                                ],
                                [
                                    ,
                                    ,
                                    "90[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345"
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CY",
                                357,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[257-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:50|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-2]|[2379]\\d\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "601123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[05689]|76)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[134]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "811234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[17]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "910123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CZ",
                                420,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-8]|9[015-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "96"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:5\\d|7[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "972123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:3\\d{9}|6\\d{7,10})",
                                    ,
                                    ,
                                    ,
                                    "93123456789"
                                ]
                            ],
                            DE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ],
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                                    ,
                                    ,
                                    ,
                                    "30123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ],
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:5(?:[0-25-9]\\d\\d|310)|7[26]\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "15123456789",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,12}",
                                    ,
                                    ,
                                    ,
                                    "8001234567890",
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18012345",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "70012345678",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DE",
                                49,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,13})",
                                        "$1 $2",
                                        [
                                            "3[02]|40|[68]9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                                            "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,11})",
                                        "$1 $2",
                                        [
                                            "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                                            "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "138"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{2,10})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,11})",
                                        "$1 $2",
                                        [
                                            "181"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{4,10})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:3|80)|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,12})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "185",
                                            "1850",
                                            "18500"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "18[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "15[1279]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "15[03568]",
                                            "15(?:[0568]|31)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{8})",
                                        "$1 $2",
                                        [
                                            "18"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{7,8})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:6[023]|7)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{7})",
                                        "$1 $2 $3",
                                        [
                                            "15[279]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{8})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "16(?:4\\d{1,10}|[89]\\d{1,11})",
                                    ,
                                    ,
                                    ,
                                    "16412345",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18(?:1\\d{5,11}|[2-9]\\d{8})",
                                    ,
                                    ,
                                    ,
                                    "18500123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "177991234567",
                                    ,
                                    ,
                                    [
                                        12,
                                        13
                                    ]
                                ]
                            ],
                            DJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2\\d|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1[2-5]|7[45])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21360003"
                                ],
                                [
                                    ,
                                    ,
                                    "77\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77831001"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DJ",
                                253,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[27]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "32123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "34412345"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DK",
                                45,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|767|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7674201234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7672251234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "767$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "767",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8092345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[024]9[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8092345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DO",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "8001|8[024]9",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-4]|[5-79]\\d|80)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "551234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[3-689]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "808123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[12]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "801123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "98[23]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "983123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "DZ",
                                213,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-8]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-7][2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "991234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7}|1[78]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-7]890\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "28901234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "EC",
                                593,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[2-7]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EE: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3212345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40\\d\\d|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[0-2]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "EE",
                                372,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                                            "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "[45]|8(?:00|[1-49])",
                                            "[45]|8(?:00[1-9]|[1-49])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800[2-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "234567890",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[0-25]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "1001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "EG",
                                20,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "1[35]|[4-6]|8[2468]|9[235-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[5-8]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "528[89]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "528812345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "650123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "891234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "592401234"
                                ],
                                "EH",
                                212,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "528[89]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ER: [
                                ,
                                [
                                    ,
                                    ,
                                    "[178]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8370362",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:17[1-3]|7\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ER",
                                291,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[178]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ES: [
                                ,
                                [
                                    ,
                                    ,
                                    "[5-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "[89]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[367]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "803123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90[12]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "901123456"
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ES",
                                34,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "905"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[79]9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]00"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]00"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "51\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "511234567"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ET: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:11|[2-579]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "111112345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "911234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ET",
                                251,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-579]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    "131234567",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]00\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "600123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FI",
                                358,
                                "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "75[12]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "20[2-59]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "11"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "(?:[1-3]0|[68])0|70[07-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,8})",
                                        "$1 $2",
                                        [
                                            "[14]|2[09]|50|7[135]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,10})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4,9})",
                                        "$1 $2",
                                        [
                                            "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "20[2-59]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "(?:[1-3]0|[68])0|70[07-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,8})",
                                        "$1 $2",
                                        [
                                            "[14]|2[09]|50|7[135]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,10})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4,9})",
                                        "$1 $2",
                                        [
                                            "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "1[03-79]|[2-9]",
                                [
                                    ,
                                    ,
                                    "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "10112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3212345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "08001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FJ",
                                679,
                                "0(?:0|52)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[235-9]|45"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-7]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-47]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "31234"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "51234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FK",
                                500,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[39]\\d\\d|820)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3201234"
                                ],
                                [
                                    ,
                                    ,
                                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3501234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FM",
                                691,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[389]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20|[34]\\d|8[19])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[27][1-9]|5\\d|9[16])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "211234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[257-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "802123"
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "901123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[0-36]|88)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "601234"
                                ],
                                "FO",
                                298,
                                "00",
                                ,
                                ,
                                ,
                                "(10(?:01|[12]0|88))",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[2-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "123456789"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[01]|2[0156]|4[024]|84)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "884012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                "FR",
                                33,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "10"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[1-79]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[1-79]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[6-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "806123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[01]1\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "01441234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "06031234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GA",
                                241,
                                "00",
                                ,
                                ,
                                ,
                                "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
                                "$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "11|[67]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1212345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7400123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{7}|800\\d{6}|8001111",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "GB",
                                44,
                                "00",
                                "0",
                                " x",
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "800",
                                            "8001",
                                            "80011",
                                            "800111",
                                            "8001111"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "845",
                                            "8454",
                                            "84546",
                                            "845464"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "1(?:38|5[23]|69|76|94)",
                                            "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                                            "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "1(?:[2-69][02-9]|[78])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[25]|7(?:0|6[02-9])",
                                            "[25]|7(?:0|6(?:[03-9]|2[356]))"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1389]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[0347]|55)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:473|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4732691234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4734031234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GD",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "473$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "473",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3-57]\\d\\d|800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "322123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "555123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[67]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "706123456"
                                ],
                                "GE",
                                995,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "32"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[57]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[348]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "70[67]\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GF: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "594101234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "694201234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "GF",
                                594,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-7]|9[47]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1481[25-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1481256789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7781123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{7}|800\\d{6}|8001111",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "GG",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([25-9]\\d{5})$|0",
                                "1481$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[0347]|55)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[235]\\d{3}|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "302345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "231234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GH",
                                233,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[237]|8[0-2]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[235]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[235]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25]\\d|60)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20012345"
                                ],
                                [
                                    ,
                                    ,
                                    "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "57123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GI",
                                350,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:19|[2-689]\\d|70)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "321000"
                                ],
                                [
                                    ,
                                    ,
                                    "[245]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "221234"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "801234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[89]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "381234"
                                ],
                                "GL",
                                299,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "19|[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "5661234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[23679]\\d|4[015]|5[0-489])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GM",
                                220,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GN: [
                                ,
                                [
                                    ,
                                    ,
                                    "722\\d{6}|(?:3|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30241234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[0-356]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "722\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "722123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "GN",
                                224,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "3"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[67]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GP: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "GP",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "333091234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:222|55\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GQ",
                                240,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[235]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GR: [
                                ,
                                [
                                    ,
                                    ,
                                    "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "6912345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "90[19]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[16]|12|[27]5|50)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8011234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GR",
                                30,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "21|7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2689]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5005000\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "5005000123",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GT: [
                                ,
                                [
                                    ,
                                    ,
                                    "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[267][2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22456789",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[01]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "18001112222",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "19\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "19001112222",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GT",
                                502,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|671|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6713001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6713001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GU",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "671$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "671",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[49]\\d{8}|4\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "443\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "443201234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:5\\d|6[569]|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "955012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "40\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "GW",
                                245,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "40"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-8]\\d{3}|9008)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:510|6\\d\\d|7(?:[0-5]\\d|6[01]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6091234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:289|8(?:00|6[28]|88|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2891234"
                                ],
                                [
                                    ,
                                    ,
                                    "9008\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9008123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "515\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5151234"
                                ],
                                "GY",
                                592,
                                "001",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HK: [
                                ,
                                [
                                    ,
                                    ,
                                    "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:44[0-35-9]|6(?:1[0-79]|4[0-57-9]|6[0-4])|7(?:[26][0-5]|4[0-48]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[015])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                                    ,
                                    ,
                                    ,
                                    "90012345678",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "81123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HK",
                                852,
                                "00(?:30|5[09]|[126-9]?)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,5})",
                                        "$1 $2",
                                        [
                                            "900",
                                            "9003"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30161234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HN: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{10}|[237-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[37-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "91234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8002\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "80021234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HN",
                                504,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[237-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[237-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8002\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "921234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "6[01459]\\d{6}|6[01]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[45]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "74123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HR",
                                385,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[01]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "6|7[245]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-57]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "62\\d{6,7}|72\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "62123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-489]\\d|55)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2\\d|5[1-5]|81|9[149])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22453300"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[34]\\d|55)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "34101234"
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "98901234"
                                ],
                                "HT",
                                509,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-589]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[235-7]\\d{8}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[257]0|3[01])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "201234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[48]0\\d|680[29])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "9[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "HU",
                                36,
                                "00",
                                "06",
                                ,
                                ,
                                "06",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "(06 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                                        ],
                                        "(06 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        "06 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[48]0\\d|680[29])\\d{5}"
                                ],
                                [
                                    ,
                                    ,
                                    "38\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "381234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ID: [
                                ,
                                [
                                    ,
                                    ,
                                    "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    "218350123",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[1-35-9]\\d{7,10}",
                                    ,
                                    ,
                                    ,
                                    "812345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8041234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ID",
                                62,
                                "00[89]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,9})",
                                        "$1 $2",
                                        [
                                            "2[124]|[36]1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,8})",
                                        "$1 $2",
                                        [
                                            "[2-79]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "8[1-35-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "804"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})",
                                        "$1 $2 $3 $4",
                                        [
                                            "001"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,9})",
                                        "$1 $2",
                                        [
                                            "2[124]|[36]1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,8})",
                                        "$1 $2",
                                        [
                                            "[2-79]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "8[1-35-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "804"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "001803\\d{5,11}|(?:007803\\d|8071)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1500|8071\\d{3})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8071123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2212345",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:22|[35-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "850123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1520123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[59]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1850123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "76\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "761234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "IE",
                                353,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2[24-9]|47|58|6[237-9]|9[35-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[45]0"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2569]|4[1-69]|7[14]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "81"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18[59]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "818\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "818123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8551234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ]
                            ],
                            IL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        11,
                                        12
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "502345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:255|80[019]\\d{3})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1919123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1700123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:38(?:[05]\\d|8[08])|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "771234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "IL",
                                972,
                                "0(?:0|1[2-9])",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "125"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "121"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-489]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "12"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "159"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3-$4",
                                        [
                                            "1[7-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                                        "$1-$2 $3-$4",
                                        [
                                            "15"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1599\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1599123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "151\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    "15112340000",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            IM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1624(?:230|[5-8]\\d\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1624756789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7924123456"
                                ],
                                [
                                    ,
                                    ,
                                    "808162\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8081624567"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9016247890"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678"
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678"
                                ],
                                "IM",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([25-8]\\d{5})$|0",
                                "1624$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "74576|(?:16|7[56])24",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5512345678"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7410410123",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",
                                    ,
                                    ,
                                    ,
                                    "1800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "186[12]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "1861123456789",
                                    ,
                                    ,
                                    [
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1860\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18603451234",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IN",
                                91,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{7})",
                                        "$1",
                                        [
                                            "575"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "5(?:0|2[23]|3[03]|[67]1|88)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1800"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "140"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                                            "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                                            "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                                            "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[6-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:6|8[06])",
                                            "1(?:6|8[06]0)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "18"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "5(?:0|2[23]|3[03]|[67]1|88)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1800"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "140"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                                            "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                                            "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                                            "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[6-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:6|8[06])",
                                            "1(?:6|8[06]0)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "18"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"
                                ],
                                [
                                    ,
                                    ,
                                    "140\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1409305260",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IO: [
                                ,
                                [
                                    ,
                                    ,
                                    "3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "37\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3709100"
                                ],
                                [
                                    ,
                                    ,
                                    "38\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3801234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IO",
                                246,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[3-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7912345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IQ",
                                964,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        10
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IR",
                                98,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "96"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-8]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
                                    ,
                                    ,
                                    ,
                                    "9601",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:38\\d|[4-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4101234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6111234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "49[0-24-79]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4921234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "IS",
                                354,
                                "00|1(?:0(?:01|[12]0)|100)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[4-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8091234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:689|8(?:7[18]|80)|95[48])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6891234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ]
                            ],
                            IT: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    "0212345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "3123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:0\\d{3}|3)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "899123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84(?:[08]\\d{3}|[17])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "848123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:78\\d|99)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1781234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "IT",
                                39,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "1(?:0|9[246])",
                                            "1(?:0|9(?:2[2-9]|[46]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1(?:1|92)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                                            "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,6})",
                                        "$1 $2",
                                        [
                                            "0(?:[13-579][2-46-8]|8[236-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "894"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:44|[679])|[378]|43"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[13-57-9][0159]|14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                                            "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,6})",
                                        "$1 $2",
                                        [
                                            "0(?:[13-579][2-46-8]|8[236-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "894"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:44|[679])|[378]|43"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[13-57-9][0159]|14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    "848\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "3[2-8]\\d{9,10}",
                                    ,
                                    ,
                                    ,
                                    "33101234501",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            JE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1534[0-24-8]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1534456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7797712345"
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:07(?:35|81)|8901)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8007354567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9018105678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "701511\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7015115678"
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678"
                                ],
                                "JE",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([0-24-8]\\d{5})$|0",
                                "1534$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5512345678"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|658|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8765230123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8762101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "JM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "658|876",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "62001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[78][0-25-9]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "790123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "JO",
                                962,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2356]|87"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "74(?:66|77)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "746612345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:10|8\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88101234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JP: [
                                ,
                                [
                                    ,
                                    ,
                                    "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "312345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[7-9]0[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",
                                    ,
                                    ,
                                    ,
                                    "120123456"
                                ],
                                [
                                    ,
                                    ,
                                    "990\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "990123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "JP",
                                81,
                                "010",
                                "0",
                                ,
                                ,
                                "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
                                "$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "007",
                                            "0077",
                                            "00777",
                                            "00777[01]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "(?:12|57|99)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "60"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[36]|4(?:2[09]|7[01])",
                                            "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{3,4})",
                                        "$1-$2-$3",
                                        [
                                            "007",
                                            "0077"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "008"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[257-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})(\\d{5,6})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})(\\d{6,7})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "(?:12|57|99)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "60"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[36]|4(?:2[09]|7[01])",
                                            "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[257-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "2012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"
                                ],
                                [
                                    ,
                                    ,
                                    "570\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "570123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "202012345",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[02-8]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "800223456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[02-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900223456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KE",
                                254,
                                "000",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "[24-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[17]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KG: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{9}|[235-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KG",
                                996,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "3(?:1[346]|[24-79])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[235-79]|88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{9}|[1-9]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                                    ,
                                    ,
                                    ,
                                    "23756789",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "91234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800(?:1\\d|2[019])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900(?:1\\d|2[09])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KH",
                                855,
                                "00[14-9]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "31234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "72001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "30010000",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "KI",
                                686,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[3478]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[4-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7712345",
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[34]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "3212345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KM",
                                269,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[3478]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8692361234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8697652917",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KN",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "869$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "869",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KP: [
                                ,
                                [
                                    ,
                                    ,
                                    "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "19[1-3]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1921234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KP",
                                850,
                                "00|99",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KR: [
                                ,
                                [
                                    ,
                                    ,
                                    "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ],
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "1020000000",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "602345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "KR",
                                82,
                                "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
                                "0",
                                ,
                                ,
                                "0(8(?:[1-46-8]|5\\d\\d))?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "1[016-9]1",
                                            "1[016-9]11",
                                            "1[016-9]114"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1-$2",
                                        [
                                            "(?:3[1-3]|[46][1-4]|5[1-5])1"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[36]0|8"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[1346]|5[1-5]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "003",
                                            "0030"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "5"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1-$2",
                                        [
                                            "(?:3[1-3]|[46][1-4]|5[1-5])1"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[36]0|8"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[1346]|5[1-5]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "5"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "1523456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "15441234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KW: [
                                ,
                                [
                                    ,
                                    ,
                                    "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "50012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1801234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KW",
                                965,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "[169]|2(?:[235]|4[1-35-9])|52"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[245]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:345|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3452221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3453231234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:345976|900[2-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KY",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "345$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "345",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        14
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "7710009998",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|108\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8081234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "751\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "7511234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "KZ",
                                7,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "33|7",
                                [
                                    ,
                                    ,
                                    "751\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21212862",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2023123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LA",
                                856,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2[13]|3[14]|[4-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[27-9]\\d{7}|[13-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:62|8[0-6]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[1-3]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LB",
                                961,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[27-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|758|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7584305678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7582845678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-8]\\d{6})$|1",
                                "758$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "758",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:01|1[27]|2[024]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2345678",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:(?:4[5-9]|5[0-46-9])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "660234567"
                                ],
                                [
                                    ,
                                    ,
                                    "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8002222"
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "9002222",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LI",
                                423,
                                "00",
                                "0",
                                ,
                                ,
                                "(1001)|0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[2379]|8(?:0[09]|7)",
                                            "[2379]|8(?:0(?:02|9)|7)"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "69"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "870(?:28|87)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "8702812",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "697(?:42|56|[78]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "697861234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ]
                            ],
                            LK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[0-25-8]\\d|4[0-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LK",
                                94,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[1-689]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1973\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "197312345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "770123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "332(?:02|[34]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "332021234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LR",
                                231,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4[67]|[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-578]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[256]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "22123456"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "50123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800[1256]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80021234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LS",
                                266,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2568]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3469]\\d|52|[78]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[1478]|4[124-6]|52)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "31234567"
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "61234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[02]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[0239]|10)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80812345"
                                ],
                                [
                                    ,
                                    ,
                                    "70[05]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    "[89]01\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                "LT",
                                370,
                                "00",
                                "0",
                                ,
                                ,
                                "[08]",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "52[0-7]"
                                        ],
                                        "(0-$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "0 $1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "37|4(?:[15]|6[1-8])"
                                        ],
                                        "(0-$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[3-6]"
                                        ],
                                        "(0-$1)",
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[67]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70712345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LU: [
                                ,
                                [
                                    ,
                                    ,
                                    "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    "27123456"
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "628123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[015]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:1\\d{5}|[2-689]\\d{1,7})",
                                    ,
                                    ,
                                    ,
                                    "20201234",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                "LU",
                                352,
                                "00",
                                ,
                                ,
                                ,
                                "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "20[2-689]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2(?:[0367]|4[3-8])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "80[01]|90[015]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "20"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "2(?:[0367]|4[3-8])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[268]\\d|90)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "63123456"
                                ],
                                [
                                    ,
                                    ,
                                    "2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    "81\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "81123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LV",
                                371,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[269]|8[01]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-6]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LY",
                                218,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[5-8]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "520123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "650123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "891234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "592401234"
                                ],
                                "MA",
                                212,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5[45]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1-$2",
                                        [
                                            "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "[5-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3489]|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:870|9[2-47-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "99123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:800|90\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MC",
                                377,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[389]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[389]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8[07]0\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[235-7]\\d|[89]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22212345"
                                ],
                                [
                                    ,
                                    ,
                                    "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "62112345"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "90[056]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80812345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "30123456"
                                ],
                                "MD",
                                373,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "22|3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[25-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "803\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80312345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ME: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "30234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "67622901",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:[0-2578]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80080002"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:4[1568]|5[178])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "94515151",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78[1-49]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "78108780",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "ME",
                                382,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "77[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "77273012",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MF: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590271234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "MF",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[23]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "202123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2-47-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "321234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "221234567"
                                ],
                                "MG",
                                261,
                                "00",
                                "0",
                                ,
                                ,
                                "([24-9]\\d{6})$|0",
                                "20$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MH: [
                                ,
                                [
                                    ,
                                    ,
                                    "329\\d{4}|(?:[256]\\d|45)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:247|528|625)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2471234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:23|54)5|329|45[35-8])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2351234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "635\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6351234"
                                ],
                                "MH",
                                692,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-6]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22012345",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "72345678"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "5\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "50012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[1-9]|[1-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MK",
                                389,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2|34[47]|4(?:[37]7|5[47]|64)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[347]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[58]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ML: [
                                ,
                                [
                                    ,
                                    ,
                                    "[24-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "20212345"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "65012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ML",
                                223,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "67[057-9]|74[045]",
                                            "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "80\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "92123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80080(?:0[1-9]|2\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8008001234",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1333\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "13331234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "MM",
                                95,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "16|2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[12]|452|678|86",
                                            "[12]|452|6788|86"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[4-7]|8[1-35]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4,6})",
                                        "$1 $2 $3",
                                        [
                                            "9(?:2[0-4]|[35-9]|4[137-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "92"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{5})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{7,9}|[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "53123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:83[01]|92[0139])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "88123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "75123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "MN",
                                976,
                                "001",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[12]1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[5-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[12]2[1-3]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                                            "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "[12]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MO: [
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "28212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "66123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "0800501",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MO",
                                853,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[268]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[58]\\d{9}|(?:67|90)0\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6702345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6702345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MP",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "670$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "670",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "596301234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69[67]\\d\\d|7091[0-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "696201234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8[129]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976612345"
                                ],
                                "MQ",
                                596,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-79]|8(?:0[6-9]|[36])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-4]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:25[08]|35\\d|45[1-7])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "35123456"
                                ],
                                [
                                    ,
                                    ,
                                    "[2-4][0-46-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MR",
                                222,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-48]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|664|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6644(?:1[0-3]|91)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6644912345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6644923456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([34]\\d{6})$|1",
                                "664$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "664",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MT: [
                                ,
                                [
                                    ,
                                    ,
                                    "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "96961234"
                                ],
                                [
                                    ,
                                    ,
                                    "800(?:02|[3467]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "80071234"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "50037123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3550\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "35501234"
                                ],
                                "MT",
                                356,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2357-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7117\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71171234"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "501\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "50112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[0346-8]\\d|1[0-8])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "54480123",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-6]|3[013]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "52512345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "802\\d{7}|80[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:20|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3201234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "MU",
                                230,
                                "0(?:0|[24-7]0|3[03])",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "020",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-46]|8[013]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[57]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "219\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2190123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6701234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:46[46]|[79]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7712345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MV",
                                960,
                                "0(?:0|19)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[34679]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:0[01]|50)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1234567"
                                ],
                                [
                                    ,
                                    ,
                                    "111\\d{6}|(?:31|77|[89][89])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "991234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MW",
                                265,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[2-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[137-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2001234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2221234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "300\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "500\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5001234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MX",
                                52,
                                "0[09]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "53"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "33|5[56]|81"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "33|5[56]|81"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "427[01]\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "323856789",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[378]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1600\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1600123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1546012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "MY",
                                60,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "[4-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1-$2 $3",
                                        [
                                            "1(?:[02469]|[378][1-9]|53)|8",
                                            "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3-$4",
                                        [
                                            "1(?:[367]|80)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "15"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2|8\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[2-79]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "821234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MZ",
                                258,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2|8[2-79]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "61221234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:60|8[1245])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "811234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8701\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "870123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:3\\d\\d|86)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88612345"
                                ],
                                "NA",
                                264,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:050|[2-57-9]\\d\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[579]\\d|8[0-79])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "751234"
                                ],
                                [
                                    ,
                                    ,
                                    "050\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "050012"
                                ],
                                [
                                    ,
                                    ,
                                    "36\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "366711"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NC",
                                687,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})",
                                        "$1",
                                        [
                                            "5[6-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1.$2.$3",
                                        [
                                            "[02-57-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1.$2.$3",
                                        [
                                            "[02-57-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[027-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:23|7[0467]|[89]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "93123456"
                                ],
                                [
                                    ,
                                    ,
                                    "08\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "08123456"
                                ],
                                [
                                    ,
                                    ,
                                    "09\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "09123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NE",
                                227,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "08"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[089]|2[013]|7[0467]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "106609",
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:14|3[58])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "381234",
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NF",
                                672,
                                "00",
                                ,
                                ,
                                ,
                                "([0-258]\\d{4})$",
                                "3$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "1[0-3]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[13]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:20|9\\d)\\d{8}|[78]\\d{9,13}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2033123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8021234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,11}",
                                    ,
                                    ,
                                    ,
                                    "80017591759"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NG",
                                234,
                                "009",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "20[129]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})(\\d{5,6})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{7,11}",
                                    ,
                                    ,
                                    ,
                                    "7001234567"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1800|[25-8]\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "21234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81234567"
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NI",
                                505,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[125-8]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "101234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[1-58]|970\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[069]\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "9061234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:85|91)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "851234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "NL",
                                31,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "1[238]|[34]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,7})",
                                        "$1 $2",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "66"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{8})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-578]|91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,7})",
                                        "$1 $2",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "66"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{8})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-578]|91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "66\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "662345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
                                    ,
                                    ,
                                    ,
                                    "14020",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0|[2-9]\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[015-8]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "40612345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[01]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "82[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "82012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "81021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "880\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85[0-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "NO",
                                47,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-79]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "[02-689]|7[0-8]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "02000"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "81[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ]
                            ],
                            NP: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "14567890",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9841234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:66001|800\\d\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "16600101234",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NP",
                                977,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1-$2",
                                        [
                                            "1[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1-$2",
                                        [
                                            "1[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4441234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5551234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NR",
                                674,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[24-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[4-7]|888\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[47]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "7012",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[56]|888[1-9])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8884012"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NU",
                                683,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "32345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "508\\d{6,7}|80\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NZ",
                                64,
                                "0(?:0|161)",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,8})",
                                        "$1 $2",
                                        [
                                            "8[1-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "50[036-8]|8|90",
                                            "50(?:[0367]|88)|8|90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "24|[346]|7[2-57-9]|9[2-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:10|74)|[589]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1|2[028]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,5})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:[169]|7[0-35-9])|7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    "83012378"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            OM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[1-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "23123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "92123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8007\\d{4,5}|(?:500|800[05])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80071234"
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "OM",
                                968,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "[58]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[179]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[047-9]\\d|1[0-8]|2[0-5]|33|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[4-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "61234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,5}|(?:00800|800\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8601234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PA",
                                507,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-57-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[68]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[14-8]|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "11234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "805\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80512345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[24]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PE",
                                51,
                                "00|19(?:1[124]|77|90)00",
                                "0",
                                " Anexo ",
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[4-8]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PF: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:0[4-689]|9[4-68])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "40412345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[7-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "87123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "499\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "49901234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "PF",
                                689,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "4|8[7-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "44\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "44\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "440123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3123456",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7\\d|8[1-38])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1801234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[0-57]|7[568])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2751234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "PG",
                                675,
                                "00|140[1-3]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "18|[2-69]|85"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[78]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "27[01]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2700123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "232345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9051234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    "180012345678",
                                    ,
                                    ,
                                    [
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PH",
                                63,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                                            "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "346|4(?:27|9[35])|883",
                                            "3469|4(?:279|9(?:30|56))|8834"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-7]|8[2-8]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PK: [
                                ,
                                [
                                    ,
                                    ,
                                    "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "122\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "122044444",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PK",
                                92,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,7})",
                                        "$1 $2 $3",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                                            "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "58"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21111825888",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "512345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[01346-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "39\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "391234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "PL",
                                48,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "11|20|64"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                                            "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "64"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[2-8]|[2-7]|8[1-79]|9[145]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "64\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "641234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "804123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "430123"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "551234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[129]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "810123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PM",
                                508,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[45]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[589]\\d\\d|787)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:787|939)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7872345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:787|939)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7872345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PR",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "787|939",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[69]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "599123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1700123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PS",
                                970,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2489]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "212345678"
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    "80[02]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "760123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:8\\d|9[1579])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "808123456"
                                ],
                                [
                                    ,
                                    ,
                                    "884[0-4689]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "884123456"
                                ],
                                [
                                    ,
                                    ,
                                    "30\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "301234567"
                                ],
                                "PT",
                                351,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[12]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "16|[236-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "6(?:222\\d|89(?:00|88|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "622212345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "707123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "600110000"
                                ]
                            ],
                            PW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[24-8]\\d\\d|345|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2771234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6201234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PW",
                                680,
                                "01[12]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PY: [
                                ,
                                [
                                    ,
                                    ,
                                    "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "961456789",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9800\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    "98000123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8700[0-4]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "870012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "PY",
                                595,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "[2-9]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "9(?:[5-79]|8[1-7])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-9]0\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "201234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            QA: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "44123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[35-7]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "33123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}|(?:0080[01]|800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "QA",
                                974,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "2[136]|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[3-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "2[136]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2123456",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RE: [
                                ,
                                [
                                    ,
                                    ,
                                    "709\\d{6}|(?:26|[689]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "262161234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "692123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-37-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[019]|2[0156]|84|90)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "939901234"
                                ],
                                "RE",
                                262,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[26-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "211234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712034567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[0136]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RO",
                                40,
                                "00",
                                "0",
                                " int ",
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2[3-6]",
                                            "2[3-6]\\d9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219|31"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[23]1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[236-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:37\\d|80[578])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "372123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RS: [
                                ,
                                [
                                    ,
                                    ,
                                    "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
                                    ,
                                    ,
                                    ,
                                    "10234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[0-689]|7\\d)\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3,9}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:78\\d|90[0169])\\d{3,7}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RS",
                                381,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "(?:2[389]|39)0|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,10})",
                                        "$1 $2",
                                        [
                                            "[1-36]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[06]\\d{4,10}",
                                    ,
                                    ,
                                    ,
                                    "700123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RU: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{13}|[347-9]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        14
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3011234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "9123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[04]|108\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[39]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8081234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RU",
                                7,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "[0-79]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-8]|2[1-9])",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-68]|2[1-9])",
                                            "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                                            "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[349]|8(?:[02-7]|1[1-8])"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "8 ($1)"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-8]|2[1-9])",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-68]|2[1-9])",
                                            "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                                            "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[349]|8(?:[02-7]|1[1-8])"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "8 ($1)"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "3[04-689]|[489]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:06|[27]\\d\\d|[89]00)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:06|2[23568]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "250123456"
                                ],
                                [
                                    ,
                                    ,
                                    "7[237-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "720123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RW",
                                250,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[15]\\d|800|92)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "512345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "925\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "925012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "920\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "920012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SA",
                                966,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[6-9]\\d{6}|[1-6]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "40123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7421234"
                                ],
                                [
                                    ,
                                    ,
                                    "1[38]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "18123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[12]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                "SB",
                                677,
                                "0[01]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2489]\\d|64)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4[2-46]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4217123"
                                ],
                                [
                                    ,
                                    ,
                                    "2[125-8]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2510123"
                                ],
                                [
                                    ,
                                    ,
                                    "800[08]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8000000"
                                ],
                                [
                                    ,
                                    ,
                                    "85\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8512345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "971\\d{4}|(?:64|95)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6412345"
                                ],
                                "SC",
                                248,
                                "010|0[0-2]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[246]|9[57]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5\\d|8[35-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "153123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0-2]|9[0-3569])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "911231234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SD",
                                249,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[19]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "8123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[02369]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "20123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "77[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "771234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "75[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "751234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SE",
                                46,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "20"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "9(?:00|39|44|9)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{3})",
                                        "$1-$2 $3",
                                        [
                                            "9(?:00|39|44)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "10|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1-$2 $3 $4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4 $5",
                                        [
                                            "[26]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "20"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "9(?:00|39|44|9)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9(?:00|39|44)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "10|7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[26]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "74[02-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "740123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "102345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:25[245]|67[3-68])\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "254123456789",
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ]
                            ],
                            SG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "61234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "897[0-5]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-6])|9[0-8]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:18|8)00\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "19001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[12]\\d|666)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "31234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SG",
                                65,
                                "0[0-3]\\d",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "1[013-9]|77",
                                            "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|8(?:0[1-9]|[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|8(?:0[1-9]|[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7000\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "70001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[256]\\d|8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[0-57-9]\\d|6[4-9])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "22158"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "51234",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "262\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "26212",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                "SH",
                                290,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "[256]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[1-357][2-8]|4[24-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "31234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-3]\\d{2,5}|90\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "59012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SI",
                                386,
                                "00|10(?:22|66|88|99)",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "8[09]|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "59|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[37][01]|4[0139]|51|6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[1-57]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{4}|(?:[489]\\d|79)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "79\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "79123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[015-8]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "41234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[01]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "82[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "82012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "81021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "880\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85[0-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SJ",
                                47,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "79",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "02000"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "81[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ]
                            ],
                            SK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "221234567"
                                ],
                                [
                                    ,
                                    ,
                                    "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "912123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:00|[78]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "850123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:02|5[0-4]|9[0-6])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "690123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "SK",
                                421,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[3-5][1-8]1",
                                            "[3-5][1-8]1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "909",
                                            "9090"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1/$2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1/$2 $3 $4",
                                        [
                                            "[3-5]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[3-5][1-8]1",
                                            "[3-5][1-8]1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1/$2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1/$2 $3 $4",
                                        [
                                            "[3-5]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9090\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9090123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "961234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[237-9]\\d|66)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22[2-4][2-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "25123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SL",
                                232,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[236-9]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0549|[5-7]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0549(?:8[0157-9]|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "0549886377",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[16]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "66661212",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[178]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[158]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "58001110",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SM",
                                378,
                                "00",
                                ,
                                ,
                                ,
                                "([89]\\d{5})$",
                                "0549$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[89]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[378]\\d|93)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "301012345"
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "701234567"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "88[4689]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "884123456"
                                ],
                                [
                                    ,
                                    ,
                                    "81[02468]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "933301234"
                                ],
                                "SN",
                                221,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[379]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4012345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SO",
                                252,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "8[125]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[134]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "(?:2|90)4|[67]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[348]|64|79|90"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "1|28|6[0-35-9]|7[67]|9[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-5]|68|[78]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "211234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[124-7]|8[1-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7412345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "561234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                "SR",
                                597,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "56"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-5]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[6-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[89]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "181234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|9[1257-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "977123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SS",
                                211,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[19]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ST: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:22|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2221234"
                                ],
                                [
                                    ,
                                    ,
                                    "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9812345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ST",
                                239,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[29]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "70123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{8}|80[01]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{4}(?:\\d{4})?",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SV",
                                503,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[267]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SX: [
                                ,
                                [
                                    ,
                                    ,
                                    "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7215425678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7215205678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SX",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "(5\\d{6})$|1",
                                "721$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "721",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-39]\\d{8}|[1-5]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "944567890",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SY",
                                963,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-5]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[23][2-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22171234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[6-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "76123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "08001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SZ",
                                268,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[0237]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TA: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TA",
                                290,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "8",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|649|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:266|712|9(?:4\\d|50))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6497121234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6492311234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:71[01]|966)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6497101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "TC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-479]\\d{6})$|1",
                                "649$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "649",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:22|[689]\\d|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22(?:[37-9]0|5[0-5]|6[89])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22501234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[69]\\d|77|8[56])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "63012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TD",
                                235,
                                "00|16",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[26-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[279]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22212345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[0-29]|9[0-36-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90112345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TG",
                                228,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[279]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "812345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:001800\\d|1800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[08]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "TH",
                                66,
                                "00[1-9]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-57-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        3,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "372123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "917123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TJ",
                                992,
                                "810",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})(\\d)(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "331",
                                            "3317"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44[02-479]|[34]7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3(?:[1245]|3[12])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[0-57-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-47]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[2-4]|[34]\\d)\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "3101"
                                ],
                                [
                                    ,
                                    ,
                                    "7[2-4]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "7290"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TK",
                                690,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TL: [
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2112345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TL",
                                670,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-489]|70"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-6]\\d|71)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6\\d|71)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "66123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TM",
                                993,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "12"
                                        ],
                                        "(8 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[1-5]"
                                        ],
                                        "(8 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[67]"
                                        ],
                                        "8 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-57-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "30010123"
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "20123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8010\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80101234"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "88123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8[12]10\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "81101234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TN",
                                216,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-57-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "20123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7715123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "0800222",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55[0-37-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5510123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "TO",
                                676,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[5-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TR: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8[89]8|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "592(?:21[12]|461)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5922121234",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "850\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8500123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "TR",
                                90,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "444"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "512|8[01589]|90"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5(?:[0-59]|61)",
                                            "5(?:[0-59]|61[06])",
                                            "5(?:[0-59]|61[06]1)"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24][1-8]|3[1-9]"
                                        ],
                                        "(0$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{6,7})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "512|8[01589]|90"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5(?:[0-59]|61)",
                                            "5(?:[0-59]|61[06])",
                                            "5(?:[0-59]|61[06]1)"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24][1-8]|3[1-9]"
                                        ],
                                        "(0$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{6,7})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "512\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:444|811\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4441444",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8682211234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8682911234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TT",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-46-8]\\d{6})$|1",
                                "868$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "868",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "868619\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8686191234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ]
                            ],
                            TV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2|7\\d\\d|90)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[02-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "20123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[01]\\d|90)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "901234",
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TV",
                                688,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "90"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "221234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-79]\\d{6}|800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:[013-9]\\d\\d|2)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "203123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "99\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "990123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                "TW",
                                886,
                                "0(?:0[25-79]|19)",
                                "0",
                                "#",
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d)(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "202"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[258]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                                            "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50[0-46-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "500123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25-8]\\d|41|90)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[2-8]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "222345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[125-9]|7[13-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "621234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "900123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:40|6[01])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "840123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "41\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "412345678"
                                ],
                                "TZ",
                                255,
                                "00[056]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[24]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[67]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[89]\\d{9}|[3-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "311234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "501234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-8]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[239]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "900212345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-579]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "UA",
                                380,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "0~0",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                                            "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                                            "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-7]|89|9[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UG: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-8]|9[0189])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678"
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-3]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90[1-3]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "901123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UG",
                                256,
                                "00[057]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "202",
                                            "2024"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[27-9]|4(?:6[45]|[7-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[34]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            US: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{9}|3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2015550123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2015550123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "305209\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3052090123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "US",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "310"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[24-9]|3(?:[02-9]|1[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "($1) $2-$3",
                                        [
                                            "[2-9]"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "310"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UY: [
                                ,
                                [
                                    ,
                                    ,
                                    "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21231234",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "94231234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0004\\d{2,9}|(?:405|80[05])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    "90[0-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UY",
                                598,
                                "0(?:0|1[3-9]\\d)",
                                "0",
                                " int. ",
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[49]0|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[124]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:20|33|[5-9]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "669050123"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UZ",
                                998,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[235-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VA: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "06698\\d{1,6}",
                                    ,
                                    ,
                                    ,
                                    "0669812345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:0\\d{3}|3)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "899123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84(?:[08]\\d{3}|[17])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "848123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:78\\d|99)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1781234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "VA",
                                39,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "06698",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "3[2-8]\\d{9,10}",
                                    ,
                                    ,
                                    ,
                                    "33101234501",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            VC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|784|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7842661234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7844301234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "78451[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7845101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "VC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "784$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "784",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2121234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:1[24-8]|2[246])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "4121234567"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "90[01]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VE",
                                58,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "[24-689]"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "501\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5010123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:284|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2842291234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2843001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VG",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-578]\\d{6})$|1",
                                "284$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "284",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[58]\\d{9}|(?:34|90)0\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3406421234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3406421234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VI",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "340$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "340",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2101234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "672\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "672012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "VN",
                                84,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[17]99"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "69"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[357-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[48]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[357-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[48]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[17]99\\d{4}|69\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "1992000",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "22123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d|7[013-7])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "5912345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81[18]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "81123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[1-9]|1[01])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9010123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "VU",
                                678,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[57-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[03]|900\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "30123"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WF: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "72\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "721234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:72|8[23])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "821234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[23]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "921234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                "WF",
                                681,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[47-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[48]0\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "401234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ]
                            ],
                            WS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7212345",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "WS",
                                685,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "[2-5]|6[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "[68]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            XK: [
                                ,
                                [
                                    ,
                                    ,
                                    "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})",
                                    ,
                                    ,
                                    ,
                                    "28012345"
                                ],
                                [
                                    ,
                                    ,
                                    "4[3-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "43201234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "XK",
                                383,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2|39"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7,10})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[01378]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "712345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "YE",
                                967,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-6]|7(?:[24-6]|8[0-7])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YT: [
                                ,
                                [
                                    ,
                                    ,
                                    "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "269601234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "639012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "939801234"
                                ],
                                "YT",
                                262,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-79]\\d{8}|8\\d{4,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "101234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "711234567",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:86[2-9]|9[0-2]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "862345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "860\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "860123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "871234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "ZA",
                                27,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "8[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "8[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "860"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "861\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "861123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZM: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[59][5-8]|7[5-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "955123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "63\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "630123456"
                                ],
                                "ZM",
                                260,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[28]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[579]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[28]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[579]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZW: [
                                ,
                                [
                                    ,
                                    ,
                                    "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1312345",
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[1278]\\d|3[1-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:[01]\\d|20|8[0-8])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8686123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "ZW",
                                263,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                                            "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                                            "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "29[013-9]|39|54"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "(?:25|54)8",
                                            "258|5483"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            800: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:00|[1-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:00|[1-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                800,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "\\d"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            808: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                808,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            870: [
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{11}|[235-7]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "301234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "201234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "001",
                                870,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[235-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            878: [
                                ,
                                [
                                    ,
                                    ,
                                    "10\\d{10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10\\d{10}",
                                    ,
                                    ,
                                    ,
                                    "101234567890"
                                ],
                                "001",
                                878,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            881: [
                                ,
                                [
                                    ,
                                    ,
                                    "6\\d{9}|[0-36-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{9}|[0-36-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                881,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[0-37-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{5,6})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            882: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3421234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "390123456789"
                                ],
                                "001",
                                882,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "16|342"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "49"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[36]|9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "3[23]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|23|3(?:[15]|4[57])|4|51"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "34"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,5})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[1-35]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "348[57]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "34851234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ]
                            ],
                            883: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-4]\\d|51)\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
                                    ,
                                    ,
                                    ,
                                    "510012345"
                                ],
                                "001",
                                883,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,8})",
                                        "$1 $2 $3",
                                        [
                                            "[14]|2[24-689]|3[02-689]|51[24-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "510"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "51[13]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[235]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            888: [
                                ,
                                [
                                    ,
                                    ,
                                    "\\d{11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                888,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "\\d{11}",
                                    ,
                                    ,
                                    ,
                                    "12345678901"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            979: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1359]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[1359]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                979,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1359]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ]
                        }; /*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.PhoneNumberUtil = function() {
                            this.regionToMetadataMap = {};
                        };
                        goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);
                        i18n.phonenumbers.Error = {
                            INVALID_COUNTRY_CODE: "Invalid country calling code",
                            NOT_A_NUMBER: "The string supplied did not seem to be a phone number",
                            TOO_SHORT_AFTER_IDD: "Phone number too short after IDD",
                            TOO_SHORT_NSN: "The string supplied is too short to be a phone number",
                            TOO_LONG: "The string supplied is too long to be a phone number"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1;
                        i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250;
                        i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ";
                        i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = {
                            54: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [
                            52,
                            54,
                            55
                        ];
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+";
                        i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=";
                        i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "\uff10": "0",
                            "\uff11": "1",
                            "\uff12": "2",
                            "\uff13": "3",
                            "\uff14": "4",
                            "\uff15": "5",
                            "\uff16": "6",
                            "\uff17": "7",
                            "\uff18": "8",
                            "\uff19": "9",
                            "\u0660": "0",
                            "\u0661": "1",
                            "\u0662": "2",
                            "\u0663": "3",
                            "\u0664": "4",
                            "\u0665": "5",
                            "\u0666": "6",
                            "\u0667": "7",
                            "\u0668": "8",
                            "\u0669": "9",
                            "\u06f0": "0",
                            "\u06f1": "1",
                            "\u06f2": "2",
                            "\u06f3": "3",
                            "\u06f4": "4",
                            "\u06f5": "5",
                            "\u06f6": "6",
                            "\u06f7": "7",
                            "\u06f8": "8",
                            "\u06f9": "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "+": i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN,
                            "*": "*",
                            "#": "#"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {
                            A: "2",
                            B: "2",
                            C: "2",
                            D: "3",
                            E: "3",
                            F: "3",
                            G: "4",
                            H: "4",
                            I: "4",
                            J: "5",
                            K: "5",
                            L: "5",
                            M: "6",
                            N: "6",
                            O: "6",
                            P: "7",
                            Q: "7",
                            R: "7",
                            S: "7",
                            T: "8",
                            U: "8",
                            V: "8",
                            W: "9",
                            X: "9",
                            Y: "9",
                            Z: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "\uff10": "0",
                            "\uff11": "1",
                            "\uff12": "2",
                            "\uff13": "3",
                            "\uff14": "4",
                            "\uff15": "5",
                            "\uff16": "6",
                            "\uff17": "7",
                            "\uff18": "8",
                            "\uff19": "9",
                            "\u0660": "0",
                            "\u0661": "1",
                            "\u0662": "2",
                            "\u0663": "3",
                            "\u0664": "4",
                            "\u0665": "5",
                            "\u0666": "6",
                            "\u0667": "7",
                            "\u0668": "8",
                            "\u0669": "9",
                            "\u06f0": "0",
                            "\u06f1": "1",
                            "\u06f2": "2",
                            "\u06f3": "3",
                            "\u06f4": "4",
                            "\u06f5": "5",
                            "\u06f6": "6",
                            "\u06f7": "7",
                            "\u06f8": "8",
                            "\u06f9": "9",
                            A: "2",
                            B: "2",
                            C: "2",
                            D: "3",
                            E: "3",
                            F: "3",
                            G: "4",
                            H: "4",
                            I: "4",
                            J: "5",
                            K: "5",
                            L: "5",
                            M: "6",
                            N: "6",
                            O: "6",
                            P: "7",
                            Q: "7",
                            R: "7",
                            S: "7",
                            T: "8",
                            U: "8",
                            V: "8",
                            W: "9",
                            X: "9",
                            Y: "9",
                            Z: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            A: "A",
                            B: "B",
                            C: "C",
                            D: "D",
                            E: "E",
                            F: "F",
                            G: "G",
                            H: "H",
                            I: "I",
                            J: "J",
                            K: "K",
                            L: "L",
                            M: "M",
                            N: "N",
                            O: "O",
                            P: "P",
                            Q: "Q",
                            R: "R",
                            S: "S",
                            T: "T",
                            U: "U",
                            V: "V",
                            W: "W",
                            X: "X",
                            Y: "Y",
                            Z: "Z",
                            a: "A",
                            b: "B",
                            c: "C",
                            d: "D",
                            e: "E",
                            f: "F",
                            g: "G",
                            h: "H",
                            i: "I",
                            j: "J",
                            k: "K",
                            l: "L",
                            m: "M",
                            n: "N",
                            o: "O",
                            p: "P",
                            q: "Q",
                            r: "R",
                            s: "S",
                            t: "T",
                            u: "U",
                            v: "V",
                            w: "W",
                            x: "X",
                            y: "Y",
                            z: "Z",
                            "-": "-",
                            "\uff0d": "-",
                            "\u2010": "-",
                            "\u2011": "-",
                            "\u2012": "-",
                            "\u2013": "-",
                            "\u2014": "-",
                            "\u2015": "-",
                            "\u2212": "-",
                            "/": "/",
                            "\uff0f": "/",
                            " ": " ",
                            "\u3000": " ",
                            "\u2060": " ",
                            ".": ".",
                            "\uff0e": "."
                        };
                        i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z";
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+\uff0b";
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
                        i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
                        i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+";
                        i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]");
                        i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/;
                        i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/;
                        i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*";
                        i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]|" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ + ")";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*$";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_);
                        i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ = i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_;
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_ = "^(" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ + "\\.)*" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ + "\\.?$";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_);
                        i18n.phonenumbers.PhoneNumberUtil.extnDigits_ = function(a) {
                            return "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1," + a + "})";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_ = function() {
                            var a = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"), b = "[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|\u0434\u043e\u0431|anexo)[:\\.\uff0e]?[ \u00a0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20") + "#?", c = "[ \u00a0\\t,]*(?:[x\uff58#\uff03~\uff5e]|int|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?", d = "[- ]+" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6") + "#", e = "[ \u00a0\\t]*(?:,{2}|;)[:\\.\uff0e]?[ \u00a0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15") + "#?", f = "[ \u00a0\\t]*(?:,)+[:\\.\uff0e]?[ \u00a0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?";
                            return a + "|" + b + "|" + c + "|" + d + "|" + e + "|" + f;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")$", "i");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")?$", "i");
                        i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/;
                        i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/;
                        i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/;
                        i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/;
                        i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/;
                        i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/;
                        i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001";
                        i18n.phonenumbers.PhoneNumberFormat = {
                            E164: 0,
                            INTERNATIONAL: 1,
                            NATIONAL: 2,
                            RFC3966: 3
                        };
                        i18n.phonenumbers.PhoneNumberType = {
                            FIXED_LINE: 0,
                            MOBILE: 1,
                            FIXED_LINE_OR_MOBILE: 2,
                            TOLL_FREE: 3,
                            PREMIUM_RATE: 4,
                            SHARED_COST: 5,
                            VOIP: 6,
                            PERSONAL_NUMBER: 7,
                            PAGER: 8,
                            UAN: 9,
                            VOICEMAIL: 10,
                            UNKNOWN: -1
                        };
                        i18n.phonenumbers.PhoneNumberUtil.MatchType = {
                            NOT_A_NUMBER: 0,
                            NO_MATCH: 1,
                            SHORT_NSN_MATCH: 2,
                            NSN_MATCH: 3,
                            EXACT_MATCH: 4
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {
                            IS_POSSIBLE: 0,
                            IS_POSSIBLE_LOCAL_ONLY: 4,
                            INVALID_COUNTRY_CODE: 1,
                            TOO_SHORT: 2,
                            INVALID_LENGTH: 5,
                            TOO_LONG: 3
                        };
                        i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(a) {
                            var b = a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
                            0 <= b ? (a = a.substring(b), a = a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), b = a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b && (a = a.substring(0, b))) : a = "";
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(a) {
                            return a.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalize = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(a) {
                            var b = i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());
                            a.clear();
                            a.append(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(a) {
                            var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
                            return null != b && (b.hasNationalPrefix() || a.hasItalianLeadingZero()) && this.isNumberGeographical(a) ? this.getLengthOfNationalDestinationCode(a) : 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(a) {
                            if (a.hasExtension()) {
                                var b = a.clone();
                                b.clearExtension();
                            } else b = a;
                            b = this.format(b, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);
                            0 == b[0].length && b.shift();
                            return 2 >= b.length ? 0 : this.getNumberType(a) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()), "" != a) ? b[2].length + a.length : b[1].length;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a] || "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
                            return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a) {
                                return isNaN(a);
                            });
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
                            return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a) {
                                return !isNaN(a);
                            }).map(function(a) {
                                return parseInt(a, 10);
                            });
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
                            var a = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
                            return [].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()), $jscomp.arrayFromIterable(a.map(function(b) {
                                return parseInt(b, 10);
                            })));
                        };
                        i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(a) {
                            return null != a && (1 != a.possibleLengthCount() || -1 != a.possibleLengthArray()[0]);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(a) {
                            return null != a && (a.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a) || a.hasNationalNumberPattern());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(a) {
                            var b = [];
                            goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(c) {
                                if (c != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
                                    var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a, c);
                                    i18n.phonenumbers.PhoneNumberUtil.descHasData_(d) && b.push(c);
                                }
                            });
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(a) {
                            return this.isValidRegionCode_(a) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)) : [];
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(a) {
                            a = this.getMetadataForNonGeographicalRegion(a);
                            return null == a ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(a, b, c) {
                            for(var d = new goog.string.StringBuffer, e, f, g = a.length, h = 0; h < g; ++h)e = a.charAt(h), f = b[e.toUpperCase()], null != f ? d.append(f) : c || d.append(e);
                            return d.toString();
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(a) {
                            return 0 == a.length || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(a) {
                            var b = this.getNumberType(a);
                            return b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(a.getCountryCodeOrDefault()) && b == i18n.phonenumbers.PhoneNumberType.MOBILE;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(a) {
                            return null != a && isNaN(a) && a.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(a) {
                            return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(a, b) {
                            if (0 == a.getNationalNumber() && a.hasRawInput()) {
                                var c = a.getRawInputOrDefault();
                                if (0 < c.length) return c;
                            }
                            c = a.getCountryCodeOrDefault();
                            var d = this.getNationalSignificantNumber(a);
                            if (b == i18n.phonenumbers.PhoneNumberFormat.E164) return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.E164, d, "");
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            var e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            a = this.maybeGetFormattedExtension_(a, e, b);
                            d = this.formatNsn_(d, e, b);
                            return this.prefixNumberWithCountryCallingCode_(c, b, d, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(a, b, c) {
                            var d = a.getCountryCodeOrDefault(), e = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(d)) return e;
                            var f = this.getRegionCodeForCountryCode(d);
                            f = this.getMetadataForRegionOrCallingCode_(d, f);
                            var g = this.chooseFormattingPatternForNumber_(c, e);
                            if (null != g) {
                                c = g.clone();
                                g = g.getNationalPrefixFormattingRuleOrDefault();
                                if (0 < g.length) {
                                    var h = f.getNationalPrefixOrDefault();
                                    0 < h.length ? (g = g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), c.setNationalPrefixFormattingRule(g)) : c.clearNationalPrefixFormattingRule();
                                }
                                e = this.formatNsnUsingPattern_(e, c, b);
                            }
                            a = this.maybeGetFormattedExtension_(a, f, b);
                            return this.prefixNumberWithCountryCallingCode_(d, b, e, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(a, b) {
                            var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            var e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            a = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            b = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b);
                            return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(a, b) {
                            return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b ? this.getMetadataForNonGeographicalRegion(a) : this.getMetadataForRegion(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(a, b) {
                            return this.formatNationalNumberWithCarrierCode(a, 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? a.getPreferredDomesticCarrierCodeOrDefault() : b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(a, b, c) {
                            var d = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(d)) return a.hasRawInput() ? a.getRawInputOrDefault() : "";
                            var e = "";
                            a = a.clone();
                            a.clearExtension();
                            var f = this.getRegionCodeForCountryCode(d), g = this.getNumberType(a), h = g != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                            if (b == f) e = g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g == i18n.phonenumbers.PhoneNumberType.MOBILE || g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, "BR" == f && e ? e = 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a, "") : "" : d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b = this.getMetadataForRegion(b), e = this.canBeInternationallyDialled(a) && this.testNumberLength_(this.getNationalSignificantNumber(a), b) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : e = (f == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || ("MX" == f || "CL" == f || "UZ" == f) && e) && this.canBeInternationallyDialled(a) ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            else if (h && this.canBeInternationallyDialled(a)) return c ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.E164);
                            return c ? e : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(a, b) {
                            if (!this.isValidRegionCode_(b)) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            if (c == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                                if (this.isNANPACountry(b)) return c + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            } else if (c == this.getCountryCodeForValidRegion_(b)) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            var e = this.getMetadataForRegion(b), f = e.getInternationalPrefixOrDefault();
                            b = "";
                            e.hasPreferredInternationalPrefix() ? b = e.getPreferredInternationalPrefixOrDefault() : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, f) && (b = f);
                            e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            d = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            a = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            return 0 < b.length ? b + " " + c + " " + d + a : this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(a, b) {
                            if (a.hasRawInput() && !this.hasFormattingPatternForNumber_(a)) return a.getRawInputOrDefault();
                            if (!a.hasCountryCodeSource()) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            switch(a.getCountryCodeSource()){
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                                    break;
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
                                    b = this.formatOutOfCountryCallingNumber(a, b);
                                    break;
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
                                    break;
                                default:
                                    var c = this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()), d = this.getNddPrefixForRegion(c, !0);
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                                    if (null != d && 0 != d.length && !this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(), d, c) && (c = this.getMetadataForRegion(c), d = this.getNationalSignificantNumber(a), c = this.chooseFormattingPatternForNumber_(c.numberFormatArray(), d), null != c)) {
                                        d = c.getNationalPrefixFormattingRuleOrDefault();
                                        var e = d.indexOf("$1");
                                        0 >= e || (d = d.substring(0, e), d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d), 0 != d.length && (b = c.clone(), b.clearNationalPrefixFormattingRule(), b = this.formatByPattern(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [
                                            b
                                        ])));
                                    }
                            }
                            a = a.getRawInputOrDefault();
                            null != b && 0 < a.length && (c = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(b), d = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(a), c != d && (b = a));
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(a, b, c) {
                            a = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
                            if (goog.string.startsWith(a, b)) try {
                                return this.isValidNumber(this.parse(a.substring(b.length), c));
                            } catch (d) {}
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(a) {
                            var b = a.getCountryCodeOrDefault(), c = this.getRegionCodeForCountryCode(b);
                            b = this.getMetadataForRegionOrCallingCode_(b, c);
                            if (null == b) return !1;
                            a = this.getNationalSignificantNumber(a);
                            return null != this.chooseFormattingPatternForNumber_(b.numberFormatArray(), a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(a, b) {
                            var c = a.getRawInputOrDefault();
                            if (0 == c.length) return this.formatOutOfCountryCallingNumber(a, b);
                            var d = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(d)) return c;
                            c = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
                            var e = this.getNationalSignificantNumber(a);
                            if (3 < e.length) {
                                var f = c.indexOf(e.substring(0, 3));
                                -1 != f && (c = c.substring(f));
                            }
                            f = this.getMetadataForRegion(b);
                            if (d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                                if (this.isNANPACountry(b)) return d + " " + c;
                            } else if (null != f && d == this.getCountryCodeForValidRegion_(b)) {
                                d = this.chooseFormattingPatternForNumber_(f.numberFormatArray(), e);
                                if (null == d) return c;
                                d = d.clone();
                                d.setPattern("(\\d+)(.*)");
                                d.setFormat("$1$2");
                                return this.formatNsnUsingPattern_(c, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            }
                            b = "";
                            null != f && (b = f.getInternationalPrefixOrDefault(), b = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, b) ? b : f.getPreferredInternationalPrefixOrDefault());
                            f = this.getRegionCodeForCountryCode(d);
                            f = this.getMetadataForRegionOrCallingCode_(d, f);
                            a = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            return 0 < b.length ? b + " " + d + " " + c + a : this.prefixNumberWithCountryCallingCode_(d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(a) {
                            if (!a.hasNationalNumber()) return "";
                            var b = "" + a.getNationalNumber();
                            return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(a, b, c, d) {
                            switch(b){
                                case i18n.phonenumbers.PhoneNumberFormat.E164:
                                    return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + c + d;
                                case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
                                    return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + " " + c + d;
                                case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
                                    return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + "-" + c + d;
                                default:
                                    return c + d;
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(a, b, c, d) {
                            b = 0 == b.intlNumberFormatArray().length || c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b.numberFormatArray() : b.intlNumberFormatArray();
                            b = this.chooseFormattingPatternForNumber_(b, a);
                            return null == b ? a : this.formatNsnUsingPattern_(a, b, c, d);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(a, b) {
                            for(var c, d = a.length, e = 0; e < d; ++e){
                                c = a[e];
                                var f = c.leadingDigitsPatternCount();
                                if (0 == f || 0 == b.search(c.getLeadingDigitsPattern(f - 1))) {
                                    if (f = new RegExp(c.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, b)) return c;
                                }
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(a, b, c, d) {
                            var e = b.getFormatOrDefault(), f = new RegExp(b.getPattern()), g = b.getDomesticCarrierCodeFormattingRuleOrDefault();
                            c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != d && 0 < d.length && 0 < g.length ? (b = g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b), a = a.replace(f, e)) : (b = b.getNationalPrefixFormattingRuleOrDefault(), a = c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != b && 0 < b.length ? a.replace(f, e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b)) : a.replace(f, e));
                            c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a = a.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), a = a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-"));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(a) {
                            return this.getExampleNumberForType(a, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(a, b) {
                            if (!this.isValidRegionCode_(a)) return null;
                            b = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a), b);
                            try {
                                if (b.hasExampleNumber()) return this.parse(b.getExampleNumber(), a);
                            } catch (c) {}
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(a) {
                            var b = this.getMetadataForNonGeographicalRegion(a);
                            if (null != b && (b = [
                                b.getMobile(),
                                b.getTollFree(),
                                b.getSharedCost(),
                                b.getVoip(),
                                b.getVoicemail(),
                                b.getUan(),
                                b.getPremiumRate()
                            ].find(function(c, d) {
                                return c.hasExampleNumber();
                            }), void 0 !== b)) try {
                                return this.parse("+" + a + b.getExampleNumber(), "ZZ");
                            } catch (c) {}
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(a, b, c) {
                            return a.hasExtension() && 0 != a.getExtension().length ? c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a.getExtension() : b.hasPreferredExtnPrefix() ? b.getPreferredExtnPrefix() + a.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a.getExtensionOrDefault() : "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(a, b) {
                            switch(b){
                                case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
                                    return a.getPremiumRate();
                                case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
                                    return a.getTollFree();
                                case i18n.phonenumbers.PhoneNumberType.MOBILE:
                                    return a.getMobile();
                                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
                                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
                                    return a.getFixedLine();
                                case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
                                    return a.getSharedCost();
                                case i18n.phonenumbers.PhoneNumberType.VOIP:
                                    return a.getVoip();
                                case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
                                    return a.getPersonalNumber();
                                case i18n.phonenumbers.PhoneNumberType.PAGER:
                                    return a.getPager();
                                case i18n.phonenumbers.PhoneNumberType.UAN:
                                    return a.getUan();
                                case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
                                    return a.getVoicemail();
                                default:
                                    return a.getGeneralDesc();
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(a) {
                            var b = this.getRegionCodeForNumber(a);
                            b = this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(), b);
                            if (null == b) return i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                            a = this.getNationalSignificantNumber(a);
                            return this.getNumberTypeHelper_(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(a, b) {
                            return this.isNumberMatchingDesc_(a, b.getGeneralDesc()) ? this.isNumberMatchingDesc_(a, b.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a, b.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a, b.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a, b.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a, b.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : this.isNumberMatchingDesc_(a, b.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a, b.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a, b.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a, b.getFixedLine()) ? b.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : !b.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(a) {
                            if (null == a) return null;
                            a = a.toUpperCase();
                            var b = this.regionToMetadataMap[a];
                            if (null == b) {
                                b = new goog.proto2.PbLiteSerializer;
                                var c = i18n.phonenumbers.metadata.countryToMetadata[a];
                                if (null == c) return null;
                                b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
                                this.regionToMetadataMap[a] = b;
                            }
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(a) {
                            return this.getMetadataForRegion("" + a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(a, b) {
                            var c = a.length;
                            return 0 < b.possibleLengthCount() && -1 == b.possibleLengthArray().indexOf(c) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(a) {
                            var b = this.getRegionCodeForNumber(a);
                            return this.isValidNumberForRegion(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(a, b) {
                            var c = a.getCountryCodeOrDefault(), d = this.getMetadataForRegionOrCallingCode_(c, b);
                            if (null == d || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b && c != this.getCountryCodeForValidRegion_(b)) return !1;
                            a = this.getNationalSignificantNumber(a);
                            return this.getNumberTypeHelper_(a, d) != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(a) {
                            if (null == a) return null;
                            var b = a.getCountryCodeOrDefault();
                            b = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];
                            return null == b ? null : 1 == b.length ? b[0] : this.getRegionCodeForNumberFromRegionList_(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(a, b) {
                            a = this.getNationalSignificantNumber(a);
                            for(var c, d = b.length, e = 0; e < d; e++){
                                c = b[e];
                                var f = this.getMetadataForRegion(c);
                                if (f.hasLeadingDigits()) {
                                    if (0 == a.search(f.getLeadingDigits())) return c;
                                } else if (this.getNumberTypeHelper_(a, f) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) return c;
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(a) {
                            a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
                            return null == a ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a[0];
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(a) {
                            a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
                            return null == a ? [] : a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(a) {
                            return this.isValidRegionCode_(a) ? this.getCountryCodeForValidRegion_(a) : 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(a) {
                            var b = this.getMetadataForRegion(a);
                            if (null == b) throw Error("Invalid region code: " + a);
                            return b.getCountryCodeOrDefault();
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(a, b) {
                            a = this.getMetadataForRegion(a);
                            if (null == a) return null;
                            a = a.getNationalPrefixOrDefault();
                            if (0 == a.length) return null;
                            b && (a = a.replace("~", ""));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(a) {
                            return null != a && i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(a.toUpperCase());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(a) {
                            if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a)) return !1;
                            a = new goog.string.StringBuffer(a);
                            this.maybeStripExtension(a);
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a.toString());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(a) {
                            a = this.isPossibleNumberWithReason(a);
                            return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(a, b) {
                            a = this.isPossibleNumberForTypeWithReason(a, b);
                            return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(a, b) {
                            return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(a, b, c) {
                            var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, c), e = 0 == d.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : d.possibleLengthArray();
                            d = d.possibleLengthLocalOnlyArray();
                            if (c == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) {
                                if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c) && (e = e.concat(0 == c.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : c.possibleLengthArray()), e.sort(), 0 == d.length ? d = c.possibleLengthLocalOnlyArray() : (d = d.concat(c.possibleLengthLocalOnlyArray()), d.sort()));
                                else return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.MOBILE);
                            }
                            if (-1 == e[0]) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
                            a = a.length;
                            if (-1 < d.indexOf(a)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                            b = e[0];
                            return b == a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b > a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e[e.length - 1] < a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < e.indexOf(a, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(a) {
                            return this.isPossibleNumberForTypeWithReason(a, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(a, b) {
                            var c = this.getNationalSignificantNumber(a);
                            a = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(a)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
                            var d = this.getRegionCodeForCountryCode(a);
                            a = this.getMetadataForRegionOrCallingCode_(a, d);
                            return this.testNumberLengthForType_(c, a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(a, b) {
                            try {
                                return this.isPossibleNumber(this.parse(a, b));
                            } catch (c) {
                                return !1;
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(a) {
                            if (this.isValidNumber(a)) return !0;
                            var b = a.clone(), c = a.getNationalNumberOrDefault();
                            do if (c = Math.floor(c / 10), b.setNationalNumber(c), 0 == c || this.isPossibleNumberWithReason(b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) return !1;
                            while (!this.isValidNumber(b));
                            a.setNationalNumber(c);
                            return !0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(a, b) {
                            a = a.toString();
                            if (0 == a.length || "0" == a.charAt(0)) return 0;
                            for(var c, d = a.length, e = 1; e <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && e <= d; ++e)if (c = parseInt(a.substring(0, e), 10), c in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) return b.append(a.substring(e)), c;
                            return 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(a, b, c, d, e) {
                            if (0 == a.length) return 0;
                            a = new goog.string.StringBuffer(a);
                            var f;
                            null != b && (f = b.getInternationalPrefix());
                            null == f && (f = "NonMatch");
                            f = this.maybeStripInternationalPrefixAndNormalize(a, f);
                            d && e.setCountryCodeSource(f);
                            if (f != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
                                if (a.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
                                b = this.extractCountryCode(a, c);
                                if (0 != b) return e.setCountryCode(b), b;
                                throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            }
                            if (null != b) {
                                f = b.getCountryCodeOrDefault();
                                var g = "" + f, h = a.toString();
                                if (goog.string.startsWith(h, g) && (g = new goog.string.StringBuffer(h.substring(g.length)), h = b.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g, b, null), g = g.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, a.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, g) || this.testNumberLength_(a.toString(), b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) return c.append(g), d && e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e.setCountryCode(f), f;
                            }
                            e.setCountryCode(0);
                            return 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(a, b) {
                            var c = b.toString();
                            if (0 == c.search(a)) {
                                a = c.match(a)[0].length;
                                var d = c.substring(a).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
                                if (d && null != d[1] && 0 < d[1].length && "0" == i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d[1])) return !1;
                                b.clear();
                                b.append(c.substring(a));
                                return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(a, b) {
                            var c = a.toString();
                            if (0 == c.length) return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
                            if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c)) return c = c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), a.clear(), a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
                            b = new RegExp(b);
                            i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);
                            return this.parsePrefixAsIdd_(b, a) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(a, b, c) {
                            var d = a.toString(), e = d.length, f = b.getNationalPrefixForParsing();
                            if (0 == e || null == f || 0 == f.length) return !1;
                            var g = new RegExp("^(?:" + f + ")");
                            if (e = g.exec(d)) {
                                f = new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());
                                var h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d), k = e.length - 1;
                                b = b.getNationalPrefixTransformRule();
                                if (null == b || 0 == b.length || null == e[k] || 0 == e[k].length) {
                                    if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d.substring(e[0].length))) return !1;
                                    null != c && 0 < k && null != e[k] && c.append(e[1]);
                                    a.set(d.substring(e[0].length));
                                } else {
                                    d = d.replace(g, b);
                                    if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d)) return !1;
                                    null != c && 0 < k && c.append(e[1]);
                                    a.set(d);
                                }
                                return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(a) {
                            var b = a.toString(), c = b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
                            if (0 <= c && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0, c))) {
                                for(var d = b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e = d.length, f = 1; f < e; ++f)if (null != d[f] && 0 < d[f].length) return a.clear(), a.append(b.substring(0, c)), d[f];
                            }
                            return "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(a, b) {
                            return this.isValidRegionCode_(b) || null != a && 0 < a.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(a, b) {
                            return this.parseHelper_(a, b, !1, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(a, b) {
                            if (!this.isValidRegionCode_(b) && 0 < a.length && a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            return this.parseHelper_(a, b, !0, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(a, b) {
                            if (1 < a.length && "0" == a.charAt(0)) {
                                b.setItalianLeadingZero(!0);
                                for(var c = 1; c < a.length - 1 && "0" == a.charAt(c);)c++;
                                1 != c && b.setNumberOfLeadingZeros(c);
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(a, b, c, d) {
                            if (null == a) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (a.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
                            var e = new goog.string.StringBuffer;
                            this.buildNationalNumberForParsing_(a, e);
                            if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString())) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (d && !this.checkRegionForParsing_(e.toString(), b)) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            d = new i18n.phonenumbers.PhoneNumber;
                            c && d.setRawInput(a);
                            a = this.maybeStripExtension(e);
                            0 < a.length && d.setExtension(a);
                            var f = this.getMetadataForRegion(b);
                            a = new goog.string.StringBuffer;
                            var g = 0, h = e.toString();
                            try {
                                g = this.maybeExtractCountryCode(h, f, a, c, d);
                            } catch (k) {
                                if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)) {
                                    if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), g = this.maybeExtractCountryCode(h, f, a, c, d), 0 == g) throw k;
                                } else throw k;
                            }
                            0 != g ? (e = this.getRegionCodeForCountryCode(g), e != b && (f = this.getMetadataForRegionOrCallingCode_(g, e))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), a.append(e.toString()), null != b ? (g = f.getCountryCodeOrDefault(), d.setCountryCode(g)) : c && d.clearCountryCodeSource());
                            if (a.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
                            null != f && (b = new goog.string.StringBuffer, e = new goog.string.StringBuffer(a.toString()), this.maybeStripNationalPrefixAndCarrierCode(e, f, b), f = this.testNumberLength_(e.toString(), f), g = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, f != g.TOO_SHORT && f != g.IS_POSSIBLE_LOCAL_ONLY && f != g.INVALID_LENGTH && (a = e, c && 0 < b.toString().length && d.setPreferredDomesticCarrierCode(b.toString())));
                            c = a.toString();
                            a = c.length;
                            if (a < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
                            if (a > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
                            i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c, d);
                            d.setNationalNumber(parseInt(c, 10));
                            return d;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_ = function(a) {
                            var b = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                            if (-1 === b) return null;
                            b += i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;
                            if (b >= a.length) return "";
                            var c = a.indexOf(";", b);
                            return -1 !== c ? a.substring(b, c) : a.substring(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_ = function(a) {
                            if (null == a) return !0;
                            if (0 === a.length) return !1;
                            var b = i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.exec(a);
                            a = i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_.exec(a);
                            return null !== b || null !== a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(a, b) {
                            var c = i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_(a);
                            if (!i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_(c)) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (null != c) {
                                c.charAt(0) === i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && b.append(c);
                                c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);
                                c = 0 <= c ? c + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0;
                                var d = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                                b.append(a.substring(c, d));
                            } else b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(null != a ? a : ""));
                            a = b.toString();
                            c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);
                            0 < c && (b.clear(), b.append(a.substring(0, c)));
                        };
                        i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(a) {
                            var b = new i18n.phonenumbers.PhoneNumber;
                            b.setCountryCode(a.getCountryCodeOrDefault());
                            b.setNationalNumber(a.getNationalNumberOrDefault());
                            0 < a.getExtensionOrDefault().length && b.setExtension(a.getExtensionOrDefault());
                            a.getItalianLeadingZero() && (b.setItalianLeadingZero(!0), b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(a, b) {
                            if ("string" == typeof a) try {
                                var c = this.parse(a, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
                            } catch (f) {
                                if (f.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                if ("string" != typeof b) {
                                    var d = this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());
                                    if (d != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
                                        try {
                                            c = this.parse(a, d);
                                        } catch (g) {
                                            return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                        }
                                        var e = this.isNumberMatch(c, b);
                                        return e == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : e;
                                    }
                                }
                                try {
                                    c = this.parseHelper_(a, null, !1, !1);
                                } catch (g) {
                                    return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                }
                            }
                            else c = a.clone();
                            if ("string" == typeof b) try {
                                return e = this.parse(b, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_), this.isNumberMatch(a, e);
                            } catch (f) {
                                return f.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(b, c);
                            }
                            else e = b.clone();
                            a = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);
                            e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);
                            if (a.hasExtension() && e.hasExtension() && a.getExtension() != e.getExtension()) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                            b = a.getCountryCodeOrDefault();
                            c = e.getCountryCodeOrDefault();
                            if (0 != b && 0 != c) return a.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : b == c && this.isNationalNumberSuffixOfTheOther_(a, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                            a.setCountryCode(0);
                            e.setCountryCode(0);
                            return a.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(a, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(a, b) {
                            a = "" + a.getNationalNumber();
                            b = "" + b.getNationalNumber();
                            return goog.string.endsWith(a, b) || goog.string.endsWith(b, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(a) {
                            var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
                            if (null == b) return !0;
                            a = this.getNationalSignificantNumber(a);
                            return !this.isNumberMatchingDesc_(a, b.getNoInternationalDialling());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function(a, b) {
                            return (a = b.match(new RegExp("^(?:" + ("string" == typeof a ? a : a.source) + ")$", "i"))) && a[0].length == b.length ? !0 : !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function(a, b) {
                            return (a = "string" == typeof a ? b.match("^(?:" + a + ")") : b.match(a)) && goog.string.startsWith(b, a[0]) ? !0 : !1;
                        };
                        i18n.phonenumbers.shortnumbermetadata = {};
                        i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = {
                            0: "AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ")
                        };
                        i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {
                            AC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AD: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|445[16]|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "445\\d",
                                    ,
                                    ,
                                    ,
                                    "4450",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            AF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)|40404",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[15]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "50000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[7-9])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "131|5\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ]
                            ],
                            AM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[148]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|8[1-7])\\d\\d|40404",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AO: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01389]\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911",
                                    ,
                                    ,
                                    ,
                                    "19",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[017]|911",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911",
                                    ,
                                    ,
                                    ,
                                    "19"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "893\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "89300",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:337|893\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "3370",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            AS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[49]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "40404|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1268]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[12]2|33|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:220|61|8108[1-3])0",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:220|810\\d\\d)\\d|610",
                                    ,
                                    ,
                                    ,
                                    "610"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-27]\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|12|258885|55\\d)|733",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:2(?:34|456)|9\\d{4,6})",
                                    ,
                                    ,
                                    ,
                                    "1234",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|12)",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1[09]\\d|24733)|225|767",
                                    ,
                                    ,
                                    ,
                                    "225",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:258885|55\\d)",
                                    ,
                                    ,
                                    ,
                                    "1550",
                                    ,
                                    ,
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "190000",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ]
                            ],
                            AW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "100|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "100|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|18|76)|91[13]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|75[12]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[148]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)|(?:404|880)0",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:404|880)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:404|880)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:16\\d{3}|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "12[2-4]",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "122"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "988|[2359]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[2359]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "988|[2-689]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[468]11",
                                    ,
                                    ,
                                    ,
                                    "411"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1579]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-26]|[19]99",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-2]|[19]99",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:11|2[13])|(?:501|959)\\d|786",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "959\\d",
                                    ,
                                    ,
                                    ,
                                    "9590",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "1204",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "2000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111))|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0189]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0[167]|81)\\d{3}|[19]99",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    "9[148]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "91000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[19]99",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0[67]\\d{3}|88000|98555",
                                    ,
                                    ,
                                    ,
                                    "06000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "88000|98555",
                                    ,
                                    ,
                                    ,
                                    "88000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[16-9]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[237]|611",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[237]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "611|7(?:10|77)|888|900",
                                    ,
                                    ,
                                    ,
                                    "611",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:71|90)0",
                                    ,
                                    ,
                                    ,
                                    "710",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            BJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[246-8]|3[68]|6[06])|7[3-5]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[246-8]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[24-8]|2[02-5]|3[126-8]|5[05]|6[06]|89)|7[0-5]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "12[02-5]",
                                    ,
                                    ,
                                    ,
                                    "120",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            BN: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]|40404",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|76)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            BR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-69]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|28|9[023])|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "102|273\\d\\d|321",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)",
                                    ,
                                    ,
                                    ,
                                    "151",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "321"
                                ]
                            ],
                            BS: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:1[19]|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[19]",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:1[19]|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-6]|40404",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "131\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13100",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "131\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13100",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|22|66|77|9[09])",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|90)",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|22|66|77|9[09])",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|988|[29]11",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[235-7]11",
                                    ,
                                    ,
                                    ,
                                    "211",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[1-35-9]\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    "10000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            CC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|77|88)",
                                    ,
                                    ,
                                    ,
                                    "113",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|77|88)",
                                    ,
                                    ,
                                    ,
                                    "113",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|23|77|88)|40404",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            CF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|22\\d)",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|220)",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[478]|220)",
                                    ,
                                    ,
                                    ,
                                    "114"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[178]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[78]",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[126-8]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[278]|6\\d{3})|4[47])|5200",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:14|8[0-2589])\\d|543|83111",
                                    ,
                                    ,
                                    ,
                                    "543",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:4[035]|6[1-46])|1(?:41|60)\\d",
                                    ,
                                    ,
                                    ,
                                    "140",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:200|35)",
                                    ,
                                    ,
                                    ,
                                    "535",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    "200",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            CI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)|4443",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d",
                                    ,
                                    ,
                                    ,
                                    "4440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "444\\d",
                                    ,
                                    ,
                                    ,
                                    "4440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CK: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:213|3[1-3])|434\\d|911",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d",
                                    ,
                                    ,
                                    ,
                                    "1060",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[1-3]|911",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:200|333)\\d",
                                    ,
                                    ,
                                    ,
                                    "2000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d",
                                    ,
                                    ,
                                    ,
                                    "1060",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            CM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])",
                                    ,
                                    ,
                                    ,
                                    "13",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])",
                                    ,
                                    ,
                                    ,
                                    "13",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])|8711",
                                    ,
                                    ,
                                    ,
                                    "13"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "871\\d",
                                    ,
                                    ,
                                    ,
                                    "8710",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "871\\d",
                                    ,
                                    ,
                                    ,
                                    "8710",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[09]|2(?:[02]|1\\d\\d|395))",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[09]|20)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "12110",
                                    ,
                                    ,
                                    ,
                                    "12110",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            CO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-589]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[29]|23|32|56)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[29]|23|32|56)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "106"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40|85)4\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:40|85)4\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            CR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1359]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:385|5(?:0[34]|51))\\d",
                                    ,
                                    ,
                                    ,
                                    "3850",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d\\d(?:\\d{3,4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[4-7]|(?:116|204\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[4-6]",
                                    ,
                                    ,
                                    ,
                                    "104",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[4-7]|1(?:6111|8)|40)|2045252",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CV: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|76)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            CX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|99)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|99)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111))|99)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[137]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[02]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|3311|7464|118\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:331|746)\\d",
                                    ,
                                    ,
                                    ,
                                    "3310",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "746\\d",
                                    ,
                                    ,
                                    ,
                                    "7460",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            DJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[24]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[248]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[47]|54\\d)",
                                    ,
                                    ,
                                    ,
                                    "14"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[47])",
                                    ,
                                    ,
                                    ,
                                    "14",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:055|12|[47]|548)|730",
                                    ,
                                    ,
                                    ,
                                    "14"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            EC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
                                    ,
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
                                    ,
                                    ,
                                    ,
                                    "126",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            EG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|80)",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|80)",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|[679]\\d{3}|80)|34400",
                                    ,
                                    ,
                                    ,
                                    "122"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "344\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "34400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "344\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "34400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            EH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ER: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2-46]|(?:12[47]|20[12])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ER",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ES: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-379]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "016",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                ,
                                ,
                                "ES",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "08[58]|112",
                                    ,
                                    ,
                                    ,
                                    "085",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    "0(?:[16][0-2]|80|9[12])|21\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "010",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:3[34]|77)|[12]2\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "22000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            ET: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:07|11?|2|39?|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ET",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11?|2|39?|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:07|11?|2|39?|45|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[2-8]\\d|75[12])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "1[2-8]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "12000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-579]\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[17]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[17]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75",
                                    ,
                                    ,
                                    ,
                                    "22"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            FK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "320\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:32022|91)1",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:32022|91)1",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FO: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[24]|81\\d)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-8]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1000",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "202\\d|6(?:1[14]|34)|70[06]",
                                    ,
                                    ,
                                    ,
                                    "611",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",
                                    ,
                                    ,
                                    ,
                                    "224",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "114|[3-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ]
                            ],
                            GA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18|1(?:3\\d|73)\\d",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3\\d\\d|730|8)",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3\\d\\d|730|8)",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-46-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901",
                                    ,
                                    ,
                                    ,
                                    "202",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "1250",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            GD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            GE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[014]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|40404|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14589]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|999",
                                    ,
                                    ,
                                    ,
                                    "191",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|999",
                                    ,
                                    ,
                                    ,
                                    "191",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|40404|(?:54|83)00|999",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d|(?:54|83)0\\d",
                                    ,
                                    ,
                                    ,
                                    "5400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d|(?:54|83)0\\d",
                                    ,
                                    ,
                                    ,
                                    "5400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            GI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[158]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[1-69]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "8100",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[09])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "150|87\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "150",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[1-8]\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "12\\d|40404",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GP: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[089]|1(?:2|6\\d{3})|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|12|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "113\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "11300",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:10|2[03])",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:10|2[03])",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "110|40404|1(?:2|[57]\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GU: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GW: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[019]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[1-3]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[1-3]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]",
                                    ,
                                    ,
                                    ,
                                    "002"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "144\\d",
                                    ,
                                    ,
                                    ,
                                    "1440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "144\\d",
                                    ,
                                    ,
                                    ,
                                    "1440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            HK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "109|1(?:08|85\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "109",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "992",
                                    ,
                                    ,
                                    ,
                                    "992",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            HN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|40404",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[016-9]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "93",
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "06\\d|(?:118|[6-8]\\d{3})\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "060",
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])|9[34]",
                                    ,
                                    ,
                                    ,
                                    "93",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:06|[6-8]\\d{4})\\d|1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]",
                                    ,
                                    ,
                                    ,
                                    "93"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "139\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "139\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]|40404",
                                    ,
                                    ,
                                    ,
                                    "114"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|12)",
                                    ,
                                    ,
                                    ,
                                    "104",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "184\\d",
                                    ,
                                    ,
                                    ,
                                    "1840",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            ID: [
                                ,
                                [
                                    ,
                                    ,
                                    "[178]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02389]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ID",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02389]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02389]|40\\d\\d|50264)|71400|89887",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:714|898)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "71400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "714\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "71400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[159]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[37]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "53000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "51\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "51210",
                                    ,
                                    ,
                                    ,
                                    "51210",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "51210|(?:118|5[037]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "11800",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "104\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "10400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "104\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "10400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "8(?:64|98)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "86400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12578]\\d{2,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "11[67]\\d{4}|56161561",
                                    ,
                                    ,
                                    ,
                                    "1160000",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-28]|12|298)|2611",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:14(?:2[5-9]|[34]\\d)|757555)",
                                    ,
                                    ,
                                    ,
                                    "51425",
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])",
                                    ,
                                    ,
                                    ,
                                    "118",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)",
                                    ,
                                    ,
                                    ,
                                    "139",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        7,
                                        8
                                    ]
                                ]
                            ],
                            IQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1479]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)|4432|71117|9988",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:443|711\\d|998)\\d",
                                    ,
                                    ,
                                    ,
                                    "4430",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:443|711\\d|998)\\d",
                                    ,
                                    ,
                                    ,
                                    "4430",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            IR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-68]|2[0-59]|9[0-579])|911",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[025]|25)|911",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5[0-469]|8[0-489])\\d",
                                    ,
                                    ,
                                    ,
                                    "1500",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d",
                                    ,
                                    ,
                                    ,
                                    "1500",
                                    ,
                                    ,
                                    [
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "990\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "990000",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ]
                            ],
                            IS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:0\\d|41)",
                                    ,
                                    ,
                                    ,
                                    "1400",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:415|90\\d)",
                                    ,
                                    ,
                                    ,
                                    "1415",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            IT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[2358]|6\\d{3})|87)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "43000",
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ]
                            ],
                            JE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]|911",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[029]|76)|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            JO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[235]|1[2-6]|9[127])|911",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[127])|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            JP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d(?:\\d{7})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[09]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000[259]\\d{6}|1(?:0[24]|1[089]|44|89)",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000[259]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "0002000000",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ]
                            ],
                            KE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "909\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "90900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "141"
                                ]
                            ],
                            KG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]|4040",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            KH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[146]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|666",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|666",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|40404|666",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            KI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[179]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[2-5]|99[2-4]",
                                    ,
                                    ,
                                    ,
                                    "192",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[2-5]|99[2-4]",
                                    ,
                                    ,
                                    ,
                                    "192",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "103",
                                    ,
                                    ,
                                    ,
                                    "103",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[27-9]|28|330|82)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[0-7]\\d|89887",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "898\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "89800",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KY: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-4]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)|212\\d",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-4]|12)|2121|(?:3040|404)0",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:304\\d|404)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:304\\d|404)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            LA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LI: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02689]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02689]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[3489]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "355|911",
                                    ,
                                    ,
                                    ,
                                    "355",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "355|911",
                                    ,
                                    ,
                                    ,
                                    "355",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "355|4040|8(?:400|933)|911",
                                    ,
                                    ,
                                    ,
                                    "355"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:404|8(?:40|93))\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:404|8(?:40|93))\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            LS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d(?:\\d(?:\\d{3})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[23]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[23]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[018]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]|11(?:[023]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1180|821\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1180",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]|11[023]",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    "1181",
                                    ,
                                    ,
                                    ,
                                    "1181",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "165\\d",
                                    ,
                                    ,
                                    ,
                                    "1650",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|41|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|90[1-3]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ME: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ME",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MH: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ML: [
                                ,
                                [
                                    ,
                                    ,
                                    "[136-8]\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)",
                                    ,
                                    ,
                                    ,
                                    "1220",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ML",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "37(?:433|575)|7400|8001\\d",
                                    ,
                                    ,
                                    ,
                                    "7400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3503\\d|(?:3[67]\\d|800)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "35030",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "7400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            MM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MO: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MP: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d(?:\\d(?:\\d{2})?)?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])|3[01]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2469]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])|(?:118[02-9]|3[0-2469])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "118\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "118000",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[29]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "211|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:000|1(?:11|23)))",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[45]|99[59]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[45]|99[59]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,4}|(?:8\\d\\d|99)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:02|1[89])",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:02|1[89])",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[45]1",
                                    ,
                                    ,
                                    ,
                                    "141",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|80400|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "80400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "804\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "80400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            MX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0579]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:6[0568]|80)|911",
                                    ,
                                    ,
                                    ,
                                    "060",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:530\\d|776)\\d",
                                    ,
                                    ,
                                    ,
                                    "7760",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:6[0568]|80)|911",
                                    ,
                                    ,
                                    ,
                                    "060",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-9]\\d|53053|7766|911",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0(?:[249]0|[35][01])",
                                    ,
                                    ,
                                    ,
                                    "020",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1369]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "666\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "66600",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:3[23679]\\d|666)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "32000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            MZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02-5]\\d\\d|1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:10|93)111|(?:1\\d|9)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "900"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[135]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[5-8]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:67|88)",
                                    ,
                                    ,
                                    ,
                                    "567",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-3578]\\d(?:\\d(?:\\d{3})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18|[578])|723\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18|[578])|723141",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NF: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|40700",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "407\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40700",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "407\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40700",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            NI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12467]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|2[08])|737\\d",
                                    ,
                                    ,
                                    ,
                                    "115"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|2[08])",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00",
                                    ,
                                    ,
                                    ,
                                    "115"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1349]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "120\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[34]00\\d",
                                    ,
                                    ,
                                    ,
                                    "3000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            NO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[023]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8\\d\\d|90)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "04\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "04000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            NP: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-36]|12)|1(?:09|11)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-2]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-2]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-2]|23|92)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[019]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "01[05]|101|999",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "010",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "018",
                                    ,
                                    ,
                                    ,
                                    "018",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
                                    ,
                                    ,
                                    ,
                                    "018"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "018"
                                ]
                            ],
                            OM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1444|999\\d",
                                    ,
                                    ,
                                    ,
                                    "1444"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "OM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1444|9999",
                                    ,
                                    ,
                                    ,
                                    "1444"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d",
                                    ,
                                    ,
                                    ,
                                    "1111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[2-4]|911",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|11[01]",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|11[01]",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:1[01]|5\\d\\d|6\\d{2,5})",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "16\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "1600",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ]
                            ],
                            PH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2\\d?|5)|[56])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:22?|5)|[56])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:122|3[014]|[56])|11[2457-9]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|3(?:0\\d|1[689])\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2469]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|31(?:03|[689]\\d)|(?:118[02-9]|3[02469])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "118\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "118000",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "310\\d",
                                    ,
                                    ,
                                    ,
                                    "3100",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PR: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|66)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-2]",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|122|44|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "112\\d",
                                    ,
                                    ,
                                    ,
                                    "1120",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PW: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[1-9]\\d|911",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            QA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99\\d",
                                    ,
                                    ,
                                    ,
                                    "990",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900",
                                    ,
                                    ,
                                    ,
                                    "900",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "QA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:18[39]|[24])|8[48])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1[24]|8[48])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            RS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[189]\\d{1,4}|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-4]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[1245]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[12]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|9(?:11|37|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|9[79])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "141\\d",
                                    ,
                                    ,
                                    ,
                                    "1410",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:10|41)\\d|90[24679]",
                                    ,
                                    ,
                                    ,
                                    "902",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[127-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[1468]|60)|999",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SD: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-37-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "11811[89]|72\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "72000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|90000",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
                                    ,
                                    ,
                                    ,
                                    "220",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[179]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[359]",
                                    ,
                                    ,
                                    ,
                                    "993",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[359]",
                                    ,
                                    ,
                                    ,
                                    "993",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "772\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "77200",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SI: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[23]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "04\\d{3}|11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "04\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "04000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|5[058])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5[058])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[069]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9",
                                    ,
                                    ,
                                    ,
                                    "019",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9",
                                    ,
                                    ,
                                    ,
                                    "019",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9|60400",
                                    ,
                                    ,
                                    ,
                                    "019"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "604\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "60400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "604\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "60400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:515|[78])|2(?:00|1)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "17",
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[246]|[468])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "24000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]",
                                    ,
                                    ,
                                    ,
                                    "12"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:01|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "22000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[46]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1400",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "2[468]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "24000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[57-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "555|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "555|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "555|777|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SS: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ST: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ST",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "116\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[13]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SX: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:19|88)",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "919",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:19|88)",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TD: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:011|1[078]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:113|2[23]\\d|5(?:09|56))",
                                    ,
                                    ,
                                    ,
                                    "1113",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:669|9[19])",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d",
                                    ,
                                    ,
                                    ,
                                    "1103",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "114[89]",
                                    ,
                                    ,
                                    ,
                                    "1148",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|1[25]|2[0138]|72|9[07])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TM: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-49]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-49]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TO: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02]|55)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:285|542)0",
                                    ,
                                    ,
                                    ,
                                    "2850",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d",
                                    ,
                                    ,
                                    ,
                                    "144",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ]
                            ],
                            TT: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:88|9[09])",
                                    ,
                                    ,
                                    ,
                                    "988"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[09]",
                                    ,
                                    ,
                                    ,
                                    "990"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:88|9[09])",
                                    ,
                                    ,
                                    ,
                                    "988"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TW: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0289]|1(?:81|92)\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "10[56]",
                                    ,
                                    ,
                                    ,
                                    "105",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:65|9(?:1\\d|50|85|98))",
                                    ,
                                    ,
                                    ,
                                    "165"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-79]|9[09])|999",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-245]|999",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|9[09])|46400|999",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "464\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "46400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "464\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "46400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            UA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|1(?:2|6\\d{3}))",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:118|[89]00)\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "1180",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UG: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            US: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|611|9(?:11|33|88)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7",
                                    ,
                                    ,
                                    ,
                                    "24280",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "US",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
                                    ,
                                    ,
                                    ,
                                    "23333",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "336\\d\\d|[2-9]\\d{3}|[2356]11",
                                    ,
                                    ,
                                    ,
                                    "211",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    "20000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            UY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|21997|911",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    "178\\d",
                                    ,
                                    ,
                                    ,
                                    "1780",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[04]\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)|45400",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "454\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "45400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "454\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "45400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            VA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VG: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VI: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "WF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[4-69])",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "WS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[4-69])",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "12[0-6]",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            XK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "XK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "YE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "YT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[134]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:01\\d\\d|12)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "41(?:348|851)",
                                    ,
                                    ,
                                    ,
                                    "41348",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:01(?:11|77)|12)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "107"
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699",
                                    ,
                                    ,
                                    ,
                                    "30782",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[34]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            ZM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[139]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:5[023]|61|9[3-59])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[013-57-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "30000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[3-59]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "114|9(?:5[023]|6[0-25])",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ]
                        }; /*

 Copyright (C) 2018 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.ShortNumberInfo = function() {
                            this.regionToMetadataMap = {};
                        };
                        goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);
                        i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = [
                            "BR",
                            "CL",
                            "NI"
                        ];
                        i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = {
                            TOLL_FREE: 0,
                            STANDARD_RATE: 1,
                            PREMIUM_RATE: 2,
                            UNKNOWN_COST: 3
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(a) {
                            return (a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a]) ? a : [];
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(a, b) {
                            a = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            return null != b && a.includes(b);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            if (!b) return !1;
                            a = this.getNationalSignificantNumber_(a).length;
                            return b.getGeneralDesc().possibleLengthArray().includes(a);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            a = this.getNationalSignificantNumber_(a).length;
                            for(var c = 0; c < b.length; c++){
                                var d = this.getMetadataForRegion_(b[c]);
                                if (d && d.getGeneralDesc().possibleLengthArray().includes(a)) return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            if (!b) return !1;
                            a = this.getNationalSignificantNumber_(a);
                            var c = b.getGeneralDesc();
                            if (!this.matchesPossibleNumberAndNationalNumber_(a, c)) return !1;
                            b = b.getShortCode();
                            return this.matchesPossibleNumberAndNationalNumber_(a, b);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()), c = this.getRegionCodeForShortNumberFromRegionList_(a, b);
                            return 1 < b.length && null != c ? !0 : this.isValidShortNumberForRegion(a, c);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(a, b) {
                            var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return c.UNKNOWN_COST;
                            var d = this.getMetadataForRegion_(b);
                            if (!d) return c.UNKNOWN_COST;
                            a = this.getNationalSignificantNumber_(a);
                            return d.getGeneralDesc().possibleLengthArray().includes(a.length) ? this.matchesPossibleNumberAndNationalNumber_(a, d.getPremiumRate()) ? c.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(a, d.getStandardRate()) ? c.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(a, d.getTollFree()) || this.isEmergencyNumber(a, b) ? c.TOLL_FREE : c.UNKNOWN_COST : c.UNKNOWN_COST;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(a) {
                            var b = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, c = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            if (0 === c.length) return b.UNKNOWN_COST;
                            if (1 === c.length) return this.getExpectedCostForRegion(a, c[0]);
                            for(var d = b.TOLL_FREE, e = 0; e < c.length; e++){
                                var f = this.getExpectedCostForRegion(a, c[e]);
                                switch(f){
                                    case b.PREMIUM_RATE:
                                        return b.PREMIUM_RATE;
                                    case b.UNKNOWN_COST:
                                        d = b.UNKNOWN_COST;
                                        break;
                                    case b.STANDARD_RATE:
                                        d !== b.UNKNOWN_COST && (d = b.STANDARD_RATE);
                                        break;
                                    case b.TOLL_FREE:
                                        break;
                                    default:
                                        throw Error("Unrecognized cost for region: " + f);
                                }
                            }
                            return d;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(a, b) {
                            if (0 === b.length) return null;
                            if (1 === b.length) return b[0];
                            a = this.getNationalSignificantNumber_(a);
                            for(var c = 0; c < b.length; c++){
                                var d = b[c], e = this.getMetadataForRegion_(d);
                                if (e && this.matchesPossibleNumberAndNationalNumber_(a, e.getShortCode())) return d;
                            }
                            return null;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
                            return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(a) {
                                return isNaN(a);
                            });
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(a) {
                            a = this.getMetadataForRegion_(a);
                            if (!a) return "";
                            a = a.getShortCode();
                            return a.hasExampleNumber() ? a.getExampleNumber() || "" : "";
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(a, b) {
                            a = this.getMetadataForRegion_(a);
                            if (!a) return "";
                            var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, d = null;
                            switch(b){
                                case c.TOLL_FREE:
                                    d = a.getTollFree();
                                    break;
                                case c.STANDARD_RATE:
                                    d = a.getStandardRate();
                                    break;
                                case c.PREMIUM_RATE:
                                    d = a.getPremiumRate();
                            }
                            return d && d.hasExampleNumber() ? d.getExampleNumber() || "" : "";
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(a, b) {
                            return this.matchesEmergencyNumberHelper_(a, b, !0);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(a, b) {
                            return this.matchesEmergencyNumberHelper_(a, b, !1);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(a) {
                            if (!a) return null;
                            a = a.toUpperCase();
                            var b = this.regionToMetadataMap[a];
                            if (null == b) {
                                b = new goog.proto2.PbLiteSerializer;
                                var c = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];
                                if (null == c) return null;
                                b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
                                this.regionToMetadataMap[a] = b;
                            }
                            return b;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(a, b, c) {
                            var d = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);
                            if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d)) return !1;
                            a = this.getMetadataForRegion_(b);
                            if (null == a || !a.hasEmergency()) return !1;
                            d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);
                            b = c && !i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(b);
                            c = a.getEmergency().getNationalNumberPatternOrDefault();
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c, d) || b && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c, d);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            b = this.getRegionCodeForShortNumberFromRegionList_(a, b);
                            a = this.getNationalSignificantNumber_(a);
                            b = this.getMetadataForRegion_(b);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            a = this.getNationalSignificantNumber_(a);
                            b = this.getMetadataForRegion_(b);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            a = this.getNationalSignificantNumber_(a);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getSmsServices());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(a) {
                            if (!a.hasNationalNumber()) return "";
                            var b = "" + a.getNationalNumber();
                            return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(a, b) {
                            return 0 < b.possibleLengthArray().length && !b.possibleLengthArray().includes(a.length) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a.toString());
                        };
                        i18n.phonenumbers.AsYouTypeFormatter = function(a) {
                            this.DIGIT_PLACEHOLDER_ = "\u2008";
                            this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_);
                            this.currentOutput_ = "";
                            this.formattingTemplate_ = new goog.string.StringBuffer;
                            this.currentFormattingPattern_ = "";
                            this.accruedInput_ = new goog.string.StringBuffer;
                            this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer;
                            this.ableToFormat_ = !0;
                            this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1;
                            this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance();
                            this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0;
                            this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer;
                            this.shouldAddSpaceAfterNationalPrefix_ = !1;
                            this.extractedNationalPrefix_ = "";
                            this.nationalNumber_ = new goog.string.StringBuffer;
                            this.possibleFormats_ = [];
                            this.defaultCountry_ = a;
                            this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ";
                        i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata;
                        i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");
                        i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*\\$1[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)*$");
                        i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/;
                        i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3;
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(a) {
                            a = this.phoneUtil_.getCountryCodeForRegion(a);
                            a = this.phoneUtil_.getRegionCodeForCountryCode(a);
                            a = this.phoneUtil_.getMetadataForRegion(a);
                            return null != a ? a : i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
                            for(var a = this.possibleFormats_.length, b = 0; b < a; ++b){
                                var c = this.possibleFormats_[b], d = c.getPatternOrDefault();
                                if (this.currentFormattingPattern_ == d) return !1;
                                if (this.createFormattingTemplate_(c)) return this.currentFormattingPattern_ = d, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
                            }
                            return this.ableToFormat_ = !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(a) {
                            for(var b = this.isCompleteNumber_ && 0 == this.extractedNationalPrefix_.length && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c = b.length, d = 0; d < c; ++d){
                                var e = b[d];
                                0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) && !e.getNationalPrefixOptionalWhenFormatting() && !e.hasDomesticCarrierCodeFormattingRule() || (0 != this.extractedNationalPrefix_.length || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) || e.getNationalPrefixOptionalWhenFormatting()) && i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e.getFormatOrDefault()) && this.possibleFormats_.push(e);
                            }
                            this.narrowDownPossibleFormats_(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(a) {
                            for(var b = [], c = a.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d = this.possibleFormats_.length, e = 0; e < d; ++e){
                                var f = this.possibleFormats_[e];
                                if (0 == f.leadingDigitsPatternCount()) b.push(this.possibleFormats_[e]);
                                else {
                                    var g = Math.min(c, f.leadingDigitsPatternCount() - 1);
                                    f = f.getLeadingDigitsPattern(g);
                                    0 == a.search(f) && b.push(this.possibleFormats_[e]);
                                }
                            }
                            this.possibleFormats_ = b;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(a) {
                            var b = a.getPatternOrDefault();
                            this.formattingTemplate_.clear();
                            a = this.getFormattingTemplate_(b, a.getFormatOrDefault());
                            return 0 < a.length ? (this.formattingTemplate_.append(a), !0) : !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(a, b) {
                            var c = "999999999999999".match(a)[0];
                            if (c.length < this.nationalNumber_.getLength()) return "";
                            a = c.replace(new RegExp(a, "g"), b);
                            return a = a.replace(/9/g, this.DIGIT_PLACEHOLDER_);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
                            this.currentOutput_ = "";
                            this.accruedInput_.clear();
                            this.accruedInputWithoutFormatting_.clear();
                            this.formattingTemplate_.clear();
                            this.lastMatchPosition_ = 0;
                            this.currentFormattingPattern_ = "";
                            this.prefixBeforeNationalNumber_.clear();
                            this.extractedNationalPrefix_ = "";
                            this.nationalNumber_.clear();
                            this.ableToFormat_ = !0;
                            this.inputHasFormatting_ = !1;
                            this.originalPosition_ = this.positionToRemember_ = 0;
                            this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1;
                            this.possibleFormats_ = [];
                            this.shouldAddSpaceAfterNationalPrefix_ = !1;
                            this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(a) {
                            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !1);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(a) {
                            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !0);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(a, b) {
                            this.accruedInput_.append(a);
                            b && (this.originalPosition_ = this.accruedInput_.getLength());
                            this.isDigitOrLeadingPlusSign_(a) ? a = this.normalizeAndAccrueDigitsAndPlusSign_(a, b) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0);
                            if (!this.ableToFormat_) {
                                if (!this.inputHasFormatting_) {
                                    if (this.attemptToExtractIdd_()) {
                                        if (this.attemptToExtractCountryCallingCode_()) return this.attemptToChoosePatternWithPrefixExtracted_();
                                    } else if (this.ableToExtractLongerNdd_()) return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
                                }
                                return this.accruedInput_.toString();
                            }
                            switch(this.accruedInputWithoutFormatting_.getLength()){
                                case 0:
                                case 1:
                                case 2:
                                    return this.accruedInput_.toString();
                                case 3:
                                    if (this.attemptToExtractIdd_()) this.isExpectingCountryCallingCode_ = !0;
                                    else return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
                                default:
                                    if (this.isExpectingCountryCallingCode_) return this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString();
                                    if (0 < this.possibleFormats_.length) {
                                        a = this.inputDigitHelper_(a);
                                        b = this.attemptToFormatAccruedDigits_();
                                        if (0 < b.length) return b;
                                        this.narrowDownPossibleFormats_(this.nationalNumber_.toString());
                                        return this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(a) : this.accruedInput_.toString();
                                    }
                                    return this.attemptToChooseFormattingPattern_();
                            }
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
                            this.ableToFormat_ = !0;
                            this.isExpectingCountryCallingCode_ = !1;
                            this.possibleFormats_ = [];
                            this.lastMatchPosition_ = 0;
                            this.formattingTemplate_.clear();
                            this.currentFormattingPattern_ = "";
                            return this.attemptToChooseFormattingPattern_();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
                            return this.extractedNationalPrefix_;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
                            if (0 < this.extractedNationalPrefix_.length) {
                                var a = this.nationalNumber_.toString();
                                this.nationalNumber_.clear();
                                this.nationalNumber_.append(this.extractedNationalPrefix_);
                                this.nationalNumber_.append(a);
                                a = this.prefixBeforeNationalNumber_.toString();
                                var b = a.lastIndexOf(this.extractedNationalPrefix_);
                                this.prefixBeforeNationalNumber_.clear();
                                this.prefixBeforeNationalNumber_.append(a.substring(0, b));
                            }
                            return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a) || 1 == this.accruedInput_.getLength() && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
                            for(var a = this.nationalNumber_.toString(), b = this.possibleFormats_.length, c = 0; c < b; ++c){
                                var d = this.possibleFormats_[c], e = d.getPatternOrDefault();
                                if (new RegExp("^(?:" + e + ")$").test(a) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()), d = a.replace(new RegExp(e, "g"), d.getFormat()), d = this.appendNationalNumber_(d), i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d) == this.accruedInputWithoutFormatting_)) return d;
                            }
                            return "";
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(a) {
                            var b = this.prefixBeforeNationalNumber_.getLength();
                            return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b && this.prefixBeforeNationalNumber_.toString().charAt(b - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a : this.prefixBeforeNationalNumber_ + a;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
                            if (!this.ableToFormat_) return this.originalPosition_;
                            for(var a = 0, b = 0, c = this.accruedInputWithoutFormatting_.toString(), d = this.currentOutput_.toString(); a < this.positionToRemember_ && b < d.length;)c.charAt(a) == d.charAt(b) && a++, b++;
                            return b;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
                            var a = this.nationalNumber_.toString();
                            return a.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a), a = this.attemptToFormatAccruedDigits_(), 0 < a.length ? a : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
                            var a = this.nationalNumber_.toString(), b = a.length;
                            if (0 < b) {
                                for(var c = "", d = 0; d < b; d++)c = this.inputDigitHelper_(a.charAt(d));
                                return this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
                            }
                            return this.prefixBeforeNationalNumber_.toString();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
                            if (1 != this.currentMetadata_.getCountryCode()) return !1;
                            var a = this.nationalNumber_.toString();
                            return "1" == a.charAt(0) && "0" != a.charAt(1) && "1" != a.charAt(1);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
                            var a = this.nationalNumber_.toString(), b = 0;
                            if (this.isNanpaNumberWithNationalPrefix_()) b = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
                            else if (this.currentMetadata_.hasNationalPrefixForParsing()) {
                                var c = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
                                c = a.match(c);
                                null != c && null != c[0] && 0 < c[0].length && (this.isCompleteNumber_ = !0, b = c[0].length, this.prefixBeforeNationalNumber_.append(a.substring(0, b)));
                            }
                            this.nationalNumber_.clear();
                            this.nationalNumber_.append(a.substring(b));
                            return a.substring(0, b);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
                            var a = this.accruedInputWithoutFormatting_.toString(), b = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
                            b = a.match(b);
                            return null != b && null != b[0] && 0 < b[0].length ? (this.isCompleteNumber_ = !0, b = b[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a.substring(b)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a.substring(0, b)), a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
                            if (0 == this.nationalNumber_.getLength()) return !1;
                            var a = new goog.string.StringBuffer, b = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a);
                            if (0 == b) return !1;
                            this.nationalNumber_.clear();
                            this.nationalNumber_.append(a.toString());
                            a = this.phoneUtil_.getRegionCodeForCountryCode(b);
                            i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b) : a != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a));
                            this.prefixBeforeNationalNumber_.append("" + b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);
                            this.extractedNationalPrefix_ = "";
                            return !0;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(a, b) {
                            if (a == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
                                var c = a;
                                this.accruedInputWithoutFormatting_.append(a);
                            } else c = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a], this.accruedInputWithoutFormatting_.append(c), this.nationalNumber_.append(c);
                            b && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength());
                            return c;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(a) {
                            var b = this.formattingTemplate_.toString();
                            if (0 <= b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
                                var c = b.search(this.DIGIT_PATTERN_);
                                a = b.replace(this.DIGIT_PATTERN_, a);
                                this.formattingTemplate_.clear();
                                this.formattingTemplate_.append(a);
                                this.lastMatchPosition_ = c;
                                return a.substring(0, this.lastMatchPosition_ + 1);
                            }
                            1 == this.possibleFormats_.length && (this.ableToFormat_ = !1);
                            this.currentFormattingPattern_ = "";
                            return this.accruedInput_.toString();
                        };
                        Object.defineProperty(exports, "__esModule", {
                            value: !0
                        });
                        exports.default = i18n.phonenumbers;
                        module1.exports = exports["default"];
                    }).call(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});

});

parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $874ecb7cc9a437a2$var$extendStatics = function(d, b) {
    $874ecb7cc9a437a2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $874ecb7cc9a437a2$var$extendStatics(d, b);
};
function $874ecb7cc9a437a2$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $874ecb7cc9a437a2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $874ecb7cc9a437a2$var$__assign = function() {
    $874ecb7cc9a437a2$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $874ecb7cc9a437a2$var$__assign.apply(this, arguments);
};
function $874ecb7cc9a437a2$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $874ecb7cc9a437a2$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $874ecb7cc9a437a2$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
function $874ecb7cc9a437a2$var$e(e, t) {
    var i = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (i[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (i[o[n]] = e[o[n]]);
    }
    return i;
}
"function" == typeof SuppressedError && SuppressedError;
var $874ecb7cc9a437a2$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $874ecb7cc9a437a2$var$i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $874ecb7cc9a437a2$var$o(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var $874ecb7cc9a437a2$var$n = $874ecb7cc9a437a2$var$o(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, i) {
                var o = e.locked.get(t);
                void 0 === o ? void 0 === i ? e.locked.set(t, []) : e.locked.set(t, [
                    i
                ]) : void 0 !== i && (o.unshift(i), e.locked.set(t, o));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(i, o) {
                    e.isLocked(t) ? e.addToLocked(t, i) : (e.addToLocked(t), i());
                });
            }, this.unlock = function(t) {
                var i = e.locked.get(t);
                if (void 0 !== i && 0 !== i.length) {
                    var o = i.pop();
                    e.locked.set(t, i), void 0 !== o && setTimeout(o, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return i.getInstance();
    };
});
$874ecb7cc9a437a2$var$i($874ecb7cc9a437a2$var$n);
var $874ecb7cc9a437a2$var$a = $874ecb7cc9a437a2$var$i($874ecb7cc9a437a2$var$o(function(e, i) {
    var o = $874ecb7cc9a437a2$var$t && $874ecb7cc9a437a2$var$t.__awaiter || function(e, t, i, o) {
        return new (i || (i = Promise))(function(n, a) {
            function r(e) {
                try {
                    c(o.next(e));
                } catch (e) {
                    a(e);
                }
            }
            function s(e) {
                try {
                    c(o.throw(e));
                } catch (e) {
                    a(e);
                }
            }
            function c(e) {
                e.done ? n(e.value) : new i(function(t) {
                    t(e.value);
                }).then(r, s);
            }
            c((o = o.apply(e, t || [])).next());
        });
    }, a = $874ecb7cc9a437a2$var$t && $874ecb7cc9a437a2$var$t.__generator || function(e, t) {
        var i, o, n, a, r = {
            label: 0,
            sent: function() {
                if (1 & n[0]) throw n[1];
                return n[1];
            },
            trys: [],
            ops: []
        };
        return a = {
            next: s(0),
            throw: s(1),
            return: s(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this;
        }), a;
        function s(a) {
            return function(s) {
                return function(a) {
                    if (i) throw new TypeError("Generator is already executing.");
                    for(; r;)try {
                        if (i = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                        switch(o = 0, n && (a = [
                            2 & a[0],
                            n.value
                        ]), a[0]){
                            case 0:
                            case 1:
                                n = a;
                                break;
                            case 4:
                                return r.label++, {
                                    value: a[1],
                                    done: !1
                                };
                            case 5:
                                r.label++, o = a[1], a = [
                                    0
                                ];
                                continue;
                            case 7:
                                a = r.ops.pop(), r.trys.pop();
                                continue;
                            default:
                                if (!(n = r.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                    r = 0;
                                    continue;
                                }
                                if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                    r.label = a[1];
                                    break;
                                }
                                if (6 === a[0] && r.label < n[1]) {
                                    r.label = n[1], n = a;
                                    break;
                                }
                                if (n && r.label < n[2]) {
                                    r.label = n[2], r.ops.push(a);
                                    break;
                                }
                                n[2] && r.ops.pop(), r.trys.pop();
                                continue;
                        }
                        a = t.call(e, r);
                    } catch (e) {
                        a = [
                            6,
                            e
                        ], o = 0;
                    } finally{
                        i = n = 0;
                    }
                    if (5 & a[0]) throw a[1];
                    return {
                        value: a[0] ? a[1] : void 0,
                        done: !0
                    };
                }([
                    a,
                    s
                ]);
            };
        }
    }, r = $874ecb7cc9a437a2$var$t;
    Object.defineProperty(i, "__esModule", {
        value: !0
    });
    var s = "browser-tabs-lock-key", c = {
        key: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function d(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function u(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", o = 0; o < e; o++)i += t[Math.floor(Math.random() * t.length)];
        return i;
    }
    var l = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + u(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, i) {
            return void 0 === i && (i = 5e3), o(this, void 0, void 0, function() {
                var o, n, r, l, h, p, m;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            o = Date.now() + u(4), n = Date.now() + i, r = s + "-" + t, l = void 0 === this.storageHandler ? c : this.storageHandler, a.label = 1;
                        case 1:
                            return Date.now() < n ? [
                                4,
                                d(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return a.sent(), null !== l.getItemSync(r) ? [
                                3,
                                5
                            ] : (h = this.id + "-" + t + "-" + o, [
                                4,
                                d(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return a.sent(), l.setItemSync(r, JSON.stringify({
                                id: this.id,
                                iat: o,
                                timeoutKey: h,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                d(30)
                            ];
                        case 4:
                            return a.sent(), null !== (p = l.getItemSync(r)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(n)
                            ];
                        case 6:
                            a.sent(), a.label = 7;
                        case 7:
                            return o = Date.now() + u(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return o(this, void 0, void 0, function() {
                var i = this;
                return a(this, function(r) {
                    return setTimeout(function() {
                        return o(i, void 0, void 0, function() {
                            var i, o, r;
                            return a(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return [
                                            4,
                                            $874ecb7cc9a437a2$var$n.default().lock(t)
                                        ];
                                    case 1:
                                        return a.sent(), this.acquiredIatSet.has(t) ? (i = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = i.getItemSync(e)) ? ($874ecb7cc9a437a2$var$n.default().unlock(t), [
                                            2
                                        ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), i.setItemSync(e, JSON.stringify(r)), $874ecb7cc9a437a2$var$n.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : ($874ecb7cc9a437a2$var$n.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return o(this, void 0, void 0, function() {
                return a(this, function(i) {
                    switch(i.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(i) {
                                    var o = !1, n = Date.now(), a = !1;
                                    function r() {
                                        if (a || (window.removeEventListener("storage", r), e.removeFromWaiting(r), clearTimeout(s), a = !0), !o) {
                                            o = !0;
                                            var t = 50 - (Date.now() - n);
                                            t > 0 ? setTimeout(i, t) : i(null);
                                        }
                                    }
                                    window.addEventListener("storage", r), e.addToWaiting(r);
                                    var s = setTimeout(r, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return i.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return o(this, void 0, void 0, function() {
                return a(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return o(this, void 0, void 0, function() {
                var i, o, r, d;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            return i = void 0 === this.storageHandler ? c : this.storageHandler, o = s + "-" + t, null === (r = i.getItemSync(o)) ? [
                                2
                            ] : (d = JSON.parse(r)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                $874ecb7cc9a437a2$var$n.default().lock(d.iat)
                            ];
                        case 1:
                            a.sent(), this.acquiredIatSet.delete(d.iat), i.removeItemSync(o), $874ecb7cc9a437a2$var$n.default().unlock(d.iat), e.notifyWaiters(), a.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var i = Date.now() - 5e3, o = t, n = [], a = 0;;){
                var r = o.keySync(a);
                if (null === r) break;
                n.push(r), a++;
            }
            for(var c = !1, d = 0; d < n.length; d++){
                var u = n[d];
                if (u.includes(s)) {
                    var l = o.getItemSync(u);
                    if (null !== l) {
                        var h = JSON.parse(l);
                        (void 0 === h.timeRefreshed && h.timeAcquired < i || void 0 !== h.timeRefreshed && h.timeRefreshed < i) && (o.removeItemSync(u), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    i.default = l;
}));
const $874ecb7cc9a437a2$var$r = {
    timeoutInSeconds: 60
}, $874ecb7cc9a437a2$var$s = {
    name: "auth0-spa-js",
    version: "2.1.3"
}, $874ecb7cc9a437a2$var$c = ()=>Date.now();
class $874ecb7cc9a437a2$export$7d465be8efa67280 extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$7d465be8efa67280.prototype);
    }
    static fromPayload({ error: e, error_description: t }) {
        return new $874ecb7cc9a437a2$export$7d465be8efa67280(e, t);
    }
}
class $874ecb7cc9a437a2$export$cf0c46b07324e9c5 extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(e, t, i, o = null){
        super(e, t), this.state = i, this.appState = o, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$cf0c46b07324e9c5.prototype);
    }
}
class $874ecb7cc9a437a2$export$66d311bf29d5c89c extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$66d311bf29d5c89c.prototype);
    }
}
class $874ecb7cc9a437a2$export$ebbb83fe03f719a4 extends $874ecb7cc9a437a2$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$ebbb83fe03f719a4.prototype);
    }
}
class $874ecb7cc9a437a2$export$f1f681f0fb26bb55 extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$f1f681f0fb26bb55.prototype);
    }
}
class $874ecb7cc9a437a2$export$c59494f4dae44ada extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(e, t, i){
        super(e, t), this.mfa_token = i, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$c59494f4dae44ada.prototype);
    }
}
class $874ecb7cc9a437a2$export$ac1d2a00f8e0a046 extends $874ecb7cc9a437a2$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${$874ecb7cc9a437a2$var$g(e, [
            "default"
        ])}', scope: '${$874ecb7cc9a437a2$var$g(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $874ecb7cc9a437a2$export$ac1d2a00f8e0a046.prototype);
    }
}
function $874ecb7cc9a437a2$var$g(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const $874ecb7cc9a437a2$var$w = ()=>window.crypto, $874ecb7cc9a437a2$var$y = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($874ecb7cc9a437a2$var$w().getRandomValues(new Uint8Array(43))).forEach((i)=>t += e[i % e.length]), t;
}, $874ecb7cc9a437a2$var$k = (e)=>btoa(e), $874ecb7cc9a437a2$var$v = (t)=>{
    var { clientId: i } = t, o = $874ecb7cc9a437a2$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, i)=>Object.assign(Object.assign({}, t), {
                [i]: e[i]
            }), {}))(Object.assign({
        client_id: i
    }, o))).toString();
}, $874ecb7cc9a437a2$var$b = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $874ecb7cc9a437a2$var$_ = async (e, t)=>{
    const i = await fetch(e, t);
    return {
        ok: i.ok,
        json: await i.json()
    };
}, $874ecb7cc9a437a2$var$I = async (e, t, i)=>{
    const o = new AbortController;
    let n;
    return t.signal = o.signal, Promise.race([
        $874ecb7cc9a437a2$var$_(e, t),
        new Promise((e, t)=>{
            n = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, i);
        })
    ]).finally(()=>{
        clearTimeout(n);
    });
}, $874ecb7cc9a437a2$var$S = async (e, t, i, o, n, a, r)=>{
    var s, c;
    return s = {
        auth: {
            audience: t,
            scope: i
        },
        timeout: n,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: r
    }, c = a, new Promise(function(e, t) {
        const i = new MessageChannel;
        i.port1.onmessage = function(o) {
            o.data.error ? t(new Error(o.data.error)) : e(o.data), i.port1.close();
        }, c.postMessage(s, [
            i.port2
        ]);
    });
}, $874ecb7cc9a437a2$var$O = async (e, t, i, o, n, a, r = 1e4)=>n ? $874ecb7cc9a437a2$var$S(e, t, i, o, r, n, a) : $874ecb7cc9a437a2$var$I(e, o, r);
async function $874ecb7cc9a437a2$var$T(t, i) {
    var { baseUrl: o, timeout: n, audience: a, scope: r, auth0Client: c, useFormData: u } = t, l = $874ecb7cc9a437a2$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData"
    ]);
    const h = u ? $874ecb7cc9a437a2$var$v(l) : JSON.stringify(l);
    return await async function(t, i, o, n, a, r, s) {
        let c, u = null;
        for(let e = 0; e < 3; e++)try {
            c = await $874ecb7cc9a437a2$var$O(t, o, n, a, r, s, i), u = null;
            break;
        } catch (e) {
            u = e;
        }
        if (u) throw u;
        const l = c.json, { error: h, error_description: p } = l, g = $874ecb7cc9a437a2$var$e(l, [
            "error",
            "error_description"
        ]), { ok: w } = c;
        if (!w) {
            const e = p || `HTTP error. Unable to fetch ${t}`;
            if ("mfa_required" === h) throw new $874ecb7cc9a437a2$export$c59494f4dae44ada(h, e, g.mfa_token);
            if ("missing_refresh_token" === h) throw new $874ecb7cc9a437a2$export$ac1d2a00f8e0a046(o, n);
            throw new $874ecb7cc9a437a2$export$7d465be8efa67280(h || "request_error", e);
        }
        return g;
    }(`${o}/oauth/token`, n, a || "default", r, {
        method: "POST",
        body: h,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(c || $874ecb7cc9a437a2$var$s))
        }
    }, i, u);
}
const $874ecb7cc9a437a2$var$j = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
};
class $874ecb7cc9a437a2$var$C {
    constructor(e, t = "@@auth0spajs@@", i){
        this.prefix = t, this.suffix = i, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, i, o, n] = e.split("::");
        return new $874ecb7cc9a437a2$var$C({
            clientId: i,
            scope: n,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: i, client_id: o } = e;
        return new $874ecb7cc9a437a2$var$C({
            scope: t,
            audience: i,
            clientId: o
        });
    }
}
class $874ecb7cc9a437a2$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $874ecb7cc9a437a2$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, i) {
                    e[t] = i;
                },
                get (t) {
                    const i = e[t];
                    if (i) return i;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $874ecb7cc9a437a2$var$x {
    constructor(e, t, i){
        this.cache = e, this.keyManifest = t, this.nowProvider = i || $874ecb7cc9a437a2$var$c;
    }
    async setIdToken(e, t, i) {
        var o;
        const n = this.getIdTokenCacheKey(e);
        await this.cache.set(n, {
            id_token: t,
            decodedToken: i
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(n));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0) {
        var i;
        let o = await this.cache.get(e.toKey());
        if (!o) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            i && (o = await this.cache.get(i));
        }
        if (!o) return;
        const n = await this.nowProvider(), a = Math.floor(n / 1e3);
        return o.expiresAt - t < a ? o.body.refresh_token ? (o.body = {
            refresh_token: o.body.refresh_token
        }, await this.cache.set(e.toKey(), o), o.body) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : o.body;
    }
    async set(e) {
        var t;
        const i = new $874ecb7cc9a437a2$var$C({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(i.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(i.toKey()));
    }
    async clear(e) {
        var t;
        const i = await this.getCacheKeys();
        i && (await i.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $874ecb7cc9a437a2$var$C({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var i;
            const o = $874ecb7cc9a437a2$var$C.fromKey(t), n = new Set(o.scope && o.scope.split(" ")), a = (null === (i = e.scope) || void 0 === i ? void 0 : i.split(" ")) || [], r = o.scope && a.reduce((e, t)=>e && n.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && r;
        })[0];
    }
}
class $874ecb7cc9a437a2$var$Z {
    constructor(e, t, i){
        this.storage = e, this.clientId = t, this.cookieDomain = i, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const $874ecb7cc9a437a2$var$K = (e)=>"number" == typeof e, $874ecb7cc9a437a2$var$W = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $874ecb7cc9a437a2$var$E = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [i, o, n] = t;
        if (3 !== t.length || !i || !o || !n) throw new Error("ID token could not be decoded");
        const a = JSON.parse($874ecb7cc9a437a2$var$b(o)), r = {
            __raw: e
        }, s = {};
        return Object.keys(a).forEach((e)=>{
            r[e] = a[e], $874ecb7cc9a437a2$var$W.includes(e) || (s[e] = a[e]);
        }), {
            encoded: {
                header: i,
                payload: o,
                signature: n
            },
            header: JSON.parse($874ecb7cc9a437a2$var$b(i)),
            claims: r,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !$874ecb7cc9a437a2$var$K(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$874ecb7cc9a437a2$var$K(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$874ecb7cc9a437a2$var$K(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const i = e.leeway || 60, o = new Date(e.now || Date.now()), n = new Date(0);
    if (n.setUTCSeconds(t.claims.exp + i), o > n) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);
    if (null != t.claims.nbf && $874ecb7cc9a437a2$var$K(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - i), o < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`);
    }
    if (null != t.claims.auth_time && $874ecb7cc9a437a2$var$K(t.claims.auth_time)) {
        const n = new Date(0);
        if (n.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), o > n) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`);
    }
    if (e.organization) {
        const i = e.organization.trim();
        if (i.startsWith("org_")) {
            const e = i;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = i.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var $874ecb7cc9a437a2$var$R = $874ecb7cc9a437a2$var$o(function(e, i) {
    var o = $874ecb7cc9a437a2$var$t && $874ecb7cc9a437a2$var$t.__assign || function() {
        return o = Object.assign || function(e) {
            for(var t, i = 1, o = arguments.length; i < o; i++)for(var n in t = arguments[i])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e;
        }, o.apply(this, arguments);
    };
    function n(e, t) {
        if (!t) return "";
        var i = "; " + e;
        return !0 === t ? i : i + "=" + t;
    }
    function a(e, t, i) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return n("Expires", e.expires ? e.expires.toUTCString() : "") + n("Domain", e.domain) + n("Path", e.path) + n("Secure", e.secure) + n("SameSite", e.sameSite);
        }(i);
    }
    function r(e) {
        for(var t = {}, i = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, n = 0; n < i.length; n++){
            var a = i[n].split("="), r = a.slice(1).join("=");
            '"' === r.charAt(0) && (r = r.slice(1, -1));
            try {
                t[a[0].replace(o, decodeURIComponent)] = r.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function s() {
        return r(document.cookie);
    }
    function c(e, t, i) {
        document.cookie = a(e, t, o({
            path: "/"
        }, i));
    }
    i.__esModule = !0, i.encode = a, i.parse = r, i.getAll = s, i.get = function(e) {
        return s()[e];
    }, i.set = c, i.remove = function(e, t) {
        c(e, "", o(o({}, t), {
            expires: -1
        }));
    };
});
$874ecb7cc9a437a2$var$i($874ecb7cc9a437a2$var$R), $874ecb7cc9a437a2$var$R.encode, $874ecb7cc9a437a2$var$R.parse, $874ecb7cc9a437a2$var$R.getAll;
var $874ecb7cc9a437a2$var$U = $874ecb7cc9a437a2$var$R.get, $874ecb7cc9a437a2$var$L = $874ecb7cc9a437a2$var$R.set, $874ecb7cc9a437a2$var$D = $874ecb7cc9a437a2$var$R.remove;
const $874ecb7cc9a437a2$var$X = {
    get (e) {
        const t = $874ecb7cc9a437a2$var$U(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $874ecb7cc9a437a2$var$L(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $874ecb7cc9a437a2$var$D(e, i);
    }
}, $874ecb7cc9a437a2$var$N = {
    get (e) {
        const t = $874ecb7cc9a437a2$var$X.get(e);
        return t || $874ecb7cc9a437a2$var$X.get(`_legacy_${e}`);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $874ecb7cc9a437a2$var$L(`_legacy_${e}`, JSON.stringify(t), o), $874ecb7cc9a437a2$var$X.save(e, t, i);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $874ecb7cc9a437a2$var$D(e, i), $874ecb7cc9a437a2$var$X.remove(e, t), $874ecb7cc9a437a2$var$X.remove(`_legacy_${e}`, t);
    }
}, $874ecb7cc9a437a2$var$J = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
function $874ecb7cc9a437a2$var$F(e, t, i) {
    var o = void 0 === t ? null : t, n = function(e, t) {
        var i = atob(e);
        if (t) {
            for(var o = new Uint8Array(i.length), n = 0, a = i.length; n < a; ++n)o[n] = i.charCodeAt(n);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return i;
    }(e, void 0 !== i && i), a = n.indexOf("\n", 10) + 1, r = n.substring(a) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        r
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $874ecb7cc9a437a2$var$H, $874ecb7cc9a437a2$var$Y, $874ecb7cc9a437a2$var$G, $874ecb7cc9a437a2$var$V, $874ecb7cc9a437a2$var$M = ($874ecb7cc9a437a2$var$H = "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", $874ecb7cc9a437a2$var$Y = null, $874ecb7cc9a437a2$var$G = !1, function(e) {
    return $874ecb7cc9a437a2$var$V = $874ecb7cc9a437a2$var$V || $874ecb7cc9a437a2$var$F($874ecb7cc9a437a2$var$H, $874ecb7cc9a437a2$var$Y, $874ecb7cc9a437a2$var$G), new Worker($874ecb7cc9a437a2$var$V, e);
});
const $874ecb7cc9a437a2$var$A = {};
class $874ecb7cc9a437a2$var$B {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const i = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        i.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...i
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const i = new Set(t.keys);
            return i.delete(e), i.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...i
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
}
const $874ecb7cc9a437a2$var$$ = {
    memory: ()=>(new $874ecb7cc9a437a2$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $874ecb7cc9a437a2$export$40ef2cb682e70737
}, $874ecb7cc9a437a2$var$q = (e)=>$874ecb7cc9a437a2$var$$[e], $874ecb7cc9a437a2$var$Q = (t)=>{
    const { openUrl: i, onRedirect: o } = t, n = $874ecb7cc9a437a2$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, n), {
        openUrl: !1 === i || i ? i : o
    });
}, $874ecb7cc9a437a2$var$ee = new $874ecb7cc9a437a2$var$a;
class $874ecb7cc9a437a2$var$te {
    constructor(e){
        let t, i;
        if (this.userCache = (new $874ecb7cc9a437a2$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            await $874ecb7cc9a437a2$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$874ecb7cc9a437a2$var$w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $874ecb7cc9a437a2$var$w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) i = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$874ecb7cc9a437a2$var$q(t)) throw new Error(`Invalid cache location "${t}"`);
            i = $874ecb7cc9a437a2$var$q(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $874ecb7cc9a437a2$var$X : $874ecb7cc9a437a2$var$N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const o = e.useCookiesForTransactions ? this.cookieStorage : $874ecb7cc9a437a2$var$J;
        var n;
        this.scope = $874ecb7cc9a437a2$var$j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $874ecb7cc9a437a2$var$Z(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $874ecb7cc9a437a2$var$c, this.cacheManager = new $874ecb7cc9a437a2$var$x(i, i.allKeys ? void 0 : new $874ecb7cc9a437a2$var$B(i, this.options.clientId), this.nowProvider), this.domainUrl = (n = this.options.domain, /^https?:\/\//.test(n) ? n : `https://${n}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $874ecb7cc9a437a2$var$M);
    }
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $874ecb7cc9a437a2$var$s)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${$874ecb7cc9a437a2$var$v(e)}`);
    }
    async _verifyIdToken(e, t, i) {
        const o = await this.nowProvider();
        var n;
        return $874ecb7cc9a437a2$var$E({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: i,
            leeway: this.options.leeway,
            max_age: (n = this.options.authorizationParams.max_age, "string" != typeof n ? n : parseInt(n, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, i) {
        const o = $874ecb7cc9a437a2$var$k($874ecb7cc9a437a2$var$y()), n = $874ecb7cc9a437a2$var$k($874ecb7cc9a437a2$var$y()), a = $874ecb7cc9a437a2$var$y(), r = ((e)=>{
            const t = new Uint8Array(e);
            return ((e)=>{
                const t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                };
                return e.replace(/[+/=]/g, (e)=>t[e]);
            })(window.btoa(String.fromCharCode(...Array.from(t))));
        })(await (async (e)=>{
            const t = $874ecb7cc9a437a2$var$w().subtle.digest({
                name: "SHA-256"
            }, (new TextEncoder).encode(e));
            return await t;
        })(a)), s = ((e, t, i, o, n, a, r, s)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), i), {
                scope: $874ecb7cc9a437a2$var$j(t, i.scope),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: n,
                redirect_uri: r || e.authorizationParams.redirect_uri,
                code_challenge: a,
                code_challenge_method: "S256"
            }))(this.options, this.scope, e, o, n, r, e.redirect_uri || this.options.authorizationParams.redirect_uri || i, null == t ? void 0 : t.response_mode), c = this._authorizeUrl(s);
        return {
            nonce: n,
            code_verifier: a,
            scope: s.scope,
            audience: s.audience || "default",
            redirect_uri: s.redirect_uri,
            state: o,
            url: c
        };
    }
    async loginWithPopup(e, t) {
        var i;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, i = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const n = await ((e)=>new Promise((t, i)=>{
                let o;
                const n = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(n), clearTimeout(a), window.removeEventListener("message", o, !1), i(new $874ecb7cc9a437a2$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(n), i(new $874ecb7cc9a437a2$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(r) {
                    if (r.data && "authorization_response" === r.data.type) {
                        if (clearTimeout(a), clearInterval(n), window.removeEventListener("message", o, !1), e.popup.close(), r.data.response.error) return i($874ecb7cc9a437a2$export$7d465be8efa67280.fromPayload(r.data.response));
                        t(r.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== n.state) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = (null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: n.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var i;
        const o = $874ecb7cc9a437a2$var$Q(t), { openUrl: n, fragment: a, appState: r } = o, s = $874ecb7cc9a437a2$var$e(o, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (i = s.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization, d = await this._prepareAuthorizeUrl(s.authorizationParams || {}), { url: u } = d, l = $874ecb7cc9a437a2$var$e(d, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: r
        }), c && {
            organization: c
        }));
        const h = a ? `${u}#${a}` : u;
        n ? await n(h) : window.location.assign(h);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const { state: i, code: o, error: n, error_description: a } = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join("")), r = this.transactionManager.get();
        if (!r) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("missing_transaction", "Invalid state");
        if (this.transactionManager.remove(), n) throw new $874ecb7cc9a437a2$export$cf0c46b07324e9c5(n, a || n, i, r.appState);
        if (!r.code_verifier || r.state && r.state !== i) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const s = r.organization, c = r.nonce, l = r.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: r.audience,
            scope: r.scope,
            code_verifier: r.code_verifier,
            grant_type: "authorization_code",
            code: o
        }, l ? {
            redirect_uri: l
        } : {}), {
            nonceIn: c,
            organization: s
        }), {
            appState: r.appState
        };
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t;
        const i = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $874ecb7cc9a437a2$var$j(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
            })
        }), o = await ((e, t)=>{
            let i = $874ecb7cc9a437a2$var$A[t];
            return i || (i = e().finally(()=>{
                delete $874ecb7cc9a437a2$var$A[t], i = null;
            }), $874ecb7cc9a437a2$var$A[t] = i), i;
        })(()=>this._getTokenSilently(i), `${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);
        return e.detailedResponse ? o : null == o ? void 0 : o.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: i } = t, o = $874ecb7cc9a437a2$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== i) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
            });
            if (e) return e;
        }
        if ("cache-only" !== i) {
            if (!await (async (e, t = 3)=>{
                for(let i = 0; i < t; i++)if (await e()) return !0;
                return !1;
            })(()=>$874ecb7cc9a437a2$var$ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new $874ecb7cc9a437a2$export$66d311bf29d5c89c;
            try {
                if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, access_token: n, oauthTokenScope: a, expires_in: r } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    access_token: n
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: r
                });
            } finally{
                await $874ecb7cc9a437a2$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
            }
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var i;
        const o = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $874ecb7cc9a437a2$var$j(this.scope, null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.scope)
            })
        });
        t = Object.assign(Object.assign({}, $874ecb7cc9a437a2$var$r), t), await this.loginWithPopup(o, t);
        return (await this.cacheManager.get(new $874ecb7cc9a437a2$var$C({
            scope: o.authorizationParams.scope,
            audience: o.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }))).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const i = t.logoutParams || {}, { federated: o } = i, n = $874ecb7cc9a437a2$var$e(i, [
            "federated"
        ]), a = o ? "&federated" : "";
        return this._url(`/v2/logout?${$874ecb7cc9a437a2$var$v(Object.assign({
            clientId: t.clientId
        }, n))}`) + a;
    }
    async logout(t = {}) {
        const i = $874ecb7cc9a437a2$var$Q(t), { openUrl: o } = i, n = $874ecb7cc9a437a2$var$e(i, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@");
        const a = this._buildLogoutUrl(n);
        o ? await o(a) : !1 !== o && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), i = this.cookieStorage.get(this.orgHintCookieName);
        i && !t.organization && (t.organization = i);
        const { url: o, state: n, nonce: a, code_verifier: r, redirect_uri: s, scope: c, audience: u } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const i = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h = await ((e, t, i = 60)=>new Promise((o, n)=>{
                    const a = window.document.createElement("iframe");
                    a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                    const r = ()=>{
                        window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", s, !1));
                    };
                    let s;
                    const c = setTimeout(()=>{
                        n(new $874ecb7cc9a437a2$export$66d311bf29d5c89c), r();
                    }, 1e3 * i);
                    s = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const i = e.source;
                        i && i.close(), e.data.response.error ? n($874ecb7cc9a437a2$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(r, 2e3);
                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                }))(o, this.domainUrl, i);
            if (n !== h.state) throw new $874ecb7cc9a437a2$export$7d465be8efa67280("state_mismatch", "Invalid state");
            const p = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: r,
                code: h.code,
                grant_type: "authorization_code",
                redirect_uri: s,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: a,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, p), {
                scope: c,
                oauthTokenScope: p.scope,
                audience: u
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new $874ecb7cc9a437a2$var$C({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }));
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $874ecb7cc9a437a2$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const i = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null;
        try {
            const n = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: i
            }), o && {
                timeout: o
            }));
            return Object.assign(Object.assign({}, n), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: n.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
    }
    async _saveEntryInCache(t) {
        const { id_token: i, decodedToken: o } = t, n = $874ecb7cc9a437a2$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: i,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(n);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = await this.cacheManager.getIdToken(new $874ecb7cc9a437a2$var$C({
            clientId: this.options.clientId,
            audience: e,
            scope: this.scope
        })), i = this.userCache.get("@@user@@");
        return t && t.id_token === (null == i ? void 0 : i.id_token) ? i : (this.userCache.set("@@user@@", t), t);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: i }) {
        const o = await this.cacheManager.get(new $874ecb7cc9a437a2$var$C({
            scope: e,
            audience: t,
            clientId: i
        }), 60);
        if (o && o.access_token) {
            const { access_token: e, oauthTokenScope: t, expires_in: i } = o, n = await this._getIdTokenFromCache();
            return n && Object.assign(Object.assign({
                id_token: n.id_token,
                access_token: e
            }, t ? {
                scope: t
            } : null), {
                expires_in: i
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: i, organization: o } = t || {}, n = await $874ecb7cc9a437a2$var$T(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs
        }, e), this.worker), a = await this._verifyIdToken(n.id_token, i, o);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n), {
            decodedToken: a,
            scope: e.scope,
            audience: e.audience || "default"
        }), n.scope ? {
            oauthTokenScope: n.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(o || a.claims.org_id), Object.assign(Object.assign({}, n), {
            decodedToken: a
        });
    }
}
class $874ecb7cc9a437a2$export$1f44aaf2ec115b54 {
}
/**
 * The initial auth state.
 */ var $874ecb7cc9a437a2$var$initialAuthState = {
    isAuthenticated: false,
    isLoading: true
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$stub = function() {
    throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$export$1b5d8f0c33515521 = $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, $874ecb7cc9a437a2$var$initialAuthState), {
    buildAuthorizeUrl: $874ecb7cc9a437a2$var$stub,
    buildLogoutUrl: $874ecb7cc9a437a2$var$stub,
    getAccessTokenSilently: $874ecb7cc9a437a2$var$stub,
    getAccessTokenWithPopup: $874ecb7cc9a437a2$var$stub,
    getIdTokenClaims: $874ecb7cc9a437a2$var$stub,
    loginWithRedirect: $874ecb7cc9a437a2$var$stub,
    loginWithPopup: $874ecb7cc9a437a2$var$stub,
    logout: $874ecb7cc9a437a2$var$stub,
    handleRedirectCallback: $874ecb7cc9a437a2$var$stub
});
/**
 * The Auth0 Context
 */ var $874ecb7cc9a437a2$export$419e9d660c2a6030 = (0, $acw62.createContext)($874ecb7cc9a437a2$export$1b5d8f0c33515521);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var $874ecb7cc9a437a2$export$bdc0f363b754b88f = /** @class */ function(_super) {
    $874ecb7cc9a437a2$var$__extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var $874ecb7cc9a437a2$var$CODE_RE = /[?&]code=[^&]+/;
var $874ecb7cc9a437a2$var$STATE_RE = /[?&]state=[^&]+/;
var $874ecb7cc9a437a2$var$ERROR_RE = /[?&]error=[^&]+/;
var $874ecb7cc9a437a2$var$hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return ($874ecb7cc9a437a2$var$CODE_RE.test(searchParams) || $874ecb7cc9a437a2$var$ERROR_RE.test(searchParams)) && $874ecb7cc9a437a2$var$STATE_RE.test(searchParams);
};
var $874ecb7cc9a437a2$var$normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === 'object' && 'error' in error && typeof error.error === 'string') {
            if ('error_description' in error && typeof error.error_description === 'string') return new $874ecb7cc9a437a2$export$bdc0f363b754b88f(error.error, error.error_description);
            return new $874ecb7cc9a437a2$export$bdc0f363b754b88f(error.error);
        }
        return new Error(fallbackMessage);
    };
};
var $874ecb7cc9a437a2$var$loginError = $874ecb7cc9a437a2$var$normalizeErrorFn('Login failed');
var $874ecb7cc9a437a2$var$tokenError = $874ecb7cc9a437a2$var$normalizeErrorFn('Get access token failed');
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $874ecb7cc9a437a2$var$deprecateRedirectUri = function(options) {
    var _a;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn('Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version');
        options.authorizationParams = options.authorizationParams || {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_a = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _a === void 0 ? void 0 : _a.redirectUri) {
        console.warn('Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version');
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var $874ecb7cc9a437a2$var$reducer = function(state, action) {
    switch(action.type){
        case 'LOGIN_POPUP_STARTED':
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isLoading: true
            });
        case 'LOGIN_POPUP_COMPLETE':
        case 'INITIALISED':
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case 'HANDLE_REDIRECT_COMPLETE':
        case 'GET_ACCESS_TOKEN_COMPLETE':
            if (state.user === action.user) return state;
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case 'LOGOUT':
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case 'ERROR':
            return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$toAuth0ClientOptions = function(opts) {
    $874ecb7cc9a437a2$var$deprecateRedirectUri(opts);
    return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, opts), {
        auth0Client: {
            name: 'auth0-react',
            version: '2.3.0'
        }
    });
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$defaultOnRedirectCallback = function(appState) {
    window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */ var $874ecb7cc9a437a2$export$6aefaad9cc4faf3c = function(opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? $874ecb7cc9a437a2$var$defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? $874ecb7cc9a437a2$export$419e9d660c2a6030 : _b, clientOpts = $874ecb7cc9a437a2$var$__rest(opts, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context"
    ]);
    var client = (0, $acw62.useState)(function() {
        return new $874ecb7cc9a437a2$var$te($874ecb7cc9a437a2$var$toAuth0ClientOptions(clientOpts));
    })[0];
    var _c = (0, $acw62.useReducer)($874ecb7cc9a437a2$var$reducer, $874ecb7cc9a437a2$var$initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = (0, $acw62.useRef)(false);
    var handleError = (0, $acw62.useCallback)(function(error) {
        dispatch({
            type: 'ERROR',
            error: error
        });
        return error;
    }, []);
    (0, $acw62.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        (function() {
            return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
                var user, appState, error_1;
                return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            user = void 0;
                            if (!($874ecb7cc9a437a2$var$hasAuthParams() && !skipRedirectCallback)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                client.handleRedirectCallback()
                            ];
                        case 1:
                            appState = _a.sent().appState;
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 2:
                            user = _a.sent();
                            onRedirectCallback(appState, user);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                client.checkSession()
                            ];
                        case 4:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 5:
                            user = _a.sent();
                            _a.label = 6;
                        case 6:
                            dispatch({
                                type: 'INITIALISED',
                                user: user
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _a.sent();
                            handleError($874ecb7cc9a437a2$var$loginError(error_1));
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback,
        handleError
    ]);
    var loginWithRedirect = (0, $acw62.useCallback)(function(opts) {
        $874ecb7cc9a437a2$var$deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, $acw62.useCallback)(function(options, config) {
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: 'LOGIN_POPUP_STARTED'
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        handleError($874ecb7cc9a437a2$var$loginError(error_2));
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: 'LOGIN_POPUP_COMPLETE',
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var logout = (0, $acw62.useCallback)(function(opts) {
        if (opts === void 0) opts = {};
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: 'LOGOUT'
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, $acw62.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return $874ecb7cc9a437a2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw $874ecb7cc9a437a2$var$tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, $acw62.useCallback)(function(opts, config) {
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return $874ecb7cc9a437a2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw $874ecb7cc9a437a2$var$tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getIdTokenClaims = (0, $acw62.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var handleRedirectCallback = (0, $acw62.useCallback)(function(url) {
        return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
            var error_5, _a;
            var _b;
            return $874ecb7cc9a437a2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw $874ecb7cc9a437a2$var$tokenError(error_5);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'HANDLE_REDIRECT_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var contextValue = (0, $acw62.useMemo)(function() {
        return $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            logout: logout,
            handleRedirectCallback: handleRedirectCallback
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
        handleRedirectCallback
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $874ecb7cc9a437a2$export$f2b63d3ca66bb884 = function(context) {
    if (context === void 0) context = $874ecb7cc9a437a2$export$419e9d660c2a6030;
    return (0, $acw62.useContext)(context);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var $874ecb7cc9a437a2$export$bf0b363fae22b33f = function(Component, context) {
    if (context === void 0) context = $874ecb7cc9a437a2$export$419e9d660c2a6030;
    return function WithAuth(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(context.Consumer, null, function(auth) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, $874ecb7cc9a437a2$var$__assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$defaultOnRedirecting = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
/**
* @ignore
*/ var $874ecb7cc9a437a2$var$defaultOnBeforeAuthentication = function() {
    return $874ecb7cc9a437a2$var$__awaiter(void 0, void 0, void 0, function() {
        return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var $874ecb7cc9a437a2$var$defaultReturnTo = function() {
    return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var $874ecb7cc9a437a2$export$2cfd0b285ff12c70 = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? $874ecb7cc9a437a2$var$defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? $874ecb7cc9a437a2$var$defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? $874ecb7cc9a437a2$var$defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? $874ecb7cc9a437a2$export$419e9d660c2a6030 : _d;
        var _e = $874ecb7cc9a437a2$export$f2b63d3ca66bb884(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, $acw62.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, loginOptions), {
                appState: $874ecb7cc9a437a2$var$__assign($874ecb7cc9a437a2$var$__assign({}, loginOptions && loginOptions.appState), {
                    returnTo: typeof returnTo === 'function' ? returnTo() : returnTo
                })
            });
            (function() {
                return $874ecb7cc9a437a2$var$__awaiter(_this, void 0, void 0, function() {
                    return $874ecb7cc9a437a2$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, $874ecb7cc9a437a2$var$__assign({}, props)) : onRedirecting();
    };
};


// src/queryClient.ts
// src/utils.ts
var $938ae10f13d49bdc$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $938ae10f13d49bdc$export$8793edee2d425525() {}
function $938ae10f13d49bdc$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $938ae10f13d49bdc$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $938ae10f13d49bdc$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $938ae10f13d49bdc$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $938ae10f13d49bdc$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $938ae10f13d49bdc$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $938ae10f13d49bdc$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $938ae10f13d49bdc$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($938ae10f13d49bdc$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $938ae10f13d49bdc$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $938ae10f13d49bdc$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $938ae10f13d49bdc$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $938ae10f13d49bdc$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$938ae10f13d49bdc$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $938ae10f13d49bdc$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$938ae10f13d49bdc$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $938ae10f13d49bdc$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $938ae10f13d49bdc$export$7a8558113332b71e(a) && $938ae10f13d49bdc$export$7a8558113332b71e(b);
    if (array || $938ae10f13d49bdc$export$53b83ca8eaab0383(a) && $938ae10f13d49bdc$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        const aItemsSet = new Set(aItems);
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItemsSet.has(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $938ae10f13d49bdc$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $938ae10f13d49bdc$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $938ae10f13d49bdc$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $938ae10f13d49bdc$export$53b83ca8eaab0383(o) {
    if (!$938ae10f13d49bdc$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$938ae10f13d49bdc$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $938ae10f13d49bdc$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $938ae10f13d49bdc$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $938ae10f13d49bdc$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $938ae10f13d49bdc$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $938ae10f13d49bdc$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $938ae10f13d49bdc$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $938ae10f13d49bdc$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $938ae10f13d49bdc$export$1aa5a89531b7670d = Symbol();
function $938ae10f13d49bdc$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $938ae10f13d49bdc$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $938ae10f13d49bdc$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}


// src/queryCache.ts

// src/query.ts

// src/notifyManager.ts
var $e2307e33fb454067$export$7c76da44185e6090 = (cb)=>setTimeout(cb, 0);
function $e2307e33fb454067$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $e2307e33fb454067$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $e2307e33fb454067$export$520687f44db6e1ab = $e2307e33fb454067$export$316a8efd03cd1458();


// src/retryer.ts
// src/focusManager.ts
// src/subscribable.ts
var $f28bf069faa02086$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $3f1a0485b2ecb725$export$86f1af424b2ca4de = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, $938ae10f13d49bdc$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $3f1a0485b2ecb725$export$6bf54661be5b02cf = new $3f1a0485b2ecb725$export$86f1af424b2ca4de();


// src/onlineManager.ts


var $0d08006668a80e57$export$58774fb55d5ff7fc = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, $938ae10f13d49bdc$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $0d08006668a80e57$export$b113e788b2dd3fdc = new $0d08006668a80e57$export$58774fb55d5ff7fc();


// src/thenable.ts

function $f6114de20f9a4572$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $f6114de20f9a4572$export$216296c47a9d1275(promise) {
    let data;
    promise.then((result)=>{
        data = result;
        return result;
    }, (0, $938ae10f13d49bdc$export$8793edee2d425525))?.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}



function $af92dbbbb3fbc9c5$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $af92dbbbb3fbc9c5$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline() : true;
}
var $af92dbbbb3fbc9c5$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $af92dbbbb3fbc9c5$export$986cc6445c1d323(value) {
    return value instanceof $af92dbbbb3fbc9c5$export$a8430ed4188f35a9;
}
function $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $af92dbbbb3fbc9c5$export$a8430ed4188f35a9(cancelOptions));
            config.abort?.();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$af92dbbbb3fbc9c5$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess?.(value);
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError?.(value);
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved) return;
            const retry = config.retry ?? ((0, $938ae10f13d49bdc$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $af92dbbbb3fbc9c5$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $938ae10f13d49bdc$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


// src/removable.ts

var $e24fc843f912068a$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $938ae10f13d49bdc$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $938ae10f13d49bdc$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


var $bbb5e4108fb61687$export$62297b13309008b2 = class extends (0, $e24fc843f912068a$export$e09608847fcc8c59) {
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $bbb5e4108fb61687$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $938ae10f13d49bdc$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $938ae10f13d49bdc$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $938ae10f13d49bdc$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: this.#client,
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: this.#client,
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const onError = (error)=>{
            if (!((0, $af92dbbbb3fbc9c5$export$986cc6445c1d323)(error) && error.silent)) this.#dispatch({
                type: "error",
                error: error
            });
            if (!(0, $af92dbbbb3fbc9c5$export$986cc6445c1d323)(error)) {
                this.#cache.config.onError?.(error, this);
                this.#cache.config.onSettled?.(this.state.data, error, this);
            }
            this.scheduleGc();
        };
        this.#retryer = (0, $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                this.#cache.config.onSuccess?.(data, this);
                this.#cache.config.onSettled?.(data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        return this.#retryer.start();
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$bbb5e4108fb61687$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    this.#revertState = void 0;
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $af92dbbbb3fbc9c5$export$986cc6445c1d323)(error) && error.revert && this.#revertState) return {
                        ...this.#revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $bbb5e4108fb61687$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $af92dbbbb3fbc9c5$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $bbb5e4108fb61687$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $74dfca891c706a66$export$5dde0cd941da8468 = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $938ae10f13d49bdc$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $bbb5e4108fb61687$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $938ae10f13d49bdc$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $938ae10f13d49bdc$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};


// src/mutationCache.ts

// src/mutation.ts



var $524c502dbe70a85f$export$17b8b19c814bcf56 = class extends (0, $e24fc843f912068a$export$e09608847fcc8c59) {
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $524c502dbe70a85f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        this.#retryer = (0, $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await this.#mutationCache.config.onMutate?.(variables, this);
                const context = await this.options.onMutate?.(variables);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this);
            await this.options.onSuccess?.(data, variables, this.state.context);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this);
            await this.options.onSettled?.(data, null, variables, this.state.context);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this);
                await this.options.onError?.(error, variables, this.state.context);
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this);
                await this.options.onSettled?.(void 0, error, variables, this.state.context);
                throw error;
            } finally{
                this.#dispatch({
                    type: "error",
                    error: error
                });
            }
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $524c502dbe70a85f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $217efee59d834f2b$export$1fcfd9a244434844 = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $524c502dbe70a85f$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $217efee59d834f2b$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $938ae10f13d49bdc$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $938ae10f13d49bdc$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $938ae10f13d49bdc$export$8793edee2d425525)))));
    }
};
function $217efee59d834f2b$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}





// src/infiniteQueryBehavior.ts

function $5e3ed657d3a894dc$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $938ae10f13d49bdc$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $938ae10f13d49bdc$export$8c6246b73dd61f4a) : (0, $938ae10f13d49bdc$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $5e3ed657d3a894dc$var$getPreviousPageParam : $5e3ed657d3a894dc$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $5e3ed657d3a894dc$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $5e3ed657d3a894dc$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $5e3ed657d3a894dc$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $5e3ed657d3a894dc$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $5e3ed657d3a894dc$var$getNextPageParam(options, data) != null;
}
function $5e3ed657d3a894dc$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $5e3ed657d3a894dc$var$getPreviousPageParam(options, data) != null;
}


var $83ccb5f70678ce73$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $74dfca891c706a66$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $217efee59d834f2b$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $0d08006668a80e57$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $938ae10f13d49bdc$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $5e3ed657d3a894dc$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $5e3ed657d3a894dc$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $938ae10f13d49bdc$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $938ae10f13d49bdc$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $938ae10f13d49bdc$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $938ae10f13d49bdc$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};


var $acw62 = parcelRequire("acw62");

"use client";
var $c780594f51309d36$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $c780594f51309d36$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($c780594f51309d36$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $c780594f51309d36$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c780594f51309d36$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



parcelRequire("acw62");


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $acw62 = parcelRequire("acw62");


//      
var $7f17f1906b9f3211$var$charCodeOfDot = ".".charCodeAt(0);
var $7f17f1906b9f3211$var$reEscapeChar = /\\(\\)?/g;
var $7f17f1906b9f3211$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7f17f1906b9f3211$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $7f17f1906b9f3211$var$charCodeOfDot) result.push("");
    string.replace($7f17f1906b9f3211$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($7f17f1906b9f3211$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $7f17f1906b9f3211$var$keysCache = {};
var $7f17f1906b9f3211$var$keysRegex = /[.[\]]+/;
var $7f17f1906b9f3211$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($7f17f1906b9f3211$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $7f17f1906b9f3211$var$keysCache[key] = key.split($7f17f1906b9f3211$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $7f17f1906b9f3211$var$keysCache[key] = $7f17f1906b9f3211$var$stringToPath(key);
    }
    return $7f17f1906b9f3211$var$keysCache[key];
};
//      
var $7f17f1906b9f3211$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $7f17f1906b9f3211$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $7f17f1906b9f3211$var$_toPropertyKey(arg) {
    var key = $7f17f1906b9f3211$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7f17f1906b9f3211$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7f17f1906b9f3211$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(current, [
                key
            ].map($7f17f1906b9f3211$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $7f17f1906b9f3211$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $7f17f1906b9f3211$var$setInRecursor(state, 0, $7f17f1906b9f3211$var$toPath(key), value1, destroyArrays);
};
var $7f17f1906b9f3211$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $7f17f1906b9f3211$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $7f17f1906b9f3211$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $7f17f1906b9f3211$export$c52e5867d5879e24(values, name);
    var error = $7f17f1906b9f3211$export$c52e5867d5879e24(errors, name);
    if (error && error[$7f17f1906b9f3211$export$735bebc8ffabf28a]) error = error[$7f17f1906b9f3211$export$735bebc8ffabf28a];
    var submitError = submitErrors && $7f17f1906b9f3211$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $7f17f1906b9f3211$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $7f17f1906b9f3211$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $7f17f1906b9f3211$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $7f17f1906b9f3211$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$7f17f1906b9f3211$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $7f17f1906b9f3211$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $7f17f1906b9f3211$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $7f17f1906b9f3211$var$subscriptionFilter(result, state, previousState, subscription, $7f17f1906b9f3211$export$41e855cb628c1b55, $7f17f1906b9f3211$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $7f17f1906b9f3211$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $7f17f1906b9f3211$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $7f17f1906b9f3211$var$subscriptionFilter(result, state, previousState, subscription, $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3, $7f17f1906b9f3211$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $7f17f1906b9f3211$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$7f17f1906b9f3211$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $7f17f1906b9f3211$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $7f17f1906b9f3211$export$83d89fbfd8236492 = "4.20.10";
var $7f17f1906b9f3211$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $7f17f1906b9f3211$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $7f17f1906b9f3211$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $7f17f1906b9f3211$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $7f17f1906b9f3211$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $7f17f1906b9f3211$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $7f17f1906b9f3211$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $7f17f1906b9f3211$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($7f17f1906b9f3211$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $7f17f1906b9f3211$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $7f17f1906b9f3211$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $7f17f1906b9f3211$export$e6bdf135a54e021b,
                    shallowEqual: $7f17f1906b9f3211$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.formState.values)); // clone to avoid writing
            if ($7f17f1906b9f3211$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $7f17f1906b9f3211$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $7f17f1906b9f3211$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $7f17f1906b9f3211$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $7f17f1906b9f3211$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $7f17f1906b9f3211$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$7f17f1906b9f3211$export$735bebc8ffabf28a]) {
                    var existing = $7f17f1906b9f3211$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$7f17f1906b9f3211$export$735bebc8ffabf28a] = error[$7f17f1906b9f3211$export$735bebc8ffabf28a];
                    merged = $7f17f1906b9f3211$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$7f17f1906b9f3211$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$7f17f1906b9f3211$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $7f17f1906b9f3211$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $7f17f1906b9f3211$var$notify(fieldSubscriber, fieldState, lastFieldState, $7f17f1906b9f3211$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $7f17f1906b9f3211$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$7f17f1906b9f3211$var$hasAnyError(formState.errors) && !(formState.submitErrors && $7f17f1906b9f3211$var$hasAnyError(formState.submitErrors));
        var nextFormState = $7f17f1906b9f3211$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $7f17f1906b9f3211$var$notify(state.subscribers, nextFormState, lastFormState, $7f17f1906b9f3211$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $7f17f1906b9f3211$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $7f17f1906b9f3211$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name) === $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $7f17f1906b9f3211$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$7f17f1906b9f3211$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $7f17f1906b9f3211$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $7f17f1906b9f3211$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $7f17f1906b9f3211$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $7f17f1906b9f3211$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}


var $a22611c327162735$var$_excluded$3 = [
    "render",
    "children",
    "component"
];
// shared logic between components that use either render prop,
// children render function, or component prop
function $a22611c327162735$var$renderComponent(props, lazyProps, name) {
    var render = props.render, children = props.children, component = props.component, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a22611c327162735$var$_excluded$3);
    if (component) return /*#__PURE__*/ $acw62.createElement(component, Object.assign(lazyProps, rest, {
        children: children,
        render: render
    }));
    if (render) return render(children === undefined ? Object.assign(lazyProps, rest) : Object.assign(lazyProps, rest, {
        children: children
    }));
    if (typeof children !== "function") throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
    return children(Object.assign(lazyProps, rest));
}
function $a22611c327162735$var$useWhenValueChanges(value, callback, isEqual) {
    if (isEqual === void 0) isEqual = function isEqual(a, b) {
        return a === b;
    };
    var previous = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!isEqual(value, previous.current)) {
            callback();
            previous.current = value;
        }
    });
}
/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param {Function} init - A function to generate the value
 */ function $a22611c327162735$var$useConstant(init) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    if (!ref.current) ref.current = init();
    return ref.current;
}
var $a22611c327162735$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
var $a22611c327162735$var$isSyntheticEvent = function isSyntheticEvent(candidate) {
    return !!(candidate && typeof candidate.stopPropagation === "function");
};
var $a22611c327162735$var$ReactFinalFormContext = /*#__PURE__*/ $acw62.createContext();
function $a22611c327162735$var$useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        ref.current = value;
    });
    return ref;
}
var $a22611c327162735$export$83d89fbfd8236492 = "6.5.8";
var $a22611c327162735$var$addLazyState = function addLazyState(dest, state, keys) {
    keys.forEach(function(key) {
        Object.defineProperty(dest, key, {
            get: function get() {
                return state[key];
            },
            enumerable: true
        });
    });
};
var $a22611c327162735$var$addLazyFormState = function addLazyFormState(dest, state) {
    return $a22611c327162735$var$addLazyState(dest, state, [
        "active",
        "dirty",
        "dirtyFields",
        "dirtySinceLastSubmit",
        "dirtyFieldsSinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ]);
};
var $a22611c327162735$var$addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
    return $a22611c327162735$var$addLazyState(dest, state, [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "visited"
    ]);
};
var $a22611c327162735$var$_excluded$2 = [
    "debug",
    "decorators",
    "destroyOnUnregister",
    "form",
    "initialValues",
    "initialValuesEqual",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "subscription",
    "validate",
    "validateOnBlur"
];
var $a22611c327162735$var$versions = {
    "final-form": (0, $7f17f1906b9f3211$export$83d89fbfd8236492),
    "react-final-form": $a22611c327162735$export$83d89fbfd8236492
};
var $a22611c327162735$var$all$1 = (0, $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
function $a22611c327162735$export$a7fed597f4b8afd8(_ref) {
    var debug = _ref.debug, _ref$decorators = _ref.decorators, decorators = _ref$decorators === void 0 ? [] : _ref$decorators, destroyOnUnregister = _ref.destroyOnUnregister, alternateFormApi = _ref.form, initialValues = _ref.initialValues, initialValuesEqual = _ref.initialValuesEqual, keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize, mutators = _ref.mutators, onSubmit = _ref.onSubmit, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $a22611c327162735$var$all$1 : _ref$subscription, validate = _ref.validate, validateOnBlur = _ref.validateOnBlur, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded$2);
    var config = {
        debug: debug,
        destroyOnUnregister: destroyOnUnregister,
        initialValues: initialValues,
        keepDirtyOnReinitialize: keepDirtyOnReinitialize,
        mutators: mutators,
        onSubmit: onSubmit,
        validate: validate,
        validateOnBlur: validateOnBlur
    };
    var form = $a22611c327162735$var$useConstant(function() {
        var f = alternateFormApi || (0, $7f17f1906b9f3211$export$f681a8129d2e9d28)(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)
        f.pauseValidation();
        return f;
    }); // synchronously register and unregister to query form state for our subscription on first render
    var _React$useState = $acw62.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1]; // save a copy of state that can break through the closure
    // on the shallowEqual() line below.
    var stateRef = $a22611c327162735$var$useLatest(state);
    $acw62.useEffect(function() {
        // We have rendered, so all fields are now registered, so we can unpause validation
        form.isValidationPaused() && form.resumeValidation();
        var unsubscriptions = [
            form.subscribe(function(s) {
                if (!$a22611c327162735$var$shallowEqual(s, stateRef.current)) setState(s);
            }, subscription)
        ].concat(decorators ? decorators.map(function(decorator) {
            return(// istanbul ignore next
            decorator(form));
        }) : []);
        return function() {
            form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
            unsubscriptions.reverse().forEach(function(unsubscribe) {
                return unsubscribe();
            }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, decorators); // warn about decorator changes
    $a22611c327162735$var$useWhenValueChanges(debug, function() {
        form.setConfig("debug", debug);
    });
    $a22611c327162735$var$useWhenValueChanges(destroyOnUnregister, function() {
        form.destroyOnUnregister = !!destroyOnUnregister;
    });
    $a22611c327162735$var$useWhenValueChanges(keepDirtyOnReinitialize, function() {
        form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
    });
    $a22611c327162735$var$useWhenValueChanges(initialValues, function() {
        form.setConfig("initialValues", initialValues);
    }, initialValuesEqual || $a22611c327162735$var$shallowEqual);
    $a22611c327162735$var$useWhenValueChanges(mutators, function() {
        form.setConfig("mutators", mutators);
    });
    $a22611c327162735$var$useWhenValueChanges(onSubmit, function() {
        form.setConfig("onSubmit", onSubmit);
    });
    $a22611c327162735$var$useWhenValueChanges(validate, function() {
        form.setConfig("validate", validate);
    });
    $a22611c327162735$var$useWhenValueChanges(validateOnBlur, function() {
        form.setConfig("validateOnBlur", validateOnBlur);
    });
    var handleSubmit = function handleSubmit(event) {
        if (event) {
            // sometimes not true, e.g. React Native
            if (typeof event.preventDefault === "function") event.preventDefault();
            if (typeof event.stopPropagation === "function") // prevent any outer forms from receiving the event too
            event.stopPropagation();
        }
        return form.submit();
    };
    var renderProps = {
        form: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, form, {
            reset: function reset(eventOrValues) {
                if ($a22611c327162735$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                form.reset();
                else form.reset(eventOrValues);
            }
        }),
        handleSubmit: handleSubmit
    };
    $a22611c327162735$var$addLazyFormState(renderProps, state);
    return /*#__PURE__*/ $acw62.createElement($a22611c327162735$var$ReactFinalFormContext.Provider, {
        value: form
    }, $a22611c327162735$var$renderComponent((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
        __versions: $a22611c327162735$var$versions
    }), renderProps, "ReactFinalForm"));
}
function $a22611c327162735$export$87c0cf8eb5a167e0(componentName) {
    var form = $acw62.useContext($a22611c327162735$var$ReactFinalFormContext);
    if (!form) throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
    return form;
}
function $a22611c327162735$export$606f11b2eb45ecc6(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, onChange = _ref.onChange, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $a22611c327162735$var$all$1 : _ref$subscription;
    var form = $a22611c327162735$export$87c0cf8eb5a167e0("useFormState");
    var firstRender = $acw62.useRef(true);
    var onChangeRef = $acw62.useRef(onChange);
    onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $acw62.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        if (onChange) onChange(initialState);
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $acw62.useEffect(function() {
        return form.subscribe(function(newState) {
            if (firstRender.current) firstRender.current = false;
            else {
                setState(newState);
                if (onChangeRef.current) onChangeRef.current(newState);
            }
        }, subscription);
    }, []);
    var lazyState = {};
    $a22611c327162735$var$addLazyFormState(lazyState, state);
    return lazyState;
}
var $a22611c327162735$var$_excluded$1 = [
    "onChange",
    "subscription"
];
function $a22611c327162735$export$d2e89184086487cb(_ref) {
    var onChange = _ref.onChange, subscription = _ref.subscription, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded$1);
    var reactFinalForm = $a22611c327162735$export$87c0cf8eb5a167e0("FormSpy");
    var state = $a22611c327162735$export$606f11b2eb45ecc6({
        onChange: onChange,
        subscription: subscription
    });
    if (onChange) return null;
    var renderProps = {
        form: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reactFinalForm, {
            reset: function reset(eventOrValues) {
                if ($a22611c327162735$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                reactFinalForm.reset();
                else reactFinalForm.reset(eventOrValues);
            }
        })
    };
    return $a22611c327162735$var$renderComponent((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, renderProps), state, "FormSpy");
}
var $a22611c327162735$var$isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
var $a22611c327162735$var$getSelectedValues = function getSelectedValues(options) {
    var result = [];
    if (options) for(var index = 0; index < options.length; index++){
        var option = options[index];
        if (option.selected) result.push(option.value);
    }
    return result;
};
var $a22611c327162735$var$getValue = function getValue(event, currentValue, valueProp, isReactNative) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;
    if (isReactNative && event.nativeEvent) return event.nativeEvent.text;
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked;
    switch(type){
        case "checkbox":
            if (valueProp !== undefined) {
                // we are maintaining an array, not just a boolean
                if (checked) // add value to current array value
                return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [
                    valueProp
                ];
                else {
                    // remove value from current array value
                    if (!Array.isArray(currentValue)) return currentValue;
                    var index = currentValue.indexOf(valueProp);
                    if (index < 0) return currentValue;
                    else return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
                }
            } else // it's just a boolean
            return !!checked;
        case "select-multiple":
            return $a22611c327162735$var$getSelectedValues(event.target.options);
        default:
            return value;
    }
};
/**
 * Creates a callback, even with closures, that will be
 * instance === for the lifetime of the component, always
 * calling the most recent version of the function and its
 * closures.
 */ function $a22611c327162735$var$useConstantCallback(callback) {
    var ref = $acw62.useRef(callback);
    $acw62.useEffect(function() {
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(null, args);
    }, []);
}
var $a22611c327162735$var$all = (0, $7f17f1906b9f3211$export$41e855cb628c1b55).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
var $a22611c327162735$var$defaultFormat = function defaultFormat(value, name) {
    return value === undefined ? "" : value;
};
var $a22611c327162735$var$defaultParse = function defaultParse(value, name) {
    return value === "" ? undefined : value;
};
var $a22611c327162735$var$defaultIsEqual = function defaultIsEqual(a, b) {
    return a === b;
};
function $a22611c327162735$export$294aa081a6c6f55d(name, config) {
    if (config === void 0) config = {};
    var _config = config, afterSubmit = _config.afterSubmit, allowNull = _config.allowNull, component = _config.component, data = _config.data, defaultValue = _config.defaultValue, _config$format = _config.format, format = _config$format === void 0 ? $a22611c327162735$var$defaultFormat : _config$format, formatOnBlur = _config.formatOnBlur, initialValue = _config.initialValue, multiple = _config.multiple, _config$parse = _config.parse, parse = _config$parse === void 0 ? $a22611c327162735$var$defaultParse : _config$parse, _config$subscription = _config.subscription, subscription = _config$subscription === void 0 ? $a22611c327162735$var$all : _config$subscription, type = _config.type, validateFields = _config.validateFields, _value = _config.value;
    var form = $a22611c327162735$export$87c0cf8eb5a167e0("useField");
    var configRef = $a22611c327162735$var$useLatest(config);
    var register = function register(callback, silent) {
        return(// because they would refer `state` from current execution context
        // whereas actual `state` would defined in the subsequent `useField` hook
        // execution
        // (that would be caused by `setState` call performed in `register` callback)
        form.registerField(name, callback, subscription, {
            afterSubmit: afterSubmit,
            beforeSubmit: function beforeSubmit() {
                var _configRef$current = configRef.current, beforeSubmit = _configRef$current.beforeSubmit, formatOnBlur = _configRef$current.formatOnBlur, _configRef$current$fo = _configRef$current.format, format = _configRef$current$fo === void 0 ? $a22611c327162735$var$defaultFormat : _configRef$current$fo;
                if (formatOnBlur) {
                    var _ref = form.getFieldState(name), value = _ref.value;
                    var formatted = format(value, name);
                    if (formatted !== value) form.change(name, formatted);
                }
                return beforeSubmit && beforeSubmit();
            },
            data: data,
            defaultValue: defaultValue,
            getValidator: function getValidator() {
                return configRef.current.validate;
            },
            initialValue: initialValue,
            isEqual: function isEqual(a, b) {
                return (configRef.current.isEqual || $a22611c327162735$var$defaultIsEqual)(a, b);
            },
            silent: silent,
            validateFields: validateFields
        }));
    };
    var firstRender = $acw62.useRef(true); // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $acw62.useState(function() {
        var initialState = {}; // temporarily disable destroyOnUnregister
        // temporarily disable destroyOnUnregister
        var destroyOnUnregister = form.destroyOnUnregister;
        form.destroyOnUnregister = false;
        register(function(state) {
            initialState = state;
        }, true)(); // return destroyOnUnregister to its original value
        // return destroyOnUnregister to its original value
        form.destroyOnUnregister = destroyOnUnregister;
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $acw62.useEffect(function() {
        return register(function(state) {
            if (firstRender.current) firstRender.current = false;
            else setState(state);
        }, false);
    }, [
        name,
        data,
        defaultValue,
        // cannot reregister field every time validate function !==.
        // validate,
        initialValue // The validateFields array is often passed as validateFields={[]}, creating
    ]);
    var meta = {};
    $a22611c327162735$var$addLazyFieldMetaState(meta, state);
    var input = {
        name: name,
        get value () {
            var value = state.value;
            if (formatOnBlur) {
                if (component === "input") value = $a22611c327162735$var$defaultFormat(value);
            } else value = format(value, name);
            if (value === null && !allowNull) value = "";
            if (type === "checkbox" || type === "radio") return _value;
            else if (component === "select" && multiple) return value || [];
            return value;
        },
        get checked () {
            var value1 = state.value;
            if (type === "checkbox") {
                value1 = format(value1, name);
                if (_value === undefined) return !!value1;
                else return !!(Array.isArray(value1) && ~value1.indexOf(_value));
            } else if (type === "radio") return format(value1, name) === _value;
            return undefined;
        },
        onBlur: $a22611c327162735$var$useConstantCallback(function(event) {
            state.blur();
            if (formatOnBlur) {
                /**
         * Here we must fetch the value directly from Final Form because we cannot
         * trust that our `state` closure has the most recent value. This is a problem
         * if-and-only-if the library consumer has called `onChange()` immediately
         * before calling `onBlur()`, but before the field has had a chance to receive
         * the value update from Final Form.
         */ var fieldState = form.getFieldState(state.name);
                state.change(format(fieldState.value, state.name));
            }
        }),
        onChange: $a22611c327162735$var$useConstantCallback(function(event) {
            var targetType, unknown, _value2;
            var value = event && event.target ? $a22611c327162735$var$getValue(event, state.value, _value, $a22611c327162735$var$isReactNative) : event;
            state.change(parse(value, name));
        }),
        onFocus: $a22611c327162735$var$useConstantCallback(function(event) {
            return state.focus();
        })
    };
    if (multiple) input.multiple = multiple;
    if (type !== undefined) input.type = type;
    var renderProps = {
        input: input,
        meta: meta
    }; // assign to force Flow check
    return renderProps;
}
var $a22611c327162735$var$_excluded = [
    "afterSubmit",
    "allowNull",
    "beforeSubmit",
    "children",
    "component",
    "data",
    "defaultValue",
    "format",
    "formatOnBlur",
    "initialValue",
    "isEqual",
    "multiple",
    "name",
    "parse",
    "subscription",
    "type",
    "validate",
    "validateFields",
    "value"
];
var $a22611c327162735$export$a455218a85c89869 = /*#__PURE__*/ $acw62.forwardRef(function Field(_ref, ref) {
    var afterSubmit = _ref.afterSubmit, allowNull = _ref.allowNull, beforeSubmit = _ref.beforeSubmit, children = _ref.children, component = _ref.component, data = _ref.data, defaultValue = _ref.defaultValue, format = _ref.format, formatOnBlur = _ref.formatOnBlur, initialValue = _ref.initialValue, isEqual = _ref.isEqual, multiple = _ref.multiple, name = _ref.name, parse = _ref.parse, subscription = _ref.subscription, type = _ref.type, validate = _ref.validate, validateFields = _ref.validateFields, value = _ref.value, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded);
    var field = $a22611c327162735$export$294aa081a6c6f55d(name, {
        afterSubmit: afterSubmit,
        allowNull: allowNull,
        beforeSubmit: beforeSubmit,
        children: children,
        component: component,
        data: data,
        defaultValue: defaultValue,
        format: format,
        formatOnBlur: formatOnBlur,
        initialValue: initialValue,
        isEqual: isEqual,
        multiple: multiple,
        parse: parse,
        subscription: subscription,
        type: type,
        validate: validate,
        validateFields: validateFields,
        value: value
    });
    if (typeof children === "function") return children((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, field, rest));
    if (typeof component === "string") // ignore meta, combine input with any other props
    return /*#__PURE__*/ $acw62.createElement(component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, field.input, {
        children: children,
        ref: ref
    }, rest));
    if (!name) throw new Error("prop name cannot be undefined in <Field> component");
    return $a22611c327162735$var$renderComponent((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        children: children,
        component: component,
        ref: ref
    }, rest), field, "Field(" + name + ")");
});
function $a22611c327162735$export$38f9b05178901e14() {
    return {
        Form: $a22611c327162735$export$a7fed597f4b8afd8,
        FormSpy: $a22611c327162735$export$d2e89184086487cb
    };
}



parcelRequire("acw62");



parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


const $75a48a2374c3e07e$var$InputField = ({ name: name, title: title, format: format, required: required, placeholder: placeholder, ...rest })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a455218a85c89869), {
        name: name,
        format: format,
        children: ({ input: input, meta: meta })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("flex flex-col", rest.className),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        placeholder: placeholder,
                        ...rest,
                        ...input,
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("form-input focus:border-mustard text-caringwire rounded-md border-2 bg-transparent px-6 py-4 text-lg font-thin transition-colors duration-200 ease-in-out focus:outline-none", meta.error && meta.touched ? "border-red-500" : "border-caringwire")
                    }),
                    meta.error && meta.touched && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 w-fit rounded-md border border-red-500 bg-red-100 p-2 text-sm text-red-800",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                role: "img",
                                "aria-label": "alert",
                                className: "mr-2",
                                children: "\u26A0\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: meta.error
                            })
                        ]
                    })
                ]
            })
    });
};
var $75a48a2374c3e07e$export$2e2bcd8739ae039 = $75a48a2374c3e07e$var$InputField;



var $59TQn = parcelRequire("59TQn");
const $3ef5978a8f0aae1f$export$a7a0278c004aac3f = (value)=>value ? undefined : "Please fill this in";
const $3ef5978a8f0aae1f$export$d290fa47940df19d = (value)=>value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? undefined : "Invalid email";
const $3ef5978a8f0aae1f$export$d6781b696a0576d1 = (number, countryCode)=>{
    try {
        var phoneUtil = (0, $59TQn.PhoneNumberUtil).getInstance();
        var numberObj = phoneUtil.parseAndKeepRawInput(number, countryCode);
        return phoneUtil.isValidNumber(numberObj);
    } catch (e) {
        return false;
    }
};
const $3ef5978a8f0aae1f$export$af5de1609f06c8e6 = (value)=>{
    if (!value) return "Please fill this in";
    return /^(0[1-9]|1[0-2])$/.test(value) ? undefined : "Month must be a number between 01 and 12";
};
const $3ef5978a8f0aae1f$export$d2d39d1adcc883a2 = (value, monthValue, yearValue)=>{
    if (!value) return "Please fill this in";
    const dayNum = parseInt(value, 10);
    if (dayNum < 1 || dayNum > 31) return "Day must be a number between 01 and 31";
    // Validate day based on day's upper bound only if both month and year are valid, else don't handle it
    const monthCheckError = $3ef5978a8f0aae1f$export$af5de1609f06c8e6(monthValue);
    const yearCheckError = $3ef5978a8f0aae1f$export$31803937850fb2da(yearValue);
    if (monthCheckError || yearCheckError) return undefined;
    const monthNum = parseInt(monthValue, 10);
    const yearNum = parseInt(yearValue, 10);
    let maxDaysInMonth = 31;
    if (monthNum === 2) {
        const isLeapYear = yearNum % 4 === 0 && yearNum % 100 !== 0 || yearNum % 100 === 0 && yearNum % 400 == 0;
        maxDaysInMonth = isLeapYear ? 29 : 28;
    } else if ([
        4,
        6,
        9,
        11
    ].includes(monthNum)) maxDaysInMonth = 30;
    if (dayNum > maxDaysInMonth) return `Day must be a number between 01 and ${maxDaysInMonth} for month ${monthValue}`;
    return undefined;
};
const $3ef5978a8f0aae1f$export$31803937850fb2da = (value)=>{
    if (!value || !/^\d{4}$/.test(value)) return "Year must be a 4-digit number";
    const currentYear = new Date().getFullYear();
    const valueNum = parseInt(value, 10);
    return valueNum >= 1900 && valueNum <= currentYear ? undefined : `Year must be between 1900 and ${currentYear}`;
};
const $3ef5978a8f0aae1f$export$8901015135f2fb22 = (value)=>{
    if (!value) return "Please fill this in";
    const valueNum = parseInt(value, 10);
    return valueNum >= 501 && valueNum <= 99500 ? undefined : "ZIP code must be between 00501 and 99500";
};



function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(r, e) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r, e) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}



function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $acw62 = parcelRequire("acw62");


function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, e);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(t);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, e);
    };
}



function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '';
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $5e4f012072913cb4$export$e6e34fd1f2686227)($f4f4fca9115ed8bd$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $5e4f012072913cb4$export$2f35ab04d2335697)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $5e4f012072913cb4$export$36776f635604f274)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '', value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)((0, $5e4f012072913cb4$export$6788812c4e6611e6)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + '*' + (0, $5e4f012072913cb4$export$6788812c4e6611e6)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}

var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = '-ms-';
var $e853ac0080e24cb4$export$2c0f367103c8d01c = '-moz-';
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = '-webkit-';
var $e853ac0080e24cb4$export$a29989082612d0d9 = 'comm';
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = 'rule';
var $e853ac0080e24cb4$export$527d108ccf083c2b = 'decl';
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = '@page';
var $e853ac0080e24cb4$export$500415a86c544f73 = '@media';
var $e853ac0080e24cb4$export$a763edbf796b780a = '@import';
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = '@charset';
var $e853ac0080e24cb4$export$1cc683e23b84b133 = '@viewport';
var $e853ac0080e24cb4$export$9447a5efea57e862 = '@supports';
var $e853ac0080e24cb4$export$ef011b4e114b1fba = '@document';
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = '@namespace';
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = '@keyframes';
var $e853ac0080e24cb4$export$2c16de31893252e6 = '@font-face';
var $e853ac0080e24cb4$export$3d846dd52e150c6f = '@counter-style';
var $e853ac0080e24cb4$export$22314bfbb57653fe = '@font-feature-values';
var $e853ac0080e24cb4$export$d773506282b3cfe6 = '@layer';




function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($36ea00327b41abe1$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $5e4f012072913cb4$export$f8e21b1e77979a08)(characters += (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $f4f4fca9115ed8bd$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f4f4fca9115ed8bd$export$955ba06d119e085e)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$4a34f930e789283c((0, $f4f4fca9115ed8bd$export$4254d4e2b3745c4c)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)(), (0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $5e4f012072913cb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) - length) (0, $5e4f012072913cb4$export$10d8903dec122b9d)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $5e4f012072913cb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f4f4fca9115ed8bd$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 45) characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
                    atrule = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(), offset = length = (0, $5e4f012072913cb4$export$36776f635604f274)(type = characters += (0, $f4f4fca9115ed8bd$export$c2ab62c7bf24634)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $5e4f012072913cb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $e853ac0080e24cb4$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$a29989082612d0d9), (0, $5e4f012072913cb4$export$6788812c4e6611e6)((0, $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7)()), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$527d108ccf083c2b), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 0, length), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $e853ac0080e24cb4$export$a763edbf796b780a:
        case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $e853ac0080e24cb4$export$a29989082612d0d9:
            return '';
        case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $5e4f012072913cb4$export$36776f635604f274)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $be3fa667258f7944$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(children, 'span') ? (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch') ? $be3fa667258f7944$export$82e9f45cca5ba907((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $b9a8452e0aabfcf6$export$5a7767152ae0305f(collection) {
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $b9a8452e0aabfcf6$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b9a8452e0aabfcf6$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element.return = (0, $be3fa667258f7944$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $b9a8452e0aabfcf6$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)((0, $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 1, (0, $5e4f012072913cb4$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)) break;
        (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)();
    }
    return (0, $f4f4fca9115ed8bd$export$58adb3bec8346d0f)(begin, (0, $f4f4fca9115ed8bd$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $f4f4fca9115ed8bd$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch') ? $fc182b1f84212d3f$var$prefix((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$36776f635604f274)(value) - 3 - (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $8f2522f8594faa86$export$fac44ee5b035f737),
        (0, $b9a8452e0aabfcf6$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $b9a8452e0aabfcf6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $72623ab6bcb0a33b$exports = {};
'use strict';
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $4eee05ec22b53782$export$23f2a1d2818174ef = false;
var $4eee05ec22b53782$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $4eee05ec22b53782$export$e7094788287c5e9b = $4eee05ec22b53782$var$EmotionCacheContext.Provider;
var $4eee05ec22b53782$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($4eee05ec22b53782$var$EmotionCacheContext);
};
var $4eee05ec22b53782$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($4eee05ec22b53782$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $4eee05ec22b53782$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $4eee05ec22b53782$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
};
var $4eee05ec22b53782$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4eee05ec22b53782$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $4eee05ec22b53782$var$getTheme(outerTheme, theme);
    });
});
var $4eee05ec22b53782$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4eee05ec22b53782$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($4eee05ec22b53782$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4eee05ec22b53782$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4eee05ec22b53782$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4eee05ec22b53782$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4eee05ec22b53782$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4eee05ec22b53782$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4eee05ec22b53782$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4eee05ec22b53782$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $4eee05ec22b53782$var$Emotion = /* #__PURE__ */ $4eee05ec22b53782$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4eee05ec22b53782$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4eee05ec22b53782$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4eee05ec22b53782$var$typePropName && !$4eee05ec22b53782$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($4eee05ec22b53782$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $4eee05ec22b53782$export$a9c23c6ac3fc3eca = $4eee05ec22b53782$var$Emotion;



var $acw62 = parcelRequire("acw62");








var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $4eee05ec22b53782$export$dda1d9f60106f0e9).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4eee05ec22b53782$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4eee05ec22b53782$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($63d46a01db878c10$export$c8a8987d4410bf2d || ($63d46a01db878c10$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $62578605b07c8dad$export$6321afa313b251b5)(args);
}
function $63d46a01db878c10$export$d25ddfdf17c3ad3e() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $4eee05ec22b53782$export$23f2a1d2818174ef)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $4eee05ec22b53782$export$23f2a1d2818174ef)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});





function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $acw62 = parcelRequire("acw62");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $204931a4986f463b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $204931a4986f463b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $204931a4986f463b$export$803cd8101b6c182b = /*#__PURE__*/ $204931a4986f463b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[0], side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[1]), []);
const $204931a4986f463b$export$96ec731ed4dcb222 = Math.min;
const $204931a4986f463b$export$8960430cfd85939f = Math.max;
const $204931a4986f463b$export$2077e0241d6afd3c = Math.round;
const $204931a4986f463b$export$a3fe094919f356fd = Math.floor;
const $204931a4986f463b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $204931a4986f463b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $204931a4986f463b$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $204931a4986f463b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $204931a4986f463b$export$8960430cfd85939f(start, $204931a4986f463b$export$96ec731ed4dcb222(value, end));
}
function $204931a4986f463b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $204931a4986f463b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $204931a4986f463b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $204931a4986f463b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $204931a4986f463b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $204931a4986f463b$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $204931a4986f463b$export$f28e8f882010718a(placement) {
    return $204931a4986f463b$var$yAxisSides.has($204931a4986f463b$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $204931a4986f463b$export$2b57e0052a6d6d4c(placement) {
    return $204931a4986f463b$export$8a000a963141ac32($204931a4986f463b$export$f28e8f882010718a(placement));
}
function $204931a4986f463b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $204931a4986f463b$export$2b57e0052a6d6d4c(placement);
    const length = $204931a4986f463b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $204931a4986f463b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $204931a4986f463b$export$9c5e28bad23365fa(placement);
    return [
        $204931a4986f463b$export$2b182c584985588b(placement),
        oppositePlacement,
        $204931a4986f463b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $204931a4986f463b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$204931a4986f463b$var$oppositeAlignmentMap[alignment]);
}
const $204931a4986f463b$var$lrPlacement = [
    'left',
    'right'
];
const $204931a4986f463b$var$rlPlacement = [
    'right',
    'left'
];
const $204931a4986f463b$var$tbPlacement = [
    'top',
    'bottom'
];
const $204931a4986f463b$var$btPlacement = [
    'bottom',
    'top'
];
function $204931a4986f463b$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $204931a4986f463b$var$rlPlacement : $204931a4986f463b$var$lrPlacement;
            return isStart ? $204931a4986f463b$var$lrPlacement : $204931a4986f463b$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $204931a4986f463b$var$tbPlacement : $204931a4986f463b$var$btPlacement;
        default:
            return [];
    }
}
function $204931a4986f463b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    let list = $204931a4986f463b$var$getSideList($204931a4986f463b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($204931a4986f463b$export$2b182c584985588b));
    }
    return list;
}
function $204931a4986f463b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$204931a4986f463b$var$oppositeSideMap[side]);
}
function $204931a4986f463b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $204931a4986f463b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $204931a4986f463b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $204931a4986f463b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $9dccb9a8753b0e86$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $204931a4986f463b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $204931a4986f463b$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9dccb9a8753b0e86$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dccb9a8753b0e86$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $204931a4986f463b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9dccb9a8753b0e86$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $204931a4986f463b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dccb9a8753b0e86$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $204931a4986f463b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $204931a4986f463b$export$803cd8101b6c182b) ? $9dccb9a8753b0e86$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $204931a4986f463b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $204931a4986f463b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $204931a4986f463b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dccb9a8753b0e86$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $204931a4986f463b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $204931a4986f463b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $204931a4986f463b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $204931a4986f463b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $204931a4986f463b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $204931a4986f463b$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>d.overflows[0] > 0 && (0, $204931a4986f463b$export$f28e8f882010718a)(d.placement) === initialSideAxis)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9dccb9a8753b0e86$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9dccb9a8753b0e86$var$isAnySideFullyClipped(overflow) {
    return (0, $204931a4986f463b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dccb9a8753b0e86$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9dccb9a8753b0e86$var$getBoundingRect(rects) {
    const minX = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9dccb9a8753b0e86$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dccb9a8753b0e86$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9dccb9a8753b0e86$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $204931a4986f463b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $9dccb9a8753b0e86$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9dccb9a8753b0e86$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $9dccb9a8753b0e86$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dccb9a8753b0e86$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9dccb9a8753b0e86$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dccb9a8753b0e86$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dccb9a8753b0e86$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $204931a4986f463b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $9dccb9a8753b0e86$var$originSides.has((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dccb9a8753b0e86$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $204931a4986f463b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $204931a4986f463b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $c51400d9a81fca36$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $c51400d9a81fca36$export$651544f548703224(node) {
    if ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $c51400d9a81fca36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c51400d9a81fca36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c51400d9a81fca36$export$8ee0fc9ee280b4ee(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Node;
}
function $c51400d9a81fca36$export$45a5e7f76e0caa8d(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Element;
}
function $c51400d9a81fca36$export$1b3bfaa9684536aa(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c51400d9a81fca36$export$af51f0f06c0f328a(value) {
    if (!$c51400d9a81fca36$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $c51400d9a81fca36$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $c51400d9a81fca36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c51400d9a81fca36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$c51400d9a81fca36$var$invalidOverflowDisplayValues.has(display);
}
const $c51400d9a81fca36$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $c51400d9a81fca36$export$71535ffaa902797f(element) {
    return $c51400d9a81fca36$var$tableElements.has($c51400d9a81fca36$export$651544f548703224(element));
}
const $c51400d9a81fca36$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $c51400d9a81fca36$export$89e651af02346cd4(element) {
    return $c51400d9a81fca36$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $c51400d9a81fca36$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $c51400d9a81fca36$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $c51400d9a81fca36$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $c51400d9a81fca36$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $c51400d9a81fca36$export$78551043582a6a98();
    const css = $c51400d9a81fca36$export$45a5e7f76e0caa8d(elementOrCss) ? $c51400d9a81fca36$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $c51400d9a81fca36$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $c51400d9a81fca36$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $c51400d9a81fca36$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $c51400d9a81fca36$export$940d8225183e1404(element) {
    let currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(element);
    while($c51400d9a81fca36$export$1b3bfaa9684536aa(currentNode) && !$c51400d9a81fca36$export$d1162fb0b6d4cd51(currentNode)){
        if ($c51400d9a81fca36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($c51400d9a81fca36$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c51400d9a81fca36$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $c51400d9a81fca36$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $c51400d9a81fca36$export$d1162fb0b6d4cd51(node) {
    return $c51400d9a81fca36$var$lastTraversableNodeNames.has($c51400d9a81fca36$export$651544f548703224(node));
}
function $c51400d9a81fca36$export$3735103072e4a80(element) {
    return $c51400d9a81fca36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c51400d9a81fca36$export$dc8fc79fa2800137(element) {
    if ($c51400d9a81fca36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $c51400d9a81fca36$export$4e12058fc4d51d56(node) {
    if ($c51400d9a81fca36$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c51400d9a81fca36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c51400d9a81fca36$export$e495491855dc5418(node);
    return $c51400d9a81fca36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c51400d9a81fca36$export$7cd01a57c8ca906c(node) {
    const parentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(node);
    if ($c51400d9a81fca36$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($c51400d9a81fca36$export$1b3bfaa9684536aa(parentNode) && $c51400d9a81fca36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c51400d9a81fca36$export$7cd01a57c8ca906c(parentNode);
}
function $c51400d9a81fca36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c51400d9a81fca36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c51400d9a81fca36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $c51400d9a81fca36$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $c51400d9a81fca36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $c51400d9a81fca36$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $c51400d9a81fca36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $c51400d9a81fca36$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $bede215d88ec3aee$var$getCssDimensions(element) {
    const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $204931a4986f463b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $204931a4986f463b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bede215d88ec3aee$var$unwrapElement(element) {
    return !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $bede215d88ec3aee$var$getScale(element) {
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domElement)) return (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bede215d88ec3aee$var$getCssDimensions(domElement);
    let x = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$noOffsets = /*#__PURE__*/ (0, $204931a4986f463b$export$a397704b5e280835)(0);
function $bede215d88ec3aee$var$getVisualOffsets(element) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$78551043582a6a98)() || !win.visualViewport) return $bede215d88ec3aee$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bede215d88ec3aee$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $bede215d88ec3aee$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $bede215d88ec3aee$var$getScale(offsetParent);
        } else scale = $bede215d88ec3aee$var$getScale(element);
    }
    const visualOffsets = $bede215d88ec3aee$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bede215d88ec3aee$var$getVisualOffsets(domElement) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bede215d88ec3aee$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bede215d88ec3aee$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $bede215d88ec3aee$var$getBoundingClientRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bede215d88ec3aee$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent);
            scale = $bede215d88ec3aee$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll, true) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bede215d88ec3aee$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bede215d88ec3aee$var$getDocumentRect(element) {
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bede215d88ec3aee$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $c51400d9a81fca36$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $204931a4986f463b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getViewportRect(element, strategy) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $c51400d9a81fca36$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $bede215d88ec3aee$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) ? $bede215d88ec3aee$var$getScale(element) : (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bede215d88ec3aee$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bede215d88ec3aee$var$getDocumentRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element));
    else if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $bede215d88ec3aee$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bede215d88ec3aee$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)(rect);
}
function $bede215d88ec3aee$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(parentNode) || (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(parentNode).position === 'fixed' || $bede215d88ec3aee$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bede215d88ec3aee$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c51400d9a81fca36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(el) && (0, $c51400d9a81fca36$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $bede215d88ec3aee$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $c51400d9a81fca36$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $bede215d88ec3aee$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bede215d88ec3aee$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(element) ? [] : $bede215d88ec3aee$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bede215d88ec3aee$var$getDimensions(element) {
    const { width: width, height: height } = $bede215d88ec3aee$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bede215d88ec3aee$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $bede215d88ec3aee$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bede215d88ec3aee$var$isStaticPositioned(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'static';
}
function $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $c51400d9a81fca36$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bede215d88ec3aee$var$getOffsetParent(element, polyfill) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if ((0, $c51400d9a81fca36$export$89e651af02346cd4)(element)) return win;
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$bede215d88ec3aee$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c51400d9a81fca36$export$71535ffaa902797f)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent))offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent) && !(0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c51400d9a81fca36$export$940d8225183e1404)(element) || win;
}
const $bede215d88ec3aee$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bede215d88ec3aee$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bede215d88ec3aee$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bede215d88ec3aee$var$isRTL(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).direction === 'rtl';
}
const $bede215d88ec3aee$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c51400d9a81fca36$export$e495491855dc5418,
    getClippingRect: $bede215d88ec3aee$var$getClippingRect,
    getOffsetParent: $bede215d88ec3aee$var$getOffsetParent,
    getElementRects: $bede215d88ec3aee$var$getElementRects,
    getClientRects: $bede215d88ec3aee$var$getClientRects,
    getDimensions: $bede215d88ec3aee$var$getDimensions,
    getScale: $bede215d88ec3aee$var$getScale,
    isElement: $c51400d9a81fca36$export$45a5e7f76e0caa8d,
    isRTL: $bede215d88ec3aee$var$isRTL
};
function $bede215d88ec3aee$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $bede215d88ec3aee$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $204931a4986f463b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $204931a4986f463b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $204931a4986f463b$export$8960430cfd85939f)(0, (0, $204931a4986f463b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$bede215d88ec3aee$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bede215d88ec3aee$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bede215d88ec3aee$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $c51400d9a81fca36$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bede215d88ec3aee$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bede215d88ec3aee$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bede215d88ec3aee$var$getBoundingClientRect(reference);
        if (prevRefRect && !$bede215d88ec3aee$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bede215d88ec3aee$export$37b6bde19b108ecc = (0, $9dccb9a8753b0e86$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bede215d88ec3aee$export$cc800923e997bb8 = (0, $9dccb9a8753b0e86$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bede215d88ec3aee$export$91fb6ecbd551914 = (0, $9dccb9a8753b0e86$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bede215d88ec3aee$export$fba63a578e423eb = (0, $9dccb9a8753b0e86$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bede215d88ec3aee$export$8a83211c878a3f1f = (0, $9dccb9a8753b0e86$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bede215d88ec3aee$export$346677f925de839c = (0, $9dccb9a8753b0e86$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bede215d88ec3aee$export$fe8985bb6374093c = (0, $9dccb9a8753b0e86$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bede215d88ec3aee$export$f2120bbfa5450bd2 = (0, $9dccb9a8753b0e86$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bede215d88ec3aee$export$18c8ad048e32c7d5 = (0, $9dccb9a8753b0e86$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bede215d88ec3aee$export$7bf07e38f3dc4b69 = (0, $9dccb9a8753b0e86$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bede215d88ec3aee$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bede215d88ec3aee$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9dccb9a8753b0e86$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = (0, $acw62.useLayoutEffect);


var $e5db4f66b3bbccc3$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e5db4f66b3bbccc3$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e5db4f66b3bbccc3$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e5db4f66b3bbccc3$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($e5db4f66b3bbccc3$var$isArray(value)) return value.filter(Boolean);
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e5db4f66b3bbccc3$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $e5db4f66b3bbccc3$var$_excluded$4);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e5db4f66b3bbccc3$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e5db4f66b3bbccc3$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e5db4f66b3bbccc3$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e5db4f66b3bbccc3$var$normalizedHeight(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollTop(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e5db4f66b3bbccc3$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e5db4f66b3bbccc3$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e5db4f66b3bbccc3$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e5db4f66b3bbccc3$export$b4171a6734a65d42;
    var start = $e5db4f66b3bbccc3$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e5db4f66b3bbccc3$var$easeOutCubic(currentTime, start, change, duration);
        $e5db4f66b3bbccc3$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e5db4f66b3bbccc3$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e5db4f66b3bbccc3$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e5db4f66b3bbccc3$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e5db4f66b3bbccc3$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e5db4f66b3bbccc3$var$passiveOptionAccessed = false;
var $e5db4f66b3bbccc3$var$options = {
    get passive () {
        return $e5db4f66b3bbccc3$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e5db4f66b3bbccc3$var$w = typeof window !== 'undefined' ? window : {};
if ($e5db4f66b3bbccc3$var$w.addEventListener && $e5db4f66b3bbccc3$var$w.removeEventListener) {
    $e5db4f66b3bbccc3$var$w.addEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, $e5db4f66b3bbccc3$var$options);
    $e5db4f66b3bbccc3$var$w.removeEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, false);
}
var $e5db4f66b3bbccc3$export$2408f22a0fab9ae5 = $e5db4f66b3bbccc3$var$passiveOptionAccessed;
function $e5db4f66b3bbccc3$export$3466f893ebf79586(item) {
    return item != null;
}
function $e5db4f66b3bbccc3$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e5db4f66b3bbccc3$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e5db4f66b3bbccc3$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e5db4f66b3bbccc3$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e5db4f66b3bbccc3$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $e5db4f66b3bbccc3$var$_excluded$3 = [
    "children",
    "innerProps"
], $e5db4f66b3bbccc3$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $e5db4f66b3bbccc3$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e5db4f66b3bbccc3$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e5db4f66b3bbccc3$var$normalizedHeight(scrollParent);
    var scrollTop = $e5db4f66b3bbccc3$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e5db4f66b3bbccc3$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e5db4f66b3bbccc3$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e5db4f66b3bbccc3$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e5db4f66b3bbccc3$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, $e5db4f66b3bbccc3$var$alignToControl(placement), '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e5db4f66b3bbccc3$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($e5db4f66b3bbccc3$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e5db4f66b3bbccc3$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $e5db4f66b3bbccc3$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e5db4f66b3bbccc3$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Menu$1 = $e5db4f66b3bbccc3$var$Menu;
// ==============================
// Menu List
// ==============================
var $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e5db4f66b3bbccc3$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e5db4f66b3bbccc3$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e5db4f66b3bbccc3$export$3b14a55fb2447963 = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$export$342063e11d6c3cad = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $e5db4f66b3bbccc3$var$_excluded$3);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $e5db4f66b3bbccc3$var$_excluded2$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $e5db4f66b3bbccc3$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e5db4f66b3bbccc3$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($e5db4f66b3bbccc3$var$coercePlacement(menuPlacement)), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e5db4f66b3bbccc3$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $bede215d88ec3aee$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e5db4f66b3bbccc3$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e5db4f66b3bbccc3$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e5db4f66b3bbccc3$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e5db4f66b3bbccc3$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e5db4f66b3bbccc3$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e5db4f66b3bbccc3$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$_templateObject;
var $e5db4f66b3bbccc3$var$_excluded$2 = [
    "size"
], $e5db4f66b3bbccc3$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $e5db4f66b3bbccc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e5db4f66b3bbccc3$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e5db4f66b3bbccc3$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $e5db4f66b3bbccc3$var$_excluded$2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e5db4f66b3bbccc3$var$_ref2
    }, props));
};
var $e5db4f66b3bbccc3$var$CrossIcon = function CrossIcon(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e5db4f66b3bbccc3$var$DownChevron = function DownChevron(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e5db4f66b3bbccc3$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e5db4f66b3bbccc3$export$f1e1789686576879 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$DownChevron, null));
};
var $e5db4f66b3bbccc3$export$407448d2b89b1813 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e5db4f66b3bbccc3$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerProps, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e5db4f66b3bbccc3$var$loadingDotAnimations = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)($e5db4f66b3bbccc3$var$_templateObject || ($e5db4f66b3bbccc3$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e5db4f66b3bbccc3$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            animation: "".concat($e5db4f66b3bbccc3$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e5db4f66b3bbccc3$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $e5db4f66b3bbccc3$var$_excluded2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $e5db4f66b3bbccc3$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e5db4f66b3bbccc3$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $e5db4f66b3bbccc3$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $e5db4f66b3bbccc3$var$Control$1 = $e5db4f66b3bbccc3$var$Control;
var $e5db4f66b3bbccc3$var$_excluded$1 = [
    "data"
];
var $e5db4f66b3bbccc3$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e5db4f66b3bbccc3$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Heading, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", null, children));
};
var $e5db4f66b3bbccc3$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e5db4f66b3bbccc3$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e5db4f66b3bbccc3$var$Group$1 = $e5db4f66b3bbccc3$var$Group;
var $e5db4f66b3bbccc3$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e5db4f66b3bbccc3$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e5db4f66b3bbccc3$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e5db4f66b3bbccc3$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e5db4f66b3bbccc3$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e5db4f66b3bbccc3$var$spacingStyle)
};
var $e5db4f66b3bbccc3$var$inputStyle = function inputStyle(isHidden) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e5db4f66b3bbccc3$var$spacingStyle);
};
var $e5db4f66b3bbccc3$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e5db4f66b3bbccc3$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e5db4f66b3bbccc3$var$Input$1 = $e5db4f66b3bbccc3$var$Input;
var $e5db4f66b3bbccc3$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e5db4f66b3bbccc3$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e5db4f66b3bbccc3$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $e5db4f66b3bbccc3$var$MultiValueContainer = $e5db4f66b3bbccc3$var$MultiValueGeneric;
var $e5db4f66b3bbccc3$var$MultiValueLabel = $e5db4f66b3bbccc3$var$MultiValueGeneric;
function $e5db4f66b3bbccc3$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$CrossIcon, {
        size: 14
    }));
}
var $e5db4f66b3bbccc3$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e5db4f66b3bbccc3$var$MultiValue$1 = $e5db4f66b3bbccc3$var$MultiValue;
var $e5db4f66b3bbccc3$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e5db4f66b3bbccc3$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Option$1 = $e5db4f66b3bbccc3$var$Option;
var $e5db4f66b3bbccc3$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$Placeholder$1 = $e5db4f66b3bbccc3$var$Placeholder;
var $e5db4f66b3bbccc3$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$SingleValue$1 = $e5db4f66b3bbccc3$var$SingleValue;
var $e5db4f66b3bbccc3$export$db3b6bfb95261072 = {
    ClearIndicator: $e5db4f66b3bbccc3$var$ClearIndicator,
    Control: $e5db4f66b3bbccc3$var$Control$1,
    DropdownIndicator: $e5db4f66b3bbccc3$var$DropdownIndicator,
    DownChevron: $e5db4f66b3bbccc3$var$DownChevron,
    CrossIcon: $e5db4f66b3bbccc3$var$CrossIcon,
    Group: $e5db4f66b3bbccc3$var$Group$1,
    GroupHeading: $e5db4f66b3bbccc3$var$GroupHeading,
    IndicatorsContainer: $e5db4f66b3bbccc3$var$IndicatorsContainer,
    IndicatorSeparator: $e5db4f66b3bbccc3$var$IndicatorSeparator,
    Input: $e5db4f66b3bbccc3$var$Input$1,
    LoadingIndicator: $e5db4f66b3bbccc3$var$LoadingIndicator,
    Menu: $e5db4f66b3bbccc3$var$Menu$1,
    MenuList: $e5db4f66b3bbccc3$var$MenuList,
    MenuPortal: $e5db4f66b3bbccc3$var$MenuPortal,
    LoadingMessage: $e5db4f66b3bbccc3$var$LoadingMessage,
    NoOptionsMessage: $e5db4f66b3bbccc3$var$NoOptionsMessage,
    MultiValue: $e5db4f66b3bbccc3$var$MultiValue$1,
    MultiValueContainer: $e5db4f66b3bbccc3$var$MultiValueContainer,
    MultiValueLabel: $e5db4f66b3bbccc3$var$MultiValueLabel,
    MultiValueRemove: $e5db4f66b3bbccc3$var$MultiValueRemove,
    Option: $e5db4f66b3bbccc3$var$Option$1,
    Placeholder: $e5db4f66b3bbccc3$var$Placeholder$1,
    SelectContainer: $e5db4f66b3bbccc3$var$SelectContainer,
    SingleValue: $e5db4f66b3bbccc3$var$SingleValue$1,
    ValueContainer: $e5db4f66b3bbccc3$var$ValueContainer
};
var $e5db4f66b3bbccc3$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$export$db3b6bfb95261072), props.components);
};



var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $4b23e30940068c4c$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $4b23e30940068c4c$var$A11yText = function A11yText(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        css: $4b23e30940068c4c$var$_ref
    }, props));
};
var $4b23e30940068c4c$var$A11yText$1 = $4b23e30940068c4c$var$A11yText;
var $4b23e30940068c4c$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $4b23e30940068c4c$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $4b23e30940068c4c$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($4b23e30940068c4c$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($4b23e30940068c4c$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $4b23e30940068c4c$var$LiveRegion$1 = $4b23e30940068c4c$var$LiveRegion;
var $4b23e30940068c4c$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $4b23e30940068c4c$var$anyDiacritic = new RegExp('[' + $4b23e30940068c4c$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $4b23e30940068c4c$var$diacriticToBase = {};
for(var $4b23e30940068c4c$var$i = 0; $4b23e30940068c4c$var$i < $4b23e30940068c4c$var$diacritics.length; $4b23e30940068c4c$var$i++){
    var $4b23e30940068c4c$var$diacritic = $4b23e30940068c4c$var$diacritics[$4b23e30940068c4c$var$i];
    for(var $4b23e30940068c4c$var$j = 0; $4b23e30940068c4c$var$j < $4b23e30940068c4c$var$diacritic.letters.length; $4b23e30940068c4c$var$j++)$4b23e30940068c4c$var$diacriticToBase[$4b23e30940068c4c$var$diacritic.letters[$4b23e30940068c4c$var$j]] = $4b23e30940068c4c$var$diacritic.base;
}
var $4b23e30940068c4c$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($4b23e30940068c4c$var$anyDiacritic, function(match) {
        return $4b23e30940068c4c$var$diacriticToBase[match];
    });
};
var $4b23e30940068c4c$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($4b23e30940068c4c$var$stripDiacritics);
var $4b23e30940068c4c$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $4b23e30940068c4c$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $4b23e30940068c4c$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $4b23e30940068c4c$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $4b23e30940068c4c$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $4b23e30940068c4c$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $4b23e30940068c4c$var$memoizedStripDiacriticsForInput(input);
            candidate = $4b23e30940068c4c$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $4b23e30940068c4c$var$_excluded = [
    "innerRef"
];
function $4b23e30940068c4c$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $4b23e30940068c4c$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $e5db4f66b3bbccc3$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $4b23e30940068c4c$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $4b23e30940068c4c$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $4b23e30940068c4c$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $e5db4f66b3bbccc3$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $4b23e30940068c4c$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $4b23e30940068c4c$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $4b23e30940068c4c$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $4b23e30940068c4c$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $4b23e30940068c4c$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4b23e30940068c4c$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $4b23e30940068c4c$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $4b23e30940068c4c$var$activeScrollLocks = 0;
var $4b23e30940068c4c$var$listenerOptions = {
    capture: false,
    passive: false
};
function $4b23e30940068c4c$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$4b23e30940068c4c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $4b23e30940068c4c$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $4b23e30940068c4c$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($4b23e30940068c4c$var$LOCK_STYLES).forEach(function(key) {
                var val = $4b23e30940068c4c$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $4b23e30940068c4c$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $4b23e30940068c4c$var$preventTouchMove, $4b23e30940068c4c$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $4b23e30940068c4c$var$preventInertiaScroll, $4b23e30940068c4c$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $4b23e30940068c4c$var$allowTouchMove, $4b23e30940068c4c$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $4b23e30940068c4c$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$4b23e30940068c4c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $4b23e30940068c4c$var$activeScrollLocks = Math.max($4b23e30940068c4c$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $4b23e30940068c4c$var$activeScrollLocks < 1) $4b23e30940068c4c$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $4b23e30940068c4c$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $4b23e30940068c4c$var$preventTouchMove, $4b23e30940068c4c$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $4b23e30940068c4c$var$preventInertiaScroll, $4b23e30940068c4c$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $4b23e30940068c4c$var$allowTouchMove, $4b23e30940068c4c$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b23e30940068c4c$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $4b23e30940068c4c$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $4b23e30940068c4c$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $4b23e30940068c4c$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $4b23e30940068c4c$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, lockEnabled && (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", {
        onClick: $4b23e30940068c4c$var$blurSelectInput,
        css: $4b23e30940068c4c$var$_ref2$1
    }), children(targetRef));
}
function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b23e30940068c4c$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $4b23e30940068c4c$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $4b23e30940068c4c$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $4b23e30940068c4c$var$RequiredInput$1 = $4b23e30940068c4c$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $4b23e30940068c4c$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $4b23e30940068c4c$var$isIPhone() {
    return $4b23e30940068c4c$var$testPlatform(/^iPhone/i);
}
function $4b23e30940068c4c$var$isMac() {
    return $4b23e30940068c4c$var$testPlatform(/^Mac/i);
}
function $4b23e30940068c4c$var$isIPad() {
    return $4b23e30940068c4c$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $4b23e30940068c4c$var$isMac() && navigator.maxTouchPoints > 1;
}
function $4b23e30940068c4c$var$isIOS() {
    return $4b23e30940068c4c$var$isIPhone() || $4b23e30940068c4c$var$isIPad();
}
function $4b23e30940068c4c$var$isAppleDevice() {
    return $4b23e30940068c4c$var$isMac() || $4b23e30940068c4c$var$isIOS();
}
var $4b23e30940068c4c$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $4b23e30940068c4c$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $4b23e30940068c4c$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $4b23e30940068c4c$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $4b23e30940068c4c$var$defaultStyles = {
    clearIndicator: (0, $e5db4f66b3bbccc3$export$407448d2b89b1813),
    container: (0, $e5db4f66b3bbccc3$export$8b22cf2602fb60ce),
    control: (0, $e5db4f66b3bbccc3$export$4368d992c4eafac0),
    dropdownIndicator: (0, $e5db4f66b3bbccc3$export$f1e1789686576879),
    group: (0, $e5db4f66b3bbccc3$export$39b482c5e57630a8),
    groupHeading: (0, $e5db4f66b3bbccc3$export$2d1720544b23b823),
    indicatorsContainer: (0, $e5db4f66b3bbccc3$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $e5db4f66b3bbccc3$export$dda1d9f60106f0e9),
    input: (0, $e5db4f66b3bbccc3$export$35e795649ee09318),
    loadingIndicator: (0, $e5db4f66b3bbccc3$export$882b5998b3b9117c),
    loadingMessage: (0, $e5db4f66b3bbccc3$export$342063e11d6c3cad),
    menu: (0, $e5db4f66b3bbccc3$export$953cecd6e717a553),
    menuList: (0, $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $e5db4f66b3bbccc3$export$ae1af26003f05816),
    multiValue: (0, $e5db4f66b3bbccc3$export$ffb5f4729a158638),
    multiValueLabel: (0, $e5db4f66b3bbccc3$export$9e5f44173e64f162),
    multiValueRemove: (0, $e5db4f66b3bbccc3$export$625550452a3fa3ec),
    noOptionsMessage: (0, $e5db4f66b3bbccc3$export$3b14a55fb2447963),
    option: (0, $e5db4f66b3bbccc3$export$90a7f3efeed30595),
    placeholder: (0, $e5db4f66b3bbccc3$export$efccba1c4a2ef57b),
    singleValue: (0, $e5db4f66b3bbccc3$export$d141bba7fdc215a3),
    valueContainer: (0, $e5db4f66b3bbccc3$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $4b23e30940068c4c$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $4b23e30940068c4c$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $4b23e30940068c4c$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $4b23e30940068c4c$var$baseUnit = 4;
// The minimum height of the control
var $4b23e30940068c4c$var$controlHeight = 38;
// The amount of space between the control and menu */
var $4b23e30940068c4c$var$menuGutter = $4b23e30940068c4c$var$baseUnit * 2;
var $4b23e30940068c4c$var$spacing = {
    baseUnit: $4b23e30940068c4c$var$baseUnit,
    controlHeight: $4b23e30940068c4c$var$controlHeight,
    menuGutter: $4b23e30940068c4c$var$menuGutter
};
var $4b23e30940068c4c$export$4368d992c4eafac0 = {
    borderRadius: $4b23e30940068c4c$var$borderRadius,
    colors: $4b23e30940068c4c$var$colors,
    spacing: $4b23e30940068c4c$var$spacing
};
var $4b23e30940068c4c$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $e5db4f66b3bbccc3$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $e5db4f66b3bbccc3$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $4b23e30940068c4c$export$db3b6bfb95261072(),
    formatGroupLabel: $4b23e30940068c4c$var$formatGroupLabel,
    getOptionLabel: $4b23e30940068c4c$export$8b22cf2602fb60ce,
    getOptionValue: $4b23e30940068c4c$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $4b23e30940068c4c$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $e5db4f66b3bbccc3$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $4b23e30940068c4c$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $4b23e30940068c4c$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $4b23e30940068c4c$var$_isOptionSelected(props, option, selectValue);
    var label = $4b23e30940068c4c$var$getOptionLabel(props, option);
    var value = $4b23e30940068c4c$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $4b23e30940068c4c$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $4b23e30940068c4c$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $4b23e30940068c4c$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $4b23e30940068c4c$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $e5db4f66b3bbccc3$export$3466f893ebf79586));
}
function $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $4b23e30940068c4c$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $4b23e30940068c4c$var$buildFocusableOptions(props, selectValue) {
    return $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions($4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue));
}
function $4b23e30940068c4c$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$4b23e30940068c4c$var$shouldHideSelectedOptions(props) || !isSelected) && $4b23e30940068c4c$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $4b23e30940068c4c$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $4b23e30940068c4c$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $4b23e30940068c4c$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $4b23e30940068c4c$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $4b23e30940068c4c$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $4b23e30940068c4c$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $4b23e30940068c4c$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $4b23e30940068c4c$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $4b23e30940068c4c$var$getOptionValue(props, i) === candidate;
    });
}
function $4b23e30940068c4c$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $4b23e30940068c4c$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $4b23e30940068c4c$var$instanceId = 1;
var $4b23e30940068c4c$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $4b23e30940068c4c$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $e5db4f66b3bbccc3$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $e5db4f66b3bbccc3$export$ef35774e6d314e91)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $e5db4f66b3bbccc3$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $e5db4f66b3bbccc3$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $4b23e30940068c4c$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $4b23e30940068c4c$var$buildFocusableOptionsWithIds($4b23e30940068c4c$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $4b23e30940068c4c$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $4b23e30940068c4c$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $4b23e30940068c4c$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $e5db4f66b3bbccc3$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $4b23e30940068c4c$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $e5db4f66b3bbccc3$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $4b23e30940068c4c$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$4b23e30940068c4c$var$instanceId);
        _this.state.selectValue = (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $4b23e30940068c4c$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $e5db4f66b3bbccc3$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $e5db4f66b3bbccc3$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $4b23e30940068c4c$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($4b23e30940068c4c$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $4b23e30940068c4c$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $4b23e30940068c4c$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $4b23e30940068c4c$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $4b23e30940068c4c$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$DummyInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $e5db4f66b3bbccc3$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$LiveRegion$1, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $4b23e30940068c4c$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $4b23e30940068c4c$var$buildFocusableOptionsWithIds($4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $4b23e30940068c4c$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $4b23e30940068c4c$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $4b23e30940068c4c$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$4b23e30940068c4c$export$25ce5a424b770e84.defaultProps = $4b23e30940068c4c$export$407448d2b89b1813;




















var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $4b23e30940068c4c$export$25ce5a424b770e84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $4eee05ec22b53782$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};


var $8159aa64a7960b5d$exports = {};
$8159aa64a7960b5d$exports = JSON.parse("{\"options\":[{\"value\":\"AL\",\"label\":\"Alabama\"},{\"value\":\"AK\",\"label\":\"Alaska\"},{\"value\":\"AZ\",\"label\":\"Arizona\"},{\"value\":\"AR\",\"label\":\"Arkansas\"},{\"value\":\"CA\",\"label\":\"California\"},{\"value\":\"CO\",\"label\":\"Colorado\"},{\"value\":\"CT\",\"label\":\"Connecticut\"},{\"value\":\"DE\",\"label\":\"Delaware\"},{\"value\":\"DC\",\"label\":\"District Of Columbia\"},{\"value\":\"FL\",\"label\":\"Florida\"},{\"value\":\"GA\",\"label\":\"Georgia\"},{\"value\":\"HI\",\"label\":\"Hawaii\"},{\"value\":\"ID\",\"label\":\"Idaho\"},{\"value\":\"IL\",\"label\":\"Illinois\"},{\"value\":\"IN\",\"label\":\"Indiana\"},{\"value\":\"IA\",\"label\":\"Iowa\"},{\"value\":\"KS\",\"label\":\"Kansas\"},{\"value\":\"KY\",\"label\":\"Kentucky\"},{\"value\":\"LA\",\"label\":\"Louisiana\"},{\"value\":\"ME\",\"label\":\"Maine\"},{\"value\":\"MD\",\"label\":\"Maryland\"},{\"value\":\"MA\",\"label\":\"Massachusetts\"},{\"value\":\"MI\",\"label\":\"Michigan\"},{\"value\":\"MN\",\"label\":\"Minnesota\"},{\"value\":\"MS\",\"label\":\"Mississippi\"},{\"value\":\"MO\",\"label\":\"Missouri\"},{\"value\":\"MT\",\"label\":\"Montana\"},{\"value\":\"NE\",\"label\":\"Nebraska\"},{\"value\":\"NV\",\"label\":\"Nevada\"},{\"value\":\"NH\",\"label\":\"New Hampshire\"},{\"value\":\"NJ\",\"label\":\"New Jersey\"},{\"value\":\"NM\",\"label\":\"New Mexico\"},{\"value\":\"NY\",\"label\":\"New York\"},{\"value\":\"NC\",\"label\":\"North Carolina\"},{\"value\":\"ND\",\"label\":\"North Dakota\"},{\"value\":\"OH\",\"label\":\"Ohio\"},{\"value\":\"OK\",\"label\":\"Oklahoma\"},{\"value\":\"OR\",\"label\":\"Oregon\"},{\"value\":\"PA\",\"label\":\"Pennsylvania\"},{\"value\":\"RI\",\"label\":\"Rhode Island\"},{\"value\":\"SC\",\"label\":\"South Carolina\"},{\"value\":\"SD\",\"label\":\"South Dakota\"},{\"value\":\"TN\",\"label\":\"Tennessee\"},{\"value\":\"TX\",\"label\":\"Texas\"},{\"value\":\"UT\",\"label\":\"Utah\"},{\"value\":\"VT\",\"label\":\"Vermont\"},{\"value\":\"VA\",\"label\":\"Virginia\"},{\"value\":\"WA\",\"label\":\"Washington\"},{\"value\":\"WV\",\"label\":\"West Virginia\"},{\"value\":\"WI\",\"label\":\"Wisconsin\"},{\"value\":\"WY\",\"label\":\"Wyoming\"},{\"value\":\"AS\",\"label\":\"American Samoa\"},{\"value\":\"GU\",\"label\":\"Guam\"},{\"value\":\"MP\",\"label\":\"Northern Mariana Islands\"},{\"value\":\"PR\",\"label\":\"Puerto Rico\"},{\"value\":\"VI\",\"label\":\"Virgin Islands\"}]}");


//Import Mixpanel SDK
// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $6fb9842575b03497$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $6fb9842575b03497$var$win;
if (typeof window === 'undefined') {
    var $6fb9842575b03497$var$loc = {
        hostname: ''
    };
    $6fb9842575b03497$var$win = {
        crypto: {
            randomUUID: function() {
                throw Error('unsupported');
            }
        },
        navigator: {
            userAgent: '',
            onLine: true
        },
        document: {
            createElement: function() {
                return {};
            },
            location: $6fb9842575b03497$var$loc,
            referrer: ''
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $6fb9842575b03497$var$loc,
        addEventListener: function() {},
        removeEventListener: function() {}
    };
} else $6fb9842575b03497$var$win = window;
function $6fb9842575b03497$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6fb9842575b03497$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $6fb9842575b03497$var$_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $6fb9842575b03497$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $6fb9842575b03497$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $6fb9842575b03497$var$_construct(Parent, args, Class) {
    if ($6fb9842575b03497$var$_is_native_reflect_construct()) $6fb9842575b03497$var$_construct = Reflect.construct;
    else $6fb9842575b03497$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $6fb9842575b03497$var$_set_prototype_of(instance, Class.prototype);
        return instance;
    };
    return $6fb9842575b03497$var$_construct.apply(null, arguments);
}
function $6fb9842575b03497$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6fb9842575b03497$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $6fb9842575b03497$var$_defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function $6fb9842575b03497$var$_extends() {
    $6fb9842575b03497$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6fb9842575b03497$var$_extends.apply(this, arguments);
}
function $6fb9842575b03497$var$_get_prototype_of(o) {
    $6fb9842575b03497$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6fb9842575b03497$var$_get_prototype_of(o);
}
function $6fb9842575b03497$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6fb9842575b03497$var$_set_prototype_of(subClass, superClass);
}
function $6fb9842575b03497$var$_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}
function $6fb9842575b03497$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $6fb9842575b03497$var$_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6fb9842575b03497$var$_set_prototype_of(o, p) {
    $6fb9842575b03497$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6fb9842575b03497$var$_set_prototype_of(o, p);
}
function $6fb9842575b03497$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function $6fb9842575b03497$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6fb9842575b03497$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6fb9842575b03497$var$_array_like_to_array(o, minLen);
}
function $6fb9842575b03497$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $6fb9842575b03497$var$_wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !$6fb9842575b03497$var$_is_native_function(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $6fb9842575b03497$var$_construct(Class, arguments, $6fb9842575b03497$var$_get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $6fb9842575b03497$var$_set_prototype_of(Wrapper, Class);
    };
    return $6fb9842575b03497$var$_wrap_native_super(Class);
}
function $6fb9842575b03497$var$_is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($6fb9842575b03497$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6fb9842575b03497$var$_unsupported_iterable_to_array(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6fb9842575b03497$var$_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $6fb9842575b03497$var$_ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var $6fb9842575b03497$var$__defProp = Object.defineProperty;
var $6fb9842575b03497$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $6fb9842575b03497$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $6fb9842575b03497$var$__publicField = function(obj, key, value) {
    return $6fb9842575b03497$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $6fb9842575b03497$var$_a;
var $6fb9842575b03497$var$__defProp$1 = Object.defineProperty;
var $6fb9842575b03497$var$__defNormalProp$1 = function(obj, key, value) {
    return key in obj ? $6fb9842575b03497$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $6fb9842575b03497$var$__publicField$1 = function(obj, key, value) {
    return $6fb9842575b03497$var$__defNormalProp$1(obj, (typeof key === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $6fb9842575b03497$var$NodeType$3 = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($6fb9842575b03497$var$NodeType$3 || {});
var $6fb9842575b03497$var$testableAccessors$1 = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $6fb9842575b03497$var$testableMethods$1 = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $6fb9842575b03497$var$untaintedBasePrototype$1 = {};
var $6fb9842575b03497$var$isAngularZonePresent$1 = function() {
    return !!globalThis.Zone;
};
function $6fb9842575b03497$var$getUntaintedPrototype$1(key) {
    if ($6fb9842575b03497$var$untaintedBasePrototype$1[key]) return $6fb9842575b03497$var$untaintedBasePrototype$1[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $6fb9842575b03497$var$testableAccessors$1 ? $6fb9842575b03497$var$testableAccessors$1[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $6fb9842575b03497$var$testableMethods$1 ? $6fb9842575b03497$var$testableMethods$1[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$6fb9842575b03497$var$isAngularZonePresent$1()) {
        $6fb9842575b03497$var$untaintedBasePrototype$1[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $6fb9842575b03497$var$untaintedBasePrototype$1[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $6fb9842575b03497$var$untaintedAccessorCache$1 = {};
function $6fb9842575b03497$var$getUntaintedAccessor$1(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($6fb9842575b03497$var$untaintedAccessorCache$1[cacheKey]) return $6fb9842575b03497$var$untaintedAccessorCache$1[cacheKey].call(instance);
    var untaintedPrototype = $6fb9842575b03497$var$getUntaintedPrototype$1(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $6fb9842575b03497$var$untaintedAccessorCache$1[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $6fb9842575b03497$var$untaintedMethodCache$1 = {};
function $6fb9842575b03497$var$getUntaintedMethod$1(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($6fb9842575b03497$var$untaintedMethodCache$1[cacheKey]) return $6fb9842575b03497$var$untaintedMethodCache$1[cacheKey].bind(instance);
    var untaintedPrototype = $6fb9842575b03497$var$getUntaintedPrototype$1(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $6fb9842575b03497$var$untaintedMethodCache$1[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $6fb9842575b03497$var$childNodes$1(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Node", n2, "childNodes");
}
function $6fb9842575b03497$var$parentNode$1(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Node", n2, "parentNode");
}
function $6fb9842575b03497$var$parentElement$1(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Node", n2, "parentElement");
}
function $6fb9842575b03497$var$textContent$1(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Node", n2, "textContent");
}
function $6fb9842575b03497$var$contains$1(n2, other) {
    return $6fb9842575b03497$var$getUntaintedMethod$1("Node", n2, "contains")(other);
}
function $6fb9842575b03497$var$getRootNode$1(n2) {
    return $6fb9842575b03497$var$getUntaintedMethod$1("Node", n2, "getRootNode")();
}
function $6fb9842575b03497$var$host$1(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $6fb9842575b03497$var$getUntaintedAccessor$1("ShadowRoot", n2, "host");
}
function $6fb9842575b03497$var$styleSheets$1(n2) {
    return n2.styleSheets;
}
function $6fb9842575b03497$var$shadowRoot$1(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Element", n2, "shadowRoot");
}
function $6fb9842575b03497$var$querySelector$1(n2, selectors) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Element", n2, "querySelector")(selectors);
}
function $6fb9842575b03497$var$querySelectorAll$1(n2, selectors) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Element", n2, "querySelectorAll")(selectors);
}
function $6fb9842575b03497$var$mutationObserverCtor$1() {
    return $6fb9842575b03497$var$getUntaintedPrototype$1("MutationObserver").constructor;
}
var $6fb9842575b03497$var$index$1 = {
    childNodes: $6fb9842575b03497$var$childNodes$1,
    parentNode: $6fb9842575b03497$var$parentNode$1,
    parentElement: $6fb9842575b03497$var$parentElement$1,
    textContent: $6fb9842575b03497$var$textContent$1,
    contains: $6fb9842575b03497$var$contains$1,
    getRootNode: $6fb9842575b03497$var$getRootNode$1,
    host: $6fb9842575b03497$var$host$1,
    styleSheets: $6fb9842575b03497$var$styleSheets$1,
    shadowRoot: $6fb9842575b03497$var$shadowRoot$1,
    querySelector: $6fb9842575b03497$var$querySelector$1,
    querySelectorAll: $6fb9842575b03497$var$querySelectorAll$1,
    mutationObserver: $6fb9842575b03497$var$mutationObserverCtor$1
};
function $6fb9842575b03497$var$isElement(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $6fb9842575b03497$var$isShadowRoot(n2) {
    var hostEl = // but only shadow roots have a `mode` property
    n2 && "host" in n2 && "mode" in n2 && $6fb9842575b03497$var$index$1.host(n2) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && $6fb9842575b03497$var$index$1.shadowRoot(hostEl) === n2);
}
function $6fb9842575b03497$var$isNativeShadowDom(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function $6fb9842575b03497$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $6fb9842575b03497$var$escapeImportStatement(rule2) {
    var cssText = rule2.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        "@import",
        "url(" + JSON.stringify(rule2.href) + ")"
    ];
    if (rule2.layerName === "") statement.push("layer");
    else if (rule2.layerName) statement.push("layer(" + rule2.layerName + ")");
    if (rule2.supportsText) statement.push("supports(" + rule2.supportsText + ")");
    if (rule2.media.length) statement.push(rule2.media.mediaText);
    return statement.join(" ") + ";";
}
function $6fb9842575b03497$var$stringifyStylesheet(s2) {
    try {
        var rules2 = s2.rules || s2.cssRules;
        if (!rules2) return null;
        var sheetHref = s2.href;
        if (!sheetHref && s2.ownerNode && s2.ownerNode.ownerDocument) sheetHref = s2.ownerNode.ownerDocument.location.href;
        var stringifiedRules = Array.from(rules2, function(rule2) {
            return $6fb9842575b03497$var$stringifyRule(rule2, sheetHref);
        }).join("");
        return $6fb9842575b03497$var$fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function $6fb9842575b03497$var$stringifyRule(rule2, sheetHref) {
    if ($6fb9842575b03497$var$isCSSImportRule(rule2)) {
        var importStringified;
        try {
            importStringified = $6fb9842575b03497$var$stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            $6fb9842575b03497$var$escapeImportStatement(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) return $6fb9842575b03497$var$absolutifyURLs(importStringified, rule2.styleSheet.href);
        return importStringified;
    } else {
        var ruleStringified = rule2.cssText;
        if ($6fb9842575b03497$var$isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) ruleStringified = $6fb9842575b03497$var$fixSafariColons(ruleStringified);
        if (sheetHref) return $6fb9842575b03497$var$absolutifyURLs(ruleStringified, sheetHref);
        return ruleStringified;
    }
}
function $6fb9842575b03497$var$fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $6fb9842575b03497$var$isCSSImportRule(rule2) {
    return "styleSheet" in rule2;
}
function $6fb9842575b03497$var$isCSSStyleRule(rule2) {
    return "selectorText" in rule2;
}
var $6fb9842575b03497$var$Mirror = /*#__PURE__*/ function() {
    function Mirror() {
        $6fb9842575b03497$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $6fb9842575b03497$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    var _proto = Mirror.prototype;
    _proto.getId = function getId(n2) {
        var _a2;
        if (!n2) return -1;
        var id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id != null ? id : -1;
    };
    _proto.getNode = function getNode(id) {
        return this.idNodeMap.get(id) || null;
    };
    _proto.getIds = function getIds() {
        return Array.from(this.idNodeMap.keys());
    };
    _proto.getMeta = function getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    };
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    _proto.removeNodeFromMap = function removeNodeFromMap(n2) {
        var _this = this;
        var id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach(function(childNode) {
            return _this.removeNodeFromMap(childNode);
        });
    };
    _proto.has = function has(id) {
        return this.idNodeMap.has(id);
    };
    _proto.hasNode = function hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    };
    _proto.add = function add(n2, meta) {
        var id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    };
    _proto.replace = function replace(id, n2) {
        var oldNode = this.getNode(id);
        if (oldNode) {
            var meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    };
    _proto.reset = function reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    };
    return Mirror;
}();
function $6fb9842575b03497$var$createMirror$2() {
    return new $6fb9842575b03497$var$Mirror();
}
function $6fb9842575b03497$var$maskInputValue(param) {
    var element = param.element, maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || "";
    var actualType = type && $6fb9842575b03497$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = "*".repeat(text.length);
    }
    return text;
}
function $6fb9842575b03497$var$toLowerCase(str) {
    return str.toLowerCase();
}
var $6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $6fb9842575b03497$var$is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext("2d");
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x2 = 0; x2 < canvas.width; x2 += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = $6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function $6fb9842575b03497$var$getInputType(element) {
    var type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $6fb9842575b03497$var$toLowerCase(type) : null;
}
function $6fb9842575b03497$var$extractFileExtension(path, baseURL) {
    var url;
    try {
        url = new URL(path, baseURL != null ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    var regex = /\.([0-9a-z]+)(?:$)/i;
    var match = url.pathname.match(regex);
    var _ref;
    return (_ref = match == null ? void 0 : match[1]) != null ? _ref : null;
}
function $6fb9842575b03497$var$extractOrigin(url) {
    var origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
var $6fb9842575b03497$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var $6fb9842575b03497$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var $6fb9842575b03497$var$URL_WWW_MATCH = /^www\..*/i;
var $6fb9842575b03497$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $6fb9842575b03497$var$absolutifyURLs(cssText, href) {
    return (cssText || "").replace($6fb9842575b03497$var$URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($6fb9842575b03497$var$URL_PROTOCOL_MATCH.test(filePath) || $6fb9842575b03497$var$URL_WWW_MATCH.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if ($6fb9842575b03497$var$DATA_URI.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if (filePath[0] === "/") return "url(" + maybeQuote + ($6fb9842575b03497$var$extractOrigin(href) + filePath) + maybeQuote + ")";
        var stack = href.split("/");
        var parts = filePath.split("/");
        stack.pop();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(parts), _step; !(_step = _iterator()).done;){
            var part = _step.value;
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return "url(" + maybeQuote + stack.join("/") + maybeQuote + ")";
    });
}
function $6fb9842575b03497$var$normalizeCssString(cssText) {
    return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
}
function $6fb9842575b03497$var$splitCssText(cssText, style) {
    var childNodes2 = Array.from(style.childNodes);
    var splits = [];
    if (childNodes2.length > 1 && cssText && typeof cssText === "string") {
        var cssTextNorm = $6fb9842575b03497$var$normalizeCssString(cssText);
        for(var i2 = 1; i2 < childNodes2.length; i2++)if (childNodes2[i2].textContent && typeof childNodes2[i2].textContent === "string") {
            var textContentNorm = $6fb9842575b03497$var$normalizeCssString(childNodes2[i2].textContent);
            for(var j = 3; j < textContentNorm.length; j++){
                var bit = textContentNorm.substring(0, j);
                if (cssTextNorm.split(bit).length === 2) {
                    var splitNorm = cssTextNorm.indexOf(bit);
                    for(var k = splitNorm; k < cssText.length; k++)if ($6fb9842575b03497$var$normalizeCssString(cssText.substring(0, k)).length === splitNorm) {
                        splits.push(cssText.substring(0, k));
                        cssText = cssText.substring(k);
                        break;
                    }
                    break;
                }
            }
        }
    }
    splits.push(cssText);
    return splits;
}
function $6fb9842575b03497$var$markCssSplits(cssText, style) {
    return $6fb9842575b03497$var$splitCssText(cssText, style).join("/* rr_split */");
}
var $6fb9842575b03497$var$_id = 1;
var $6fb9842575b03497$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
var $6fb9842575b03497$var$IGNORED_NODE = -2;
function $6fb9842575b03497$var$genId() {
    return $6fb9842575b03497$var$_id++;
}
function $6fb9842575b03497$var$getValidTagName$1(element) {
    if ($6fb9842575b03497$var$_instanceof(element, HTMLFormElement)) return "form";
    var processedTagName = $6fb9842575b03497$var$toLowerCase(element.tagName);
    if ($6fb9842575b03497$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
var $6fb9842575b03497$var$canvasService;
var $6fb9842575b03497$var$canvasCtx;
var $6fb9842575b03497$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var $6fb9842575b03497$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $6fb9842575b03497$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars2;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    var output = [];
    while(true){
        collectCharacters($6fb9842575b03497$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters($6fb9842575b03497$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $6fb9842575b03497$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = "";
            url = $6fb9842575b03497$var$absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
var $6fb9842575b03497$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $6fb9842575b03497$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $6fb9842575b03497$var$getHref(doc, attributeValue);
}
function $6fb9842575b03497$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $6fb9842575b03497$var$getHref(doc, customHref) {
    var a2 = $6fb9842575b03497$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $6fb9842575b03497$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $6fb9842575b03497$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $6fb9842575b03497$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $6fb9842575b03497$var$absolutifyURLs(value, $6fb9842575b03497$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    return value;
}
function $6fb9842575b03497$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $6fb9842575b03497$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $6fb9842575b03497$var$classMatchesRegex(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $6fb9842575b03497$var$classMatchesRegex($6fb9842575b03497$var$index$1.parentNode(node2), regex, checkAncestors);
    }
    for(var eIndex = node2.classList.length; eIndex--;){
        var className = node2.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $6fb9842575b03497$var$classMatchesRegex($6fb9842575b03497$var$index$1.parentNode(node2), regex, checkAncestors);
}
function $6fb9842575b03497$var$needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
    var el;
    if ($6fb9842575b03497$var$isElement(node2)) {
        el = node2;
        if (!$6fb9842575b03497$var$index$1.childNodes(el).length) return false;
    } else if ($6fb9842575b03497$var$index$1.parentElement(node2) === null) return false;
    else el = $6fb9842575b03497$var$index$1.parentElement(node2);
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest("." + maskTextClass)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($6fb9842575b03497$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e2) {}
    return false;
}
function $6fb9842575b03497$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        var timer = setTimeout(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", function() {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $6fb9842575b03497$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    var timer = setTimeout(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", function() {
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $6fb9842575b03497$var$serializeNode(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, needsMask = options.needsMask, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var rootId = $6fb9842575b03497$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $6fb9842575b03497$var$NodeType$3.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $6fb9842575b03497$var$NodeType$3.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType$3.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $6fb9842575b03497$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n2.TEXT_NODE:
            return $6fb9842575b03497$var$serializeTextNode(n2, {
                doc: doc,
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId,
                cssCaptured: cssCaptured
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType$3.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType$3.Comment,
                textContent: $6fb9842575b03497$var$index$1.textContent(n2) || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $6fb9842575b03497$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    var docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $6fb9842575b03497$var$serializeTextNode(n2, options) {
    var needsMask = options.needsMask, maskTextFn = options.maskTextFn, rootId = options.rootId, cssCaptured = options.cssCaptured;
    var parent = $6fb9842575b03497$var$index$1.parentNode(n2);
    var parentTagName = parent && parent.tagName;
    var textContent2 = "";
    var isStyle = parentTagName === "STYLE" ? true : void 0;
    var isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isScript) textContent2 = "SCRIPT_PLACEHOLDER";
    else if (!cssCaptured) {
        textContent2 = $6fb9842575b03497$var$index$1.textContent(n2);
        if (isStyle && textContent2) textContent2 = $6fb9842575b03497$var$absolutifyURLs(textContent2, $6fb9842575b03497$var$getHref(options.doc));
    }
    if (!isStyle && !isScript && textContent2 && needsMask) textContent2 = maskTextFn ? maskTextFn(textContent2, $6fb9842575b03497$var$index$1.parentElement(n2)) : textContent2.replace(/[\S]/g, "*");
    return {
        type: $6fb9842575b03497$var$NodeType$3.Text,
        textContent: textContent2 || "",
        rootId: rootId
    };
}
function $6fb9842575b03497$var$serializeElementNode(n2, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId;
    var needBlock = $6fb9842575b03497$var$_isBlockedElement(n2, blockClass, blockSelector);
    var tagName = $6fb9842575b03497$var$getValidTagName$1(n2);
    var attributes = {};
    var len = n2.attributes.length;
    for(var i2 = 0; i2 < len; i2++){
        var attr = n2.attributes[i2];
        if (!$6fb9842575b03497$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $6fb9842575b03497$var$transformAttribute(doc, tagName, $6fb9842575b03497$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === "link" && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s2) {
            return s2.href === n2.href;
        });
        var cssText = null;
        if (stylesheet) cssText = $6fb9842575b03497$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n2.sheet) {
        var cssText1 = $6fb9842575b03497$var$stringifyStylesheet(n2.sheet);
        if (cssText1) {
            if (n2.childNodes.length > 1) cssText1 = $6fb9842575b03497$var$markCssSplits(cssText1, n2);
            attributes._cssText = cssText1;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        var value = n2.value;
        var checked = n2.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) attributes.value = $6fb9842575b03497$var$maskInputValue({
            element: n2,
            type: $6fb9842575b03497$var$getInputType(n2),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "dialog" && n2.open) attributes.rr_open_mode = n2.matches("dialog:modal") ? "modal" : "non-modal";
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$6fb9842575b03497$var$is2DCanvasBlank(n2)) attributes.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            var canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$6fb9842575b03497$var$canvasService) {
            $6fb9842575b03497$var$canvasService = doc.createElement("canvas");
            $6fb9842575b03497$var$canvasCtx = $6fb9842575b03497$var$canvasService.getContext("2d");
        }
        var image = n2;
        var imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        var priorCrossOrigin = image.crossOrigin;
        var recordInlineImage = function() {
            image.removeEventListener("load", recordInlineImage);
            try {
                $6fb9842575b03497$var$canvasService.width = image.naturalWidth;
                $6fb9842575b03497$var$canvasService.height = image.naturalHeight;
                $6fb9842575b03497$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $6fb9842575b03497$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn("Cannot inline img src=" + imageSrc + "! Error: " + err);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        var mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n2.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n2.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n2.playbackRate;
        mediaAttributes.rr_mediaMuted = n2.muted;
        mediaAttributes.rr_mediaLoop = n2.loop;
        mediaAttributes.rr_mediaVolume = n2.volume;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        var _n2_getBoundingClientRect = n2.getBoundingClientRect(), width = _n2_getBoundingClientRect.width, height = _n2_getBoundingClientRect.height;
        attributes = {
            class: attributes.class,
            rr_width: "" + width + "px",
            rr_height: "" + height + "px"
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n2.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $6fb9842575b03497$var$NodeType$3.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $6fb9842575b03497$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $6fb9842575b03497$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $6fb9842575b03497$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $6fb9842575b03497$var$NodeType$3.Comment) return true;
    else if (sn.type === $6fb9842575b03497$var$NodeType$3.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $6fb9842575b03497$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "application-name" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "icon" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "robots" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "googlebot" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "author" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "generator" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "framework" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "publisher" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "progid" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $6fb9842575b03497$var$serializeNodeWithId(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5e3 : _options_iframeLoadTimeout, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5e3 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var needsMask = options.needsMask;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    if (!needsMask) {
        var checkAncestors = needsMask === void 0;
        needsMask = $6fb9842575b03497$var$needMaskingText(n2, maskTextClass, maskTextSelector, checkAncestors);
    }
    var _serializedNode = $6fb9842575b03497$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        cssCaptured: cssCaptured
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    var id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($6fb9842575b03497$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $6fb9842575b03497$var$NodeType$3.Text && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $6fb9842575b03497$var$IGNORED_NODE;
    else id = $6fb9842575b03497$var$genId();
    var serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode);
    if (id === $6fb9842575b03497$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    var recordChild = !skipChild;
    if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        var shadowRootEl = $6fb9842575b03497$var$index$1.shadowRoot(n2);
        if (shadowRootEl && $6fb9842575b03497$var$isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $6fb9842575b03497$var$NodeType$3.Document || serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            cssCaptured: false
        };
        if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.attributes._cssText !== void 0 && typeof serializedNode.attributes._cssText === "string") bypassOptions.cssCaptured = true;
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(Array.from($6fb9842575b03497$var$index$1.childNodes(n2))), _step; !(_step = _iterator()).done;){
                var childN = _step.value;
                var serializedChildNode = $6fb9842575b03497$var$serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        }
        var shadowRootEl1 = null;
        if ($6fb9842575b03497$var$isElement(n2) && (shadowRootEl1 = $6fb9842575b03497$var$index$1.shadowRoot(n2))) for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(Array.from($6fb9842575b03497$var$index$1.childNodes(shadowRootEl1))), _step1; !(_step1 = _iterator1()).done;){
            var childN1 = _step1.value;
            var serializedChildNode1 = $6fb9842575b03497$var$serializeNodeWithId(childN1, bypassOptions);
            if (serializedChildNode1) {
                $6fb9842575b03497$var$isNativeShadowDom(shadowRootEl1) && (serializedChildNode1.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode1);
            }
        }
    }
    var parent = $6fb9842575b03497$var$index$1.parentNode(n2);
    if (parent && $6fb9842575b03497$var$isShadowRoot(parent) && $6fb9842575b03497$var$isNativeShadowDom(parent)) serializedNode.isShadow = true;
    if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.tagName === "iframe") $6fb9842575b03497$var$onceIframeLoaded(n2, function() {
        var iframeDoc = n2.contentDocument;
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = $6fb9842575b03497$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $6fb9842575b03497$var$extractFileExtension(serializedNode.attributes.href) === "css")) $6fb9842575b03497$var$onceStylesheetLoaded(n2, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = $6fb9842575b03497$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $6fb9842575b03497$var$snapshot(n2, options) {
    var _ref = options || {}, tmp = _ref.mirror, mirror2 = tmp === void 0 ? new $6fb9842575b03497$var$Mirror() : tmp, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? "rr-block" : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? "rr-mask" : _ref_maskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $6fb9842575b03497$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $6fb9842575b03497$var$getDefaultExportFromCjs$1(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $6fb9842575b03497$var$getAugmentedNamespace$1(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($6fb9842575b03497$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $6fb9842575b03497$var$picocolors_browser$1 = {
    exports: {}
};
var $6fb9842575b03497$var$x$1 = String;
var $6fb9842575b03497$var$create$1 = function create$1() {
    return {
        isColorSupported: false,
        reset: $6fb9842575b03497$var$x$1,
        bold: $6fb9842575b03497$var$x$1,
        dim: $6fb9842575b03497$var$x$1,
        italic: $6fb9842575b03497$var$x$1,
        underline: $6fb9842575b03497$var$x$1,
        inverse: $6fb9842575b03497$var$x$1,
        hidden: $6fb9842575b03497$var$x$1,
        strikethrough: $6fb9842575b03497$var$x$1,
        black: $6fb9842575b03497$var$x$1,
        red: $6fb9842575b03497$var$x$1,
        green: $6fb9842575b03497$var$x$1,
        yellow: $6fb9842575b03497$var$x$1,
        blue: $6fb9842575b03497$var$x$1,
        magenta: $6fb9842575b03497$var$x$1,
        cyan: $6fb9842575b03497$var$x$1,
        white: $6fb9842575b03497$var$x$1,
        gray: $6fb9842575b03497$var$x$1,
        bgBlack: $6fb9842575b03497$var$x$1,
        bgRed: $6fb9842575b03497$var$x$1,
        bgGreen: $6fb9842575b03497$var$x$1,
        bgYellow: $6fb9842575b03497$var$x$1,
        bgBlue: $6fb9842575b03497$var$x$1,
        bgMagenta: $6fb9842575b03497$var$x$1,
        bgCyan: $6fb9842575b03497$var$x$1,
        bgWhite: $6fb9842575b03497$var$x$1
    };
};
$6fb9842575b03497$var$picocolors_browser$1.exports = $6fb9842575b03497$var$create$1();
$6fb9842575b03497$var$picocolors_browser$1.exports.createColors = $6fb9842575b03497$var$create$1;
var $6fb9842575b03497$var$picocolors_browserExports$1 = $6fb9842575b03497$var$picocolors_browser$1.exports;
var $6fb9842575b03497$var$__viteBrowserExternal$2 = {};
var $6fb9842575b03497$var$__viteBrowserExternal$1$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $6fb9842575b03497$var$__viteBrowserExternal$2
}, Symbol.toStringTag, {
    value: "Module"
}));
var $6fb9842575b03497$var$require$$2$1 = /* @__PURE__ */ $6fb9842575b03497$var$getAugmentedNamespace$1($6fb9842575b03497$var$__viteBrowserExternal$1$1);
var $6fb9842575b03497$var$pico$1 = $6fb9842575b03497$var$picocolors_browserExports$1;
var $6fb9842575b03497$var$terminalHighlight$1$1 = $6fb9842575b03497$var$require$$2$1;
var $6fb9842575b03497$var$CssSyntaxError$3$1 = /*#__PURE__*/ function(Error1) {
    $6fb9842575b03497$var$_inherits(CssSyntaxError, Error1);
    function CssSyntaxError(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError);
        return _this;
    }
    var _proto = CssSyntaxError.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $6fb9842575b03497$var$pico$1.isColorSupported;
        if ($6fb9842575b03497$var$terminalHighlight$1$1) {
            if (color) css = $6fb9842575b03497$var$terminalHighlight$1$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico$1_createColors = $6fb9842575b03497$var$pico$1.createColors(true), bold = _pico$1_createColors.bold, gray = _pico$1_createColors.gray, red = _pico$1_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError;
}($6fb9842575b03497$var$_wrap_native_super(Error));
var $6fb9842575b03497$var$cssSyntaxError$1 = $6fb9842575b03497$var$CssSyntaxError$3$1;
$6fb9842575b03497$var$CssSyntaxError$3$1.default = $6fb9842575b03497$var$CssSyntaxError$3$1;
var $6fb9842575b03497$var$symbols$1 = {};
$6fb9842575b03497$var$symbols$1.isClean = Symbol("isClean");
$6fb9842575b03497$var$symbols$1.my = Symbol("my");
var $6fb9842575b03497$var$DEFAULT_RAW$1 = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $6fb9842575b03497$var$capitalize$1(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $6fb9842575b03497$var$Stringifier$2$1 = /*#__PURE__*/ function() {
    function Stringifier(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $6fb9842575b03497$var$DEFAULT_RAW$1[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $6fb9842575b03497$var$capitalize$1(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $6fb9842575b03497$var$DEFAULT_RAW$1[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier;
}();
var $6fb9842575b03497$var$stringifier$1 = $6fb9842575b03497$var$Stringifier$2$1;
$6fb9842575b03497$var$Stringifier$2$1.default = $6fb9842575b03497$var$Stringifier$2$1;
var $6fb9842575b03497$var$Stringifier$1$1 = $6fb9842575b03497$var$stringifier$1;
function $6fb9842575b03497$var$stringify$4$1(node2, builder) {
    var str = new $6fb9842575b03497$var$Stringifier$1$1(builder);
    str.stringify(node2);
}
var $6fb9842575b03497$var$stringify_1$1 = $6fb9842575b03497$var$stringify$4$1;
$6fb9842575b03497$var$stringify$4$1.default = $6fb9842575b03497$var$stringify$4$1;
var $6fb9842575b03497$var$isClean$2$1 = $6fb9842575b03497$var$symbols$1.isClean, $6fb9842575b03497$var$my$2$1 = $6fb9842575b03497$var$symbols$1.my;
var $6fb9842575b03497$var$CssSyntaxError$2$1 = $6fb9842575b03497$var$cssSyntaxError$1;
var $6fb9842575b03497$var$Stringifier2$1 = $6fb9842575b03497$var$stringifier$1;
var $6fb9842575b03497$var$stringify$3$1 = $6fb9842575b03497$var$stringify_1$1;
function $6fb9842575b03497$var$cloneNode$1(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $6fb9842575b03497$var$cloneNode$1(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $6fb9842575b03497$var$cloneNode$1(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $6fb9842575b03497$var$Node$4$1 = /*#__PURE__*/ function() {
    function Node2(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$6fb9842575b03497$var$isClean$2$1] = false;
        this[$6fb9842575b03497$var$my$2$1] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node2.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $6fb9842575b03497$var$cloneNode$1(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $6fb9842575b03497$var$CssSyntaxError$2$1(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$6fb9842575b03497$var$isClean$2$1]) {
            this[$6fb9842575b03497$var$isClean$2$1] = false;
            var next = this;
            while(next = next.parent)next[$6fb9842575b03497$var$isClean$2$1] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $6fb9842575b03497$var$Stringifier2$1();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $6fb9842575b03497$var$stringify$3$1;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $6fb9842575b03497$var$_create_class(Node2, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node2;
}();
var $6fb9842575b03497$var$node$1 = $6fb9842575b03497$var$Node$4$1;
$6fb9842575b03497$var$Node$4$1.default = $6fb9842575b03497$var$Node$4$1;
var $6fb9842575b03497$var$Node$3$1 = $6fb9842575b03497$var$node$1;
var $6fb9842575b03497$var$Declaration$4$1 = /*#__PURE__*/ function(Node$3$1) {
    $6fb9842575b03497$var$_inherits(Declaration, Node$3$1);
    function Declaration(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $6fb9842575b03497$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3$1.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $6fb9842575b03497$var$_create_class(Declaration, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration;
}($6fb9842575b03497$var$Node$3$1);
var $6fb9842575b03497$var$declaration$1 = $6fb9842575b03497$var$Declaration$4$1;
$6fb9842575b03497$var$Declaration$4$1.default = $6fb9842575b03497$var$Declaration$4$1;
var $6fb9842575b03497$var$urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $6fb9842575b03497$var$nanoid$1$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $6fb9842575b03497$var$urlAlphabet$1[Math.random() * 64 | 0];
    return id;
};
var $6fb9842575b03497$var$nonSecure$1 = {
    nanoid: $6fb9842575b03497$var$nanoid$1$1
};
var $6fb9842575b03497$var$SourceMapConsumer$2$1 = $6fb9842575b03497$var$require$$2$1.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$2$1 = $6fb9842575b03497$var$require$$2$1.SourceMapGenerator;
var $6fb9842575b03497$var$existsSync$1 = $6fb9842575b03497$var$require$$2$1.existsSync, $6fb9842575b03497$var$readFileSync$1 = $6fb9842575b03497$var$require$$2$1.readFileSync;
var $6fb9842575b03497$var$dirname$1$1 = $6fb9842575b03497$var$require$$2$1.dirname, $6fb9842575b03497$var$join$1 = $6fb9842575b03497$var$require$$2$1.join;
function $6fb9842575b03497$var$fromBase64$1(str) {
    if ($6fb9842575b03497$require$Buffer) return $6fb9842575b03497$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $6fb9842575b03497$var$PreviousMap$2$1 = /*#__PURE__*/ function() {
    function PreviousMap(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $6fb9842575b03497$var$dirname$1$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $6fb9842575b03497$var$SourceMapConsumer$2$1(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $6fb9842575b03497$var$fromBase64$1(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $6fb9842575b03497$var$dirname$1$1(path);
        if ($6fb9842575b03497$var$existsSync$1(path)) {
            this.mapFile = path;
            return $6fb9842575b03497$var$readFileSync$1(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($6fb9842575b03497$var$_instanceof(prev, $6fb9842575b03497$var$SourceMapConsumer$2$1)) return $6fb9842575b03497$var$SourceMapGenerator$2$1.fromSourceMap(prev).toString();
            else if ($6fb9842575b03497$var$_instanceof(prev, $6fb9842575b03497$var$SourceMapGenerator$2$1)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $6fb9842575b03497$var$join$1($6fb9842575b03497$var$dirname$1$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap;
}();
var $6fb9842575b03497$var$previousMap$1 = $6fb9842575b03497$var$PreviousMap$2$1;
$6fb9842575b03497$var$PreviousMap$2$1.default = $6fb9842575b03497$var$PreviousMap$2$1;
var $6fb9842575b03497$var$SourceMapConsumer$1$1 = $6fb9842575b03497$var$require$$2$1.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$1$1 = $6fb9842575b03497$var$require$$2$1.SourceMapGenerator;
var $6fb9842575b03497$var$fileURLToPath$1 = $6fb9842575b03497$var$require$$2$1.fileURLToPath, $6fb9842575b03497$var$pathToFileURL$1$1 = $6fb9842575b03497$var$require$$2$1.pathToFileURL;
var $6fb9842575b03497$var$isAbsolute$1 = $6fb9842575b03497$var$require$$2$1.isAbsolute, $6fb9842575b03497$var$resolve$1$1 = $6fb9842575b03497$var$require$$2$1.resolve;
var $6fb9842575b03497$var$nanoid$2 = $6fb9842575b03497$var$nonSecure$1.nanoid;
var $6fb9842575b03497$var$terminalHighlight$2 = $6fb9842575b03497$var$require$$2$1;
var $6fb9842575b03497$var$CssSyntaxError$1$1 = $6fb9842575b03497$var$cssSyntaxError$1;
var $6fb9842575b03497$var$PreviousMap$1$1 = $6fb9842575b03497$var$previousMap$1;
var $6fb9842575b03497$var$fromOffsetCache$1 = Symbol("fromOffsetCache");
var $6fb9842575b03497$var$sourceMapAvailable$1$1 = Boolean($6fb9842575b03497$var$SourceMapConsumer$1$1 && $6fb9842575b03497$var$SourceMapGenerator$1$1);
var $6fb9842575b03497$var$pathAvailable$1$1 = Boolean($6fb9842575b03497$var$resolve$1$1 && $6fb9842575b03497$var$isAbsolute$1);
var $6fb9842575b03497$var$Input$4$1 = /*#__PURE__*/ function() {
    function Input(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$6fb9842575b03497$var$pathAvailable$1$1 || /^\w+:\/\//.test(opts.from) || $6fb9842575b03497$var$isAbsolute$1(opts.from)) this.file = opts.from;
            else this.file = $6fb9842575b03497$var$resolve$1$1(opts.from);
        }
        if ($6fb9842575b03497$var$pathAvailable$1$1 && $6fb9842575b03497$var$sourceMapAvailable$1$1) {
            var map = new $6fb9842575b03497$var$PreviousMap$1$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $6fb9842575b03497$var$nanoid$2(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $6fb9842575b03497$var$CssSyntaxError$1$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $6fb9842575b03497$var$CssSyntaxError$1$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($6fb9842575b03497$var$pathToFileURL$1$1) result2.input.url = $6fb9842575b03497$var$pathToFileURL$1$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$6fb9842575b03497$var$fromOffsetCache$1]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$6fb9842575b03497$var$fromOffsetCache$1] = lineToIndex;
        } else lineToIndex = this[$6fb9842575b03497$var$fromOffsetCache$1];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $6fb9842575b03497$var$resolve$1$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($6fb9842575b03497$var$isAbsolute$1(from.source)) fromUrl = $6fb9842575b03497$var$pathToFileURL$1$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $6fb9842575b03497$var$pathToFileURL$1$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($6fb9842575b03497$var$fileURLToPath$1) result2.file = $6fb9842575b03497$var$fileURLToPath$1(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $6fb9842575b03497$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $6fb9842575b03497$var$_create_class(Input, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input;
}();
var $6fb9842575b03497$var$input$1 = $6fb9842575b03497$var$Input$4$1;
$6fb9842575b03497$var$Input$4$1.default = $6fb9842575b03497$var$Input$4$1;
if ($6fb9842575b03497$var$terminalHighlight$2 && $6fb9842575b03497$var$terminalHighlight$2.registerInput) $6fb9842575b03497$var$terminalHighlight$2.registerInput($6fb9842575b03497$var$Input$4$1);
var $6fb9842575b03497$var$SourceMapConsumer$3 = $6fb9842575b03497$var$require$$2$1.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$3 = $6fb9842575b03497$var$require$$2$1.SourceMapGenerator;
var $6fb9842575b03497$var$dirname$2 = $6fb9842575b03497$var$require$$2$1.dirname, $6fb9842575b03497$var$relative$1 = $6fb9842575b03497$var$require$$2$1.relative, $6fb9842575b03497$var$resolve$2 = $6fb9842575b03497$var$require$$2$1.resolve, $6fb9842575b03497$var$sep$1 = $6fb9842575b03497$var$require$$2$1.sep;
var $6fb9842575b03497$var$pathToFileURL$2 = $6fb9842575b03497$var$require$$2$1.pathToFileURL;
var $6fb9842575b03497$var$Input$3$1 = $6fb9842575b03497$var$input$1;
var $6fb9842575b03497$var$sourceMapAvailable$2 = Boolean($6fb9842575b03497$var$SourceMapConsumer$3 && $6fb9842575b03497$var$SourceMapGenerator$3);
var $6fb9842575b03497$var$pathAvailable$2 = Boolean($6fb9842575b03497$var$dirname$2 && $6fb9842575b03497$var$resolve$2 && $6fb9842575b03497$var$relative$1 && $6fb9842575b03497$var$sep$1);
var $6fb9842575b03497$var$MapGenerator$2$1 = /*#__PURE__*/ function() {
    function MapGenerator(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $6fb9842575b03497$var$dirname$2(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $6fb9842575b03497$var$SourceMapConsumer$3(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($6fb9842575b03497$var$pathAvailable$2 && $6fb9842575b03497$var$sourceMapAvailable$2 && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $6fb9842575b03497$var$SourceMapGenerator$3.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $6fb9842575b03497$var$SourceMapGenerator$3({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $6fb9842575b03497$var$SourceMapGenerator$3({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $6fb9842575b03497$var$dirname$2(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $6fb9842575b03497$var$dirname$2($6fb9842575b03497$var$resolve$2(from, this.mapOpts.annotation));
        var path = $6fb9842575b03497$var$relative$1(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $6fb9842575b03497$var$Input$3$1(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($6fb9842575b03497$require$Buffer) return $6fb9842575b03497$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($6fb9842575b03497$var$pathToFileURL$2) {
            var fileURL = $6fb9842575b03497$var$pathToFileURL$2(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($6fb9842575b03497$var$sep$1 === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator;
}();
var $6fb9842575b03497$var$mapGenerator$1 = $6fb9842575b03497$var$MapGenerator$2$1;
var $6fb9842575b03497$var$Node$2$1 = $6fb9842575b03497$var$node$1;
var $6fb9842575b03497$var$Comment$4$1 = /*#__PURE__*/ function(Node$2$1) {
    $6fb9842575b03497$var$_inherits(Comment, Node$2$1);
    function Comment(defaults) {
        var _this;
        _this = Node$2$1.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment;
}($6fb9842575b03497$var$Node$2$1);
var $6fb9842575b03497$var$comment$1 = $6fb9842575b03497$var$Comment$4$1;
$6fb9842575b03497$var$Comment$4$1.default = $6fb9842575b03497$var$Comment$4$1;
var $6fb9842575b03497$var$isClean$1$1 = $6fb9842575b03497$var$symbols$1.isClean, $6fb9842575b03497$var$my$1$1 = $6fb9842575b03497$var$symbols$1.my;
var $6fb9842575b03497$var$Declaration$3$1 = $6fb9842575b03497$var$declaration$1;
var $6fb9842575b03497$var$Comment$3$1 = $6fb9842575b03497$var$comment$1;
var $6fb9842575b03497$var$Node$1$1 = $6fb9842575b03497$var$node$1;
var $6fb9842575b03497$var$parse$4$1, $6fb9842575b03497$var$Rule$4$1, $6fb9842575b03497$var$AtRule$4$1, $6fb9842575b03497$var$Root$6$1;
function $6fb9842575b03497$var$cleanSource$1(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $6fb9842575b03497$var$cleanSource$1(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $6fb9842575b03497$var$markDirtyUp$1(node2) {
    node2[$6fb9842575b03497$var$isClean$1$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $6fb9842575b03497$var$markDirtyUp$1(i2);
    }
}
var $6fb9842575b03497$var$Container$7$1 = /*#__PURE__*/ function(Node$1$1) {
    $6fb9842575b03497$var$_inherits(Container, Node$1$1);
    function Container() {
        return Node$1$1.apply(this, arguments) || this;
    }
    var _proto = Container.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $6fb9842575b03497$var$cleanSource$1($6fb9842575b03497$var$parse$4$1(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $6fb9842575b03497$var$Declaration$3$1(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $6fb9842575b03497$var$Rule$4$1(nodes)
        ];
        else if (nodes.name) nodes = [
            new $6fb9842575b03497$var$AtRule$4$1(nodes)
        ];
        else if (nodes.text) nodes = [
            new $6fb9842575b03497$var$Comment$3$1(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$6fb9842575b03497$var$my$1$1]) Container.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$6fb9842575b03497$var$isClean$1$1]) $6fb9842575b03497$var$markDirtyUp$1(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $6fb9842575b03497$var$_create_class(Container, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container;
}($6fb9842575b03497$var$Node$1$1);
$6fb9842575b03497$var$Container$7$1.registerParse = function(dependant) {
    $6fb9842575b03497$var$parse$4$1 = dependant;
};
$6fb9842575b03497$var$Container$7$1.registerRule = function(dependant) {
    $6fb9842575b03497$var$Rule$4$1 = dependant;
};
$6fb9842575b03497$var$Container$7$1.registerAtRule = function(dependant) {
    $6fb9842575b03497$var$AtRule$4$1 = dependant;
};
$6fb9842575b03497$var$Container$7$1.registerRoot = function(dependant) {
    $6fb9842575b03497$var$Root$6$1 = dependant;
};
var $6fb9842575b03497$var$container$1 = $6fb9842575b03497$var$Container$7$1;
$6fb9842575b03497$var$Container$7$1.default = $6fb9842575b03497$var$Container$7$1;
$6fb9842575b03497$var$Container$7$1.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $6fb9842575b03497$var$AtRule$4$1.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Rule$4$1.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Declaration$3$1.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Comment$3$1.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Root$6$1.prototype);
    node2[$6fb9842575b03497$var$my$1$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $6fb9842575b03497$var$Container$7$1.rebuild(child);
    });
};
var $6fb9842575b03497$var$Container$6$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$LazyResult$4$1, $6fb9842575b03497$var$Processor$3$1;
var $6fb9842575b03497$var$Document$3$1 = /*#__PURE__*/ function(Container$6$1) {
    $6fb9842575b03497$var$_inherits(Document2, Container$6$1);
    function Document2(defaults) {
        var _this;
        _this = Container$6$1.call(this, $6fb9842575b03497$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document2.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $6fb9842575b03497$var$LazyResult$4$1(new $6fb9842575b03497$var$Processor$3$1(), this, opts);
        return lazy.stringify();
    };
    return Document2;
}($6fb9842575b03497$var$Container$6$1);
$6fb9842575b03497$var$Document$3$1.registerLazyResult = function(dependant) {
    $6fb9842575b03497$var$LazyResult$4$1 = dependant;
};
$6fb9842575b03497$var$Document$3$1.registerProcessor = function(dependant) {
    $6fb9842575b03497$var$Processor$3$1 = dependant;
};
var $6fb9842575b03497$var$document$1$1 = $6fb9842575b03497$var$Document$3$1;
$6fb9842575b03497$var$Document$3$1.default = $6fb9842575b03497$var$Document$3$1;
var $6fb9842575b03497$var$printed$1 = {};
var $6fb9842575b03497$var$warnOnce$2$1 = function warnOnce(message) {
    if ($6fb9842575b03497$var$printed$1[message]) return;
    $6fb9842575b03497$var$printed$1[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $6fb9842575b03497$var$Warning$2$1 = /*#__PURE__*/ function() {
    function Warning(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning;
}();
var $6fb9842575b03497$var$warning$1 = $6fb9842575b03497$var$Warning$2$1;
$6fb9842575b03497$var$Warning$2$1.default = $6fb9842575b03497$var$Warning$2$1;
var $6fb9842575b03497$var$Warning$1$1 = $6fb9842575b03497$var$warning$1;
var $6fb9842575b03497$var$Result$3$1 = /*#__PURE__*/ function() {
    function Result(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $6fb9842575b03497$var$Warning$1$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $6fb9842575b03497$var$_create_class(Result, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result;
}();
var $6fb9842575b03497$var$result$1 = $6fb9842575b03497$var$Result$3$1;
$6fb9842575b03497$var$Result$3$1.default = $6fb9842575b03497$var$Result$3$1;
var $6fb9842575b03497$var$SINGLE_QUOTE$1 = "'".charCodeAt(0);
var $6fb9842575b03497$var$DOUBLE_QUOTE$1 = '"'.charCodeAt(0);
var $6fb9842575b03497$var$BACKSLASH$1 = "\\".charCodeAt(0);
var $6fb9842575b03497$var$SLASH$1 = "/".charCodeAt(0);
var $6fb9842575b03497$var$NEWLINE$1 = "\n".charCodeAt(0);
var $6fb9842575b03497$var$SPACE$1 = " ".charCodeAt(0);
var $6fb9842575b03497$var$FEED$1 = "\f".charCodeAt(0);
var $6fb9842575b03497$var$TAB$1 = "	".charCodeAt(0);
var $6fb9842575b03497$var$CR$1 = "\r".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_SQUARE$1 = "[".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_SQUARE$1 = "]".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_PARENTHESES$1 = "(".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_PARENTHESES$1 = ")".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_CURLY$1 = "{".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_CURLY$1 = "}".charCodeAt(0);
var $6fb9842575b03497$var$SEMICOLON$1 = ";".charCodeAt(0);
var $6fb9842575b03497$var$ASTERISK$1 = "*".charCodeAt(0);
var $6fb9842575b03497$var$COLON$1 = ":".charCodeAt(0);
var $6fb9842575b03497$var$AT$1 = "@".charCodeAt(0);
var $6fb9842575b03497$var$RE_AT_END$1 = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $6fb9842575b03497$var$RE_WORD_END$1 = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $6fb9842575b03497$var$RE_BAD_BRACKET$1 = /.[\r\n"'(/\\]/;
var $6fb9842575b03497$var$RE_HEX_ESCAPE$1 = /[\da-f]/i;
var $6fb9842575b03497$var$tokenize$1 = function tokenizer(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $6fb9842575b03497$var$NEWLINE$1:
            case $6fb9842575b03497$var$SPACE$1:
            case $6fb9842575b03497$var$TAB$1:
            case $6fb9842575b03497$var$CR$1:
            case $6fb9842575b03497$var$FEED$1:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $6fb9842575b03497$var$SPACE$1 || code === $6fb9842575b03497$var$NEWLINE$1 || code === $6fb9842575b03497$var$TAB$1 || code === $6fb9842575b03497$var$CR$1 || code === $6fb9842575b03497$var$FEED$1);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $6fb9842575b03497$var$OPEN_SQUARE$1:
            case $6fb9842575b03497$var$CLOSE_SQUARE$1:
            case $6fb9842575b03497$var$OPEN_CURLY$1:
            case $6fb9842575b03497$var$CLOSE_CURLY$1:
            case $6fb9842575b03497$var$COLON$1:
            case $6fb9842575b03497$var$SEMICOLON$1:
            case $6fb9842575b03497$var$CLOSE_PARENTHESES$1:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $6fb9842575b03497$var$OPEN_PARENTHESES$1:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $6fb9842575b03497$var$SINGLE_QUOTE$1 && n2 !== $6fb9842575b03497$var$DOUBLE_QUOTE$1 && n2 !== $6fb9842575b03497$var$SPACE$1 && n2 !== $6fb9842575b03497$var$NEWLINE$1 && n2 !== $6fb9842575b03497$var$TAB$1 && n2 !== $6fb9842575b03497$var$FEED$1 && n2 !== $6fb9842575b03497$var$CR$1) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $6fb9842575b03497$var$BACKSLASH$1){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $6fb9842575b03497$var$RE_BAD_BRACKET$1.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $6fb9842575b03497$var$SINGLE_QUOTE$1:
            case $6fb9842575b03497$var$DOUBLE_QUOTE$1:
                quote = code === $6fb9842575b03497$var$SINGLE_QUOTE$1 ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $6fb9842575b03497$var$BACKSLASH$1){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $6fb9842575b03497$var$AT$1:
                $6fb9842575b03497$var$RE_AT_END$1.lastIndex = pos + 1;
                $6fb9842575b03497$var$RE_AT_END$1.test(css);
                if ($6fb9842575b03497$var$RE_AT_END$1.lastIndex === 0) next = css.length - 1;
                else next = $6fb9842575b03497$var$RE_AT_END$1.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $6fb9842575b03497$var$BACKSLASH$1:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $6fb9842575b03497$var$BACKSLASH$1){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $6fb9842575b03497$var$SLASH$1 && code !== $6fb9842575b03497$var$SPACE$1 && code !== $6fb9842575b03497$var$NEWLINE$1 && code !== $6fb9842575b03497$var$TAB$1 && code !== $6fb9842575b03497$var$CR$1 && code !== $6fb9842575b03497$var$FEED$1) {
                    next += 1;
                    if ($6fb9842575b03497$var$RE_HEX_ESCAPE$1.test(css.charAt(next))) {
                        while($6fb9842575b03497$var$RE_HEX_ESCAPE$1.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $6fb9842575b03497$var$SPACE$1) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $6fb9842575b03497$var$SLASH$1 && css.charCodeAt(pos + 1) === $6fb9842575b03497$var$ASTERISK$1) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $6fb9842575b03497$var$RE_WORD_END$1.lastIndex = pos + 1;
                    $6fb9842575b03497$var$RE_WORD_END$1.test(css);
                    if ($6fb9842575b03497$var$RE_WORD_END$1.lastIndex === 0) next = css.length - 1;
                    else next = $6fb9842575b03497$var$RE_WORD_END$1.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $6fb9842575b03497$var$Container$5$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$AtRule$3$1 = /*#__PURE__*/ function(Container$5$1) {
    $6fb9842575b03497$var$_inherits(AtRule, Container$5$1);
    function AtRule(defaults) {
        var _this;
        _this = Container$5$1.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_append = Container$5$1.prototype.append).call.apply(_Container$5$1_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_prepend = Container$5$1.prototype.prepend).call.apply(_Container$5$1_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule;
}($6fb9842575b03497$var$Container$5$1);
var $6fb9842575b03497$var$atRule$1 = $6fb9842575b03497$var$AtRule$3$1;
$6fb9842575b03497$var$AtRule$3$1.default = $6fb9842575b03497$var$AtRule$3$1;
$6fb9842575b03497$var$Container$5$1.registerAtRule($6fb9842575b03497$var$AtRule$3$1);
var $6fb9842575b03497$var$Container$4$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$LazyResult$3$1, $6fb9842575b03497$var$Processor$2$1;
var $6fb9842575b03497$var$Root$5$1 = /*#__PURE__*/ function(Container$4$1) {
    $6fb9842575b03497$var$_inherits(Root, Container$4$1);
    function Root(defaults) {
        var _this;
        _this = Container$4$1.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4$1.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4$1.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $6fb9842575b03497$var$LazyResult$3$1(new $6fb9842575b03497$var$Processor$2$1(), this, opts);
        return lazy.stringify();
    };
    return Root;
}($6fb9842575b03497$var$Container$4$1);
$6fb9842575b03497$var$Root$5$1.registerLazyResult = function(dependant) {
    $6fb9842575b03497$var$LazyResult$3$1 = dependant;
};
$6fb9842575b03497$var$Root$5$1.registerProcessor = function(dependant) {
    $6fb9842575b03497$var$Processor$2$1 = dependant;
};
var $6fb9842575b03497$var$root$1 = $6fb9842575b03497$var$Root$5$1;
$6fb9842575b03497$var$Root$5$1.default = $6fb9842575b03497$var$Root$5$1;
$6fb9842575b03497$var$Container$4$1.registerRoot($6fb9842575b03497$var$Root$5$1);
var $6fb9842575b03497$var$list$2$1 = {
    comma: function comma(string) {
        return $6fb9842575b03497$var$list$2$1.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $6fb9842575b03497$var$list$2$1.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $6fb9842575b03497$var$list_1$1 = $6fb9842575b03497$var$list$2$1;
$6fb9842575b03497$var$list$2$1.default = $6fb9842575b03497$var$list$2$1;
var $6fb9842575b03497$var$Container$3$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$list$1$1 = $6fb9842575b03497$var$list_1$1;
var $6fb9842575b03497$var$Rule$3$1 = /*#__PURE__*/ function(Container$3$1) {
    $6fb9842575b03497$var$_inherits(Rule, Container$3$1);
    function Rule(defaults) {
        var _this;
        _this = Container$3$1.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $6fb9842575b03497$var$_create_class(Rule, [
        {
            key: "selectors",
            get: function get() {
                return $6fb9842575b03497$var$list$1$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule;
}($6fb9842575b03497$var$Container$3$1);
var $6fb9842575b03497$var$rule$1 = $6fb9842575b03497$var$Rule$3$1;
$6fb9842575b03497$var$Rule$3$1.default = $6fb9842575b03497$var$Rule$3$1;
$6fb9842575b03497$var$Container$3$1.registerRule($6fb9842575b03497$var$Rule$3$1);
var $6fb9842575b03497$var$Declaration$2$1 = $6fb9842575b03497$var$declaration$1;
var $6fb9842575b03497$var$tokenizer2$1 = $6fb9842575b03497$var$tokenize$1;
var $6fb9842575b03497$var$Comment$2$1 = $6fb9842575b03497$var$comment$1;
var $6fb9842575b03497$var$AtRule$2$1 = $6fb9842575b03497$var$atRule$1;
var $6fb9842575b03497$var$Root$4$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$Rule$2$1 = $6fb9842575b03497$var$rule$1;
var $6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR$1 = {
    empty: true,
    space: true
};
function $6fb9842575b03497$var$findLastWithPosition$1(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $6fb9842575b03497$var$Parser$1$1 = /*#__PURE__*/ function() {
    function Parser(input2) {
        this.input = input2;
        this.root = new $6fb9842575b03497$var$Root$4$1();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $6fb9842575b03497$var$AtRule$2$1();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $6fb9842575b03497$var$Comment$2$1();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $6fb9842575b03497$var$tokenizer2$1(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $6fb9842575b03497$var$Declaration$2$1();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $6fb9842575b03497$var$findLastWithPosition$1(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $6fb9842575b03497$var$Rule$2$1();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR$1[prev] && !$6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR$1[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $6fb9842575b03497$var$Rule$2$1();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser;
}();
var $6fb9842575b03497$var$parser$1 = $6fb9842575b03497$var$Parser$1$1;
var $6fb9842575b03497$var$Container$2$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$Parser2$1 = $6fb9842575b03497$var$parser$1;
var $6fb9842575b03497$var$Input$2$1 = $6fb9842575b03497$var$input$1;
function $6fb9842575b03497$var$parse$3$1(css, opts) {
    var input2 = new $6fb9842575b03497$var$Input$2$1(css, opts);
    var parser2 = new $6fb9842575b03497$var$Parser2$1(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $6fb9842575b03497$var$parse_1$1 = $6fb9842575b03497$var$parse$3$1;
$6fb9842575b03497$var$parse$3$1.default = $6fb9842575b03497$var$parse$3$1;
$6fb9842575b03497$var$Container$2$1.registerParse($6fb9842575b03497$var$parse$3$1);
var $6fb9842575b03497$var$isClean$3 = $6fb9842575b03497$var$symbols$1.isClean, $6fb9842575b03497$var$my$3 = $6fb9842575b03497$var$symbols$1.my;
var $6fb9842575b03497$var$MapGenerator$1$1 = $6fb9842575b03497$var$mapGenerator$1;
var $6fb9842575b03497$var$stringify$2$1 = $6fb9842575b03497$var$stringify_1$1;
var $6fb9842575b03497$var$Container$1$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$Document$2$1 = $6fb9842575b03497$var$document$1$1;
var $6fb9842575b03497$var$warnOnce$1$1 = $6fb9842575b03497$var$warnOnce$2$1;
var $6fb9842575b03497$var$Result$2$1 = $6fb9842575b03497$var$result$1;
var $6fb9842575b03497$var$parse$2$1 = $6fb9842575b03497$var$parse_1$1;
var $6fb9842575b03497$var$Root$3$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$TYPE_TO_CLASS_NAME$1 = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $6fb9842575b03497$var$PLUGIN_PROPS$1 = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $6fb9842575b03497$var$NOT_VISITORS$1 = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $6fb9842575b03497$var$CHILDREN$1 = 0;
function $6fb9842575b03497$var$isPromise$1(obj) {
    return (typeof obj === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $6fb9842575b03497$var$getEvents$1(node2) {
    var key = false;
    var type = $6fb9842575b03497$var$TYPE_TO_CLASS_NAME$1[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $6fb9842575b03497$var$CHILDREN$1,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $6fb9842575b03497$var$CHILDREN$1,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $6fb9842575b03497$var$toStack$1(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $6fb9842575b03497$var$CHILDREN$1,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $6fb9842575b03497$var$CHILDREN$1,
        "RootExit"
    ];
    else events = $6fb9842575b03497$var$getEvents$1(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $6fb9842575b03497$var$cleanMarks$1(node2) {
    node2[$6fb9842575b03497$var$isClean$3] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $6fb9842575b03497$var$cleanMarks$1(i2);
    });
    return node2;
}
var $6fb9842575b03497$var$postcss$2$1 = {};
var $6fb9842575b03497$var$LazyResult$2$1 = /*#__PURE__*/ function() {
    function LazyResult(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $6fb9842575b03497$var$cleanMarks$1(css);
        else if ($6fb9842575b03497$var$_instanceof(css, LazyResult) || $6fb9842575b03497$var$_instanceof(css, $6fb9842575b03497$var$Result$2$1)) {
            root2 = $6fb9842575b03497$var$cleanMarks$1(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $6fb9842575b03497$var$parse$2$1;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$6fb9842575b03497$var$my$3]) $6fb9842575b03497$var$Container$1$1.rebuild(root2);
        }
        this.result = new $6fb9842575b03497$var$Result$2$1(processor2, root2, opts);
        this.helpers = $6fb9842575b03497$var$_extends({}, $6fb9842575b03497$var$postcss$2$1, {
            postcss: $6fb9842575b03497$var$postcss$2$1,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $6fb9842575b03497$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$6fb9842575b03497$var$PLUGIN_PROPS$1[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$6fb9842575b03497$var$NOT_VISITORS$1[event]) {
                    if ($6fb9842575b03497$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $6fb9842575b03497$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$6fb9842575b03497$var$isPromise$1(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$6fb9842575b03497$var$isClean$3]) return [
                            3,
                            14
                        ];
                        root2[$6fb9842575b03497$var$isClean$3] = true;
                        stack = [
                            $6fb9842575b03497$var$toStack$1(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$6fb9842575b03497$var$isPromise$1(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $6fb9842575b03497$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($6fb9842575b03497$var$isPromise$1(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $6fb9842575b03497$var$stringify$2$1;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $6fb9842575b03497$var$MapGenerator$1$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($6fb9842575b03497$var$isPromise$1(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$6fb9842575b03497$var$isClean$3]){
                root2[$6fb9842575b03497$var$isClean$3] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($6fb9842575b03497$var$isPromise$1(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$6fb9842575b03497$var$isClean$3]) {
                    child[$6fb9842575b03497$var$isClean$3] = true;
                    stack.push($6fb9842575b03497$var$toStack$1(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $6fb9842575b03497$var$CHILDREN$1) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$6fb9842575b03497$var$isClean$3] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$6fb9842575b03497$var$isClean$3] = true;
        var events = $6fb9842575b03497$var$getEvents$1(node2);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $6fb9842575b03497$var$CHILDREN$1) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$6fb9842575b03497$var$isClean$3]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $6fb9842575b03497$var$_create_class(LazyResult, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult;
}();
$6fb9842575b03497$var$LazyResult$2$1.registerPostcss = function(dependant) {
    $6fb9842575b03497$var$postcss$2$1 = dependant;
};
var $6fb9842575b03497$var$lazyResult$1 = $6fb9842575b03497$var$LazyResult$2$1;
$6fb9842575b03497$var$LazyResult$2$1.default = $6fb9842575b03497$var$LazyResult$2$1;
$6fb9842575b03497$var$Root$3$1.registerLazyResult($6fb9842575b03497$var$LazyResult$2$1);
$6fb9842575b03497$var$Document$2$1.registerLazyResult($6fb9842575b03497$var$LazyResult$2$1);
var $6fb9842575b03497$var$MapGenerator2$1 = $6fb9842575b03497$var$mapGenerator$1;
var $6fb9842575b03497$var$stringify$1$1 = $6fb9842575b03497$var$stringify_1$1;
var $6fb9842575b03497$var$warnOnce2$1 = $6fb9842575b03497$var$warnOnce$2$1;
var $6fb9842575b03497$var$parse$1$1 = $6fb9842575b03497$var$parse_1$1;
var $6fb9842575b03497$var$Result$1$1 = $6fb9842575b03497$var$result$1;
var $6fb9842575b03497$var$NoWorkResult$1$1 = /*#__PURE__*/ function() {
    function NoWorkResult(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $6fb9842575b03497$var$stringify$1$1;
        this.result = new $6fb9842575b03497$var$Result$1$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $6fb9842575b03497$var$MapGenerator2$1(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $6fb9842575b03497$var$_create_class(NoWorkResult, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $6fb9842575b03497$var$parse$1$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult;
}();
var $6fb9842575b03497$var$noWorkResult$1 = $6fb9842575b03497$var$NoWorkResult$1$1;
$6fb9842575b03497$var$NoWorkResult$1$1.default = $6fb9842575b03497$var$NoWorkResult$1$1;
var $6fb9842575b03497$var$NoWorkResult2$1 = $6fb9842575b03497$var$noWorkResult$1;
var $6fb9842575b03497$var$LazyResult$1$1 = $6fb9842575b03497$var$lazyResult$1;
var $6fb9842575b03497$var$Document$1$1 = $6fb9842575b03497$var$document$1$1;
var $6fb9842575b03497$var$Root$2$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$Processor$1$1 = /*#__PURE__*/ function() {
    function Processor(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $6fb9842575b03497$var$NoWorkResult2$1(this, css, opts);
        else return new $6fb9842575b03497$var$LazyResult$1$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor;
}();
var $6fb9842575b03497$var$processor$1 = $6fb9842575b03497$var$Processor$1$1;
$6fb9842575b03497$var$Processor$1$1.default = $6fb9842575b03497$var$Processor$1$1;
$6fb9842575b03497$var$Root$2$1.registerProcessor($6fb9842575b03497$var$Processor$1$1);
$6fb9842575b03497$var$Document$1$1.registerProcessor($6fb9842575b03497$var$Processor$1$1);
var $6fb9842575b03497$var$Declaration$1$1 = $6fb9842575b03497$var$declaration$1;
var $6fb9842575b03497$var$PreviousMap2$1 = $6fb9842575b03497$var$previousMap$1;
var $6fb9842575b03497$var$Comment$1$1 = $6fb9842575b03497$var$comment$1;
var $6fb9842575b03497$var$AtRule$1$1 = $6fb9842575b03497$var$atRule$1;
var $6fb9842575b03497$var$Input$1$1 = $6fb9842575b03497$var$input$1;
var $6fb9842575b03497$var$Root$1$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$Rule$1$1 = $6fb9842575b03497$var$rule$1;
function $6fb9842575b03497$var$fromJSON$1$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $6fb9842575b03497$var$fromJSON$1$1(n2);
    });
    var ownInputs = json.inputs, defaults = $6fb9842575b03497$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $6fb9842575b03497$var$_extends({}, input2, {
                __proto__: $6fb9842575b03497$var$Input$1$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $6fb9842575b03497$var$_extends({}, inputHydrated.map, {
                __proto__: $6fb9842575b03497$var$PreviousMap2$1.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $6fb9842575b03497$var$fromJSON$1$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $6fb9842575b03497$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $6fb9842575b03497$var$Root$1$1(defaults);
    else if (defaults.type === "decl") return new $6fb9842575b03497$var$Declaration$1$1(defaults);
    else if (defaults.type === "rule") return new $6fb9842575b03497$var$Rule$1$1(defaults);
    else if (defaults.type === "comment") return new $6fb9842575b03497$var$Comment$1$1(defaults);
    else if (defaults.type === "atrule") return new $6fb9842575b03497$var$AtRule$1$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $6fb9842575b03497$var$fromJSON_1$1 = $6fb9842575b03497$var$fromJSON$1$1;
$6fb9842575b03497$var$fromJSON$1$1.default = $6fb9842575b03497$var$fromJSON$1$1;
var $6fb9842575b03497$var$CssSyntaxError2$1 = $6fb9842575b03497$var$cssSyntaxError$1;
var $6fb9842575b03497$var$Declaration2$1 = $6fb9842575b03497$var$declaration$1;
var $6fb9842575b03497$var$LazyResult2$1 = $6fb9842575b03497$var$lazyResult$1;
var $6fb9842575b03497$var$Container2$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$Processor2$1 = $6fb9842575b03497$var$processor$1;
var $6fb9842575b03497$var$stringify$5 = $6fb9842575b03497$var$stringify_1$1;
var $6fb9842575b03497$var$fromJSON$2 = $6fb9842575b03497$var$fromJSON_1$1;
var $6fb9842575b03497$var$Document22 = $6fb9842575b03497$var$document$1$1;
var $6fb9842575b03497$var$Warning2$1 = $6fb9842575b03497$var$warning$1;
var $6fb9842575b03497$var$Comment2$1 = $6fb9842575b03497$var$comment$1;
var $6fb9842575b03497$var$AtRule2$1 = $6fb9842575b03497$var$atRule$1;
var $6fb9842575b03497$var$Result2$1 = $6fb9842575b03497$var$result$1;
var $6fb9842575b03497$var$Input2$1 = $6fb9842575b03497$var$input$1;
var $6fb9842575b03497$var$parse$5 = $6fb9842575b03497$var$parse_1$1;
var $6fb9842575b03497$var$list$3 = $6fb9842575b03497$var$list_1$1;
var $6fb9842575b03497$var$Rule2$1 = $6fb9842575b03497$var$rule$1;
var $6fb9842575b03497$var$Root2$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$Node2$1 = $6fb9842575b03497$var$node$1;
function $6fb9842575b03497$var$postcss$3() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $6fb9842575b03497$var$Processor2$1(plugins);
}
$6fb9842575b03497$var$postcss$3.plugin = function plugin(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $6fb9842575b03497$var$Processor2$1().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $6fb9842575b03497$var$postcss$3([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$6fb9842575b03497$var$postcss$3.stringify = $6fb9842575b03497$var$stringify$5;
$6fb9842575b03497$var$postcss$3.parse = $6fb9842575b03497$var$parse$5;
$6fb9842575b03497$var$postcss$3.fromJSON = $6fb9842575b03497$var$fromJSON$2;
$6fb9842575b03497$var$postcss$3.list = $6fb9842575b03497$var$list$3;
$6fb9842575b03497$var$postcss$3.comment = function(defaults) {
    return new $6fb9842575b03497$var$Comment2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.atRule = function(defaults) {
    return new $6fb9842575b03497$var$AtRule2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.decl = function(defaults) {
    return new $6fb9842575b03497$var$Declaration2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.rule = function(defaults) {
    return new $6fb9842575b03497$var$Rule2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.root = function(defaults) {
    return new $6fb9842575b03497$var$Root2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.document = function(defaults) {
    return new $6fb9842575b03497$var$Document22(defaults);
};
$6fb9842575b03497$var$postcss$3.CssSyntaxError = $6fb9842575b03497$var$CssSyntaxError2$1;
$6fb9842575b03497$var$postcss$3.Declaration = $6fb9842575b03497$var$Declaration2$1;
$6fb9842575b03497$var$postcss$3.Container = $6fb9842575b03497$var$Container2$1;
$6fb9842575b03497$var$postcss$3.Processor = $6fb9842575b03497$var$Processor2$1;
$6fb9842575b03497$var$postcss$3.Document = $6fb9842575b03497$var$Document22;
$6fb9842575b03497$var$postcss$3.Comment = $6fb9842575b03497$var$Comment2$1;
$6fb9842575b03497$var$postcss$3.Warning = $6fb9842575b03497$var$Warning2$1;
$6fb9842575b03497$var$postcss$3.AtRule = $6fb9842575b03497$var$AtRule2$1;
$6fb9842575b03497$var$postcss$3.Result = $6fb9842575b03497$var$Result2$1;
$6fb9842575b03497$var$postcss$3.Input = $6fb9842575b03497$var$Input2$1;
$6fb9842575b03497$var$postcss$3.Rule = $6fb9842575b03497$var$Rule2$1;
$6fb9842575b03497$var$postcss$3.Root = $6fb9842575b03497$var$Root2$1;
$6fb9842575b03497$var$postcss$3.Node = $6fb9842575b03497$var$Node2$1;
$6fb9842575b03497$var$LazyResult2$1.registerPostcss($6fb9842575b03497$var$postcss$3);
var $6fb9842575b03497$var$postcss_1$1 = $6fb9842575b03497$var$postcss$3;
$6fb9842575b03497$var$postcss$3.default = $6fb9842575b03497$var$postcss$3;
var $6fb9842575b03497$var$postcss$1$1 = /* @__PURE__ */ $6fb9842575b03497$var$getDefaultExportFromCjs$1($6fb9842575b03497$var$postcss_1$1);
$6fb9842575b03497$var$postcss$1$1.stringify;
$6fb9842575b03497$var$postcss$1$1.fromJSON;
$6fb9842575b03497$var$postcss$1$1.plugin;
$6fb9842575b03497$var$postcss$1$1.parse;
$6fb9842575b03497$var$postcss$1$1.list;
$6fb9842575b03497$var$postcss$1$1.document;
$6fb9842575b03497$var$postcss$1$1.comment;
$6fb9842575b03497$var$postcss$1$1.atRule;
$6fb9842575b03497$var$postcss$1$1.rule;
$6fb9842575b03497$var$postcss$1$1.decl;
$6fb9842575b03497$var$postcss$1$1.root;
$6fb9842575b03497$var$postcss$1$1.CssSyntaxError;
$6fb9842575b03497$var$postcss$1$1.Declaration;
$6fb9842575b03497$var$postcss$1$1.Container;
$6fb9842575b03497$var$postcss$1$1.Processor;
$6fb9842575b03497$var$postcss$1$1.Document;
$6fb9842575b03497$var$postcss$1$1.Comment;
$6fb9842575b03497$var$postcss$1$1.Warning;
$6fb9842575b03497$var$postcss$1$1.AtRule;
$6fb9842575b03497$var$postcss$1$1.Result;
$6fb9842575b03497$var$postcss$1$1.Input;
$6fb9842575b03497$var$postcss$1$1.Rule;
$6fb9842575b03497$var$postcss$1$1.Root;
$6fb9842575b03497$var$postcss$1$1.Node;
var $6fb9842575b03497$var$__defProp2 = Object.defineProperty;
var $6fb9842575b03497$var$__defNormalProp2 = function(obj, key, value) {
    return key in obj ? $6fb9842575b03497$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $6fb9842575b03497$var$__publicField2 = function(obj, key, value) {
    return $6fb9842575b03497$var$__defNormalProp2(obj, (typeof key === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
function $6fb9842575b03497$var$getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $6fb9842575b03497$var$getAugmentedNamespace(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($6fb9842575b03497$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $6fb9842575b03497$var$picocolors_browser = {
    exports: {}
};
var $6fb9842575b03497$var$x = String;
var $6fb9842575b03497$var$create = function create() {
    return {
        isColorSupported: false,
        reset: $6fb9842575b03497$var$x,
        bold: $6fb9842575b03497$var$x,
        dim: $6fb9842575b03497$var$x,
        italic: $6fb9842575b03497$var$x,
        underline: $6fb9842575b03497$var$x,
        inverse: $6fb9842575b03497$var$x,
        hidden: $6fb9842575b03497$var$x,
        strikethrough: $6fb9842575b03497$var$x,
        black: $6fb9842575b03497$var$x,
        red: $6fb9842575b03497$var$x,
        green: $6fb9842575b03497$var$x,
        yellow: $6fb9842575b03497$var$x,
        blue: $6fb9842575b03497$var$x,
        magenta: $6fb9842575b03497$var$x,
        cyan: $6fb9842575b03497$var$x,
        white: $6fb9842575b03497$var$x,
        gray: $6fb9842575b03497$var$x,
        bgBlack: $6fb9842575b03497$var$x,
        bgRed: $6fb9842575b03497$var$x,
        bgGreen: $6fb9842575b03497$var$x,
        bgYellow: $6fb9842575b03497$var$x,
        bgBlue: $6fb9842575b03497$var$x,
        bgMagenta: $6fb9842575b03497$var$x,
        bgCyan: $6fb9842575b03497$var$x,
        bgWhite: $6fb9842575b03497$var$x
    };
};
$6fb9842575b03497$var$picocolors_browser.exports = $6fb9842575b03497$var$create();
$6fb9842575b03497$var$picocolors_browser.exports.createColors = $6fb9842575b03497$var$create;
var $6fb9842575b03497$var$picocolors_browserExports = $6fb9842575b03497$var$picocolors_browser.exports;
var $6fb9842575b03497$var$__viteBrowserExternal = {};
var $6fb9842575b03497$var$__viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $6fb9842575b03497$var$__viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
var $6fb9842575b03497$var$require$$2 = /* @__PURE__ */ $6fb9842575b03497$var$getAugmentedNamespace($6fb9842575b03497$var$__viteBrowserExternal$1);
var $6fb9842575b03497$var$pico = $6fb9842575b03497$var$picocolors_browserExports;
var $6fb9842575b03497$var$terminalHighlight$1 = $6fb9842575b03497$var$require$$2;
var $6fb9842575b03497$var$CssSyntaxError$3 = /*#__PURE__*/ function(Error1) {
    $6fb9842575b03497$var$_inherits(CssSyntaxError2, Error1);
    function CssSyntaxError2(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError2);
        return _this;
    }
    var _proto = CssSyntaxError2.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $6fb9842575b03497$var$pico.isColorSupported;
        if ($6fb9842575b03497$var$terminalHighlight$1) {
            if (color) css = $6fb9842575b03497$var$terminalHighlight$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico_createColors = $6fb9842575b03497$var$pico.createColors(true), bold = _pico_createColors.bold, gray = _pico_createColors.gray, red = _pico_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError2;
}($6fb9842575b03497$var$_wrap_native_super(Error));
var $6fb9842575b03497$var$cssSyntaxError = $6fb9842575b03497$var$CssSyntaxError$3;
$6fb9842575b03497$var$CssSyntaxError$3.default = $6fb9842575b03497$var$CssSyntaxError$3;
var $6fb9842575b03497$var$symbols = {};
$6fb9842575b03497$var$symbols.isClean = Symbol("isClean");
$6fb9842575b03497$var$symbols.my = Symbol("my");
var $6fb9842575b03497$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $6fb9842575b03497$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $6fb9842575b03497$var$Stringifier$2 = /*#__PURE__*/ function() {
    function Stringifier2(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier2.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $6fb9842575b03497$var$DEFAULT_RAW[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $6fb9842575b03497$var$capitalize(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $6fb9842575b03497$var$DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier2;
}();
var $6fb9842575b03497$var$stringifier = $6fb9842575b03497$var$Stringifier$2;
$6fb9842575b03497$var$Stringifier$2.default = $6fb9842575b03497$var$Stringifier$2;
var $6fb9842575b03497$var$Stringifier$1 = $6fb9842575b03497$var$stringifier;
function $6fb9842575b03497$var$stringify$4(node2, builder) {
    var str = new $6fb9842575b03497$var$Stringifier$1(builder);
    str.stringify(node2);
}
var $6fb9842575b03497$var$stringify_1 = $6fb9842575b03497$var$stringify$4;
$6fb9842575b03497$var$stringify$4.default = $6fb9842575b03497$var$stringify$4;
var $6fb9842575b03497$var$isClean$2 = $6fb9842575b03497$var$symbols.isClean, $6fb9842575b03497$var$my$2 = $6fb9842575b03497$var$symbols.my;
var $6fb9842575b03497$var$CssSyntaxError$2 = $6fb9842575b03497$var$cssSyntaxError;
var $6fb9842575b03497$var$Stringifier22 = $6fb9842575b03497$var$stringifier;
var $6fb9842575b03497$var$stringify$3 = $6fb9842575b03497$var$stringify_1;
function $6fb9842575b03497$var$cloneNode(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $6fb9842575b03497$var$cloneNode(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $6fb9842575b03497$var$cloneNode(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $6fb9842575b03497$var$Node$4 = /*#__PURE__*/ function() {
    function Node3(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$6fb9842575b03497$var$isClean$2] = false;
        this[$6fb9842575b03497$var$my$2] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node3.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $6fb9842575b03497$var$cloneNode(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $6fb9842575b03497$var$CssSyntaxError$2(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$6fb9842575b03497$var$isClean$2]) {
            this[$6fb9842575b03497$var$isClean$2] = false;
            var next = this;
            while(next = next.parent)next[$6fb9842575b03497$var$isClean$2] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $6fb9842575b03497$var$Stringifier22();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $6fb9842575b03497$var$stringify$3;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $6fb9842575b03497$var$_create_class(Node3, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node3;
}();
var $6fb9842575b03497$var$node = $6fb9842575b03497$var$Node$4;
$6fb9842575b03497$var$Node$4.default = $6fb9842575b03497$var$Node$4;
var $6fb9842575b03497$var$Node$3 = $6fb9842575b03497$var$node;
var $6fb9842575b03497$var$Declaration$4 = /*#__PURE__*/ function(Node$3) {
    $6fb9842575b03497$var$_inherits(Declaration2, Node$3);
    function Declaration2(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $6fb9842575b03497$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $6fb9842575b03497$var$_create_class(Declaration2, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration2;
}($6fb9842575b03497$var$Node$3);
var $6fb9842575b03497$var$declaration = $6fb9842575b03497$var$Declaration$4;
$6fb9842575b03497$var$Declaration$4.default = $6fb9842575b03497$var$Declaration$4;
var $6fb9842575b03497$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $6fb9842575b03497$var$nanoid$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $6fb9842575b03497$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
var $6fb9842575b03497$var$nonSecure = {
    nanoid: $6fb9842575b03497$var$nanoid$1
};
var $6fb9842575b03497$var$SourceMapConsumer$2 = $6fb9842575b03497$var$require$$2.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$2 = $6fb9842575b03497$var$require$$2.SourceMapGenerator;
var $6fb9842575b03497$var$existsSync = $6fb9842575b03497$var$require$$2.existsSync, $6fb9842575b03497$var$readFileSync = $6fb9842575b03497$var$require$$2.readFileSync;
var $6fb9842575b03497$var$dirname$1 = $6fb9842575b03497$var$require$$2.dirname, $6fb9842575b03497$var$join = $6fb9842575b03497$var$require$$2.join;
function $6fb9842575b03497$var$fromBase64(str) {
    if ($6fb9842575b03497$require$Buffer) return $6fb9842575b03497$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $6fb9842575b03497$var$PreviousMap$2 = /*#__PURE__*/ function() {
    function PreviousMap2(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $6fb9842575b03497$var$dirname$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap2.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $6fb9842575b03497$var$SourceMapConsumer$2(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $6fb9842575b03497$var$fromBase64(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $6fb9842575b03497$var$dirname$1(path);
        if ($6fb9842575b03497$var$existsSync(path)) {
            this.mapFile = path;
            return $6fb9842575b03497$var$readFileSync(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($6fb9842575b03497$var$_instanceof(prev, $6fb9842575b03497$var$SourceMapConsumer$2)) return $6fb9842575b03497$var$SourceMapGenerator$2.fromSourceMap(prev).toString();
            else if ($6fb9842575b03497$var$_instanceof(prev, $6fb9842575b03497$var$SourceMapGenerator$2)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $6fb9842575b03497$var$join($6fb9842575b03497$var$dirname$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap2;
}();
var $6fb9842575b03497$var$previousMap = $6fb9842575b03497$var$PreviousMap$2;
$6fb9842575b03497$var$PreviousMap$2.default = $6fb9842575b03497$var$PreviousMap$2;
var $6fb9842575b03497$var$SourceMapConsumer$1 = $6fb9842575b03497$var$require$$2.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$1 = $6fb9842575b03497$var$require$$2.SourceMapGenerator;
var $6fb9842575b03497$var$fileURLToPath = $6fb9842575b03497$var$require$$2.fileURLToPath, $6fb9842575b03497$var$pathToFileURL$1 = $6fb9842575b03497$var$require$$2.pathToFileURL;
var $6fb9842575b03497$var$isAbsolute = $6fb9842575b03497$var$require$$2.isAbsolute, $6fb9842575b03497$var$resolve$1 = $6fb9842575b03497$var$require$$2.resolve;
var $6fb9842575b03497$var$nanoid = $6fb9842575b03497$var$nonSecure.nanoid;
var $6fb9842575b03497$var$terminalHighlight = $6fb9842575b03497$var$require$$2;
var $6fb9842575b03497$var$CssSyntaxError$1 = $6fb9842575b03497$var$cssSyntaxError;
var $6fb9842575b03497$var$PreviousMap$1 = $6fb9842575b03497$var$previousMap;
var $6fb9842575b03497$var$fromOffsetCache = Symbol("fromOffsetCache");
var $6fb9842575b03497$var$sourceMapAvailable$1 = Boolean($6fb9842575b03497$var$SourceMapConsumer$1 && $6fb9842575b03497$var$SourceMapGenerator$1);
var $6fb9842575b03497$var$pathAvailable$1 = Boolean($6fb9842575b03497$var$resolve$1 && $6fb9842575b03497$var$isAbsolute);
var $6fb9842575b03497$var$Input$4 = /*#__PURE__*/ function() {
    function Input2(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$6fb9842575b03497$var$pathAvailable$1 || /^\w+:\/\//.test(opts.from) || $6fb9842575b03497$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $6fb9842575b03497$var$resolve$1(opts.from);
        }
        if ($6fb9842575b03497$var$pathAvailable$1 && $6fb9842575b03497$var$sourceMapAvailable$1) {
            var map = new $6fb9842575b03497$var$PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $6fb9842575b03497$var$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input2.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $6fb9842575b03497$var$CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $6fb9842575b03497$var$CssSyntaxError$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($6fb9842575b03497$var$pathToFileURL$1) result2.input.url = $6fb9842575b03497$var$pathToFileURL$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$6fb9842575b03497$var$fromOffsetCache]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$6fb9842575b03497$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$6fb9842575b03497$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $6fb9842575b03497$var$resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($6fb9842575b03497$var$isAbsolute(from.source)) fromUrl = $6fb9842575b03497$var$pathToFileURL$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $6fb9842575b03497$var$pathToFileURL$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($6fb9842575b03497$var$fileURLToPath) result2.file = $6fb9842575b03497$var$fileURLToPath(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $6fb9842575b03497$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $6fb9842575b03497$var$_create_class(Input2, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input2;
}();
var $6fb9842575b03497$var$input = $6fb9842575b03497$var$Input$4;
$6fb9842575b03497$var$Input$4.default = $6fb9842575b03497$var$Input$4;
if ($6fb9842575b03497$var$terminalHighlight && $6fb9842575b03497$var$terminalHighlight.registerInput) $6fb9842575b03497$var$terminalHighlight.registerInput($6fb9842575b03497$var$Input$4);
var $6fb9842575b03497$var$SourceMapConsumer = $6fb9842575b03497$var$require$$2.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator = $6fb9842575b03497$var$require$$2.SourceMapGenerator;
var $6fb9842575b03497$var$dirname = $6fb9842575b03497$var$require$$2.dirname, $6fb9842575b03497$var$relative = $6fb9842575b03497$var$require$$2.relative, $6fb9842575b03497$var$resolve$3 = $6fb9842575b03497$var$require$$2.resolve, $6fb9842575b03497$var$sep = $6fb9842575b03497$var$require$$2.sep;
var $6fb9842575b03497$var$pathToFileURL = $6fb9842575b03497$var$require$$2.pathToFileURL;
var $6fb9842575b03497$var$Input$3 = $6fb9842575b03497$var$input;
var $6fb9842575b03497$var$sourceMapAvailable = Boolean($6fb9842575b03497$var$SourceMapConsumer && $6fb9842575b03497$var$SourceMapGenerator);
var $6fb9842575b03497$var$pathAvailable = Boolean($6fb9842575b03497$var$dirname && $6fb9842575b03497$var$resolve$3 && $6fb9842575b03497$var$relative && $6fb9842575b03497$var$sep);
var $6fb9842575b03497$var$MapGenerator$2 = /*#__PURE__*/ function() {
    function MapGenerator2(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator2.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $6fb9842575b03497$var$dirname(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $6fb9842575b03497$var$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($6fb9842575b03497$var$pathAvailable && $6fb9842575b03497$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $6fb9842575b03497$var$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $6fb9842575b03497$var$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $6fb9842575b03497$var$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $6fb9842575b03497$var$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $6fb9842575b03497$var$dirname($6fb9842575b03497$var$resolve$3(from, this.mapOpts.annotation));
        var path = $6fb9842575b03497$var$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $6fb9842575b03497$var$Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($6fb9842575b03497$require$Buffer) return $6fb9842575b03497$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($6fb9842575b03497$var$pathToFileURL) {
            var fileURL = $6fb9842575b03497$var$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($6fb9842575b03497$var$sep === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator2;
}();
var $6fb9842575b03497$var$mapGenerator = $6fb9842575b03497$var$MapGenerator$2;
var $6fb9842575b03497$var$Node$2 = $6fb9842575b03497$var$node;
var $6fb9842575b03497$var$Comment$4 = /*#__PURE__*/ function(Node$2) {
    $6fb9842575b03497$var$_inherits(Comment2, Node$2);
    function Comment2(defaults) {
        var _this;
        _this = Node$2.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment2;
}($6fb9842575b03497$var$Node$2);
var $6fb9842575b03497$var$comment = $6fb9842575b03497$var$Comment$4;
$6fb9842575b03497$var$Comment$4.default = $6fb9842575b03497$var$Comment$4;
var $6fb9842575b03497$var$isClean$1 = $6fb9842575b03497$var$symbols.isClean, $6fb9842575b03497$var$my$1 = $6fb9842575b03497$var$symbols.my;
var $6fb9842575b03497$var$Declaration$3 = $6fb9842575b03497$var$declaration;
var $6fb9842575b03497$var$Comment$3 = $6fb9842575b03497$var$comment;
var $6fb9842575b03497$var$Node$1 = $6fb9842575b03497$var$node;
var $6fb9842575b03497$var$parse$4, $6fb9842575b03497$var$Rule$4, $6fb9842575b03497$var$AtRule$4, $6fb9842575b03497$var$Root$6;
function $6fb9842575b03497$var$cleanSource(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $6fb9842575b03497$var$cleanSource(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $6fb9842575b03497$var$markDirtyUp(node2) {
    node2[$6fb9842575b03497$var$isClean$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $6fb9842575b03497$var$markDirtyUp(i2);
    }
}
var $6fb9842575b03497$var$Container$7 = /*#__PURE__*/ function(Node$1) {
    $6fb9842575b03497$var$_inherits(Container2, Node$1);
    function Container2() {
        return Node$1.apply(this, arguments) || this;
    }
    var _proto = Container2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $6fb9842575b03497$var$cleanSource($6fb9842575b03497$var$parse$4(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $6fb9842575b03497$var$Declaration$3(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $6fb9842575b03497$var$Rule$4(nodes)
        ];
        else if (nodes.name) nodes = [
            new $6fb9842575b03497$var$AtRule$4(nodes)
        ];
        else if (nodes.text) nodes = [
            new $6fb9842575b03497$var$Comment$3(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$6fb9842575b03497$var$my$1]) Container2.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$6fb9842575b03497$var$isClean$1]) $6fb9842575b03497$var$markDirtyUp(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $6fb9842575b03497$var$_create_class(Container2, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container2;
}($6fb9842575b03497$var$Node$1);
$6fb9842575b03497$var$Container$7.registerParse = function(dependant) {
    $6fb9842575b03497$var$parse$4 = dependant;
};
$6fb9842575b03497$var$Container$7.registerRule = function(dependant) {
    $6fb9842575b03497$var$Rule$4 = dependant;
};
$6fb9842575b03497$var$Container$7.registerAtRule = function(dependant) {
    $6fb9842575b03497$var$AtRule$4 = dependant;
};
$6fb9842575b03497$var$Container$7.registerRoot = function(dependant) {
    $6fb9842575b03497$var$Root$6 = dependant;
};
var $6fb9842575b03497$var$container = $6fb9842575b03497$var$Container$7;
$6fb9842575b03497$var$Container$7.default = $6fb9842575b03497$var$Container$7;
$6fb9842575b03497$var$Container$7.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $6fb9842575b03497$var$AtRule$4.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Rule$4.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Declaration$3.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Comment$3.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Root$6.prototype);
    node2[$6fb9842575b03497$var$my$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $6fb9842575b03497$var$Container$7.rebuild(child);
    });
};
var $6fb9842575b03497$var$Container$6 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$LazyResult$4, $6fb9842575b03497$var$Processor$3;
var $6fb9842575b03497$var$Document$3 = /*#__PURE__*/ function(Container$6) {
    $6fb9842575b03497$var$_inherits(Document23, Container$6);
    function Document23(defaults) {
        var _this;
        _this = Container$6.call(this, $6fb9842575b03497$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document23.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $6fb9842575b03497$var$LazyResult$4(new $6fb9842575b03497$var$Processor$3(), this, opts);
        return lazy.stringify();
    };
    return Document23;
}($6fb9842575b03497$var$Container$6);
$6fb9842575b03497$var$Document$3.registerLazyResult = function(dependant) {
    $6fb9842575b03497$var$LazyResult$4 = dependant;
};
$6fb9842575b03497$var$Document$3.registerProcessor = function(dependant) {
    $6fb9842575b03497$var$Processor$3 = dependant;
};
var $6fb9842575b03497$var$document$1$2 = $6fb9842575b03497$var$Document$3;
$6fb9842575b03497$var$Document$3.default = $6fb9842575b03497$var$Document$3;
var $6fb9842575b03497$var$printed = {};
var $6fb9842575b03497$var$warnOnce$2 = function warnOnce2(message) {
    if ($6fb9842575b03497$var$printed[message]) return;
    $6fb9842575b03497$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $6fb9842575b03497$var$Warning$2 = /*#__PURE__*/ function() {
    function Warning2(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning2.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning2;
}();
var $6fb9842575b03497$var$warning = $6fb9842575b03497$var$Warning$2;
$6fb9842575b03497$var$Warning$2.default = $6fb9842575b03497$var$Warning$2;
var $6fb9842575b03497$var$Warning$1 = $6fb9842575b03497$var$warning;
var $6fb9842575b03497$var$Result$3 = /*#__PURE__*/ function() {
    function Result2(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result2.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $6fb9842575b03497$var$Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $6fb9842575b03497$var$_create_class(Result2, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result2;
}();
var $6fb9842575b03497$var$result = $6fb9842575b03497$var$Result$3;
$6fb9842575b03497$var$Result$3.default = $6fb9842575b03497$var$Result$3;
var $6fb9842575b03497$var$SINGLE_QUOTE = "'".charCodeAt(0);
var $6fb9842575b03497$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
var $6fb9842575b03497$var$BACKSLASH = "\\".charCodeAt(0);
var $6fb9842575b03497$var$SLASH = "/".charCodeAt(0);
var $6fb9842575b03497$var$NEWLINE = "\n".charCodeAt(0);
var $6fb9842575b03497$var$SPACE = " ".charCodeAt(0);
var $6fb9842575b03497$var$FEED = "\f".charCodeAt(0);
var $6fb9842575b03497$var$TAB = "	".charCodeAt(0);
var $6fb9842575b03497$var$CR = "\r".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_SQUARE = "[".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_SQUARE = "]".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_PARENTHESES = "(".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_CURLY = "{".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_CURLY = "}".charCodeAt(0);
var $6fb9842575b03497$var$SEMICOLON = ";".charCodeAt(0);
var $6fb9842575b03497$var$ASTERISK = "*".charCodeAt(0);
var $6fb9842575b03497$var$COLON = ":".charCodeAt(0);
var $6fb9842575b03497$var$AT = "@".charCodeAt(0);
var $6fb9842575b03497$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $6fb9842575b03497$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $6fb9842575b03497$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var $6fb9842575b03497$var$RE_HEX_ESCAPE = /[\da-f]/i;
var $6fb9842575b03497$var$tokenize = function tokenizer2(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $6fb9842575b03497$var$NEWLINE:
            case $6fb9842575b03497$var$SPACE:
            case $6fb9842575b03497$var$TAB:
            case $6fb9842575b03497$var$CR:
            case $6fb9842575b03497$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $6fb9842575b03497$var$SPACE || code === $6fb9842575b03497$var$NEWLINE || code === $6fb9842575b03497$var$TAB || code === $6fb9842575b03497$var$CR || code === $6fb9842575b03497$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $6fb9842575b03497$var$OPEN_SQUARE:
            case $6fb9842575b03497$var$CLOSE_SQUARE:
            case $6fb9842575b03497$var$OPEN_CURLY:
            case $6fb9842575b03497$var$CLOSE_CURLY:
            case $6fb9842575b03497$var$COLON:
            case $6fb9842575b03497$var$SEMICOLON:
            case $6fb9842575b03497$var$CLOSE_PARENTHESES:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $6fb9842575b03497$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $6fb9842575b03497$var$SINGLE_QUOTE && n2 !== $6fb9842575b03497$var$DOUBLE_QUOTE && n2 !== $6fb9842575b03497$var$SPACE && n2 !== $6fb9842575b03497$var$NEWLINE && n2 !== $6fb9842575b03497$var$TAB && n2 !== $6fb9842575b03497$var$FEED && n2 !== $6fb9842575b03497$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $6fb9842575b03497$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $6fb9842575b03497$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $6fb9842575b03497$var$SINGLE_QUOTE:
            case $6fb9842575b03497$var$DOUBLE_QUOTE:
                quote = code === $6fb9842575b03497$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $6fb9842575b03497$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $6fb9842575b03497$var$AT:
                $6fb9842575b03497$var$RE_AT_END.lastIndex = pos + 1;
                $6fb9842575b03497$var$RE_AT_END.test(css);
                if ($6fb9842575b03497$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $6fb9842575b03497$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $6fb9842575b03497$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $6fb9842575b03497$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $6fb9842575b03497$var$SLASH && code !== $6fb9842575b03497$var$SPACE && code !== $6fb9842575b03497$var$NEWLINE && code !== $6fb9842575b03497$var$TAB && code !== $6fb9842575b03497$var$CR && code !== $6fb9842575b03497$var$FEED) {
                    next += 1;
                    if ($6fb9842575b03497$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($6fb9842575b03497$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $6fb9842575b03497$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $6fb9842575b03497$var$SLASH && css.charCodeAt(pos + 1) === $6fb9842575b03497$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $6fb9842575b03497$var$RE_WORD_END.lastIndex = pos + 1;
                    $6fb9842575b03497$var$RE_WORD_END.test(css);
                    if ($6fb9842575b03497$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $6fb9842575b03497$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $6fb9842575b03497$var$Container$5 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$AtRule$3 = /*#__PURE__*/ function(Container$5) {
    $6fb9842575b03497$var$_inherits(AtRule2, Container$5);
    function AtRule2(defaults) {
        var _this;
        _this = Container$5.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_append = Container$5.prototype.append).call.apply(_Container$5_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_prepend = Container$5.prototype.prepend).call.apply(_Container$5_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule2;
}($6fb9842575b03497$var$Container$5);
var $6fb9842575b03497$var$atRule = $6fb9842575b03497$var$AtRule$3;
$6fb9842575b03497$var$AtRule$3.default = $6fb9842575b03497$var$AtRule$3;
$6fb9842575b03497$var$Container$5.registerAtRule($6fb9842575b03497$var$AtRule$3);
var $6fb9842575b03497$var$Container$4 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$LazyResult$3, $6fb9842575b03497$var$Processor$2;
var $6fb9842575b03497$var$Root$5 = /*#__PURE__*/ function(Container$4) {
    $6fb9842575b03497$var$_inherits(Root2, Container$4);
    function Root2(defaults) {
        var _this;
        _this = Container$4.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root2.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $6fb9842575b03497$var$LazyResult$3(new $6fb9842575b03497$var$Processor$2(), this, opts);
        return lazy.stringify();
    };
    return Root2;
}($6fb9842575b03497$var$Container$4);
$6fb9842575b03497$var$Root$5.registerLazyResult = function(dependant) {
    $6fb9842575b03497$var$LazyResult$3 = dependant;
};
$6fb9842575b03497$var$Root$5.registerProcessor = function(dependant) {
    $6fb9842575b03497$var$Processor$2 = dependant;
};
var $6fb9842575b03497$var$root = $6fb9842575b03497$var$Root$5;
$6fb9842575b03497$var$Root$5.default = $6fb9842575b03497$var$Root$5;
$6fb9842575b03497$var$Container$4.registerRoot($6fb9842575b03497$var$Root$5);
var $6fb9842575b03497$var$list$2 = {
    comma: function comma(string) {
        return $6fb9842575b03497$var$list$2.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $6fb9842575b03497$var$list$2.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $6fb9842575b03497$var$list_1 = $6fb9842575b03497$var$list$2;
$6fb9842575b03497$var$list$2.default = $6fb9842575b03497$var$list$2;
var $6fb9842575b03497$var$Container$3 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$list$1 = $6fb9842575b03497$var$list_1;
var $6fb9842575b03497$var$Rule$3 = /*#__PURE__*/ function(Container$3) {
    $6fb9842575b03497$var$_inherits(Rule2, Container$3);
    function Rule2(defaults) {
        var _this;
        _this = Container$3.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $6fb9842575b03497$var$_create_class(Rule2, [
        {
            key: "selectors",
            get: function get() {
                return $6fb9842575b03497$var$list$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule2;
}($6fb9842575b03497$var$Container$3);
var $6fb9842575b03497$var$rule = $6fb9842575b03497$var$Rule$3;
$6fb9842575b03497$var$Rule$3.default = $6fb9842575b03497$var$Rule$3;
$6fb9842575b03497$var$Container$3.registerRule($6fb9842575b03497$var$Rule$3);
var $6fb9842575b03497$var$Declaration$2 = $6fb9842575b03497$var$declaration;
var $6fb9842575b03497$var$tokenizer22 = $6fb9842575b03497$var$tokenize;
var $6fb9842575b03497$var$Comment$2 = $6fb9842575b03497$var$comment;
var $6fb9842575b03497$var$AtRule$2 = $6fb9842575b03497$var$atRule;
var $6fb9842575b03497$var$Root$4 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$Rule$2 = $6fb9842575b03497$var$rule;
var $6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $6fb9842575b03497$var$findLastWithPosition(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $6fb9842575b03497$var$Parser$1 = /*#__PURE__*/ function() {
    function Parser2(input2) {
        this.input = input2;
        this.root = new $6fb9842575b03497$var$Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser2.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $6fb9842575b03497$var$AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $6fb9842575b03497$var$Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $6fb9842575b03497$var$tokenizer22(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $6fb9842575b03497$var$Declaration$2();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $6fb9842575b03497$var$findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $6fb9842575b03497$var$Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR[prev] && !$6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $6fb9842575b03497$var$Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser2;
}();
var $6fb9842575b03497$var$parser = $6fb9842575b03497$var$Parser$1;
var $6fb9842575b03497$var$Container$2 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$Parser22 = $6fb9842575b03497$var$parser;
var $6fb9842575b03497$var$Input$2 = $6fb9842575b03497$var$input;
function $6fb9842575b03497$var$parse$3(css, opts) {
    var input2 = new $6fb9842575b03497$var$Input$2(css, opts);
    var parser2 = new $6fb9842575b03497$var$Parser22(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $6fb9842575b03497$var$parse_1 = $6fb9842575b03497$var$parse$3;
$6fb9842575b03497$var$parse$3.default = $6fb9842575b03497$var$parse$3;
$6fb9842575b03497$var$Container$2.registerParse($6fb9842575b03497$var$parse$3);
var $6fb9842575b03497$var$isClean = $6fb9842575b03497$var$symbols.isClean, $6fb9842575b03497$var$my = $6fb9842575b03497$var$symbols.my;
var $6fb9842575b03497$var$MapGenerator$1 = $6fb9842575b03497$var$mapGenerator;
var $6fb9842575b03497$var$stringify$2 = $6fb9842575b03497$var$stringify_1;
var $6fb9842575b03497$var$Container$1 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$Document$2 = $6fb9842575b03497$var$document$1$2;
var $6fb9842575b03497$var$warnOnce$1 = $6fb9842575b03497$var$warnOnce$2;
var $6fb9842575b03497$var$Result$2 = $6fb9842575b03497$var$result;
var $6fb9842575b03497$var$parse$2 = $6fb9842575b03497$var$parse_1;
var $6fb9842575b03497$var$Root$3 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $6fb9842575b03497$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $6fb9842575b03497$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $6fb9842575b03497$var$CHILDREN = 0;
function $6fb9842575b03497$var$isPromise(obj) {
    return (typeof obj === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $6fb9842575b03497$var$getEvents(node2) {
    var key = false;
    var type = $6fb9842575b03497$var$TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $6fb9842575b03497$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $6fb9842575b03497$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $6fb9842575b03497$var$toStack(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $6fb9842575b03497$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $6fb9842575b03497$var$CHILDREN,
        "RootExit"
    ];
    else events = $6fb9842575b03497$var$getEvents(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $6fb9842575b03497$var$cleanMarks(node2) {
    node2[$6fb9842575b03497$var$isClean] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $6fb9842575b03497$var$cleanMarks(i2);
    });
    return node2;
}
var $6fb9842575b03497$var$postcss$2 = {};
var $6fb9842575b03497$var$LazyResult$2 = /*#__PURE__*/ function() {
    function LazyResult2(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $6fb9842575b03497$var$cleanMarks(css);
        else if ($6fb9842575b03497$var$_instanceof(css, LazyResult2) || $6fb9842575b03497$var$_instanceof(css, $6fb9842575b03497$var$Result$2)) {
            root2 = $6fb9842575b03497$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $6fb9842575b03497$var$parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$6fb9842575b03497$var$my]) $6fb9842575b03497$var$Container$1.rebuild(root2);
        }
        this.result = new $6fb9842575b03497$var$Result$2(processor2, root2, opts);
        this.helpers = $6fb9842575b03497$var$_extends({}, $6fb9842575b03497$var$postcss$2, {
            postcss: $6fb9842575b03497$var$postcss$2,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $6fb9842575b03497$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$6fb9842575b03497$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$6fb9842575b03497$var$NOT_VISITORS[event]) {
                    if ($6fb9842575b03497$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $6fb9842575b03497$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$6fb9842575b03497$var$isPromise(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$6fb9842575b03497$var$isClean]) return [
                            3,
                            14
                        ];
                        root2[$6fb9842575b03497$var$isClean] = true;
                        stack = [
                            $6fb9842575b03497$var$toStack(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$6fb9842575b03497$var$isPromise(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $6fb9842575b03497$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($6fb9842575b03497$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $6fb9842575b03497$var$stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $6fb9842575b03497$var$MapGenerator$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($6fb9842575b03497$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$6fb9842575b03497$var$isClean]){
                root2[$6fb9842575b03497$var$isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($6fb9842575b03497$var$isPromise(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$6fb9842575b03497$var$isClean]) {
                    child[$6fb9842575b03497$var$isClean] = true;
                    stack.push($6fb9842575b03497$var$toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $6fb9842575b03497$var$CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$6fb9842575b03497$var$isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$6fb9842575b03497$var$isClean] = true;
        var events = $6fb9842575b03497$var$getEvents(node2);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $6fb9842575b03497$var$CHILDREN) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$6fb9842575b03497$var$isClean]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $6fb9842575b03497$var$_create_class(LazyResult2, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult2;
}();
$6fb9842575b03497$var$LazyResult$2.registerPostcss = function(dependant) {
    $6fb9842575b03497$var$postcss$2 = dependant;
};
var $6fb9842575b03497$var$lazyResult = $6fb9842575b03497$var$LazyResult$2;
$6fb9842575b03497$var$LazyResult$2.default = $6fb9842575b03497$var$LazyResult$2;
$6fb9842575b03497$var$Root$3.registerLazyResult($6fb9842575b03497$var$LazyResult$2);
$6fb9842575b03497$var$Document$2.registerLazyResult($6fb9842575b03497$var$LazyResult$2);
var $6fb9842575b03497$var$MapGenerator22 = $6fb9842575b03497$var$mapGenerator;
var $6fb9842575b03497$var$stringify$1 = $6fb9842575b03497$var$stringify_1;
var $6fb9842575b03497$var$warnOnce22 = $6fb9842575b03497$var$warnOnce$2;
var $6fb9842575b03497$var$parse$1 = $6fb9842575b03497$var$parse_1;
var $6fb9842575b03497$var$Result$1 = $6fb9842575b03497$var$result;
var $6fb9842575b03497$var$NoWorkResult$1 = /*#__PURE__*/ function() {
    function NoWorkResult2(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $6fb9842575b03497$var$stringify$1;
        this.result = new $6fb9842575b03497$var$Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $6fb9842575b03497$var$MapGenerator22(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $6fb9842575b03497$var$_create_class(NoWorkResult2, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $6fb9842575b03497$var$parse$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult2;
}();
var $6fb9842575b03497$var$noWorkResult = $6fb9842575b03497$var$NoWorkResult$1;
$6fb9842575b03497$var$NoWorkResult$1.default = $6fb9842575b03497$var$NoWorkResult$1;
var $6fb9842575b03497$var$NoWorkResult22 = $6fb9842575b03497$var$noWorkResult;
var $6fb9842575b03497$var$LazyResult$1 = $6fb9842575b03497$var$lazyResult;
var $6fb9842575b03497$var$Document$1 = $6fb9842575b03497$var$document$1$2;
var $6fb9842575b03497$var$Root$2 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$Processor$1 = /*#__PURE__*/ function() {
    function Processor2(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor2.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $6fb9842575b03497$var$NoWorkResult22(this, css, opts);
        else return new $6fb9842575b03497$var$LazyResult$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor2;
}();
var $6fb9842575b03497$var$processor = $6fb9842575b03497$var$Processor$1;
$6fb9842575b03497$var$Processor$1.default = $6fb9842575b03497$var$Processor$1;
$6fb9842575b03497$var$Root$2.registerProcessor($6fb9842575b03497$var$Processor$1);
$6fb9842575b03497$var$Document$1.registerProcessor($6fb9842575b03497$var$Processor$1);
var $6fb9842575b03497$var$Declaration$1 = $6fb9842575b03497$var$declaration;
var $6fb9842575b03497$var$PreviousMap22 = $6fb9842575b03497$var$previousMap;
var $6fb9842575b03497$var$Comment$1 = $6fb9842575b03497$var$comment;
var $6fb9842575b03497$var$AtRule$1 = $6fb9842575b03497$var$atRule;
var $6fb9842575b03497$var$Input$1 = $6fb9842575b03497$var$input;
var $6fb9842575b03497$var$Root$1 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$Rule$1 = $6fb9842575b03497$var$rule;
function $6fb9842575b03497$var$fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $6fb9842575b03497$var$fromJSON$1(n2);
    });
    var ownInputs = json.inputs, defaults = $6fb9842575b03497$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $6fb9842575b03497$var$_extends({}, input2, {
                __proto__: $6fb9842575b03497$var$Input$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $6fb9842575b03497$var$_extends({}, inputHydrated.map, {
                __proto__: $6fb9842575b03497$var$PreviousMap22.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $6fb9842575b03497$var$fromJSON$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $6fb9842575b03497$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $6fb9842575b03497$var$Root$1(defaults);
    else if (defaults.type === "decl") return new $6fb9842575b03497$var$Declaration$1(defaults);
    else if (defaults.type === "rule") return new $6fb9842575b03497$var$Rule$1(defaults);
    else if (defaults.type === "comment") return new $6fb9842575b03497$var$Comment$1(defaults);
    else if (defaults.type === "atrule") return new $6fb9842575b03497$var$AtRule$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $6fb9842575b03497$var$fromJSON_1 = $6fb9842575b03497$var$fromJSON$1;
$6fb9842575b03497$var$fromJSON$1.default = $6fb9842575b03497$var$fromJSON$1;
var $6fb9842575b03497$var$CssSyntaxError22 = $6fb9842575b03497$var$cssSyntaxError;
var $6fb9842575b03497$var$Declaration22 = $6fb9842575b03497$var$declaration;
var $6fb9842575b03497$var$LazyResult22 = $6fb9842575b03497$var$lazyResult;
var $6fb9842575b03497$var$Container22 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$Processor22 = $6fb9842575b03497$var$processor;
var $6fb9842575b03497$var$stringify = $6fb9842575b03497$var$stringify_1;
var $6fb9842575b03497$var$fromJSON = $6fb9842575b03497$var$fromJSON_1;
var $6fb9842575b03497$var$Document222 = $6fb9842575b03497$var$document$1$2;
var $6fb9842575b03497$var$Warning22 = $6fb9842575b03497$var$warning;
var $6fb9842575b03497$var$Comment22 = $6fb9842575b03497$var$comment;
var $6fb9842575b03497$var$AtRule22 = $6fb9842575b03497$var$atRule;
var $6fb9842575b03497$var$Result22 = $6fb9842575b03497$var$result;
var $6fb9842575b03497$var$Input22 = $6fb9842575b03497$var$input;
var $6fb9842575b03497$var$parse = $6fb9842575b03497$var$parse_1;
var $6fb9842575b03497$var$list = $6fb9842575b03497$var$list_1;
var $6fb9842575b03497$var$Rule22 = $6fb9842575b03497$var$rule;
var $6fb9842575b03497$var$Root22 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$Node22 = $6fb9842575b03497$var$node;
function $6fb9842575b03497$var$postcss() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $6fb9842575b03497$var$Processor22(plugins);
}
$6fb9842575b03497$var$postcss.plugin = function plugin2(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $6fb9842575b03497$var$Processor22().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $6fb9842575b03497$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$6fb9842575b03497$var$postcss.stringify = $6fb9842575b03497$var$stringify;
$6fb9842575b03497$var$postcss.parse = $6fb9842575b03497$var$parse;
$6fb9842575b03497$var$postcss.fromJSON = $6fb9842575b03497$var$fromJSON;
$6fb9842575b03497$var$postcss.list = $6fb9842575b03497$var$list;
$6fb9842575b03497$var$postcss.comment = function(defaults) {
    return new $6fb9842575b03497$var$Comment22(defaults);
};
$6fb9842575b03497$var$postcss.atRule = function(defaults) {
    return new $6fb9842575b03497$var$AtRule22(defaults);
};
$6fb9842575b03497$var$postcss.decl = function(defaults) {
    return new $6fb9842575b03497$var$Declaration22(defaults);
};
$6fb9842575b03497$var$postcss.rule = function(defaults) {
    return new $6fb9842575b03497$var$Rule22(defaults);
};
$6fb9842575b03497$var$postcss.root = function(defaults) {
    return new $6fb9842575b03497$var$Root22(defaults);
};
$6fb9842575b03497$var$postcss.document = function(defaults) {
    return new $6fb9842575b03497$var$Document222(defaults);
};
$6fb9842575b03497$var$postcss.CssSyntaxError = $6fb9842575b03497$var$CssSyntaxError22;
$6fb9842575b03497$var$postcss.Declaration = $6fb9842575b03497$var$Declaration22;
$6fb9842575b03497$var$postcss.Container = $6fb9842575b03497$var$Container22;
$6fb9842575b03497$var$postcss.Processor = $6fb9842575b03497$var$Processor22;
$6fb9842575b03497$var$postcss.Document = $6fb9842575b03497$var$Document222;
$6fb9842575b03497$var$postcss.Comment = $6fb9842575b03497$var$Comment22;
$6fb9842575b03497$var$postcss.Warning = $6fb9842575b03497$var$Warning22;
$6fb9842575b03497$var$postcss.AtRule = $6fb9842575b03497$var$AtRule22;
$6fb9842575b03497$var$postcss.Result = $6fb9842575b03497$var$Result22;
$6fb9842575b03497$var$postcss.Input = $6fb9842575b03497$var$Input22;
$6fb9842575b03497$var$postcss.Rule = $6fb9842575b03497$var$Rule22;
$6fb9842575b03497$var$postcss.Root = $6fb9842575b03497$var$Root22;
$6fb9842575b03497$var$postcss.Node = $6fb9842575b03497$var$Node22;
$6fb9842575b03497$var$LazyResult22.registerPostcss($6fb9842575b03497$var$postcss);
var $6fb9842575b03497$var$postcss_1 = $6fb9842575b03497$var$postcss;
$6fb9842575b03497$var$postcss.default = $6fb9842575b03497$var$postcss;
var $6fb9842575b03497$var$postcss$1 = /* @__PURE__ */ $6fb9842575b03497$var$getDefaultExportFromCjs($6fb9842575b03497$var$postcss_1);
$6fb9842575b03497$var$postcss$1.stringify;
$6fb9842575b03497$var$postcss$1.fromJSON;
$6fb9842575b03497$var$postcss$1.plugin;
$6fb9842575b03497$var$postcss$1.parse;
$6fb9842575b03497$var$postcss$1.list;
$6fb9842575b03497$var$postcss$1.document;
$6fb9842575b03497$var$postcss$1.comment;
$6fb9842575b03497$var$postcss$1.atRule;
$6fb9842575b03497$var$postcss$1.rule;
$6fb9842575b03497$var$postcss$1.decl;
$6fb9842575b03497$var$postcss$1.root;
$6fb9842575b03497$var$postcss$1.CssSyntaxError;
$6fb9842575b03497$var$postcss$1.Declaration;
$6fb9842575b03497$var$postcss$1.Container;
$6fb9842575b03497$var$postcss$1.Processor;
$6fb9842575b03497$var$postcss$1.Document;
$6fb9842575b03497$var$postcss$1.Comment;
$6fb9842575b03497$var$postcss$1.Warning;
$6fb9842575b03497$var$postcss$1.AtRule;
$6fb9842575b03497$var$postcss$1.Result;
$6fb9842575b03497$var$postcss$1.Input;
$6fb9842575b03497$var$postcss$1.Rule;
$6fb9842575b03497$var$postcss$1.Root;
$6fb9842575b03497$var$postcss$1.Node;
var $6fb9842575b03497$var$BaseRRNode = /*#__PURE__*/ function() {
    function BaseRRNode() {
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        $6fb9842575b03497$var$__publicField2(this, "parentElement", null);
        $6fb9842575b03497$var$__publicField2(this, "parentNode", null);
        $6fb9842575b03497$var$__publicField2(this, "ownerDocument");
        $6fb9842575b03497$var$__publicField2(this, "firstChild", null);
        $6fb9842575b03497$var$__publicField2(this, "lastChild", null);
        $6fb9842575b03497$var$__publicField2(this, "previousSibling", null);
        $6fb9842575b03497$var$__publicField2(this, "nextSibling", null);
        $6fb9842575b03497$var$__publicField2(this, "ELEMENT_NODE", 1);
        $6fb9842575b03497$var$__publicField2(this, "TEXT_NODE", 3);
        $6fb9842575b03497$var$__publicField2(this, "nodeType");
        $6fb9842575b03497$var$__publicField2(this, "nodeName");
        $6fb9842575b03497$var$__publicField2(this, "RRNodeType");
    }
    var _proto = BaseRRNode.prototype;
    _proto.contains = function contains(node2) {
        if (!$6fb9842575b03497$var$_instanceof(node2, BaseRRNode)) return false;
        else if (node2.ownerDocument !== this.ownerDocument) return false;
        else if (node2 === this) return true;
        while(node2.parentNode){
            if (node2.parentNode === this) return true;
            node2 = node2.parentNode;
        }
        return false;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.appendChild = function appendChild(_newChild) {
        throw new Error("RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.insertBefore = function insertBefore(_newChild, _refChild) {
        throw new Error("RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.removeChild = function removeChild(_node) {
        throw new Error("RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.");
    };
    _proto.toString = function toString() {
        return "RRNode";
    };
    $6fb9842575b03497$var$_create_class(BaseRRNode, [
        {
            key: "childNodes",
            get: function get() {
                var childNodes2 = [];
                var childIterator = this.firstChild;
                while(childIterator){
                    childNodes2.push(childIterator);
                    childIterator = childIterator.nextSibling;
                }
                return childNodes2;
            }
        }
    ]);
    return BaseRRNode;
}();
var $6fb9842575b03497$var$testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $6fb9842575b03497$var$testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $6fb9842575b03497$var$untaintedBasePrototype = {};
var $6fb9842575b03497$var$isAngularZonePresent = function() {
    return !!globalThis.Zone;
};
function $6fb9842575b03497$var$getUntaintedPrototype(key) {
    if ($6fb9842575b03497$var$untaintedBasePrototype[key]) return $6fb9842575b03497$var$untaintedBasePrototype[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $6fb9842575b03497$var$testableAccessors ? $6fb9842575b03497$var$testableAccessors[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $6fb9842575b03497$var$testableMethods ? $6fb9842575b03497$var$testableMethods[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$6fb9842575b03497$var$isAngularZonePresent()) {
        $6fb9842575b03497$var$untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $6fb9842575b03497$var$untaintedBasePrototype[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $6fb9842575b03497$var$untaintedAccessorCache = {};
function $6fb9842575b03497$var$getUntaintedAccessor(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($6fb9842575b03497$var$untaintedAccessorCache[cacheKey]) return $6fb9842575b03497$var$untaintedAccessorCache[cacheKey].call(instance);
    var untaintedPrototype = $6fb9842575b03497$var$getUntaintedPrototype(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $6fb9842575b03497$var$untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $6fb9842575b03497$var$untaintedMethodCache = {};
function $6fb9842575b03497$var$getUntaintedMethod(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($6fb9842575b03497$var$untaintedMethodCache[cacheKey]) return $6fb9842575b03497$var$untaintedMethodCache[cacheKey].bind(instance);
    var untaintedPrototype = $6fb9842575b03497$var$getUntaintedPrototype(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $6fb9842575b03497$var$untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $6fb9842575b03497$var$childNodes(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Node", n2, "childNodes");
}
function $6fb9842575b03497$var$parentNode(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Node", n2, "parentNode");
}
function $6fb9842575b03497$var$parentElement(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Node", n2, "parentElement");
}
function $6fb9842575b03497$var$textContent(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Node", n2, "textContent");
}
function $6fb9842575b03497$var$contains(n2, other) {
    return $6fb9842575b03497$var$getUntaintedMethod("Node", n2, "contains")(other);
}
function $6fb9842575b03497$var$getRootNode(n2) {
    return $6fb9842575b03497$var$getUntaintedMethod("Node", n2, "getRootNode")();
}
function $6fb9842575b03497$var$host(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $6fb9842575b03497$var$getUntaintedAccessor("ShadowRoot", n2, "host");
}
function $6fb9842575b03497$var$styleSheets(n2) {
    return n2.styleSheets;
}
function $6fb9842575b03497$var$shadowRoot(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $6fb9842575b03497$var$getUntaintedAccessor("Element", n2, "shadowRoot");
}
function $6fb9842575b03497$var$querySelector(n2, selectors) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Element", n2, "querySelector")(selectors);
}
function $6fb9842575b03497$var$querySelectorAll(n2, selectors) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Element", n2, "querySelectorAll")(selectors);
}
function $6fb9842575b03497$var$mutationObserverCtor() {
    return $6fb9842575b03497$var$getUntaintedPrototype("MutationObserver").constructor;
}
var $6fb9842575b03497$var$index = {
    childNodes: $6fb9842575b03497$var$childNodes,
    parentNode: $6fb9842575b03497$var$parentNode,
    parentElement: $6fb9842575b03497$var$parentElement,
    textContent: $6fb9842575b03497$var$textContent,
    contains: $6fb9842575b03497$var$contains,
    getRootNode: $6fb9842575b03497$var$getRootNode,
    host: $6fb9842575b03497$var$host,
    styleSheets: $6fb9842575b03497$var$styleSheets,
    shadowRoot: $6fb9842575b03497$var$shadowRoot,
    querySelector: $6fb9842575b03497$var$querySelector,
    querySelectorAll: $6fb9842575b03497$var$querySelectorAll,
    mutationObserver: $6fb9842575b03497$var$mutationObserverCtor
};
function $6fb9842575b03497$var$on(type, fn, target) {
    if (target === void 0) target = document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var $6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var $6fb9842575b03497$var$_mirror = {
    map: {},
    getId: function getId() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function getNode() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function removeNodeFromMap() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function has() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function reset() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $6fb9842575b03497$var$_mirror = new Proxy($6fb9842575b03497$var$_mirror, {
    get: function get(target, prop, receiver) {
        if (prop === "map") console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $6fb9842575b03497$var$throttle(func, wait, options) {
    if (options === void 0) options = {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $6fb9842575b03497$var$hookSetter(target, key, d, isRevoked, win) {
    if (win === void 0) win = window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function set(value) {
            var _this = this;
            setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return $6fb9842575b03497$var$hookSetter(target, key, original || {}, true);
    };
}
function $6fb9842575b03497$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $6fb9842575b03497$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $6fb9842575b03497$var$nowTimestamp = function() {
    return /* @__PURE__ */ new Date().getTime();
};
function $6fb9842575b03497$var$getWindowScroll(win) {
    var _a2, _b, _c, _d;
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc.documentElement.scrollLeft || (doc == null ? void 0 : doc.body) && ((_a2 = $6fb9842575b03497$var$index.parentElement(doc.body)) == null ? void 0 : _a2.scrollLeft) || ((_b = doc == null ? void 0 : doc.body) == null ? void 0 : _b.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc == null ? void 0 : doc.documentElement.scrollTop) || (doc == null ? void 0 : doc.body) && ((_c = $6fb9842575b03497$var$index.parentElement(doc.body)) == null ? void 0 : _c.scrollTop) || ((_d = doc == null ? void 0 : doc.body) == null ? void 0 : _d.scrollTop) || 0
    };
}
function $6fb9842575b03497$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $6fb9842575b03497$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $6fb9842575b03497$var$closestElementOfNode(node2) {
    if (!node2) return null;
    var el = node2.nodeType === node2.ELEMENT_NODE ? node2 : $6fb9842575b03497$var$index.parentElement(node2);
    return el;
}
function $6fb9842575b03497$var$isBlocked(node2, blockClass, blockSelector, checkAncestors) {
    if (!node2) return false;
    var el = $6fb9842575b03497$var$closestElementOfNode(node2);
    if (!el) return false;
    try {
        if (typeof blockClass === "string") {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest("." + blockClass) !== null) return true;
        } else {
            if ($6fb9842575b03497$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e2) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $6fb9842575b03497$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $6fb9842575b03497$var$isIgnored(n2, mirror2, slimDOMOptions) {
    if (n2.tagName === "TITLE" && slimDOMOptions.headTitleMutations) return true;
    return mirror2.getId(n2) === $6fb9842575b03497$var$IGNORED_NODE;
}
function $6fb9842575b03497$var$isAncestorRemoved(target, mirror2) {
    if ($6fb9842575b03497$var$isShadowRoot(target)) return false;
    var id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    var parent = $6fb9842575b03497$var$index.parentNode(target);
    if (parent && parent.nodeType === target.DOCUMENT_NODE) return false;
    if (!parent) return true;
    return $6fb9842575b03497$var$isAncestorRemoved(parent, mirror2);
}
function $6fb9842575b03497$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $6fb9842575b03497$var$polyfill$1(win) {
    if (win === void 0) win = window;
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
}
function $6fb9842575b03497$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $6fb9842575b03497$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $6fb9842575b03497$var$hasShadowRoot(n2) {
    if (!n2) return false;
    if ($6fb9842575b03497$var$_instanceof(n2, $6fb9842575b03497$var$BaseRRNode) && "shadowRoot" in n2) return Boolean(n2.shadowRoot);
    return Boolean($6fb9842575b03497$var$index.shadowRoot(n2));
}
var $6fb9842575b03497$var$StyleSheetMirror = /*#__PURE__*/ function() {
    function StyleSheetMirror() {
        $6fb9842575b03497$var$__publicField(this, "id", 1);
        $6fb9842575b03497$var$__publicField(this, "styleIDMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "idStyleMap", /* @__PURE__ */ new Map());
    }
    var _proto = StyleSheetMirror.prototype;
    _proto.getId = function getId(stylesheet) {
        var _this_styleIDMap_get;
        return (_this_styleIDMap_get = this.styleIDMap.get(stylesheet)) != null ? _this_styleIDMap_get : -1;
    };
    _proto.has = function has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    };
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ _proto.add = function add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        var newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    };
    _proto.getStyle = function getStyle(id) {
        return this.idStyleMap.get(id) || null;
    };
    _proto.reset = function reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    };
    _proto.generateId = function generateId() {
        return this.id++;
    };
    return StyleSheetMirror;
}();
function $6fb9842575b03497$var$getShadowHost(n2) {
    var _a2;
    var shadowHost = null;
    if ("getRootNode" in n2 && ((_a2 = $6fb9842575b03497$var$index.getRootNode(n2)) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && $6fb9842575b03497$var$index.host($6fb9842575b03497$var$index.getRootNode(n2))) shadowHost = $6fb9842575b03497$var$index.host($6fb9842575b03497$var$index.getRootNode(n2));
    return shadowHost;
}
function $6fb9842575b03497$var$getRootShadowHost(n2) {
    var rootShadowHost = n2;
    var shadowHost;
    while(shadowHost = $6fb9842575b03497$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $6fb9842575b03497$var$shadowHostInDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    var shadowHost = $6fb9842575b03497$var$getRootShadowHost(n2);
    return $6fb9842575b03497$var$index.contains(doc, shadowHost);
}
function $6fb9842575b03497$var$inDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    return $6fb9842575b03497$var$index.contains(doc, n2) || $6fb9842575b03497$var$shadowHostInDom(n2);
}
var $6fb9842575b03497$var$EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}($6fb9842575b03497$var$EventType || {});
var $6fb9842575b03497$var$IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}($6fb9842575b03497$var$IncrementalSource || {});
var $6fb9842575b03497$var$MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}($6fb9842575b03497$var$MouseInteractions || {});
var $6fb9842575b03497$var$PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}($6fb9842575b03497$var$PointerTypes || {});
var $6fb9842575b03497$var$CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}($6fb9842575b03497$var$CanvasContext || {});
var $6fb9842575b03497$var$MediaInteractions = /* @__PURE__ */ function(MediaInteractions2) {
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
}($6fb9842575b03497$var$MediaInteractions || {});
var $6fb9842575b03497$var$NodeType = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($6fb9842575b03497$var$NodeType || {});
function $6fb9842575b03497$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
var $6fb9842575b03497$var$DoubleLinkedList = /*#__PURE__*/ function() {
    function DoubleLinkedList() {
        $6fb9842575b03497$var$__publicField(this, "length", 0);
        $6fb9842575b03497$var$__publicField(this, "head", null);
        $6fb9842575b03497$var$__publicField(this, "tail", null);
    }
    var _proto = DoubleLinkedList.prototype;
    _proto.get = function get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        var current = this.head;
        for(var index2 = 0; index2 < position; index2++)current = (current == null ? void 0 : current.next) || null;
        return current;
    };
    _proto.addNode = function addNode(n2) {
        var node2 = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node2;
        if (n2.previousSibling && $6fb9842575b03497$var$isNodeInLinkedList(n2.previousSibling)) {
            var current = n2.previousSibling.__ln.next;
            node2.next = current;
            node2.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node2;
            if (current) current.previous = node2;
        } else if (n2.nextSibling && $6fb9842575b03497$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            var current1 = n2.nextSibling.__ln.previous;
            node2.previous = current1;
            node2.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node2;
            if (current1) current1.next = node2;
        } else {
            if (this.head) this.head.previous = node2;
            node2.next = this.head;
            this.head = node2;
        }
        if (node2.next === null) this.tail = node2;
        this.length++;
    };
    _proto.removeNode = function removeNode(n2) {
        var current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    };
    return DoubleLinkedList;
}();
var $6fb9842575b03497$var$moveKey = function(id, parentId) {
    return id + "@" + parentId;
};
var $6fb9842575b03497$var$MutationBuffer = /*#__PURE__*/ function() {
    function MutationBuffer() {
        var _this = this;
        $6fb9842575b03497$var$__publicField(this, "frozen", false);
        $6fb9842575b03497$var$__publicField(this, "locked", false);
        $6fb9842575b03497$var$__publicField(this, "texts", []);
        $6fb9842575b03497$var$__publicField(this, "attributes", []);
        $6fb9842575b03497$var$__publicField(this, "attributeMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "removes", []);
        $6fb9842575b03497$var$__publicField(this, "mapRemoves", []);
        $6fb9842575b03497$var$__publicField(this, "movedMap", {});
        /**
     * the browser MutationObserver emits multiple mutations after
     * a delay for performance reasons, making tracing added nodes hard
     * in our `processMutations` callback function.
     * For example, if we append an element el_1 into body, and then append
     * another element el_2 into el_1, these two mutations may be passed to the
     * callback function together when the two operations were done.
     * Generally we need to trace child nodes of newly added nodes, but in this
     * case if we count el_2 as el_1's child node in the first mutation record,
     * then we will count el_2 again in the second mutation record which was
     * duplicated.
     * To avoid of duplicate counting added nodes, we use a Set to store
     * added nodes and its child nodes during iterate mutation records. Then
     * collect added nodes from the Set which have no duplicate copy. But
     * this also causes newly added nodes will not be serialized with id ASAP,
     * which means all the id related calculation should be lazy too.
     */ $6fb9842575b03497$var$__publicField(this, "addedSet", /* @__PURE__ */ new Set());
        $6fb9842575b03497$var$__publicField(this, "movedSet", /* @__PURE__ */ new Set());
        $6fb9842575b03497$var$__publicField(this, "droppedSet", /* @__PURE__ */ new Set());
        $6fb9842575b03497$var$__publicField(this, "removesSubTreeCache", /* @__PURE__ */ new Set());
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "blockClass");
        $6fb9842575b03497$var$__publicField(this, "blockSelector");
        $6fb9842575b03497$var$__publicField(this, "maskTextClass");
        $6fb9842575b03497$var$__publicField(this, "maskTextSelector");
        $6fb9842575b03497$var$__publicField(this, "inlineStylesheet");
        $6fb9842575b03497$var$__publicField(this, "maskInputOptions");
        $6fb9842575b03497$var$__publicField(this, "maskTextFn");
        $6fb9842575b03497$var$__publicField(this, "maskInputFn");
        $6fb9842575b03497$var$__publicField(this, "keepIframeSrcFn");
        $6fb9842575b03497$var$__publicField(this, "recordCanvas");
        $6fb9842575b03497$var$__publicField(this, "inlineImages");
        $6fb9842575b03497$var$__publicField(this, "slimDOMOptions");
        $6fb9842575b03497$var$__publicField(this, "dataURLOptions");
        $6fb9842575b03497$var$__publicField(this, "doc");
        $6fb9842575b03497$var$__publicField(this, "mirror");
        $6fb9842575b03497$var$__publicField(this, "iframeManager");
        $6fb9842575b03497$var$__publicField(this, "stylesheetManager");
        $6fb9842575b03497$var$__publicField(this, "shadowDomManager");
        $6fb9842575b03497$var$__publicField(this, "canvasManager");
        $6fb9842575b03497$var$__publicField(this, "processedNodeManager");
        $6fb9842575b03497$var$__publicField(this, "unattachedDoc");
        $6fb9842575b03497$var$__publicField(this, "processMutations", function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        });
        $6fb9842575b03497$var$__publicField(this, "emit", function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = /* @__PURE__ */ new Set();
            var addList = new $6fb9842575b03497$var$DoubleLinkedList();
            var getNextId = function(n2) {
                var ns = n2;
                var nextId = $6fb9842575b03497$var$IGNORED_NODE;
                while(nextId === $6fb9842575b03497$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n2) {
                var parent = $6fb9842575b03497$var$index.parentNode(n2);
                if (!parent || !$6fb9842575b03497$var$inDom(n2)) return;
                var cssCaptured = false;
                if (n2.nodeType === Node.TEXT_NODE) {
                    var parentTag = parent.tagName;
                    if (parentTag === "TEXTAREA") return;
                    else if (parentTag === "STYLE" && _this.addedSet.has(parent)) cssCaptured = true;
                }
                var parentId = $6fb9842575b03497$var$isShadowRoot(parent) ? _this.mirror.getId($6fb9842575b03497$var$getShadowHost(n2)) : _this.mirror.getId(parent);
                var nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                var sn = $6fb9842575b03497$var$serializeNodeWithId(n2, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskTextClass: _this.maskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if ($6fb9842575b03497$var$isSerializedIframe(currentN, _this.mirror)) _this.iframeManager.addIframe(currentN);
                        if ($6fb9842575b03497$var$isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if ($6fb9842575b03497$var$hasShadowRoot(n2)) _this.shadowDomManager.addShadowRoot($6fb9842575b03497$var$index.shadowRoot(n2), _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    cssCaptured: cssCaptured
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(_this.movedSet), _step; !(_step = _iterator()).done;){
                var n2 = _step.value;
                if ($6fb9842575b03497$var$isParentRemoved(_this.removesSubTreeCache, n2, _this.mirror) && !_this.movedSet.has($6fb9842575b03497$var$index.parentNode(n2))) continue;
                pushAdd(n2);
            }
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(_this.addedSet), _step1; !(_step1 = _iterator1()).done;){
                var n21 = _step1.value;
                if (!$6fb9842575b03497$var$isAncestorInSet(_this.droppedSet, n21) && !$6fb9842575b03497$var$isParentRemoved(_this.removesSubTreeCache, n21, _this.mirror)) pushAdd(n21);
                else if ($6fb9842575b03497$var$isAncestorInSet(_this.movedSet, n21)) pushAdd(n21);
                else _this.droppedSet.add(n21);
            }
            var candidate = null;
            while(addList.length){
                var node2 = null;
                if (candidate) {
                    var parentId = _this.mirror.getId($6fb9842575b03497$var$index.parentNode(candidate.value));
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node2 = candidate;
                }
                if (!node2) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId($6fb9842575b03497$var$index.parentNode(_node.value));
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node2 = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                var parent = $6fb9842575b03497$var$index.parentNode(unhandledNode);
                                if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = $6fb9842575b03497$var$index.host(parent);
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node2 = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node2) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node2.previous;
                addList.removeNode(node2.value);
                pushAdd(node2.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    var n2 = text.node;
                    var parent = $6fb9842575b03497$var$index.parentNode(n2);
                    if (parent && parent.tagName === "TEXTAREA") _this.genTextAreaValueMutation(parent);
                    return {
                        id: _this.mirror.getId(n2),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === "string") {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = /* @__PURE__ */ new WeakMap();
            _this.removes = [];
            _this.addedSet = /* @__PURE__ */ new Set();
            _this.movedSet = /* @__PURE__ */ new Set();
            _this.droppedSet = /* @__PURE__ */ new Set();
            _this.removesSubTreeCache = /* @__PURE__ */ new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        });
        $6fb9842575b03497$var$__publicField(this, "genTextAreaValueMutation", function(textarea) {
            var item = _this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                _this.attributes.push(item);
                _this.attributeMap.set(textarea, item);
            }
            item.attributes.value = Array.from($6fb9842575b03497$var$index.childNodes(textarea), function(cn) {
                return $6fb9842575b03497$var$index.textContent(cn) || "";
            }).join("");
        });
        $6fb9842575b03497$var$__publicField(this, "processMutation", function(m) {
            if ($6fb9842575b03497$var$isIgnored(m.target, _this.mirror, _this.slimDOMOptions)) return;
            switch(m.type){
                case "characterData":
                    var value = $6fb9842575b03497$var$index.textContent(m.target);
                    if (!$6fb9842575b03497$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) && value !== m.oldValue) _this.texts.push({
                        value: $6fb9842575b03497$var$needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, true) && value ? _this.maskTextFn ? _this.maskTextFn(value, $6fb9842575b03497$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                        node: m.target
                    });
                    break;
                case "attributes":
                    var target = m.target;
                    var attributeName = m.attributeName;
                    var value1 = m.target.getAttribute(attributeName);
                    if (attributeName === "value") {
                        var type = $6fb9842575b03497$var$getInputType(target);
                        value1 = $6fb9842575b03497$var$maskInputValue({
                            element: target,
                            maskInputOptions: _this.maskInputOptions,
                            tagName: target.tagName,
                            type: type,
                            value: value1,
                            maskInputFn: _this.maskInputFn
                        });
                    }
                    if ($6fb9842575b03497$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || value1 === m.oldValue) return;
                    var item = _this.attributeMap.get(m.target);
                    if (target.tagName === "IFRAME" && attributeName === "src" && !_this.keepIframeSrcFn(value1)) {
                        if (!target.contentDocument) attributeName = "rr_src";
                        else return;
                    }
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                            styleDiff: {},
                            _unchangedStyles: {}
                        };
                        _this.attributes.push(item);
                        _this.attributeMap.set(m.target, item);
                    }
                    if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                    if (!$6fb9842575b03497$var$ignoreAttribute(target.tagName, attributeName)) {
                        item.attributes[attributeName] = $6fb9842575b03497$var$transformAttribute(_this.doc, $6fb9842575b03497$var$toLowerCase(target.tagName), $6fb9842575b03497$var$toLowerCase(attributeName), value1);
                        if (attributeName === "style") {
                            if (!_this.unattachedDoc) try {
                                _this.unattachedDoc = document.implementation.createHTMLDocument();
                            } catch (e2) {
                                _this.unattachedDoc = _this.doc;
                            }
                            var old = _this.unattachedDoc.createElement("span");
                            if (m.oldValue) old.setAttribute("style", m.oldValue);
                            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(Array.from(target.style)), _step; !(_step = _iterator()).done;){
                                var pname = _step.value;
                                var newValue = target.style.getPropertyValue(pname);
                                var newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === "") item.styleDiff[pname] = newValue;
                                    else item.styleDiff[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                } else item._unchangedStyles[pname] = [
                                    newValue,
                                    newPriority
                                ];
                            }
                            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(Array.from(old.style)), _step1; !(_step1 = _iterator1()).done;){
                                var pname1 = _step1.value;
                                if (target.style.getPropertyValue(pname1) === "") item.styleDiff[pname1] = false;
                            }
                        } else if (attributeName === "open" && target.tagName === "DIALOG") {
                            if (target.matches("dialog:modal")) item.attributes["rr_open_mode"] = "modal";
                            else item.attributes["rr_open_mode"] = "non-modal";
                        }
                    }
                    break;
                case "childList":
                    if ($6fb9842575b03497$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, true)) return;
                    if (m.target.tagName === "TEXTAREA") {
                        _this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach(function(n2) {
                        return _this.genAdds(n2, m.target);
                    });
                    m.removedNodes.forEach(function(n2) {
                        var nodeId = _this.mirror.getId(n2);
                        var parentId = $6fb9842575b03497$var$isShadowRoot(m.target) ? _this.mirror.getId($6fb9842575b03497$var$index.host(m.target)) : _this.mirror.getId(m.target);
                        if ($6fb9842575b03497$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || $6fb9842575b03497$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions) || !$6fb9842575b03497$var$isSerialized(n2, _this.mirror)) return;
                        if (_this.addedSet.has(n2)) {
                            $6fb9842575b03497$var$deepDelete(_this.addedSet, n2);
                            _this.droppedSet.add(n2);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($6fb9842575b03497$var$isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n2) && _this.movedMap[$6fb9842575b03497$var$moveKey(nodeId, parentId)]) $6fb9842575b03497$var$deepDelete(_this.movedSet, n2);
                        else {
                            _this.removes.push({
                                parentId: parentId,
                                id: nodeId,
                                isShadow: $6fb9842575b03497$var$isShadowRoot(m.target) && $6fb9842575b03497$var$isNativeShadowDom(m.target) ? true : void 0
                            });
                            $6fb9842575b03497$var$processRemoves(n2, _this.removesSubTreeCache);
                        }
                        _this.mapRemoves.push(n2);
                    });
                    break;
            }
        });
        /**
     * Make sure you check if `n`'s parent is blocked before calling this function
     * */ $6fb9842575b03497$var$__publicField(this, "genAdds", function(n2, target) {
            if (_this.processedNodeManager.inOtherBuffer(n2, _this)) return;
            if (_this.addedSet.has(n2) || _this.movedSet.has(n2)) return;
            if (_this.mirror.hasNode(n2)) {
                if ($6fb9842575b03497$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions)) return;
                _this.movedSet.add(n2);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[$6fb9842575b03497$var$moveKey(_this.mirror.getId(n2), targetId)] = true;
            } else {
                _this.addedSet.add(n2);
                _this.droppedSet.delete(n2);
            }
            if (!$6fb9842575b03497$var$isBlocked(n2, _this.blockClass, _this.blockSelector, false)) {
                $6fb9842575b03497$var$index.childNodes(n2).forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if ($6fb9842575b03497$var$hasShadowRoot(n2)) $6fb9842575b03497$var$index.childNodes($6fb9842575b03497$var$index.shadowRoot(n2)).forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n2);
                });
            }
        });
    }
    var _proto = MutationBuffer.prototype;
    _proto.init = function init(options) {
        var _this = this;
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "maskTextClass",
            "maskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach(function(key) {
            _this[key] = options[key];
        });
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    };
    _proto.isFrozen = function isFrozen() {
        return this.frozen;
    };
    _proto.lock = function lock() {
        this.locked = true;
        this.canvasManager.lock();
    };
    _proto.unlock = function unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    };
    _proto.reset = function reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    };
    return MutationBuffer;
}();
function $6fb9842575b03497$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    $6fb9842575b03497$var$index.childNodes(n2).forEach(function(childN) {
        return $6fb9842575b03497$var$deepDelete(addsSet, childN);
    });
}
function $6fb9842575b03497$var$processRemoves(n2, cache) {
    var queue = [
        n2
    ];
    while(queue.length){
        var next = queue.pop();
        if (cache.has(next)) continue;
        cache.add(next);
        $6fb9842575b03497$var$index.childNodes(next).forEach(function(n22) {
            return queue.push(n22);
        });
    }
    return;
}
function $6fb9842575b03497$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.size === 0) return false;
    return $6fb9842575b03497$var$_isParentRemoved(removes, n2);
}
function $6fb9842575b03497$var$_isParentRemoved(removes, n2, _mirror2) {
    var node2 = $6fb9842575b03497$var$index.parentNode(n2);
    if (!node2) return false;
    return removes.has(node2);
}
function $6fb9842575b03497$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $6fb9842575b03497$var$_isAncestorInSet(set, n2);
}
function $6fb9842575b03497$var$_isAncestorInSet(set, n2) {
    var parent = $6fb9842575b03497$var$index.parentNode(n2);
    if (!parent) return false;
    if (set.has(parent)) return true;
    return $6fb9842575b03497$var$_isAncestorInSet(set, parent);
}
var $6fb9842575b03497$var$errorHandler;
function $6fb9842575b03497$var$registerErrorHandler(handler) {
    $6fb9842575b03497$var$errorHandler = handler;
}
function $6fb9842575b03497$var$unregisterErrorHandler() {
    $6fb9842575b03497$var$errorHandler = void 0;
}
var $6fb9842575b03497$var$callbackWrapper = function(cb) {
    if (!$6fb9842575b03497$var$errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
        try {
            return cb.apply(void 0, [].concat(rest));
        } catch (error) {
            if ($6fb9842575b03497$var$errorHandler && $6fb9842575b03497$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
var $6fb9842575b03497$var$mutationBuffers = [];
function $6fb9842575b03497$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e) {}
    return event && event.target;
}
function $6fb9842575b03497$var$initMutationObserver(options, rootEl) {
    var mutationBuffer = new $6fb9842575b03497$var$MutationBuffer();
    $6fb9842575b03497$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var observer = new ($6fb9842575b03497$var$mutationObserverCtor())($6fb9842575b03497$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $6fb9842575b03497$var$initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror2 = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = $6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function(evt) {
        var target = $6fb9842575b03497$var$getEventTarget(evt);
        var _ref = $6fb9842575b03497$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = $6fb9842575b03497$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $6fb9842575b03497$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && $6fb9842575b03497$var$_instanceof(evt, DragEvent) ? $6fb9842575b03497$var$IncrementalSource.Drag : $6fb9842575b03497$var$_instanceof(evt, MouseEvent) ? $6fb9842575b03497$var$IncrementalSource.MouseMove : $6fb9842575b03497$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        $6fb9842575b03497$var$on("mousemove", updatePosition, doc),
        $6fb9842575b03497$var$on("touchmove", updatePosition, doc),
        $6fb9842575b03497$var$on("drag", updatePosition, doc)
    ];
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = $6fb9842575b03497$var$getEventTarget(event);
            if ($6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $6fb9842575b03497$var$PointerTypes.Touch) {
                    if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $6fb9842575b03497$var$PointerTypes.Pen;
            } else if ($6fb9842575b03497$var$legacy_isTouchEvent(event)) pointerType = $6fb9842575b03497$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $6fb9842575b03497$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $6fb9842575b03497$var$PointerTypes.Mouse) pointerType = null;
            } else if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e2 = $6fb9842575b03497$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            var id = mirror2.getId(target);
            var clientX = e2.clientX, clientY = e2.clientY;
            $6fb9842575b03497$var$callbackWrapper(mouseInteractionCb)($6fb9842575b03497$var$_extends({
                type: $6fb9842575b03497$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($6fb9842575b03497$var$MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = $6fb9842575b03497$var$toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch($6fb9842575b03497$var$MouseInteractions[eventKey]){
            case $6fb9842575b03497$var$MouseInteractions.MouseDown:
            case $6fb9842575b03497$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $6fb9842575b03497$var$MouseInteractions.TouchStart:
            case $6fb9842575b03497$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($6fb9842575b03497$var$on(eventName, handler, doc));
    });
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    var updatePosition = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function(evt) {
        var target = $6fb9842575b03497$var$getEventTarget(evt);
        if (!target || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
        var id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = $6fb9842575b03497$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $6fb9842575b03497$var$on("scroll", updatePosition, doc);
}
function $6fb9842575b03497$var$initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb;
    var win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function() {
        var height = $6fb9842575b03497$var$getWindowHeight();
        var width = $6fb9842575b03497$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $6fb9842575b03497$var$on("resize", updateDimension, win);
}
var $6fb9842575b03497$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
var $6fb9842575b03497$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $6fb9842575b03497$var$initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput;
    function eventHandler(event) {
        var target = $6fb9842575b03497$var$getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && target.tagName;
        if (target && tagName === "OPTION") target = $6fb9842575b03497$var$index.parentElement(target);
        if (!target || !tagName || $6fb9842575b03497$var$INPUT_TAGS.indexOf(tagName) < 0 || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        var text = target.value;
        var isChecked = false;
        var type = $6fb9842575b03497$var$getInputType(target) || "";
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $6fb9842575b03497$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function(el) {
            if (el !== target) {
                var text2 = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        var lastInputValue = $6fb9842575b03497$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $6fb9842575b03497$var$lastInputValueMap.set(target, v2);
            var id = mirror2.getId(target);
            $6fb9842575b03497$var$callbackWrapper(inputCb)($6fb9842575b03497$var$_extends({}, v2, {
                id: id
            }));
        }
    }
    var events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    var handlers = events.map(function(eventName) {
        return $6fb9842575b03497$var$on(eventName, $6fb9842575b03497$var$callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        var _handlers;
        (_handlers = handlers).push.apply(_handlers, [].concat(hookProperties.map(function(p) {
            return $6fb9842575b03497$var$hookSetter(p[0], p[1], {
                set: function set() {
                    $6fb9842575b03497$var$callbackWrapper(eventHandler)({
                        target: this,
                        isTrusted: false
                    });
                }
            }, false, currentWindow);
        })));
    }
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$getNestedCSSRulePositions(rule2) {
    var positions = [];
    function recurse(childRule, pos) {
        if ($6fb9842575b03497$var$hasNestedCSSRule("CSSGroupingRule") && $6fb9842575b03497$var$_instanceof(childRule.parentRule, CSSGroupingRule) || $6fb9842575b03497$var$hasNestedCSSRule("CSSMediaRule") && $6fb9842575b03497$var$_instanceof(childRule.parentRule, CSSMediaRule) || $6fb9842575b03497$var$hasNestedCSSRule("CSSSupportsRule") && $6fb9842575b03497$var$_instanceof(childRule.parentRule, CSSSupportsRule) || $6fb9842575b03497$var$hasNestedCSSRule("CSSConditionRule") && $6fb9842575b03497$var$_instanceof(childRule.parentRule, CSSConditionRule)) {
            var rules2 = Array.from(childRule.parentRule.cssRules);
            var index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        } else if (childRule.parentStyleSheet) {
            var rules21 = Array.from(childRule.parentStyleSheet.cssRules);
            var index21 = rules21.indexOf(childRule);
            pos.unshift(index21);
        }
        return pos;
    }
    return recurse(rule2, positions);
}
function $6fb9842575b03497$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $6fb9842575b03497$var$initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var rule2 = argumentsList[0], index2 = argumentsList[1];
            var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule2,
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.addRule = function(selector, styleBlock, index2) {
        if (index2 === void 0) index2 = this.cssRules.length;
        var rule2 = selector + " { " + styleBlock + " }";
        return win.CSSStyleSheet.prototype.insertRule.apply(this, [
            rule2,
            index2
        ]);
    };
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var index2 = argumentsList[0];
            var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.removeRule = function(index2) {
        return win.CSSStyleSheet.prototype.deleteRule.apply(this, [
            index2
        ]);
    };
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var typeKey = param[0], type = param[1];
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var rule2 = argumentsList[0], index2 = argumentsList[1];
                var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule2,
                            index: [].concat($6fb9842575b03497$var$getNestedCSSRulePositions(thisArg), [
                                index2 || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var index2 = argumentsList[0];
                var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [].concat($6fb9842575b03497$var$getNestedCSSRulePositions(thisArg), [
                                index2
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $6fb9842575b03497$var$callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var typeKey = param[0], type = param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $6fb9842575b03497$var$initAdoptedStyleSheetObserver(param, host2) {
    var mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var _a2, _b, _c;
    var hostId = null;
    if (host2.nodeName === "#document") hostId = mirror2.getId(host2);
    else hostId = mirror2.getId($6fb9842575b03497$var$index.host(host2));
    var patchTarget = host2.nodeName === "#document" ? (_a2 = host2.defaultView) == null ? void 0 : _a2.Document : (_c = (_b = host2.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.ShadowRoot;
    var originalPropertyDescriptor = (patchTarget == null ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget == null ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host2, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function get() {
            var _a3;
            return (_a3 = originalPropertyDescriptor.get) == null ? void 0 : _a3.call(this);
        },
        set: function set(sheets) {
            var _a3;
            var result2 = (_a3 = originalPropertyDescriptor.set) == null ? void 0 : _a3.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result2;
        }
    });
    return $6fb9842575b03497$var$callbackWrapper(function() {
        Object.defineProperty(host2, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $6fb9842575b03497$var$initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror2 = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0], value = argumentsList[1], priority = argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $6fb9842575b03497$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $6fb9842575b03497$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $6fb9842575b03497$var$callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $6fb9842575b03497$var$initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, mirror2 = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = $6fb9842575b03497$var$callbackWrapper(function(type) {
        return $6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function(event) {
            var target = $6fb9842575b03497$var$getEventTarget(event);
            if (!target || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate, loop = target.loop;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500);
    });
    var handlers = [
        $6fb9842575b03497$var$on("play", handler($6fb9842575b03497$var$MediaInteractions.Play), doc),
        $6fb9842575b03497$var$on("pause", handler($6fb9842575b03497$var$MediaInteractions.Pause), doc),
        $6fb9842575b03497$var$on("seeked", handler($6fb9842575b03497$var$MediaInteractions.Seeked), doc),
        $6fb9842575b03497$var$on("volumechange", handler($6fb9842575b03497$var$MediaInteractions.VolumeChange), doc),
        $6fb9842575b03497$var$on("ratechange", handler($6fb9842575b03497$var$MediaInteractions.RateChange), doc)
    ];
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = /* @__PURE__ */ new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = $6fb9842575b03497$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($6fb9842575b03497$var$callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$initSelectionObserver(param) {
    var doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = $6fb9842575b03497$var$callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && (selection == null ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i2 = 0; i2 < count; i2++){
            var range = selection.getRangeAt(i2);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = $6fb9842575b03497$var$isBlocked(startContainer, blockClass, blockSelector, true) || $6fb9842575b03497$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $6fb9842575b03497$var$on("selectionchange", updateSelection);
}
function $6fb9842575b03497$var$initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = $6fb9842575b03497$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {
                console.warn("Custom element callback failed for " + name);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $6fb9842575b03497$var$mergeHooks(o2, hooks) {
    var mutationCb = o2.mutationCb, mousemoveCb = o2.mousemoveCb, mouseInteractionCb = o2.mouseInteractionCb, scrollCb = o2.scrollCb, viewportResizeCb = o2.viewportResizeCb, inputCb = o2.inputCb, mediaInteractionCb = o2.mediaInteractionCb, styleSheetRuleCb = o2.styleSheetRuleCb, styleDeclarationCb = o2.styleDeclarationCb, canvasMutationCb = o2.canvasMutationCb, fontCb = o2.fontCb, selectionCb = o2.selectionCb, customElementCb = o2.customElementCb;
    o2.mutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mutation) {
            var _hooks;
            (_hooks = hooks).mutation.apply(_hooks, [].concat(p));
        }
        mutationCb.apply(void 0, [].concat(p));
    };
    o2.mousemoveCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mousemove) {
            var _hooks;
            (_hooks = hooks).mousemove.apply(_hooks, [].concat(p));
        }
        mousemoveCb.apply(void 0, [].concat(p));
    };
    o2.mouseInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mouseInteraction) {
            var _hooks;
            (_hooks = hooks).mouseInteraction.apply(_hooks, [].concat(p));
        }
        mouseInteractionCb.apply(void 0, [].concat(p));
    };
    o2.scrollCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.scroll) {
            var _hooks;
            (_hooks = hooks).scroll.apply(_hooks, [].concat(p));
        }
        scrollCb.apply(void 0, [].concat(p));
    };
    o2.viewportResizeCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.viewportResize) {
            var _hooks;
            (_hooks = hooks).viewportResize.apply(_hooks, [].concat(p));
        }
        viewportResizeCb.apply(void 0, [].concat(p));
    };
    o2.inputCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.input) {
            var _hooks;
            (_hooks = hooks).input.apply(_hooks, [].concat(p));
        }
        inputCb.apply(void 0, [].concat(p));
    };
    o2.mediaInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mediaInteaction) {
            var _hooks;
            (_hooks = hooks).mediaInteaction.apply(_hooks, [].concat(p));
        }
        mediaInteractionCb.apply(void 0, [].concat(p));
    };
    o2.styleSheetRuleCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleSheetRule) {
            var _hooks;
            (_hooks = hooks).styleSheetRule.apply(_hooks, [].concat(p));
        }
        styleSheetRuleCb.apply(void 0, [].concat(p));
    };
    o2.styleDeclarationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleDeclaration) {
            var _hooks;
            (_hooks = hooks).styleDeclaration.apply(_hooks, [].concat(p));
        }
        styleDeclarationCb.apply(void 0, [].concat(p));
    };
    o2.canvasMutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.canvasMutation) {
            var _hooks;
            (_hooks = hooks).canvasMutation.apply(_hooks, [].concat(p));
        }
        canvasMutationCb.apply(void 0, [].concat(p));
    };
    o2.fontCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.font) {
            var _hooks;
            (_hooks = hooks).font.apply(_hooks, [].concat(p));
        }
        fontCb.apply(void 0, [].concat(p));
    };
    o2.selectionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.selection) {
            var _hooks;
            (_hooks = hooks).selection.apply(_hooks, [].concat(p));
        }
        selectionCb.apply(void 0, [].concat(p));
    };
    o2.customElementCb = function() {
        for(var _len = arguments.length, c2 = new Array(_len), _key = 0; _key < _len; _key++)c2[_key] = arguments[_key];
        if (hooks.customElement) {
            var _hooks;
            (_hooks = hooks).customElement.apply(_hooks, [].concat(c2));
        }
        customElementCb.apply(void 0, [].concat(c2));
    };
}
function $6fb9842575b03497$var$initObservers(o2, hooks) {
    if (hooks === void 0) hooks = {};
    var currentWindow = o2.doc.defaultView;
    if (!currentWindow) return function() {};
    $6fb9842575b03497$var$mergeHooks(o2, hooks);
    var mutationObserver;
    if (o2.recordDOM) mutationObserver = $6fb9842575b03497$var$initMutationObserver(o2, o2.doc);
    var mousemoveHandler = $6fb9842575b03497$var$initMoveObserver(o2);
    var mouseInteractionHandler = $6fb9842575b03497$var$initMouseInteractionObserver(o2);
    var scrollHandler = $6fb9842575b03497$var$initScrollObserver(o2);
    var viewportResizeHandler = $6fb9842575b03497$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    var inputHandler = $6fb9842575b03497$var$initInputObserver(o2);
    var mediaInteractionHandler = $6fb9842575b03497$var$initMediaInteractionObserver(o2);
    var styleSheetObserver = function() {};
    var adoptedStyleSheetObserver = function() {};
    var styleDeclarationObserver = function() {};
    var fontObserver = function() {};
    if (o2.recordDOM) {
        styleSheetObserver = $6fb9842575b03497$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $6fb9842575b03497$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $6fb9842575b03497$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $6fb9842575b03497$var$initFontObserver(o2);
    }
    var selectionObserver = $6fb9842575b03497$var$initSelectionObserver(o2);
    var customElementObserver = $6fb9842575b03497$var$initCustomElementObserver(o2);
    var pluginHandlers = [];
    for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(o2.plugins), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        pluginHandlers.push(plugin3.observer(plugin3.callback, currentWindow, plugin3.options));
    }
    return $6fb9842575b03497$var$callbackWrapper(function() {
        $6fb9842575b03497$var$mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver == null || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $6fb9842575b03497$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
var $6fb9842575b03497$var$CrossOriginIframeMirror = /*#__PURE__*/ function() {
    function CrossOriginIframeMirror(generateIdFn) {
        $6fb9842575b03497$var$__publicField(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap());
        this.generateIdFn = generateIdFn;
    }
    var _proto = CrossOriginIframeMirror.prototype;
    _proto.getId = function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        var id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    };
    _proto.getIds = function getIds(iframe, remoteId) {
        var _this = this;
        var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map(function(id) {
            return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
        });
    };
    _proto.getRemoteId = function getRemoteId(iframe, id, map) {
        var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        var remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    };
    _proto.getRemoteIds = function getRemoteIds(iframe, ids) {
        var _this = this;
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map(function(id) {
            return _this.getRemoteId(iframe, id, remoteIdToIdMap);
        });
    };
    _proto.reset = function reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    };
    _proto.getIdToRemoteIdMap = function getIdToRemoteIdMap(iframe) {
        var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    };
    _proto.getRemoteIdToIdMap = function getRemoteIdToIdMap(iframe) {
        var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    };
    return CrossOriginIframeMirror;
}();
var $6fb9842575b03497$var$IframeManager = /*#__PURE__*/ function() {
    function IframeManager(options) {
        $6fb9842575b03497$var$__publicField(this, "iframes", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "crossOriginIframeMirror", new $6fb9842575b03497$var$CrossOriginIframeMirror($6fb9842575b03497$var$genId));
        $6fb9842575b03497$var$__publicField(this, "crossOriginIframeStyleMirror");
        $6fb9842575b03497$var$__publicField(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "mirror");
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "wrappedEmit");
        $6fb9842575b03497$var$__publicField(this, "loadListener");
        $6fb9842575b03497$var$__publicField(this, "stylesheetManager");
        $6fb9842575b03497$var$__publicField(this, "recordCrossOriginIframes");
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $6fb9842575b03497$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    var _proto = IframeManager.prototype;
    _proto.addIframe = function addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    };
    _proto.addLoadListener = function addLoadListener(cb) {
        this.loadListener = cb;
    };
    _proto.attachIframe = function attachIframe(iframeEl, childSn) {
        var _a2, _b;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) (_a2 = iframeEl.contentWindow) == null || _a2.addEventListener("message", this.handleMessage.bind(this));
        (_b = this.loadListener) == null || _b.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    };
    _proto.handleMessage = function handleMessage(message) {
        var crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        var iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        var iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    };
    _proto.transformCrossOriginEvent = function transformCrossOriginEvent(iframeEl, e2) {
        var _this = this;
        var _a2;
        switch(e2.type){
            case $6fb9842575b03497$var$EventType.FullSnapshot:
                this.crossOriginIframeMirror.reset(iframeEl);
                this.crossOriginIframeStyleMirror.reset(iframeEl);
                this.replaceIdOnNode(e2.data.node, iframeEl);
                var rootId = e2.data.node.id;
                this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                this.patchRootIdOnNode(e2.data.node, rootId);
                return {
                    timestamp: e2.timestamp,
                    type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                    data: {
                        source: $6fb9842575b03497$var$IncrementalSource.Mutation,
                        adds: [
                            {
                                parentId: this.mirror.getId(iframeEl),
                                nextId: null,
                                node: e2.data.node
                            }
                        ],
                        removes: [],
                        texts: [],
                        attributes: [],
                        isAttachIframe: true
                    }
                };
            case $6fb9842575b03497$var$EventType.Meta:
            case $6fb9842575b03497$var$EventType.Load:
            case $6fb9842575b03497$var$EventType.DomContentLoaded:
                return false;
            case $6fb9842575b03497$var$EventType.Plugin:
                return e2;
            case $6fb9842575b03497$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $6fb9842575b03497$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $6fb9842575b03497$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            _this.replaceIdOnNode(n2.node, iframeEl);
                            var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && _this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.Drag:
                    case $6fb9842575b03497$var$IncrementalSource.TouchMove:
                    case $6fb9842575b03497$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach(function(p) {
                            _this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.ViewportResize:
                        return false;
                    case $6fb9842575b03497$var$IncrementalSource.MediaInteraction:
                    case $6fb9842575b03497$var$IncrementalSource.MouseInteraction:
                    case $6fb9842575b03497$var$IncrementalSource.Scroll:
                    case $6fb9842575b03497$var$IncrementalSource.CanvasMutation:
                    case $6fb9842575b03497$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.StyleSheetRule:
                    case $6fb9842575b03497$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.Font:
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach(function(range) {
                            _this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        (_a2 = e2.data.styles) == null || _a2.forEach(function(style) {
                            _this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    };
    _proto.replace = function replace(iframeMirror, obj, iframeEl, keys) {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(keys), _step; !(_step = _iterator()).done;){
            var key = _step.value;
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    };
    _proto.replaceIds = function replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    };
    _proto.replaceStyleIds = function replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    };
    _proto.replaceIdOnNode = function replaceIdOnNode(node2, iframeEl) {
        var _this = this;
        this.replaceIds(node2, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.replaceIdOnNode(child, iframeEl);
        });
    };
    _proto.patchRootIdOnNode = function patchRootIdOnNode(node2, rootId) {
        var _this = this;
        if (node2.type !== $6fb9842575b03497$var$NodeType.Document && !node2.rootId) node2.rootId = rootId;
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.patchRootIdOnNode(child, rootId);
        });
    };
    return IframeManager;
}();
var $6fb9842575b03497$var$ShadowDomManager = /*#__PURE__*/ function() {
    function ShadowDomManager(options) {
        $6fb9842575b03497$var$__publicField(this, "shadowDoms", /* @__PURE__ */ new WeakSet());
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "scrollCb");
        $6fb9842575b03497$var$__publicField(this, "bypassOptions");
        $6fb9842575b03497$var$__publicField(this, "mirror");
        $6fb9842575b03497$var$__publicField(this, "restoreHandlers", []);
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    var _proto = ShadowDomManager.prototype;
    _proto.init = function init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    };
    _proto.addShadowRoot = function addShadowRoot(shadowRoot2, doc) {
        var _this = this;
        if (!$6fb9842575b03497$var$isNativeShadowDom(shadowRoot2)) return;
        if (this.shadowDoms.has(shadowRoot2)) return;
        this.shadowDoms.add(shadowRoot2);
        var observer = $6fb9842575b03497$var$initMutationObserver($6fb9842575b03497$var$_extends({}, this.bypassOptions, {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot2);
        this.restoreHandlers.push(function() {
            return observer.disconnect();
        });
        this.restoreHandlers.push($6fb9842575b03497$var$initScrollObserver($6fb9842575b03497$var$_extends({}, this.bypassOptions, {
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot2,
            mirror: this.mirror
        })));
        setTimeout(function() {
            if (shadowRoot2.adoptedStyleSheets && shadowRoot2.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot2.adoptedStyleSheets, _this.mirror.getId($6fb9842575b03497$var$index.host(shadowRoot2)));
            _this.restoreHandlers.push($6fb9842575b03497$var$initAdoptedStyleSheetObserver({
                mirror: _this.mirror,
                stylesheetManager: _this.bypassOptions.stylesheetManager
            }, shadowRoot2));
        }, 0);
    };
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ _proto.observeAttachShadow = function observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    };
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ _proto.patchAttachShadow = function patchAttachShadow(element, doc) {
        var manager = this;
        this.restoreHandlers.push($6fb9842575b03497$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                var sRoot = original.call(this, option);
                var shadowRootEl = $6fb9842575b03497$var$index.shadowRoot(this);
                if (shadowRootEl && $6fb9842575b03497$var$inDom(this)) manager.addShadowRoot(shadowRootEl, doc);
                return sRoot;
            };
        }));
    };
    _proto.reset = function reset() {
        this.restoreHandlers.forEach(function(handler) {
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
    };
    return ShadowDomManager;
}();
var $6fb9842575b03497$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $6fb9842575b03497$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $6fb9842575b03497$var$i$1 = 0; $6fb9842575b03497$var$i$1 < $6fb9842575b03497$var$chars.length; $6fb9842575b03497$var$i$1++)$6fb9842575b03497$var$lookup[$6fb9842575b03497$var$chars.charCodeAt($6fb9842575b03497$var$i$1)] = $6fb9842575b03497$var$i$1;
var $6fb9842575b03497$var$encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $6fb9842575b03497$var$chars[bytes[i2] >> 2];
        base64 += $6fb9842575b03497$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $6fb9842575b03497$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $6fb9842575b03497$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $6fb9842575b03497$var$canvasVarMap = /* @__PURE__ */ new Map();
function $6fb9842575b03497$var$variableListFor$1(ctx, ctor) {
    var contextMap = $6fb9842575b03497$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $6fb9842575b03497$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var $6fb9842575b03497$var$saveWebGLVar = function(value, win, ctx) {
    if (!value || !($6fb9842575b03497$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value)) === "object")) return;
    var name = value.constructor.name;
    var list2 = $6fb9842575b03497$var$variableListFor$1(ctx, name);
    var index2 = list2.indexOf(value);
    if (index2 === -1) {
        index2 = list2.length;
        list2.push(value);
    }
    return index2;
};
function $6fb9842575b03497$var$serializeArg(value, win, ctx) {
    if ($6fb9842575b03497$var$_instanceof(value, Array)) return value.map(function(arg) {
        return $6fb9842575b03497$var$serializeArg(arg, win, ctx);
    });
    else if (value === null) return value;
    else if ($6fb9842575b03497$var$_instanceof(value, Float32Array) || $6fb9842575b03497$var$_instanceof(value, Float64Array) || $6fb9842575b03497$var$_instanceof(value, Int32Array) || $6fb9842575b03497$var$_instanceof(value, Uint32Array) || $6fb9842575b03497$var$_instanceof(value, Uint8Array) || $6fb9842575b03497$var$_instanceof(value, Uint16Array) || $6fb9842575b03497$var$_instanceof(value, Int16Array) || $6fb9842575b03497$var$_instanceof(value, Int8Array) || $6fb9842575b03497$var$_instanceof(value, Uint8ClampedArray)) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    $6fb9842575b03497$var$_instanceof(value, ArrayBuffer)) {
        var name1 = value.constructor.name;
        var base64 = $6fb9842575b03497$var$encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if ($6fb9842575b03497$var$_instanceof(value, DataView)) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                $6fb9842575b03497$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if ($6fb9842575b03497$var$_instanceof(value, HTMLImageElement)) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if ($6fb9842575b03497$var$_instanceof(value, HTMLCanvasElement)) {
        var name4 = "HTMLImageElement";
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if ($6fb9842575b03497$var$_instanceof(value, ImageData)) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                $6fb9842575b03497$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($6fb9842575b03497$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value)) === "object") {
        var name6 = value.constructor.name;
        var index2 = $6fb9842575b03497$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index2
        };
    }
    return value;
}
var $6fb9842575b03497$var$serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return $6fb9842575b03497$var$serializeArg(arg, win, ctx);
    });
};
var $6fb9842575b03497$var$isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === "function";
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return $6fb9842575b03497$var$_instanceof(value, win[name]);
    }));
};
function $6fb9842575b03497$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    var _loop = function() {
        var prop = _step.value;
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") return "continue";
            var restoreHandler = $6fb9842575b03497$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                return function() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    if (!$6fb9842575b03497$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(function() {
                        var recordArgs = $6fb9842575b03497$var$serializeArgs(args, win, _this);
                        cb(_this.canvas, {
                            type: $6fb9842575b03497$var$CanvasContext["2D"],
                            property: prop,
                            args: recordArgs
                        });
                    }, 0);
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $6fb9842575b03497$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: $6fb9842575b03497$var$CanvasContext["2D"],
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(props2D), _step; !(_step = _iterator()).done;)_loop();
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $6fb9842575b03497$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = $6fb9842575b03497$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (!$6fb9842575b03497$var$isBlocked(this, blockClass, blockSelector, true)) {
                    var ctxName = $6fb9842575b03497$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && $6fb9842575b03497$var$_type_of(args[0]) === "object") {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [].concat([
                    contextType
                ], args));
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $6fb9842575b03497$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, win) {
    var _loop = function() {
        var prop = _step.value;
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) return "continue";
        try {
            if (typeof prototype[prop] !== "function") return "continue";
            var restoreHandler = $6fb9842575b03497$var$patch(prototype, prop, function(original) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var result2 = original.apply(this, args);
                    $6fb9842575b03497$var$saveWebGLVar(result2, win, this);
                    if ("tagName" in this.canvas && !$6fb9842575b03497$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        var recordArgs = $6fb9842575b03497$var$serializeArgs(args, win, this);
                        var mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result2;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $6fb9842575b03497$var$hookSetter(prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(props), _step; !(_step = _iterator()).done;)_loop();
    return handlers;
}
function $6fb9842575b03497$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector) {
    var _handlers;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, [].concat($6fb9842575b03497$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $6fb9842575b03497$var$CanvasContext.WebGL, cb, blockClass, blockSelector, win)));
    if (typeof win.WebGL2RenderingContext !== "undefined") {
        var _handlers1;
        (_handlers1 = handlers).push.apply(_handlers1, [].concat($6fb9842575b03497$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $6fb9842575b03497$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, win)));
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var $6fb9842575b03497$var$encodedJs = "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";
var $6fb9842575b03497$var$decodeBase64 = function(base64) {
    return Uint8Array.from(atob(base64), function(c2) {
        return c2.charCodeAt(0);
    });
};
var $6fb9842575b03497$var$blob = typeof window !== "undefined" && window.Blob && new Blob([
    $6fb9842575b03497$var$decodeBase64($6fb9842575b03497$var$encodedJs)
], {
    type: "text/javascript;charset=utf-8"
});
function $6fb9842575b03497$var$WorkerWrapper(options) {
    var objURL;
    try {
        objURL = $6fb9842575b03497$var$blob && (window.URL || window.webkitURL).createObjectURL($6fb9842575b03497$var$blob);
        if (!objURL) throw "";
        var worker = new Worker(objURL, {
            name: options == null ? void 0 : options.name
        });
        worker.addEventListener("error", function() {
            (window.URL || window.webkitURL).revokeObjectURL(objURL);
        });
        return worker;
    } catch (e2) {
        return new Worker("data:text/javascript;base64," + $6fb9842575b03497$var$encodedJs, {
            name: options == null ? void 0 : options.name
        });
    } finally{
        objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
    }
}
var $6fb9842575b03497$var$CanvasManager = /*#__PURE__*/ function() {
    function CanvasManager(options) {
        var _this = this;
        $6fb9842575b03497$var$__publicField(this, "pendingCanvasMutations", /* @__PURE__ */ new Map());
        $6fb9842575b03497$var$__publicField(this, "rafStamps", {
            latestId: 0,
            invokeId: null
        });
        $6fb9842575b03497$var$__publicField(this, "mirror");
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "resetObservers");
        $6fb9842575b03497$var$__publicField(this, "frozen", false);
        $6fb9842575b03497$var$__publicField(this, "locked", false);
        $6fb9842575b03497$var$__publicField(this, "processMutation", function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) _this.pendingCanvasMutations.set(target, []);
            _this.pendingCanvasMutations.get(target).push(mutation);
        });
        var _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? "all" : _options_sampling, win = options.win, blockClass = options.blockClass, blockSelector = options.blockSelector, recordCanvas = options.recordCanvas, dataURLOptions = options.dataURLOptions;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    var _proto = CanvasManager.prototype;
    _proto.reset = function reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
    };
    _proto.lock = function lock() {
        this.locked = true;
    };
    _proto.unlock = function unlock() {
        this.locked = false;
    };
    _proto.initCanvasFPSObserver = function initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        var _this = this;
        var canvasContextReset = $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
        var snapshotInProgressMap = /* @__PURE__ */ new Map();
        var worker = new $6fb9842575b03497$var$WorkerWrapper();
        worker.onmessage = function(e2) {
            var id = e2.data.id;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in e2.data)) return;
            var _e2_data = e2.data, base64 = _e2_data.base64, type = _e2_data.type, width = _e2_data.width, height = _e2_data.height;
            _this.mutationCb({
                id: id,
                type: $6fb9842575b03497$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        var timeBetweenSnapshots = 1e3 / fps;
        var lastSnapshotTime = 0;
        var rafId;
        var getCanvas = function() {
            var matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach(function(canvas) {
                if (!$6fb9842575b03497$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        var takeCanvasSnapshots = function(timestamp) {
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            var _this1 = _this;
            getCanvas().forEach(/*#__PURE__*/ $6fb9842575b03497$var$_async_to_generator(function(canvas) {
                var _a2, id, context, bitmap;
                return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = _this1.mirror.getId(canvas);
                            if (snapshotInProgressMap.get(id)) return [
                                2
                            ];
                            if (canvas.width === 0 || canvas.height === 0) return [
                                2
                            ];
                            snapshotInProgressMap.set(id, true);
                            if ([
                                "webgl",
                                "webgl2"
                            ].includes(canvas.__context)) {
                                context = canvas.getContext(canvas.__context);
                                if (((_a2 = context == null ? void 0 : context.getContextAttributes()) == null ? void 0 : _a2.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                            }
                            return [
                                4,
                                createImageBitmap(canvas)
                            ];
                        case 1:
                            bitmap = _state.sent();
                            worker.postMessage({
                                id: id,
                                bitmap: bitmap,
                                width: canvas.width,
                                height: canvas.height,
                                dataURLOptions: options.dataURLOptions
                            }, [
                                bitmap
                            ]);
                            return [
                                2
                            ];
                    }
                });
            }));
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = function() {
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    };
    _proto.initCanvasMutationObserver = function initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        var canvasContextReset = $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
        var canvas2DReset = $6fb9842575b03497$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        var canvasWebGL1and2Reset = $6fb9842575b03497$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        this.resetObservers = function() {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    };
    _proto.startPendingCanvasMutationFlusher = function startPendingCanvasMutationFlusher() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.startRAFTimestamping = function startRAFTimestamping() {
        var _this = this;
        var setLatestRAFTimestamp = function(timestamp) {
            _this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    };
    _proto.flushPendingCanvasMutations = function flushPendingCanvasMutations() {
        var _this = this;
        this.pendingCanvasMutations.forEach(function(_values, canvas) {
            var id = _this.mirror.getId(canvas);
            _this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.flushPendingCanvasMutationFor = function flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        var valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        var values = valuesWithType.map(function(value) {
            value.type;
            var rest = $6fb9842575b03497$var$_object_without_properties_loose(value, [
                "type"
            ]);
            return rest;
        });
        var type = valuesWithType[0].type;
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    };
    return CanvasManager;
}();
var $6fb9842575b03497$var$StylesheetManager = /*#__PURE__*/ function() {
    function StylesheetManager(options) {
        $6fb9842575b03497$var$__publicField(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet());
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "adoptedStyleSheetCb");
        $6fb9842575b03497$var$__publicField(this, "styleMirror", new $6fb9842575b03497$var$StyleSheetMirror());
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    var _proto = StylesheetManager.prototype;
    _proto.attachLinkElement = function attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    };
    _proto.trackLinkElement = function trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    };
    _proto.adoptStyleSheets = function adoptStyleSheets(sheets, hostId) {
        var _this, _loop = function() {
            var sheet = _step.value;
            var styleId = void 0;
            if (!_this.styleMirror.has(sheet)) {
                styleId = _this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, function(r2, index2) {
                        return {
                            rule: $6fb9842575b03497$var$stringifyRule(r2, sheet.href),
                            index: index2
                        };
                    })
                });
            } else styleId = _this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        };
        if (sheets.length === 0) return;
        var adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        var styles = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(sheets), _step; !(_step = _iterator()).done;)_this = this, _loop();
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    };
    _proto.reset = function reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    };
    // TODO: take snapshot on stylesheet reload by applying event listener
    _proto.trackStylesheetInLinkElement = function trackStylesheetInLinkElement(_linkEl) {};
    return StylesheetManager;
}();
var $6fb9842575b03497$var$ProcessedNodeManager = /*#__PURE__*/ function() {
    function ProcessedNodeManager() {
        $6fb9842575b03497$var$__publicField(this, "nodeMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "active", false);
    }
    var _proto = ProcessedNodeManager.prototype;
    _proto.inOtherBuffer = function inOtherBuffer(node2, thisBuffer) {
        var buffers = this.nodeMap.get(node2);
        return buffers && Array.from(buffers).some(function(buffer) {
            return buffer !== thisBuffer;
        });
    };
    _proto.add = function add(node2, buffer) {
        var _this = this;
        if (!this.active) {
            this.active = true;
            requestAnimationFrame(function() {
                _this.nodeMap = /* @__PURE__ */ new WeakMap();
                _this.active = false;
            });
        }
        this.nodeMap.set(node2, (this.nodeMap.get(node2) || /* @__PURE__ */ new Set()).add(buffer));
    };
    _proto.destroy = function destroy() {};
    return ProcessedNodeManager;
}();
var $6fb9842575b03497$var$wrappedEmit;
var $6fb9842575b03497$var$takeFullSnapshot$1;
var $6fb9842575b03497$var$canvasManager;
var $6fb9842575b03497$var$recording = false;
try {
    if (Array.from([
        1
    ], function(x2) {
        return x2 * 2;
    })[0] !== 2) {
        var $6fb9842575b03497$var$cleanFrame = document.createElement("iframe");
        document.body.appendChild($6fb9842575b03497$var$cleanFrame);
        Array.from = (($6fb9842575b03497$var$_a = $6fb9842575b03497$var$cleanFrame.contentWindow) == null ? void 0 : $6fb9842575b03497$var$_a.Array.from) || Array.from;
        document.body.removeChild($6fb9842575b03497$var$cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
var $6fb9842575b03497$var$mirror = $6fb9842575b03497$var$createMirror$2();
function $6fb9842575b03497$var$record(options) {
    if (options === void 0) options = {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? "rr-block" : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? "rr-ignore" : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? "rr-mask" : _options_maskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, hooks = options.hooks, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordDOM = options.recordDOM, recordDOM = _options_recordDOM === void 0 ? true : _options_recordDOM, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load" : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _options_ignoreCSSAttributes, errorHandler2 = options.errorHandler;
    $6fb9842575b03497$var$registerErrorHandler(errorHandler2);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return function() {};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $6fb9842575b03497$var$mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {
        password: true
    };
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all",
        headTitleMutations: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $6fb9842575b03497$var$polyfill$1();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e2) {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
            var plugin3 = _step.value;
            if (plugin3.eventProcessor) e2 = plugin3.eventProcessor(e2);
        }
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $6fb9842575b03497$var$wrappedEmit = function(r2, isCheckout) {
        var _a2;
        var e2 = r2;
        e2.timestamp = $6fb9842575b03497$var$nowTimestamp();
        if (((_a2 = $6fb9842575b03497$var$mutationBuffers[0]) == null ? void 0 : _a2.isFrozen()) && e2.type !== $6fb9842575b03497$var$EventType.FullSnapshot && !(e2.type === $6fb9842575b03497$var$EventType.IncrementalSnapshot && e2.data.source === $6fb9842575b03497$var$IncrementalSource.Mutation)) $6fb9842575b03497$var$mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) emit == null || emit(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            var message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $6fb9842575b03497$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $6fb9842575b03497$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $6fb9842575b03497$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $6fb9842575b03497$var$takeFullSnapshot$1(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
            data: $6fb9842575b03497$var$_extends({
                source: $6fb9842575b03497$var$IncrementalSource.Mutation
            }, m)
        });
    };
    var wrappedScrollEmit = function(p) {
        return $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
            data: $6fb9842575b03497$var$_extends({
                source: $6fb9842575b03497$var$IncrementalSource.Scroll
            }, p)
        });
    };
    var wrappedCanvasMutationEmit = function(p) {
        return $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
            data: $6fb9842575b03497$var$_extends({
                source: $6fb9842575b03497$var$IncrementalSource.CanvasMutation
            }, p)
        });
    };
    var wrappedAdoptedStyleSheetEmit = function(a2) {
        return $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
            data: $6fb9842575b03497$var$_extends({
                source: $6fb9842575b03497$var$IncrementalSource.AdoptedStyleSheet
            }, a2)
        });
    };
    var stylesheetManager = new $6fb9842575b03497$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = new $6fb9842575b03497$var$IframeManager({
        mirror: $6fb9842575b03497$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $6fb9842575b03497$var$wrappedEmit
    });
    for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        if (plugin3.getMirror) plugin3.getMirror({
            nodeMirror: $6fb9842575b03497$var$mirror,
            crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
            crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
        });
    }
    var processedNodeManager = new $6fb9842575b03497$var$ProcessedNodeManager();
    $6fb9842575b03497$var$canvasManager = new $6fb9842575b03497$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $6fb9842575b03497$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    var shadowDomManager = new $6fb9842575b03497$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $6fb9842575b03497$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $6fb9842575b03497$var$mirror
    });
    $6fb9842575b03497$var$takeFullSnapshot$1 = function(isCheckout) {
        if (isCheckout === void 0) isCheckout = false;
        if (!recordDOM) return;
        $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $6fb9842575b03497$var$getWindowWidth(),
                height: $6fb9842575b03497$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $6fb9842575b03497$var$mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node2 = $6fb9842575b03497$var$snapshot(document, {
            mirror: $6fb9842575b03497$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n2) {
                if ($6fb9842575b03497$var$isSerializedIframe(n2, $6fb9842575b03497$var$mirror)) iframeManager.addIframe(n2);
                if ($6fb9842575b03497$var$isSerializedStylesheet(n2, $6fb9842575b03497$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($6fb9842575b03497$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot($6fb9842575b03497$var$index.shadowRoot(n2), document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node2) return console.warn("Failed to snapshot the document");
        $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.FullSnapshot,
            data: {
                node: node2,
                initialOffset: $6fb9842575b03497$var$getWindowScroll(window)
            }
        }, isCheckout);
        $6fb9842575b03497$var$mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $6fb9842575b03497$var$mirror.getId(document));
    };
    try {
        var handlers = [];
        var observe = function(doc) {
            var _a2;
            return $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    });
                },
                mouseInteractionCb: function(d) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.MouseInteraction
                        }, d)
                    });
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.ViewportResize
                        }, d)
                    });
                },
                inputCb: function(v2) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.Input
                        }, v2)
                    });
                },
                mediaInteractionCb: function(p) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.MediaInteraction
                        }, p)
                    });
                },
                styleSheetRuleCb: function(r2) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.StyleSheetRule
                        }, r2)
                    });
                },
                styleDeclarationCb: function(r2) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.StyleDeclaration
                        }, r2)
                    });
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.Font
                        }, p)
                    });
                },
                selectionCb: function(p) {
                    $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: function(c2) {
                    $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.CustomElement
                        }, c2)
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $6fb9842575b03497$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $6fb9842575b03497$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a2 = plugins == null ? void 0 : plugins.filter(function(p) {
                    return p.observer;
                })) == null ? void 0 : _a2.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return $6fb9842575b03497$var$wrappedEmit({
                                type: $6fb9842575b03497$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            });
                        }
                    };
                })) || []
            }, hooks);
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            $6fb9842575b03497$var$takeFullSnapshot$1();
            handlers.push(observe(document));
            $6fb9842575b03497$var$recording = true;
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($6fb9842575b03497$var$on("DOMContentLoaded", function() {
                $6fb9842575b03497$var$wrappedEmit({
                    type: $6fb9842575b03497$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($6fb9842575b03497$var$on("load", function() {
                $6fb9842575b03497$var$wrappedEmit({
                    type: $6fb9842575b03497$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return function() {
            handlers.forEach(function(h) {
                return h();
            });
            processedNodeManager.destroy();
            $6fb9842575b03497$var$recording = false;
            $6fb9842575b03497$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$6fb9842575b03497$var$record.addCustomEvent = function(tag, payload) {
    if (!$6fb9842575b03497$var$recording) throw new Error("please add custom event after start recording");
    $6fb9842575b03497$var$wrappedEmit({
        type: $6fb9842575b03497$var$EventType.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    });
};
$6fb9842575b03497$var$record.freezePage = function() {
    $6fb9842575b03497$var$mutationBuffers.forEach(function(buf) {
        return buf.freeze();
    });
};
$6fb9842575b03497$var$record.takeFullSnapshot = function(isCheckout) {
    if (!$6fb9842575b03497$var$recording) throw new Error("please take full snapshot after start recording");
    $6fb9842575b03497$var$takeFullSnapshot$1(isCheckout);
};
$6fb9842575b03497$var$record.mirror = $6fb9842575b03497$var$mirror;
var $6fb9842575b03497$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($6fb9842575b03497$var$n || ($6fb9842575b03497$var$n = {}));
$6fb9842575b03497$var$record.addCustomEvent;
$6fb9842575b03497$var$record.freezePage;
$6fb9842575b03497$var$record.takeFullSnapshot;
var $6fb9842575b03497$var$setImmediate = $6fb9842575b03497$var$win['setImmediate'];
var $6fb9842575b03497$var$builtInProp, $6fb9842575b03497$var$cycle, $6fb9842575b03497$var$schedulingQueue, $6fb9842575b03497$var$ToString = Object.prototype.toString, $6fb9842575b03497$var$timer = typeof $6fb9842575b03497$var$setImmediate !== 'undefined' ? function timer(fn) {
    return $6fb9842575b03497$var$setImmediate(fn);
} : setTimeout;
// dammit, IE8.
try {
    Object.defineProperty({}, 'x', {});
    $6fb9842575b03497$var$builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
            value: val,
            writable: true,
            configurable: config !== false
        });
    };
} catch (err) {
    $6fb9842575b03497$var$builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
    };
}
// Note: using a queue instead of array for efficiency
$6fb9842575b03497$var$schedulingQueue = function Queue() {
    var first, last, item;
    function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
    }
    return {
        add: function add(fn, self) {
            item = new Item(fn, self);
            if (last) last.next = item;
            else first = item;
            last = item;
            item = void 0;
        },
        drain: function drain() {
            var f = first;
            first = last = $6fb9842575b03497$var$cycle = void 0;
            while(f){
                f.fn.call(f.self);
                f = f.next;
            }
        }
    };
}();
function $6fb9842575b03497$var$schedule(fn, self) {
    $6fb9842575b03497$var$schedulingQueue.add(fn, self);
    if (!$6fb9842575b03497$var$cycle) $6fb9842575b03497$var$cycle = $6fb9842575b03497$var$timer($6fb9842575b03497$var$schedulingQueue.drain);
}
// promise duck typing
function $6fb9842575b03497$var$isThenable(o) {
    var _then, oType = typeof o;
    if (o !== null && (oType === 'object' || oType === 'function')) _then = o.then;
    return typeof _then === 'function' ? _then : false;
}
function $6fb9842575b03497$var$notify() {
    for(var i = 0; i < this.chain.length; i++)$6fb9842575b03497$var$notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    this.chain.length = 0;
}
// NOTE: This is a separate function to isolate
// the `try..catch` so that other code can be
// optimized better
function $6fb9842575b03497$var$notifyIsolated(self, cb, chain) {
    var ret, _then;
    try {
        if (cb === false) chain.reject(self.msg);
        else {
            if (cb === true) ret = self.msg;
            else ret = cb.call(void 0, self.msg);
            if (ret === chain.promise) chain.reject(TypeError('Promise-chain cycle'));
            else if (_then = $6fb9842575b03497$var$isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
            else chain.resolve(ret);
        }
    } catch (err) {
        chain.reject(err);
    }
}
function $6fb9842575b03497$var$resolve(msg) {
    var _then, self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    try {
        // eslint-disable-next-line no-cond-assign
        if (_then = $6fb9842575b03497$var$isThenable(msg)) $6fb9842575b03497$var$schedule(function() {
            var defWrapper = new $6fb9842575b03497$var$MakeDefWrapper(self);
            try {
                _then.call(msg, function $resolve$() {
                    $6fb9842575b03497$var$resolve.apply(defWrapper, arguments);
                }, function $reject$() {
                    $6fb9842575b03497$var$reject.apply(defWrapper, arguments);
                });
            } catch (err) {
                $6fb9842575b03497$var$reject.call(defWrapper, err);
            }
        });
        else {
            self.msg = msg;
            self.state = 1;
            if (self.chain.length > 0) $6fb9842575b03497$var$schedule($6fb9842575b03497$var$notify, self);
        }
    } catch (err) {
        $6fb9842575b03497$var$reject.call(new $6fb9842575b03497$var$MakeDefWrapper(self), err);
    }
}
function $6fb9842575b03497$var$reject(msg) {
    var self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    self.msg = msg;
    self.state = 2;
    if (self.chain.length > 0) $6fb9842575b03497$var$schedule($6fb9842575b03497$var$notify, self);
}
function $6fb9842575b03497$var$iteratePromises(Constructor, arr, resolver, rejecter) {
    for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
        }, rejecter);
    })(idx);
}
function $6fb9842575b03497$var$MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
}
function $6fb9842575b03497$var$MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
}
function $6fb9842575b03497$var$NpoPromise(executor) {
    if (typeof executor !== 'function') throw TypeError('Not a function');
    if (this['__NPO__'] !== 0) throw TypeError('Not a promise');
    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this['__NPO__'] = 1;
    var def = new $6fb9842575b03497$var$MakeDef(this);
    this['then'] = function then(success, failure) {
        var o = {
            success: typeof success === 'function' ? success : true,
            failure: typeof failure === 'function' ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
            if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
            o.resolve = resolve;
            o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) $6fb9842575b03497$var$schedule($6fb9842575b03497$var$notify, def);
        return o.promise;
    };
    this['catch'] = function $catch$(failure) {
        return this.then(void 0, failure);
    };
    try {
        executor.call(void 0, function publicResolve(msg) {
            $6fb9842575b03497$var$resolve.call(def, msg);
        }, function publicReject(msg) {
            $6fb9842575b03497$var$reject.call(def, msg);
        });
    } catch (err) {
        $6fb9842575b03497$var$reject.call(def, err);
    }
}
var $6fb9842575b03497$var$PromisePrototype = $6fb9842575b03497$var$builtInProp({}, 'constructor', $6fb9842575b03497$var$NpoPromise, /*configurable=*/ false);
// Note: Android 4 cannot use `Object.defineProperty(..)` here
$6fb9842575b03497$var$NpoPromise.prototype = $6fb9842575b03497$var$PromisePrototype;
// built-in "brand" to signal an "uninitialized" promise
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$PromisePrototype, '__NPO__', 0, /*configurable=*/ false);
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$NpoPromise, 'resolve', function Promise$resolve(msg) {
    var Constructor = this;
    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && typeof msg === 'object' && msg['__NPO__'] === 1) return msg;
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        resolve(msg);
    });
});
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$NpoPromise, 'reject', function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        reject(msg);
    });
});
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$NpoPromise, 'all', function Promise$all(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($6fb9842575b03497$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    if (arr.length === 0) return Constructor.resolve([]);
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        var len = arr.length, msgs = Array(len), count = 0;
        $6fb9842575b03497$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            msgs[idx] = msg;
            if (++count === len) resolve(msgs);
        }, reject);
    });
});
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$NpoPromise, 'race', function Promise$race(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($6fb9842575b03497$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        $6fb9842575b03497$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            resolve(msg);
        }, reject);
    });
});
var $6fb9842575b03497$var$PromisePolyfill;
if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) $6fb9842575b03497$var$PromisePolyfill = Promise;
else $6fb9842575b03497$var$PromisePolyfill = $6fb9842575b03497$var$NpoPromise;
var $6fb9842575b03497$var$Config = {
    DEBUG: false,
    LIB_VERSION: '2.65.0'
};
/* eslint camelcase: "off", eqeqeq: "off" */ // Maximum allowed session recording length
var $6fb9842575b03497$var$MAX_RECORDING_MS = 86400000; // 24 hours
// Maximum allowed value for minimum session recording length
var $6fb9842575b03497$var$MAX_VALUE_FOR_MIN_RECORDING_MS = 8000; // 8 seconds
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $6fb9842575b03497$var$ArrayProto = Array.prototype, $6fb9842575b03497$var$FuncProto = Function.prototype, $6fb9842575b03497$var$ObjProto = Object.prototype, $6fb9842575b03497$var$slice = $6fb9842575b03497$var$ArrayProto.slice, $6fb9842575b03497$var$toString = $6fb9842575b03497$var$ObjProto.toString, $6fb9842575b03497$var$hasOwnProperty = $6fb9842575b03497$var$ObjProto.hasOwnProperty, $6fb9842575b03497$var$windowConsole = $6fb9842575b03497$var$win.console, $6fb9842575b03497$var$navigator = $6fb9842575b03497$var$win.navigator, $6fb9842575b03497$var$document$1 = $6fb9842575b03497$var$win.document, $6fb9842575b03497$var$windowOpera = $6fb9842575b03497$var$win.opera, $6fb9842575b03497$var$screen = $6fb9842575b03497$var$win.screen, $6fb9842575b03497$var$userAgent = $6fb9842575b03497$var$navigator.userAgent;
var $6fb9842575b03497$var$nativeBind = $6fb9842575b03497$var$FuncProto.bind, $6fb9842575b03497$var$nativeForEach = $6fb9842575b03497$var$ArrayProto.forEach, $6fb9842575b03497$var$nativeIndexOf = $6fb9842575b03497$var$ArrayProto.indexOf, $6fb9842575b03497$var$nativeMap = $6fb9842575b03497$var$ArrayProto.map, $6fb9842575b03497$var$nativeIsArray = Array.isArray, $6fb9842575b03497$var$breaker = {};
var $6fb9842575b03497$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
// Console override
var $6fb9842575b03497$var$console$1 = {
    /** @type {function(...*)} */ log: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) try {
            $6fb9842575b03497$var$windowConsole.log.apply($6fb9842575b03497$var$windowConsole, arguments);
        } catch (err) {
            $6fb9842575b03497$var$_.each(arguments, function(arg) {
                $6fb9842575b03497$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                'Mixpanel warning:'
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.warn.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.error.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.error.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $6fb9842575b03497$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply($6fb9842575b03497$var$console$1, arguments);
    };
};
var $6fb9842575b03497$var$console_with_prefix = function(prefix) {
    return {
        log: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.log, prefix),
        error: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.error, prefix),
        critical: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.critical, prefix)
    };
};
var $6fb9842575b03497$var$safewrap = function(f) {
    return function() {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            $6fb9842575b03497$var$console$1.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
            if ($6fb9842575b03497$var$Config.DEBUG) $6fb9842575b03497$var$console$1.critical(e);
        }
    };
};
var $6fb9842575b03497$var$safewrapClass = function(klass) {
    var proto = klass.prototype;
    for(var func in proto)if (typeof proto[func] === 'function') proto[func] = $6fb9842575b03497$var$safewrap(proto[func]);
};
// UNDERSCORE
// Embed part of the Underscore Library
$6fb9842575b03497$var$_.bind = function(func, context) {
    var args, bound;
    if ($6fb9842575b03497$var$nativeBind && func.bind === $6fb9842575b03497$var$nativeBind) return $6fb9842575b03497$var$nativeBind.apply(func, $6fb9842575b03497$var$slice.call(arguments, 1));
    if (!$6fb9842575b03497$var$_.isFunction(func)) throw new TypeError();
    args = $6fb9842575b03497$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($6fb9842575b03497$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($6fb9842575b03497$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $6fb9842575b03497$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($6fb9842575b03497$var$nativeForEach && obj.forEach === $6fb9842575b03497$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $6fb9842575b03497$var$breaker) return;
    }
    else {
        for(var key in obj)if ($6fb9842575b03497$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $6fb9842575b03497$var$breaker) return;
        }
    }
};
$6fb9842575b03497$var$_.extend = function(obj) {
    $6fb9842575b03497$var$_.each($6fb9842575b03497$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$6fb9842575b03497$var$_.isArray = $6fb9842575b03497$var$nativeIsArray || function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) === '[object Array]';
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$6fb9842575b03497$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$6fb9842575b03497$var$_.isArguments = function(obj) {
    return !!(obj && $6fb9842575b03497$var$hasOwnProperty.call(obj, 'callee'));
};
$6fb9842575b03497$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($6fb9842575b03497$var$_.isArray(iterable)) return $6fb9842575b03497$var$slice.call(iterable);
    if ($6fb9842575b03497$var$_.isArguments(iterable)) return $6fb9842575b03497$var$slice.call(iterable);
    return $6fb9842575b03497$var$_.values(iterable);
};
$6fb9842575b03497$var$_.map = function(arr, callback, context) {
    if ($6fb9842575b03497$var$nativeMap && arr.map === $6fb9842575b03497$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $6fb9842575b03497$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$6fb9842575b03497$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $6fb9842575b03497$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$6fb9842575b03497$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $6fb9842575b03497$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$6fb9842575b03497$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($6fb9842575b03497$var$nativeIndexOf && obj.indexOf === $6fb9842575b03497$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $6fb9842575b03497$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $6fb9842575b03497$var$breaker;
    });
    return found;
};
$6fb9842575b03497$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$6fb9842575b03497$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$6fb9842575b03497$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$6fb9842575b03497$var$_.isArray(obj);
};
$6fb9842575b03497$var$_.isEmptyObject = function(obj) {
    if ($6fb9842575b03497$var$_.isObject(obj)) {
        for(var key in obj){
            if ($6fb9842575b03497$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$6fb9842575b03497$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$6fb9842575b03497$var$_.isString = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == '[object String]';
};
$6fb9842575b03497$var$_.isDate = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == '[object Date]';
};
$6fb9842575b03497$var$_.isNumber = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == '[object Number]';
};
$6fb9842575b03497$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$6fb9842575b03497$var$_.encodeDates = function(obj) {
    $6fb9842575b03497$var$_.each(obj, function(v, k) {
        if ($6fb9842575b03497$var$_.isDate(v)) obj[k] = $6fb9842575b03497$var$_.formatDate(v);
        else if ($6fb9842575b03497$var$_.isObject(v)) obj[k] = $6fb9842575b03497$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$6fb9842575b03497$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$6fb9842575b03497$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};
$6fb9842575b03497$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $6fb9842575b03497$var$_.each(p, function(v, k) {
        if ($6fb9842575b03497$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $6fb9842575b03497$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === 'string') ret = obj.slice(0, length);
    else if ($6fb9842575b03497$var$_.isArray(obj)) {
        ret = [];
        $6fb9842575b03497$var$_.each(obj, function(val) {
            ret.push($6fb9842575b03497$var$_.truncate(val, length));
        });
    } else if ($6fb9842575b03497$var$_.isObject(obj)) {
        ret = {};
        $6fb9842575b03497$var$_.each(obj, function(val, key) {
            ret[key] = $6fb9842575b03497$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$6fb9842575b03497$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' && typeof value.toJSON === 'function') value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case 'string':
                    return quote(value);
                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';
                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return 'null';
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($6fb9842575b03497$var$toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || 'null';
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($6fb9842575b03497$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $6fb9842575b03497$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        'b': '\b',
        'f': '\f',
        'n': '\n',
        'r': '\r',
        't': '\t'
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = '';
        if (ch === '-') {
            string = '-';
            next('-');
        }
        while(ch >= '0' && ch <= '9'){
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while(next() && ch >= '0' && ch <= '9')string += ch;
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while(ch >= '0' && ch <= '9'){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error('Bad number');
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = '', uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === '\\') {
                next();
                if (ch === 'u') {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === 'string') string += escapee[ch];
                else break;
            } else string += ch;
        }
        error('Bad string');
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= ' ')next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) error('Syntax error');
        return result;
    };
}();
$6fb9842575b03497$var$_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) return data;
    data = $6fb9842575b03497$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join('');
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};
$6fb9842575b03497$var$_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '', start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$6fb9842575b03497$var$_.UUID = function() {
    try {
        // use native Crypto API when available
        return $6fb9842575b03497$var$win['crypto']['randomUUID']();
    } catch (err) {
        // fall back to generating our own UUID
        // based on https://gist.github.com/scwood/3bff42cc005cc20ab7ec98f0d8e1d59d
        var uuid = new Array(36);
        for(var i = 0; i < 36; i++)uuid[i] = Math.floor(Math.random() * 16);
        uuid[14] = 4; // set bits 12-15 of time-high-and-version to 0100
        uuid[19] = uuid[19] &= -5; // set bit 6 of clock-seq-and-reserved to zero
        uuid[19] = uuid[19] |= 8; // set bit 7 of clock-seq-and-reserved to one
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        return $6fb9842575b03497$var$_.map(uuid, function(x) {
            return x.toString(16);
        }).join('');
    }
};
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $6fb9842575b03497$var$BLOCKED_UA_STRS = [
    'ahrefsbot',
    'ahrefssiteaudit',
    'amazonbot',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'chrome-lighthouse',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandex',
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
$6fb9842575b03497$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $6fb9842575b03497$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($6fb9842575b03497$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $6fb9842575b03497$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($6fb9842575b03497$var$_.isUndefined(arg_separator)) arg_separator = '&';
    $6fb9842575b03497$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$6fb9842575b03497$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/g, '\\[').replace(/[\]]/g, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)', regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) return '';
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $6fb9842575b03497$var$console$1.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$6fb9842575b03497$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = $6fb9842575b03497$var$document$1.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $6fb9842575b03497$var$_.JSONDecode($6fb9842575b03497$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $6fb9842575b03497$var$extract_domain($6fb9842575b03497$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        $6fb9842575b03497$var$document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $6fb9842575b03497$var$extract_domain($6fb9842575b03497$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        $6fb9842575b03497$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $6fb9842575b03497$var$_.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $6fb9842575b03497$var$_testStorageSupported = function(storage) {
    var supported = true;
    try {
        var key = '__mplss_' + $6fb9842575b03497$var$cheap_guid(8), val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    return supported;
};
var $6fb9842575b03497$var$_localStorageSupported = null;
var $6fb9842575b03497$var$localStorageSupported = function(storage, forceCheck) {
    if ($6fb9842575b03497$var$_localStorageSupported !== null && !forceCheck) return $6fb9842575b03497$var$_localStorageSupported;
    return $6fb9842575b03497$var$_localStorageSupported = $6fb9842575b03497$var$_testStorageSupported(storage || $6fb9842575b03497$var$win.localStorage);
};
var $6fb9842575b03497$var$_sessionStorageSupported = null;
var $6fb9842575b03497$var$sessionStorageSupported = function(storage, forceCheck) {
    if ($6fb9842575b03497$var$_sessionStorageSupported !== null && !forceCheck) return $6fb9842575b03497$var$_sessionStorageSupported;
    return $6fb9842575b03497$var$_sessionStorageSupported = $6fb9842575b03497$var$_testStorageSupported(storage || $6fb9842575b03497$var$win.sessionStorage);
};
function $6fb9842575b03497$var$_storageWrapper(storage, name, is_supported_fn) {
    var log_error = function(msg) {
        $6fb9842575b03497$var$console$1.error(name + ' error: ' + msg);
    };
    return {
        is_supported: function(forceCheck) {
            var supported = is_supported_fn(storage, forceCheck);
            if (!supported) $6fb9842575b03497$var$console$1.error(name + ' unsupported');
            return supported;
        },
        error: log_error,
        get: function(key) {
            try {
                return storage.getItem(key);
            } catch (err) {
                log_error(err);
            }
            return null;
        },
        parse: function(key) {
            try {
                return $6fb9842575b03497$var$_.JSONDecode(storage.getItem(key)) || {};
            } catch (err) {
            // noop
            }
            return null;
        },
        set: function(key, value) {
            try {
                storage.setItem(key, value);
            } catch (err) {
                log_error(err);
            }
        },
        remove: function(key) {
            try {
                storage.removeItem(key);
            } catch (err) {
                log_error(err);
            }
        }
    };
}
$6fb9842575b03497$var$_.localStorage = $6fb9842575b03497$var$_storageWrapper($6fb9842575b03497$var$win.localStorage, 'localStorage', $6fb9842575b03497$var$localStorageSupported);
$6fb9842575b03497$var$_.sessionStorage = $6fb9842575b03497$var$_storageWrapper($6fb9842575b03497$var$win.sessionStorage, 'sessionStorage', $6fb9842575b03497$var$sessionStorageSupported);
$6fb9842575b03497$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $6fb9842575b03497$var$console$1.error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent($6fb9842575b03497$var$win.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($6fb9842575b03497$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $6fb9842575b03497$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$6fb9842575b03497$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$6fb9842575b03497$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $6fb9842575b03497$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = $6fb9842575b03497$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = '*';
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $6fb9842575b03497$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($6fb9842575b03497$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = '*';
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case '=':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($6fb9842575b03497$var$_.isElement(query)) return [
            query
        ];
        else if ($6fb9842575b03497$var$_.isObject(query) && !$6fb9842575b03497$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $6fb9842575b03497$var$CAMPAIGN_KEYWORDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_source_platform',
    'utm_campaign_id',
    'utm_creative_format',
    'utm_marketing_tactic'
];
var $6fb9842575b03497$var$CLICK_IDS = [
    'dclid',
    'fbclid',
    'gclid',
    'ko_click_id',
    'li_fat_id',
    'msclkid',
    'sccid',
    'ttclid',
    'twclid',
    'wbraid'
];
$6fb9842575b03497$var$_.info = {
    campaignParams: function(default_value) {
        var kw = '', params = {};
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $6fb9842575b03497$var$_.getQueryParam($6fb9842575b03497$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = '', params = {};
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$CLICK_IDS, function(idkey) {
            id = $6fb9842575b03497$var$_.getQueryParam($6fb9842575b03497$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.info.campaignParams(), $6fb9842575b03497$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) return 'google';
        else if (referrer.search('https?://(.*)bing.com') === 0) return 'bing';
        else if (referrer.search('https?://(.*)yahoo.com') === 0) return 'yahoo';
        else if (referrer.search('https?://(.*)duckduckgo.com') === 0) return 'duckduckgo';
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $6fb9842575b03497$var$_.info.searchEngine(referrer), param = search != 'yahoo' ? 'q' : 'p', ret = {};
        if (search !== null) {
            ret['$search_engine'] = search;
            var keyword = $6fb9842575b03497$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret['mp_keyword'] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || $6fb9842575b03497$var$_.includes(user_agent, ' OPR/')) {
            if ($6fb9842575b03497$var$_.includes(user_agent, 'Mini')) return 'Opera Mini';
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'IEMobile') || $6fb9842575b03497$var$_.includes(user_agent, 'WPDesktop')) return 'Internet Explorer Mobile';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'SamsungBrowser/')) // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Edge') || $6fb9842575b03497$var$_.includes(user_agent, 'Edg/')) return 'Microsoft Edge';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'FBIOS')) return 'Facebook Mobile';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Whale/')) // https://user-agents.net/browsers/whale-browser
        return 'Whale Browser';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Chrome')) return 'Chrome';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'CriOS')) return 'Chrome iOS';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'UCWEB') || $6fb9842575b03497$var$_.includes(user_agent, 'UCBrowser')) return 'UC Browser';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'FxiOS')) return 'Firefox iOS';
        else if ($6fb9842575b03497$var$_.includes(vendor, 'Apple')) {
            if ($6fb9842575b03497$var$_.includes(user_agent, 'Mobile')) return 'Mobile Safari';
            return 'Safari';
        } else if ($6fb9842575b03497$var$_.includes(user_agent, 'Android')) return 'Android Mobile';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Konqueror')) return 'Konqueror';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Firefox')) return 'Firefox';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'MSIE') || $6fb9842575b03497$var$_.includes(user_agent, 'Trident/')) return 'Internet Explorer';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Gecko')) return 'Mozilla';
        else return '';
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $6fb9842575b03497$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/,
            'Whale Browser': /Whale\/(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $6fb9842575b03497$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return 'Windows Phone';
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) return 'iOS';
        else if (/Android/.test(a)) return 'Android';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return 'BlackBerry';
        else if (/Mac/i.test(a)) return 'Mac OS X';
        else if (/Linux/.test(a)) return 'Linux';
        else if (/CrOS/.test(a)) return 'Chrome OS';
        else return '';
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return 'Windows Phone';
        else if (/iPad/.test(user_agent)) return 'iPad';
        else if (/iPod/.test(user_agent)) return 'iPod Touch';
        else if (/iPhone/.test(user_agent)) return 'iPhone';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (/Android/.test(user_agent)) return 'Android';
        else return '';
    },
    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) return split[2];
        return '';
    },
    currentUrl: function() {
        return $6fb9842575b03497$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== 'object') extra_props = {};
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.strip_empty_properties({
            '$os': $6fb9842575b03497$var$_.info.os(),
            '$browser': $6fb9842575b03497$var$_.info.browser($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera),
            '$referrer': $6fb9842575b03497$var$document$1.referrer,
            '$referring_domain': $6fb9842575b03497$var$_.info.referringDomain($6fb9842575b03497$var$document$1.referrer),
            '$device': $6fb9842575b03497$var$_.info.device($6fb9842575b03497$var$userAgent)
        }), {
            '$current_url': $6fb9842575b03497$var$_.info.currentUrl(),
            '$browser_version': $6fb9842575b03497$var$_.info.browserVersion($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera),
            '$screen_height': $6fb9842575b03497$var$screen.height,
            '$screen_width': $6fb9842575b03497$var$screen.width,
            'mp_lib': 'web',
            '$lib_version': $6fb9842575b03497$var$Config.LIB_VERSION,
            '$insert_id': $6fb9842575b03497$var$cheap_guid(),
            'time': $6fb9842575b03497$var$_.timestamp() / 1000 // epoch time in seconds
        }, $6fb9842575b03497$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.strip_empty_properties({
            '$os': $6fb9842575b03497$var$_.info.os(),
            '$browser': $6fb9842575b03497$var$_.info.browser($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera)
        }), {
            '$browser_version': $6fb9842575b03497$var$_.info.browserVersion($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $6fb9842575b03497$var$_.strip_empty_properties({
            'current_page_title': $6fb9842575b03497$var$document$1.title,
            'current_domain': $6fb9842575b03497$var$win.location.hostname,
            'current_url_path': $6fb9842575b03497$var$win.location.pathname,
            'current_url_protocol': $6fb9842575b03497$var$win.location.protocol,
            'current_url_search': $6fb9842575b03497$var$win.location.search
        });
    }
};
/**
 * Returns a throttled function that will only run at most every `waitMs` and returns a promise that resolves with the next invocation.
 * Throttled calls will build up a batch of args and invoke the callback with all args since the last invocation.
 */ var $6fb9842575b03497$var$batchedThrottle = function(fn, waitMs) {
    var timeoutPromise = null;
    var throttledItems = [];
    return function(item) {
        var self = this;
        throttledItems.push(item);
        if (!timeoutPromise) timeoutPromise = new $6fb9842575b03497$var$PromisePolyfill(function(resolve) {
            setTimeout(function() {
                var returnValue = fn.apply(self, [
                    throttledItems
                ]);
                timeoutPromise = null;
                throttledItems = [];
                resolve(returnValue);
            }, waitMs);
        });
        return timeoutPromise;
    };
};
var $6fb9842575b03497$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $6fb9842575b03497$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $6fb9842575b03497$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $6fb9842575b03497$var$extract_domain = function(hostname) {
    var domain_regex = $6fb9842575b03497$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') domain_regex = $6fb9842575b03497$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};
/**
 * Check whether we have network connection. default to true for browsers that don't support navigator.onLine (IE)
 * @returns {boolean}
 */ var $6fb9842575b03497$var$isOnline = function() {
    var onLine = $6fb9842575b03497$var$win.navigator['onLine'];
    return $6fb9842575b03497$var$_.isUndefined(onLine) || onLine;
};
var $6fb9842575b03497$var$NOOP_FUNC = function() {};
var $6fb9842575b03497$var$JSONStringify = null, $6fb9842575b03497$var$JSONParse = null;
if (typeof JSON !== 'undefined') {
    $6fb9842575b03497$var$JSONStringify = JSON.stringify;
    $6fb9842575b03497$var$JSONParse = JSON.parse;
}
$6fb9842575b03497$var$JSONStringify = $6fb9842575b03497$var$JSONStringify || $6fb9842575b03497$var$_.JSONEncode;
$6fb9842575b03497$var$JSONParse = $6fb9842575b03497$var$JSONParse || $6fb9842575b03497$var$_.JSONDecode;
// UNMINIFIED EXPORTS (for closure compiler)
$6fb9842575b03497$var$_['info'] = $6fb9842575b03497$var$_.info;
$6fb9842575b03497$var$_['info']['browser'] = $6fb9842575b03497$var$_.info.browser;
$6fb9842575b03497$var$_['info']['browserVersion'] = $6fb9842575b03497$var$_.info.browserVersion;
$6fb9842575b03497$var$_['info']['device'] = $6fb9842575b03497$var$_.info.device;
$6fb9842575b03497$var$_['info']['properties'] = $6fb9842575b03497$var$_.info.properties;
$6fb9842575b03497$var$_['isBlockedUA'] = $6fb9842575b03497$var$_.isBlockedUA;
$6fb9842575b03497$var$_['isEmptyObject'] = $6fb9842575b03497$var$_.isEmptyObject;
$6fb9842575b03497$var$_['isObject'] = $6fb9842575b03497$var$_.isObject;
$6fb9842575b03497$var$_['JSONDecode'] = $6fb9842575b03497$var$_.JSONDecode;
$6fb9842575b03497$var$_['JSONEncode'] = $6fb9842575b03497$var$_.JSONEncode;
$6fb9842575b03497$var$_['toArray'] = $6fb9842575b03497$var$_.toArray;
$6fb9842575b03497$var$_['NPO'] = $6fb9842575b03497$var$NpoPromise;
var $6fb9842575b03497$var$MIXPANEL_DB_NAME = 'mixpanelBrowserDb';
var $6fb9842575b03497$var$RECORDING_EVENTS_STORE_NAME = 'mixpanelRecordingEvents';
var $6fb9842575b03497$var$RECORDING_REGISTRY_STORE_NAME = 'mixpanelRecordingRegistry';
// note: increment the version number when adding new object stores
var $6fb9842575b03497$var$DB_VERSION = 1;
var $6fb9842575b03497$var$OBJECT_STORES = [
    $6fb9842575b03497$var$RECORDING_EVENTS_STORE_NAME,
    $6fb9842575b03497$var$RECORDING_REGISTRY_STORE_NAME
];
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $6fb9842575b03497$var$IDBStorageWrapper = function(storeName) {
    /**
     * @type {Promise<IDBDatabase>|null}
     */ this.dbPromise = null;
    this.storeName = storeName;
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype._openDb = function() {
    return new $6fb9842575b03497$var$PromisePolyfill(function(resolve, reject) {
        var openRequest = $6fb9842575b03497$var$win.indexedDB.open($6fb9842575b03497$var$MIXPANEL_DB_NAME, $6fb9842575b03497$var$DB_VERSION);
        openRequest['onerror'] = function() {
            reject(openRequest.error);
        };
        openRequest['onsuccess'] = function() {
            resolve(openRequest.result);
        };
        openRequest['onupgradeneeded'] = function(ev) {
            var db = ev.target.result;
            $6fb9842575b03497$var$OBJECT_STORES.forEach(function(storeName) {
                db.createObjectStore(storeName);
            });
        };
    });
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.init = function() {
    if (!$6fb9842575b03497$var$win.indexedDB) return $6fb9842575b03497$var$PromisePolyfill.reject('indexedDB is not supported in this browser');
    if (!this.dbPromise) this.dbPromise = this._openDb();
    return this.dbPromise.then(function(dbOrError) {
        if (dbOrError instanceof $6fb9842575b03497$var$win['IDBDatabase']) return $6fb9842575b03497$var$PromisePolyfill.resolve();
        else return $6fb9842575b03497$var$PromisePolyfill.reject(dbOrError);
    });
};
/**
 * @param {IDBTransactionMode} mode
 * @param {function(IDBObjectStore): void} storeCb
 */ $6fb9842575b03497$var$IDBStorageWrapper.prototype.makeTransaction = function(mode, storeCb) {
    var storeName = this.storeName;
    var doTransaction = function(db) {
        return new $6fb9842575b03497$var$PromisePolyfill(function(resolve, reject) {
            var transaction = db.transaction(storeName, mode);
            transaction.oncomplete = function() {
                resolve(transaction);
            };
            transaction.onabort = transaction.onerror = function() {
                reject(transaction.error);
            };
            storeCb(transaction.objectStore(storeName));
        });
    };
    return this.dbPromise.then(doTransaction).catch((function(err) {
        if (err && err['name'] === 'InvalidStateError') {
            // try reopening the DB if the connection is closed
            this.dbPromise = this._openDb();
            return this.dbPromise.then(doTransaction);
        } else return $6fb9842575b03497$var$PromisePolyfill.reject(err);
    }).bind(this));
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.setItem = function(key, value) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.put(value, key);
    });
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.getItem = function(key) {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.get(key);
    }).then(function() {
        return req.result;
    });
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.removeItem = function(key) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.delete(key);
    });
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.getAll = function() {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.getAll();
    }).then(function() {
        return req.result;
    });
};
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $6fb9842575b03497$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$optIn(token, options) {
    $6fb9842575b03497$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $6fb9842575b03497$var$optOut(token, options) {
    $6fb9842575b03497$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $6fb9842575b03497$var$hasOptedIn(token, options) {
    return $6fb9842575b03497$var$_getStorageValue(token, options) === '1';
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $6fb9842575b03497$var$hasOptedOut(token, options) {
    if ($6fb9842575b03497$var$_hasDoNotTrackFlagOn(options)) {
        $6fb9842575b03497$var$console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $6fb9842575b03497$var$_getStorageValue(token, options) === '0';
    if (optedOut) $6fb9842575b03497$var$console$1.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelLib(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$clearOptInOut(token, options) {
    options = options || {};
    $6fb9842575b03497$var$_getStorage(options).remove($6fb9842575b03497$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $6fb9842575b03497$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? $6fb9842575b03497$var$_.localStorage : $6fb9842575b03497$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $6fb9842575b03497$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $6fb9842575b03497$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $6fb9842575b03497$var$_getStorageValue(token, options) {
    return $6fb9842575b03497$var$_getStorage(options).get($6fb9842575b03497$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $6fb9842575b03497$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $6fb9842575b03497$var$win;
    var nav = win$1['navigator'] || {};
    var hasDntOn = false;
    $6fb9842575b03497$var$_.each([
        nav['doNotTrack'],
        nav['msDoNotTrack'],
        win$1['doNotTrack']
    ], function(dntValue) {
        if ($6fb9842575b03497$var$_.includes([
            true,
            1,
            '1',
            'yes'
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$_optInOut(optValue, token, options) {
    if (!$6fb9842575b03497$var$_.isString(token) || !token.length) {
        $6fb9842575b03497$var$console$1.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }
    options = options || {};
    $6fb9842575b03497$var$_getStorage(options).set($6fb9842575b03497$var$_getStorageKey(token, options), optValue ? 1 : 0, $6fb9842575b03497$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || '$opt_in', options.trackProperties, {
        'send_immediately': true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
            if (token) optedOut = $6fb9842575b03497$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $6fb9842575b03497$var$console$1.error('Unexpected error when checking tracking opt-out status: ' + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') callback(0);
        return;
    };
}
var $6fb9842575b03497$var$logger$6 = $6fb9842575b03497$var$console_with_prefix('lock');
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $6fb9842575b03497$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || $6fb9842575b03497$var$win.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
    // dependency-inject promise implementation for testing purposes
    this.promiseImpl = options.promiseImpl || $6fb9842575b03497$var$PromisePolyfill;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$6fb9842575b03497$var$SharedLock.prototype.withLock = function(lockedCB, pid) {
    var Promise1 = this.promiseImpl;
    return new Promise1($6fb9842575b03497$var$_.bind(function(resolve, reject) {
        var i = pid || new Date().getTime() + '|' + Math.random();
        var startTime = new Date().getTime();
        var key = this.storageKey;
        var pollIntervalMS = this.pollIntervalMS;
        var timeoutMS = this.timeoutMS;
        var storage = this.storage;
        var keyX = key + ':X';
        var keyY = key + ':Y';
        var keyZ = key + ':Z';
        var delay = function(cb) {
            if (new Date().getTime() - startTime > timeoutMS) {
                $6fb9842575b03497$var$logger$6.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
                storage.removeItem(keyZ);
                storage.removeItem(keyY);
                loop();
                return;
            }
            setTimeout(function() {
                try {
                    cb();
                } catch (err) {
                    reject(err);
                }
            }, pollIntervalMS * (Math.random() + 0.1));
        };
        var waitFor = function(predicate, cb) {
            if (predicate()) cb();
            else delay(function() {
                waitFor(predicate, cb);
            });
        };
        var getSetY = function() {
            var valY = storage.getItem(keyY);
            if (valY && valY !== i) return false;
            else {
                storage.setItem(keyY, i);
                if (storage.getItem(keyY) === i) return true;
                else {
                    if (!$6fb9842575b03497$var$localStorageSupported(storage, true)) reject(new Error('localStorage support dropped while acquiring lock'));
                    return false;
                }
            }
        };
        var loop = function() {
            storage.setItem(keyX, i);
            waitFor(getSetY, function() {
                if (storage.getItem(keyX) === i) {
                    criticalSection();
                    return;
                }
                delay(function() {
                    if (storage.getItem(keyY) !== i) {
                        loop();
                        return;
                    }
                    waitFor(function() {
                        return !storage.getItem(keyZ);
                    }, criticalSection);
                });
            });
        };
        var criticalSection = function() {
            storage.setItem(keyZ, '1');
            var removeLock = function() {
                storage.removeItem(keyZ);
                if (storage.getItem(keyY) === i) storage.removeItem(keyY);
                if (storage.getItem(keyX) === i) storage.removeItem(keyX);
            };
            lockedCB().then(function(ret) {
                removeLock();
                resolve(ret);
            }).catch(function(err) {
                removeLock();
                reject(err);
            });
        };
        try {
            if ($6fb9842575b03497$var$localStorageSupported(storage, true)) loop();
            else throw new Error('localStorage support check failed');
        } catch (err) {
            reject(err);
        }
    }, this));
};
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $6fb9842575b03497$var$LocalStorageWrapper = function(storageOverride) {
    this.storage = storageOverride || $6fb9842575b03497$var$win.localStorage;
};
$6fb9842575b03497$var$LocalStorageWrapper.prototype.init = function() {
    return $6fb9842575b03497$var$PromisePolyfill.resolve();
};
$6fb9842575b03497$var$LocalStorageWrapper.prototype.setItem = function(key, value) {
    return new $6fb9842575b03497$var$PromisePolyfill($6fb9842575b03497$var$_.bind(function(resolve, reject) {
        try {
            this.storage.setItem(key, $6fb9842575b03497$var$JSONStringify(value));
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
$6fb9842575b03497$var$LocalStorageWrapper.prototype.getItem = function(key) {
    return new $6fb9842575b03497$var$PromisePolyfill($6fb9842575b03497$var$_.bind(function(resolve, reject) {
        var item;
        try {
            item = $6fb9842575b03497$var$JSONParse(this.storage.getItem(key));
        } catch (e) {
            reject(e);
        }
        resolve(item);
    }, this));
};
$6fb9842575b03497$var$LocalStorageWrapper.prototype.removeItem = function(key) {
    return new $6fb9842575b03497$var$PromisePolyfill($6fb9842575b03497$var$_.bind(function(resolve, reject) {
        try {
            this.storage.removeItem(key);
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
var $6fb9842575b03497$var$logger$5 = $6fb9842575b03497$var$console_with_prefix('batch');
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $6fb9842575b03497$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.usePersistence = options.usePersistence;
    if (this.usePersistence) {
        this.queueStorage = options.queueStorage || new $6fb9842575b03497$var$LocalStorageWrapper();
        this.lock = new $6fb9842575b03497$var$SharedLock(storageKey, {
            storage: options.sharedLockStorage || $6fb9842575b03497$var$win.localStorage,
            timeoutMS: options.sharedLockTimeoutMS
        });
    }
    this.reportError = options.errorReporter || $6fb9842575b03497$var$_.bind($6fb9842575b03497$var$logger$5.error, $6fb9842575b03497$var$logger$5);
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
    this.initialized = false;
    if (options.enqueueThrottleMs) this.enqueuePersisted = $6fb9842575b03497$var$batchedThrottle($6fb9842575b03497$var$_.bind(this._enqueuePersisted, this), options.enqueueThrottleMs);
    else this.enqueuePersisted = $6fb9842575b03497$var$_.bind(function(queueEntry) {
        return this._enqueuePersisted([
            queueEntry
        ]);
    }, this);
};
$6fb9842575b03497$var$RequestQueue.prototype.ensureInit = function() {
    if (this.initialized) return $6fb9842575b03497$var$PromisePolyfill.resolve();
    return this.queueStorage.init().then($6fb9842575b03497$var$_.bind(function() {
        this.initialized = true;
    }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error initializing queue persistence. Disabling persistence', err);
        this.initialized = true;
        this.usePersistence = false;
    }, this));
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $6fb9842575b03497$var$RequestQueue.prototype.enqueue = function(item, flushInterval) {
    var queueEntry = {
        'id': $6fb9842575b03497$var$cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        return $6fb9842575b03497$var$PromisePolyfill.resolve(true);
    } else return this.enqueuePersisted(queueEntry);
};
$6fb9842575b03497$var$RequestQueue.prototype._enqueuePersisted = function(queueEntries) {
    var enqueueItem = $6fb9842575b03497$var$_.bind(function() {
        return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
            return this.saveToStorage(storedQueue.concat(queueEntries));
        }, this)).then($6fb9842575b03497$var$_.bind(function(succeeded) {
            // only add to in-memory queue when storage succeeds
            if (succeeded) this.memQueue = this.memQueue.concat(queueEntries);
            return succeeded;
        }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
            this.reportError('Error enqueueing items', err, queueEntries);
            return false;
        }, this));
    }, this);
    return this.lock.withLock(enqueueItem, this.pid).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $6fb9842575b03497$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) // don't need lock just to read events; localStorage is thread-safe
    // and the worst that could happen is a duplicate send of some
    // orphaned events, which will be deduplicated on the server side
    return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
        return this.readFromStorage();
    }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $6fb9842575b03497$var$_.each(batch, function(item) {
                idsInBatch[item['id']] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
        return batch;
    }, this));
    else return $6fb9842575b03497$var$PromisePolyfill.resolve(batch);
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $6fb9842575b03497$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $6fb9842575b03497$var$_.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $6fb9842575b03497$var$RequestQueue.prototype.removeItemsByID = function(ids) {
    var idSet = {}; // poor man's Set
    $6fb9842575b03497$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $6fb9842575b03497$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) return $6fb9842575b03497$var$PromisePolyfill.resolve(true);
    else {
        var removeFromStorage = $6fb9842575b03497$var$_.bind(function() {
            return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
                storedQueue = $6fb9842575b03497$var$filterOutIDsAndInvalid(storedQueue, idSet);
                return this.saveToStorage(storedQueue);
            }, this)).then($6fb9842575b03497$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
                // an extra check: did storage report success but somehow
                // the items are still there?
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) throw new Error('Item not removed from storage');
                }
                return true;
            }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
                this.reportError('Error removing items', err, ids);
                return false;
            }, this));
        }, this);
        return this.lock.withLock(removeFromStorage, this.pid).catch($6fb9842575b03497$var$_.bind(function(err) {
            this.reportError('Error acquiring storage lock', err);
            if (!$6fb9842575b03497$var$localStorageSupported(this.lock.storage, true)) // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            return removeFromStorage().then($6fb9842575b03497$var$_.bind(function(success) {
                if (!success) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                return this.queueStorage.removeItem(this.storageKey).then(function() {
                    return success;
                });
                return success;
            }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
                this.reportError('Error clearing queue', err);
                return false;
            }, this));
            else return false;
        }, this));
    }
};
// internal helper for RequestQueue.updatePayloads
var $6fb9842575b03497$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $6fb9842575b03497$var$_.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $6fb9842575b03497$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate) {
    this.memQueue = $6fb9842575b03497$var$updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) return $6fb9842575b03497$var$PromisePolyfill.resolve(true);
    else return this.lock.withLock($6fb9842575b03497$var$_.bind(function lockAcquired() {
        return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
            storedQueue = $6fb9842575b03497$var$updatePayloads(storedQueue, itemsToUpdate);
            return this.saveToStorage(storedQueue);
        }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
            this.reportError('Error updating items', itemsToUpdate, err);
            return false;
        }, this));
    }, this), this.pid).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $6fb9842575b03497$var$RequestQueue.prototype.readFromStorage = function() {
    return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
        return this.queueStorage.getItem(this.storageKey);
    }, this)).then($6fb9842575b03497$var$_.bind(function(storageEntry) {
        if (storageEntry) {
            if (!$6fb9842575b03497$var$_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
        return storageEntry || [];
    }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error retrieving queue', err);
        return [];
    }, this));
};
/**
 * Serialize the given items array to localStorage.
 */ $6fb9842575b03497$var$RequestQueue.prototype.saveToStorage = function(queue) {
    return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
        return this.queueStorage.setItem(this.storageKey, queue);
    }, this)).then(function() {
        return true;
    }).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error saving queue', err);
        return false;
    }, this));
};
/**
 * Clear out queues (memory and localStorage).
 */ $6fb9842575b03497$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
        return this.queueStorage.removeItem(this.storageKey);
    }, this));
    else return $6fb9842575b03497$var$PromisePolyfill.resolve();
};
// maximum interval between request retries after exponential backoff
var $6fb9842575b03497$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $6fb9842575b03497$var$logger$4 = $6fb9842575b03497$var$console_with_prefix('batch');
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $6fb9842575b03497$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $6fb9842575b03497$var$RequestQueue(storageKey, {
        errorReporter: $6fb9842575b03497$var$_.bind(this.reportError, this),
        queueStorage: options.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        sharedLockTimeoutMS: options.sharedLockTimeoutMS,
        usePersistence: options.usePersistence,
        enqueueThrottleMs: options.enqueueThrottleMs
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
    this._flushPromise = null;
};
/**
 * Add one item to queue.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.enqueue = function(item) {
    return this.queue.enqueue(item, this.flushInterval);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    return this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $6fb9842575b03497$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.clear = function() {
    return this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($6fb9842575b03497$var$_.bind(function() {
        if (!this.stopped) this._flushPromise = this.flush();
    }, this), this.flushInterval);
};
/**
 * Send a request using the sendRequest callback, but promisified.
 * TODO: sendRequest should be promisified in the first place.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.sendRequestPromise = function(data, options) {
    return new $6fb9842575b03497$var$PromisePolyfill($6fb9842575b03497$var$_.bind(function(resolve) {
        this.sendRequest(data, options, resolve);
    }, this));
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $6fb9842575b03497$var$RequestBatcher.prototype.flush = function(options) {
    if (this.requestInProgress) {
        $6fb9842575b03497$var$logger$4.log('Flush: Request already in progress');
        return $6fb9842575b03497$var$PromisePolyfill.resolve();
    }
    this.requestInProgress = true;
    options = options || {};
    var timeoutMS = this.libConfig['batch_request_timeout_ms'];
    var startTime = new Date().getTime();
    var currentBatchSize = this.batchSize;
    return this.queue.fillBatch(currentBatchSize).then($6fb9842575b03497$var$_.bind(function(batch) {
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        $6fb9842575b03497$var$_.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) payload['properties'] = $6fb9842575b03497$var$_.extend({}, payload['properties'], {
                    'mp_sent_by_lib_version': $6fb9842575b03497$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError('[dupe] found item with no ID', {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.requestInProgress = false;
            this.resetFlush();
            return $6fb9842575b03497$var$PromisePolyfill.resolve(); // nothing to do
        }
        var removeItemsFromQueue = $6fb9842575b03497$var$_.bind(function() {
            return this.queue.removeItemsByID($6fb9842575b03497$var$_.map(batch, function(item) {
                return item['id'];
            })).then($6fb9842575b03497$var$_.bind(function(succeeded) {
                // client-side dedupe
                $6fb9842575b03497$var$_.each(batch, $6fb9842575b03497$var$_.bind(function(item) {
                    var itemId = item['id'];
                    if (itemId) {
                        this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                        this.itemIdsSentSuccessfully[itemId]++;
                        if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError('[dupe] item ID sent too many times', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                    } else this.reportError('[dupe] found item with no ID while removing', {
                        item: item
                    });
                }, this));
                if (succeeded) {
                    this.consecutiveRemovalFailures = 0;
                    if (this.flushOnlyOnInterval && !attemptSecondaryFlush) {
                        this.resetFlush(); // schedule next batch with a delay
                        return $6fb9842575b03497$var$PromisePolyfill.resolve();
                    } else return this.flush(); // handle next batch if the queue isn't empty
                } else {
                    if (++this.consecutiveRemovalFailures > 5) {
                        this.reportError('Too many queue failures; disabling batching system.');
                        this.stopAllBatching();
                    } else this.resetFlush();
                    return $6fb9842575b03497$var$PromisePolyfill.resolve();
                }
            }, this));
        }, this);
        var batchSendCallback = $6fb9842575b03497$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                if (options.unloading) // update persisted data to include hook transformations
                return this.queue.updatePayloads(transformedItems);
                else if ($6fb9842575b03497$var$_.isObject(res) && res.error === 'timeout' && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError('Network timeout; retrying');
                    return this.flush();
                } else if ($6fb9842575b03497$var$_.isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.httpStatusCode <= 0 && !$6fb9842575b03497$var$isOnline() || res.error === 'timeout')) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min($6fb9842575b03497$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                    return $6fb9842575b03497$var$PromisePolyfill.resolve();
                } else if ($6fb9842575b03497$var$_.isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                        return $6fb9842575b03497$var$PromisePolyfill.resolve();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        return removeItemsFromQueue();
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                return removeItemsFromQueue();
            } catch (err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = 'sendBeacon';
        $6fb9842575b03497$var$logger$4.log('MIXPANEL REQUEST:', dataForRequest);
        return this.sendRequestPromise(dataForRequest, requestOptions).then(batchSendCallback);
    }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }, this));
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $6fb9842575b03497$var$logger$4.error.apply($6fb9842575b03497$var$logger$4.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$logger$4.error(err);
    }
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 * @returns {boolean}
 */ var $6fb9842575b03497$var$isRecordingExpired = function(serializedRecording) {
    var now = Date.now();
    return !serializedRecording || now > serializedRecording['maxExpires'] || now > serializedRecording['idleExpires'];
};
var $6fb9842575b03497$var$RECORD_ENQUEUE_THROTTLE_MS = 250;
var $6fb9842575b03497$var$logger$3 = $6fb9842575b03497$var$console_with_prefix('recorder');
var $6fb9842575b03497$var$CompressionStream = $6fb9842575b03497$var$win['CompressionStream'];
var $6fb9842575b03497$var$RECORDER_BATCHER_LIB_CONFIG = {
    'batch_size': 1000,
    'batch_flush_interval_ms': 10000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true
};
var $6fb9842575b03497$var$ACTIVE_SOURCES = new Set([
    $6fb9842575b03497$var$IncrementalSource.MouseMove,
    $6fb9842575b03497$var$IncrementalSource.MouseInteraction,
    $6fb9842575b03497$var$IncrementalSource.Scroll,
    $6fb9842575b03497$var$IncrementalSource.ViewportResize,
    $6fb9842575b03497$var$IncrementalSource.Input,
    $6fb9842575b03497$var$IncrementalSource.TouchMove,
    $6fb9842575b03497$var$IncrementalSource.MediaInteraction,
    $6fb9842575b03497$var$IncrementalSource.Drag,
    $6fb9842575b03497$var$IncrementalSource.Selection
]);
function $6fb9842575b03497$var$isUserEvent(ev) {
    return ev.type === $6fb9842575b03497$var$EventType.IncrementalSnapshot && $6fb9842575b03497$var$ACTIVE_SOURCES.has(ev.data.source);
}
/**
 * @typedef {Object} SerializedRecording
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayId
 * @property {string} tabId
 * @property {string} replayStartUrl
 */ /**
 * @typedef {Object} SessionRecordingOptions
 * @property {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
 * @property {String} [options.replayId] - unique uuid for a single replay
 * @property {Function} [options.onIdleTimeout] - callback when a recording reaches idle timeout
 * @property {Function} [options.onMaxLengthReached] - callback when a recording reaches its maximum length
 * @property {Function} [options.rrwebRecord] - rrweb's `record` function
 * @property {Function} [options.onBatchSent] - callback when a batch of events is sent to the server
 * @property {Storage} [options.sharedLockStorage] - optional storage for shared lock, used for test dependency injection
 * optional properties for deserialization:
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayStartUrl
 */ /**
 * This class encapsulates a single session recording and its lifecycle.
 * @param {SessionRecordingOptions} options
 */ var $6fb9842575b03497$var$SessionRecording = function(options) {
    this._mixpanel = options.mixpanelInstance;
    this._onIdleTimeout = options.onIdleTimeout || $6fb9842575b03497$var$NOOP_FUNC;
    this._onMaxLengthReached = options.onMaxLengthReached || $6fb9842575b03497$var$NOOP_FUNC;
    this._onBatchSent = options.onBatchSent || $6fb9842575b03497$var$NOOP_FUNC;
    this._rrwebRecord = options.rrwebRecord || null;
    // internal rrweb stopRecording function
    this._stopRecording = null;
    this.replayId = options.replayId;
    this.batchStartUrl = options.batchStartUrl || null;
    this.replayStartUrl = options.replayStartUrl || null;
    this.idleExpires = options.idleExpires || null;
    this.maxExpires = options.maxExpires || null;
    this.replayStartTime = options.replayStartTime || null;
    this.seqNo = options.seqNo || 0;
    this.idleTimeoutId = null;
    this.maxTimeoutId = null;
    this.recordMaxMs = $6fb9842575b03497$var$MAX_RECORDING_MS;
    this.recordMinMs = 0;
    // disable persistence if localStorage is not supported
    // request-queue will automatically disable persistence if indexedDB fails to initialize
    var usePersistence = $6fb9842575b03497$var$localStorageSupported(options.sharedLockStorage, true);
    // each replay has its own batcher key to avoid conflicts between rrweb events of different recordings
    // this will be important when persistence is introduced
    this.batcherKey = '__mprec_' + this.getConfig('name') + '_' + this.getConfig('token') + '_' + this.replayId;
    this.queueStorage = new $6fb9842575b03497$var$IDBStorageWrapper($6fb9842575b03497$var$RECORDING_EVENTS_STORE_NAME);
    this.batcher = new $6fb9842575b03497$var$RequestBatcher(this.batcherKey, {
        errorReporter: this.reportError.bind(this),
        flushOnlyOnInterval: true,
        libConfig: $6fb9842575b03497$var$RECORDER_BATCHER_LIB_CONFIG,
        sendRequestFunc: this.flushEventsWithOptOut.bind(this),
        queueStorage: this.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        usePersistence: usePersistence,
        stopAllBatchingFunc: this.stopRecording.bind(this),
        // increased throttle and shared lock timeout because recording events are very high frequency.
        // this will minimize the amount of lock contention between enqueued events.
        // for session recordings there is a lock for each tab anyway, so there's no risk of deadlock between tabs.
        enqueueThrottleMs: $6fb9842575b03497$var$RECORD_ENQUEUE_THROTTLE_MS,
        sharedLockTimeoutMS: 10000
    });
};
$6fb9842575b03497$var$SessionRecording.prototype.unloadPersistedData = function() {
    this.batcher.stop();
    return this.batcher.flush().then((function() {
        return this.queueStorage.removeItem(this.batcherKey);
    }).bind(this));
};
$6fb9842575b03497$var$SessionRecording.prototype.getConfig = function(configVar) {
    return this._mixpanel.get_config(configVar);
};
// Alias for getConfig, used by the common addOptOutCheckMixpanelLib function which
// reaches into this class instance and expects the snake case version of the function.
// eslint-disable-next-line camelcase
$6fb9842575b03497$var$SessionRecording.prototype.get_config = function(configVar) {
    return this.getConfig(configVar);
};
$6fb9842575b03497$var$SessionRecording.prototype.startRecording = function(shouldStopBatcher) {
    if (this._rrwebRecord === null) {
        this.reportError('rrweb record function not provided. ');
        return;
    }
    if (this._stopRecording !== null) {
        $6fb9842575b03497$var$logger$3.log('Recording already in progress, skipping startRecording.');
        return;
    }
    this.recordMaxMs = this.getConfig('record_max_ms');
    if (this.recordMaxMs > $6fb9842575b03497$var$MAX_RECORDING_MS) {
        this.recordMaxMs = $6fb9842575b03497$var$MAX_RECORDING_MS;
        $6fb9842575b03497$var$logger$3.critical('record_max_ms cannot be greater than ' + $6fb9842575b03497$var$MAX_RECORDING_MS + 'ms. Capping value.');
    }
    if (!this.maxExpires) this.maxExpires = new Date().getTime() + this.recordMaxMs;
    this.recordMinMs = this.getConfig('record_min_ms');
    if (this.recordMinMs > $6fb9842575b03497$var$MAX_VALUE_FOR_MIN_RECORDING_MS) {
        this.recordMinMs = $6fb9842575b03497$var$MAX_VALUE_FOR_MIN_RECORDING_MS;
        $6fb9842575b03497$var$logger$3.critical('record_min_ms cannot be greater than ' + $6fb9842575b03497$var$MAX_VALUE_FOR_MIN_RECORDING_MS + 'ms. Capping value.');
    }
    if (!this.replayStartTime) {
        this.replayStartTime = new Date().getTime();
        this.batchStartUrl = $6fb9842575b03497$var$_.info.currentUrl();
        this.replayStartUrl = $6fb9842575b03497$var$_.info.currentUrl();
    }
    if (shouldStopBatcher || this.recordMinMs > 0) // the primary case for shouldStopBatcher is when we're starting recording after a reset
    // and don't want to send anything over the network until there's
    // actual user activity
    // this also applies if the minimum recording length has not been hit yet
    // so that we don't send data until we know the recording will be long enough
    this.batcher.stop();
    else this.batcher.start();
    var resetIdleTimeout = (function() {
        clearTimeout(this.idleTimeoutId);
        var idleTimeoutMs = this.getConfig('record_idle_timeout_ms');
        this.idleTimeoutId = setTimeout(this._onIdleTimeout, idleTimeoutMs);
        this.idleExpires = new Date().getTime() + idleTimeoutMs;
    }).bind(this);
    resetIdleTimeout();
    var blockSelector = this.getConfig('record_block_selector');
    if (blockSelector === '' || blockSelector === null) blockSelector = undefined;
    try {
        this._stopRecording = this._rrwebRecord({
            'emit': (function(ev) {
                if (this.idleExpires && this.idleExpires < ev.timestamp) {
                    this._onIdleTimeout();
                    return;
                }
                if ($6fb9842575b03497$var$isUserEvent(ev)) {
                    if (this.batcher.stopped && new Date().getTime() - this.replayStartTime >= this.recordMinMs) // start flushing again after user activity
                    this.batcher.start();
                    resetIdleTimeout();
                }
                // promise only used to await during tests
                this.__enqueuePromise = this.batcher.enqueue(ev);
            }).bind(this),
            'blockClass': this.getConfig('record_block_class'),
            'blockSelector': blockSelector,
            'collectFonts': this.getConfig('record_collect_fonts'),
            'dataURLOptions': {
                'type': 'image/webp',
                'quality': 0.6
            },
            'maskAllInputs': true,
            'maskTextClass': this.getConfig('record_mask_text_class'),
            'maskTextSelector': this.getConfig('record_mask_text_selector'),
            'recordCanvas': this.getConfig('record_canvas'),
            'sampling': {
                'canvas': 15
            }
        });
    } catch (err) {
        this.reportError('Unexpected error when starting rrweb recording.', err);
    }
    if (typeof this._stopRecording !== 'function') {
        this.reportError('rrweb failed to start, skipping this recording.');
        this._stopRecording = null;
        this.stopRecording(); // stop batcher looping and any timeouts
        return;
    }
    var maxTimeoutMs = this.maxExpires - new Date().getTime();
    this.maxTimeoutId = setTimeout(this._onMaxLengthReached.bind(this), maxTimeoutMs);
};
$6fb9842575b03497$var$SessionRecording.prototype.stopRecording = function(skipFlush) {
    if (!this.isRrwebStopped()) {
        try {
            this._stopRecording();
        } catch (err) {
            this.reportError('Error with rrweb stopRecording', err);
        }
        this._stopRecording = null;
    }
    var flushPromise;
    if (this.batcher.stopped) // never got user activity to flush after reset, so just clear the batcher
    flushPromise = this.batcher.clear();
    else if (!skipFlush) // flush any remaining events from running batcher
    flushPromise = this.batcher.flush();
    this.batcher.stop();
    clearTimeout(this.idleTimeoutId);
    clearTimeout(this.maxTimeoutId);
    return flushPromise;
};
$6fb9842575b03497$var$SessionRecording.prototype.isRrwebStopped = function() {
    return this._stopRecording === null;
};
/**
 * Flushes the current batch of events to the server, but passes an opt-out callback to make sure
 * we stop recording and dump any queued events if the user has opted out.
 */ $6fb9842575b03497$var$SessionRecording.prototype.flushEventsWithOptOut = function(data, options, cb) {
    var onOptOut = (function(code) {
        // addOptOutCheckMixpanelLib invokes this function with code=0 when the user has opted out
        if (code === 0) {
            this.stopRecording();
            cb({
                error: 'Tracking has been opted out, stopping recording.'
            });
        }
    }).bind(this);
    this._flushEvents(data, options, cb, onOptOut);
};
/**
 * @returns {SerializedRecording}
 */ $6fb9842575b03497$var$SessionRecording.prototype.serialize = function() {
    // don't break if mixpanel instance was destroyed at some point
    var tabId;
    try {
        tabId = this._mixpanel.get_tab_id();
    } catch (e) {
        this.reportError('Error getting tab ID for serialization ', e);
        tabId = null;
    }
    return {
        'replayId': this.replayId,
        'seqNo': this.seqNo,
        'replayStartTime': this.replayStartTime,
        'batchStartUrl': this.batchStartUrl,
        'replayStartUrl': this.replayStartUrl,
        'idleExpires': this.idleExpires,
        'maxExpires': this.maxExpires,
        'tabId': tabId
    };
};
/**
 * @static
 * @param {SerializedRecording} serializedRecording
 * @param {SessionRecordingOptions} options
 * @returns {SessionRecording}
 */ $6fb9842575b03497$var$SessionRecording.deserialize = function(serializedRecording, options) {
    var recording = new $6fb9842575b03497$var$SessionRecording($6fb9842575b03497$var$_.extend({}, options, {
        replayId: serializedRecording['replayId'],
        batchStartUrl: serializedRecording['batchStartUrl'],
        replayStartUrl: serializedRecording['replayStartUrl'],
        idleExpires: serializedRecording['idleExpires'],
        maxExpires: serializedRecording['maxExpires'],
        replayStartTime: serializedRecording['replayStartTime'],
        seqNo: serializedRecording['seqNo'],
        sharedLockStorage: options.sharedLockStorage
    }));
    return recording;
};
$6fb9842575b03497$var$SessionRecording.prototype._sendRequest = function(currentReplayId, reqParams, reqBody, callback) {
    var onSuccess = (function(response, responseBody) {
        // Update batch specific props only if the request was successful to guarantee ordering.
        // RequestBatcher will always flush the next batch after the previous one succeeds.
        // extra check to see if the replay ID has changed so that we don't increment the seqNo on the wrong replay
        if (response.status === 200 && this.replayId === currentReplayId) {
            this.seqNo++;
            this.batchStartUrl = $6fb9842575b03497$var$_.info.currentUrl();
        }
        this._onBatchSent();
        callback({
            status: 0,
            httpStatusCode: response.status,
            responseBody: responseBody,
            retryAfter: response.headers.get('Retry-After')
        });
    }).bind(this);
    $6fb9842575b03497$var$win['fetch'](this.getConfig('api_host') + '/' + this.getConfig('api_routes')['record'] + '?' + new URLSearchParams(reqParams), {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': reqBody
    }).then(function(response) {
        response.json().then(function(responseBody) {
            onSuccess(response, responseBody);
        }).catch(function(error) {
            callback({
                error: error
            });
        });
    }).catch(function(error) {
        callback({
            error: error,
            httpStatusCode: 0
        });
    });
};
$6fb9842575b03497$var$SessionRecording.prototype._flushEvents = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(data, options, callback) {
    var numEvents = data.length;
    if (numEvents > 0) {
        var replayId = this.replayId;
        // each rrweb event has a timestamp - leverage those to get time properties
        var batchStartTime = Infinity;
        var batchEndTime = -Infinity;
        var hasFullSnapshot = false;
        for(var i = 0; i < numEvents; i++){
            batchStartTime = Math.min(batchStartTime, data[i].timestamp);
            batchEndTime = Math.max(batchEndTime, data[i].timestamp);
            if (data[i].type === $6fb9842575b03497$var$EventType.FullSnapshot) hasFullSnapshot = true;
        }
        if (this.seqNo === 0) {
            if (!hasFullSnapshot) {
                callback({
                    error: 'First batch does not contain a full snapshot. Aborting recording.'
                });
                this.stopRecording(true);
                return;
            }
            this.replayStartTime = batchStartTime;
        } else if (!this.replayStartTime) {
            this.reportError('Replay start time not set but seqNo is not 0. Using current batch start time as a fallback.');
            this.replayStartTime = batchStartTime;
        }
        var replayLengthMs = batchEndTime - this.replayStartTime;
        var reqParams = {
            '$current_url': this.batchStartUrl,
            '$lib_version': $6fb9842575b03497$var$Config.LIB_VERSION,
            'batch_start_time': batchStartTime / 1000,
            'distinct_id': String(this._mixpanel.get_distinct_id()),
            'mp_lib': 'web',
            'replay_id': replayId,
            'replay_length_ms': replayLengthMs,
            'replay_start_time': this.replayStartTime / 1000,
            'replay_start_url': this.replayStartUrl,
            'seq': this.seqNo
        };
        var eventsJson = JSON.stringify(data);
        // send ID management props if they exist
        var deviceId = this._mixpanel.get_property('$device_id');
        if (deviceId) reqParams['$device_id'] = deviceId;
        var userId = this._mixpanel.get_property('$user_id');
        if (userId) reqParams['$user_id'] = userId;
        if ($6fb9842575b03497$var$CompressionStream) {
            var jsonStream = new Blob([
                eventsJson
            ], {
                type: 'application/json'
            }).stream();
            var gzipStream = jsonStream.pipeThrough(new $6fb9842575b03497$var$CompressionStream('gzip'));
            new Response(gzipStream).blob().then((function(compressedBlob) {
                reqParams['format'] = 'gzip';
                this._sendRequest(replayId, reqParams, compressedBlob, callback);
            }).bind(this));
        } else {
            reqParams['format'] = 'body';
            this._sendRequest(replayId, reqParams, eventsJson, callback);
        }
    }
});
$6fb9842575b03497$var$SessionRecording.prototype.reportError = function(msg, err) {
    $6fb9842575b03497$var$logger$3.error.apply($6fb9842575b03497$var$logger$3.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.getConfig('error_reporter')(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$logger$3.error(err);
    }
};
/**
 * Module for handling the storage and retrieval of recording metadata as well as any active recordings.
 * Makes sure that only one tab can be recording at a time.
 */ var $6fb9842575b03497$var$RecordingRegistry = function(options) {
    this.idb = new $6fb9842575b03497$var$IDBStorageWrapper($6fb9842575b03497$var$RECORDING_REGISTRY_STORE_NAME);
    this.errorReporter = options.errorReporter;
    this.mixpanelInstance = options.mixpanelInstance;
    this.sharedLockStorage = options.sharedLockStorage;
};
$6fb9842575b03497$var$RecordingRegistry.prototype.handleError = function(err) {
    this.errorReporter('IndexedDB error: ', err);
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 */ $6fb9842575b03497$var$RecordingRegistry.prototype.setActiveRecording = function(serializedRecording) {
    var tabId = serializedRecording['tabId'];
    if (!tabId) {
        console.warn('No tab ID is set, cannot persist recording metadata.');
        return $6fb9842575b03497$var$PromisePolyfill.resolve();
    }
    return this.idb.init().then((function() {
        return this.idb.setItem(tabId, serializedRecording);
    }).bind(this)).catch(this.handleError.bind(this));
};
/**
 * @returns {Promise<import('./session-recording').SerializedRecording>}
 */ $6fb9842575b03497$var$RecordingRegistry.prototype.getActiveRecording = function() {
    return this.idb.init().then((function() {
        return this.idb.getItem(this.mixpanelInstance.get_tab_id());
    }).bind(this)).then((function(serializedRecording) {
        return $6fb9842575b03497$var$isRecordingExpired(serializedRecording) ? null : serializedRecording;
    }).bind(this)).catch(this.handleError.bind(this));
};
$6fb9842575b03497$var$RecordingRegistry.prototype.clearActiveRecording = function() {
    // mark recording as expired instead of deleting it in case the page unloads mid-flush and doesn't make it to ingestion.
    // this will ensure the next pageload will flush the remaining events, but not try to continue the recording.
    return this.getActiveRecording().then((function(serializedRecording) {
        if (serializedRecording) {
            serializedRecording['maxExpires'] = 0;
            return this.setActiveRecording(serializedRecording);
        }
    }).bind(this)).catch(this.handleError.bind(this));
};
/**
 * Flush any inactive recordings from the registry to minimize data loss.
 * The main idea here is that we can flush remaining rrweb events on the next page load if a tab is closed mid-batch.
 */ $6fb9842575b03497$var$RecordingRegistry.prototype.flushInactiveRecordings = function() {
    return this.idb.init().then((function() {
        return this.idb.getAll();
    }).bind(this)).then((function(serializedRecordings) {
        // clean up any expired recordings from the registry, non-expired ones may be active in other tabs
        var unloadPromises = serializedRecordings.filter(function(serializedRecording) {
            return $6fb9842575b03497$var$isRecordingExpired(serializedRecording);
        }).map((function(serializedRecording) {
            var sessionRecording = $6fb9842575b03497$var$SessionRecording.deserialize(serializedRecording, {
                mixpanelInstance: this.mixpanelInstance,
                sharedLockStorage: this.sharedLockStorage
            });
            return sessionRecording.unloadPersistedData().then((function() {
                // expired recording was successfully flushed, we can clean it up from the registry
                return this.idb.removeItem(serializedRecording['tabId']);
            }).bind(this)).catch(this.handleError.bind(this));
        }).bind(this));
        return $6fb9842575b03497$var$PromisePolyfill.all(unloadPromises);
    }).bind(this)).catch(this.handleError.bind(this));
};
var $6fb9842575b03497$var$logger$2 = $6fb9842575b03497$var$console_with_prefix('recorder');
/**
 * Recorder API: bundles rrweb and and exposes methods to start and stop recordings.
 * @param {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
*/ var $6fb9842575b03497$var$MixpanelRecorder = function(mixpanelInstance, rrwebRecord, sharedLockStorage) {
    this.mixpanelInstance = mixpanelInstance;
    this.rrwebRecord = rrwebRecord || $6fb9842575b03497$var$record;
    this.sharedLockStorage = sharedLockStorage;
    /**
     * @member {import('./registry').RecordingRegistry}
     */ this.recordingRegistry = new $6fb9842575b03497$var$RecordingRegistry({
        mixpanelInstance: this.mixpanelInstance,
        errorReporter: $6fb9842575b03497$var$logger$2.error,
        sharedLockStorage: sharedLockStorage
    });
    this._flushInactivePromise = this.recordingRegistry.flushInactiveRecordings();
    this.activeRecording = null;
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.startRecording = function(options) {
    options = options || {};
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) {
        $6fb9842575b03497$var$logger$2.log('Recording already in progress, skipping startRecording.');
        return;
    }
    var onIdleTimeout = (function() {
        $6fb9842575b03497$var$logger$2.log('Idle timeout reached, restarting recording.');
        this.resetRecording();
    }).bind(this);
    var onMaxLengthReached = (function() {
        $6fb9842575b03497$var$logger$2.log('Max recording length reached, stopping recording.');
        this.resetRecording();
    }).bind(this);
    var onBatchSent = (function() {
        this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
        this['__flushPromise'] = this.activeRecording.batcher._flushPromise;
    }).bind(this);
    /**
     * @type {import('./session-recording').SessionRecordingOptions}
     */ var sessionRecordingOptions = {
        mixpanelInstance: this.mixpanelInstance,
        onBatchSent: onBatchSent,
        onIdleTimeout: onIdleTimeout,
        onMaxLengthReached: onMaxLengthReached,
        replayId: $6fb9842575b03497$var$_.UUID(),
        rrwebRecord: this.rrwebRecord,
        sharedLockStorage: this.sharedLockStorage
    };
    if (options.activeSerializedRecording) this.activeRecording = $6fb9842575b03497$var$SessionRecording.deserialize(options.activeSerializedRecording, sessionRecordingOptions);
    else this.activeRecording = new $6fb9842575b03497$var$SessionRecording(sessionRecordingOptions);
    this.activeRecording.startRecording(options.shouldStopBatcher);
    return this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.stopRecording = function() {
    var stopPromise = this._stopCurrentRecording(false);
    this.recordingRegistry.clearActiveRecording();
    this.activeRecording = null;
    return stopPromise;
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.pauseRecording = function() {
    return this._stopCurrentRecording(false);
};
$6fb9842575b03497$var$MixpanelRecorder.prototype._stopCurrentRecording = function(skipFlush) {
    if (this.activeRecording) return this.activeRecording.stopRecording(skipFlush);
    return $6fb9842575b03497$var$PromisePolyfill.resolve();
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.resumeRecording = function(startNewIfInactive) {
    if (this.activeRecording && this.activeRecording.isRrwebStopped()) {
        this.activeRecording.startRecording(false);
        return $6fb9842575b03497$var$PromisePolyfill.resolve(null);
    }
    return this.recordingRegistry.getActiveRecording().then((function(activeSerializedRecording) {
        if (activeSerializedRecording) return this.startRecording({
            activeSerializedRecording: activeSerializedRecording
        });
        else if (startNewIfInactive) return this.startRecording({
            shouldStopBatcher: false
        });
        else {
            $6fb9842575b03497$var$logger$2.log('No resumable recording found.');
            return null;
        }
    }).bind(this));
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.resetRecording = function() {
    this.stopRecording();
    this.startRecording({
        shouldStopBatcher: true
    });
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.getActiveReplayId = function() {
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) return this.activeRecording.replayId;
    else return null;
};
// getter so that older mixpanel-core versions can still retrieve the replay ID
// when pulling the latest recorder bundle from the CDN
Object.defineProperty($6fb9842575b03497$var$MixpanelRecorder.prototype, 'replayId', {
    get: function() {
        return this.getActiveReplayId();
    }
});
$6fb9842575b03497$var$win['__mp_recorder'] = $6fb9842575b03497$var$MixpanelRecorder;
// stateless utils
// mostly from https://github.com/mixpanel/mixpanel-js/blob/989ada50f518edab47b9c4fd9535f9fbd5ec5fc0/src/autotrack-utils.js
var $6fb9842575b03497$var$EV_CHANGE = 'change';
var $6fb9842575b03497$var$EV_CLICK = 'click';
var $6fb9842575b03497$var$EV_HASHCHANGE = 'hashchange';
var $6fb9842575b03497$var$EV_MP_LOCATION_CHANGE = 'mp_locationchange';
var $6fb9842575b03497$var$EV_POPSTATE = 'popstate';
// TODO scrollend isn't available in Safari: document or polyfill?
var $6fb9842575b03497$var$EV_SCROLLEND = 'scrollend';
var $6fb9842575b03497$var$EV_SUBMIT = 'submit';
var $6fb9842575b03497$var$CLICK_EVENT_PROPS = [
    'clientX',
    'clientY',
    'offsetX',
    'offsetY',
    'pageX',
    'pageY',
    'screenX',
    'screenY',
    'x',
    'y'
];
var $6fb9842575b03497$var$OPT_IN_CLASSES = [
    'mp-include'
];
var $6fb9842575b03497$var$OPT_OUT_CLASSES = [
    'mp-no-track'
];
var $6fb9842575b03497$var$SENSITIVE_DATA_CLASSES = $6fb9842575b03497$var$OPT_OUT_CLASSES.concat([
    'mp-sensitive'
]);
var $6fb9842575b03497$var$TRACKED_ATTRS = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'href',
    'name',
    'role',
    'title',
    'type'
];
var $6fb9842575b03497$var$logger$1 = $6fb9842575b03497$var$console_with_prefix('autocapture');
function $6fb9842575b03497$var$getClasses(el) {
    var classes = {};
    var classList = $6fb9842575b03497$var$getClassName(el).split(' ');
    for(var i = 0; i < classList.length; i++){
        var cls = classList[i];
        if (cls) classes[cls] = true;
    }
    return classes;
}
/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */ function $6fb9842575b03497$var$getClassName(el) {
    switch(typeof el.className){
        case 'string':
            return el.className;
        case 'object':
            return el.className.baseVal || el.getAttribute('class') || '';
        default:
            return '';
    }
}
function $6fb9842575b03497$var$getPreviousElementSibling(el) {
    if (el.previousElementSibling) return el.previousElementSibling;
    else {
        do el = el.previousSibling;
        while (el && !$6fb9842575b03497$var$isElementNode(el));
        return el;
    }
}
function $6fb9842575b03497$var$getPropertiesFromElement(el, ev, blockAttrsSet, extraAttrs, allowElementCallback, allowSelectors) {
    var props = {
        '$classes': $6fb9842575b03497$var$getClassName(el).split(' '),
        '$tag_name': el.tagName.toLowerCase()
    };
    var elId = el.id;
    if (elId) props['$id'] = elId;
    if ($6fb9842575b03497$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors)) $6fb9842575b03497$var$_.each($6fb9842575b03497$var$TRACKED_ATTRS.concat(extraAttrs), function(attr) {
        if (el.hasAttribute(attr) && !blockAttrsSet[attr]) {
            var attrVal = el.getAttribute(attr);
            if ($6fb9842575b03497$var$shouldTrackValue(attrVal)) props['$attr-' + attr] = attrVal;
        }
    });
    var nthChild = 1;
    var nthOfType = 1;
    var currentElem = el;
    while(currentElem = $6fb9842575b03497$var$getPreviousElementSibling(currentElem)){
        nthChild++;
        if (currentElem.tagName === el.tagName) nthOfType++;
    }
    props['$nth_child'] = nthChild;
    props['$nth_of_type'] = nthOfType;
    return props;
}
function $6fb9842575b03497$var$getPropsForDOMEvent(ev, config) {
    var allowElementCallback = config.allowElementCallback;
    var allowSelectors = config.allowSelectors || [];
    var blockAttrs = config.blockAttrs || [];
    var blockElementCallback = config.blockElementCallback;
    var blockSelectors = config.blockSelectors || [];
    var captureTextContent = config.captureTextContent || false;
    var captureExtraAttrs = config.captureExtraAttrs || [];
    var capturedForHeatMap = config.capturedForHeatMap || false;
    // convert array to set every time, as the config may have changed
    var blockAttrsSet = {};
    $6fb9842575b03497$var$_.each(blockAttrs, function(attr) {
        blockAttrsSet[attr] = true;
    });
    var props = null;
    var target = typeof ev.target === 'undefined' ? ev.srcElement : ev.target;
    if ($6fb9842575b03497$var$isTextNode(target)) target = target.parentNode;
    if ($6fb9842575b03497$var$shouldTrackDomEvent(target, ev) && $6fb9842575b03497$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) && !$6fb9842575b03497$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) {
        var targetElementList = [
            target
        ];
        var curEl = target;
        while(curEl.parentNode && !$6fb9842575b03497$var$isTag(curEl, 'body')){
            targetElementList.push(curEl.parentNode);
            curEl = curEl.parentNode;
        }
        var elementsJson = [];
        var href, explicitNoTrack = false;
        $6fb9842575b03497$var$_.each(targetElementList, function(el) {
            var shouldTrackDetails = $6fb9842575b03497$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors);
            // if the element or a parent element is an anchor tag
            // include the href as a property
            if (!blockAttrsSet['href'] && el.tagName.toLowerCase() === 'a') {
                href = el.getAttribute('href');
                href = shouldTrackDetails && $6fb9842575b03497$var$shouldTrackValue(href) && href;
            }
            if ($6fb9842575b03497$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors)) explicitNoTrack = true;
            elementsJson.push($6fb9842575b03497$var$getPropertiesFromElement(el, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors));
        }, this);
        if (!explicitNoTrack) {
            var docElement = $6fb9842575b03497$var$document$1['documentElement'];
            props = {
                '$event_type': ev.type,
                '$host': $6fb9842575b03497$var$win.location.host,
                '$pathname': $6fb9842575b03497$var$win.location.pathname,
                '$elements': elementsJson,
                '$el_attr__href': href,
                '$viewportHeight': Math.max(docElement['clientHeight'], $6fb9842575b03497$var$win['innerHeight'] || 0),
                '$viewportWidth': Math.max(docElement['clientWidth'], $6fb9842575b03497$var$win['innerWidth'] || 0),
                '$pageHeight': $6fb9842575b03497$var$document$1['body']['offsetHeight'] || 0,
                '$pageWidth': $6fb9842575b03497$var$document$1['body']['offsetWidth'] || 0
            };
            $6fb9842575b03497$var$_.each(captureExtraAttrs, function(attr) {
                if (!blockAttrsSet[attr] && target.hasAttribute(attr)) {
                    var attrVal = target.getAttribute(attr);
                    if ($6fb9842575b03497$var$shouldTrackValue(attrVal)) props['$el_attr__' + attr] = attrVal;
                }
            });
            if (captureTextContent) {
                elementText = $6fb9842575b03497$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (ev.type === $6fb9842575b03497$var$EV_CLICK) {
                $6fb9842575b03497$var$_.each($6fb9842575b03497$var$CLICK_EVENT_PROPS, function(prop) {
                    if (prop in ev) props['$' + prop] = ev[prop];
                });
                if (capturedForHeatMap) props['$captured_for_heatmap'] = true;
                target = $6fb9842575b03497$var$guessRealClickTarget(ev);
            }
            // prioritize text content from "real" click target if different from original target
            if (captureTextContent) {
                var elementText = $6fb9842575b03497$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (target) {
                // target may have been recalculated; check allowlists and blocklists again
                if (!$6fb9842575b03497$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) || $6fb9842575b03497$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) return null;
                var targetProps = $6fb9842575b03497$var$getPropertiesFromElement(target, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors);
                props['$target'] = targetProps;
                // pull up more props onto main event props
                props['$el_classes'] = targetProps['$classes'];
                $6fb9842575b03497$var$_.extend(props, $6fb9842575b03497$var$_.strip_empty_properties({
                    '$el_id': targetProps['$id'],
                    '$el_tag_name': targetProps['$tag_name']
                }));
            }
        }
    }
    return props;
}
/**
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {string} the element's direct text content
 */ function $6fb9842575b03497$var$getSafeText(el, ev, allowElementCallback, allowSelectors) {
    var elText = '';
    if ($6fb9842575b03497$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) && el.childNodes && el.childNodes.length) $6fb9842575b03497$var$_.each(el.childNodes, function(child) {
        if ($6fb9842575b03497$var$isTextNode(child) && child.textContent) elText += $6fb9842575b03497$var$_.trim(child.textContent)// scrub potentially sensitive values
        .split(/(\s+)/).filter($6fb9842575b03497$var$shouldTrackValue).join('')// normalize whitespace
        .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')// truncate
        .substring(0, 255);
    });
    return $6fb9842575b03497$var$_.trim(elText);
}
function $6fb9842575b03497$var$guessRealClickTarget(ev) {
    var target = ev.target;
    var composedPath = ev['composedPath']();
    for(var i = 0; i < composedPath.length; i++){
        var node = composedPath[i];
        if ($6fb9842575b03497$var$isTag(node, 'a') || $6fb9842575b03497$var$isTag(node, 'button') || $6fb9842575b03497$var$isTag(node, 'input') || $6fb9842575b03497$var$isTag(node, 'select') || node.getAttribute && node.getAttribute('role') === 'button') {
            target = node;
            break;
        }
        if (node === target) break;
    }
    return target;
}
function $6fb9842575b03497$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors) {
    if (allowElementCallback) try {
        if (!allowElementCallback(el, ev)) return false;
    } catch (err) {
        $6fb9842575b03497$var$logger$1.critical('Error while checking element in allowElementCallback', err);
        return false;
    }
    if (!allowSelectors.length) // no allowlist; all elements are fair game
    return true;
    for(var i = 0; i < allowSelectors.length; i++){
        var sel = allowSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            $6fb9842575b03497$var$logger$1.critical('Error while checking selector: ' + sel, err);
        }
    }
    return false;
}
function $6fb9842575b03497$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors) {
    var i;
    if (blockElementCallback) try {
        if (blockElementCallback(el, ev)) return true;
    } catch (err) {
        $6fb9842575b03497$var$logger$1.critical('Error while checking element in blockElementCallback', err);
        return true;
    }
    if (blockSelectors && blockSelectors.length) // programmatically prevent tracking of elements that match CSS selectors
    for(i = 0; i < blockSelectors.length; i++){
        var sel = blockSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            $6fb9842575b03497$var$logger$1.critical('Error while checking selector: ' + sel, err);
        }
    }
    // allow users to programmatically prevent tracking of elements by adding default classes such as 'mp-no-track'
    var classes = $6fb9842575b03497$var$getClasses(el);
    for(i = 0; i < $6fb9842575b03497$var$OPT_OUT_CLASSES.length; i++){
        if (classes[$6fb9842575b03497$var$OPT_OUT_CLASSES[i]]) return true;
    }
    return false;
}
/*
 * Check whether a DOM node has nodeType Node.ELEMENT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of the correct nodeType
 */ function $6fb9842575b03497$var$isElementNode(node) {
    return node && node.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}
/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */ function $6fb9842575b03497$var$isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}
/*
 * Check whether a DOM node is a TEXT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of type Node.TEXT_NODE
 */ function $6fb9842575b03497$var$isTextNode(node) {
    return node && node.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}
function $6fb9842575b03497$var$minDOMApisSupported() {
    try {
        var testEl = $6fb9842575b03497$var$document$1.createElement('div');
        return !!testEl['matches'];
    } catch (err) {
        return false;
    }
}
/*
 * Check whether a DOM event should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} ev - event to check
 * @returns {boolean} whether the event should be tracked
 */ function $6fb9842575b03497$var$shouldTrackDomEvent(el, ev) {
    if (!el || $6fb9842575b03497$var$isTag(el, 'html') || !$6fb9842575b03497$var$isElementNode(el)) return false;
    var tag = el.tagName.toLowerCase();
    switch(tag){
        case 'form':
            return ev.type === $6fb9842575b03497$var$EV_SUBMIT;
        case 'input':
            if ([
                'button',
                'submit'
            ].indexOf(el.getAttribute('type')) === -1) return ev.type === $6fb9842575b03497$var$EV_CHANGE;
            else return ev.type === $6fb9842575b03497$var$EV_CLICK;
        case 'select':
        case 'textarea':
            return ev.type === $6fb9842575b03497$var$EV_CHANGE;
        default:
            return ev.type === $6fb9842575b03497$var$EV_CLICK;
    }
}
/*
 * Check whether a DOM element should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {boolean} whether the element should be tracked
 */ function $6fb9842575b03497$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) {
    var i;
    if (!$6fb9842575b03497$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors)) return false;
    for(var curEl = el; curEl.parentNode && !$6fb9842575b03497$var$isTag(curEl, 'body'); curEl = curEl.parentNode){
        var classes = $6fb9842575b03497$var$getClasses(curEl);
        for(i = 0; i < $6fb9842575b03497$var$SENSITIVE_DATA_CLASSES.length; i++){
            if (classes[$6fb9842575b03497$var$SENSITIVE_DATA_CLASSES[i]]) return false;
        }
    }
    var elClasses = $6fb9842575b03497$var$getClasses(el);
    for(i = 0; i < $6fb9842575b03497$var$OPT_IN_CLASSES.length; i++){
        if (elClasses[$6fb9842575b03497$var$OPT_IN_CLASSES[i]]) return true;
    }
    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if ($6fb9842575b03497$var$isTag(el, 'input') || $6fb9842575b03497$var$isTag(el, 'select') || $6fb9842575b03497$var$isTag(el, 'textarea') || el.getAttribute('contenteditable') === 'true') return false;
    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') switch(type.toLowerCase()){
        case 'hidden':
            return false;
        case 'password':
            return false;
    }
    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    if (typeof name === 'string') {
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) return false;
    }
    return true;
}
/*
 * Check whether a string value should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */ function $6fb9842575b03497$var$shouldTrackValue(value) {
    if (value === null || $6fb9842575b03497$var$_.isUndefined(value)) return false;
    if (typeof value === 'string') {
        value = $6fb9842575b03497$var$_.trim(value);
        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[- ]/g, ''))) return false;
        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) return false;
    }
    return true;
}
var $6fb9842575b03497$var$AUTOCAPTURE_CONFIG_KEY = 'autocapture';
var $6fb9842575b03497$var$LEGACY_PAGEVIEW_CONFIG_KEY = 'track_pageview';
var $6fb9842575b03497$var$PAGEVIEW_OPTION_FULL_URL = 'full-url';
var $6fb9842575b03497$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING = 'url-with-path-and-query-string';
var $6fb9842575b03497$var$PAGEVIEW_OPTION_URL_WITH_PATH = 'url-with-path';
var $6fb9842575b03497$var$CONFIG_ALLOW_ELEMENT_CALLBACK = 'allow_element_callback';
var $6fb9842575b03497$var$CONFIG_ALLOW_SELECTORS = 'allow_selectors';
var $6fb9842575b03497$var$CONFIG_ALLOW_URL_REGEXES = 'allow_url_regexes';
var $6fb9842575b03497$var$CONFIG_BLOCK_ATTRS = 'block_attrs';
var $6fb9842575b03497$var$CONFIG_BLOCK_ELEMENT_CALLBACK = 'block_element_callback';
var $6fb9842575b03497$var$CONFIG_BLOCK_SELECTORS = 'block_selectors';
var $6fb9842575b03497$var$CONFIG_BLOCK_URL_REGEXES = 'block_url_regexes';
var $6fb9842575b03497$var$CONFIG_CAPTURE_EXTRA_ATTRS = 'capture_extra_attrs';
var $6fb9842575b03497$var$CONFIG_CAPTURE_TEXT_CONTENT = 'capture_text_content';
var $6fb9842575b03497$var$CONFIG_SCROLL_CAPTURE_ALL = 'scroll_capture_all';
var $6fb9842575b03497$var$CONFIG_SCROLL_CHECKPOINTS = 'scroll_depth_percent_checkpoints';
var $6fb9842575b03497$var$CONFIG_TRACK_CLICK = 'click';
var $6fb9842575b03497$var$CONFIG_TRACK_INPUT = 'input';
var $6fb9842575b03497$var$CONFIG_TRACK_PAGEVIEW = 'pageview';
var $6fb9842575b03497$var$CONFIG_TRACK_SCROLL = 'scroll';
var $6fb9842575b03497$var$CONFIG_TRACK_SUBMIT = 'submit';
var $6fb9842575b03497$var$CONFIG_DEFAULTS$1 = {};
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_ALLOW_SELECTORS] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_ALLOW_URL_REGEXES] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_BLOCK_ATTRS] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_BLOCK_ELEMENT_CALLBACK] = null;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_BLOCK_SELECTORS] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_BLOCK_URL_REGEXES] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_CAPTURE_EXTRA_ATTRS] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_CAPTURE_TEXT_CONTENT] = false;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_SCROLL_CAPTURE_ALL] = false;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_SCROLL_CHECKPOINTS] = [
    25,
    50,
    75,
    100
];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_CLICK] = true;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_INPUT] = true;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_PAGEVIEW] = $6fb9842575b03497$var$PAGEVIEW_OPTION_FULL_URL;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_SCROLL] = true;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_SUBMIT] = true;
var $6fb9842575b03497$var$DEFAULT_PROPS = {
    '$mp_autocapture': true
};
var $6fb9842575b03497$var$MP_EV_CLICK = '$mp_click';
var $6fb9842575b03497$var$MP_EV_INPUT = '$mp_input_change';
var $6fb9842575b03497$var$MP_EV_SCROLL = '$mp_scroll';
var $6fb9842575b03497$var$MP_EV_SUBMIT = '$mp_submit';
/**
 * Autocapture: manages automatic event tracking
 * @constructor
 */ var $6fb9842575b03497$var$Autocapture = function(mp) {
    this.mp = mp;
};
$6fb9842575b03497$var$Autocapture.prototype.init = function() {
    if (!$6fb9842575b03497$var$minDOMApisSupported()) {
        $6fb9842575b03497$var$logger$1.critical('Autocapture unavailable: missing required DOM APIs');
        return;
    }
    this.initPageviewTracking();
    this.initClickTracking();
    this.initInputTracking();
    this.initScrollTracking();
    this.initSubmitTracking();
};
$6fb9842575b03497$var$Autocapture.prototype.getFullConfig = function() {
    var autocaptureConfig = this.mp.get_config($6fb9842575b03497$var$AUTOCAPTURE_CONFIG_KEY);
    if (!autocaptureConfig) // Autocapture is completely off
    return {};
    else if ($6fb9842575b03497$var$_.isObject(autocaptureConfig)) return $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$CONFIG_DEFAULTS$1, autocaptureConfig);
    else // Autocapture config is non-object truthy value, return default
    return $6fb9842575b03497$var$CONFIG_DEFAULTS$1;
};
$6fb9842575b03497$var$Autocapture.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$6fb9842575b03497$var$Autocapture.prototype.currentUrlBlocked = function() {
    var i;
    var currentUrl = $6fb9842575b03497$var$_.info.currentUrl();
    var allowUrlRegexes = this.getConfig($6fb9842575b03497$var$CONFIG_ALLOW_URL_REGEXES) || [];
    if (allowUrlRegexes.length) {
        // we're using an allowlist, only track if current URL matches
        var allowed = false;
        for(i = 0; i < allowUrlRegexes.length; i++){
            var allowRegex = allowUrlRegexes[i];
            try {
                if (currentUrl.match(allowRegex)) {
                    allowed = true;
                    break;
                }
            } catch (err) {
                $6fb9842575b03497$var$logger$1.critical('Error while checking block URL regex: ' + allowRegex, err);
                return true;
            }
        }
        if (!allowed) // wasn't allowed by any regex
        return true;
    }
    var blockUrlRegexes = this.getConfig($6fb9842575b03497$var$CONFIG_BLOCK_URL_REGEXES) || [];
    if (!blockUrlRegexes || !blockUrlRegexes.length) return false;
    for(i = 0; i < blockUrlRegexes.length; i++)try {
        if (currentUrl.match(blockUrlRegexes[i])) return true;
    } catch (err) {
        $6fb9842575b03497$var$logger$1.critical('Error while checking block URL regex: ' + blockUrlRegexes[i], err);
        return true;
    }
    return false;
};
$6fb9842575b03497$var$Autocapture.prototype.pageviewTrackingConfig = function() {
    // supports both autocapture config and old track_pageview config
    if (this.mp.get_config($6fb9842575b03497$var$AUTOCAPTURE_CONFIG_KEY)) return this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_PAGEVIEW);
    else return this.mp.get_config($6fb9842575b03497$var$LEGACY_PAGEVIEW_CONFIG_KEY);
};
// helper for event handlers
$6fb9842575b03497$var$Autocapture.prototype.trackDomEvent = function(ev, mpEventName) {
    if (this.currentUrlBlocked()) return;
    var props = $6fb9842575b03497$var$getPropsForDOMEvent(ev, {
        allowElementCallback: this.getConfig($6fb9842575b03497$var$CONFIG_ALLOW_ELEMENT_CALLBACK),
        allowSelectors: this.getConfig($6fb9842575b03497$var$CONFIG_ALLOW_SELECTORS),
        blockAttrs: this.getConfig($6fb9842575b03497$var$CONFIG_BLOCK_ATTRS),
        blockElementCallback: this.getConfig($6fb9842575b03497$var$CONFIG_BLOCK_ELEMENT_CALLBACK),
        blockSelectors: this.getConfig($6fb9842575b03497$var$CONFIG_BLOCK_SELECTORS),
        captureExtraAttrs: this.getConfig($6fb9842575b03497$var$CONFIG_CAPTURE_EXTRA_ATTRS),
        captureTextContent: this.getConfig($6fb9842575b03497$var$CONFIG_CAPTURE_TEXT_CONTENT),
        capturedForHeatMap: mpEventName === $6fb9842575b03497$var$MP_EV_CLICK && !this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_CLICK) && this.mp.is_recording_heatmap_data()
    });
    if (props) {
        $6fb9842575b03497$var$_.extend(props, $6fb9842575b03497$var$DEFAULT_PROPS);
        this.mp.track(mpEventName, props);
    }
};
$6fb9842575b03497$var$Autocapture.prototype.initClickTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_CLICK, this.listenerClick);
    if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_CLICK) && !this.mp.get_config('record_heatmap_data')) return;
    $6fb9842575b03497$var$logger$1.log('Initializing click tracking');
    this.listenerClick = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_CLICK, (function(ev) {
        if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_CLICK) && !this.mp.is_recording_heatmap_data()) return;
        this.trackDomEvent(ev, $6fb9842575b03497$var$MP_EV_CLICK);
    }).bind(this));
};
$6fb9842575b03497$var$Autocapture.prototype.initInputTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_CHANGE, this.listenerChange);
    if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_INPUT)) return;
    $6fb9842575b03497$var$logger$1.log('Initializing input tracking');
    this.listenerChange = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_CHANGE, (function(ev) {
        if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_INPUT)) return;
        this.trackDomEvent(ev, $6fb9842575b03497$var$MP_EV_INPUT);
    }).bind(this));
};
$6fb9842575b03497$var$Autocapture.prototype.initPageviewTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_POPSTATE, this.listenerPopstate);
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_HASHCHANGE, this.listenerHashchange);
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE, this.listenerLocationchange);
    if (!this.pageviewTrackingConfig()) return;
    $6fb9842575b03497$var$logger$1.log('Initializing pageview tracking');
    var previousTrackedUrl = '';
    var tracked = false;
    if (!this.currentUrlBlocked()) tracked = this.mp.track_pageview($6fb9842575b03497$var$DEFAULT_PROPS);
    if (tracked) previousTrackedUrl = $6fb9842575b03497$var$_.info.currentUrl();
    this.listenerPopstate = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_POPSTATE, function() {
        $6fb9842575b03497$var$win.dispatchEvent(new Event($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE));
    });
    this.listenerHashchange = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_HASHCHANGE, function() {
        $6fb9842575b03497$var$win.dispatchEvent(new Event($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE));
    });
    var nativePushState = $6fb9842575b03497$var$win.history.pushState;
    if (typeof nativePushState === 'function') $6fb9842575b03497$var$win.history.pushState = function(state, unused, url) {
        nativePushState.call($6fb9842575b03497$var$win.history, state, unused, url);
        $6fb9842575b03497$var$win.dispatchEvent(new Event($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE));
    };
    var nativeReplaceState = $6fb9842575b03497$var$win.history.replaceState;
    if (typeof nativeReplaceState === 'function') $6fb9842575b03497$var$win.history.replaceState = function(state, unused, url) {
        nativeReplaceState.call($6fb9842575b03497$var$win.history, state, unused, url);
        $6fb9842575b03497$var$win.dispatchEvent(new Event($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE));
    };
    this.listenerLocationchange = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE, $6fb9842575b03497$var$safewrap((function() {
        if (this.currentUrlBlocked()) return;
        var currentUrl = $6fb9842575b03497$var$_.info.currentUrl();
        var shouldTrack = false;
        var didPathChange = currentUrl.split('#')[0].split('?')[0] !== previousTrackedUrl.split('#')[0].split('?')[0];
        var trackPageviewOption = this.pageviewTrackingConfig();
        if (trackPageviewOption === $6fb9842575b03497$var$PAGEVIEW_OPTION_FULL_URL) shouldTrack = currentUrl !== previousTrackedUrl;
        else if (trackPageviewOption === $6fb9842575b03497$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING) shouldTrack = currentUrl.split('#')[0] !== previousTrackedUrl.split('#')[0];
        else if (trackPageviewOption === $6fb9842575b03497$var$PAGEVIEW_OPTION_URL_WITH_PATH) shouldTrack = didPathChange;
        if (shouldTrack) {
            var tracked = this.mp.track_pageview($6fb9842575b03497$var$DEFAULT_PROPS);
            if (tracked) previousTrackedUrl = currentUrl;
            if (didPathChange) {
                this.lastScrollCheckpoint = 0;
                $6fb9842575b03497$var$logger$1.log('Path change: re-initializing scroll depth checkpoints');
            }
        }
    }).bind(this)));
};
$6fb9842575b03497$var$Autocapture.prototype.initScrollTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_SCROLLEND, this.listenerScroll);
    if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_SCROLL)) return;
    $6fb9842575b03497$var$logger$1.log('Initializing scroll tracking');
    this.lastScrollCheckpoint = 0;
    this.listenerScroll = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_SCROLLEND, $6fb9842575b03497$var$safewrap((function() {
        if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_SCROLL)) return;
        if (this.currentUrlBlocked()) return;
        var shouldTrack = this.getConfig($6fb9842575b03497$var$CONFIG_SCROLL_CAPTURE_ALL);
        var scrollCheckpoints = (this.getConfig($6fb9842575b03497$var$CONFIG_SCROLL_CHECKPOINTS) || []).slice().sort(function(a, b) {
            return a - b;
        });
        var scrollTop = $6fb9842575b03497$var$win.scrollY;
        var props = $6fb9842575b03497$var$_.extend({
            '$scroll_top': scrollTop
        }, $6fb9842575b03497$var$DEFAULT_PROPS);
        try {
            var scrollHeight = $6fb9842575b03497$var$document$1.body.scrollHeight;
            var scrollPercentage = Math.round(scrollTop / (scrollHeight - $6fb9842575b03497$var$win.innerHeight) * 100);
            props['$scroll_height'] = scrollHeight;
            props['$scroll_percentage'] = scrollPercentage;
            if (scrollPercentage > this.lastScrollCheckpoint) for(var i = 0; i < scrollCheckpoints.length; i++){
                var checkpoint = scrollCheckpoints[i];
                if (scrollPercentage >= checkpoint && this.lastScrollCheckpoint < checkpoint) {
                    props['$scroll_checkpoint'] = checkpoint;
                    this.lastScrollCheckpoint = checkpoint;
                    shouldTrack = true;
                }
            }
        } catch (err) {
            $6fb9842575b03497$var$logger$1.critical('Error while calculating scroll percentage', err);
        }
        if (shouldTrack) this.mp.track($6fb9842575b03497$var$MP_EV_SCROLL, props);
    }).bind(this)));
};
$6fb9842575b03497$var$Autocapture.prototype.initSubmitTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_SUBMIT, this.listenerSubmit);
    if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_SUBMIT)) return;
    $6fb9842575b03497$var$logger$1.log('Initializing submit tracking');
    this.listenerSubmit = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_SUBMIT, (function(ev) {
        if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_SUBMIT)) return;
        this.trackDomEvent(ev, $6fb9842575b03497$var$MP_EV_SUBMIT);
    }).bind(this));
};
// TODO integrate error_reporter from mixpanel instance
$6fb9842575b03497$var$safewrapClass($6fb9842575b03497$var$Autocapture);
var $6fb9842575b03497$var$fetch = $6fb9842575b03497$var$win['fetch'];
var $6fb9842575b03497$var$logger = $6fb9842575b03497$var$console_with_prefix('flags');
var $6fb9842575b03497$var$FLAGS_CONFIG_KEY = 'flags';
var $6fb9842575b03497$var$CONFIG_CONTEXT = 'context';
var $6fb9842575b03497$var$CONFIG_DEFAULTS = {};
$6fb9842575b03497$var$CONFIG_DEFAULTS[$6fb9842575b03497$var$CONFIG_CONTEXT] = {};
/**
 * FeatureFlagManager: support for Mixpanel's feature flagging product
 * @constructor
 */ var $6fb9842575b03497$var$FeatureFlagManager = function(initOptions) {
    this.getMpConfig = initOptions.getConfigFunc;
    this.getDistinctId = initOptions.getDistinctIdFunc;
    this.track = initOptions.trackingFunc;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.init = function() {
    if (!$6fb9842575b03497$var$minApisSupported()) {
        $6fb9842575b03497$var$logger.critical('Feature Flags unavailable: missing minimum required APIs');
        return;
    }
    this.flags = null;
    this.fetchFlags();
    this.trackedFeatures = new Set();
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getFullConfig = function() {
    var ffConfig = this.getMpConfig($6fb9842575b03497$var$FLAGS_CONFIG_KEY);
    if (!ffConfig) // flags are completely off
    return {};
    else if ($6fb9842575b03497$var$_.isObject(ffConfig)) return $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$CONFIG_DEFAULTS, ffConfig);
    else // config is non-object truthy value, return default
    return $6fb9842575b03497$var$CONFIG_DEFAULTS;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.isSystemEnabled = function() {
    return !!this.getMpConfig($6fb9842575b03497$var$FLAGS_CONFIG_KEY);
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.areFlagsReady = function() {
    if (!this.isSystemEnabled()) $6fb9842575b03497$var$logger.error('Feature Flags not enabled');
    return !!this.flags;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.fetchFlags = function() {
    if (!this.isSystemEnabled()) return;
    var distinctId = this.getDistinctId();
    $6fb9842575b03497$var$logger.log('Fetching flags for distinct ID: ' + distinctId);
    var reqParams = {
        'context': $6fb9842575b03497$var$_.extend({
            'distinct_id': distinctId
        }, this.getConfig($6fb9842575b03497$var$CONFIG_CONTEXT))
    };
    this.fetchPromise = $6fb9842575b03497$var$win['fetch'](this.getMpConfig('api_host') + '/' + this.getMpConfig('api_routes')['flags'], {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getMpConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': JSON.stringify(reqParams)
    }).then((function(response) {
        return response.json().then((function(responseBody) {
            var responseFlags = responseBody['flags'];
            if (!responseFlags) throw new Error('No flags in API response');
            var flags = new Map();
            $6fb9842575b03497$var$_.each(responseFlags, function(data, key) {
                flags.set(key, {
                    'key': data['variant_key'],
                    'value': data['variant_value']
                });
            });
            this.flags = flags;
        }).bind(this)).catch(function(error) {
            $6fb9842575b03497$var$logger.error(error);
        });
    }).bind(this)).catch(function() {});
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getVariant = function(featureName, fallback) {
    if (!this.fetchPromise) return new Promise(function(resolve) {
        $6fb9842575b03497$var$logger.critical('Feature Flags not initialized');
        resolve(fallback);
    });
    return this.fetchPromise.then((function() {
        return this.getVariantSync(featureName, fallback);
    }).bind(this)).catch(function(error) {
        $6fb9842575b03497$var$logger.error(error);
        return fallback;
    });
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getVariantSync = function(featureName, fallback) {
    if (!this.areFlagsReady()) {
        $6fb9842575b03497$var$logger.log('Flags not loaded yet');
        return fallback;
    }
    var feature = this.flags.get(featureName);
    if (!feature) {
        $6fb9842575b03497$var$logger.log('No flag found: "' + featureName + '"');
        return fallback;
    }
    this.trackFeatureCheck(featureName, feature);
    return feature;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getVariantValue = function(featureName, fallbackValue) {
    return this.getVariant(featureName, {
        'value': fallbackValue
    }).then(function(feature) {
        return feature['value'];
    }).catch(function(error) {
        $6fb9842575b03497$var$logger.error(error);
        return fallbackValue;
    });
};
// TODO remove deprecated method
$6fb9842575b03497$var$FeatureFlagManager.prototype.getFeatureData = function(featureName, fallbackValue) {
    $6fb9842575b03497$var$logger.critical('mixpanel.flags.get_feature_data() is deprecated and will be removed in a future release. Use mixpanel.flags.get_variant_value() instead.');
    return this.getVariantValue(featureName, fallbackValue);
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getVariantValueSync = function(featureName, fallbackValue) {
    return this.getVariantSync(featureName, {
        'value': fallbackValue
    })['value'];
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.isEnabled = function(featureName, fallbackValue) {
    return this.getVariantValue(featureName).then((function() {
        return this.isEnabledSync(featureName, fallbackValue);
    }).bind(this)).catch(function(error) {
        $6fb9842575b03497$var$logger.error(error);
        return fallbackValue;
    });
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.isEnabledSync = function(featureName, fallbackValue) {
    fallbackValue = fallbackValue || false;
    var val = this.getVariantValueSync(featureName, fallbackValue);
    if (val !== true && val !== false) {
        $6fb9842575b03497$var$logger.error('Feature flag "' + featureName + '" value: ' + val + ' is not a boolean; returning fallback value: ' + fallbackValue);
        val = fallbackValue;
    }
    return val;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.trackFeatureCheck = function(featureName, feature) {
    if (this.trackedFeatures.has(featureName)) return;
    this.trackedFeatures.add(featureName);
    this.track('$experiment_started', {
        'Experiment name': featureName,
        'Variant name': feature['key'],
        '$experiment_type': 'feature_flag'
    });
};
function $6fb9842575b03497$var$minApisSupported() {
    return !!$6fb9842575b03497$var$fetch && typeof Promise !== 'undefined' && typeof Map !== 'undefined' && typeof Set !== 'undefined';
}
$6fb9842575b03497$var$safewrapClass($6fb9842575b03497$var$FeatureFlagManager);
$6fb9842575b03497$var$FeatureFlagManager.prototype['are_flags_ready'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.areFlagsReady;
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_variant'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getVariant;
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_variant_sync'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getVariantSync;
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_variant_value'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getVariantValue;
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_variant_value_sync'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getVariantValueSync;
$6fb9842575b03497$var$FeatureFlagManager.prototype['is_enabled'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.isEnabled;
$6fb9842575b03497$var$FeatureFlagManager.prototype['is_enabled_sync'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.isEnabledSync;
// Deprecated method
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_feature_data'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getFeatureData;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $6fb9842575b03497$var$DomTracker = function() {};
// interface
$6fb9842575b03497$var$DomTracker.prototype.create_properties = function() {};
$6fb9842575b03497$var$DomTracker.prototype.event_handler = function() {};
$6fb9842575b03497$var$DomTracker.prototype.after_track_handler = function() {};
$6fb9842575b03497$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $6fb9842575b03497$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $6fb9842575b03497$var$_.dom_query(query);
    if (elements.length === 0) {
        $6fb9842575b03497$var$console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }
    $6fb9842575b03497$var$_.each(elements, function(element) {
        $6fb9842575b03497$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $6fb9842575b03497$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$6fb9842575b03497$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === 'function') props = properties(element);
    else props = $6fb9842575b03497$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $6fb9842575b03497$var$LinkTracker = function() {
    this.override_event = 'click';
};
$6fb9842575b03497$var$_.inherit($6fb9842575b03497$var$LinkTracker, $6fb9842575b03497$var$DomTracker);
$6fb9842575b03497$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $6fb9842575b03497$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props['url'] = element.href;
    return props;
};
$6fb9842575b03497$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$6fb9842575b03497$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $6fb9842575b03497$var$FormTracker = function() {
    this.override_event = 'submit';
};
$6fb9842575b03497$var$_.inherit($6fb9842575b03497$var$FormTracker, $6fb9842575b03497$var$DomTracker);
$6fb9842575b03497$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$6fb9842575b03497$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
/* eslint camelcase: "off" */ /** @const */ var $6fb9842575b03497$var$SET_ACTION = '$set';
/** @const */ var $6fb9842575b03497$var$SET_ONCE_ACTION = '$set_once';
/** @const */ var $6fb9842575b03497$var$UNSET_ACTION = '$unset';
/** @const */ var $6fb9842575b03497$var$ADD_ACTION = '$add';
/** @const */ var $6fb9842575b03497$var$APPEND_ACTION = '$append';
/** @const */ var $6fb9842575b03497$var$UNION_ACTION = '$union';
/** @const */ var $6fb9842575b03497$var$REMOVE_ACTION = '$remove';
/** @const */ var $6fb9842575b03497$var$DELETE_ACTION = '$delete';
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $6fb9842575b03497$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($6fb9842575b03497$var$_.isObject(prop)) $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$6fb9842575b03497$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$6fb9842575b03497$var$_.isArray(prop)) prop = [
            prop
        ];
        $6fb9842575b03497$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$6fb9842575b03497$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($6fb9842575b03497$var$_.isObject(prop)) $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$6fb9842575b03497$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $6fb9842575b03497$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $6fb9842575b03497$var$_.isArray(values) ? values : [
            values
        ];
        data[$6fb9842575b03497$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$6fb9842575b03497$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$6fb9842575b03497$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$6fb9842575b03497$var$DELETE_ACTION] = '';
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelGroup = function() {};
$6fb9842575b03497$var$_.extend($6fb9842575b03497$var$MixpanelGroup.prototype, $6fb9842575b03497$var$apiActions);
$6fb9842575b03497$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.set = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.set_once = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.unset = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.union = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype['delete'] = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.remove = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$6fb9842575b03497$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');
    var date_encoded_data = $6fb9842575b03497$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['groups'],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$6fb9842575b03497$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};
$6fb9842575b03497$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$6fb9842575b03497$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};
// MixpanelGroup Exports
$6fb9842575b03497$var$MixpanelGroup.prototype['remove'] = $6fb9842575b03497$var$MixpanelGroup.prototype.remove;
$6fb9842575b03497$var$MixpanelGroup.prototype['set'] = $6fb9842575b03497$var$MixpanelGroup.prototype.set;
$6fb9842575b03497$var$MixpanelGroup.prototype['set_once'] = $6fb9842575b03497$var$MixpanelGroup.prototype.set_once;
$6fb9842575b03497$var$MixpanelGroup.prototype['union'] = $6fb9842575b03497$var$MixpanelGroup.prototype.union;
$6fb9842575b03497$var$MixpanelGroup.prototype['unset'] = $6fb9842575b03497$var$MixpanelGroup.prototype.unset;
$6fb9842575b03497$var$MixpanelGroup.prototype['toString'] = $6fb9842575b03497$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelPeople = function() {};
$6fb9842575b03497$var$_.extend($6fb9842575b03497$var$MixpanelPeople.prototype, $6fb9842575b03497$var$apiActions);
$6fb9842575b03497$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.set = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) this._mixpanel['persistence'].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$6fb9842575b03497$var$SET_ACTION] = $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$_.info.people_properties(), data[$6fb9842575b03497$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.set_once = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.unset = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.increment = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($6fb9842575b03497$var$_.isObject(prop)) {
        $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $6fb9842575b03497$var$console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($6fb9842575b03497$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$6fb9842575b03497$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.append = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.remove = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.union = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelPeople.prototype.track_charge = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function() {
    $6fb9842575b03497$var$console$1.error('mixpanel.people.track_charge() is deprecated and no longer has any effect.');
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $6fb9842575b03497$var$console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {
        '$delete': this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$6fb9842575b03497$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};
$6fb9842575b03497$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) data['$device_id'] = device_id;
    if (user_id) data['$user_id'] = user_id;
    if (had_persisted_distinct_id) data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    var date_encoded_data = $6fb9842575b03497$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$6fb9842575b03497$var$_.isUndefined(callback)) {
            if (this._get_config('verbose')) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $6fb9842575b03497$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['engage'],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$6fb9842575b03497$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($6fb9842575b03497$var$SET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$SET_ACTION, data);
    else if ($6fb9842575b03497$var$SET_ONCE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$SET_ONCE_ACTION, data);
    else if ($6fb9842575b03497$var$UNSET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$UNSET_ACTION, data);
    else if ($6fb9842575b03497$var$ADD_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$ADD_ACTION, data);
    else if ($6fb9842575b03497$var$APPEND_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$APPEND_ACTION, data);
    else if ($6fb9842575b03497$var$REMOVE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$REMOVE_ACTION, data);
    else if ($6fb9842575b03497$var$UNION_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$UNION_ACTION, data);
    else $6fb9842575b03497$var$console$1.error('Invalid call to _enqueue():', data);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $6fb9842575b03497$var$_.extend({}, this._mixpanel['persistence'].load_queue(action));
    var action_params = queued_data;
    if (!$6fb9842575b03497$var$_.isUndefined(queued_data) && $6fb9842575b03497$var$_.isObject(queued_data) && !$6fb9842575b03497$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        _this._mixpanel['persistence'].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            if (!$6fb9842575b03497$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$6fb9842575b03497$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($6fb9842575b03497$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($6fb9842575b03497$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($6fb9842575b03497$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $6fb9842575b03497$var$_.keys(queue);
    });
    this._flush_one_queue($6fb9842575b03497$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($6fb9842575b03497$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel['persistence'].load_queue($6fb9842575b03497$var$APPEND_ACTION);
    if (!$6fb9842575b03497$var$_.isUndefined($append_queue) && $6fb9842575b03497$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$APPEND_ACTION, $append_item);
            if (!$6fb9842575b03497$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel['persistence'].load_queue($6fb9842575b03497$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$6fb9842575b03497$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel['persistence'].load_queue($6fb9842575b03497$var$REMOVE_ACTION);
    if (!$6fb9842575b03497$var$_.isUndefined($remove_queue) && $6fb9842575b03497$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$REMOVE_ACTION, $remove_item);
            if (!$6fb9842575b03497$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel['persistence'].load_queue($6fb9842575b03497$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$6fb9842575b03497$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$6fb9842575b03497$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};
// MixpanelPeople Exports
$6fb9842575b03497$var$MixpanelPeople.prototype['set'] = $6fb9842575b03497$var$MixpanelPeople.prototype.set;
$6fb9842575b03497$var$MixpanelPeople.prototype['set_once'] = $6fb9842575b03497$var$MixpanelPeople.prototype.set_once;
$6fb9842575b03497$var$MixpanelPeople.prototype['unset'] = $6fb9842575b03497$var$MixpanelPeople.prototype.unset;
$6fb9842575b03497$var$MixpanelPeople.prototype['increment'] = $6fb9842575b03497$var$MixpanelPeople.prototype.increment;
$6fb9842575b03497$var$MixpanelPeople.prototype['append'] = $6fb9842575b03497$var$MixpanelPeople.prototype.append;
$6fb9842575b03497$var$MixpanelPeople.prototype['remove'] = $6fb9842575b03497$var$MixpanelPeople.prototype.remove;
$6fb9842575b03497$var$MixpanelPeople.prototype['union'] = $6fb9842575b03497$var$MixpanelPeople.prototype.union;
$6fb9842575b03497$var$MixpanelPeople.prototype['track_charge'] = $6fb9842575b03497$var$MixpanelPeople.prototype.track_charge;
$6fb9842575b03497$var$MixpanelPeople.prototype['clear_charges'] = $6fb9842575b03497$var$MixpanelPeople.prototype.clear_charges;
$6fb9842575b03497$var$MixpanelPeople.prototype['delete_user'] = $6fb9842575b03497$var$MixpanelPeople.prototype.delete_user;
$6fb9842575b03497$var$MixpanelPeople.prototype['toString'] = $6fb9842575b03497$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $6fb9842575b03497$var$SET_QUEUE_KEY = '__mps';
/** @const */ var $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */ var $6fb9842575b03497$var$UNSET_QUEUE_KEY = '__mpus';
/** @const */ var $6fb9842575b03497$var$ADD_QUEUE_KEY = '__mpa';
/** @const */ var $6fb9842575b03497$var$APPEND_QUEUE_KEY = '__mpap';
/** @const */ var $6fb9842575b03497$var$REMOVE_QUEUE_KEY = '__mpr';
/** @const */ var $6fb9842575b03497$var$UNION_QUEUE_KEY = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var $6fb9842575b03497$var$ALIAS_ID_KEY = '__alias';
/** @const */ var $6fb9842575b03497$var$EVENT_TIMERS_KEY = '__timers';
/** @const */ var $6fb9842575b03497$var$RESERVED_PROPERTIES = [
    $6fb9842575b03497$var$SET_QUEUE_KEY,
    $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY,
    $6fb9842575b03497$var$UNSET_QUEUE_KEY,
    $6fb9842575b03497$var$ADD_QUEUE_KEY,
    $6fb9842575b03497$var$APPEND_QUEUE_KEY,
    $6fb9842575b03497$var$REMOVE_QUEUE_KEY,
    $6fb9842575b03497$var$UNION_QUEUE_KEY,
    $6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY,
    $6fb9842575b03497$var$ALIAS_ID_KEY,
    $6fb9842575b03497$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;
    if (config['persistence_name']) this.name = 'mp_' + config['persistence_name'];
    else this.name = 'mp_' + config['token'] + '_mixpanel';
    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        $6fb9842575b03497$var$console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }
    if (storage_type === 'localStorage' && $6fb9842575b03497$var$_.localStorage.is_supported()) this.storage = $6fb9842575b03497$var$_.localStorage;
    else this.storage = $6fb9842575b03497$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $6fb9842575b03497$var$_.each(this['props'], function(v, k) {
        if (!$6fb9842575b03497$var$_.include($6fb9842575b03497$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this['props'] = $6fb9842575b03497$var$_.extend({}, entry);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === $6fb9842575b03497$var$_.localStorage) {
        old_cookie = $6fb9842575b03497$var$_.cookie.parse(this.name);
        $6fb9842575b03497$var$_.cookie.remove(this.name);
        $6fb9842575b03497$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === $6fb9842575b03497$var$_.cookie) {
        old_localstorage = $6fb9842575b03497$var$_.localStorage.parse(this.name);
        $6fb9842575b03497$var$_.localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $6fb9842575b03497$var$JSONStringify(this['props']), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this['props'][key];
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$6fb9842575b03497$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $6fb9842575b03497$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($6fb9842575b03497$var$_.isObject(props)) {
        if (typeof default_value === 'undefined') default_value = 'None';
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $6fb9842575b03497$var$_.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) this['props'][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $6fb9842575b03497$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($6fb9842575b03497$var$_.isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $6fb9842575b03497$var$_.extend(this['props'], props);
        this.save();
        return true;
    }
    return false;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($6fb9842575b03497$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': $6fb9842575b03497$var$_.info.referringDomain(referrer) || '$direct'
    }, '');
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $6fb9842575b03497$var$_.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($6fb9842575b03497$var$SET_ACTION), set_once_q = this._get_or_create_queue($6fb9842575b03497$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($6fb9842575b03497$var$UNSET_ACTION), add_q = this._get_or_create_queue($6fb9842575b03497$var$ADD_ACTION), union_q = this._get_or_create_queue($6fb9842575b03497$var$UNION_ACTION), remove_q = this._get_or_create_queue($6fb9842575b03497$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($6fb9842575b03497$var$APPEND_ACTION, []);
    if (q_key === $6fb9842575b03497$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $6fb9842575b03497$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($6fb9842575b03497$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($6fb9842575b03497$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$UNSET_QUEUE_KEY) $6fb9842575b03497$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $6fb9842575b03497$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $6fb9842575b03497$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $6fb9842575b03497$var$ADD_QUEUE_KEY) {
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$UNION_QUEUE_KEY) {
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            if ($6fb9842575b03497$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // Prevent duplicate values
                $6fb9842575b03497$var$_.each(v, function(item) {
                    if (!$6fb9842575b03497$var$_.include(union_q[k], item)) union_q[k].push(item);
                });
            }
        });
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$APPEND_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    }
    $6fb9842575b03497$var$console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    $6fb9842575b03497$var$console$1.log(data);
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this['props'][this._get_queue_key(queue)];
    if (!$6fb9842575b03497$var$_.isUndefined(q)) $6fb9842575b03497$var$_.each(data, function(v, k) {
        if (queue === $6fb9842575b03497$var$APPEND_ACTION || queue === $6fb9842575b03497$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $6fb9842575b03497$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $6fb9842575b03497$var$SET_ACTION) return $6fb9842575b03497$var$SET_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$SET_ONCE_ACTION) return $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$UNSET_ACTION) return $6fb9842575b03497$var$UNSET_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$ADD_ACTION) return $6fb9842575b03497$var$ADD_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$APPEND_ACTION) return $6fb9842575b03497$var$APPEND_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$REMOVE_ACTION) return $6fb9842575b03497$var$REMOVE_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$UNION_ACTION) return $6fb9842575b03497$var$UNION_QUEUE_KEY;
    else $6fb9842575b03497$var$console$1.error('Invalid queue:', queue);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $6fb9842575b03497$var$_.isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($6fb9842575b03497$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this['props'][$6fb9842575b03497$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($6fb9842575b03497$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$6fb9842575b03497$var$_.isUndefined(timestamp)) {
        delete this['props'][$6fb9842575b03497$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ /*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $6fb9842575b03497$var$init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var $6fb9842575b03497$var$load_extra_bundle = function(src, _onload) {
    throw new Error(src + ' not available in this build.');
};
var $6fb9842575b03497$var$mixpanel_master; // main mixpanel instance / object
var $6fb9842575b03497$var$INIT_MODULE = 0;
var $6fb9842575b03497$var$INIT_SNIPPET = 1;
var $6fb9842575b03497$var$IDENTITY_FUNC = function(x) {
    return x;
};
/** @const */ var $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64 = 'base64';
/** @const */ var $6fb9842575b03497$var$PAYLOAD_TYPE_JSON = 'json';
/** @const */ var $6fb9842575b03497$var$DEVICE_ID_PREFIX = '$device:';
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $6fb9842575b03497$var$USE_XHR = $6fb9842575b03497$var$win.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $6fb9842575b03497$var$ENQUEUE_REQUESTS = !$6fb9842575b03497$var$USE_XHR && $6fb9842575b03497$var$userAgent.indexOf('MSIE') === -1 && $6fb9842575b03497$var$userAgent.indexOf('Mozilla') === -1;
// save reference to navigator.sendBeacon so it can be minified
var $6fb9842575b03497$var$sendBeacon = null;
if ($6fb9842575b03497$var$navigator['sendBeacon']) $6fb9842575b03497$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $6fb9842575b03497$var$navigator['sendBeacon'].apply($6fb9842575b03497$var$navigator, arguments);
};
var $6fb9842575b03497$var$DEFAULT_API_ROUTES = {
    'track': 'track/',
    'engage': 'engage/',
    'groups': 'groups/',
    'record': 'record/',
    'flags': 'flags/'
};
/*
 * Module-level globals
 */ var $6fb9842575b03497$var$DEFAULT_CONFIG = {
    'api_host': 'https://api-js.mixpanel.com',
    'api_routes': $6fb9842575b03497$var$DEFAULT_API_ROUTES,
    'api_extra_query_params': {},
    'api_method': 'POST',
    'api_transport': 'XHR',
    'api_payload_format': $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64,
    'app_host': 'https://mixpanel.com',
    'autocapture': false,
    'cdn': 'https://cdn.mxpnl.com',
    'cross_site_cookie': false,
    'cross_subdomain_cookie': true,
    'error_reporter': $6fb9842575b03497$var$NOOP_FUNC,
    'flags': false,
    'persistence': 'cookie',
    'persistence_name': '',
    'cookie_domain': '',
    'cookie_name': '',
    'loaded': $6fb9842575b03497$var$NOOP_FUNC,
    'mp_loader': null,
    'track_marketing': true,
    'track_pageview': false,
    'skip_first_touch_marketing': false,
    'store_google': true,
    'stop_utm_persistence': false,
    'save_referrer': true,
    'test': false,
    'verbose': false,
    'img': false,
    'debug': false,
    'track_links_timeout': 300,
    'cookie_expiration': 365,
    'upgrade': false,
    'disable_persistence': false,
    'disable_cookie': false,
    'secure_cookie': false,
    'ip': true,
    'opt_out_tracking_by_default': false,
    'opt_out_persistence_by_default': false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix': null,
    'property_blacklist': [],
    'xhr_headers': {},
    'ignore_dnt': false,
    'batch_requests': true,
    'batch_size': 50,
    'batch_flush_interval_ms': 5000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true,
    'hooks': {},
    'record_block_class': new RegExp('^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$'),
    'record_block_selector': 'img, video',
    'record_canvas': false,
    'record_collect_fonts': false,
    'record_heatmap_data': false,
    'record_idle_timeout_ms': 1800000,
    'record_mask_text_class': new RegExp('^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$'),
    'record_mask_text_selector': '*',
    'record_max_ms': $6fb9842575b03497$var$MAX_RECORDING_MS,
    'record_min_ms': 0,
    'record_sessions_percent': 0,
    'recorder_src': 'https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js'
};
var $6fb9842575b03497$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $6fb9842575b03497$var$create_mplib = function(token, config, name) {
    var instance, target = name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME ? $6fb9842575b03497$var$mixpanel_master : $6fb9842575b03497$var$mixpanel_master[name];
    if (target && $6fb9842575b03497$var$init_type === $6fb9842575b03497$var$INIT_MODULE) instance = target;
    else {
        if (target && !$6fb9842575b03497$var$_.isArray(target)) {
            $6fb9842575b03497$var$console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new $6fb9842575b03497$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance['people'] = new $6fb9842575b03497$var$MixpanelPeople();
    instance['people']._init(instance);
    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $6fb9842575b03497$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $6fb9842575b03497$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance['people'].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $6fb9842575b03497$var$Config.DEBUG = $6fb9842575b03497$var$Config.DEBUG || instance.get_config('debug');
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$6fb9842575b03497$var$_.isUndefined(target) && $6fb9842575b03497$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $6fb9842575b03497$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($6fb9842575b03497$var$_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }
    var instance = $6fb9842575b03497$var$create_mplib(token, config, name);
    $6fb9842575b03497$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$6fb9842575b03497$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this['__loaded'] = true;
    this['config'] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || $6fb9842575b03497$var$DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) variable_features['api_payload_format'] = $6fb9842575b03497$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': (name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME ? name : $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));
    this['_jsc'] = $6fb9842575b03497$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!$6fb9842575b03497$var$_.localStorage.is_supported(true) || !$6fb9842575b03497$var$USE_XHR) {
            this._batch_requests = false;
            $6fb9842575b03497$var$console$1.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
            $6fb9842575b03497$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $6fb9842575b03497$var$console$1.log('Clearing batch queue ' + batcher_config.queue_key);
                $6fb9842575b03497$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($6fb9842575b03497$var$sendBeacon && $6fb9842575b03497$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $6fb9842575b03497$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $6fb9842575b03497$var$win.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) flush_on_unload();
                });
                $6fb9842575b03497$var$win.addEventListener('visibilitychange', function() {
                    if ($6fb9842575b03497$var$document$1['visibilityState'] === 'hidden') flush_on_unload();
                });
            }
        }
    }
    this['persistence'] = this['cookie'] = new $6fb9842575b03497$var$MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $6fb9842575b03497$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        'distinct_id': $6fb9842575b03497$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    this.flags = new $6fb9842575b03497$var$FeatureFlagManager({
        getConfigFunc: $6fb9842575b03497$var$_.bind(this.get_config, this),
        getDistinctIdFunc: $6fb9842575b03497$var$_.bind(this.get_distinct_id, this),
        trackingFunc: $6fb9842575b03497$var$_.bind(this.track, this)
    });
    this.flags.init();
    this['flags'] = this.flags;
    this.autocapture = new $6fb9842575b03497$var$Autocapture(this);
    this.autocapture.init();
    this._init_tab_id();
    this._check_and_start_session_recording();
};
/**
 * Assigns a unique UUID to this tab / window by leveraging sessionStorage.
 * This is primarily used for session recording, where data must be isolated to the current tab.
 */ $6fb9842575b03497$var$MixpanelLib.prototype._init_tab_id = function() {
    if ($6fb9842575b03497$var$_.sessionStorage.is_supported()) try {
        var key_suffix = this.get_config('name') + '_' + this.get_config('token');
        var tab_id_key = 'mp_tab_id_' + key_suffix;
        // A flag is used to determine if sessionStorage is copied over and we need to generate a new tab ID.
        // This enforces a unique ID in the cases like duplicated tab, window.open(...)
        var should_generate_new_tab_id_key = 'mp_gen_new_tab_id_' + key_suffix;
        if ($6fb9842575b03497$var$_.sessionStorage.get(should_generate_new_tab_id_key) || !$6fb9842575b03497$var$_.sessionStorage.get(tab_id_key)) $6fb9842575b03497$var$_.sessionStorage.set(tab_id_key, '$tab-' + $6fb9842575b03497$var$_.UUID());
        $6fb9842575b03497$var$_.sessionStorage.set(should_generate_new_tab_id_key, '1');
        this.tab_id = $6fb9842575b03497$var$_.sessionStorage.get(tab_id_key);
        // Remove the flag when the tab is unloaded to indicate the stored tab ID can be reused. This event is not reliable to detect all page unloads,
        // but reliable in cases where the user remains in the tab e.g. a refresh or href navigation.
        // If the flag is absent, this indicates to the next SDK instance that we can reuse the stored tab_id.
        $6fb9842575b03497$var$win.addEventListener('beforeunload', function() {
            $6fb9842575b03497$var$_.sessionStorage.remove(should_generate_new_tab_id_key);
        });
    } catch (err) {
        this.report_error('Error initializing tab id', err);
    }
    else this.report_error('Session storage is not supported, cannot keep track of unique tab ID.');
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_tab_id = function() {
    return this.tab_id || null;
};
$6fb9842575b03497$var$MixpanelLib.prototype._should_load_recorder = function() {
    var recording_registry_idb = new $6fb9842575b03497$var$IDBStorageWrapper($6fb9842575b03497$var$RECORDING_REGISTRY_STORE_NAME);
    var tab_id = this.get_tab_id();
    return recording_registry_idb.init().then(function() {
        return recording_registry_idb.getAll();
    }).then(function(recordings) {
        for(var i = 0; i < recordings.length; i++){
            // if there are expired recordings in the registry, we should load the recorder to flush them
            // if there's a recording for this tab id, we should load the recorder to continue the recording
            if ($6fb9842575b03497$var$isRecordingExpired(recordings[i]) || recordings[i]['tabId'] === tab_id) return true;
        }
        return false;
    }).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.report_error('Error checking recording registry', err);
    }, this));
};
$6fb9842575b03497$var$MixpanelLib.prototype._check_and_start_session_recording = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(force_start) {
    if (!$6fb9842575b03497$var$win['MutationObserver']) {
        $6fb9842575b03497$var$console$1.critical('Browser does not support MutationObserver; skipping session recording');
        return;
    }
    var loadRecorder = $6fb9842575b03497$var$_.bind(function(startNewIfInactive) {
        var handleLoadedRecorder = $6fb9842575b03497$var$_.bind(function() {
            this._recorder = this._recorder || new $6fb9842575b03497$var$win['__mp_recorder'](this);
            this._recorder['resumeRecording'](startNewIfInactive);
        }, this);
        if ($6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$win['__mp_recorder'])) $6fb9842575b03497$var$load_extra_bundle(this.get_config('recorder_src'), handleLoadedRecorder);
        else handleLoadedRecorder();
    }, this);
    /**
     * If the user is sampled or start_session_recording is called, we always load the recorder since it's guaranteed a recording should start.
     * Otherwise, if the recording registry has any records then it's likely there's a recording in progress or orphaned data that needs to be flushed.
     */ var is_sampled = this.get_config('record_sessions_percent') > 0 && Math.random() * 100 <= this.get_config('record_sessions_percent');
    if (force_start || is_sampled) loadRecorder(true);
    else this._should_load_recorder().then(function(shouldLoad) {
        if (shouldLoad) loadRecorder(false);
    });
});
$6fb9842575b03497$var$MixpanelLib.prototype.start_session_recording = function() {
    this._check_and_start_session_recording(true);
};
$6fb9842575b03497$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) this._recorder['stopRecording']();
};
$6fb9842575b03497$var$MixpanelLib.prototype.pause_session_recording = function() {
    if (this._recorder) this._recorder['pauseRecording']();
};
$6fb9842575b03497$var$MixpanelLib.prototype.resume_session_recording = function() {
    if (this._recorder) this._recorder['resumeRecording']();
};
$6fb9842575b03497$var$MixpanelLib.prototype.is_recording_heatmap_data = function() {
    return this._get_session_replay_id() && this.get_config('record_heatmap_data');
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    var replay_id = this._get_session_replay_id();
    if (replay_id) props['$mp_replay_id'] = replay_id;
    return props;
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_session_replay_url = function() {
    var replay_url = null;
    var replay_id = this._get_session_replay_id();
    if (replay_id) {
        var query_params = $6fb9842575b03497$var$_.HTTPBuildQuery({
            'replay_id': replay_id,
            'distinct_id': this.get_distinct_id(),
            'token': this.get_config('token')
        });
        replay_url = 'https://mixpanel.com/projects/replay-redirect?' + query_params;
    }
    return replay_url;
};
$6fb9842575b03497$var$MixpanelLib.prototype._get_session_replay_id = function() {
    var replay_id = null;
    if (this._recorder) replay_id = this._recorder['replayId'];
    return replay_id || null;
};
// "private" public method to reach into the recorder in test cases
$6fb9842575b03497$var$MixpanelLib.prototype.__get_recorder = function() {
    return this._recorder;
};
// Private methods
$6fb9842575b03497$var$MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
    this['people'].set_once(this['persistence'].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config('store_google') && this.get_config('stop_utm_persistence')) {
        var utm_params = $6fb9842575b03497$var$_.info.campaignParams(null);
        $6fb9842575b03497$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$6fb9842575b03497$var$MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword($6fb9842575b03497$var$document$1.referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config('store_google') && !this.get_config('stop_utm_persistence')) this.register($6fb9842575b03497$var$_.info.campaignParams());
    if (this.get_config('save_referrer')) this['persistence'].update_referrer_info($6fb9842575b03497$var$document$1.referrer);
};
$6fb9842575b03497$var$MixpanelLib.prototype._dom_loaded = function() {
    $6fb9842575b03497$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $6fb9842575b03497$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$6fb9842575b03497$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }
    if (!$6fb9842575b03497$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $6fb9842575b03497$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($6fb9842575b03497$var$_.isUndefined(callback)) return null;
    if ($6fb9842575b03497$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$6fb9842575b03497$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($6fb9842575b03497$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;
    if (!callback && ($6fb9842575b03497$var$_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = $6fb9842575b03497$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$6fb9842575b03497$var$USE_XHR) options.method = 'GET';
    var use_post = options.method === 'POST';
    var use_sendBeacon = $6fb9842575b03497$var$sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) verbose_mode = true;
    if (this.get_config('test')) data['test'] = 1;
    if (verbose_mode) data['verbose'] = 1;
    if (this.get_config('img')) data['img'] = 1;
    if (!$6fb9842575b03497$var$USE_XHR) {
        if (callback) data['callback'] = callback;
        else if (verbose_mode || this.get_config('test')) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
    }
    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }
    $6fb9842575b03497$var$_.extend(data, this.get_config('api_extra_query_params'));
    url += '?' + $6fb9842575b03497$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ('img' in data) {
        var img = $6fb9842575b03497$var$document$1.createElement('img');
        img.src = url;
        $6fb9842575b03497$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $6fb9842575b03497$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($6fb9842575b03497$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config('xhr_headers');
        if (use_post) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        $6fb9842575b03497$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== 'undefined') {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $6fb9842575b03497$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = 'timeout';
                    else error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req['responseHeaders'] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req['status'],
                                error: error,
                                retryAfter: response_headers['Retry-After']
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $6fb9842575b03497$var$document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $6fb9842575b03497$var$document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $6fb9842575b03497$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $6fb9842575b03497$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($6fb9842575b03497$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === 'function') item.call(this);
            else if ($6fb9842575b03497$var$_.isArray(item) && fn_name === 'alias') alias_calls.push(item);
            else if ($6fb9842575b03497$var$_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $6fb9842575b03497$var$_.each(calls, function(item) {
            if ($6fb9842575b03497$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $6fb9842575b03497$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$6fb9842575b03497$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = '__mpq_' + this.get_config('token');
    var api_routes = this.get_config('api_routes');
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: 'events',
            endpoint: '/' + api_routes['track'],
            queue_key: queue_prefix + '_ev'
        },
        people: {
            type: 'people',
            endpoint: '/' + api_routes['engage'],
            queue_key: queue_prefix + '_pp'
        },
        groups: {
            type: 'groups',
            endpoint: '/' + api_routes['groups'],
            queue_key: queue_prefix + '_gr'
        }
    };
    return this._batcher_configs;
};
$6fb9842575b03497$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $6fb9842575b03497$var$_.bind(function(attrs) {
            return new $6fb9842575b03497$var$RequestBatcher(attrs.queue_key, {
                libConfig: this['config'],
                errorReporter: this.get_config('error_reporter'),
                sendRequestFunc: $6fb9842575b03497$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config('api_host') + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $6fb9842575b03497$var$_.bind(function(item) {
                    return this._run_hook('before_send_' + attrs.type, item);
                }, this),
                stopAllBatchingFunc: $6fb9842575b03497$var$_.bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config('batch_autostart')) this.start_batch_senders();
};
$6fb9842575b03497$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$6fb9842575b03497$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $6fb9842575b03497$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $6fb9842575b03497$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === 'undefined') this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$6fb9842575b03497$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $6fb9842575b03497$var$JSONStringify(data);
    if (this.get_config('api_payload_format') === $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64) encoded_data = $6fb9842575b03497$var$_.base64Encode(encoded_data);
    return {
        'data': encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$6fb9842575b03497$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $6fb9842575b03497$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $6fb9842575b03497$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $6fb9842575b03497$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        if (truncated_data) {
            $6fb9842575b03497$var$console$1.log('MIXPANEL REQUEST:');
            $6fb9842575b03497$var$console$1.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data).then(function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') callback = $6fb9842575b03497$var$NOOP_FUNC;
    if ($6fb9842575b03497$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $6fb9842575b03497$var$_.extend({}, properties);
    properties['token'] = this.get_config('token');
    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!$6fb9842575b03497$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config('track_marketing') ? $6fb9842575b03497$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$_.info.properties({
        'mp_loader': this.get_config('mp_loader')
    }), marketing_properties, this['persistence'].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config('property_blacklist');
    if ($6fb9842575b03497$var$_.isArray(property_blacklist)) $6fb9842575b03497$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/' + this.get_config('api_routes')['track'],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $6fb9842575b03497$var$MixpanelLib.prototype.set_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$6fb9842575b03497$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.add_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this['people'].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.remove_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this['people'].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_with_groups = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $6fb9842575b03497$var$_.extend({}, properties || {});
    $6fb9842575b03497$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$6fb9842575b03497$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};
$6fb9842575b03497$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $6fb9842575b03497$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_pageview = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== 'object') properties = {};
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';
    var default_page_properties = $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.info.mpPageViewProperties(), $6fb9842575b03497$var$_.info.campaignParams(), $6fb9842575b03497$var$_.info.clickParams());
    var event_properties = $6fb9842575b03497$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $6fb9842575b03497$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $6fb9842575b03497$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($6fb9842575b03497$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this['persistence'].set_event_timer(event_name, new Date().getTime());
};
var $6fb9842575b03497$var$REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $6fb9842575b03497$var$options_for_register = function(days_or_options) {
    var options;
    if ($6fb9842575b03497$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$6fb9842575b03497$var$_.isUndefined(days_or_options)) options = {
        'days': days_or_options
    };
    else options = {};
    return $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $6fb9842575b03497$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register(props, options['days']);
    else $6fb9842575b03497$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $6fb9842575b03497$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register_once(props, default_value, options['days']);
    else {
        if (typeof default_value === 'undefined') default_value = 'None';
        $6fb9842575b03497$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $6fb9842575b03497$var$options_for_register(options);
    if (options['persistent']) this['persistence'].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$6fb9842575b03497$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf($6fb9842575b03497$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({
            '$user_id': new_distinct_id
        });
    }
    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($6fb9842575b03497$var$ALIAS_ID_KEY)) {
        this.unregister($6fb9842575b03497$var$ALIAS_ID_KEY);
        this.register({
            'distinct_id': new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track('$identify', {
        'distinct_id': new_distinct_id,
        '$anon_distinct_id': previous_distinct_id
    }, {
        skip_hooks: true
    });
    // check feature flags again if distinct id has changed
    if (new_distinct_id !== previous_distinct_id) this.flags.fetchFlags();
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = $6fb9842575b03497$var$_.UUID();
    this.register_once({
        'distinct_id': $6fb9842575b03497$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    this.stop_session_recording();
    this._check_and_start_session_recording();
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }
    var _this = this;
    if ($6fb9842575b03497$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($6fb9842575b03497$var$ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $6fb9842575b03497$var$MixpanelLib.prototype.set_config = function(config) {
    if ($6fb9842575b03497$var$_.isObject(config)) {
        $6fb9842575b03497$var$_.extend(this['config'], config);
        var new_batch_size = config['batch_size'];
        if (new_batch_size) $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config('persistence_name')) this['config']['persistence_name'] = this['config']['cookie_name'];
        if (!this.get_config('disable_persistence')) this['config']['disable_persistence'] = this['config']['disable_cookie'];
        if (this['persistence']) this['persistence'].update_config(this['config']);
        $6fb9842575b03497$var$Config.DEBUG = $6fb9842575b03497$var$Config.DEBUG || this.get_config('debug');
        if (('autocapture' in config || 'record_heatmap_data' in config) && this.autocapture) this.autocapture.init();
    }
};
/**
 * returns the current config object for the library.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $6fb9842575b03497$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || $6fb9842575b03497$var$IDENTITY_FUNC).apply(this, $6fb9842575b03497$var$slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence'].load_prop([
        property_name
    ]);
};
$6fb9842575b03497$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) name = $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME + '.' + name;
    return name;
};
$6fb9842575b03497$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $6fb9842575b03497$var$_.isBlockedUA($6fb9842575b03497$var$userAgent) || this._flags.disable_all_events || $6fb9842575b03497$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$6fb9842575b03497$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $6fb9842575b03497$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            'persistence_type': 'cookie'
        })) this.opt_in_tracking({
            'enable_persistence': false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            'persistence_type': 'cookie'
        })) this.opt_out_tracking({
            'clear_persistence': false
        });
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        'clear_persistence': true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config('opt_out_tracking_by_default') || $6fb9842575b03497$var$_.cookie.get('mp_optout'))) {
        $6fb9842575b03497$var$_.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $6fb9842575b03497$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) disabled = true;
    else if (options && options['enable_persistence']) disabled = false;
    else return;
    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) this['persistence'].set_disabled(disabled);
    if (disabled) {
        this.stop_batch_senders();
        this.stop_session_recording();
    } else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$6fb9842575b03497$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $6fb9842575b03497$var$_.extend({
        'track': $6fb9842575b03497$var$_.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$6fb9842575b03497$var$_.localStorage.is_supported()) options['persistence_type'] = 'cookie';
    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($6fb9842575b03497$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }
    this._gdpr_call_func($6fb9842575b03497$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($6fb9842575b03497$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($6fb9842575b03497$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($6fb9842575b03497$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$6fb9842575b03497$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $6fb9842575b03497$var$console$1.error.apply($6fb9842575b03497$var$console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$console$1.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$6fb9842575b03497$var$MixpanelLib.prototype['init'] = $6fb9842575b03497$var$MixpanelLib.prototype.init;
$6fb9842575b03497$var$MixpanelLib.prototype['reset'] = $6fb9842575b03497$var$MixpanelLib.prototype.reset;
$6fb9842575b03497$var$MixpanelLib.prototype['disable'] = $6fb9842575b03497$var$MixpanelLib.prototype.disable;
$6fb9842575b03497$var$MixpanelLib.prototype['time_event'] = $6fb9842575b03497$var$MixpanelLib.prototype.time_event;
$6fb9842575b03497$var$MixpanelLib.prototype['track'] = $6fb9842575b03497$var$MixpanelLib.prototype.track;
$6fb9842575b03497$var$MixpanelLib.prototype['track_links'] = $6fb9842575b03497$var$MixpanelLib.prototype.track_links;
$6fb9842575b03497$var$MixpanelLib.prototype['track_forms'] = $6fb9842575b03497$var$MixpanelLib.prototype.track_forms;
$6fb9842575b03497$var$MixpanelLib.prototype['track_pageview'] = $6fb9842575b03497$var$MixpanelLib.prototype.track_pageview;
$6fb9842575b03497$var$MixpanelLib.prototype['register'] = $6fb9842575b03497$var$MixpanelLib.prototype.register;
$6fb9842575b03497$var$MixpanelLib.prototype['register_once'] = $6fb9842575b03497$var$MixpanelLib.prototype.register_once;
$6fb9842575b03497$var$MixpanelLib.prototype['unregister'] = $6fb9842575b03497$var$MixpanelLib.prototype.unregister;
$6fb9842575b03497$var$MixpanelLib.prototype['identify'] = $6fb9842575b03497$var$MixpanelLib.prototype.identify;
$6fb9842575b03497$var$MixpanelLib.prototype['alias'] = $6fb9842575b03497$var$MixpanelLib.prototype.alias;
$6fb9842575b03497$var$MixpanelLib.prototype['name_tag'] = $6fb9842575b03497$var$MixpanelLib.prototype.name_tag;
$6fb9842575b03497$var$MixpanelLib.prototype['set_config'] = $6fb9842575b03497$var$MixpanelLib.prototype.set_config;
$6fb9842575b03497$var$MixpanelLib.prototype['get_config'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_config;
$6fb9842575b03497$var$MixpanelLib.prototype['get_property'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_property;
$6fb9842575b03497$var$MixpanelLib.prototype['get_distinct_id'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_distinct_id;
$6fb9842575b03497$var$MixpanelLib.prototype['toString'] = $6fb9842575b03497$var$MixpanelLib.prototype.toString;
$6fb9842575b03497$var$MixpanelLib.prototype['opt_out_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.opt_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['opt_in_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.opt_in_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['has_opted_out_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['has_opted_in_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_in_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['clear_opt_in_out_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['get_group'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_group;
$6fb9842575b03497$var$MixpanelLib.prototype['set_group'] = $6fb9842575b03497$var$MixpanelLib.prototype.set_group;
$6fb9842575b03497$var$MixpanelLib.prototype['add_group'] = $6fb9842575b03497$var$MixpanelLib.prototype.add_group;
$6fb9842575b03497$var$MixpanelLib.prototype['remove_group'] = $6fb9842575b03497$var$MixpanelLib.prototype.remove_group;
$6fb9842575b03497$var$MixpanelLib.prototype['track_with_groups'] = $6fb9842575b03497$var$MixpanelLib.prototype.track_with_groups;
$6fb9842575b03497$var$MixpanelLib.prototype['start_batch_senders'] = $6fb9842575b03497$var$MixpanelLib.prototype.start_batch_senders;
$6fb9842575b03497$var$MixpanelLib.prototype['stop_batch_senders'] = $6fb9842575b03497$var$MixpanelLib.prototype.stop_batch_senders;
$6fb9842575b03497$var$MixpanelLib.prototype['start_session_recording'] = $6fb9842575b03497$var$MixpanelLib.prototype.start_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype['stop_session_recording'] = $6fb9842575b03497$var$MixpanelLib.prototype.stop_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype['pause_session_recording'] = $6fb9842575b03497$var$MixpanelLib.prototype.pause_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype['resume_session_recording'] = $6fb9842575b03497$var$MixpanelLib.prototype.resume_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype['get_session_recording_properties'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_session_recording_properties;
$6fb9842575b03497$var$MixpanelLib.prototype['get_session_replay_url'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_session_replay_url;
$6fb9842575b03497$var$MixpanelLib.prototype['get_tab_id'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_tab_id;
$6fb9842575b03497$var$MixpanelLib.prototype['DEFAULT_API_ROUTES'] = $6fb9842575b03497$var$DEFAULT_API_ROUTES;
// Exports intended only for testing
$6fb9842575b03497$var$MixpanelLib.prototype['__get_recorder'] = $6fb9842575b03497$var$MixpanelLib.prototype.__get_recorder;
// MixpanelPersistence Exports
$6fb9842575b03497$var$MixpanelPersistence.prototype['properties'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.properties;
$6fb9842575b03497$var$MixpanelPersistence.prototype['update_search_keyword'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.update_search_keyword;
$6fb9842575b03497$var$MixpanelPersistence.prototype['update_referrer_info'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.update_referrer_info;
$6fb9842575b03497$var$MixpanelPersistence.prototype['get_cross_subdomain'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.get_cross_subdomain;
$6fb9842575b03497$var$MixpanelPersistence.prototype['clear'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.clear;
var $6fb9842575b03497$var$instances = {};
var $6fb9842575b03497$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $6fb9842575b03497$var$_.each($6fb9842575b03497$var$instances, function(instance, name) {
        if (name !== $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) $6fb9842575b03497$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $6fb9842575b03497$var$mixpanel_master['_'] = $6fb9842575b03497$var$_;
};
var $6fb9842575b03497$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $6fb9842575b03497$var$mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$6fb9842575b03497$var$mixpanel_master[name]) {
                $6fb9842575b03497$var$mixpanel_master[name] = $6fb9842575b03497$var$instances[name] = $6fb9842575b03497$var$create_mplib(token, config, name);
                $6fb9842575b03497$var$mixpanel_master[name]._loaded();
            }
            return $6fb9842575b03497$var$mixpanel_master[name];
        } else {
            var instance = $6fb9842575b03497$var$mixpanel_master;
            if ($6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $6fb9842575b03497$var$create_mplib(token, config, $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $6fb9842575b03497$var$mixpanel_master = instance;
            if ($6fb9842575b03497$var$init_type === $6fb9842575b03497$var$INIT_SNIPPET) $6fb9842575b03497$var$win[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME] = $6fb9842575b03497$var$mixpanel_master;
            $6fb9842575b03497$var$extend_mp();
        }
    };
};
var $6fb9842575b03497$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $6fb9842575b03497$var$DOM_LOADED = true;
        $6fb9842575b03497$var$ENQUEUE_REQUESTS = false;
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $6fb9842575b03497$var$document$1.documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($6fb9842575b03497$var$document$1.addEventListener) {
        if ($6fb9842575b03497$var$document$1.readyState === 'complete') // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $6fb9842575b03497$var$document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
    } else if ($6fb9842575b03497$var$document$1.attachEvent) {
        // IE
        $6fb9842575b03497$var$document$1.attachEvent('onreadystatechange', dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $6fb9842575b03497$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($6fb9842575b03497$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $6fb9842575b03497$var$_.register_event($6fb9842575b03497$var$win, 'load', dom_loaded_handler, true);
};
function $6fb9842575b03497$var$init_as_module(bundle_loader) {
    $6fb9842575b03497$var$load_extra_bundle = bundle_loader;
    $6fb9842575b03497$var$init_type = $6fb9842575b03497$var$INIT_MODULE;
    $6fb9842575b03497$var$mixpanel_master = new $6fb9842575b03497$var$MixpanelLib();
    $6fb9842575b03497$var$override_mp_init_func();
    $6fb9842575b03497$var$mixpanel_master['init']();
    $6fb9842575b03497$var$add_dom_loaded_handler();
    return $6fb9842575b03497$var$mixpanel_master;
}
// For loading separate bundles asynchronously via script tag
// so that we don't load them until they are needed at runtime.
// For builds that have everything in one bundle, no extra work.
function $6fb9842575b03497$var$loadNoop(_src, onload) {
    onload();
}
/* eslint camelcase: "off" */ var $6fb9842575b03497$export$2e2bcd8739ae039 = $6fb9842575b03497$var$init_as_module($6fb9842575b03497$var$loadNoop);


// Near entry of your product, init Mixpanel
(0, $6fb9842575b03497$export$2e2bcd8739ae039).init("d61c65daaf1004001601eb7615f614ac", {
    debug: true,
    persistence: "localStorage"
});


const $cbd5e2ca5ac31863$var$AddressForm = ()=>{
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("form-page-viewed", {
        "form-name": "address"
    });
    const options = (0, (/*@__PURE__*/$parcel$interopDefault($8159aa64a7960b5d$exports))).options;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            const newState = {
                ...state,
                ...values
            };
            // Form submission logic here
            console.log(newState);
            navigate("/hahs/payment", {
                state: newState
            });
        },
        validate: (values)=>{
            const errors = {};
            const addressError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.address);
            errors.address = addressError;
            const cityError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.city);
            errors.city = cityError;
            const stateError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.state);
            errors.state = stateError;
            const zipError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.zip);
            errors.zip = zipError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid, form: form })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Home Address"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "Your address is used to connect you with clinicians who are licensed in your state. Your personal information is never sold or shared."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "address",
                                        title: "Address",
                                        placeholder: "Address *",
                                        autoComplete: "street-address",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "addressLine2",
                                        title: "Address Line 2",
                                        placeholder: "Address Line 2",
                                        autoComplete: "address-line2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "city",
                                        title: "City",
                                        placeholder: "City",
                                        autoComplete: "address-level2",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                        name: "state",
                                        placeholder: "State",
                                        options: options,
                                        className: "react-select-container min-w-40 max-w-64 form-input focus:border-mustard text-caringwire rounded-md bg-transparent text-2xl font-thin transition-colors duration-200 ease-in-out focus:outline-none",
                                        required: true,
                                        onChange: (option)=>{
                                            form.change("state", option.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "zip",
                                        title: "Zip",
                                        placeholder: "Zip",
                                        autoComplete: "postal-code",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    // print all the values
                                                    console.log(state);
                                                    navigate("/hahs/dob", {
                                                        state: {
                                                            ...state,
                                                            country: "United States"
                                                        }
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $cbd5e2ca5ac31863$export$2e2bcd8739ae039 = $cbd5e2ca5ac31863$var$AddressForm;





parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $59TQn = parcelRequire("59TQn");
function $41bb2bdb656054d2$export$842dcfa371c6bb83(val, countryCode, addSuffix, allowExtension, isAllowedKey) {
    try {
        var clean = val.replace(/\D/g, ""), // NOTE: we use AsYouTypeFormatter because the default format function can't handle incomplete numbers e.g. "+17024" formats to "+1 7024" as opposed to "+1 702-4"
        formatter = new (0, $59TQn.AsYouTypeFormatter)(countryCode), // if clean is empty, we still need this to be a string otherwise we get errors later
        result = "", next, extSuffix = " ext. ";
        if (val.substr(0, 1) == "+") clean = "+" + clean;
        for(var i = 0; i < clean.length; i++){
            // TODO: improve this so don't just pump in every digit every time - we should just cache this formatter object, and just call inputDigit once each time the user enters a new digit
            next = formatter.inputDigit(clean.charAt(i));
            // if adding this char didn't change the length, or made it smaller (and there's no longer any spaces): that means that formatting failed which means the number was no longer a potentially valid number, so if we're allowing extensions: assume the rest is the ext
            if (allowExtension && result && next.length <= result.length && next.indexOf(" ") == -1) {
                // set flag for extension
                next = -1;
                break;
            }
            result = next;
        }
        // for some reason libphonenumber formats "+44" to "+44 ", but doesn't do the same with "+1"
        if (result.charAt(result.length - 1) == " ") result = result.substr(0, result.length - 1);
        // check if there's a suffix to add (unless there's an ext)
        if (addSuffix && !val.split(extSuffix)[1]) {
            // hack to get formatting suffix
            var test = formatter.inputDigit("5");
            // again the "+44 " problem... (also affects "+45" apparently)
            if (test.charAt(test.length - 1) == " ") test = test.substr(0, test.length - 1);
            // if adding a '5' introduces a formatting char - check if the penultimate char is not-a-number
            var penultimate = test.substr(test.length - 2, 1);
            // Note: never use isNaN without parseFloat
            if (isNaN(parseFloat(penultimate))) // return the new value (minus that last '5' we just added)
            return test.substr(0, test.length - 1);
            else if (allowExtension && result && test.length <= result.length && test.indexOf(" ") == -1 && !isAllowedKey) // else if the next digit would break the formating, and we're allowing extensions, AND this is not an allowed key: add the suffix
            // NOTE: we must check this is not an allowed key because if it was that means it was the last digit in a valid number and we dont want to add the "ext" suffix in that case. This whole condition is just here to catch the case that: after typing a valid number, they try to type "ext" - this will not automatically add it for them.
            return result + extSuffix;
        }
        // if the clean number contains an extension we need to add it
        if (next == -1) result += extSuffix + clean.substring(i, clean.length);
        return result;
    } catch (e) {
        return val;
    }
}


// Define a list of options for the dropdown
const $036040cd3bc5e884$var$countryOptions = [
    {
        label: "United States",
        code: "1",
        value: "US",
        flag: "\uD83C\uDDFA\uD83C\uDDF8"
    },
    {
        label: "Australia",
        code: "61",
        value: "AU",
        flag: "\uD83C\uDDE6\uD83C\uDDFA"
    },
    {
        label: "Brazil",
        code: "55",
        value: "BR",
        flag: "\uD83C\uDDE7\uD83C\uDDF7"
    },
    {
        label: "Canada",
        code: "1",
        value: "CA",
        flag: "\uD83C\uDDE8\uD83C\uDDE6"
    },
    {
        label: "China",
        code: "86",
        value: "CN",
        flag: "\uD83C\uDDE8\uD83C\uDDF3"
    },
    {
        label: "France",
        code: "33",
        value: "FR",
        flag: "\uD83C\uDDEB\uD83C\uDDF7"
    },
    {
        label: "Germany",
        code: "49",
        value: "DE",
        flag: "\uD83C\uDDE9\uD83C\uDDEA"
    },
    {
        label: "India",
        code: "91",
        value: "IN",
        flag: "\uD83C\uDDEE\uD83C\uDDF3"
    },
    {
        label: "Italy",
        code: "39",
        value: "IT",
        flag: "\uD83C\uDDEE\uD83C\uDDF9"
    },
    {
        label: "Japan",
        code: "81",
        value: "JP",
        flag: "\uD83C\uDDEF\uD83C\uDDF5"
    },
    {
        label: "Mexico",
        code: "52",
        value: "MX",
        flag: "\uD83C\uDDF2\uD83C\uDDFD"
    },
    {
        label: "New Zealand",
        code: "64",
        value: "NZ",
        flag: "\uD83C\uDDF3\uD83C\uDDFF"
    },
    {
        label: "Russia",
        code: "7",
        value: "RU",
        flag: "\uD83C\uDDF7\uD83C\uDDFA"
    },
    {
        label: "South Africa",
        code: "27",
        value: "ZA",
        flag: "\uD83C\uDDFF\uD83C\uDDE6"
    },
    {
        label: "Spain",
        code: "34",
        value: "ES",
        flag: "\uD83C\uDDEA\uD83C\uDDF8"
    },
    {
        label: "United Kingdom",
        code: "44",
        value: "GB",
        flag: "\uD83C\uDDEC\uD83C\uDDE7"
    }
];
const $036040cd3bc5e884$var$FlagMenuList = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).MenuList, {
        ...props,
        className: "w-72"
    });
const $036040cd3bc5e884$var$FlagMenu = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Menu, {
        ...props,
        className: "w-fit"
    });
const $036040cd3bc5e884$var$PhoneNumberInput = ({ name: name, title: title, required: required })=>{
    const [selectedCountry, setSelectedCountry] = (0, $acw62.useState)($036040cd3bc5e884$var$countryOptions[0]);
    const { change: change } = (0, $a22611c327162735$export$87c0cf8eb5a167e0)();
    const handleCountryChange = (option)=>{
        setSelectedCountry(option);
        change("phoneNumber", "");
    };
    const formatPhoneNumber = (value)=>{
        let cleanValue = value?.replace(/\D/g, "").substring(0, 16);
        if (cleanValue?.length === 0 || !cleanValue) return "+" + selectedCountry.code;
        return `${(0, $41bb2bdb656054d2$export$842dcfa371c6bb83)(value, selectedCountry.value, true, true, false)}`.replace("ext.", "").trim();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a455218a85c89869), {
        name: name,
        validate: (value)=>{
            return (0, $3ef5978a8f0aae1f$export$d6781b696a0576d1)(value || "", selectedCountry.value) ? undefined : "Invalid phone number";
        },
        format: formatPhoneNumber,
        render: ({ input: input, meta: meta })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("focus-within:border-mustard flex flex-row flex-wrap rounded-md border-2 bg-transparent px-4 py-2 text-2xl transition-colors duration-200  ease-in-out ", meta.error && meta.touched ? "border-red-500" : "border-caringwire"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                options: $036040cd3bc5e884$var$countryOptions,
                                value: selectedCountry,
                                onChange: handleCountryChange,
                                formatOptionLabel: (option, { context: context })=>context === "value" ? option.flag : `${option.flag} ${option.label}`,
                                components: {
                                    MenuList: $036040cd3bc5e884$var$FlagMenuList,
                                    Menu: $036040cd3bc5e884$var$FlagMenu
                                },
                                placeholder: "Select a country",
                                className: "mr-4 flex-none rounded-none bg-transparent text-lg transition-colors duration-200 ease-in-out focus:border-blue-500 focus:outline-none"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                ...input,
                                type: "tel",
                                autoComplete: "tel",
                                placeholder: "+1(123)456-7890",
                                className: "w-52 flex-auto border-0 outline-none font-light text-caringwire"
                            })
                        ]
                    }),
                    meta.error && meta.touched && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 w-fit rounded-md border border-red-500 bg-red-100 p-2 text-sm text-red-800",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                role: "img",
                                "aria-label": "alert",
                                className: "mr-2",
                                children: "\u26A0\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: meta.error
                            })
                        ]
                    })
                ]
            })
    });
};
var $036040cd3bc5e884$export$2e2bcd8739ae039 = $036040cd3bc5e884$var$PhoneNumberInput;






const $1a00bb0b32f3727d$var$InfoForm = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const params = new URLSearchParams(searchParams);
    const orgId = params.get("org_id");
    const priceId = params.get("stripe_price_id");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            // only keep the digits and remove whitespace
            const phoneNumber = `+${values.phoneNumber.replace(/\D/g, "")}`;
            const params = {
                ...values,
                phoneNumber: phoneNumber,
                orgId: orgId,
                priceId: priceId
            };
            // Form submission logic here
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("form-page-viewed", {
                "form-name": "info"
            });
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("form-started", params);
            console.log(params);
            navigate("/hahs/dob", {
                state: params
            });
        },
        validate: (values)=>{
            const errors = {};
            const firstNameError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.firstName);
            errors.firstName = firstNameError;
            const lastNameError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.lastName);
            errors.lastName = lastNameError;
            const phoneNumberError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.phoneNumber);
            errors.phoneNumber = phoneNumberError;
            const emailError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.email) || (0, $3ef5978a8f0aae1f$export$d290fa47940df19d)(values.email);
            errors.email = emailError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10 pb-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Register for HAHS"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue text-center text-xl font-light",
                                    children: "The following information is used to setup your HAHS account and provide access."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        title: "First Name",
                                        placeholder: "First Name *",
                                        type: "text",
                                        autoComplete: "given-name",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        title: "Last Name",
                                        placeholder: "Last Name *",
                                        type: "text",
                                        autoComplete: "family-name",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $036040cd3bc5e884$export$2e2bcd8739ae039), {
                                        name: "phoneNumber",
                                        title: "Phone number",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "email",
                                        title: "Email",
                                        placeholder: "Email *",
                                        type: "email",
                                        autoComplete: "email",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $1a00bb0b32f3727d$export$2e2bcd8739ae039 = $1a00bb0b32f3727d$var$InfoForm;





parcelRequire("acw62");





const $81e332e9c2fc3191$var$DateOfBirthForm = ()=>{
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("form-page-viewed", {
        "form-name": "date-of-birth"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            const newState = {
                ...state,
                ...values
            };
            // Form submission logic here
            console.log(newState);
            navigate("/hahs/address", {
                state: newState
            });
        },
        validate: (values)=>{
            const errors = {};
            const monthError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.dateOfBirthMonth);
            errors.dateOfBirthMonth = monthError;
            const dayError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.dateOfBirthDay);
            errors.dateOfBirthDay = dayError;
            const yearError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.dateOfBirthYear);
            errors.dateOfBirthYear = yearError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Date of Birth"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "This is required to establish access to on-demand Telehealth and TeleTherapy. Your personal information is encrypted, secured and protected by HIPPA."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthMonth",
                                        title: "MM",
                                        placeholder: "MM *",
                                        type: "text",
                                        maxLength: 2,
                                        format: (value)=>{
                                            // only allow 01-12
                                            const month = value?.replace(/\D/g, "");
                                            if (month && parseInt(month) > 12) return "12";
                                            else return month;
                                        },
                                        autoComplete: "bday-month",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthDay",
                                        title: "DD",
                                        placeholder: "DD *",
                                        type: "text",
                                        maxLength: 2,
                                        format: (value)=>{
                                            // only allow 01-31
                                            const day = value?.replace(/\D/g, "");
                                            if (day && parseInt(day) > 31) return "31";
                                            else return day;
                                        },
                                        autoComplete: "bday-day",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthYear",
                                        title: "YYYY",
                                        placeholder: "YYYY *",
                                        type: "text",
                                        maxLength: 4,
                                        format: (value)=>value?.replace(/\D/g, ""),
                                        autoComplete: "bday-year",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    navigate("/hahs", {
                                                        state: state
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $81e332e9c2fc3191$export$2e2bcd8739ae039 = $81e332e9c2fc3191$var$DateOfBirthForm;






var $acw62 = parcelRequire("acw62");


var $7bf3b98cbc00db03$exports = {};

(function(global, factory) {
    factory($7bf3b98cbc00db03$exports, (parcelRequire("acw62")));
})($7bf3b98cbc00db03$exports, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "2.8.1"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "2.8.1",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded = [
        "on",
        "session"
    ];
    var CustomCheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutSdkContext.displayName = 'CustomCheckoutSdkContext';
    var parseCustomCheckoutSdkContext = function parseCustomCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CustomCheckoutProvider> provider."));
        return ctx;
    };
    var CustomCheckoutContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutContext.displayName = 'CustomCheckoutContext';
    var extractCustomCheckoutContextValue = function extractCustomCheckoutContextValue(customCheckoutSdk, sessionState) {
        if (!customCheckoutSdk) return null;
        customCheckoutSdk.on;
        customCheckoutSdk.session;
        var actions = _objectWithoutProperties(customCheckoutSdk, _excluded);
        if (!sessionState) return _objectSpread2(_objectSpread2({}, actions), customCheckoutSdk.session());
        return _objectSpread2(_objectSpread2({}, actions), sessionState);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `CustomCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var CustomCheckoutProvider = function CustomCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                customCheckoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, customCheckoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.customCheckoutSdk) return ctx;
                return {
                    stripe: stripe,
                    customCheckoutSdk: customCheckoutSdk
                };
            });
        }; // Ref used to avoid calling initCustomCheckout multiple times when options changes
        var initCustomCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCustomCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCustomCheckoutCalledRef.current = true;
                    stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                        if (customCheckoutSdk) {
                            safeSetContext(stripe, customCheckoutSdk);
                            customCheckoutSdk.on('change', setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === 'sync' && parsed.stripe && !initCustomCheckoutCalledRef.current) {
                initCustomCheckoutCalledRef.current = true;
                parsed.stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                    if (customCheckoutSdk) {
                        safeSetContext(parsed.stripe, customCheckoutSdk);
                        customCheckoutSdk.on('change', setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on CustomCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            if (!ctx.customCheckoutSdk) return;
            if (options.clientSecret && !isUnknownObject(prevOptions) && !isEqual(options.clientSecret, prevOptions.clientSecret)) console.warn('Unsupported prop change: options.client_secret is not a mutable property.');
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            if (currentAppearance && !isEqual(currentAppearance, previousAppearance)) ctx.customCheckoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.customCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var customCheckoutContextValue = React.useMemo(function() {
            return extractCustomCheckoutContextValue(ctx.customCheckoutSdk, session);
        }, [
            ctx.customCheckoutSdk,
            session
        ]);
        if (!ctx.customCheckoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CustomCheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CustomCheckoutContext.Provider, {
            value: customCheckoutContextValue
        }, children));
    };
    CustomCheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            clientSecret: PropTypes.string.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCustomCheckoutSdkContextWithUseCase = function useCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CustomCheckoutSdkContext);
        return parseCustomCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCustomCheckoutSdkContextWithUseCase = function useElementsOrCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var customCheckoutSdkContext = React.useContext(CustomCheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (customCheckoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CustomCheckoutProvider> and <Elements> providers."));
        if (customCheckoutSdkContext) return parseCustomCheckoutSdkContext(customCheckoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCustomCheckout = function useCustomCheckout() {
        // ensure it's in CustomCheckoutProvider
        useCustomCheckoutSdkContextWithUseCase('calls useCustomCheckout()');
        var ctx = React.useContext(CustomCheckoutContext);
        if (!ctx) throw new Error('Could not find CustomCheckout Context; You need to wrap the part of your app that calls useCustomCheckout() in an <CustomCheckoutProvider> provider.');
        return ctx;
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var customCheckoutSdk = 'customCheckoutSdk' in ctx ? ctx.customCheckoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || customCheckoutSdk)) {
                    var newElement = null;
                    if (customCheckoutSdk) newElement = customCheckoutSdk.createElement(type, options);
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                customCheckoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCustomC = useElementsOrCustomCheckoutSdkContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCustomC.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent('fpxBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent('idealBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent('p24Bank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent('epsBank', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var CurrencySelectorElement = createElementComponent('currencySelector', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent('affirmMessage', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent('afterpayClearpayMessage', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CurrencySelectorElement = CurrencySelectorElement;
    exports1.CustomCheckoutProvider = CustomCheckoutProvider;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCustomCheckout = useCustomCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});



var $2110bf72a86f956f$var$V3_URL = 'https://js.stripe.com/v3';
var $2110bf72a86f956f$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $2110bf72a86f956f$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($2110bf72a86f956f$var$V3_URL, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$2110bf72a86f956f$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $2110bf72a86f956f$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($2110bf72a86f956f$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $2110bf72a86f956f$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "3.4.1",
        startTime: startTime
    });
};
var $2110bf72a86f956f$var$stripePromise = null;
var $2110bf72a86f956f$var$onErrorListener = null;
var $2110bf72a86f956f$var$onLoadListener = null;
var $2110bf72a86f956f$var$onError = function onError(reject) {
    return function() {
        reject(new Error('Failed to load Stripe.js'));
    };
};
var $2110bf72a86f956f$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var $2110bf72a86f956f$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($2110bf72a86f956f$var$stripePromise !== null) return $2110bf72a86f956f$var$stripePromise;
    $2110bf72a86f956f$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $2110bf72a86f956f$var$findScript();
            if (script && params) console.warn($2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $2110bf72a86f956f$var$injectScript(params);
            else if (script && $2110bf72a86f956f$var$onLoadListener !== null && $2110bf72a86f956f$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', $2110bf72a86f956f$var$onLoadListener);
                script.removeEventListener('error', $2110bf72a86f956f$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $2110bf72a86f956f$var$injectScript(params);
            }
            $2110bf72a86f956f$var$onLoadListener = $2110bf72a86f956f$var$onLoad(resolve, reject);
            $2110bf72a86f956f$var$onErrorListener = $2110bf72a86f956f$var$onError(reject);
            script.addEventListener('load', $2110bf72a86f956f$var$onLoadListener);
            script.addEventListener('error', $2110bf72a86f956f$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $2110bf72a86f956f$var$stripePromise["catch"](function(error) {
        $2110bf72a86f956f$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $2110bf72a86f956f$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $2110bf72a86f956f$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $2110bf72a86f956f$var$stripePromise$1;
var $2110bf72a86f956f$var$loadCalled = false;
var $2110bf72a86f956f$var$getStripePromise = function getStripePromise() {
    if ($2110bf72a86f956f$var$stripePromise$1) return $2110bf72a86f956f$var$stripePromise$1;
    $2110bf72a86f956f$var$stripePromise$1 = $2110bf72a86f956f$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $2110bf72a86f956f$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
    return $2110bf72a86f956f$var$stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $2110bf72a86f956f$var$getStripePromise();
})["catch"](function(error) {
    if (!$2110bf72a86f956f$var$loadCalled) console.warn(error);
});
var $2110bf72a86f956f$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $2110bf72a86f956f$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $2110bf72a86f956f$var$getStripePromise().then(function(maybeStripe) {
        return $2110bf72a86f956f$var$initStripe(maybeStripe, args, startTime);
    });
};




const $5ca181f363cd7023$var$stripePromise = (0, $2110bf72a86f956f$export$de80f7562c3fd6b1)("pk_test_51OniN4CYoJkhdgxLABsTZOr83Ja31XJu6b4jQInGwnpAyaYVf9odha7Ch22fQgDdsisxrHBsQEH3fuOEg3DJPjND00e4xndxM2");
const $5ca181f363cd7023$var$PaymentForm = ({ stripeElementsOptions: stripeElementsOptions })=>{
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
    const elements = (0, $7bf3b98cbc00db03$exports.useElements)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        onSubmit: async (values)=>{
            // only keep the digits and remove whitespace
            const params = {
                ...state,
                ...values
            };
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("form-page-viewed", {
                "form-name": "payment"
            });
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("form-ended", state);
            await elements.submit();
            try {
                const apiCall = await fetch("https://oczrewh6ee.execute-api.us-east-1.amazonaws.com/hahs-test/stripe/create-subscription", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(params)
                });
                const responseJSON = await apiCall.json();
                const { secret: secret, type: type } = responseJSON;
                const confirmIntent = type === "setup" ? stripe.confirmSetup : stripe.confirmPayment;
                const { error: error } = await confirmIntent({
                    elements: elements,
                    clientSecret: secret,
                    confirmParams: {
                        return_url: `${"https://test.core.forms.caringwire.com"}/hahs/success`
                    }
                });
                if (error) console.error(error.message);
            } catch (e) {
                console.error(e);
            }
        },
        validate: (values)=>{
            const errors = {};
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Payment Information"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "Great! Now all we need are your payment details and we're good to go!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-caringwireDarkBlue mt-4 text-center text-sm",
                            children: [
                                "HAHS Subscription is $",
                                stripeElementsOptions.amount / 100,
                                " after taxes and fees. We never store your card number or CVC number"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8 pt-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.PaymentElement), {
                                        className: "focus-visible:outline-none"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    navigate("/hahs/address", {
                                                        state: state
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $5ca181f363cd7023$export$2e2bcd8739ae039 = ()=>{
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { priceId: priceId } = state;
    const [stripeHahsSubscriptionOptions, setStripeHahsSubscriptionOptions] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            const apiCall = await fetch("https://oczrewh6ee.execute-api.us-east-1.amazonaws.com/hahs-test" + `/stripe/price/${priceId}`, {
                method: "get",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const priceResponse = await apiCall.json();
            if (!priceResponse.unit_amount) throw new Error("Invalid price response");
            const newOptions = {
                mode: "subscription",
                amount: priceResponse.unit_amount,
                currency: "usd",
                appearance: {
                    theme: "stripe",
                    rules: {
                        ".Input": {
                            border: "2px solid #038fca",
                            outline: "none",
                            borderRadius: "0.375rem;"
                        },
                        ".Input:focus": {
                            border: "1px solid #C4C4C4",
                            outline: "none"
                        }
                    }
                }
            };
            setStripeHahsSubscriptionOptions(newOptions);
        })();
    }, [
        priceId
    ]);
    if (!stripeHahsSubscriptionOptions) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center h-screen",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "text-4xl text-center",
            children: "Loading..."
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
        stripe: $5ca181f363cd7023$var$stripePromise,
        options: stripeHahsSubscriptionOptions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ca181f363cd7023$var$PaymentForm, {
            stripeElementsOptions: stripeHahsSubscriptionOptions
        })
    });
};



parcelRequire("acw62");

const $ce0d1bd640cc8431$var$SuccessPage = ()=>{
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("form-page-viewed", {
        "form-name": "success"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "m-8 overflow-clip rounded-3xl bg-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                        children: [
                            "Success",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                        children: "Your information has been successfully submitted. We will contact you shortly!"
                    })
                ]
            })
        })
    });
};
var $ce0d1bd640cc8431$export$2e2bcd8739ae039 = $ce0d1bd640cc8431$var$SuccessPage;






var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");

"use client";
function $b00d3e7401eac195$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$b00d3e7401eac195$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $b00d3e7401eac195$var$L = (t)=>typeof t == "number" && !isNaN(t), $b00d3e7401eac195$var$N = (t)=>typeof t == "string", $b00d3e7401eac195$var$P = (t)=>typeof t == "function", $b00d3e7401eac195$var$mt = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$L(t), $b00d3e7401eac195$var$B = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) ? t : null, $b00d3e7401eac195$var$pt = (t, o)=>t === !1 || $b00d3e7401eac195$var$L(t) && t > 0 ? t : o, $b00d3e7401eac195$var$z = (t)=>(0, $acw62.isValidElement)(t) || $b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) || $b00d3e7401eac195$var$L(t);
function $b00d3e7401eac195$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $b00d3e7401eac195$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $acw62.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $b00d3e7401eac195$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, a);
    };
}
function $b00d3e7401eac195$var$J(t, o) {
    return {
        content: $b00d3e7401eac195$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $b00d3e7401eac195$var$tt(t, o, e = !1) {
    return (0, $acw62.isValidElement)(t) && !$b00d3e7401eac195$var$N(t.type) ? (0, $acw62.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $b00d3e7401eac195$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $b00d3e7401eac195$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $b00d3e7401eac195$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $b00d3e7401eac195$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $b00d3e7401eac195$var$Xt = 1, $b00d3e7401eac195$var$at = ()=>`${$b00d3e7401eac195$var$Xt++}`;
function $b00d3e7401eac195$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($b00d3e7401eac195$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $b00d3e7401eac195$var$B(n.className || d.toastClassName),
                progressClassName: $b00d3e7401eac195$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $b00d3e7401eac195$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($b00d3e7401eac195$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $b00d3e7401eac195$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $b00d3e7401eac195$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $b00d3e7401eac195$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $b00d3e7401eac195$var$I = new Map, $b00d3e7401eac195$var$F = [], $b00d3e7401eac195$var$st = new Set, $b00d3e7401eac195$var$Vt = (t)=>$b00d3e7401eac195$var$st.forEach((o)=>o(t)), $b00d3e7401eac195$var$bt = ()=>$b00d3e7401eac195$var$I.size > 0;
function $b00d3e7401eac195$var$Qt() {
    $b00d3e7401eac195$var$F.forEach((t)=>$b00d3e7401eac195$var$nt(t.content, t.options)), $b00d3e7401eac195$var$F = [];
}
var $b00d3e7401eac195$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $b00d3e7401eac195$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $b00d3e7401eac195$var$X(t, o) {
    var r;
    if (o) return !!((r = $b00d3e7401eac195$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $b00d3e7401eac195$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $b00d3e7401eac195$var$ht(t) {
    if (!$b00d3e7401eac195$var$bt()) {
        $b00d3e7401eac195$var$F = $b00d3e7401eac195$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $b00d3e7401eac195$var$mt(t)) $b00d3e7401eac195$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $b00d3e7401eac195$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $b00d3e7401eac195$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $b00d3e7401eac195$var$Ct = (t = {})=>{
    $b00d3e7401eac195$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $b00d3e7401eac195$var$nt(t, o) {
    $b00d3e7401eac195$var$z(t) && ($b00d3e7401eac195$var$bt() || $b00d3e7401eac195$var$F.push({
        content: t,
        options: o
    }), $b00d3e7401eac195$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $b00d3e7401eac195$var$xt(t) {
    var o;
    (o = $b00d3e7401eac195$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $b00d3e7401eac195$var$rt(t, o) {
    $b00d3e7401eac195$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $b00d3e7401eac195$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $b00d3e7401eac195$var$_t(o, t, $b00d3e7401eac195$var$Vt);
            $b00d3e7401eac195$var$I.set(o, r);
            let s = r.observe(e);
            return $b00d3e7401eac195$var$Qt(), ()=>{
                s(), $b00d3e7401eac195$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $b00d3e7401eac195$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $b00d3e7401eac195$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $b00d3e7401eac195$var$Pt(t) {
    return $b00d3e7401eac195$var$st.add(t), ()=>{
        $b00d3e7401eac195$var$st.delete(t);
    };
}
function $b00d3e7401eac195$var$Wt(t) {
    return t && ($b00d3e7401eac195$var$N(t.toastId) || $b00d3e7401eac195$var$L(t.toastId)) ? t.toastId : $b00d3e7401eac195$var$at();
}
function $b00d3e7401eac195$var$U(t, o) {
    return $b00d3e7401eac195$var$nt(t, o), o.toastId;
}
function $b00d3e7401eac195$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $b00d3e7401eac195$var$Wt(o)
    };
}
function $b00d3e7401eac195$var$Q(t) {
    return (o, e)=>$b00d3e7401eac195$var$U(o, $b00d3e7401eac195$var$V(t, e));
}
function $b00d3e7401eac195$export$b410431fab84fa58(t, o) {
    return $b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", o));
}
$b00d3e7401eac195$export$b410431fab84fa58.loading = (t, o)=>$b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $b00d3e7401eac195$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $b00d3e7401eac195$var$N(o) ? $b00d3e7401eac195$export$b410431fab84fa58.loading(o, s) : $b00d3e7401eac195$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $b00d3e7401eac195$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $b00d3e7401eac195$var$N(g) ? {
            render: g
        } : g;
        return l ? $b00d3e7401eac195$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $b00d3e7401eac195$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $b00d3e7401eac195$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$b00d3e7401eac195$export$b410431fab84fa58.promise = $b00d3e7401eac195$var$Gt;
$b00d3e7401eac195$export$b410431fab84fa58.success = $b00d3e7401eac195$var$Q("success");
$b00d3e7401eac195$export$b410431fab84fa58.info = $b00d3e7401eac195$var$Q("info");
$b00d3e7401eac195$export$b410431fab84fa58.error = $b00d3e7401eac195$var$Q("error");
$b00d3e7401eac195$export$b410431fab84fa58.warning = $b00d3e7401eac195$var$Q("warning");
$b00d3e7401eac195$export$b410431fab84fa58.warn = $b00d3e7401eac195$export$b410431fab84fa58.warning;
$b00d3e7401eac195$export$b410431fab84fa58.dark = (t, o)=>$b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", {
        theme: "dark",
        ...o
    }));
function $b00d3e7401eac195$var$qt(t) {
    $b00d3e7401eac195$var$ht(t);
}
$b00d3e7401eac195$export$b410431fab84fa58.dismiss = $b00d3e7401eac195$var$qt;
$b00d3e7401eac195$export$b410431fab84fa58.clearWaitingQueue = $b00d3e7401eac195$var$Ct;
$b00d3e7401eac195$export$b410431fab84fa58.isActive = $b00d3e7401eac195$var$X;
$b00d3e7401eac195$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $b00d3e7401eac195$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $b00d3e7401eac195$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $b00d3e7401eac195$var$U(a, l);
    }
};
$b00d3e7401eac195$export$b410431fab84fa58.done = (t)=>{
    $b00d3e7401eac195$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$b00d3e7401eac195$export$b410431fab84fa58.onChange = $b00d3e7401eac195$var$Pt;
$b00d3e7401eac195$export$b410431fab84fa58.play = (t)=>$b00d3e7401eac195$var$rt(!0, t);
$b00d3e7401eac195$export$b410431fab84fa58.pause = (t)=>$b00d3e7401eac195$var$rt(!1, t);
function $b00d3e7401eac195$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $acw62.useRef)($b00d3e7401eac195$var$Et(t)).current;
    r(t);
    let s = (a = (0, $acw62.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $b00d3e7401eac195$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $b00d3e7401eac195$var$At(t) {
    let [o, e] = (0, $acw62.useState)(!1), [r, s] = (0, $acw62.useState)(!1), l = (0, $acw62.useRef)(null), a = (0, $acw62.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $b00d3e7401eac195$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $acw62.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $b00d3e7401eac195$var$Ot = typeof window != "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $b00d3e7401eac195$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $b00d3e7401eac195$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $b00d3e7401eac195$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $b00d3e7401eac195$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $b00d3e7401eac195$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $b00d3e7401eac195$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $b00d3e7401eac195$export$4f13f83fd8bb1dac = {
    info: $b00d3e7401eac195$var$so,
    warning: $b00d3e7401eac195$var$ao,
    success: $b00d3e7401eac195$var$no,
    error: $b00d3e7401eac195$var$ro,
    spinner: $b00d3e7401eac195$var$io
}, $b00d3e7401eac195$var$lo = (t)=>t in $b00d3e7401eac195$export$4f13f83fd8bb1dac;
function $b00d3e7401eac195$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($b00d3e7401eac195$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $acw62.isValidElement)(r) ? s = (0, $acw62.cloneElement)(r, l) : e ? s = $b00d3e7401eac195$export$4f13f83fd8bb1dac.spinner() : $b00d3e7401eac195$var$lo(o) && (s = $b00d3e7401eac195$export$4f13f83fd8bb1dac[o](l))), s;
}
var $b00d3e7401eac195$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $b00d3e7401eac195$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $b00d3e7401eac195$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(D, E), ft = $b00d3e7401eac195$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($b00d3e7401eac195$var$P(a) ? H = a(j) : (0, $acw62.isValidElement)(a) ? H = (0, $acw62.cloneElement)(a, j) : H = $b00d3e7401eac195$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $b00d3e7401eac195$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $b00d3e7401eac195$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $b00d3e7401eac195$export$d20e79fdc3899e95 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("bounce", !0)), $b00d3e7401eac195$export$d8dc01b5c85a37b9 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("slide", !0)), $b00d3e7401eac195$export$65cfd44a2050f99 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("zoom")), $b00d3e7401eac195$export$4d2fae537bd90431 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("flip"));
var $b00d3e7401eac195$var$_o = {
    position: "top-right",
    transition: $b00d3e7401eac195$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $b00d3e7401eac195$export$f2815235e76a62b9(t) {
    let o = {
        ...$b00d3e7401eac195$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $acw62.useState)(!0), l = (0, $acw62.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $b00d3e7401eac195$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $b00d3e7401eac195$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(p, $b00d3e7401eac195$var$B(T));
    }
    function E() {
        e && (s(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
    }
    return $b00d3e7401eac195$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $acw62.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}



parcelRequire("acw62");
const $e25dccdcb9caf9d6$var$LoadingSpinner = ({ message: message })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex min-h-screen items-center justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col items-center space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "size-12 animate-spin rounded-full border-4 border-slate-50 border-t-transparent"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-lg font-semibold text-slate-50",
                    children: message
                })
            ]
        })
    });
};
var $e25dccdcb9caf9d6$export$2e2bcd8739ae039 = $e25dccdcb9caf9d6$var$LoadingSpinner;


const $df3cc72a9e4357db$var$InfoForm = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const params = new URLSearchParams(searchParams);
    const redemptionCode = params.get("redemption_code");
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [invalidCodeMessage, setInvalidCodeMessage] = (0, $acw62.useState)("");
    const isValidRedemptionCode = (0, $acw62.useCallback)(async (redemptionCode)=>{
        if (!redemptionCode) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Redemption code not found");
            console.error("Redemption code not found");
            setInvalidCodeMessage("Redemption code not found");
            setLoading(false);
            return false;
        }
        try {
            const response = await fetch(`${"https://8u475v1sna.execute-api.us-east-1.amazonaws.com/test"}/users/validate-redemption-code?redemptionCode=${redemptionCode}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const resultJSON = await response.json();
            if (!resultJSON.success) {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error(resultJSON.message || "Failed to validate redemption code");
                console.error(resultJSON.message || "Failed to validate redemption code");
                setInvalidCodeMessage(resultJSON.message || "Failed to validate redemption code");
                setLoading(false);
                return false;
            } else {
                setLoading(false);
                return true;
            }
        } catch (error) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Error while validating redemption code");
            console.error(error);
            setInvalidCodeMessage("Error while validating redemption code");
            setLoading(false);
            return false;
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        isValidRedemptionCode(redemptionCode).then((isValid)=>{
            if (!isValid) setLoading(false);
        });
    }, [
        redemptionCode,
        isValidRedemptionCode
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e25dccdcb9caf9d6$export$2e2bcd8739ae039), {
        message: "Validating redemption code"
    });
    if (invalidCodeMessage) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "m-8 overflow-visible rounded-3xl bg-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col content-center justify-center gap-1 p-10 pb-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-caringwireDarkBlue text-center text-xl font-light",
                    children: invalidCodeMessage
                })
            })
        })
    });
    const options = [
        {
            value: "M",
            label: "Male"
        },
        {
            value: "F",
            label: "Female"
        },
        {
            value: "NB",
            label: "Non-Binary"
        },
        {
            value: "U",
            label: "Prefer Not to Say"
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            // only keep the digits and remove whitespace
            const phoneNumber = `+${values.phoneNumber.replace(/\D/g, "")}`;
            const params = {
                ...values,
                phoneNumber: phoneNumber,
                redemptionCode: redemptionCode
            };
            // Form submission logic here
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-bh-form-page-viewed", {
                "form-name": "info"
            });
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-bh-form-started", params);
            navigate(`/wellabebh/dob?redemption_code=${redemptionCode}`, {
                state: params
            });
        },
        validate: (values)=>{
            const errors = {};
            const firstNameError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.firstName);
            errors.firstName = firstNameError;
            const lastNameError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.lastName);
            errors.lastName = lastNameError;
            const phoneNumberError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.phoneNumber);
            errors.phoneNumber = phoneNumberError;
            const emailError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.email) || (0, $3ef5978a8f0aae1f$export$d290fa47940df19d)(values.email);
            errors.email = emailError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid, form: form })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-visible rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 p-10 pb-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Register for Wellabe BH"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue text-center text-xl font-light",
                                    children: "The following information is used to setup your Wellabe BH account and provide access."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        title: "First Name",
                                        placeholder: "First Name *",
                                        type: "text",
                                        autoComplete: "given-name",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        title: "Last Name",
                                        placeholder: "Last Name *",
                                        type: "text",
                                        autoComplete: "family-name",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $036040cd3bc5e884$export$2e2bcd8739ae039), {
                                        name: "phoneNumber",
                                        title: "Phone number",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "email",
                                        title: "Email",
                                        placeholder: "Email *",
                                        type: "email",
                                        autoComplete: "email",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                        name: "gender",
                                        placeholder: "Gender",
                                        options: options,
                                        className: "react-select-container min-w-40 max-w-64 form-input focus:border-mustard text-caringwire rounded-md bg-transparent text-2xl font-thin transition-colors duration-200 ease-in-out focus:outline-none",
                                        required: true,
                                        onChange: (option)=>{
                                            form.change("gender", option.value);
                                        }
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                disabled: !valid,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $df3cc72a9e4357db$export$2e2bcd8739ae039 = $df3cc72a9e4357db$var$InfoForm;






var $acw62 = parcelRequire("acw62");






const $6bd9d088d8c47c07$var$DateOfBirthForm = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const params = new URLSearchParams(searchParams);
    const redemptionCode = params.get("redemption_code");
    const [hasRedemptionCode, setHasRedemptionCode] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        if (!redemptionCode) {
            setHasRedemptionCode(false);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Redemption code not found");
        } else setHasRedemptionCode(true);
    }, [
        redemptionCode
    ]);
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-bh-form-page-viewed", {
        "form-name": "date-of-birth"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            const newState = {
                ...state,
                ...values
            };
            // Form submission logic here
            console.log(newState);
            if (redemptionCode) navigate(`/wellabebh/address?redemption_code=${redemptionCode}`, {
                state: newState
            });
            else navigate("/wellabebh/address", {
                state: newState
            });
        },
        validate: (values)=>{
            const errors = {};
            const monthError = (0, $3ef5978a8f0aae1f$export$af5de1609f06c8e6)(values.dateOfBirthMonth);
            errors.dateOfBirthMonth = monthError;
            const dayError = (0, $3ef5978a8f0aae1f$export$d2d39d1adcc883a2)(values.dateOfBirthDay, values.dateOfBirthMonth, values.dateOfBirthYear);
            errors.dateOfBirthDay = dayError;
            const yearError = (0, $3ef5978a8f0aae1f$export$31803937850fb2da)(values.dateOfBirthYear);
            errors.dateOfBirthYear = yearError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Date of Birth"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "This is required to establish access to on-demand Telehealth and TeleTherapy. Your personal information is encrypted, secured and protected by HIPPA."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthMonth",
                                        title: "MM",
                                        placeholder: "MM *",
                                        type: "text",
                                        maxLength: 2,
                                        format: (value)=>{
                                            // only allow 01-12
                                            const month = value?.replace(/\D/g, "");
                                            if (month && parseInt(month) > 12) return "12";
                                            else return month;
                                        },
                                        autoComplete: "bday-month",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthDay",
                                        title: "DD",
                                        placeholder: "DD *",
                                        type: "text",
                                        maxLength: 2,
                                        format: (value)=>{
                                            // only allow 01-31
                                            const day = value?.replace(/\D/g, "");
                                            if (day && parseInt(day) > 31) return "31";
                                            else return day;
                                        },
                                        autoComplete: "bday-day",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthYear",
                                        title: "YYYY",
                                        placeholder: "YYYY *",
                                        type: "text",
                                        maxLength: 4,
                                        format: (value)=>value?.replace(/\D/g, ""),
                                        autoComplete: "bday-year",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    if (redemptionCode) navigate(`/wellabebh?redemption_code=${redemptionCode}`, {
                                                        state: state
                                                    });
                                                    else navigate("/wellabebh", {
                                                        state: state
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", (!valid || !hasRedemptionCode) && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", (!valid || !hasRedemptionCode) && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $6bd9d088d8c47c07$export$2e2bcd8739ae039 = $6bd9d088d8c47c07$var$DateOfBirthForm;






var $acw62 = parcelRequire("acw62");








const $a39e9fd1f0c8a254$var$AddressForm = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const options = (0, (/*@__PURE__*/$parcel$interopDefault($8159aa64a7960b5d$exports))).options;
    const params = new URLSearchParams(searchParams);
    const redemptionCode = params.get("redemption_code");
    const [hasRedemptionCode, setHasRedemptionCode] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        if (!redemptionCode) {
            setHasRedemptionCode(false);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Redemption code not found");
        } else setHasRedemptionCode(true);
    }, [
        redemptionCode
    ]);
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-bh-form-page-viewed", {
        "form-name": "address"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            // only keep the digits and remove whitespace
            const params = {
                ...state,
                ...values,
                redemptionCode: redemptionCode
            };
            try {
                const user = await fetch("https://8u475v1sna.execute-api.us-east-1.amazonaws.com/test/users/create-wellabe-user", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(params)
                });
                const userJSON = await user.json();
                if (userJSON.error) (0, $b00d3e7401eac195$export$b410431fab84fa58).error(userJSON.message);
                else if (userJSON.success) {
                    const { value: value } = userJSON;
                    const whvcResponse = await fetch("https://8u475v1sna.execute-api.us-east-1.amazonaws.com/test/whvc/create-primary-member", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            userId: value.id,
                            plancode: "2374",
                            groupcode: "OPYNSTGCARUL",
                            disableNotifications: '0',
                            sendRegistrationNotification: '1'
                        })
                    });
                    console.log({
                        userId: value.id,
                        plancode: "2374",
                        groupcode: "OPYNSTGCARUL"
                    });
                    const whvcJSON = await whvcResponse.json();
                    navigate("/wellabebh/success", {
                        state: params
                    });
                }
            } catch (e) {
                console.error(e);
            }
        },
        validate: (values)=>{
            const errors = {};
            const addressError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.address);
            errors.address = addressError;
            const cityError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.city);
            errors.city = cityError;
            const stateError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.state);
            errors.state = stateError;
            const zipError = (0, $3ef5978a8f0aae1f$export$8901015135f2fb22)(values.zip);
            errors.zip = zipError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid, form: form })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-visible rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Home Address"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "Your address is used to connect you with clinicians who are licensed in your state. Your personal information is never sold or shared."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "address",
                                        title: "Address",
                                        placeholder: "Address *",
                                        autoComplete: "street-address",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "addressLine2",
                                        title: "Address Line 2",
                                        placeholder: "Address Line 2",
                                        autoComplete: "address-line2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "city",
                                        title: "City",
                                        placeholder: "City",
                                        autoComplete: "address-level2",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                        name: "state",
                                        placeholder: "State",
                                        options: options,
                                        className: "react-select-container min-w-40 max-w-64 form-input focus:border-mustard text-caringwire rounded-md bg-transparent text-2xl font-thin transition-colors duration-200 ease-in-out focus:outline-none",
                                        required: true,
                                        onChange: (option)=>{
                                            form.change("state", option.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "zip",
                                        title: "Zip",
                                        placeholder: "Zip",
                                        autoComplete: "postal-code",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    // print all the values
                                                    console.log(state);
                                                    if (redemptionCode) navigate(`/wellabebh/dob?redemption_code=${redemptionCode}`, {
                                                        state: {
                                                            ...state,
                                                            country: "United States"
                                                        }
                                                    });
                                                    else navigate(`/wellabebh/dob`, {
                                                        state: {
                                                            ...state,
                                                            country: "United States"
                                                        }
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", (!valid || !hasRedemptionCode) && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", (!valid || !hasRedemptionCode) && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $a39e9fd1f0c8a254$export$2e2bcd8739ae039 = $a39e9fd1f0c8a254$var$AddressForm;



parcelRequire("acw62");

const $16b56aeedb36b00c$var$SuccessPage = ()=>{
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-bh-form-page-viewed", {
        "form-name": "success"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "m-8 overflow-clip rounded-3xl bg-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                        children: [
                            "Success",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                        children: "Your information has been successfully submitted. We will contact you shortly!"
                    })
                ]
            })
        })
    });
};
var $16b56aeedb36b00c$export$2e2bcd8739ae039 = $16b56aeedb36b00c$var$SuccessPage;






var $acw62 = parcelRequire("acw62");









const $10342bf20a1483d2$var$InfoForm = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const params = new URLSearchParams(searchParams);
    const redemptionCode = params.get("redemption_code");
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [invalidCodeMessage, setInvalidCodeMessage] = (0, $acw62.useState)("");
    const isValidRedemptionCode = (0, $acw62.useCallback)(async (redemptionCode)=>{
        if (!redemptionCode) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Redemption code not found");
            console.error("Redemption code not found");
            setInvalidCodeMessage("Redemption code not found");
            setLoading(false);
            return false;
        }
        try {
            const response = await fetch(`${"https://8u475v1sna.execute-api.us-east-1.amazonaws.com/test"}/users/validate-redemption-code?redemptionCode=${redemptionCode}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const resultJSON = await response.json();
            if (!resultJSON.success) {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error(resultJSON.message || "Failed to validate redemption code");
                console.error(resultJSON.message || "Failed to validate redemption code");
                setInvalidCodeMessage(resultJSON.message || "Failed to validate redemption code");
                setLoading(false);
                return false;
            } else {
                setLoading(false);
                return true;
            }
        } catch (error) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Error while validating redemption code");
            console.error(error);
            setInvalidCodeMessage("Error while validating redemption code");
            setLoading(false);
            return false;
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        isValidRedemptionCode(redemptionCode).then((isValid)=>{
            if (!isValid) setLoading(false);
        });
    }, [
        redemptionCode,
        isValidRedemptionCode
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e25dccdcb9caf9d6$export$2e2bcd8739ae039), {
        message: "Validating redemption code"
    });
    if (invalidCodeMessage) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "m-8 overflow-visible rounded-3xl bg-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col content-center justify-center gap-1 p-10 pb-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-caringwireDarkBlue text-center text-xl font-light",
                    children: invalidCodeMessage
                })
            })
        })
    });
    const options = [
        {
            value: "M",
            label: "Male"
        },
        {
            value: "F",
            label: "Female"
        },
        {
            value: "NB",
            label: "Non-Binary"
        },
        {
            value: "U",
            label: "Prefer Not to Say"
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            // only keep the digits and remove whitespace
            const phoneNumber = `+${values.phoneNumber.replace(/\D/g, "")}`;
            const params = {
                ...values,
                phoneNumber: phoneNumber,
                redemptionCode: redemptionCode
            };
            // Form submission logic here
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-p2p-form-page-viewed", {
                "form-name": "info"
            });
            (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-p2p-form-started", params);
            navigate(`/wellabep2p/dob?redemption_code=${redemptionCode}`, {
                state: params
            });
        },
        validate: (values)=>{
            const errors = {};
            const firstNameError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.firstName);
            errors.firstName = firstNameError;
            const lastNameError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.lastName);
            errors.lastName = lastNameError;
            const phoneNumberError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.phoneNumber);
            errors.phoneNumber = phoneNumberError;
            const emailError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.email) || (0, $3ef5978a8f0aae1f$export$d290fa47940df19d)(values.email);
            errors.email = emailError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid, form: form })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-visible rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 p-10 pb-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Register for Wellabe P2P"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue text-center text-xl font-light",
                                    children: "The following information is used to setup your Wellabe P2P account and provide access."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        title: "First Name",
                                        placeholder: "First Name *",
                                        type: "text",
                                        autoComplete: "given-name",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        title: "Last Name",
                                        placeholder: "Last Name *",
                                        type: "text",
                                        autoComplete: "family-name",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $036040cd3bc5e884$export$2e2bcd8739ae039), {
                                        name: "phoneNumber",
                                        title: "Phone number",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "email",
                                        title: "Email",
                                        placeholder: "Email *",
                                        type: "email",
                                        autoComplete: "email",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                        name: "gender",
                                        placeholder: "Gender",
                                        options: options,
                                        className: "react-select-container min-w-40 max-w-64 form-input focus:border-mustard text-caringwire rounded-md bg-transparent text-2xl font-thin transition-colors duration-200 ease-in-out focus:outline-none",
                                        required: true,
                                        onChange: (option)=>{
                                            form.change("gender", option.value);
                                        }
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                disabled: !valid,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $10342bf20a1483d2$export$2e2bcd8739ae039 = $10342bf20a1483d2$var$InfoForm;






var $acw62 = parcelRequire("acw62");






const $19d4724289db3fdd$var$DateOfBirthForm = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const params = new URLSearchParams(searchParams);
    const redemptionCode = params.get("redemption_code");
    const [hasRedemptionCode, setHasRedemptionCode] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        if (!redemptionCode) {
            setHasRedemptionCode(false);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Redemption code not found");
        } else setHasRedemptionCode(true);
    }, [
        redemptionCode
    ]);
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-p2p-form-page-viewed", {
        "form-name": "date-of-birth"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            const newState = {
                ...state,
                ...values
            };
            // Form submission logic here
            console.log(newState);
            if (redemptionCode) navigate(`/wellabep2p/address?redemption_code=${redemptionCode}`, {
                state: newState
            });
            else navigate("/wellabep2p/address", {
                state: newState
            });
        },
        validate: (values)=>{
            const errors = {};
            const monthError = (0, $3ef5978a8f0aae1f$export$af5de1609f06c8e6)(values.dateOfBirthMonth);
            errors.dateOfBirthMonth = monthError;
            const dayError = (0, $3ef5978a8f0aae1f$export$d2d39d1adcc883a2)(values.dateOfBirthDay, values.dateOfBirthMonth, values.dateOfBirthYear);
            errors.dateOfBirthDay = dayError;
            const yearError = (0, $3ef5978a8f0aae1f$export$31803937850fb2da)(values.dateOfBirthYear);
            errors.dateOfBirthYear = yearError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Date of Birth"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "This is required to establish access to on-demand Telehealth and TeleTherapy. Your personal information is encrypted, secured and protected by HIPPA."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthMonth",
                                        title: "MM",
                                        placeholder: "MM *",
                                        type: "text",
                                        maxLength: 2,
                                        format: (value)=>{
                                            // only allow 01-12
                                            const month = value?.replace(/\D/g, "");
                                            if (month && parseInt(month) > 12) return "12";
                                            else return month;
                                        },
                                        autoComplete: "bday-month",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthDay",
                                        title: "DD",
                                        placeholder: "DD *",
                                        type: "text",
                                        maxLength: 2,
                                        format: (value)=>{
                                            // only allow 01-31
                                            const day = value?.replace(/\D/g, "");
                                            if (day && parseInt(day) > 31) return "31";
                                            else return day;
                                        },
                                        autoComplete: "bday-day",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthYear",
                                        title: "YYYY",
                                        placeholder: "YYYY *",
                                        type: "text",
                                        maxLength: 4,
                                        format: (value)=>value?.replace(/\D/g, ""),
                                        autoComplete: "bday-year",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    if (redemptionCode) navigate(`/wellabep2p?redemption_code=${redemptionCode}`, {
                                                        state: state
                                                    });
                                                    else navigate("/wellabep2p", {
                                                        state: state
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", (!valid || !hasRedemptionCode) && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", (!valid || !hasRedemptionCode) && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $19d4724289db3fdd$export$2e2bcd8739ae039 = $19d4724289db3fdd$var$DateOfBirthForm;






var $acw62 = parcelRequire("acw62");








const $a02d00d254a9fb62$var$AddressForm = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const options = (0, (/*@__PURE__*/$parcel$interopDefault($8159aa64a7960b5d$exports))).options;
    const params = new URLSearchParams(searchParams);
    const redemptionCode = params.get("redemption_code");
    const [hasRedemptionCode, setHasRedemptionCode] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        if (!redemptionCode) {
            setHasRedemptionCode(false);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Redemption code not found");
        } else setHasRedemptionCode(true);
    }, [
        redemptionCode
    ]);
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-p2p-form-page-viewed", {
        "form-name": "address"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            // only keep the digits and remove whitespace
            const params = {
                ...state,
                ...values,
                redemptionCode: redemptionCode
            };
            try {
                const result = await fetch("https://8u475v1sna.execute-api.us-east-1.amazonaws.com/test/users/create-wellabe-user", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(params)
                });
                const resultJSON = await result.json();
                if (resultJSON.error) (0, $b00d3e7401eac195$export$b410431fab84fa58).error(resultJSON.message);
                else if (resultJSON.success) {
                    window.open("https://kindlyhuman.io/welcome");
                    navigate("/wellabep2p/success", {
                        state: params
                    });
                }
            } catch (e) {
                console.error(e);
            }
        },
        validate: (values)=>{
            const errors = {};
            const addressError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.address);
            errors.address = addressError;
            const cityError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.city);
            errors.city = cityError;
            const stateError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.state);
            errors.state = stateError;
            const zipError = (0, $3ef5978a8f0aae1f$export$8901015135f2fb22)(values.zip);
            errors.zip = zipError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid, form: form })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-visible rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Home Address"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "Your address is used to connect you with clinicians who are licensed in your state. Your personal information is never sold or shared."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "address",
                                        title: "Address",
                                        placeholder: "Address *",
                                        autoComplete: "street-address",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "addressLine2",
                                        title: "Address Line 2",
                                        placeholder: "Address Line 2",
                                        autoComplete: "address-line2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "city",
                                        title: "City",
                                        placeholder: "City",
                                        autoComplete: "address-level2",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                        name: "state",
                                        placeholder: "State",
                                        options: options,
                                        className: "react-select-container min-w-40 max-w-64 form-input focus:border-mustard text-caringwire rounded-md bg-transparent text-2xl font-thin transition-colors duration-200 ease-in-out focus:outline-none",
                                        required: true,
                                        onChange: (option)=>{
                                            form.change("state", option.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "zip",
                                        title: "Zip",
                                        placeholder: "Zip",
                                        autoComplete: "postal-code",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    // print all the values
                                                    console.log(state);
                                                    if (redemptionCode) navigate(`/wellabep2p/dob?redemption_code=${redemptionCode}`, {
                                                        state: {
                                                            ...state,
                                                            country: "United States"
                                                        }
                                                    });
                                                    else navigate(`/wellabep2p/dob`, {
                                                        state: {
                                                            ...state,
                                                            country: "United States"
                                                        }
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", (!valid || !hasRedemptionCode) && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", (!valid || !hasRedemptionCode) && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $a02d00d254a9fb62$export$2e2bcd8739ae039 = $a02d00d254a9fb62$var$AddressForm;



parcelRequire("acw62");

const $a551a6284ad86f57$var$SuccessPage = ()=>{
    (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("wellabe-bh-form-page-viewed", {
        "form-name": "success"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "m-8 overflow-clip rounded-3xl bg-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                        children: [
                            "Success",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                        children: "Your information has been successfully submitted. We will contact you shortly!"
                    })
                ]
            })
        })
    });
};
var $a551a6284ad86f57$export$2e2bcd8739ae039 = $a551a6284ad86f57$var$SuccessPage;




parcelRequire("acw62");
function $da29e3727c14b3f9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
        children: "Access Denied"
    });
}



parcelRequire("acw62");


parcelRequire("acw62");

const $c976729de51b0dbb$var$LogoutButton = ()=>{
    const { logout: logout } = (0, $874ecb7cc9a437a2$export$f2b63d3ca66bb884)();
    const handleLogout = async ()=>{
        try {
            await logout({
                logoutParams: {
                    returnTo: window.location.origin
                }
            });
        } catch (error) {
            console.error("Logout failed:", error);
            alert("Logout failed. Please try again.");
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: "px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-400 transition-all",
        onClick: handleLogout,
        children: "Log Out"
    });
};
var $c976729de51b0dbb$export$2e2bcd8739ae039 = $c976729de51b0dbb$var$LogoutButton;




var $acw62 = parcelRequire("acw62");


function $567fcb40ff0197aa$export$f0f76eeab536c10d({ children: children }) {
    const { isAuthenticated: isAuthenticated, isLoading: isLoading, loginWithRedirect: loginWithRedirect, getAccessTokenSilently: getAccessTokenSilently } = (0, $874ecb7cc9a437a2$export$f2b63d3ca66bb884)();
    const [isAdmin, setIsAdmin] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        if (!isLoading && !isAuthenticated) loginWithRedirect({
            appState: {
                returnTo: location.pathname
            }
        });
    }, [
        isLoading,
        isAuthenticated,
        loginWithRedirect,
        location.pathname
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchUserDetails = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                console.log("access token:", token);
                const controller = new AbortController();
                const timeout = setTimeout(()=>controller.abort(), 10000);
                const response = await fetch(`${"https://oczrewh6ee.execute-api.us-east-1.amazonaws.com/hahs-test"}/users/me`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    signal: controller.signal
                });
                clearTimeout(timeout);
                if (!response.ok) {
                    setError(`Failed to fetch user info: ${response.status} ${response.statusText}`);
                    return;
                }
                const result = await response.json();
                const adminBool = result.value.isAdmin;
                setIsAdmin(adminBool);
                setError(null);
            } catch (err) {
                if (err.name === "AbortError") setError("Request timed out. Please try again.");
                else setError("Network error. Please check your connection and try again.");
                console.error("Failed to fetch user info", err);
            }
        };
        if (!isLoading && isAuthenticated && isAdmin === null && !error) fetchUserDetails();
    }, [
        isLoading,
        isAuthenticated,
        getAccessTokenSilently,
        error
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isAdmin === false) navigate("/admin/access-denied", {
            replace: true
        });
    }, [
        isAdmin,
        navigate
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            className: "animate-spin h-8 w-8 text-white",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8v8z"
                })
            ]
        })
    });
    if (!isAuthenticated) return null;
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center justify-center text-red-500 mt-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Error: ",
                    error
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "mt-4 px-4 py-2 bg-blue-600 text-white rounded",
                onClick: ()=>{
                    setError(null);
                    setIsAdmin(null);
                },
                children: "Retry"
            })
        ]
    });
    return children;
}


const $eea8bba1be8df4f6$var$NAV_LINKS = [
    {
        to: "/admin/eligibilities/upload",
        label: "Upload Eligibilities"
    },
    {
        to: "/admin/eligibilities/history",
        label: "History"
    }
];
const $eea8bba1be8df4f6$var$AdminLayout = ({ children: children })=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen flex flex-col px-6 py-8 max-w-7xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full flex justify-between items-center p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-2xl font-semibold text-gray-100",
                                children: "ADMIN PANEL"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "flex gap-6",
                                children: $eea8bba1be8df4f6$var$NAV_LINKS.map((link)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: link.to,
                                            className: `text-gray-200 hover:text-white px-2 py-1 rounded transition-colors ${location.pathname === link.to ? "underline" : ""}`,
                                            children: link.label
                                        })
                                    }, link.to))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c976729de51b0dbb$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 p-4",
                children: children ? children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $567fcb40ff0197aa$export$f0f76eeab536c10d), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
                })
            })
        ]
    });
};
var $eea8bba1be8df4f6$export$2e2bcd8739ae039 = $eea8bba1be8df4f6$var$AdminLayout;



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $a0acfd416da73b8a$var$extendStatics = function(d, b) {
    $a0acfd416da73b8a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a0acfd416da73b8a$var$extendStatics(d, b);
};
function $a0acfd416da73b8a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a0acfd416da73b8a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a0acfd416da73b8a$export$18ce0697a983be9b = function() {
    $a0acfd416da73b8a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a0acfd416da73b8a$export$18ce0697a983be9b.apply(this, arguments);
};
function $a0acfd416da73b8a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a0acfd416da73b8a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a0acfd416da73b8a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a0acfd416da73b8a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a0acfd416da73b8a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a0acfd416da73b8a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a0acfd416da73b8a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a0acfd416da73b8a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a0acfd416da73b8a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a0acfd416da73b8a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a0acfd416da73b8a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a0acfd416da73b8a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a0acfd416da73b8a$export$45d3717a4c69092e(o, m, p);
}
function $a0acfd416da73b8a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a0acfd416da73b8a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a0acfd416da73b8a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a0acfd416da73b8a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a0acfd416da73b8a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a0acfd416da73b8a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a0acfd416da73b8a$export$10c90e4f7922046c(v) {
    return this instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? (this.v = v, this) : new $a0acfd416da73b8a$export$10c90e4f7922046c(v);
}
function $a0acfd416da73b8a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a0acfd416da73b8a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a0acfd416da73b8a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a0acfd416da73b8a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a0acfd416da73b8a$export$19a8beecd37a4c45 === "function" ? $a0acfd416da73b8a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a0acfd416da73b8a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a0acfd416da73b8a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a0acfd416da73b8a$var$ownKeys = function(o) {
    $a0acfd416da73b8a$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a0acfd416da73b8a$var$ownKeys(o);
};
function $a0acfd416da73b8a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a0acfd416da73b8a$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a0acfd416da73b8a$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a0acfd416da73b8a$var$__setModuleDefault(result, mod);
    return result;
}
function $a0acfd416da73b8a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a0acfd416da73b8a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a0acfd416da73b8a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a0acfd416da73b8a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a0acfd416da73b8a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a0acfd416da73b8a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a0acfd416da73b8a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a0acfd416da73b8a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a0acfd416da73b8a$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a0acfd416da73b8a$export$2e2bcd8739ae039 = {
    __extends: $a0acfd416da73b8a$export$a8ba968b8961cb8a,
    __assign: $a0acfd416da73b8a$export$18ce0697a983be9b,
    __rest: $a0acfd416da73b8a$export$3c9a16f847548506,
    __decorate: $a0acfd416da73b8a$export$29e00dfd3077644b,
    __param: $a0acfd416da73b8a$export$d5ad3fd78186038f,
    __esDecorate: $a0acfd416da73b8a$export$3a84e1ae4e97e9b0,
    __runInitializers: $a0acfd416da73b8a$export$d831c04e792af3d,
    __propKey: $a0acfd416da73b8a$export$6a2a36740a146cb8,
    __setFunctionName: $a0acfd416da73b8a$export$d1a06452d3489bc7,
    __metadata: $a0acfd416da73b8a$export$f1db080c865becb9,
    __awaiter: $a0acfd416da73b8a$export$1050f835b63b671e,
    __generator: $a0acfd416da73b8a$export$67ebef60e6f28a6,
    __createBinding: $a0acfd416da73b8a$export$45d3717a4c69092e,
    __exportStar: $a0acfd416da73b8a$export$f33643c0debef087,
    __values: $a0acfd416da73b8a$export$19a8beecd37a4c45,
    __read: $a0acfd416da73b8a$export$8d051b38c9118094,
    __spread: $a0acfd416da73b8a$export$afc72e2116322959,
    __spreadArrays: $a0acfd416da73b8a$export$6388937ca91ccae8,
    __spreadArray: $a0acfd416da73b8a$export$1216008129fb82ed,
    __await: $a0acfd416da73b8a$export$10c90e4f7922046c,
    __asyncGenerator: $a0acfd416da73b8a$export$e427f37a30a4de9b,
    __asyncDelegator: $a0acfd416da73b8a$export$bbd80228419bb833,
    __asyncValues: $a0acfd416da73b8a$export$e3b29a3d6162315f,
    __makeTemplateObject: $a0acfd416da73b8a$export$4fb47efe1390b86f,
    __importStar: $a0acfd416da73b8a$export$c21735bcef00d192,
    __importDefault: $a0acfd416da73b8a$export$da59b14a69baef04,
    __classPrivateFieldGet: $a0acfd416da73b8a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a0acfd416da73b8a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a0acfd416da73b8a$export$81fdc39f203e4e04,
    __addDisposableResource: $a0acfd416da73b8a$export$88ac25d8e944e405,
    __disposeResources: $a0acfd416da73b8a$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a0acfd416da73b8a$export$889dfb5d17574b0b
};


const $0c417c97818a47bb$export$db0345794bfc14ed = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        '1km',
        'application/vnd.1000minds.decision-model+xml'
    ],
    [
        '3dml',
        'text/vnd.in3d.3dml'
    ],
    [
        '3ds',
        'image/x-3ds'
    ],
    [
        '3g2',
        'video/3gpp2'
    ],
    [
        '3gp',
        'video/3gp'
    ],
    [
        '3gpp',
        'video/3gpp'
    ],
    [
        '3mf',
        'model/3mf'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        '7zip',
        'application/x-7z-compressed'
    ],
    [
        '123',
        'application/vnd.lotus-1-2-3'
    ],
    [
        'aab',
        'application/x-authorware-bin'
    ],
    [
        'aac',
        'audio/x-acc'
    ],
    [
        'aam',
        'application/x-authorware-map'
    ],
    [
        'aas',
        'application/x-authorware-seg'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'ac',
        'application/vnd.nokia.n-gage.ac+xml'
    ],
    [
        'ac3',
        'audio/ac3'
    ],
    [
        'acc',
        'application/vnd.americandynamics.acc'
    ],
    [
        'ace',
        'application/x-ace-compressed'
    ],
    [
        'acu',
        'application/vnd.acucobol'
    ],
    [
        'acutc',
        'application/vnd.acucorp'
    ],
    [
        'adp',
        'audio/adpcm'
    ],
    [
        'aep',
        'application/vnd.audiograph'
    ],
    [
        'afm',
        'application/x-font-type1'
    ],
    [
        'afp',
        'application/vnd.ibm.modcap'
    ],
    [
        'ahead',
        'application/vnd.ahead.space'
    ],
    [
        'ai',
        'application/pdf'
    ],
    [
        'aif',
        'audio/x-aiff'
    ],
    [
        'aifc',
        'audio/x-aiff'
    ],
    [
        'aiff',
        'audio/x-aiff'
    ],
    [
        'air',
        'application/vnd.adobe.air-application-installer-package+zip'
    ],
    [
        'ait',
        'application/vnd.dvb.ait'
    ],
    [
        'ami',
        'application/vnd.amiga.ami'
    ],
    [
        'amr',
        'audio/amr'
    ],
    [
        'apk',
        'application/vnd.android.package-archive'
    ],
    [
        'apng',
        'image/apng'
    ],
    [
        'appcache',
        'text/cache-manifest'
    ],
    [
        'application',
        'application/x-ms-application'
    ],
    [
        'apr',
        'application/vnd.lotus-approach'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'arj',
        'application/x-arj'
    ],
    [
        'asc',
        'application/pgp-signature'
    ],
    [
        'asf',
        'video/x-ms-asf'
    ],
    [
        'asm',
        'text/x-asm'
    ],
    [
        'aso',
        'application/vnd.accpac.simply.aso'
    ],
    [
        'asx',
        'video/x-ms-asf'
    ],
    [
        'atc',
        'application/vnd.acucorp'
    ],
    [
        'atom',
        'application/atom+xml'
    ],
    [
        'atomcat',
        'application/atomcat+xml'
    ],
    [
        'atomdeleted',
        'application/atomdeleted+xml'
    ],
    [
        'atomsvc',
        'application/atomsvc+xml'
    ],
    [
        'atx',
        'application/vnd.antix.game-component'
    ],
    [
        'au',
        'audio/x-au'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'aw',
        'application/applixware'
    ],
    [
        'azf',
        'application/vnd.airzip.filesecure.azf'
    ],
    [
        'azs',
        'application/vnd.airzip.filesecure.azs'
    ],
    [
        'azv',
        'image/vnd.airzip.accelerator.azv'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'b16',
        'image/vnd.pco.b16'
    ],
    [
        'bat',
        'application/x-msdownload'
    ],
    [
        'bcpio',
        'application/x-bcpio'
    ],
    [
        'bdf',
        'application/x-font-bdf'
    ],
    [
        'bdm',
        'application/vnd.syncml.dm+wbxml'
    ],
    [
        'bdoc',
        'application/x-bdoc'
    ],
    [
        'bed',
        'application/vnd.realvnc.bed'
    ],
    [
        'bh2',
        'application/vnd.fujitsu.oasysprs'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'blb',
        'application/x-blorb'
    ],
    [
        'blorb',
        'application/x-blorb'
    ],
    [
        'bmi',
        'application/vnd.bmi'
    ],
    [
        'bmml',
        'application/vnd.balsamiq.bmml+xml'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'book',
        'application/vnd.framemaker'
    ],
    [
        'box',
        'application/vnd.previewsystems.box'
    ],
    [
        'boz',
        'application/x-bzip2'
    ],
    [
        'bpk',
        'application/octet-stream'
    ],
    [
        'bpmn',
        'application/octet-stream'
    ],
    [
        'bsp',
        'model/vnd.valve.source.compiled-map'
    ],
    [
        'btif',
        'image/prs.btif'
    ],
    [
        'buffer',
        'application/octet-stream'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'c',
        'text/x-c'
    ],
    [
        'c4d',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4f',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4g',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4p',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4u',
        'application/vnd.clonk.c4group'
    ],
    [
        'c11amc',
        'application/vnd.cluetrust.cartomobile-config'
    ],
    [
        'c11amz',
        'application/vnd.cluetrust.cartomobile-config-pkg'
    ],
    [
        'cab',
        'application/vnd.ms-cab-compressed'
    ],
    [
        'caf',
        'audio/x-caf'
    ],
    [
        'cap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'car',
        'application/vnd.curl.car'
    ],
    [
        'cat',
        'application/vnd.ms-pki.seccat'
    ],
    [
        'cb7',
        'application/x-cbr'
    ],
    [
        'cba',
        'application/x-cbr'
    ],
    [
        'cbr',
        'application/x-cbr'
    ],
    [
        'cbt',
        'application/x-cbr'
    ],
    [
        'cbz',
        'application/x-cbr'
    ],
    [
        'cc',
        'text/x-c'
    ],
    [
        'cco',
        'application/x-cocoa'
    ],
    [
        'cct',
        'application/x-director'
    ],
    [
        'ccxml',
        'application/ccxml+xml'
    ],
    [
        'cdbcmsg',
        'application/vnd.contact.cmsg'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'cdf',
        'application/x-netcdf'
    ],
    [
        'cdfx',
        'application/cdfx+xml'
    ],
    [
        'cdkey',
        'application/vnd.mediastation.cdkey'
    ],
    [
        'cdmia',
        'application/cdmi-capability'
    ],
    [
        'cdmic',
        'application/cdmi-container'
    ],
    [
        'cdmid',
        'application/cdmi-domain'
    ],
    [
        'cdmio',
        'application/cdmi-object'
    ],
    [
        'cdmiq',
        'application/cdmi-queue'
    ],
    [
        'cdr',
        'application/cdr'
    ],
    [
        'cdx',
        'chemical/x-cdx'
    ],
    [
        'cdxml',
        'application/vnd.chemdraw+xml'
    ],
    [
        'cdy',
        'application/vnd.cinderella'
    ],
    [
        'cer',
        'application/pkix-cert'
    ],
    [
        'cfs',
        'application/x-cfs-compressed'
    ],
    [
        'cgm',
        'image/cgm'
    ],
    [
        'chat',
        'application/x-chat'
    ],
    [
        'chm',
        'application/vnd.ms-htmlhelp'
    ],
    [
        'chrt',
        'application/vnd.kde.kchart'
    ],
    [
        'cif',
        'chemical/x-cif'
    ],
    [
        'cii',
        'application/vnd.anser-web-certificate-issue-initiation'
    ],
    [
        'cil',
        'application/vnd.ms-artgalry'
    ],
    [
        'cjs',
        'application/node'
    ],
    [
        'cla',
        'application/vnd.claymore'
    ],
    [
        'class',
        'application/octet-stream'
    ],
    [
        'clkk',
        'application/vnd.crick.clicker.keyboard'
    ],
    [
        'clkp',
        'application/vnd.crick.clicker.palette'
    ],
    [
        'clkt',
        'application/vnd.crick.clicker.template'
    ],
    [
        'clkw',
        'application/vnd.crick.clicker.wordbank'
    ],
    [
        'clkx',
        'application/vnd.crick.clicker'
    ],
    [
        'clp',
        'application/x-msclip'
    ],
    [
        'cmc',
        'application/vnd.cosmocaller'
    ],
    [
        'cmdf',
        'chemical/x-cmdf'
    ],
    [
        'cml',
        'chemical/x-cml'
    ],
    [
        'cmp',
        'application/vnd.yellowriver-custom-menu'
    ],
    [
        'cmx',
        'image/x-cmx'
    ],
    [
        'cod',
        'application/vnd.rim.cod'
    ],
    [
        'coffee',
        'text/coffeescript'
    ],
    [
        'com',
        'application/x-msdownload'
    ],
    [
        'conf',
        'text/plain'
    ],
    [
        'cpio',
        'application/x-cpio'
    ],
    [
        'cpp',
        'text/x-c'
    ],
    [
        'cpt',
        'application/mac-compactpro'
    ],
    [
        'crd',
        'application/x-mscardfile'
    ],
    [
        'crl',
        'application/pkix-crl'
    ],
    [
        'crt',
        'application/x-x509-ca-cert'
    ],
    [
        'crx',
        'application/x-chrome-extension'
    ],
    [
        'cryptonote',
        'application/vnd.rig.cryptonote'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'csl',
        'application/vnd.citationstyles.style+xml'
    ],
    [
        'csml',
        'chemical/x-csml'
    ],
    [
        'csp',
        'application/vnd.commonspace'
    ],
    [
        'csr',
        'application/octet-stream'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'cst',
        'application/x-director'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'cu',
        'application/cu-seeme'
    ],
    [
        'curl',
        'text/vnd.curl'
    ],
    [
        'cww',
        'application/prs.cww'
    ],
    [
        'cxt',
        'application/x-director'
    ],
    [
        'cxx',
        'text/x-c'
    ],
    [
        'dae',
        'model/vnd.collada+xml'
    ],
    [
        'daf',
        'application/vnd.mobius.daf'
    ],
    [
        'dart',
        'application/vnd.dart'
    ],
    [
        'dataless',
        'application/vnd.fdsn.seed'
    ],
    [
        'davmount',
        'application/davmount+xml'
    ],
    [
        'dbf',
        'application/vnd.dbf'
    ],
    [
        'dbk',
        'application/docbook+xml'
    ],
    [
        'dcr',
        'application/x-director'
    ],
    [
        'dcurl',
        'text/vnd.curl.dcurl'
    ],
    [
        'dd2',
        'application/vnd.oma.dd2+xml'
    ],
    [
        'ddd',
        'application/vnd.fujixerox.ddd'
    ],
    [
        'ddf',
        'application/vnd.syncml.dmddf+xml'
    ],
    [
        'dds',
        'image/vnd.ms-dds'
    ],
    [
        'deb',
        'application/x-debian-package'
    ],
    [
        'def',
        'text/plain'
    ],
    [
        'deploy',
        'application/octet-stream'
    ],
    [
        'der',
        'application/x-x509-ca-cert'
    ],
    [
        'dfac',
        'application/vnd.dreamfactory'
    ],
    [
        'dgc',
        'application/x-dgc-compressed'
    ],
    [
        'dic',
        'text/x-c'
    ],
    [
        'dir',
        'application/x-director'
    ],
    [
        'dis',
        'application/vnd.mobius.dis'
    ],
    [
        'disposition-notification',
        'message/disposition-notification'
    ],
    [
        'dist',
        'application/octet-stream'
    ],
    [
        'distz',
        'application/octet-stream'
    ],
    [
        'djv',
        'image/vnd.djvu'
    ],
    [
        'djvu',
        'image/vnd.djvu'
    ],
    [
        'dll',
        'application/octet-stream'
    ],
    [
        'dmg',
        'application/x-apple-diskimage'
    ],
    [
        'dmn',
        'application/octet-stream'
    ],
    [
        'dmp',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'dms',
        'application/octet-stream'
    ],
    [
        'dna',
        'application/vnd.dna'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'dot',
        'application/msword'
    ],
    [
        'dotm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'dotx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    ],
    [
        'dp',
        'application/vnd.osgi.dp'
    ],
    [
        'dpg',
        'application/vnd.dpgraph'
    ],
    [
        'dra',
        'audio/vnd.dra'
    ],
    [
        'drle',
        'image/dicom-rle'
    ],
    [
        'dsc',
        'text/prs.lines.tag'
    ],
    [
        'dssc',
        'application/dssc+der'
    ],
    [
        'dtb',
        'application/x-dtbook+xml'
    ],
    [
        'dtd',
        'application/xml-dtd'
    ],
    [
        'dts',
        'audio/vnd.dts'
    ],
    [
        'dtshd',
        'audio/vnd.dts.hd'
    ],
    [
        'dump',
        'application/octet-stream'
    ],
    [
        'dvb',
        'video/vnd.dvb.file'
    ],
    [
        'dvi',
        'application/x-dvi'
    ],
    [
        'dwd',
        'application/atsc-dwd+xml'
    ],
    [
        'dwf',
        'model/vnd.dwf'
    ],
    [
        'dwg',
        'image/vnd.dwg'
    ],
    [
        'dxf',
        'image/vnd.dxf'
    ],
    [
        'dxp',
        'application/vnd.spotfire.dxp'
    ],
    [
        'dxr',
        'application/x-director'
    ],
    [
        'ear',
        'application/java-archive'
    ],
    [
        'ecelp4800',
        'audio/vnd.nuera.ecelp4800'
    ],
    [
        'ecelp7470',
        'audio/vnd.nuera.ecelp7470'
    ],
    [
        'ecelp9600',
        'audio/vnd.nuera.ecelp9600'
    ],
    [
        'ecma',
        'application/ecmascript'
    ],
    [
        'edm',
        'application/vnd.novadigm.edm'
    ],
    [
        'edx',
        'application/vnd.novadigm.edx'
    ],
    [
        'efif',
        'application/vnd.picsel'
    ],
    [
        'ei6',
        'application/vnd.pg.osasli'
    ],
    [
        'elc',
        'application/octet-stream'
    ],
    [
        'emf',
        'image/emf'
    ],
    [
        'eml',
        'message/rfc822'
    ],
    [
        'emma',
        'application/emma+xml'
    ],
    [
        'emotionml',
        'application/emotionml+xml'
    ],
    [
        'emz',
        'application/x-msmetafile'
    ],
    [
        'eol',
        'audio/vnd.digital-winds'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'eps',
        'application/postscript'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'es',
        'application/ecmascript'
    ],
    [
        'es3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'esa',
        'application/vnd.osgi.subsystem'
    ],
    [
        'esf',
        'application/vnd.epson.esf'
    ],
    [
        'et3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'etx',
        'text/x-setext'
    ],
    [
        'eva',
        'application/x-eva'
    ],
    [
        'evy',
        'application/x-envoy'
    ],
    [
        'exe',
        'application/octet-stream'
    ],
    [
        'exi',
        'application/exi'
    ],
    [
        'exp',
        'application/express'
    ],
    [
        'exr',
        'image/aces'
    ],
    [
        'ext',
        'application/vnd.novadigm.ext'
    ],
    [
        'ez',
        'application/andrew-inset'
    ],
    [
        'ez2',
        'application/vnd.ezpix-album'
    ],
    [
        'ez3',
        'application/vnd.ezpix-package'
    ],
    [
        'f',
        'text/x-fortran'
    ],
    [
        'f4v',
        'video/mp4'
    ],
    [
        'f77',
        'text/x-fortran'
    ],
    [
        'f90',
        'text/x-fortran'
    ],
    [
        'fbs',
        'image/vnd.fastbidsheet'
    ],
    [
        'fcdt',
        'application/vnd.adobe.formscentral.fcdt'
    ],
    [
        'fcs',
        'application/vnd.isac.fcs'
    ],
    [
        'fdf',
        'application/vnd.fdf'
    ],
    [
        'fdt',
        'application/fdt+xml'
    ],
    [
        'fe_launch',
        'application/vnd.denovo.fcselayout-link'
    ],
    [
        'fg5',
        'application/vnd.fujitsu.oasysgp'
    ],
    [
        'fgd',
        'application/x-director'
    ],
    [
        'fh',
        'image/x-freehand'
    ],
    [
        'fh4',
        'image/x-freehand'
    ],
    [
        'fh5',
        'image/x-freehand'
    ],
    [
        'fh7',
        'image/x-freehand'
    ],
    [
        'fhc',
        'image/x-freehand'
    ],
    [
        'fig',
        'application/x-xfig'
    ],
    [
        'fits',
        'image/fits'
    ],
    [
        'flac',
        'audio/x-flac'
    ],
    [
        'fli',
        'video/x-fli'
    ],
    [
        'flo',
        'application/vnd.micrografx.flo'
    ],
    [
        'flv',
        'video/x-flv'
    ],
    [
        'flw',
        'application/vnd.kde.kivio'
    ],
    [
        'flx',
        'text/vnd.fmi.flexstor'
    ],
    [
        'fly',
        'text/vnd.fly'
    ],
    [
        'fm',
        'application/vnd.framemaker'
    ],
    [
        'fnc',
        'application/vnd.frogans.fnc'
    ],
    [
        'fo',
        'application/vnd.software602.filler.form+xml'
    ],
    [
        'for',
        'text/x-fortran'
    ],
    [
        'fpx',
        'image/vnd.fpx'
    ],
    [
        'frame',
        'application/vnd.framemaker'
    ],
    [
        'fsc',
        'application/vnd.fsc.weblaunch'
    ],
    [
        'fst',
        'image/vnd.fst'
    ],
    [
        'ftc',
        'application/vnd.fluxtime.clip'
    ],
    [
        'fti',
        'application/vnd.anser-web-funds-transfer-initiation'
    ],
    [
        'fvt',
        'video/vnd.fvt'
    ],
    [
        'fxp',
        'application/vnd.adobe.fxp'
    ],
    [
        'fxpl',
        'application/vnd.adobe.fxp'
    ],
    [
        'fzs',
        'application/vnd.fuzzysheet'
    ],
    [
        'g2w',
        'application/vnd.geoplan'
    ],
    [
        'g3',
        'image/g3fax'
    ],
    [
        'g3w',
        'application/vnd.geospace'
    ],
    [
        'gac',
        'application/vnd.groove-account'
    ],
    [
        'gam',
        'application/x-tads'
    ],
    [
        'gbr',
        'application/rpki-ghostbusters'
    ],
    [
        'gca',
        'application/x-gca-compressed'
    ],
    [
        'gdl',
        'model/vnd.gdl'
    ],
    [
        'gdoc',
        'application/vnd.google-apps.document'
    ],
    [
        'geo',
        'application/vnd.dynageo'
    ],
    [
        'geojson',
        'application/geo+json'
    ],
    [
        'gex',
        'application/vnd.geometry-explorer'
    ],
    [
        'ggb',
        'application/vnd.geogebra.file'
    ],
    [
        'ggt',
        'application/vnd.geogebra.tool'
    ],
    [
        'ghf',
        'application/vnd.groove-help'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'gim',
        'application/vnd.groove-identity-message'
    ],
    [
        'glb',
        'model/gltf-binary'
    ],
    [
        'gltf',
        'model/gltf+json'
    ],
    [
        'gml',
        'application/gml+xml'
    ],
    [
        'gmx',
        'application/vnd.gmx'
    ],
    [
        'gnumeric',
        'application/x-gnumeric'
    ],
    [
        'gpg',
        'application/gpg-keys'
    ],
    [
        'gph',
        'application/vnd.flographit'
    ],
    [
        'gpx',
        'application/gpx+xml'
    ],
    [
        'gqf',
        'application/vnd.grafeq'
    ],
    [
        'gqs',
        'application/vnd.grafeq'
    ],
    [
        'gram',
        'application/srgs'
    ],
    [
        'gramps',
        'application/x-gramps-xml'
    ],
    [
        'gre',
        'application/vnd.geometry-explorer'
    ],
    [
        'grv',
        'application/vnd.groove-injector'
    ],
    [
        'grxml',
        'application/srgs+xml'
    ],
    [
        'gsf',
        'application/x-font-ghostscript'
    ],
    [
        'gsheet',
        'application/vnd.google-apps.spreadsheet'
    ],
    [
        'gslides',
        'application/vnd.google-apps.presentation'
    ],
    [
        'gtar',
        'application/x-gtar'
    ],
    [
        'gtm',
        'application/vnd.groove-tool-message'
    ],
    [
        'gtw',
        'model/vnd.gtw'
    ],
    [
        'gv',
        'text/vnd.graphviz'
    ],
    [
        'gxf',
        'application/gxf'
    ],
    [
        'gxt',
        'application/vnd.geonext'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gzip',
        'application/gzip'
    ],
    [
        'h',
        'text/x-c'
    ],
    [
        'h261',
        'video/h261'
    ],
    [
        'h263',
        'video/h263'
    ],
    [
        'h264',
        'video/h264'
    ],
    [
        'hal',
        'application/vnd.hal+xml'
    ],
    [
        'hbci',
        'application/vnd.hbci'
    ],
    [
        'hbs',
        'text/x-handlebars-template'
    ],
    [
        'hdd',
        'application/x-virtualbox-hdd'
    ],
    [
        'hdf',
        'application/x-hdf'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heics',
        'image/heic-sequence'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'heifs',
        'image/heif-sequence'
    ],
    [
        'hej2',
        'image/hej2k'
    ],
    [
        'held',
        'application/atsc-held+xml'
    ],
    [
        'hh',
        'text/x-c'
    ],
    [
        'hjson',
        'application/hjson'
    ],
    [
        'hlp',
        'application/winhlp'
    ],
    [
        'hpgl',
        'application/vnd.hp-hpgl'
    ],
    [
        'hpid',
        'application/vnd.hp-hpid'
    ],
    [
        'hps',
        'application/vnd.hp-hps'
    ],
    [
        'hqx',
        'application/mac-binhex40'
    ],
    [
        'hsj2',
        'image/hsj2'
    ],
    [
        'htc',
        'text/x-component'
    ],
    [
        'htke',
        'application/vnd.kenameaapp'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'hvd',
        'application/vnd.yamaha.hv-dic'
    ],
    [
        'hvp',
        'application/vnd.yamaha.hv-voice'
    ],
    [
        'hvs',
        'application/vnd.yamaha.hv-script'
    ],
    [
        'i2g',
        'application/vnd.intergeo'
    ],
    [
        'icc',
        'application/vnd.iccprofile'
    ],
    [
        'ice',
        'x-conference/x-cooltalk'
    ],
    [
        'icm',
        'application/vnd.iccprofile'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'ief',
        'image/ief'
    ],
    [
        'ifb',
        'text/calendar'
    ],
    [
        'ifm',
        'application/vnd.shana.informed.formdata'
    ],
    [
        'iges',
        'model/iges'
    ],
    [
        'igl',
        'application/vnd.igloader'
    ],
    [
        'igm',
        'application/vnd.insors.igm'
    ],
    [
        'igs',
        'model/iges'
    ],
    [
        'igx',
        'application/vnd.micrografx.igx'
    ],
    [
        'iif',
        'application/vnd.shana.informed.interchange'
    ],
    [
        'img',
        'application/octet-stream'
    ],
    [
        'imp',
        'application/vnd.accpac.simply.imp'
    ],
    [
        'ims',
        'application/vnd.ms-ims'
    ],
    [
        'in',
        'text/plain'
    ],
    [
        'ini',
        'text/plain'
    ],
    [
        'ink',
        'application/inkml+xml'
    ],
    [
        'inkml',
        'application/inkml+xml'
    ],
    [
        'install',
        'application/x-install-instructions'
    ],
    [
        'iota',
        'application/vnd.astraea-software.iota'
    ],
    [
        'ipfix',
        'application/ipfix'
    ],
    [
        'ipk',
        'application/vnd.shana.informed.package'
    ],
    [
        'irm',
        'application/vnd.ibm.rights-management'
    ],
    [
        'irp',
        'application/vnd.irepository.package+xml'
    ],
    [
        'iso',
        'application/x-iso9660-image'
    ],
    [
        'itp',
        'application/vnd.shana.informed.formtemplate'
    ],
    [
        'its',
        'application/its+xml'
    ],
    [
        'ivp',
        'application/vnd.immervision-ivp'
    ],
    [
        'ivu',
        'application/vnd.immervision-ivu'
    ],
    [
        'jad',
        'text/vnd.sun.j2me.app-descriptor'
    ],
    [
        'jade',
        'text/jade'
    ],
    [
        'jam',
        'application/vnd.jam'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jardiff',
        'application/x-java-archive-diff'
    ],
    [
        'java',
        'text/x-java-source'
    ],
    [
        'jhc',
        'image/jphc'
    ],
    [
        'jisp',
        'application/vnd.jisp'
    ],
    [
        'jls',
        'image/jls'
    ],
    [
        'jlt',
        'application/vnd.hp-jlyt'
    ],
    [
        'jng',
        'image/x-jng'
    ],
    [
        'jnlp',
        'application/x-java-jnlp-file'
    ],
    [
        'joda',
        'application/vnd.joost.joda-archive'
    ],
    [
        'jp2',
        'image/jp2'
    ],
    [
        'jpe',
        'image/jpeg'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpf',
        'image/jpx'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'jpg2',
        'image/jp2'
    ],
    [
        'jpgm',
        'video/jpm'
    ],
    [
        'jpgv',
        'video/jpeg'
    ],
    [
        'jph',
        'image/jph'
    ],
    [
        'jpm',
        'video/jpm'
    ],
    [
        'jpx',
        'image/jpx'
    ],
    [
        'js',
        'application/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'json5',
        'application/json5'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    // https://jsonlines.org/
    [
        'jsonl',
        'application/jsonl'
    ],
    [
        'jsonml',
        'application/jsonml+json'
    ],
    [
        'jsx',
        'text/jsx'
    ],
    [
        'jxr',
        'image/jxr'
    ],
    [
        'jxra',
        'image/jxra'
    ],
    [
        'jxrs',
        'image/jxrs'
    ],
    [
        'jxs',
        'image/jxs'
    ],
    [
        'jxsc',
        'image/jxsc'
    ],
    [
        'jxsi',
        'image/jxsi'
    ],
    [
        'jxss',
        'image/jxss'
    ],
    [
        'kar',
        'audio/midi'
    ],
    [
        'karbon',
        'application/vnd.kde.karbon'
    ],
    [
        'kdb',
        'application/octet-stream'
    ],
    [
        'kdbx',
        'application/x-keepass2'
    ],
    [
        'key',
        'application/x-iwork-keynote-sffkey'
    ],
    [
        'kfo',
        'application/vnd.kde.kformula'
    ],
    [
        'kia',
        'application/vnd.kidspiration'
    ],
    [
        'kml',
        'application/vnd.google-earth.kml+xml'
    ],
    [
        'kmz',
        'application/vnd.google-earth.kmz'
    ],
    [
        'kne',
        'application/vnd.kinar'
    ],
    [
        'knp',
        'application/vnd.kinar'
    ],
    [
        'kon',
        'application/vnd.kde.kontour'
    ],
    [
        'kpr',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpt',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpxx',
        'application/vnd.ds-keypoint'
    ],
    [
        'ksp',
        'application/vnd.kde.kspread'
    ],
    [
        'ktr',
        'application/vnd.kahootz'
    ],
    [
        'ktx',
        'image/ktx'
    ],
    [
        'ktx2',
        'image/ktx2'
    ],
    [
        'ktz',
        'application/vnd.kahootz'
    ],
    [
        'kwd',
        'application/vnd.kde.kword'
    ],
    [
        'kwt',
        'application/vnd.kde.kword'
    ],
    [
        'lasxml',
        'application/vnd.las.las+xml'
    ],
    [
        'latex',
        'application/x-latex'
    ],
    [
        'lbd',
        'application/vnd.llamagraphics.life-balance.desktop'
    ],
    [
        'lbe',
        'application/vnd.llamagraphics.life-balance.exchange+xml'
    ],
    [
        'les',
        'application/vnd.hhe.lesson-player'
    ],
    [
        'less',
        'text/less'
    ],
    [
        'lgr',
        'application/lgr+xml'
    ],
    [
        'lha',
        'application/octet-stream'
    ],
    [
        'link66',
        'application/vnd.route66.link66+xml'
    ],
    [
        'list',
        'text/plain'
    ],
    [
        'list3820',
        'application/vnd.ibm.modcap'
    ],
    [
        'listafp',
        'application/vnd.ibm.modcap'
    ],
    [
        'litcoffee',
        'text/coffeescript'
    ],
    [
        'lnk',
        'application/x-ms-shortcut'
    ],
    [
        'log',
        'text/plain'
    ],
    [
        'lostxml',
        'application/lost+xml'
    ],
    [
        'lrf',
        'application/octet-stream'
    ],
    [
        'lrm',
        'application/vnd.ms-lrm'
    ],
    [
        'ltf',
        'application/vnd.frogans.ltf'
    ],
    [
        'lua',
        'text/x-lua'
    ],
    [
        'luac',
        'application/x-lua-bytecode'
    ],
    [
        'lvp',
        'audio/vnd.lucent.voice'
    ],
    [
        'lwp',
        'application/vnd.lotus-wordpro'
    ],
    [
        'lzh',
        'application/octet-stream'
    ],
    [
        'm1v',
        'video/mpeg'
    ],
    [
        'm2a',
        'audio/mpeg'
    ],
    [
        'm2v',
        'video/mpeg'
    ],
    [
        'm3a',
        'audio/mpeg'
    ],
    [
        'm3u',
        'text/plain'
    ],
    [
        'm3u8',
        'application/vnd.apple.mpegurl'
    ],
    [
        'm4a',
        'audio/x-m4a'
    ],
    [
        'm4p',
        'application/mp4'
    ],
    [
        'm4s',
        'video/iso.segment'
    ],
    [
        'm4u',
        'application/vnd.mpegurl'
    ],
    [
        'm4v',
        'video/x-m4v'
    ],
    [
        'm13',
        'application/x-msmediaview'
    ],
    [
        'm14',
        'application/x-msmediaview'
    ],
    [
        'm21',
        'application/mp21'
    ],
    [
        'ma',
        'application/mathematica'
    ],
    [
        'mads',
        'application/mads+xml'
    ],
    [
        'maei',
        'application/mmt-aei+xml'
    ],
    [
        'mag',
        'application/vnd.ecowin.chart'
    ],
    [
        'maker',
        'application/vnd.framemaker'
    ],
    [
        'man',
        'text/troff'
    ],
    [
        'manifest',
        'text/cache-manifest'
    ],
    [
        'map',
        'application/json'
    ],
    [
        'mar',
        'application/octet-stream'
    ],
    [
        'markdown',
        'text/markdown'
    ],
    [
        'mathml',
        'application/mathml+xml'
    ],
    [
        'mb',
        'application/mathematica'
    ],
    [
        'mbk',
        'application/vnd.mobius.mbk'
    ],
    [
        'mbox',
        'application/mbox'
    ],
    [
        'mc1',
        'application/vnd.medcalcdata'
    ],
    [
        'mcd',
        'application/vnd.mcd'
    ],
    [
        'mcurl',
        'text/vnd.curl.mcurl'
    ],
    [
        'md',
        'text/markdown'
    ],
    [
        'mdb',
        'application/x-msaccess'
    ],
    [
        'mdi',
        'image/vnd.ms-modi'
    ],
    [
        'mdx',
        'text/mdx'
    ],
    [
        'me',
        'text/troff'
    ],
    [
        'mesh',
        'model/mesh'
    ],
    [
        'meta4',
        'application/metalink4+xml'
    ],
    [
        'metalink',
        'application/metalink+xml'
    ],
    [
        'mets',
        'application/mets+xml'
    ],
    [
        'mfm',
        'application/vnd.mfmp'
    ],
    [
        'mft',
        'application/rpki-manifest'
    ],
    [
        'mgp',
        'application/vnd.osgeo.mapguide.package'
    ],
    [
        'mgz',
        'application/vnd.proteus.magazine'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mie',
        'application/x-mie'
    ],
    [
        'mif',
        'application/vnd.mif'
    ],
    [
        'mime',
        'message/rfc822'
    ],
    [
        'mj2',
        'video/mj2'
    ],
    [
        'mjp2',
        'video/mj2'
    ],
    [
        'mjs',
        'application/javascript'
    ],
    [
        'mk3d',
        'video/x-matroska'
    ],
    [
        'mka',
        'audio/x-matroska'
    ],
    [
        'mkd',
        'text/x-markdown'
    ],
    [
        'mks',
        'video/x-matroska'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mlp',
        'application/vnd.dolby.mlp'
    ],
    [
        'mmd',
        'application/vnd.chipnuts.karaoke-mmd'
    ],
    [
        'mmf',
        'application/vnd.smaf'
    ],
    [
        'mml',
        'text/mathml'
    ],
    [
        'mmr',
        'image/vnd.fujixerox.edmics-mmr'
    ],
    [
        'mng',
        'video/x-mng'
    ],
    [
        'mny',
        'application/x-msmoney'
    ],
    [
        'mobi',
        'application/x-mobipocket-ebook'
    ],
    [
        'mods',
        'application/mods+xml'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'movie',
        'video/x-sgi-movie'
    ],
    [
        'mp2',
        'audio/mpeg'
    ],
    [
        'mp2a',
        'audio/mpeg'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mp4a',
        'audio/mp4'
    ],
    [
        'mp4s',
        'application/mp4'
    ],
    [
        'mp4v',
        'video/mp4'
    ],
    [
        'mp21',
        'application/mp21'
    ],
    [
        'mpc',
        'application/vnd.mophun.certificate'
    ],
    [
        'mpd',
        'application/dash+xml'
    ],
    [
        'mpe',
        'video/mpeg'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpg',
        'video/mpeg'
    ],
    [
        'mpg4',
        'video/mp4'
    ],
    [
        'mpga',
        'audio/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'mpm',
        'application/vnd.blueice.multipass'
    ],
    [
        'mpn',
        'application/vnd.mophun.application'
    ],
    [
        'mpp',
        'application/vnd.ms-project'
    ],
    [
        'mpt',
        'application/vnd.ms-project'
    ],
    [
        'mpy',
        'application/vnd.ibm.minipay'
    ],
    [
        'mqy',
        'application/vnd.mobius.mqy'
    ],
    [
        'mrc',
        'application/marc'
    ],
    [
        'mrcx',
        'application/marcxml+xml'
    ],
    [
        'ms',
        'text/troff'
    ],
    [
        'mscml',
        'application/mediaservercontrol+xml'
    ],
    [
        'mseed',
        'application/vnd.fdsn.mseed'
    ],
    [
        'mseq',
        'application/vnd.mseq'
    ],
    [
        'msf',
        'application/vnd.epson.msf'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ],
    [
        'msh',
        'model/mesh'
    ],
    [
        'msi',
        'application/x-msdownload'
    ],
    [
        'msl',
        'application/vnd.mobius.msl'
    ],
    [
        'msm',
        'application/octet-stream'
    ],
    [
        'msp',
        'application/octet-stream'
    ],
    [
        'msty',
        'application/vnd.muvee.style'
    ],
    [
        'mtl',
        'model/mtl'
    ],
    [
        'mts',
        'model/vnd.mts'
    ],
    [
        'mus',
        'application/vnd.musician'
    ],
    [
        'musd',
        'application/mmt-usd+xml'
    ],
    [
        'musicxml',
        'application/vnd.recordare.musicxml+xml'
    ],
    [
        'mvb',
        'application/x-msmediaview'
    ],
    [
        'mvt',
        'application/vnd.mapbox-vector-tile'
    ],
    [
        'mwf',
        'application/vnd.mfer'
    ],
    [
        'mxf',
        'application/mxf'
    ],
    [
        'mxl',
        'application/vnd.recordare.musicxml'
    ],
    [
        'mxmf',
        'audio/mobile-xmf'
    ],
    [
        'mxml',
        'application/xv+xml'
    ],
    [
        'mxs',
        'application/vnd.triscape.mxs'
    ],
    [
        'mxu',
        'video/vnd.mpegurl'
    ],
    [
        'n-gage',
        'application/vnd.nokia.n-gage.symbian.install'
    ],
    [
        'n3',
        'text/n3'
    ],
    [
        'nb',
        'application/mathematica'
    ],
    [
        'nbp',
        'application/vnd.wolfram.player'
    ],
    [
        'nc',
        'application/x-netcdf'
    ],
    [
        'ncx',
        'application/x-dtbncx+xml'
    ],
    [
        'nfo',
        'text/x-nfo'
    ],
    [
        'ngdat',
        'application/vnd.nokia.n-gage.data'
    ],
    [
        'nitf',
        'application/vnd.nitf'
    ],
    [
        'nlu',
        'application/vnd.neurolanguage.nlu'
    ],
    [
        'nml',
        'application/vnd.enliven'
    ],
    [
        'nnd',
        'application/vnd.noblenet-directory'
    ],
    [
        'nns',
        'application/vnd.noblenet-sealer'
    ],
    [
        'nnw',
        'application/vnd.noblenet-web'
    ],
    [
        'npx',
        'image/vnd.net-fpx'
    ],
    [
        'nq',
        'application/n-quads'
    ],
    [
        'nsc',
        'application/x-conference'
    ],
    [
        'nsf',
        'application/vnd.lotus-notes'
    ],
    [
        'nt',
        'application/n-triples'
    ],
    [
        'ntf',
        'application/vnd.nitf'
    ],
    [
        'numbers',
        'application/x-iwork-numbers-sffnumbers'
    ],
    [
        'nzb',
        'application/x-nzb'
    ],
    [
        'oa2',
        'application/vnd.fujitsu.oasys2'
    ],
    [
        'oa3',
        'application/vnd.fujitsu.oasys3'
    ],
    [
        'oas',
        'application/vnd.fujitsu.oasys'
    ],
    [
        'obd',
        'application/x-msbinder'
    ],
    [
        'obgx',
        'application/vnd.openblox.game+xml'
    ],
    [
        'obj',
        'model/obj'
    ],
    [
        'oda',
        'application/oda'
    ],
    [
        'odb',
        'application/vnd.oasis.opendocument.database'
    ],
    [
        'odc',
        'application/vnd.oasis.opendocument.chart'
    ],
    [
        'odf',
        'application/vnd.oasis.opendocument.formula'
    ],
    [
        'odft',
        'application/vnd.oasis.opendocument.formula-template'
    ],
    [
        'odg',
        'application/vnd.oasis.opendocument.graphics'
    ],
    [
        'odi',
        'application/vnd.oasis.opendocument.image'
    ],
    [
        'odm',
        'application/vnd.oasis.opendocument.text-master'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogex',
        'model/vnd.opengex'
    ],
    [
        'ogg',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'omdoc',
        'application/omdoc+xml'
    ],
    [
        'onepkg',
        'application/onenote'
    ],
    [
        'onetmp',
        'application/onenote'
    ],
    [
        'onetoc',
        'application/onenote'
    ],
    [
        'onetoc2',
        'application/onenote'
    ],
    [
        'opf',
        'application/oebps-package+xml'
    ],
    [
        'opml',
        'text/x-opml'
    ],
    [
        'oprc',
        'application/vnd.palm'
    ],
    [
        'opus',
        'audio/ogg'
    ],
    [
        'org',
        'text/x-org'
    ],
    [
        'osf',
        'application/vnd.yamaha.openscoreformat'
    ],
    [
        'osfpvg',
        'application/vnd.yamaha.openscoreformat.osfpvg+xml'
    ],
    [
        'osm',
        'application/vnd.openstreetmap.data+xml'
    ],
    [
        'otc',
        'application/vnd.oasis.opendocument.chart-template'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'otg',
        'application/vnd.oasis.opendocument.graphics-template'
    ],
    [
        'oth',
        'application/vnd.oasis.opendocument.text-web'
    ],
    [
        'oti',
        'application/vnd.oasis.opendocument.image-template'
    ],
    [
        'otp',
        'application/vnd.oasis.opendocument.presentation-template'
    ],
    [
        'ots',
        'application/vnd.oasis.opendocument.spreadsheet-template'
    ],
    [
        'ott',
        'application/vnd.oasis.opendocument.text-template'
    ],
    [
        'ova',
        'application/x-virtualbox-ova'
    ],
    [
        'ovf',
        'application/x-virtualbox-ovf'
    ],
    [
        'owl',
        'application/rdf+xml'
    ],
    [
        'oxps',
        'application/oxps'
    ],
    [
        'oxt',
        'application/vnd.openofficeorg.extension'
    ],
    [
        'p',
        'text/x-pascal'
    ],
    [
        'p7a',
        'application/x-pkcs7-signature'
    ],
    [
        'p7b',
        'application/x-pkcs7-certificates'
    ],
    [
        'p7c',
        'application/pkcs7-mime'
    ],
    [
        'p7m',
        'application/pkcs7-mime'
    ],
    [
        'p7r',
        'application/x-pkcs7-certreqresp'
    ],
    [
        'p7s',
        'application/pkcs7-signature'
    ],
    [
        'p8',
        'application/pkcs8'
    ],
    [
        'p10',
        'application/x-pkcs10'
    ],
    [
        'p12',
        'application/x-pkcs12'
    ],
    [
        'pac',
        'application/x-ns-proxy-autoconfig'
    ],
    [
        'pages',
        'application/x-iwork-pages-sffpages'
    ],
    [
        'pas',
        'text/x-pascal'
    ],
    [
        'paw',
        'application/vnd.pawaafile'
    ],
    [
        'pbd',
        'application/vnd.powerbuilder6'
    ],
    [
        'pbm',
        'image/x-portable-bitmap'
    ],
    [
        'pcap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'pcf',
        'application/x-font-pcf'
    ],
    [
        'pcl',
        'application/vnd.hp-pcl'
    ],
    [
        'pclxl',
        'application/vnd.hp-pclxl'
    ],
    [
        'pct',
        'image/x-pict'
    ],
    [
        'pcurl',
        'application/vnd.curl.pcurl'
    ],
    [
        'pcx',
        'image/x-pcx'
    ],
    [
        'pdb',
        'application/x-pilot'
    ],
    [
        'pde',
        'text/x-processing'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'pem',
        'application/x-x509-user-cert'
    ],
    [
        'pfa',
        'application/x-font-type1'
    ],
    [
        'pfb',
        'application/x-font-type1'
    ],
    [
        'pfm',
        'application/x-font-type1'
    ],
    [
        'pfr',
        'application/font-tdpfr'
    ],
    [
        'pfx',
        'application/x-pkcs12'
    ],
    [
        'pgm',
        'image/x-portable-graymap'
    ],
    [
        'pgn',
        'application/x-chess-pgn'
    ],
    [
        'pgp',
        'application/pgp'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'php3',
        'application/x-httpd-php'
    ],
    [
        'php4',
        'application/x-httpd-php'
    ],
    [
        'phps',
        'application/x-httpd-php-source'
    ],
    [
        'phtml',
        'application/x-httpd-php'
    ],
    [
        'pic',
        'image/x-pict'
    ],
    [
        'pkg',
        'application/octet-stream'
    ],
    [
        'pki',
        'application/pkixcmp'
    ],
    [
        'pkipath',
        'application/pkix-pkipath'
    ],
    [
        'pkpass',
        'application/vnd.apple.pkpass'
    ],
    [
        'pl',
        'application/x-perl'
    ],
    [
        'plb',
        'application/vnd.3gpp.pic-bw-large'
    ],
    [
        'plc',
        'application/vnd.mobius.plc'
    ],
    [
        'plf',
        'application/vnd.pocketlearn'
    ],
    [
        'pls',
        'application/pls+xml'
    ],
    [
        'pm',
        'application/x-perl'
    ],
    [
        'pml',
        'application/vnd.ctc-posml'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pnm',
        'image/x-portable-anymap'
    ],
    [
        'portpkg',
        'application/vnd.macports.portpkg'
    ],
    [
        'pot',
        'application/vnd.ms-powerpoint'
    ],
    [
        'potm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.template'
    ],
    [
        'ppa',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppam',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    ],
    [
        'ppd',
        'application/vnd.cups-ppd'
    ],
    [
        'ppm',
        'image/x-portable-pixmap'
    ],
    [
        'pps',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppsm',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    [
        'ppsx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    ],
    [
        'ppt',
        'application/powerpoint'
    ],
    [
        'pptm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'pqa',
        'application/vnd.palm'
    ],
    [
        'prc',
        'application/x-pilot'
    ],
    [
        'pre',
        'application/vnd.lotus-freelance'
    ],
    [
        'prf',
        'application/pics-rules'
    ],
    [
        'provx',
        'application/provenance+xml'
    ],
    [
        'ps',
        'application/postscript'
    ],
    [
        'psb',
        'application/vnd.3gpp.pic-bw-small'
    ],
    [
        'psd',
        'application/x-photoshop'
    ],
    [
        'psf',
        'application/x-font-linux-psf'
    ],
    [
        'pskcxml',
        'application/pskc+xml'
    ],
    [
        'pti',
        'image/prs.pti'
    ],
    [
        'ptid',
        'application/vnd.pvi.ptid1'
    ],
    [
        'pub',
        'application/x-mspublisher'
    ],
    [
        'pvb',
        'application/vnd.3gpp.pic-bw-var'
    ],
    [
        'pwn',
        'application/vnd.3m.post-it-notes'
    ],
    [
        'pya',
        'audio/vnd.ms-playready.media.pya'
    ],
    [
        'pyv',
        'video/vnd.ms-playready.media.pyv'
    ],
    [
        'qam',
        'application/vnd.epson.quickanime'
    ],
    [
        'qbo',
        'application/vnd.intu.qbo'
    ],
    [
        'qfx',
        'application/vnd.intu.qfx'
    ],
    [
        'qps',
        'application/vnd.publishare-delta-tree'
    ],
    [
        'qt',
        'video/quicktime'
    ],
    [
        'qwd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qwt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxb',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxl',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'ra',
        'audio/x-realaudio'
    ],
    [
        'ram',
        'audio/x-pn-realaudio'
    ],
    [
        'raml',
        'application/raml+yaml'
    ],
    [
        'rapd',
        'application/route-apd+xml'
    ],
    [
        'rar',
        'application/x-rar'
    ],
    [
        'ras',
        'image/x-cmu-raster'
    ],
    [
        'rcprofile',
        'application/vnd.ipunplugged.rcprofile'
    ],
    [
        'rdf',
        'application/rdf+xml'
    ],
    [
        'rdz',
        'application/vnd.data-vision.rdz'
    ],
    [
        'relo',
        'application/p2p-overlay+xml'
    ],
    [
        'rep',
        'application/vnd.businessobjects'
    ],
    [
        'res',
        'application/x-dtbresource+xml'
    ],
    [
        'rgb',
        'image/x-rgb'
    ],
    [
        'rif',
        'application/reginfo+xml'
    ],
    [
        'rip',
        'audio/vnd.rip'
    ],
    [
        'ris',
        'application/x-research-info-systems'
    ],
    [
        'rl',
        'application/resource-lists+xml'
    ],
    [
        'rlc',
        'image/vnd.fujixerox.edmics-rlc'
    ],
    [
        'rld',
        'application/resource-lists-diff+xml'
    ],
    [
        'rm',
        'audio/x-pn-realaudio'
    ],
    [
        'rmi',
        'audio/midi'
    ],
    [
        'rmp',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rms',
        'application/vnd.jcp.javame.midlet-rms'
    ],
    [
        'rmvb',
        'application/vnd.rn-realmedia-vbr'
    ],
    [
        'rnc',
        'application/relax-ng-compact-syntax'
    ],
    [
        'rng',
        'application/xml'
    ],
    [
        'roa',
        'application/rpki-roa'
    ],
    [
        'roff',
        'text/troff'
    ],
    [
        'rp9',
        'application/vnd.cloanto.rp9'
    ],
    [
        'rpm',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rpss',
        'application/vnd.nokia.radio-presets'
    ],
    [
        'rpst',
        'application/vnd.nokia.radio-preset'
    ],
    [
        'rq',
        'application/sparql-query'
    ],
    [
        'rs',
        'application/rls-services+xml'
    ],
    [
        'rsa',
        'application/x-pkcs7'
    ],
    [
        'rsat',
        'application/atsc-rsat+xml'
    ],
    [
        'rsd',
        'application/rsd+xml'
    ],
    [
        'rsheet',
        'application/urc-ressheet+xml'
    ],
    [
        'rss',
        'application/rss+xml'
    ],
    [
        'rtf',
        'text/rtf'
    ],
    [
        'rtx',
        'text/richtext'
    ],
    [
        'run',
        'application/x-makeself'
    ],
    [
        'rusd',
        'application/route-usd+xml'
    ],
    [
        'rv',
        'video/vnd.rn-realvideo'
    ],
    [
        's',
        'text/x-asm'
    ],
    [
        's3m',
        'audio/s3m'
    ],
    [
        'saf',
        'application/vnd.yamaha.smaf-audio'
    ],
    [
        'sass',
        'text/x-sass'
    ],
    [
        'sbml',
        'application/sbml+xml'
    ],
    [
        'sc',
        'application/vnd.ibm.secure-container'
    ],
    [
        'scd',
        'application/x-msschedule'
    ],
    [
        'scm',
        'application/vnd.lotus-screencam'
    ],
    [
        'scq',
        'application/scvp-cv-request'
    ],
    [
        'scs',
        'application/scvp-cv-response'
    ],
    [
        'scss',
        'text/x-scss'
    ],
    [
        'scurl',
        'text/vnd.curl.scurl'
    ],
    [
        'sda',
        'application/vnd.stardivision.draw'
    ],
    [
        'sdc',
        'application/vnd.stardivision.calc'
    ],
    [
        'sdd',
        'application/vnd.stardivision.impress'
    ],
    [
        'sdkd',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdkm',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdp',
        'application/sdp'
    ],
    [
        'sdw',
        'application/vnd.stardivision.writer'
    ],
    [
        'sea',
        'application/octet-stream'
    ],
    [
        'see',
        'application/vnd.seemail'
    ],
    [
        'seed',
        'application/vnd.fdsn.seed'
    ],
    [
        'sema',
        'application/vnd.sema'
    ],
    [
        'semd',
        'application/vnd.semd'
    ],
    [
        'semf',
        'application/vnd.semf'
    ],
    [
        'senmlx',
        'application/senml+xml'
    ],
    [
        'sensmlx',
        'application/sensml+xml'
    ],
    [
        'ser',
        'application/java-serialized-object'
    ],
    [
        'setpay',
        'application/set-payment-initiation'
    ],
    [
        'setreg',
        'application/set-registration-initiation'
    ],
    [
        'sfd-hdstx',
        'application/vnd.hydrostatix.sof-data'
    ],
    [
        'sfs',
        'application/vnd.spotfire.sfs'
    ],
    [
        'sfv',
        'text/x-sfv'
    ],
    [
        'sgi',
        'image/sgi'
    ],
    [
        'sgl',
        'application/vnd.stardivision.writer-global'
    ],
    [
        'sgm',
        'text/sgml'
    ],
    [
        'sgml',
        'text/sgml'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'shar',
        'application/x-shar'
    ],
    [
        'shex',
        'text/shex'
    ],
    [
        'shf',
        'application/shf+xml'
    ],
    [
        'shtml',
        'text/html'
    ],
    [
        'sid',
        'image/x-mrsid-image'
    ],
    [
        'sieve',
        'application/sieve'
    ],
    [
        'sig',
        'application/pgp-signature'
    ],
    [
        'sil',
        'audio/silk'
    ],
    [
        'silo',
        'model/mesh'
    ],
    [
        'sis',
        'application/vnd.symbian.install'
    ],
    [
        'sisx',
        'application/vnd.symbian.install'
    ],
    [
        'sit',
        'application/x-stuffit'
    ],
    [
        'sitx',
        'application/x-stuffitx'
    ],
    [
        'siv',
        'application/sieve'
    ],
    [
        'skd',
        'application/vnd.koan'
    ],
    [
        'skm',
        'application/vnd.koan'
    ],
    [
        'skp',
        'application/vnd.koan'
    ],
    [
        'skt',
        'application/vnd.koan'
    ],
    [
        'sldm',
        'application/vnd.ms-powerpoint.slide.macroenabled.12'
    ],
    [
        'sldx',
        'application/vnd.openxmlformats-officedocument.presentationml.slide'
    ],
    [
        'slim',
        'text/slim'
    ],
    [
        'slm',
        'text/slim'
    ],
    [
        'sls',
        'application/route-s-tsid+xml'
    ],
    [
        'slt',
        'application/vnd.epson.salt'
    ],
    [
        'sm',
        'application/vnd.stepmania.stepchart'
    ],
    [
        'smf',
        'application/vnd.stardivision.math'
    ],
    [
        'smi',
        'application/smil'
    ],
    [
        'smil',
        'application/smil'
    ],
    [
        'smv',
        'video/x-smv'
    ],
    [
        'smzip',
        'application/vnd.stepmania.package'
    ],
    [
        'snd',
        'audio/basic'
    ],
    [
        'snf',
        'application/x-font-snf'
    ],
    [
        'so',
        'application/octet-stream'
    ],
    [
        'spc',
        'application/x-pkcs7-certificates'
    ],
    [
        'spdx',
        'text/spdx'
    ],
    [
        'spf',
        'application/vnd.yamaha.smaf-phrase'
    ],
    [
        'spl',
        'application/x-futuresplash'
    ],
    [
        'spot',
        'text/vnd.in3d.spot'
    ],
    [
        'spp',
        'application/scvp-vp-response'
    ],
    [
        'spq',
        'application/scvp-vp-request'
    ],
    [
        'spx',
        'audio/ogg'
    ],
    [
        'sql',
        'application/x-sql'
    ],
    [
        'src',
        'application/x-wais-source'
    ],
    [
        'srt',
        'application/x-subrip'
    ],
    [
        'sru',
        'application/sru+xml'
    ],
    [
        'srx',
        'application/sparql-results+xml'
    ],
    [
        'ssdl',
        'application/ssdl+xml'
    ],
    [
        'sse',
        'application/vnd.kodak-descriptor'
    ],
    [
        'ssf',
        'application/vnd.epson.ssf'
    ],
    [
        'ssml',
        'application/ssml+xml'
    ],
    [
        'sst',
        'application/octet-stream'
    ],
    [
        'st',
        'application/vnd.sailingtracker.track'
    ],
    [
        'stc',
        'application/vnd.sun.xml.calc.template'
    ],
    [
        'std',
        'application/vnd.sun.xml.draw.template'
    ],
    [
        'stf',
        'application/vnd.wt.stf'
    ],
    [
        'sti',
        'application/vnd.sun.xml.impress.template'
    ],
    [
        'stk',
        'application/hyperstudio'
    ],
    [
        'stl',
        'model/stl'
    ],
    [
        'stpx',
        'model/step+xml'
    ],
    [
        'stpxz',
        'model/step-xml+zip'
    ],
    [
        'stpz',
        'model/step+zip'
    ],
    [
        'str',
        'application/vnd.pg.format'
    ],
    [
        'stw',
        'application/vnd.sun.xml.writer.template'
    ],
    [
        'styl',
        'text/stylus'
    ],
    [
        'stylus',
        'text/stylus'
    ],
    [
        'sub',
        'text/vnd.dvb.subtitle'
    ],
    [
        'sus',
        'application/vnd.sus-calendar'
    ],
    [
        'susp',
        'application/vnd.sus-calendar'
    ],
    [
        'sv4cpio',
        'application/x-sv4cpio'
    ],
    [
        'sv4crc',
        'application/x-sv4crc'
    ],
    [
        'svc',
        'application/vnd.dvb.service'
    ],
    [
        'svd',
        'application/vnd.svd'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'svgz',
        'image/svg+xml'
    ],
    [
        'swa',
        'application/x-director'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'swi',
        'application/vnd.aristanetworks.swi'
    ],
    [
        'swidtag',
        'application/swid+xml'
    ],
    [
        'sxc',
        'application/vnd.sun.xml.calc'
    ],
    [
        'sxd',
        'application/vnd.sun.xml.draw'
    ],
    [
        'sxg',
        'application/vnd.sun.xml.writer.global'
    ],
    [
        'sxi',
        'application/vnd.sun.xml.impress'
    ],
    [
        'sxm',
        'application/vnd.sun.xml.math'
    ],
    [
        'sxw',
        'application/vnd.sun.xml.writer'
    ],
    [
        't',
        'text/troff'
    ],
    [
        't3',
        'application/x-t3vm-image'
    ],
    [
        't38',
        'image/t38'
    ],
    [
        'taglet',
        'application/vnd.mynfc'
    ],
    [
        'tao',
        'application/vnd.tao.intent-module-archive'
    ],
    [
        'tap',
        'image/vnd.tencent.tap'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tcap',
        'application/vnd.3gpp2.tcap'
    ],
    [
        'tcl',
        'application/x-tcl'
    ],
    [
        'td',
        'application/urc-targetdesc+xml'
    ],
    [
        'teacher',
        'application/vnd.smart.teacher'
    ],
    [
        'tei',
        'application/tei+xml'
    ],
    [
        'teicorpus',
        'application/tei+xml'
    ],
    [
        'tex',
        'application/x-tex'
    ],
    [
        'texi',
        'application/x-texinfo'
    ],
    [
        'texinfo',
        'application/x-texinfo'
    ],
    [
        'text',
        'text/plain'
    ],
    [
        'tfi',
        'application/thraud+xml'
    ],
    [
        'tfm',
        'application/x-tex-tfm'
    ],
    [
        'tfx',
        'image/tiff-fx'
    ],
    [
        'tga',
        'image/x-tga'
    ],
    [
        'tgz',
        'application/x-tar'
    ],
    [
        'thmx',
        'application/vnd.ms-officetheme'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'tk',
        'application/x-tcl'
    ],
    [
        'tmo',
        'application/vnd.tmobile-livetv'
    ],
    [
        'toml',
        'application/toml'
    ],
    [
        'torrent',
        'application/x-bittorrent'
    ],
    [
        'tpl',
        'application/vnd.groove-tool-template'
    ],
    [
        'tpt',
        'application/vnd.trid.tpt'
    ],
    [
        'tr',
        'text/troff'
    ],
    [
        'tra',
        'application/vnd.trueapp'
    ],
    [
        'trig',
        'application/trig'
    ],
    [
        'trm',
        'application/x-msterminal'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'tsd',
        'application/timestamped-data'
    ],
    [
        'tsv',
        'text/tab-separated-values'
    ],
    [
        'ttc',
        'font/collection'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'ttl',
        'text/turtle'
    ],
    [
        'ttml',
        'application/ttml+xml'
    ],
    [
        'twd',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'twds',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'txd',
        'application/vnd.genomatix.tuxedo'
    ],
    [
        'txf',
        'application/vnd.mobius.txf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'u8dsn',
        'message/global-delivery-status'
    ],
    [
        'u8hdr',
        'message/global-headers'
    ],
    [
        'u8mdn',
        'message/global-disposition-notification'
    ],
    [
        'u8msg',
        'message/global'
    ],
    [
        'u32',
        'application/x-authorware-bin'
    ],
    [
        'ubj',
        'application/ubjson'
    ],
    [
        'udeb',
        'application/x-debian-package'
    ],
    [
        'ufd',
        'application/vnd.ufdl'
    ],
    [
        'ufdl',
        'application/vnd.ufdl'
    ],
    [
        'ulx',
        'application/x-glulx'
    ],
    [
        'umj',
        'application/vnd.umajin'
    ],
    [
        'unityweb',
        'application/vnd.unity'
    ],
    [
        'uoml',
        'application/vnd.uoml+xml'
    ],
    [
        'uri',
        'text/uri-list'
    ],
    [
        'uris',
        'text/uri-list'
    ],
    [
        'urls',
        'text/uri-list'
    ],
    [
        'usdz',
        'model/vnd.usdz+zip'
    ],
    [
        'ustar',
        'application/x-ustar'
    ],
    [
        'utz',
        'application/vnd.uiq.theme'
    ],
    [
        'uu',
        'text/x-uuencode'
    ],
    [
        'uva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvd',
        'application/vnd.dece.data'
    ],
    [
        'uvf',
        'application/vnd.dece.data'
    ],
    [
        'uvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvv',
        'video/vnd.dece.video'
    ],
    [
        'uvva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvvd',
        'application/vnd.dece.data'
    ],
    [
        'uvvf',
        'application/vnd.dece.data'
    ],
    [
        'uvvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvvv',
        'video/vnd.dece.video'
    ],
    [
        'uvvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvvz',
        'application/vnd.dece.zip'
    ],
    [
        'uvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvz',
        'application/vnd.dece.zip'
    ],
    [
        'vbox',
        'application/x-virtualbox-vbox'
    ],
    [
        'vbox-extpack',
        'application/x-virtualbox-vbox-extpack'
    ],
    [
        'vcard',
        'text/vcard'
    ],
    [
        'vcd',
        'application/x-cdlink'
    ],
    [
        'vcf',
        'text/x-vcard'
    ],
    [
        'vcg',
        'application/vnd.groove-vcard'
    ],
    [
        'vcs',
        'text/x-vcalendar'
    ],
    [
        'vcx',
        'application/vnd.vcx'
    ],
    [
        'vdi',
        'application/x-virtualbox-vdi'
    ],
    [
        'vds',
        'model/vnd.sap.vds'
    ],
    [
        'vhd',
        'application/x-virtualbox-vhd'
    ],
    [
        'vis',
        'application/vnd.visionary'
    ],
    [
        'viv',
        'video/vnd.vivo'
    ],
    [
        'vlc',
        'application/videolan'
    ],
    [
        'vmdk',
        'application/x-virtualbox-vmdk'
    ],
    [
        'vob',
        'video/x-ms-vob'
    ],
    [
        'vor',
        'application/vnd.stardivision.writer'
    ],
    [
        'vox',
        'application/x-authorware-bin'
    ],
    [
        'vrml',
        'model/vrml'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'vsf',
        'application/vnd.vsf'
    ],
    [
        'vss',
        'application/vnd.visio'
    ],
    [
        'vst',
        'application/vnd.visio'
    ],
    [
        'vsw',
        'application/vnd.visio'
    ],
    [
        'vtf',
        'image/vnd.valve.source.texture'
    ],
    [
        'vtt',
        'text/vtt'
    ],
    [
        'vtu',
        'model/vnd.vtu'
    ],
    [
        'vxml',
        'application/voicexml+xml'
    ],
    [
        'w3d',
        'application/x-director'
    ],
    [
        'wad',
        'application/x-doom'
    ],
    [
        'wadl',
        'application/vnd.sun.wadl+xml'
    ],
    [
        'war',
        'application/java-archive'
    ],
    [
        'wasm',
        'application/wasm'
    ],
    [
        'wav',
        'audio/x-wav'
    ],
    [
        'wax',
        'audio/x-ms-wax'
    ],
    [
        'wbmp',
        'image/vnd.wap.wbmp'
    ],
    [
        'wbs',
        'application/vnd.criticaltools.wbs+xml'
    ],
    [
        'wbxml',
        'application/wbxml'
    ],
    [
        'wcm',
        'application/vnd.ms-works'
    ],
    [
        'wdb',
        'application/vnd.ms-works'
    ],
    [
        'wdp',
        'image/vnd.ms-photo'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webapp',
        'application/x-web-app-manifest+json'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webmanifest',
        'application/manifest+json'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'wg',
        'application/vnd.pmi.widget'
    ],
    [
        'wgt',
        'application/widget'
    ],
    [
        'wks',
        'application/vnd.ms-works'
    ],
    [
        'wm',
        'video/x-ms-wm'
    ],
    [
        'wma',
        'audio/x-ms-wma'
    ],
    [
        'wmd',
        'application/x-ms-wmd'
    ],
    [
        'wmf',
        'image/wmf'
    ],
    [
        'wml',
        'text/vnd.wap.wml'
    ],
    [
        'wmlc',
        'application/wmlc'
    ],
    [
        'wmls',
        'text/vnd.wap.wmlscript'
    ],
    [
        'wmlsc',
        'application/vnd.wap.wmlscriptc'
    ],
    [
        'wmv',
        'video/x-ms-wmv'
    ],
    [
        'wmx',
        'video/x-ms-wmx'
    ],
    [
        'wmz',
        'application/x-msmetafile'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'word',
        'application/msword'
    ],
    [
        'wpd',
        'application/vnd.wordperfect'
    ],
    [
        'wpl',
        'application/vnd.ms-wpl'
    ],
    [
        'wps',
        'application/vnd.ms-works'
    ],
    [
        'wqd',
        'application/vnd.wqd'
    ],
    [
        'wri',
        'application/x-mswrite'
    ],
    [
        'wrl',
        'model/vrml'
    ],
    [
        'wsc',
        'message/vnd.wfa.wsc'
    ],
    [
        'wsdl',
        'application/wsdl+xml'
    ],
    [
        'wspolicy',
        'application/wspolicy+xml'
    ],
    [
        'wtb',
        'application/vnd.webturbo'
    ],
    [
        'wvx',
        'video/x-ms-wvx'
    ],
    [
        'x3d',
        'model/x3d+xml'
    ],
    [
        'x3db',
        'model/x3d+fastinfoset'
    ],
    [
        'x3dbz',
        'model/x3d+binary'
    ],
    [
        'x3dv',
        'model/x3d-vrml'
    ],
    [
        'x3dvz',
        'model/x3d+vrml'
    ],
    [
        'x3dz',
        'model/x3d+xml'
    ],
    [
        'x32',
        'application/x-authorware-bin'
    ],
    [
        'x_b',
        'model/vnd.parasolid.transmit.binary'
    ],
    [
        'x_t',
        'model/vnd.parasolid.transmit.text'
    ],
    [
        'xaml',
        'application/xaml+xml'
    ],
    [
        'xap',
        'application/x-silverlight-app'
    ],
    [
        'xar',
        'application/vnd.xara'
    ],
    [
        'xav',
        'application/xcap-att+xml'
    ],
    [
        'xbap',
        'application/x-ms-xbap'
    ],
    [
        'xbd',
        'application/vnd.fujixerox.docuworks.binder'
    ],
    [
        'xbm',
        'image/x-xbitmap'
    ],
    [
        'xca',
        'application/xcap-caps+xml'
    ],
    [
        'xcs',
        'application/calendar+xml'
    ],
    [
        'xdf',
        'application/xcap-diff+xml'
    ],
    [
        'xdm',
        'application/vnd.syncml.dm+xml'
    ],
    [
        'xdp',
        'application/vnd.adobe.xdp+xml'
    ],
    [
        'xdssc',
        'application/dssc+xml'
    ],
    [
        'xdw',
        'application/vnd.fujixerox.docuworks'
    ],
    [
        'xel',
        'application/xcap-el+xml'
    ],
    [
        'xenc',
        'application/xenc+xml'
    ],
    [
        'xer',
        'application/patch-ops-error+xml'
    ],
    [
        'xfdf',
        'application/vnd.adobe.xfdf'
    ],
    [
        'xfdl',
        'application/vnd.xfdl'
    ],
    [
        'xht',
        'application/xhtml+xml'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xhvml',
        'application/xv+xml'
    ],
    [
        'xif',
        'image/vnd.xiff'
    ],
    [
        'xl',
        'application/excel'
    ],
    [
        'xla',
        'application/vnd.ms-excel'
    ],
    [
        'xlam',
        'application/vnd.ms-excel.addin.macroEnabled.12'
    ],
    [
        'xlc',
        'application/vnd.ms-excel'
    ],
    [
        'xlf',
        'application/xliff+xml'
    ],
    [
        'xlm',
        'application/vnd.ms-excel'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsb',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    [
        'xlsm',
        'application/vnd.ms-excel.sheet.macroEnabled.12'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xlt',
        'application/vnd.ms-excel'
    ],
    [
        'xltm',
        'application/vnd.ms-excel.template.macroEnabled.12'
    ],
    [
        'xltx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    ],
    [
        'xlw',
        'application/vnd.ms-excel'
    ],
    [
        'xm',
        'audio/xm'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xns',
        'application/xcap-ns+xml'
    ],
    [
        'xo',
        'application/vnd.olpc-sugar'
    ],
    [
        'xop',
        'application/xop+xml'
    ],
    [
        'xpi',
        'application/x-xpinstall'
    ],
    [
        'xpl',
        'application/xproc+xml'
    ],
    [
        'xpm',
        'image/x-xpixmap'
    ],
    [
        'xpr',
        'application/vnd.is-xpr'
    ],
    [
        'xps',
        'application/vnd.ms-xpsdocument'
    ],
    [
        'xpw',
        'application/vnd.intercon.formnet'
    ],
    [
        'xpx',
        'application/vnd.intercon.formnet'
    ],
    [
        'xsd',
        'application/xml'
    ],
    [
        'xsl',
        'application/xml'
    ],
    [
        'xslt',
        'application/xslt+xml'
    ],
    [
        'xsm',
        'application/vnd.syncml+xml'
    ],
    [
        'xspf',
        'application/xspf+xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'xvm',
        'application/xv+xml'
    ],
    [
        'xvml',
        'application/xv+xml'
    ],
    [
        'xwd',
        'image/x-xwindowdump'
    ],
    [
        'xyz',
        'chemical/x-xyz'
    ],
    [
        'xz',
        'application/x-xz'
    ],
    [
        'yaml',
        'text/yaml'
    ],
    [
        'yang',
        'application/yang'
    ],
    [
        'yin',
        'application/yin+xml'
    ],
    [
        'yml',
        'text/yaml'
    ],
    [
        'ymp',
        'text/x-suse-ymp'
    ],
    [
        'z',
        'application/x-compress'
    ],
    [
        'z1',
        'application/x-zmachine'
    ],
    [
        'z2',
        'application/x-zmachine'
    ],
    [
        'z3',
        'application/x-zmachine'
    ],
    [
        'z4',
        'application/x-zmachine'
    ],
    [
        'z5',
        'application/x-zmachine'
    ],
    [
        'z6',
        'application/x-zmachine'
    ],
    [
        'z7',
        'application/x-zmachine'
    ],
    [
        'z8',
        'application/x-zmachine'
    ],
    [
        'zaz',
        'application/vnd.zzazz.deck+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'zir',
        'application/vnd.zul'
    ],
    [
        'zirz',
        'application/vnd.zul'
    ],
    [
        'zmm',
        'application/vnd.handheld-entertainment+xml'
    ],
    [
        'zsh',
        'text/x-scriptzsh'
    ]
]);
function $0c417c97818a47bb$export$8cc09085015f0dc7(file, path, h) {
    const f = $0c417c97818a47bb$var$withMimeType(file);
    const { webkitRelativePath: webkitRelativePath } = file;
    const p = typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== 'string') $0c417c97818a47bb$var$setObjProp(f, 'path', p);
    if (h !== undefined) Object.defineProperty(f, 'handle', {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    $0c417c97818a47bb$var$setObjProp(f, 'relativePath', p);
    return f;
}
function $0c417c97818a47bb$var$withMimeType(file) {
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.').pop().toLowerCase();
        const type = $0c417c97818a47bb$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function $0c417c97818a47bb$var$setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value: value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}


const $5cf572b3062ef12c$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $5cf572b3062ef12c$export$a36e16046ae8f1bb(evt) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        if ($5cf572b3062ef12c$var$isObject(evt) && $5cf572b3062ef12c$var$isDataTransfer(evt.dataTransfer)) return $5cf572b3062ef12c$var$getDataTransferFiles(evt.dataTransfer, evt.type);
        else if ($5cf572b3062ef12c$var$isChangeEvt(evt)) return $5cf572b3062ef12c$var$getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>'getFile' in item && typeof item.getFile === 'function')) return $5cf572b3062ef12c$var$getFsHandleFiles(evt);
        return [];
    });
}
function $5cf572b3062ef12c$var$isDataTransfer(value) {
    return $5cf572b3062ef12c$var$isObject(value);
}
function $5cf572b3062ef12c$var$isChangeEvt(value) {
    return $5cf572b3062ef12c$var$isObject(value) && $5cf572b3062ef12c$var$isObject(value.target);
}
function $5cf572b3062ef12c$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $5cf572b3062ef12c$var$getInputFiles(evt) {
    return $5cf572b3062ef12c$var$fromList(evt.target.files).map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $5cf572b3062ef12c$var$getFsHandleFiles(handles) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file));
    });
}
function $5cf572b3062ef12c$var$getDataTransferFiles(dt, type) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = $5cf572b3062ef12c$var$fromList(dt.items).filter((item)=>item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') return items;
            const files = yield Promise.all(items.map($5cf572b3062ef12c$var$toFilePromises));
            return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$flatten(files));
        }
        return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$fromList(dt.files).map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file)));
    });
}
function $5cf572b3062ef12c$var$noIgnoredFiles(files) {
    return files.filter((file)=>$5cf572b3062ef12c$var$FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $5cf572b3062ef12c$var$fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $5cf572b3062ef12c$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $5cf572b3062ef12c$var$fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $5cf572b3062ef12c$var$fromDirEntry(entry);
    return $5cf572b3062ef12c$var$fromDataTransferItem(item, entry);
}
function $5cf572b3062ef12c$var$flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? $5cf572b3062ef12c$var$flatten(files) : [
                files
            ]
        ], []);
}
function $5cf572b3062ef12c$var$fromDataTransferItem(item, entry) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) throw new Error(`${item} is not a File`);
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file);
            }
        }
        const file = item.getAsFile();
        if (!file) throw new Error(`${item} is not a File`);
        const fwp = (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $5cf572b3062ef12c$var$fromEntry(entry) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return entry.isDirectory ? $5cf572b3062ef12c$var$fromDirEntry(entry) : $5cf572b3062ef12c$var$fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $5cf572b3062ef12c$var$fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map($5cf572b3062ef12c$var$fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $5cf572b3062ef12c$var$fromFileEntry(entry) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}




var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $aaac53b849ab07d4$var$_toConsumableArray(arr) {
    return $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) || $aaac53b849ab07d4$var$_iterableToArray(arr) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr) || $aaac53b849ab07d4$var$_nonIterableSpread();
}
function $aaac53b849ab07d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aaac53b849ab07d4$var$_arrayLikeToArray(arr);
}
function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$var$accepts = typeof (0, $000a86df99a95c54$export$2e2bcd8739ae039) === "function" ? (0, $000a86df99a95c54$export$2e2bcd8739ae039) : (0, $000a86df99a95c54$export$2e2bcd8739ae039).default; // Error codes
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
};
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(msg)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
};
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || $aaac53b849ab07d4$var$accepts(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$8ce4bd13c494743e(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $aaac53b849ab07d4$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$aaac53b849ab07d4$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($aaac53b849ab07d4$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $aaac53b849ab07d4$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, agg), {}, $aaac53b849ab07d4$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $aaac53b849ab07d4$export$1278288bcefb97b9(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $aaac53b849ab07d4$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($aaac53b849ab07d4$var$_toConsumableArray(a), [
            mimeType
        ], $aaac53b849ab07d4$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) || $aaac53b849ab07d4$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $aaac53b849ab07d4$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 


var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $5cf572b3062ef12c$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $aaac53b849ab07d4$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $acw62.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $acw62.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $aaac53b849ab07d4$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $aaac53b849ab07d4$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $aaac53b849ab07d4$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $aaac53b849ab07d4$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $aaac53b849ab07d4$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $aaac53b849ab07d4$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $aaac53b849ab07d4$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}


const $ebcb6a3d1e8c2f0f$var$ACCEPTED_TYPES = {
    "text/csv": [
        ".csv"
    ]
};
const $ebcb6a3d1e8c2f0f$var$MAX_FILE_SIZE = 10485760; // 10MB
const $ebcb6a3d1e8c2f0f$var$EligibilityDropzone = ({ onFile: onFile })=>{
    const [error, setError] = (0, $acw62.useState)(null);
    const onDrop = (acceptedFiles, fileRejections)=>{
        if (acceptedFiles && acceptedFiles.length > 0) {
            setError(null);
            onFile(acceptedFiles[0]);
        } else if (fileRejections && fileRejections.length > 0) {
            const errorCodes = fileRejections.flatMap((rej)=>rej.errors.map((e)=>e.code));
            if (errorCodes.includes("file-too-large")) setError("File is too large. Maximum allowed size is 10MB.");
            else if (errorCodes.includes("too-many-files")) setError("Only one file can be uploaded at a time.");
            else if (errorCodes.includes("file-invalid-type")) setError("Only .csv files are accepted.");
            else setError("File rejected. Please check the file and try again.");
        }
    };
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        accept: $ebcb6a3d1e8c2f0f$var$ACCEPTED_TYPES,
        multiple: false,
        maxFiles: 1,
        maxSize: $ebcb6a3d1e8c2f0f$var$MAX_FILE_SIZE
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...getRootProps(),
        className: `border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-2",
                children: "Drag and drop a .csv file here, or click to select"
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-red-500 text-sm mt-2",
                children: error
            })
        ]
    });
};
var $ebcb6a3d1e8c2f0f$export$2e2bcd8739ae039 = $ebcb6a3d1e8c2f0f$var$EligibilityDropzone;


async function $e19de912f27c6f38$export$e0a9582776d94188(file, token) {
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(`${"https://oczrewh6ee.execute-api.us-east-1.amazonaws.com/hahs-test"}/eligibilities`, {
        method: "POST",
        body: formData,
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
}
async function $e19de912f27c6f38$export$e732b5726664d556(token, params = {}) {
    const query = new URLSearchParams();
    if (params.org) query.append("org", params.org);
    if (params.status) query.append("status", params.status);
    if (params.page) query.append("page", params.page.toString());
    if (params.pageSize) query.append("pageSize", params.pageSize.toString());
    if (params.sortBy) query.append("sortBy", params.sortBy);
    if (params.sortDir) query.append("sortDir", params.sortDir);
    const url = `${"https://oczrewh6ee.execute-api.us-east-1.amazonaws.com/hahs-test"}/eligibilities?${query.toString()}`;
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
}
async function $e19de912f27c6f38$export$c521715156a6b830(token, id) {
    const url = `${"https://oczrewh6ee.execute-api.us-east-1.amazonaws.com/hahs-test"}/eligibilities/${id}`;
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
}
async function $e19de912f27c6f38$export$46c77663237f5ef7(token, id) {
    const url = `${"https://oczrewh6ee.execute-api.us-east-1.amazonaws.com/hahs-test"}/eligibilities/${id}/download`;
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
}




var $acw62 = parcelRequire("acw62");
// src/mutationObserver.ts




var $1ddf06f11bccca52$export$d3c1860ee66f291a = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $524c502dbe70a85f$export$a1659b54bac3252a)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            if (this.#mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const context = this.#currentResult.context;
                if (action?.type === "success") {
                    this.#mutateOptions.onSuccess?.(action.data, variables, context);
                    this.#mutateOptions.onSettled?.(action.data, null, variables, context);
                } else if (action?.type === "error") {
                    this.#mutateOptions.onError?.(action.error, variables, context);
                    this.#mutateOptions.onSettled?.(void 0, action.error, variables, context);
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};



"use client";
function $6a05afbd57376433$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $1ddf06f11bccca52$export$d3c1860ee66f291a)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $938ae10f13d49bdc$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}



const $15ef8acb32c99e32$var$UploadPage = ()=>{
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $874ecb7cc9a437a2$export$f2b63d3ca66bb884)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (file)=>{
            const token = await getAccessTokenSilently();
            return (0, $e19de912f27c6f38$export$e0a9582776d94188)(file, token);
        },
        onSuccess: ()=>{
            (0, $b00d3e7401eac195$export$b410431fab84fa58).success("File uploaded successfully!");
            navigate("/admin/eligibilities");
        },
        onError: (err)=>{
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error("Upload failed: " + (err?.toString() || "Unknown error"));
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-xl mx-auto mt-12 p-8 bg-white rounded shadow",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-2xl font-bold",
                        children: "Upload Eligibilities"
                    }),
                    mutation.isPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                className: "animate-spin h-6 w-6 text-blue-500",
                                viewBox: "0 0 24 24",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        className: "opacity-25",
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        stroke: "currentColor",
                                        strokeWidth: "4",
                                        fill: "none"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        className: "opacity-75",
                                        fill: "currentColor",
                                        d: "M4 12a8 8 0 018-8v8z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ml-2 text-blue-600 text-base",
                                children: "Uploading..."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebcb6a3d1e8c2f0f$export$2e2bcd8739ae039), {
                onFile: (file)=>mutation.mutate(file)
            })
        ]
    });
};
var $15ef8acb32c99e32$export$2e2bcd8739ae039 = $15ef8acb32c99e32$var$UploadPage;





var $acw62 = parcelRequire("acw62");
// src/queryObserver.ts






var $2905803326ac545c$export$a06cf8c0066f0d4c = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.#currentThenable = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
        if (!this.options.experimental_prefetchInRender) this.#currentThenable.reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
        this.bindMethods();
        this.setOptions(options);
    }
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #currentThenable;
    #selectError;
    #selectFn;
    #selectResult;
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($2905803326ac545c$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2905803326ac545c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2905803326ac545c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $2905803326ac545c$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, this.#currentQuery) || (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if ($2905803326ac545c$var$shouldAssignObserverCurrentProperties(this, result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked?.(key);
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        this.#trackedProps.add(key);
    }
    getCurrentQuery() {
        return this.#currentQuery;
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
        return promise;
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery);
        if ((0, $938ae10f13d49bdc$export$6acf61af03e62db) || this.#currentResult.isStale || !(0, $938ae10f13d49bdc$export$e539f754e934e270)(staleTime)) return;
        const time = (0, $938ae10f13d49bdc$export$811b83d62bcf47f0)(this.#currentResult.dataUpdatedAt, staleTime);
        const timeout = time + 1;
        this.#staleTimeoutId = setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if ((0, $938ae10f13d49bdc$export$6acf61af03e62db) || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) === false || !(0, $938ae10f13d49bdc$export$e539f754e934e270)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) return;
        this.#refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId) {
            clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId) {
            clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $2905803326ac545c$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $2905803326ac545c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $bbb5e4108fb61687$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(data);
                data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        }
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $2905803326ac545c$var$isStale(query, options),
            refetch: this.refetch,
            promise: this.#currentThenable
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = this.#currentThenable = nextResult.promise = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = this.#currentThenable;
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        this.#notify({
            listeners: shouldNotifyListeners()
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
    #notify(notifyOptions) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
};
function $2905803326ac545c$var$shouldLoadOnMount(query, options) {
    return (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $2905803326ac545c$var$shouldFetchOnMount(query, options) {
    return $2905803326ac545c$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $2905803326ac545c$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $2905803326ac545c$var$shouldFetchOn(query, options, field) {
    if ((0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false && (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $2905803326ac545c$var$isStale(query, options);
    }
    return false;
}
function $2905803326ac545c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $2905803326ac545c$var$isStale(query, options);
}
function $2905803326ac545c$var$isStale(query, options) {
    return (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $2905803326ac545c$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

"use client";
function $3ccd03800b9b1a4a$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext = $acw62.createContext($3ccd03800b9b1a4a$var$createValue());
var $3ccd03800b9b1a4a$export$50dfac555130cafd = ()=>$acw62.useContext($3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext);
var $3ccd03800b9b1a4a$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$3ccd03800b9b1a4a$var$createValue());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
var $b8d88d7bae8d797f$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $b8d88d7bae8d797f$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $b8d88d7bae8d797f$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $938ae10f13d49bdc$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $acw62 = parcelRequire("acw62");
"use client";
var $b2f924bc70e540d6$var$IsRestoringContext = $acw62.createContext(false);
var $b2f924bc70e540d6$export$4da0178d6b5f553 = ()=>$acw62.useContext($b2f924bc70e540d6$var$IsRestoringContext);
var $b2f924bc70e540d6$export$593807d4e94f9621 = $b2f924bc70e540d6$var$IsRestoringContext.Provider;


// src/suspense.ts
var $d9109c84b9b954d9$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $d9109c84b9b954d9$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? 1e3, 1e3);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $d9109c84b9b954d9$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $d9109c84b9b954d9$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
var $d9109c84b9b954d9$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $22b97878ddf0e02d$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $b2f924bc70e540d6$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $3ccd03800b9b1a4a$export$50dfac555130cafd)();
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    client.getDefaultOptions().queries?._experimental_beforeQuery?.(defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $d9109c84b9b954d9$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $b8d88d7bae8d797f$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $b8d88d7bae8d797f$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $938ae10f13d49bdc$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $d9109c84b9b954d9$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $b8d88d7bae8d797f$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    client.getDefaultOptions().queries?._experimental_afterQuery?.(defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $938ae10f13d49bdc$export$6acf61af03e62db) && (0, $d9109c84b9b954d9$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        client.getQueryCache().get(defaultedOptions.queryHash)?.promise;
        promise?.catch((0, $938ae10f13d49bdc$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $4cdfd80436a5bb32$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $22b97878ddf0e02d$export$fff0865807e996c5)(options, (0, $2905803326ac545c$export$a06cf8c0066f0d4c), queryClient);
}




/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ 
var $acw62 = parcelRequire("acw62");
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $03d3295ed0668f0a$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === 'function' ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $03d3295ed0668f0a$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $03d3295ed0668f0a$export$8793edee2d425525() {
//
}
function $03d3295ed0668f0a$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $03d3295ed0668f0a$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $03d3295ed0668f0a$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $03d3295ed0668f0a$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === 'number');
}
function $03d3295ed0668f0a$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $03d3295ed0668f0a$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = ' ' + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $03d3295ed0668f0a$export$b1f82222dc43996c(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function $03d3295ed0668f0a$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugCells', 'cell.getContext'))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
function $03d3295ed0668f0a$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === 'function' ? accessorKey.replaceAll('.', '_') : accessorKey.replace(/\./g, '_') : undefined) != null ? _ref : typeof resolvedColumnDef.header === 'string' ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes('.')) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split('.')){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getFlatColumns')),
        getLeafColumns: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getLeafColumns'))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to unknown, because we know more than the compiler here.
    return column;
}
const $03d3295ed0668f0a$var$debug = 'debugHeaders';
//
function $03d3295ed0668f0a$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const $03d3295ed0668f0a$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = $03d3295ed0668f0a$export$d8c3a8af36458fc3(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getHeaderGroups'));
        table.getCenterHeaderGroups = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return $03d3295ed0668f0a$export$d8c3a8af36458fc3(allColumns, leafColumns, table, 'center');
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getCenterHeaderGroups'));
        table.getLeftHeaderGroups = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return $03d3295ed0668f0a$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'left');
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getLeftHeaderGroups'));
        table.getRightHeaderGroups = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return $03d3295ed0668f0a$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'right');
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getRightHeaderGroups'));
        // Footer Groups
        table.getFooterGroups = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getFooterGroups'));
        table.getLeftFooterGroups = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getLeftFooterGroups'));
        table.getCenterFooterGroups = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getCenterFooterGroups'));
        table.getRightFooterGroups = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getRightFooterGroups'));
        // Flat Headers
        table.getFlatHeaders = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getFlatHeaders'));
        table.getLeftFlatHeaders = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getLeftFlatHeaders'));
        table.getCenterFlatHeaders = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getCenterFlatHeaders'));
        table.getRightFlatHeaders = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getRightFlatHeaders'));
        // Leaf Headers
        table.getCenterLeafHeaders = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getCenterLeafHeaders'));
        table.getLeftLeafHeaders = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getLeftLeafHeaders'));
        table.getRightLeafHeaders = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getRightLeafHeaders'));
        table.getLeafHeaders = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, $03d3295ed0668f0a$var$debug, 'getLeafHeaders'));
    }
};
function $03d3295ed0668f0a$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join('_'),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $03d3295ed0668f0a$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join('_'),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$03d3295ed0668f0a$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
const $03d3295ed0668f0a$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$03d3295ed0668f0a$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $03d3295ed0668f0a$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCells')),
        _getAllCellsByColumnId: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCellsByColumnId'))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
//
const $03d3295ed0668f0a$export$1f746e6a9cd841b1 = {
    createColumn: (column, table)=>{
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    }
};
const $03d3295ed0668f0a$var$includesString = (row, columnId, filterValue)=>{
    var _filterValue$toString, _row$getValue;
    const search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
$03d3295ed0668f0a$var$includesString.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val);
const $03d3295ed0668f0a$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
$03d3295ed0668f0a$var$includesStringSensitive.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val);
const $03d3295ed0668f0a$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$03d3295ed0668f0a$var$equalsString.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val);
const $03d3295ed0668f0a$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$03d3295ed0668f0a$var$arrIncludes.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val);
const $03d3295ed0668f0a$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$03d3295ed0668f0a$var$arrIncludesAll.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val) || !(val != null && val.length);
const $03d3295ed0668f0a$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$03d3295ed0668f0a$var$arrIncludesSome.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val) || !(val != null && val.length);
const $03d3295ed0668f0a$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$03d3295ed0668f0a$var$equals.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val);
const $03d3295ed0668f0a$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$03d3295ed0668f0a$var$weakEquals.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val);
const $03d3295ed0668f0a$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$03d3295ed0668f0a$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$03d3295ed0668f0a$var$inNumberRange.autoRemove = (val)=>$03d3295ed0668f0a$var$testFalsey(val) || $03d3295ed0668f0a$var$testFalsey(val[0]) && $03d3295ed0668f0a$var$testFalsey(val[1]);
// Export
const $03d3295ed0668f0a$export$6ad8312e296ec316 = {
    includesString: $03d3295ed0668f0a$var$includesString,
    includesStringSensitive: $03d3295ed0668f0a$var$includesStringSensitive,
    equalsString: $03d3295ed0668f0a$var$equalsString,
    arrIncludes: $03d3295ed0668f0a$var$arrIncludes,
    arrIncludesAll: $03d3295ed0668f0a$var$arrIncludesAll,
    arrIncludesSome: $03d3295ed0668f0a$var$arrIncludesSome,
    equals: $03d3295ed0668f0a$var$equals,
    weakEquals: $03d3295ed0668f0a$var$weakEquals,
    inNumberRange: $03d3295ed0668f0a$var$inNumberRange
};
// Utils
function $03d3295ed0668f0a$var$testFalsey(val) {
    return val === undefined || val === null || val === '';
}
//
const $03d3295ed0668f0a$export$f1d67534a0c5e9d3 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $03d3295ed0668f0a$export$2b5605d8069324bd('columnFilters', table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return $03d3295ed0668f0a$export$6ad8312e296ec316.includesString;
            if (typeof value === 'number') return $03d3295ed0668f0a$export$6ad8312e296ec316.inNumberRange;
            if (typeof value === 'boolean') return $03d3295ed0668f0a$export$6ad8312e296ec316.equals;
            if (value !== null && typeof value === 'object') return $03d3295ed0668f0a$export$6ad8312e296ec316.equals;
            if (Array.isArray(value)) return $03d3295ed0668f0a$export$6ad8312e296ec316.arrIncludes;
            return $03d3295ed0668f0a$export$6ad8312e296ec316.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return $03d3295ed0668f0a$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === 'auto' ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $03d3295ed0668f0a$export$6ad8312e296ec316[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousFilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = $03d3295ed0668f0a$export$7f095f455ad5af3f(value, previousFilter ? previousFilter.value : undefined);
                //
                if ($03d3295ed0668f0a$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousFilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
    },
    createRow: (row, _table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = $03d3295ed0668f0a$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if ($03d3295ed0668f0a$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
    }
};
function $03d3295ed0668f0a$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === 'undefined' || typeof value === 'string' && !value;
}
const $03d3295ed0668f0a$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === 'number' ? nextValue : 0);
    }, 0);
};
const $03d3295ed0668f0a$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $03d3295ed0668f0a$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $03d3295ed0668f0a$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $03d3295ed0668f0a$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $03d3295ed0668f0a$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$03d3295ed0668f0a$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $03d3295ed0668f0a$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $03d3295ed0668f0a$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $03d3295ed0668f0a$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $03d3295ed0668f0a$export$3aa4339120b8b25b = {
    sum: $03d3295ed0668f0a$var$sum,
    min: $03d3295ed0668f0a$var$min,
    max: $03d3295ed0668f0a$var$max,
    extent: $03d3295ed0668f0a$var$extent,
    mean: $03d3295ed0668f0a$var$mean,
    median: $03d3295ed0668f0a$var$median,
    unique: $03d3295ed0668f0a$var$unique,
    uniqueCount: $03d3295ed0668f0a$var$uniqueCount,
    count: $03d3295ed0668f0a$var$count
};
//
const $03d3295ed0668f0a$export$9c9247c655f92e74 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $03d3295ed0668f0a$export$2b5605d8069324bd('grouping', table),
            groupedColumnMode: 'reorder'
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'number') return $03d3295ed0668f0a$export$3aa4339120b8b25b.sum;
            if (Object.prototype.toString.call(value) === '[object Date]') return $03d3295ed0668f0a$export$3aa4339120b8b25b.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return $03d3295ed0668f0a$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === 'auto' ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $03d3295ed0668f0a$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function $03d3295ed0668f0a$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === 'remove') return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $03d3295ed0668f0a$export$fec9c66cd0275c2c = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $03d3295ed0668f0a$export$2b5605d8069324bd('columnOrder', table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = $03d3295ed0668f0a$export$7c73462e0d25e514((position)=>[
                $03d3295ed0668f0a$export$1d7c103713892a11(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', 'getIndex'));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = $03d3295ed0668f0a$export$1d7c103713892a11(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = $03d3295ed0668f0a$export$1d7c103713892a11(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return $03d3295ed0668f0a$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
            }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', '_getOrderColumnsFn'));
    }
};
//
const $03d3295ed0668f0a$var$getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const $03d3295ed0668f0a$export$3563275ce70c4813 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $03d3295ed0668f0a$var$getDefaultColumnPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $03d3295ed0668f0a$export$2b5605d8069324bd('columnPinning', table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === 'right') {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === 'left') {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left: left, right: right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? 'left' : isRight ? 'right' : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.getCenterVisibleCells = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterVisibleCells'));
        row.getLeftVisibleCells = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'left'
                }));
            return cells;
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getLeftVisibleCells'));
        row.getRightVisibleCells = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'right'
                }));
            return cells;
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getRightVisibleCells'));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? $03d3295ed0668f0a$var$getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $03d3295ed0668f0a$var$getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', 'getLeftLeafColumns'));
        table.getRightLeafColumns = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', 'getRightLeafColumns'));
        table.getCenterLeafColumns = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', 'getCenterLeafColumns'));
    }
};
function $03d3295ed0668f0a$var$safelyAccessDocument(_document) {
    return _document || (typeof document !== 'undefined' ? document : null);
}
//
//
const $03d3295ed0668f0a$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $03d3295ed0668f0a$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $03d3295ed0668f0a$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $03d3295ed0668f0a$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $03d3295ed0668f0a$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: 'onEnd',
            columnResizeDirection: 'ltr',
            onColumnSizingChange: $03d3295ed0668f0a$export$2b5605d8069324bd('columnSizing', table),
            onColumnSizingInfoChange: $03d3295ed0668f0a$export$2b5605d8069324bd('columnSizingInfo', table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $03d3295ed0668f0a$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $03d3295ed0668f0a$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $03d3295ed0668f0a$export$2f660993f4eb1f29.maxSize);
        };
        column.getStart = $03d3295ed0668f0a$export$7c73462e0d25e514((position)=>[
                position,
                $03d3295ed0668f0a$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', 'getStart'));
        column.getAfter = $03d3295ed0668f0a$export$7c73462e0d25e514((position)=>[
                position,
                $03d3295ed0668f0a$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', 'getAfter'));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if ($03d3295ed0668f0a$var$isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = $03d3295ed0668f0a$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== 'number') return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === 'rtl' ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset: deltaOffset,
                            deltaPercentage: deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === 'onChange' || eventType === 'end') table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset('move', clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset('end', clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = $03d3295ed0668f0a$var$safelyAccessDocument(_contextDocument);
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener('mousemove', mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('mouseup', mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener('touchmove', touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('touchend', touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = $03d3295ed0668f0a$export$4927b5943c7c0b4() ? {
                    passive: false
                } : false;
                if ($03d3295ed0668f0a$var$isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener('touchmove', touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('touchend', touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener('mousemove', mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize: startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart: columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? $03d3295ed0668f0a$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $03d3295ed0668f0a$var$getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let $03d3295ed0668f0a$var$passiveSupported = null;
function $03d3295ed0668f0a$export$4927b5943c7c0b4() {
    if (typeof $03d3295ed0668f0a$var$passiveSupported === 'boolean') return $03d3295ed0668f0a$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop);
    } catch (err) {
        supported = false;
    }
    $03d3295ed0668f0a$var$passiveSupported = supported;
    return $03d3295ed0668f0a$var$passiveSupported;
}
function $03d3295ed0668f0a$var$isTouchStartEvent(e) {
    return e.type === 'touchstart';
}
//
const $03d3295ed0668f0a$export$be5545a32e20d889 = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $03d3295ed0668f0a$export$2b5605d8069324bd('columnVisibility', table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _ref, _table$getState$colum;
            const childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some((c)=>c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', '_getAllVisibleCells'));
        row.getVisibleCells = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getVisibleCells'));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join('_')
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugColumns', key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod('getVisibleFlatColumns', ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod('getVisibleLeafColumns', ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod('getLeftVisibleLeafColumns', ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod('getRightVisibleLeafColumns', ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod('getCenterVisibleLeafColumns', ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function $03d3295ed0668f0a$export$1d7c103713892a11(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === 'center' ? table.getCenterVisibleLeafColumns() : position === 'left' ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
//
const $03d3295ed0668f0a$export$4b37edcdc7ad2fe1 = {
    createTable: (table)=>{
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__');
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, '__global__');
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, '__global__');
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
//
const $03d3295ed0668f0a$export$61e9e0661ff79b1c = {
    getInitialState: (state)=>{
        return {
            globalFilter: undefined,
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGlobalFilterChange: $03d3295ed0668f0a$export$2b5605d8069324bd('globalFilter', table),
            globalFilterFn: 'auto',
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === 'string' || typeof value === 'number';
            }
        };
    },
    createColumn: (column, table)=>{
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
            return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return $03d3295ed0668f0a$export$6ad8312e296ec316.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            const { globalFilterFn: globalFilterFn } = table.options;
            return $03d3295ed0668f0a$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === 'auto' ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : $03d3295ed0668f0a$export$6ad8312e296ec316[globalFilterFn];
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
    }
};
//
const $03d3295ed0668f0a$export$fed54e0d64c17fb2 = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $03d3295ed0668f0a$export$2b5605d8069324bd('expanded', table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === 'boolean') return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split('.');
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
//
const $03d3295ed0668f0a$var$defaultPageIndex = 0;
const $03d3295ed0668f0a$var$defaultPageSize = 10;
const $03d3295ed0668f0a$var$getDefaultPaginationState = ()=>({
        pageIndex: $03d3295ed0668f0a$var$defaultPageIndex,
        pageSize: $03d3295ed0668f0a$var$defaultPageSize
    });
const $03d3295ed0668f0a$export$bce540641752d22b = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$03d3295ed0668f0a$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $03d3295ed0668f0a$export$2b5605d8069324bd('pagination', table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = $03d3295ed0668f0a$export$7f095f455ad5af3f(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? $03d3295ed0668f0a$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $03d3295ed0668f0a$var$getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = $03d3295ed0668f0a$export$7f095f455ad5af3f(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex: pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? $03d3295ed0668f0a$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : $03d3295ed0668f0a$var$defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? $03d3295ed0668f0a$var$defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : $03d3295ed0668f0a$var$defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, $03d3295ed0668f0a$export$7f095f455ad5af3f(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex: pageIndex,
                    pageSize: pageSize
                };
            });
        };
        //deprecated
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = $03d3295ed0668f0a$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === 'number') newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getPageOptions'));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex: pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.firstPage = ()=>{
            return table.setPageIndex(0);
        };
        table.lastPage = ()=>{
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = ()=>{
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
const $03d3295ed0668f0a$var$getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const $03d3295ed0668f0a$export$213d72cb2ac7d440 = {
    getInitialState: (state)=>{
        return {
            rowPinning: $03d3295ed0668f0a$var$getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowPinningChange: $03d3295ed0668f0a$export$2b5605d8069324bd('rowPinning', table)
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref)=>{
                let { id: id } = _ref;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2)=>{
                let { id: id } = _ref2;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === 'bottom') {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === 'top') {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref3;
            const { enableRowPinning: enableRowPinning, enablePinning: enablePinning } = table.options;
            if (typeof enableRowPinning === 'function') return enableRowPinning(row);
            return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top: top, bottom: bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? 'top' : isBottom ? 'bottom' : false;
        };
        row.getPinnedIndex = ()=>{
            var _ref4, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_ref4 = position === 'top' ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map((_ref5)=>{
                let { id: id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
    },
    createTable: (table)=>{
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState;
            return table.setRowPinning(defaultState ? $03d3295ed0668f0a$var$getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : $03d3295ed0668f0a$var$getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table._getPinnedRows = (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position: position
                }));
        };
        table.getTopRows = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top
            ], (allRows, topPinnedRowIds)=>table._getPinnedRows(allRows, topPinnedRowIds, 'top'), $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getTopRows'));
        table.getBottomRows = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.bottom
            ], (allRows, bottomPinnedRowIds)=>table._getPinnedRows(allRows, bottomPinnedRowIds, 'bottom'), $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getBottomRows'));
        table.getCenterRows = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterRows'));
    }
};
//
const $03d3295ed0668f0a$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $03d3295ed0668f0a$export$2b5605d8069324bd('rowSelection', table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    $03d3295ed0668f0a$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $03d3295ed0668f0a$export$f150e72530556b0b(table, rowModel);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getSelectedRowModel'));
        table.getFilteredSelectedRowModel = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $03d3295ed0668f0a$export$f150e72530556b0b(table, rowModel);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredSelectedRowModel'));
        table.getGroupedSelectedRowModel = $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $03d3295ed0668f0a$export$f150e72530556b0b(table, rowModel);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedSelectedRowModel'));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection: rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection: rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== 'undefined' ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                $03d3295ed0668f0a$var$mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $03d3295ed0668f0a$export$710e11cf672b86c(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $03d3295ed0668f0a$export$8f4c46e5d7907334(row, rowSelection) === 'some';
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $03d3295ed0668f0a$export$8f4c46e5d7907334(row, rowSelection) === 'all';
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === 'function') return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === 'function') return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === 'function') return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const $03d3295ed0668f0a$var$mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$03d3295ed0668f0a$var$mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function $03d3295ed0668f0a$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $03d3295ed0668f0a$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $03d3295ed0668f0a$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $03d3295ed0668f0a$export$8f4c46e5d7907334(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if ($03d3295ed0668f0a$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = $03d3295ed0668f0a$export$8f4c46e5d7907334(subRow, selection);
            if (subRowChildrenSelected === 'all') someSelected = true;
            else if (subRowChildrenSelected === 'some') {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
}
const $03d3295ed0668f0a$export$8758689f50bddb9f = /([0-9]+)/gm;
const $03d3295ed0668f0a$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $03d3295ed0668f0a$var$compareAlphanumeric($03d3295ed0668f0a$var$toString(rowA.getValue(columnId)).toLowerCase(), $03d3295ed0668f0a$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $03d3295ed0668f0a$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $03d3295ed0668f0a$var$compareAlphanumeric($03d3295ed0668f0a$var$toString(rowA.getValue(columnId)), $03d3295ed0668f0a$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $03d3295ed0668f0a$var$text = (rowA, rowB, columnId)=>{
    return $03d3295ed0668f0a$var$compareBasic($03d3295ed0668f0a$var$toString(rowA.getValue(columnId)).toLowerCase(), $03d3295ed0668f0a$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $03d3295ed0668f0a$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $03d3295ed0668f0a$var$compareBasic($03d3295ed0668f0a$var$toString(rowA.getValue(columnId)), $03d3295ed0668f0a$var$toString(rowB.getValue(columnId)));
};
const $03d3295ed0668f0a$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $03d3295ed0668f0a$var$basic = (rowA, rowB, columnId)=>{
    return $03d3295ed0668f0a$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $03d3295ed0668f0a$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $03d3295ed0668f0a$var$toString(a) {
    if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) return '';
        return String(a);
    }
    if (typeof a === 'string') return a;
    return '';
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $03d3295ed0668f0a$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($03d3295ed0668f0a$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($03d3295ed0668f0a$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $03d3295ed0668f0a$export$47423a4cd813a815 = {
    alphanumeric: $03d3295ed0668f0a$var$alphanumeric,
    alphanumericCaseSensitive: $03d3295ed0668f0a$var$alphanumericCaseSensitive,
    text: $03d3295ed0668f0a$var$text,
    textCaseSensitive: $03d3295ed0668f0a$var$textCaseSensitive,
    datetime: $03d3295ed0668f0a$var$datetime,
    basic: $03d3295ed0668f0a$var$basic
};
//
const $03d3295ed0668f0a$export$c7de5ec16c5efba8 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: 'auto',
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $03d3295ed0668f0a$export$2b5605d8069324bd('sorting', table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === '[object Date]') return $03d3295ed0668f0a$export$47423a4cd813a815.datetime;
                if (typeof value === 'string') {
                    isString = true;
                    if (value.split($03d3295ed0668f0a$export$8758689f50bddb9f).length > 1) return $03d3295ed0668f0a$export$47423a4cd813a815.alphanumeric;
                }
            }
            if (isString) return $03d3295ed0668f0a$export$47423a4cd813a815.text;
            return $03d3295ed0668f0a$export$47423a4cd813a815.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return 'asc';
            return 'desc';
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return $03d3295ed0668f0a$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === 'auto' ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $03d3295ed0668f0a$export$47423a4cd813a815[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== 'undefined' && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc';
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'add';
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = 'replace';
                    else if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'replace';
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === 'toggle') {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = 'remove';
                    }
                }
                if (sortAction === 'add') {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === 'toggle') // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === 'remove') newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === 'desc';
            return sortDescFirst ? 'desc' : 'asc';
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === 'desc' ? 'asc' : 'desc';
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
const $03d3295ed0668f0a$var$builtInFeatures = [
    $03d3295ed0668f0a$export$79b704688b15c0f4,
    $03d3295ed0668f0a$export$be5545a32e20d889,
    $03d3295ed0668f0a$export$fec9c66cd0275c2c,
    $03d3295ed0668f0a$export$3563275ce70c4813,
    $03d3295ed0668f0a$export$1f746e6a9cd841b1,
    $03d3295ed0668f0a$export$f1d67534a0c5e9d3,
    $03d3295ed0668f0a$export$4b37edcdc7ad2fe1,
    //depends on ColumnFaceting
    $03d3295ed0668f0a$export$61e9e0661ff79b1c,
    //depends on ColumnFiltering
    $03d3295ed0668f0a$export$c7de5ec16c5efba8,
    $03d3295ed0668f0a$export$9c9247c655f92e74,
    //depends on RowSorting
    $03d3295ed0668f0a$export$fed54e0d64c17fb2,
    $03d3295ed0668f0a$export$bce540641752d22b,
    $03d3295ed0668f0a$export$213d72cb2ac7d440,
    $03d3295ed0668f0a$export$e8905133e7bf3121,
    $03d3295ed0668f0a$export$9916c85814812d4a
];
//
function $03d3295ed0668f0a$export$33bbb3ec7652e187(options) {
    var _options$_features, _options$initialState;
    const _features = [
        ...$03d3295ed0668f0a$var$builtInFeatures,
        ...(_options$_features = options._features) != null ? _options$_features : []
    ];
    let table = {
        _features: _features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: _features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $03d3295ed0668f0a$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join('.') : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(options, 'debugColumns', '_getDefaultColumnDef')),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $03d3295ed0668f0a$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(options, 'debugColumns', 'getAllColumns')),
        getAllFlatColumns: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumns')),
        _getAllFlatColumnsById: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumnsById')),
        getAllLeafColumns: $03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(options, 'debugColumns', 'getAllLeafColumns')),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function $03d3295ed0668f0a$export$32d0bc001e828250() {
    return (table)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $03d3295ed0668f0a$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getRowModel', ()=>table._autoResetPageIndex()));
}
function $03d3295ed0668f0a$export$53cfec7b1b8d1fcd() {
    return (table)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $03d3295ed0668f0a$export$1293f966cdb38633(rowModel);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getExpandedRowModel'));
}
function $03d3295ed0668f0a$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $03d3295ed0668f0a$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return undefined;
            const uniqueValues = facetedRowModel.flatRows.flatMap((flatRow)=>{
                var _flatRow$getUniqueVal;
                return (_flatRow$getUniqueVal = flatRow.getUniqueValues(columnId)) != null ? _flatRow$getUniqueVal : [];
            }).map(Number).filter((value)=>!Number.isNaN(value));
            if (!uniqueValues.length) return;
            let facetedMinValue = uniqueValues[0];
            let facetedMaxValue = uniqueValues[uniqueValues.length - 1];
            for (const value of uniqueValues){
                if (value < facetedMinValue) facetedMinValue = value;
                else if (value > facetedMaxValue) facetedMaxValue = value;
            }
            return [
                facetedMinValue,
                facetedMaxValue
            ];
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedMinMaxValues'));
}
function $03d3295ed0668f0a$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $03d3295ed0668f0a$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $03d3295ed0668f0a$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $03d3295ed0668f0a$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $03d3295ed0668f0a$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $03d3295ed0668f0a$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $03d3295ed0668f0a$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $03d3295ed0668f0a$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? '__global__' : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $03d3295ed0668f0a$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedRowModel'));
}
function $03d3295ed0668f0a$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', `getFacetedUniqueValues_${columnId}`));
}
function $03d3295ed0668f0a$export$26f255a2756e1638() {
    return (table)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = (columnFilters != null ? columnFilters : []).map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push('__global__');
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $03d3295ed0668f0a$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredRowModel', ()=>table._autoResetPageIndex()));
}
function $03d3295ed0668f0a$export$2b7f4b57ce71b81() {
    return (table)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) {
                rowModel.rows.forEach((row)=>{
                    row.depth = 0;
                    row.parentId = undefined;
                });
                return rowModel;
            }
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $03d3295ed0668f0a$var$groupBy(rows, columnId);
                // Perform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    subRows.forEach((subRow)=>{
                        subRow.parentId = id;
                    });
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $03d3295ed0668f0a$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $03d3295ed0668f0a$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedRowModel', ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function $03d3295ed0668f0a$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $03d3295ed0668f0a$export$ddfd3662e196c265(opts) {
    return (table)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $03d3295ed0668f0a$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getPaginationRowModel'));
}
function $03d3295ed0668f0a$export$4ca93ca80835d8c1() {
    return (table)=>$03d3295ed0668f0a$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const sortUndefined = columnInfo.sortUndefined;
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) {
                                if (sortUndefined === 'first') return aUndefined ? -1 : 1;
                                if (sortUndefined === 'last') return aUndefined ? 1 : -1;
                                sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                            }
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, $03d3295ed0668f0a$export$b1f82222dc43996c(table.options, 'debugTable', 'getSortedRowModel', ()=>table._autoResetPageIndex()));
}


//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function $38aa98f8131a8a5c$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $38aa98f8131a8a5c$var$isReactComponent(Comp) ? /*#__PURE__*/ $acw62.createElement(Comp, props) : Comp;
}
function $38aa98f8131a8a5c$var$isReactComponent(component) {
    return $38aa98f8131a8a5c$var$isClassComponent(component) || typeof component === 'function' || $38aa98f8131a8a5c$var$isExoticComponent(component);
}
function $38aa98f8131a8a5c$var$isClassComponent(component) {
    return typeof component === 'function' && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $38aa98f8131a8a5c$var$isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && [
        'react.memo',
        'react.forward_ref'
    ].includes(component.$$typeof.description);
}
function $38aa98f8131a8a5c$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $acw62.useState(()=>({
            current: (0, $03d3295ed0668f0a$export$33bbb3ec7652e187)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $acw62.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}




parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $db42588f972bc829$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $db42588f972bc829$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $db42588f972bc829$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $db42588f972bc829$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)((0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $f36710bd138be5d0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $f36710bd138be5d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check", $f36710bd138be5d0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $200392fae49ddb7e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clock", $200392fae49ddb7e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $00824d397ec63c04$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $00824d397ec63c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("triangle-alert", $00824d397ec63c04$export$3efd853dbb351e94);


const $cdef40175fa68bf9$var$StatusBadge = ({ status: status, className: className = "", message: message })=>{
    let color = "";
    let icon = null;
    if (status === "completed" || status === "success") {
        color = "bg-green-100 text-green-800";
        icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
            className: "w-4 h-4 mr-1 text-green-500"
        });
    } else if (status === "processing") {
        color = "bg-blue-100 text-blue-800";
        icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
            className: "w-4 h-4 mr-1 text-blue-500"
        });
    } else if (status === "failed" || status === "error") {
        color = "bg-red-100 text-red-800";
        icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
            className: "w-4 h-4 mr-1 text-red-500"
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${color} ${className}`,
        children: [
            icon,
            status === "error" && message ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    "Error: ",
                    message
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "capitalize",
                children: status
            })
        ]
    });
};
var $cdef40175fa68bf9$export$2e2bcd8739ae039 = $cdef40175fa68bf9$var$StatusBadge;


const $176015ca9bb00e03$var$STATUS_OPTIONS = [
    "pending",
    "processing",
    "completed",
    "failed"
];
const $176015ca9bb00e03$var$AutoRefreshIndicator = /*#__PURE__*/ (0, $acw62.memo)(({ hasProcessingItems: hasProcessingItems, isFetching: isFetching })=>{
    const [secondsLeft, setSecondsLeft] = (0, $acw62.useState)(5);
    const intervalRef = (0, $acw62.useRef)(null);
    // Reset countdown when data finishes fetching
    (0, $acw62.useEffect)(()=>{
        if (!isFetching && hasProcessingItems) setSecondsLeft(5);
    }, [
        isFetching,
        hasProcessingItems
    ]);
    (0, $acw62.useEffect)(()=>{
        // Only run countdown timer if there are processing items
        if (hasProcessingItems) intervalRef.current = setInterval(()=>{
            setSecondsLeft((prev)=>prev > 0 ? prev - 1 : 5);
        }, 1000);
        else if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        hasProcessingItems
    ]);
    if (!hasProcessingItems) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "text-xs text-white ml-auto mr-1 italic",
        children: [
            "Automatically updates in ",
            secondsLeft,
            " second",
            secondsLeft === 1 ? "" : "s"
        ]
    });
});
function $176015ca9bb00e03$export$2e2bcd8739ae039() {
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $874ecb7cc9a437a2$export$f2b63d3ca66bb884)();
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)("");
    const [sorting, setSorting] = (0, $acw62.useState)([
        {
            id: "createdAt",
            desc: true
        }
    ]);
    const [columnFilters, setColumnFilters] = (0, $acw62.useState)([]);
    const [pagination, setPagination] = (0, $acw62.useState)({
        pageIndex: 0,
        pageSize: 10
    });
    const handleDownload = (0, $acw62.useCallback)(async (id, fileName)=>{
        try {
            const token = await getAccessTokenSilently();
            const response = await (0, $e19de912f27c6f38$export$46c77663237f5ef7)(token, id);
            // Create a temporary link to download the file
            const link = document.createElement("a");
            link.href = response.downloadUrl;
            link.download = fileName;
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
            alert("Failed to download file. Please try again.");
        }
    }, [
        getAccessTokenSilently
    ]);
    const { data: data, isLoading: isLoading, error: error, isFetching: isFetching } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            "eligibility-history",
            statusFilter,
            pagination.pageIndex,
            pagination.pageSize,
            sorting
        ],
        queryFn: async ()=>{
            const token = await getAccessTokenSilently();
            const sort = sorting[0] || {
                id: "createdAt",
                desc: true
            };
            return (0, $e19de912f27c6f38$export$e732b5726664d556)(token, {
                status: statusFilter || undefined,
                page: pagination.pageIndex + 1,
                pageSize: pagination.pageSize,
                sortBy: sort.id,
                sortDir: sort.desc ? "desc" : "asc"
            });
        },
        refetchInterval: 5000
    });
    // Check if there are processing items
    const hasProcessingItems = (0, $acw62.useMemo)(()=>{
        return data?.data?.some((row)=>[
                "processing",
                "pending"
            ].includes(row.status.toLowerCase())) ?? false;
    }, [
        data?.data
    ]);
    // Efficiently memoize table data by comparing actual content changes
    const prevDataRef = (0, $acw62.useRef)("");
    const prevTableDataRef = (0, $acw62.useRef)([]);
    const tableData = (0, $acw62.useMemo)(()=>{
        if (!data?.data) return [];
        // Create a stable key from the essential data
        const dataKey = data.data.map((row)=>`${row._id}-${row.fileName}-${row.status}-${row.processedRows}-${row.createdAt}`).join("|");
        // Only re-compute if the data content has actually changed
        if (dataKey === prevDataRef.current) return prevTableDataRef.current; // Return previous computed value
        prevDataRef.current = dataKey;
        prevTableDataRef.current = data?.data;
        return data?.data;
    }, [
        data?.data
    ]);
    const columns = (0, $acw62.useMemo)(()=>[
            {
                accessorKey: "fileName",
                header: "File",
                cell: (info)=>{
                    const fileName = info.getValue();
                    const rowId = info.row.original._id;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>handleDownload(rowId, fileName),
                        className: "text-blue-600 underline hover:text-blue-800 text-left",
                        title: "Click to download file",
                        children: fileName
                    });
                }
            },
            {
                accessorKey: "formattedCreatedAt",
                header: "Date",
                cell: (info)=>info.getValue()
            },
            {
                accessorKey: "status",
                header: "Status",
                cell: (info)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cdef40175fa68bf9$export$2e2bcd8739ae039), {
                        status: info.getValue()
                    })
            },
            {
                accessorKey: "processedRows",
                header: "# Processed",
                cell: (info)=>info.getValue()
            },
            {
                accessorKey: "viewUrl",
                header: "View",
                cell: (info)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/admin/eligibilities/${info.row.original._id}`,
                        className: "text-blue-600 underline hover:text-blue-800",
                        children: "View"
                    });
                },
                enableSorting: false
            }
        ], [
        handleDownload
    ]);
    const table = (0, $38aa98f8131a8a5c$export$25eaeb3743e6b31f)({
        data: tableData,
        columns: columns,
        state: {
            sorting: sorting,
            columnFilters: columnFilters,
            pagination: pagination
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,
        onPaginationChange: setPagination,
        getCoreRowModel: (0, $03d3295ed0668f0a$export$32d0bc001e828250)(),
        getSortedRowModel: (0, $03d3295ed0668f0a$export$4ca93ca80835d8c1)(),
        getFilteredRowModel: (0, $03d3295ed0668f0a$export$26f255a2756e1638)(),
        manualPagination: true,
        pageCount: data?.totalPages ?? -1,
        manualSorting: true,
        manualFiltering: false,
        debugTable: false
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($176015ca9bb00e03$var$AutoRefreshIndicator, {
                hasProcessingItems: hasProcessingItems,
                isFetching: isFetching
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-4 bg-white rounded shadow",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-between mb-4 gap-4 flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: "border rounded px-2 py-1",
                                        value: statusFilter,
                                        onChange: (e)=>setStatusFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "All"
                                            }),
                                            $176015ca9bb00e03$var$STATUS_OPTIONS.map((status)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: status,
                                                    children: status
                                                }, status))
                                        ]
                                    })
                                ]
                            }),
                            isFetching && data && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-xs text-gray-500 flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        className: "animate-spin h-3 w-3",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8v8z"
                                            })
                                        ]
                                    }),
                                    "Updating..."
                                ]
                            })
                        ]
                    }),
                    isLoading && !data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex items-center justify-center py-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                            className: "animate-spin h-8 w-8",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    className: "opacity-25",
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    strokeWidth: "4"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    className: "opacity-75",
                                    fill: "currentColor",
                                    d: "M4 12a8 8 0 018-8v8z"
                                })
                            ]
                        })
                    }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-red-600 py-8",
                        children: "Error loading history."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overflow-x-auto",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "min-w-full border border-gray-200",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            className: "bg-gray-100",
                                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                            className: "px-4 py-2 text-left text-xs font-semibold text-gray-700 border-b cursor-pointer select-none",
                                                            onClick: header.column.getToggleSortingHandler(),
                                                            children: [
                                                                (0, $38aa98f8131a8a5c$export$f2385bb6e3ac4b4f)(header.column.columnDef.header, header.getContext()),
                                                                header.column.getIsSorted() === "asc" && " \u25B2",
                                                                header.column.getIsSorted() === "desc" && " \u25BC"
                                                            ]
                                                        }, header.id))
                                                }, headerGroup.id))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: table.getRowModel().rows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: columns.length,
                                                    className: "text-center py-8 text-gray-500",
                                                    children: "No history found."
                                                })
                                            }) : table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    className: "hover:bg-gray-50",
                                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-2 border-b",
                                                            children: (0, $38aa98f8131a8a5c$export$f2385bb6e3ac4b4f)(cell.column.columnDef.cell, cell.getContext())
                                                        }, cell.id))
                                                }, row.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "px-3 py-1 border rounded mr-2 disabled:opacity-50",
                                                onClick: ()=>table.setPageIndex(table.getState().pagination.pageIndex - 1),
                                                disabled: table.getState().pagination.pageIndex === 0,
                                                children: "Prev"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "px-3 py-1 border rounded disabled:opacity-50",
                                                onClick: ()=>table.setPageIndex(table.getState().pagination.pageIndex + 1),
                                                disabled: data?.totalPages ? table.getState().pagination.pageIndex + 1 >= data.totalPages : false,
                                                children: "Next"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-sm",
                                        children: [
                                            "Page ",
                                            table.getState().pagination.pageIndex + 1,
                                            " of",
                                            " ",
                                            data?.totalPages ?? 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                            className: "border rounded px-2 py-1",
                                            value: table.getState().pagination.pageSize,
                                            onChange: (e)=>table.setPageSize(Number(e.target.value)),
                                            children: [
                                                10,
                                                20,
                                                30,
                                                40,
                                                50
                                            ].map((pageSize)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                    value: pageSize,
                                                    children: [
                                                        "Show ",
                                                        pageSize
                                                    ]
                                                }, pageSize))
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


parcelRequire("acw62");
const $04ba47db372b3b93$var$HistoryPage = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $176015ca9bb00e03$export$2e2bcd8739ae039), {})
    });
};
var $04ba47db372b3b93$export$2e2bcd8739ae039 = $04ba47db372b3b93$var$HistoryPage;




var $acw62 = parcelRequire("acw62");






const $c0261ca6bae7158b$export$d0e452ce48c9ffa4 = ()=>{
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { getAccessTokenSilently: getAccessTokenSilently } = (0, $874ecb7cc9a437a2$export$f2b63d3ca66bb884)();
    const { data: data, isLoading: isLoading, error: error } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            "eligibility-detail",
            id
        ],
        queryFn: async ()=>{
            const token = await getAccessTokenSilently();
            return (0, $e19de912f27c6f38$export$c521715156a6b830)(token, id);
        },
        enabled: !!id
    });
    const columns = (0, $acw62.useMemo)(()=>[
            {
                accessorKey: "firstName",
                header: "First Name",
                cell: (info)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "block truncate",
                        children: info.getValue()
                    })
            },
            {
                accessorKey: "lastName",
                header: "Last Name",
                cell: (info)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "block truncate",
                        children: info.getValue()
                    })
            },
            {
                accessorKey: "email",
                header: "Email"
            },
            {
                id: "address",
                header: "Address",
                cell: (info)=>{
                    const address = info.row.original.address || {};
                    const address1 = address.address1 || "";
                    const city = address.city || "";
                    const state = address.state || "";
                    const parts = [
                        address1,
                        city,
                        state
                    ].filter(Boolean);
                    return parts.length > 0 ? parts.join(", ") : "-";
                }
            },
            {
                accessorKey: "subscriptionExpirationDate",
                header: "Subscription End Date",
                cell: (info)=>{
                    console.log(info);
                    const value = info.getValue();
                    if (!value) return "-";
                    const date = new Date(value);
                    return isNaN(date.getTime()) ? "-" : date.toLocaleDateString();
                }
            },
            {
                accessorKey: "organizationName",
                header: "Organization",
                cell: (info)=>info.getValue() || "-"
            },
            {
                accessorKey: "status",
                header: "Status",
                cell: (info)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cdef40175fa68bf9$export$2e2bcd8739ae039), {
                        status: info.getValue(),
                        message: info.row.original.message
                    })
            }
        ], []);
    const table = (0, $38aa98f8131a8a5c$export$25eaeb3743e6b31f)({
        data: data?.results || [],
        columns: columns,
        getCoreRowModel: (0, $03d3295ed0668f0a$export$32d0bc001e828250)()
    });
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center py-12",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            className: "animate-spin h-8 w-8 text-white",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8v8z"
                })
            ]
        })
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-red-600 py-8 text-center",
        children: "Error loading eligibility detail."
    });
    if (!data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-center py-8",
        children: "No data found."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "p-6 bg-white rounded shadow",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center justify-between mb-4",
                children: data.fileName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-bold",
                                    children: "Eligibility details for "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                    className: "font-mono bg-gray-100 px-2 py-1 rounded text-base font-normal",
                                    children: data.fileName
                                })
                            ]
                        }),
                        data.status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cdef40175fa68bf9$export$2e2bcd8739ae039), {
                            status: data.status
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "font-bold text-xl",
                    children: "Eligibility Upload Details"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-x-auto rounded",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "min-w-full border border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            className: "bg-gray-100",
                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-4 py-2 text-left text-xs font-semibold text-gray-700 border-b",
                                            children: (0, $38aa98f8131a8a5c$export$f2385bb6e3ac4b4f)(header.column.columnDef.header, header.getContext())
                                        }, header.id))
                                }, headerGroup.id))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: table.getRowModel().rows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    colSpan: columns.length,
                                    className: "text-center py-8 text-gray-500",
                                    children: "No results found."
                                })
                            }) : table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    className: "hover:bg-gray-50",
                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "px-4 py-2 border-b",
                                            children: (0, $38aa98f8131a8a5c$export$f2385bb6e3ac4b4f)(cell.column.columnDef.cell, cell.getContext())
                                        }, cell.id))
                                }, row.id))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end mt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition",
                    onClick: ()=>navigate("/admin/eligibilities/history"),
                    children: "\u2190 Back to History"
                })
            })
        ]
    });
};


function $cd93687958c8007e$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$Layout, {}),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "hahs",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$Layout, {}),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a00bb0b32f3727d$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "dob",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81e332e9c2fc3191$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "address",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbd5e2ca5ac31863$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "success",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce0d1bd640cc8431$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "payment",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca181f363cd7023$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "wellabep2p",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$Layout, {}),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10342bf20a1483d2$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "dob",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19d4724289db3fdd$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "address",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a02d00d254a9fb62$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "success",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a551a6284ad86f57$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "wellabebh",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$Layout, {}),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df3cc72a9e4357db$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "dob",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bd9d088d8c47c07$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "address",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a39e9fd1f0c8a254$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "success",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $16b56aeedb36b00c$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "admin",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea8bba1be8df4f6$export$2e2bcd8739ae039), {}),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "eligibilities",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                            to: "upload",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "upload",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15ef8acb32c99e32$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "history",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ba47db372b3b93$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: ":id",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0261ca6bae7158b$export$d0e452ce48c9ffa4), {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "admin/access-denied",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea8bba1be8df4f6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da29e3727c14b3f9$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {})
        ]
    });
}
function $cd93687958c8007e$var$Layout() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
    });
}
function $cd93687958c8007e$var$NoMatch() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Nothing to see here!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: "Go to the home page "
                })
            })
        ]
    });
}


const $35da740d59af89ba$var$domain = "caringwire-hahs-test.us.auth0.com";
const $35da740d59af89ba$var$clientId = "2cyPcETy9oxtmM2d28Yi5Ymfp5YLpitu";
const $35da740d59af89ba$var$queryClient = new (0, $83ccb5f70678ce73$export$405d0624ed55a03f)();
const $35da740d59af89ba$var$Auth0ProviderWithRedirectCallback = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const onRedirectCallback = (appState)=>{
        navigate(appState?.returnTo || window.location.pathname);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $874ecb7cc9a437a2$export$6aefaad9cc4faf3c), {
        domain: $35da740d59af89ba$var$domain,
        clientId: $35da740d59af89ba$var$clientId,
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: "https://hahs-test.caringwire.com"
        },
        onRedirectCallback: onRedirectCallback,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
    });
};
const $35da740d59af89ba$var$container = document.getElementById("app");
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($35da740d59af89ba$var$container);
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c780594f51309d36$export$45604f0cc8ae667b), {
    client: $35da740d59af89ba$var$queryClient,
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35da740d59af89ba$var$Auth0ProviderWithRedirectCallback, {})
    })
}));


//# sourceMappingURL=forms.55d99e8e.js.map
